var U0 = Object.defineProperty, K0 = Object.defineProperties;
var G0 = Object.getOwnPropertyDescriptors;
var sr = Object.getOwnPropertySymbols;
var Ja = Object.prototype.hasOwnProperty, el = Object.prototype.propertyIsEnumerable;
var Qa = (e, t, n) => t in e ? U0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oe = (e, t) => {
  for (var n in t || (t = {}))
    Ja.call(t, n) && Qa(e, n, t[n]);
  if (sr)
    for (var n of sr(t))
      el.call(t, n) && Qa(e, n, t[n]);
  return e;
}, de = (e, t) => K0(e, G0(t));
var Ki = (e, t) => {
  var n = {};
  for (var o in e)
    Ja.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && sr)
    for (var o of sr(e))
      t.indexOf(o) < 0 && el.call(e, o) && (n[o] = e[o]);
  return n;
};
import { createElementBlock as h, openBlock as l, Fragment as G, renderList as q, createElementVNode as d, createBlock as _, resolveDynamicComponent as R, resolveComponent as S, normalizeStyle as H, renderSlot as C, createVNode as $, normalizeClass as p, createCommentVNode as g, toDisplayString as f, createTextVNode as k, withCtx as b, TransitionGroup as nn, resolveDirective as Ne, withDirectives as me, withKeys as N, withModifiers as D, Transition as ye, vModelText as z0, unref as Z0, getCurrentScope as $u, onScopeDispose as Iu, ref as tn, computed as xo, watch as ri, vShow as Ft, nextTick as Bt, normalizeProps as W0, guardReactiveProps as q0, mergeProps as Ce, onMounted as Qs, getCurrentInstance as Au, toValue as Lu, shallowRef as Y0, useTemplateRef as x0, createSlots as Ou, defineComponent as X0, onUnmounted as Q0, Comment as J0, cloneVNode as e2, h as bo } from "vue";
function tl(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientX : e.touches[0].clientX;
}
function nl(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientY : e.touches[0].clientY;
}
var t2 = function() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch (n) {
  }
  return e;
}(), n2 = {
  install: function(e, t) {
    var n = Object.assign({}, {
      disableClick: !1,
      tapTolerance: 10,
      // px
      swipeTolerance: 30,
      // px
      touchHoldTolerance: 400,
      // ms
      longTapTimeInterval: 400,
      // ms
      touchClass: "",
      dragFrequency: 100,
      // ms
      rollOverFrequency: 100,
      // ms
      namespace: "touch"
    }, t);
    function o(O) {
      var L = this.$$touchObj, U = O.type.indexOf("touch") >= 0, z = O.type.indexOf("mouse") >= 0, B = this;
      U && (L.lastTouchStartTime = O.timeStamp), !(z && L.lastTouchStartTime && O.timeStamp - L.lastTouchStartTime < 350) && (L.touchStarted || (w(this), L.touchStarted = !0, L.touchMoved = !1, L.swipeOutBounded = !1, L.startX = tl(O), L.startY = nl(O), L.currentX = 0, L.currentY = 0, L.touchStartTime = O.timeStamp, L.hasSwipe = c(this, "swipe") || c(this, "swipe.left") || c(this, "swipe.right") || c(this, "swipe.top") || c(this, "swipe.bottom"), c(this, "hold") && (L.touchHoldTimer = setTimeout(function() {
        L.touchHoldTimer = null, y(O, B, "hold");
      }, L.options.touchHoldTolerance)), y(O, this, "press")));
    }
    function i(O) {
      var L = this.$$touchObj, U = tl(O), z = nl(O), B = L.currentX != U || L.currentY != z;
      if (L.currentX = U, L.currentY = z, L.touchMoved) {
        if (L.hasSwipe && !L.swipeOutBounded) {
          var Y = L.options.swipeTolerance;
          L.swipeOutBounded = Math.abs(L.startX - L.currentX) > Y && Math.abs(L.startY - L.currentY) > Y;
        }
      } else {
        var j = L.options.tapTolerance;
        L.touchMoved = Math.abs(L.startX - L.currentX) > j || Math.abs(L.startY - L.currentY) > j, L.touchMoved && (E(L), y(O, this, "drag.once"));
      }
      if (c(this, "rollover") && B) {
        var K = O.timeStamp, ne = L.options.rollOverFrequency;
        (L.touchRollTime == null || K > L.touchRollTime + ne) && (L.touchRollTime = K, y(O, this, "rollover"));
      }
      if (c(this, "drag") && L.touchStarted && L.touchMoved && B) {
        var K = O.timeStamp, ne = L.options.dragFrequency;
        (L.touchDragTime == null || K > L.touchDragTime + ne) && (L.touchDragTime = K, y(O, this, "drag"));
      }
    }
    function r() {
      var O = this.$$touchObj;
      E(O), v(this), O.touchStarted = O.touchMoved = !1, O.startX = O.startY = 0;
    }
    function a(O) {
      var L = this.$$touchObj, U = O.type.indexOf("touch") >= 0, z = O.type.indexOf("mouse") >= 0;
      U && (L.lastTouchEndTime = O.timeStamp);
      var B = U && !L.touchHoldTimer;
      if (E(L), L.touchStarted = !1, v(this), !(z && L.lastTouchEndTime && O.timeStamp - L.lastTouchEndTime < 350))
        if (y(O, this, "release"), L.touchMoved) {
          if (L.hasSwipe && !L.swipeOutBounded) {
            var j = L.options.swipeTolerance, Y, K = Math.abs(L.startY - L.currentY), ne = Math.abs(L.startX - L.currentX);
            (K > j || ne > j) && (K > ne ? Y = L.startY > L.currentY ? "top" : "bottom" : Y = L.startX > L.currentX ? "left" : "right", c(this, "swipe." + Y) ? y(O, this, "swipe." + Y, Y) : y(O, this, "swipe", Y));
          }
        } else if (c(this, "longtap") && O.timeStamp - L.touchStartTime > L.options.longTapTimeInterval)
          O.cancelable && O.preventDefault(), y(O, this, "longtap");
        else if (c(this, "hold") && B) {
          O.cancelable && O.preventDefault();
          return;
        } else
          y(O, this, "tap");
    }
    function s() {
      w(this);
    }
    function u() {
      v(this);
    }
    function c(O, L) {
      var U = O.$$touchObj.callbacks[L];
      return U != null && U.length > 0;
    }
    function y(O, L, U, z) {
      var B = L.$$touchObj, j = B.callbacks[U];
      if (j == null || j.length === 0)
        return null;
      for (var Y = 0; Y < j.length; Y++) {
        var K = j[Y];
        K.modifiers.stop && O.stopPropagation(), K.modifiers.prevent && O.preventDefault(), !(K.modifiers.self && O.target !== O.currentTarget) && typeof K.value == "function" && (z ? K.value(z, O) : K.value(O));
      }
    }
    function w(O) {
      var L = O.$$touchObj.options.touchClass;
      L && O.classList.add(L);
    }
    function v(O) {
      var L = O.$$touchObj.options.touchClass;
      L && O.classList.remove(L);
    }
    function E(O) {
      O && O.touchHoldTimer && (clearTimeout(O.touchHoldTimer), O.touchHoldTimer = null);
    }
    function F(O, L) {
      var U = O.$$touchObj || {
        // an object contains all callbacks registered,
        // key is event name, value is an array
        callbacks: {},
        // prevent bind twice, set to true when event bound
        hasBindTouchEvents: !1,
        // default options, would be override by v-touch-options
        options: n
      };
      return L && (U.options = Object.assign({}, U.options, L)), O.$$touchObj = U, O.$$touchObj;
    }
    e.directive(n.namespace, {
      beforeMount: function(O, L) {
        var U = F(O), z = t2 ? { passive: !0 } : !1, B = L.arg || "tap";
        switch (B) {
          case "swipe":
            var j = L.modifiers;
            if (j.left || j.right || j.top || j.bottom) {
              for (var Y in L.modifiers)
                if (["left", "right", "top", "bottom"].indexOf(Y) >= 0) {
                  var K = "swipe." + Y;
                  U.callbacks[K] = U.callbacks[K] || [], U.callbacks[K].push(L);
                }
            } else
              U.callbacks.swipe = U.callbacks.swipe || [], U.callbacks.swipe.push(L);
            break;
          case "press":
          case "drag":
            L.modifiers.disablePassive && (z = !1);
          default:
            U.callbacks[B] = U.callbacks[B] || [], U.callbacks[B].push(L);
        }
        U.hasBindTouchEvents || (O.addEventListener("touchstart", o, z), O.addEventListener("touchmove", i, z), O.addEventListener("touchcancel", r), O.addEventListener("touchend", a), U.options.disableClick || (O.addEventListener("mousedown", o), O.addEventListener("mousemove", i), O.addEventListener("mouseup", a), O.addEventListener("mouseenter", s), O.addEventListener("mouseleave", u)), U.hasBindTouchEvents = !0);
      },
      unmounted: function(O) {
        E(O.$$touchObj), O.removeEventListener("touchstart", o), O.removeEventListener("touchmove", i), O.removeEventListener("touchcancel", r), O.removeEventListener("touchend", a), O.$$touchObj && !O.$$touchObj.options.disableClick && (O.removeEventListener("mousedown", o), O.removeEventListener("mousemove", i), O.removeEventListener("mouseup", a), O.removeEventListener("mouseenter", s), O.removeEventListener("mouseleave", u)), delete O.$$touchObj;
      }
    }), e.directive(`${n.namespace}-class`, {
      beforeMount: function(O, L) {
        F(O, {
          touchClass: L.value
        });
      }
    }), e.directive(`${n.namespace}-options`, {
      beforeMount: function(O, L) {
        F(O, L.value);
      }
    });
  }
}, ar = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Qn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var o2 = Array.isArray, En = o2, r2 = typeof ar == "object" && ar && ar.Object === Object && ar, Nu = r2, i2 = Nu, s2 = typeof self == "object" && self && self.Object === Object && self, a2 = i2 || s2 || Function("return this")(), Ct = a2, l2 = Ct, d2 = l2.Symbol, ii = d2, ol = ii, Hu = Object.prototype, u2 = Hu.hasOwnProperty, c2 = Hu.toString, yo = ol ? ol.toStringTag : void 0;
function h2(e) {
  var t = u2.call(e, yo), n = e[yo];
  try {
    e[yo] = void 0;
    var o = !0;
  } catch (r) {
  }
  var i = c2.call(e);
  return o && (t ? e[yo] = n : delete e[yo]), i;
}
var m2 = h2, p2 = Object.prototype, f2 = p2.toString;
function g2(e) {
  return f2.call(e);
}
var v2 = g2, rl = ii, b2 = m2, y2 = v2, C2 = "[object Null]", _2 = "[object Undefined]", il = rl ? rl.toStringTag : void 0;
function w2(e) {
  return e == null ? e === void 0 ? _2 : C2 : il && il in Object(e) ? b2(e) : y2(e);
}
var Xo = w2;
function T2(e) {
  return e != null && typeof e == "object";
}
var Jn = T2, k2 = Xo, E2 = Jn, S2 = "[object Symbol]";
function M2(e) {
  return typeof e == "symbol" || E2(e) && k2(e) == S2;
}
var si = M2, $2 = En, I2 = si, A2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, L2 = /^\w*$/;
function O2(e, t) {
  if ($2(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || I2(e) ? !0 : L2.test(e) || !A2.test(e) || t != null && e in Object(t);
}
var N2 = O2;
function H2(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var on = H2, P2 = Xo, D2 = on, R2 = "[object AsyncFunction]", V2 = "[object Function]", B2 = "[object GeneratorFunction]", F2 = "[object Proxy]";
function j2(e) {
  if (!D2(e))
    return !1;
  var t = P2(e);
  return t == V2 || t == B2 || t == R2 || t == F2;
}
var Pu = j2, U2 = Ct, K2 = U2["__core-js_shared__"], G2 = K2, Gi = G2, sl = function() {
  var e = /[^.]+$/.exec(Gi && Gi.keys && Gi.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function z2(e) {
  return !!sl && sl in e;
}
var Z2 = z2, W2 = Function.prototype, q2 = W2.toString;
function Y2(e) {
  if (e != null) {
    try {
      return q2.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var Du = Y2, x2 = Pu, X2 = Z2, Q2 = on, J2 = Du, em = /[\\^$.*+?()[\]{}|]/g, tm = /^\[object .+?Constructor\]$/, nm = Function.prototype, om = Object.prototype, rm = nm.toString, im = om.hasOwnProperty, sm = RegExp(
  "^" + rm.call(im).replace(em, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function am(e) {
  if (!Q2(e) || X2(e))
    return !1;
  var t = x2(e) ? sm : tm;
  return t.test(J2(e));
}
var lm = am;
function dm(e, t) {
  return e == null ? void 0 : e[t];
}
var um = dm, cm = lm, hm = um;
function mm(e, t) {
  var n = hm(e, t);
  return cm(n) ? n : void 0;
}
var Sn = mm, pm = Sn, fm = pm(Object, "create"), ai = fm, al = ai;
function gm() {
  this.__data__ = al ? al(null) : {}, this.size = 0;
}
var vm = gm;
function bm(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ym = bm, Cm = ai, _m = "__lodash_hash_undefined__", wm = Object.prototype, Tm = wm.hasOwnProperty;
function km(e) {
  var t = this.__data__;
  if (Cm) {
    var n = t[e];
    return n === _m ? void 0 : n;
  }
  return Tm.call(t, e) ? t[e] : void 0;
}
var Em = km, Sm = ai, Mm = Object.prototype, $m = Mm.hasOwnProperty;
function Im(e) {
  var t = this.__data__;
  return Sm ? t[e] !== void 0 : $m.call(t, e);
}
var Am = Im, Lm = ai, Om = "__lodash_hash_undefined__";
function Nm(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Lm && t === void 0 ? Om : t, this;
}
var Hm = Nm, Pm = vm, Dm = ym, Rm = Em, Vm = Am, Bm = Hm;
function eo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
eo.prototype.clear = Pm;
eo.prototype.delete = Dm;
eo.prototype.get = Rm;
eo.prototype.has = Vm;
eo.prototype.set = Bm;
var Fm = eo;
function jm() {
  this.__data__ = [], this.size = 0;
}
var Um = jm;
function Km(e, t) {
  return e === t || e !== e && t !== t;
}
var Js = Km, Gm = Js;
function zm(e, t) {
  for (var n = e.length; n--; )
    if (Gm(e[n][0], t))
      return n;
  return -1;
}
var li = zm, Zm = li, Wm = Array.prototype, qm = Wm.splice;
function Ym(e) {
  var t = this.__data__, n = Zm(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : qm.call(t, n, 1), --this.size, !0;
}
var xm = Ym, Xm = li;
function Qm(e) {
  var t = this.__data__, n = Xm(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Jm = Qm, e5 = li;
function t5(e) {
  return e5(this.__data__, e) > -1;
}
var n5 = t5, o5 = li;
function r5(e, t) {
  var n = this.__data__, o = o5(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var i5 = r5, s5 = Um, a5 = xm, l5 = Jm, d5 = n5, u5 = i5;
function to(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
to.prototype.clear = s5;
to.prototype.delete = a5;
to.prototype.get = l5;
to.prototype.has = d5;
to.prototype.set = u5;
var di = to, c5 = Sn, h5 = Ct, m5 = c5(h5, "Map"), ea = m5, ll = Fm, p5 = di, f5 = ea;
function g5() {
  this.size = 0, this.__data__ = {
    hash: new ll(),
    map: new (f5 || p5)(),
    string: new ll()
  };
}
var v5 = g5;
function b5(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var y5 = b5, C5 = y5;
function _5(e, t) {
  var n = e.__data__;
  return C5(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var ui = _5, w5 = ui;
function T5(e) {
  var t = w5(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var k5 = T5, E5 = ui;
function S5(e) {
  return E5(this, e).get(e);
}
var M5 = S5, $5 = ui;
function I5(e) {
  return $5(this, e).has(e);
}
var A5 = I5, L5 = ui;
function O5(e, t) {
  var n = L5(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var N5 = O5, H5 = v5, P5 = k5, D5 = M5, R5 = A5, V5 = N5;
function no(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
no.prototype.clear = H5;
no.prototype.delete = P5;
no.prototype.get = D5;
no.prototype.has = R5;
no.prototype.set = V5;
var Ru = no, Vu = Ru, B5 = "Expected a function";
function ta(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(B5);
  var n = function() {
    var o = arguments, i = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var a = e.apply(this, o);
    return n.cache = r.set(i, a) || r, a;
  };
  return n.cache = new (ta.Cache || Vu)(), n;
}
ta.Cache = Vu;
var F5 = ta, j5 = F5, U5 = 500;
function K5(e) {
  var t = j5(e, function(o) {
    return n.size === U5 && n.clear(), o;
  }), n = t.cache;
  return t;
}
var G5 = K5, z5 = G5, Z5 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, W5 = /\\(\\)?/g, q5 = z5(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Z5, function(n, o, i, r) {
    t.push(i ? r.replace(W5, "$1") : o || n);
  }), t;
}), Y5 = q5;
function x5(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = Array(o); ++n < o; )
    i[n] = t(e[n], n, e);
  return i;
}
var X5 = x5, dl = ii, Q5 = X5, J5 = En, ep = si, ul = dl ? dl.prototype : void 0, cl = ul ? ul.toString : void 0;
function Bu(e) {
  if (typeof e == "string")
    return e;
  if (J5(e))
    return Q5(e, Bu) + "";
  if (ep(e))
    return cl ? cl.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var tp = Bu, np = tp;
function op(e) {
  return e == null ? "" : np(e);
}
var rp = op, ip = En, sp = N2, ap = Y5, lp = rp;
function dp(e, t) {
  return ip(e) ? e : sp(e, t) ? [e] : ap(lp(e));
}
var up = dp, cp = si;
function hp(e) {
  if (typeof e == "string" || cp(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var mp = hp, pp = up, fp = mp;
function gp(e, t) {
  t = pp(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[fp(t[n++])];
  return n && n == o ? e : void 0;
}
var vp = gp, bp = vp;
function yp(e, t, n) {
  var o = e == null ? void 0 : bp(e, t);
  return o === void 0 ? n : o;
}
var Cp = yp;
const T = /* @__PURE__ */ Qn(Cp);
function Br(e) {
  "@babel/helpers - typeof";
  return Br = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Br(e);
}
var _p = /^\s+/, wp = /\s+$/;
function ie(e, t) {
  if (e = e || "", t = t || {}, e instanceof ie)
    return e;
  if (!(this instanceof ie))
    return new ie(e, t);
  var n = Tp(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
ie.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, o, i, r, a, s;
    return n = t.r / 255, o = t.g / 255, i = t.b / 255, n <= 0.03928 ? r = n / 12.92 : r = Math.pow((n + 0.055) / 1.055, 2.4), o <= 0.03928 ? a = o / 12.92 : a = Math.pow((o + 0.055) / 1.055, 2.4), i <= 0.03928 ? s = i / 12.92 : s = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = Fu(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = ml(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = ml(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), i = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + o + "%, " + i + "%)" : "hsva(" + n + ", " + o + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = hl(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = hl(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), i = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + o + "%, " + i + "%)" : "hsla(" + n + ", " + o + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return pl(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return Mp(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Oe(this._r, 255) * 100) + "%",
      g: Math.round(Oe(this._g, 255) * 100) + "%",
      b: Math.round(Oe(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Oe(this._r, 255) * 100) + "%, " + Math.round(Oe(this._g, 255) * 100) + "%, " + Math.round(Oe(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Oe(this._r, 255) * 100) + "%, " + Math.round(Oe(this._g, 255) * 100) + "%, " + Math.round(Oe(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Bp[pl(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + fl(this._r, this._g, this._b, this._a), o = n, i = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var r = ie(t);
      o = "#" + fl(r._r, r._g, r._b, r._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + n + ",endColorstr=" + o + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var o = !1, i = this._a < 1 && this._a >= 0, r = !n && i && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return r ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (o = this.toRgbString()), t === "prgb" && (o = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (o = this.toHexString()), t === "hex3" && (o = this.toHexString(!0)), t === "hex4" && (o = this.toHex8String(!0)), t === "hex8" && (o = this.toHex8String()), t === "name" && (o = this.toName()), t === "hsl" && (o = this.toHslString()), t === "hsv" && (o = this.toHsvString()), o || this.toHexString());
  },
  clone: function() {
    return ie(this.toString());
  },
  _applyModification: function(t, n) {
    var o = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = o._r, this._g = o._g, this._b = o._b, this.setAlpha(o._a), this;
  },
  lighten: function() {
    return this._applyModification(Lp, arguments);
  },
  brighten: function() {
    return this._applyModification(Op, arguments);
  },
  darken: function() {
    return this._applyModification(Np, arguments);
  },
  desaturate: function() {
    return this._applyModification($p, arguments);
  },
  saturate: function() {
    return this._applyModification(Ip, arguments);
  },
  greyscale: function() {
    return this._applyModification(Ap, arguments);
  },
  spin: function() {
    return this._applyModification(Hp, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(Rp, arguments);
  },
  complement: function() {
    return this._applyCombination(Pp, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(Vp, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(Dp, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(gl, [3]);
  },
  tetrad: function() {
    return this._applyCombination(gl, [4]);
  }
};
ie.fromRatio = function(e, t) {
  if (Br(e) == "object") {
    var n = {};
    for (var o in e)
      e.hasOwnProperty(o) && (o === "a" ? n[o] = e[o] : n[o] = Do(e[o]));
    e = n;
  }
  return ie(e, t);
};
function Tp(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, o = null, i = null, r = null, a = !1, s = !1;
  return typeof e == "string" && (e = Kp(e)), Br(e) == "object" && (Lt(e.r) && Lt(e.g) && Lt(e.b) ? (t = kp(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Lt(e.h) && Lt(e.s) && Lt(e.v) ? (o = Do(e.s), i = Do(e.v), t = Sp(e.h, o, i), a = !0, s = "hsv") : Lt(e.h) && Lt(e.s) && Lt(e.l) && (o = Do(e.s), r = Do(e.l), t = Ep(e.h, o, r), a = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = Fu(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function kp(e, t, n) {
  return {
    r: Oe(e, 255) * 255,
    g: Oe(t, 255) * 255,
    b: Oe(n, 255) * 255
  };
}
function hl(e, t, n) {
  e = Oe(e, 255), t = Oe(t, 255), n = Oe(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = (o + i) / 2;
  if (o == i)
    r = a = 0;
  else {
    var u = o - i;
    switch (a = s > 0.5 ? u / (2 - o - i) : u / (o + i), o) {
      case e:
        r = (t - n) / u + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / u + 2;
        break;
      case n:
        r = (e - t) / u + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    l: s
  };
}
function Ep(e, t, n) {
  var o, i, r;
  e = Oe(e, 360), t = Oe(t, 100), n = Oe(n, 100);
  function a(c, y, w) {
    return w < 0 && (w += 1), w > 1 && (w -= 1), w < 1 / 6 ? c + (y - c) * 6 * w : w < 1 / 2 ? y : w < 2 / 3 ? c + (y - c) * (2 / 3 - w) * 6 : c;
  }
  if (t === 0)
    o = i = r = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, u = 2 * n - s;
    o = a(u, s, e + 1 / 3), i = a(u, s, e), r = a(u, s, e - 1 / 3);
  }
  return {
    r: o * 255,
    g: i * 255,
    b: r * 255
  };
}
function ml(e, t, n) {
  e = Oe(e, 255), t = Oe(t, 255), n = Oe(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = o, u = o - i;
  if (a = o === 0 ? 0 : u / o, o == i)
    r = 0;
  else {
    switch (o) {
      case e:
        r = (t - n) / u + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / u + 2;
        break;
      case n:
        r = (e - t) / u + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    v: s
  };
}
function Sp(e, t, n) {
  e = Oe(e, 360) * 6, t = Oe(t, 100), n = Oe(n, 100);
  var o = Math.floor(e), i = e - o, r = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), u = o % 6, c = [n, a, r, r, s, n][u], y = [s, n, n, a, r, r][u], w = [r, r, s, n, n, a][u];
  return {
    r: c * 255,
    g: y * 255,
    b: w * 255
  };
}
function pl(e, t, n, o) {
  var i = [yt(Math.round(e).toString(16)), yt(Math.round(t).toString(16)), yt(Math.round(n).toString(16))];
  return o && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function Mp(e, t, n, o, i) {
  var r = [yt(Math.round(e).toString(16)), yt(Math.round(t).toString(16)), yt(Math.round(n).toString(16)), yt(ju(o))];
  return i && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) && r[3].charAt(0) == r[3].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) + r[3].charAt(0) : r.join("");
}
function fl(e, t, n, o) {
  var i = [yt(ju(o)), yt(Math.round(e).toString(16)), yt(Math.round(t).toString(16)), yt(Math.round(n).toString(16))];
  return i.join("");
}
ie.equals = function(e, t) {
  return !e || !t ? !1 : ie(e).toRgbString() == ie(t).toRgbString();
};
ie.random = function() {
  return ie.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function $p(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ie(e).toHsl();
  return n.s -= t / 100, n.s = ci(n.s), ie(n);
}
function Ip(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ie(e).toHsl();
  return n.s += t / 100, n.s = ci(n.s), ie(n);
}
function Ap(e) {
  return ie(e).desaturate(100);
}
function Lp(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ie(e).toHsl();
  return n.l += t / 100, n.l = ci(n.l), ie(n);
}
function Op(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ie(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), ie(n);
}
function Np(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ie(e).toHsl();
  return n.l -= t / 100, n.l = ci(n.l), ie(n);
}
function Hp(e, t) {
  var n = ie(e).toHsl(), o = (n.h + t) % 360;
  return n.h = o < 0 ? 360 + o : o, ie(n);
}
function Pp(e) {
  var t = ie(e).toHsl();
  return t.h = (t.h + 180) % 360, ie(t);
}
function gl(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = ie(e).toHsl(), o = [ie(e)], i = 360 / t, r = 1; r < t; r++)
    o.push(ie({
      h: (n.h + r * i) % 360,
      s: n.s,
      l: n.l
    }));
  return o;
}
function Dp(e) {
  var t = ie(e).toHsl(), n = t.h;
  return [ie(e), ie({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), ie({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function Rp(e, t, n) {
  t = t || 6, n = n || 30;
  var o = ie(e).toHsl(), i = 360 / n, r = [ie(e)];
  for (o.h = (o.h - (i * t >> 1) + 720) % 360; --t; )
    o.h = (o.h + i) % 360, r.push(ie(o));
  return r;
}
function Vp(e, t) {
  t = t || 6;
  for (var n = ie(e).toHsv(), o = n.h, i = n.s, r = n.v, a = [], s = 1 / t; t--; )
    a.push(ie({
      h: o,
      s: i,
      v: r
    })), r = (r + s) % 1;
  return a;
}
ie.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var o = ie(e).toRgb(), i = ie(t).toRgb(), r = n / 100, a = {
    r: (i.r - o.r) * r + o.r,
    g: (i.g - o.g) * r + o.g,
    b: (i.b - o.b) * r + o.b,
    a: (i.a - o.a) * r + o.a
  };
  return ie(a);
};
ie.readability = function(e, t) {
  var n = ie(e), o = ie(t);
  return (Math.max(n.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), o.getLuminance()) + 0.05);
};
ie.isReadable = function(e, t, n) {
  var o = ie.readability(e, t), i, r;
  switch (r = !1, i = Gp(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      r = o >= 4.5;
      break;
    case "AAlarge":
      r = o >= 3;
      break;
    case "AAAsmall":
      r = o >= 7;
      break;
  }
  return r;
};
ie.mostReadable = function(e, t, n) {
  var o = null, i = 0, r, a, s, u;
  n = n || {}, a = n.includeFallbackColors, s = n.level, u = n.size;
  for (var c = 0; c < t.length; c++)
    r = ie.readability(e, t[c]), r > i && (i = r, o = ie(t[c]));
  return ie.isReadable(e, o, {
    level: s,
    size: u
  }) || !a ? o : (n.includeFallbackColors = !1, ie.mostReadable(e, ["#fff", "#000"], n));
};
var Es = ie.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, Bp = ie.hexNames = Fp(Es);
function Fp(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function Fu(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Oe(e, t) {
  jp(e) && (e = "100%");
  var n = Up(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function ci(e) {
  return Math.min(1, Math.max(0, e));
}
function nt(e) {
  return parseInt(e, 16);
}
function jp(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function Up(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function yt(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function Do(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function ju(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function vl(e) {
  return nt(e) / 255;
}
var ft = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Lt(e) {
  return !!ft.CSS_UNIT.exec(e);
}
function Kp(e) {
  e = e.replace(_p, "").replace(wp, "").toLowerCase();
  var t = !1;
  if (Es[e])
    e = Es[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = ft.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = ft.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = ft.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = ft.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = ft.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = ft.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = ft.hex8.exec(e)) ? {
    r: nt(n[1]),
    g: nt(n[2]),
    b: nt(n[3]),
    a: vl(n[4]),
    format: t ? "name" : "hex8"
  } : (n = ft.hex6.exec(e)) ? {
    r: nt(n[1]),
    g: nt(n[2]),
    b: nt(n[3]),
    format: t ? "name" : "hex"
  } : (n = ft.hex4.exec(e)) ? {
    r: nt(n[1] + "" + n[1]),
    g: nt(n[2] + "" + n[2]),
    b: nt(n[3] + "" + n[3]),
    a: vl(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = ft.hex3.exec(e)) ? {
    r: nt(n[1] + "" + n[1]),
    g: nt(n[2] + "" + n[2]),
    b: nt(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function Gp(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var zp = Ct, Zp = function() {
  return zp.Date.now();
}, Wp = Zp, qp = /\s/;
function Yp(e) {
  for (var t = e.length; t-- && qp.test(e.charAt(t)); )
    ;
  return t;
}
var xp = Yp, Xp = xp, Qp = /^\s+/;
function Jp(e) {
  return e && e.slice(0, Xp(e) + 1).replace(Qp, "");
}
var e9 = Jp, t9 = e9, bl = on, n9 = si, yl = NaN, o9 = /^[-+]0x[0-9a-f]+$/i, r9 = /^0b[01]+$/i, i9 = /^0o[0-7]+$/i, s9 = parseInt;
function a9(e) {
  if (typeof e == "number")
    return e;
  if (n9(e))
    return yl;
  if (bl(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = bl(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = t9(e);
  var n = r9.test(e);
  return n || i9.test(e) ? s9(e.slice(2), n ? 2 : 8) : o9.test(e) ? yl : +e;
}
var Uu = a9, l9 = on, zi = Wp, Cl = Uu, d9 = "Expected a function", u9 = Math.max, c9 = Math.min;
function h9(e, t, n) {
  var o, i, r, a, s, u, c = 0, y = !1, w = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(d9);
  t = Cl(t) || 0, l9(n) && (y = !!n.leading, w = "maxWait" in n, r = w ? u9(Cl(n.maxWait) || 0, t) : r, v = "trailing" in n ? !!n.trailing : v);
  function E(K) {
    var ne = o, te = i;
    return o = i = void 0, c = K, a = e.apply(te, ne), a;
  }
  function F(K) {
    return c = K, s = setTimeout(U, t), y ? E(K) : a;
  }
  function O(K) {
    var ne = K - u, te = K - c, le = t - ne;
    return w ? c9(le, r - te) : le;
  }
  function L(K) {
    var ne = K - u, te = K - c;
    return u === void 0 || ne >= t || ne < 0 || w && te >= r;
  }
  function U() {
    var K = zi();
    if (L(K))
      return z(K);
    s = setTimeout(U, O(K));
  }
  function z(K) {
    return s = void 0, v && o ? E(K) : (o = i = void 0, a);
  }
  function B() {
    s !== void 0 && clearTimeout(s), c = 0, o = u = i = s = void 0;
  }
  function j() {
    return s === void 0 ? a : z(zi());
  }
  function Y() {
    var K = zi(), ne = L(K);
    if (o = arguments, i = this, u = K, ne) {
      if (s === void 0)
        return F(u);
      if (w)
        return clearTimeout(s), s = setTimeout(U, t), E(u);
    }
    return s === void 0 && (s = setTimeout(U, t)), a;
  }
  return Y.cancel = B, Y.flush = j, Y;
}
var m9 = h9;
const zo = /* @__PURE__ */ Qn(m9), rt = {
  data() {
    return {
      screenSize: "",
      debouncedSetScreenSize: () => {
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debouncedSetScreenSize = zo(this.setScreenSize, 100), window.addEventListener("resize", this.debouncedSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = document.documentElement.clientWidth;
    }
  }
}, I = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, p9 = {
  name: "LinesAccent"
}, f9 = { class: "lines-accent" };
function g9(e, t, n, o, i, r) {
  return l(), h("div", f9, [
    (l(), h(G, null, q(3, (a, s) => d("div", {
      key: s,
      class: "accent"
    })), 64))
  ]);
}
const v9 = /* @__PURE__ */ I(p9, [["render", g9], ["__scopeId", "data-v-0477e467"]]), b9 = {
  name: "DotsAccent",
  methods: {
    yOffset(e) {
      return e * 8 + 1;
    }
  }
}, y9 = { class: "dots-accent" }, C9 = {
  width: "4000",
  height: "18",
  viewBox: "0 0 4000 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _9 = ["y1", "y2"];
function w9(e, t, n, o, i, r) {
  return l(), h("div", y9, [
    (l(), h("svg", C9, [
      (l(), h(G, null, q(3, (a, s) => d("line", {
        key: s,
        x1: "0",
        y1: r.yOffset(s),
        x2: "4000",
        y2: r.yOffset(s),
        "stroke-dasharray": "2, 6",
        "stroke-width": "2"
      }, null, 8, _9)), 64))
    ]))
  ]);
}
const T9 = /* @__PURE__ */ I(b9, [["render", w9], ["__scopeId", "data-v-49a600d6"]]), k9 = {
  name: "HeaderAccent",
  components: { LinesAccent: v9, DotsAccent: T9 },
  props: {
    version: {
      type: String,
      default: ""
    }
  },
  computed: {
    accentType() {
      return this.version === "dot" ? "DotsAccent" : "LinesAccent";
    }
  }
}, E9 = { class: "header-accent" };
function S9(e, t, n, o, i, r) {
  return l(), h("div", E9, [
    (l(), _(R(r.accentType)))
  ]);
}
const M9 = /* @__PURE__ */ I(k9, [["render", S9], ["__scopeId", "data-v-8bc0e22c"]]), $9 = {
  name: "SeeAllContainer",
  components: { HeaderAccent: M9 },
  mixins: [rt],
  props: {
    themeOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      headerWidth: 32
    };
  },
  computed: {
    cssVars() {
      return {
        "--width-header": `${this.headerWidth}px`
      };
    },
    accentType() {
      return T(this.themeOptions, "globalThemeSettings.accentType", "dot");
    }
  },
  watch: {
    screenSize() {
      this.resize("watch");
    }
  },
  mounted() {
    this.resize("mounted");
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        if (!this.$refs["header-slot-container"]) return;
        const e = this.$refs["header-slot-container"];
        e.firstElementChild && e.firstElementChild.offsetWidth !== null && e.firstElementChild.offsetWidth > 32 && (this.headerWidth = e.firstElementChild.offsetWidth);
      });
    }
  }
}, I9 = {
  ref: "header-slot-container",
  class: "header-slot-container"
}, A9 = {
  class: "purple-header-accent",
  "data-testid": "purple-header-accent"
};
function L9(e, t, n, o, i, r) {
  const a = S("HeaderAccent");
  return l(), h("div", {
    class: "see-all-container",
    "data-testid": "header",
    style: H(r.cssVars)
  }, [
    t[0] || (t[0] = d("span", {
      "data-testid": "monterrey-header-accent-left",
      class: "monterrey-header-accent-left"
    }, null, -1)),
    d("div", I9, [
      C(e.$slots, "header", { ref: "header-slot" })
    ], 512),
    d("div", A9, [
      $(a, { version: r.accentType }, null, 8, ["version"])
    ]),
    t[1] || (t[1] = d("span", {
      "data-testid": "light-header-accent",
      class: "light-header-accent"
    }, null, -1)),
    t[2] || (t[2] = d("span", {
      "data-testid": "monterrey-header-accent",
      class: "monterrey-header-accent"
    }, null, -1)),
    C(e.$slots, "default")
  ], 4);
}
const O9 = /* @__PURE__ */ I($9, [["render", L9], ["__scopeId", "data-v-bf33d851"]]), Qe = {
  components: { SeeAllContainer: O9 },
  mixins: [rt],
  methods: {
    getColorOption(e, ...t) {
      const n = t.find((o) => e[o]);
      return n ? e[n] : { hex: "" };
    },
    link(e = "") {
      return this.isPreview ? "#" : `${this.pathPrefix}/${e}`;
    },
    sharedThemeColors() {
      const e = this.theme.style, n = ["light", "purple", "monterrey", "sydney"].includes(e), o = T(this.theme, "bg_color.hex", "none"), i = T(this.theme, "heading_color.hex", "#000"), r = T(this.theme, "top_heading_color.hex", "#000"), a = T(this.theme, "see_all_link_color.hex", i), s = T(this.theme, "see_all_bg_color.hex", "#000"), u = T(this.theme, "see_all_text_color.hex", "#fff"), c = T(this.theme, "button_border_color.hex", "#000"), y = n ? T(this.theme, "button_bg_color.hex", s) : "none", w = n ? T(this.theme, "button_text_color.hex", u) : a, v = T(this.theme, "header_accent_color.hex", "#000");
      return {
        "--bg-color": o,
        "--heading-color": i,
        "--top-heading-color": r,
        "--button-bg-color": y,
        "--button-text-color": w,
        "--button-border-color": c,
        "--header-accent-color": v,
        "--focus-visible-outline": ie.mostReadable(o, ["#0000FF", "#FFFFFF"], { includeFallbackColors: !0 }).toHexString(),
        "--focus-visible-box-shadow": "#FFFFFF"
      };
    }
  }
};
function Ku(e = "", t = 180) {
  return e.length <= t ? e : e.slice(0, t).concat("...");
}
const _l = (e = "") => e.replace(/<[^>]*>/g, "").trim(), Ss = (e = "") => {
  const t = {
    "&amp;": "&",
    "&nbsp;": " ",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#44;": ",",
    "&gt;": ">",
    "&lt;": "<"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (o) => t[o.toLowerCase()]);
}, N9 = (e = "", t = 180) => t ? Ku(_l(Ss(e)), t) : _l(Ss(e)), H9 = (e = "") => e.toLowerCase().replace(/ /g, "-"), P9 = (e = "") => {
  const n = (e.match(/<[^>]*>*/g) || []).pop() || "</>";
  return n.startsWith("</") ? e : e.replace(n, "...");
}, rn = {
  mixins: [Qe],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    articles: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    isIFrame: Boolean,
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    cssVars() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return de(oe({}, e), {
        "--article-title-color": T(this.theme, "article_title_color.hex", t),
        "--article-date-color": T(this.theme, "article_date_color.hex", "#757575"),
        "--article-link-color": T(this.theme, "article_link_color.hex", "#CC314B"),
        "--snippet-color": T(this.theme, "snippet_color.hex", "#333"),
        "--news-accent-border-color": T(
          this.theme,
          "news_image_borders_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--news-accent-image-bar": T(
          this.theme,
          "news_image_color_bar.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--top-heading-color": T(this.theme, "top_heading_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-border-color": T(
          this.theme,
          "button_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--pager-color": T(this.theme, "pager_color.hex", "#CC314B"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "#CC314B"),
        "--event-arrow-color": T(this.theme, "event_arrow_color.hex", "#fff"),
        "--scrollbar-color": T(this.theme, "scrollbar_color.hex", "#000"),
        "--scrollbar-bg_color": T(
          this.theme,
          "scrollbar_bg_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--scrollbar-arrow-color": T(this.theme, "scrollbar_arrow_color.hex", "#000"),
        "--arrow-icon-color": T(this.theme, "arrow_icon_color.hex", "#fff"),
        "--overlay-color": T(this.theme, "overlay_color.hex", "#000"),
        "--arrow-border-color": T(this.theme, "arrow_border_color.hex", "#000"),
        "--focus-outline-width": "2px",
        "--focus-outline-offset": "1px",
        "--focus-outline-margin": "calc(var(--focus-outline-width) + var(--focus-outline-offset))",
        "--focus-outline-shadow": "0 0 0 calc(var(--focus-outline-margin) * 2)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("news");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    saniTruncate: N9,
    replaceHTMLEntities: Ss,
    calculateFocalPoints(e) {
      var o, i;
      if (!(e != null && e.cover_image)) return "50% 50%";
      const t = (o = e == null ? void 0 : e.image_focal_point_x) != null ? o : 50, n = (i = e == null ? void 0 : e.image_focal_point_y) != null ? i : 50;
      return `${t}% ${n}%`;
    }
  }
}, D9 = {
  name: "NewsStory",
  mixins: [rn],
  props: {
    item: {
      type: Object,
      required: !0
    },
    showSnippet: {
      type: Boolean,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      required: !0
    },
    showPublishedTime: {
      type: Boolean,
      default: !1
    },
    totalCards: {
      type: Number,
      default: 0
    },
    cardNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    showSliderAriaLabels() {
      return ["N6-story", "N5-story"].includes(this.variant);
    },
    renderSeeAllButtonOverImage() {
      return this.seeAllButtonOverImage && this.theme.style !== "bold" && this.screenSize < 481;
    }
  },
  methods: {
    formatDate(e) {
      const t = e !== void 0 ? new Date(e) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(t);
    }
  }
}, R9 = ["role", "aria-roledescription", "aria-label"], V9 = ["href"], B9 = { class: "news-image-container" }, F9 = { class: "news-image" }, j9 = ["src"], U9 = {
  key: 0,
  class: "news-date",
  "data-testid": "news-date"
};
function K9(e, t, n, o, i, r) {
  return l(), h("div", {
    role: r.showSliderAriaLabels ? "group" : void 0,
    "aria-roledescription": r.showSliderAriaLabels ? "slide" : void 0,
    "aria-label": r.showSliderAriaLabels ? `${n.cardNumber} of ${n.totalCards}` : void 0,
    class: p(["story", e.theme.style, n.variant])
  }, [
    d("a", {
      href: e.link(`article/${n.item.id}`),
      class: "news-image-title-link"
    }, [
      d("div", B9, [
        d("div", F9, [
          d("div", {
            class: p(["image-hidden-wrapper", { "accent-styling": r.hasAccentStyling }])
          }, [
            d("img", {
              alt: "",
              src: n.item.cover_image ? n.item.cover_image : e.fallbackImage.url,
              style: H({ objectPosition: e.calculateFocalPoints(this.item) }),
              loading: "lazy"
            }, null, 12, j9),
            t[0] || (t[0] = d("div", { class: "news-backdrop" }, null, -1))
          ], 2)
        ])
      ]),
      n.showPublishedTime ? (l(), h("div", U9, f(r.formatDate(n.item.published_at)), 1)) : g("", !0),
      n.showTitle ? (l(), h("div", {
        key: 1,
        class: p(["news-title", [e.theme.style, { "accent-styling": r.hasAccentStyling }]])
      }, [
        k(f(e.saniTruncate(n.item.title)) + " ", 1),
        d("div", {
          class: p(["news-snippet inner-snippet", e.theme.style])
        }, f(e.replaceHTMLEntities(n.item.snippet)), 3)
      ], 2)) : g("", !0)
    ], 8, V9),
    n.showSnippet ? (l(), h("div", {
      key: 0,
      class: p(["news-snippet outer-snippet", e.theme.style])
    }, f(e.replaceHTMLEntities(n.item.snippet)), 3)) : g("", !0)
  ], 10, R9);
}
const Mn = /* @__PURE__ */ I(D9, [["render", K9], ["__scopeId", "data-v-956c32b0"]]), G9 = {
  name: "N1",
  components: { NewsStory: Mn },
  mixins: [rn]
}, z9 = ["data-testid"], Z9 = { class: "news-content" };
function W9(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory");
  return l(), h("div", {
    id: "news-n1",
    style: H(e.cssVars),
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n1"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, z9)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", Z9, [
      (l(!0), h(G, null, q(e.articles.slice(0, 4), (u, c) => (l(), _(s, {
        key: c,
        item: u,
        theme: e.theme,
        variant: "N1-story",
        class: p({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const q9 = /* @__PURE__ */ I(G9, [["render", W9], ["__scopeId", "data-v-d976f3ef"]]), Y9 = {
  name: "N2",
  components: { NewsStory: Mn },
  mixins: [rn]
}, x9 = ["data-testid"], X9 = { class: "news-content" }, Q9 = {
  "data-testid": "more-headlines",
  class: "more-headlines-header"
};
function J9(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory");
  return l(), h("div", {
    id: "news-n2",
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    style: H(e.cssVars)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, x9)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", X9, [
      (l(!0), h(G, null, q(e.articles.slice(0, 2), (u, c) => (l(), _(s, {
        key: c,
        item: u,
        theme: e.theme,
        variant: "N2-story",
        class: p({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    d("div", Q9, f(e.translations.more_headlines), 1),
    d("div", {
      class: p([e.theme.style, "more-headlines-content news-content"])
    }, [
      (l(!0), h(G, null, q(e.articles.slice(2, 6), (u, c) => (l(), _(s, {
        key: c,
        item: u,
        theme: e.theme,
        variant: "N2-more-story",
        class: p({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const ef = /* @__PURE__ */ I(Y9, [["render", J9], ["__scopeId", "data-v-288ce2d2"]]), tf = {
  name: "N3",
  components: { NewsStory: Mn },
  mixins: [rn]
}, nf = ["data-testid"], of = { class: "news-content" };
function rf(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory");
  return l(), h("div", {
    id: "news-n3",
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    style: H(e.cssVars)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, nf)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", of, [
      (l(!0), h(G, null, q(e.articles.slice(0, 4), (u, c) => (l(), _(s, {
        key: c,
        item: u,
        theme: e.theme,
        variant: "N3-story",
        class: p({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const sf = /* @__PURE__ */ I(tf, [["render", rf], ["__scopeId", "data-v-6c45c410"]]), af = {
  name: "N4",
  components: { NewsStory: Mn },
  mixins: [rn]
}, lf = ["data-testid"], df = { class: "news-content" };
function uf(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory");
  return l(), h("div", {
    id: "news-n4",
    style: H(e.cssVars),
    class: p([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, lf)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", df, [
      (l(!0), h(G, null, q(e.articles.slice(0, 3), (u, c) => (l(), _(s, {
        key: c,
        item: u,
        theme: e.theme,
        variant: "N4-story",
        class: p({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.isPurpleStyle || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const cf = /* @__PURE__ */ I(af, [["render", uf], ["__scopeId", "data-v-6981df32"]]), hf = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, mf = ["fill"], pf = ["stroke"];
function ff(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.21582 1.18164L6.21582 14.1816M6.21582 1.18164L1.21582 5.97111M6.21582 1.18164L11.2158 5.97112",
      stroke: n.fillColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, pf)
  ], 8, mf);
}
const gf = /* @__PURE__ */ I(hf, [["render", ff]]), We = {
  data() {
    return {
      currentCard: 0,
      visibleCardNum: 0,
      allCardsVisible: !1
    };
  },
  computed: {
    pagerSectionCount() {
      return Math.ceil(this.content.length / (this.visibleCardNum <= 0 ? 1 : this.visibleCardNum));
    },
    sliderCenterElements() {
      return this.sliderCenterSize && this.sliderCenterSize >= this.screenSize;
    },
    sliderReady() {
      return !!(this.$refs[`sliderCard-${this.currentCard}`] && this.$refs["sliderCard-0"] && this.$refs[`sliderCard-${this.content.length - 1}`]);
    }
  },
  mixins: [rt],
  mounted() {
    this.$nextTick(() => {
      this.sliderReady && this.setVisibleCardNumber();
    }), window.addEventListener("resize", this.setVisibleCardNumber);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setVisibleCardNumber);
  },
  methods: {
    setVisibleCardNumber() {
      const e = this.lastVisibleCard(), t = this.firstVisibleCard();
      this.allCardsVisible = e < 0 && t === 0, this.visibleCardNum = e - t || 1, this.calculateScroll();
    },
    calculateScroll() {
      if (this.sliderReady) {
        const e = this.getHTMLElement(this.$refs[`sliderCard-${this.currentCard}`]), t = this.getHTMLElement(this.$refs["sliderCard-0"]), n = this.getHTMLElement(this.$refs[`sliderCard-${this.content.length - 1}`]), o = this.getHTMLElement(this.$refs.scrollWrapper);
        t.style["margin-left"] = this.sliderCenterElements ? "50vw" : "0px", n.style["margin-right"] = this.sliderCenterElements ? "50vw" : "0px";
        const i = e.getBoundingClientRect().left, r = this.sliderCenterElements ? e.offsetWidth / 2 : 0, a = this.sliderCenterElements ? (o.getBoundingClientRect().left + o.getBoundingClientRect().right) / 2 : o.getBoundingClientRect().left, s = i - (a - r);
        o.scrollLeft += s;
      }
    },
    lastVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().right;
      return this.content.findIndex((n, o) => {
        var r, a;
        return ((a = this.getHTMLElement((r = this.$refs) == null ? void 0 : r[`sliderCard-${o}`])) == null ? void 0 : a.getBoundingClientRect().right) > t;
      });
    },
    firstVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().left;
      return this.content.findIndex((n, o) => {
        var r, a;
        const i = (a = this.getHTMLElement((r = this.$refs) == null ? void 0 : r[`sliderCard-${o}`])) == null ? void 0 : a.getBoundingClientRect().left;
        return Math.round(i) >= t;
      });
    },
    scrollLeft() {
      if (this.sliderCenterElements)
        this.currentCard = this.currentCard === 0 ? this.content.length - 1 : this.currentCard - 1;
      else {
        const e = this.firstVisibleCard() - 1;
        this.currentCard = e < 0 ? this.content.length - 1 : e;
      }
      this.calculateScroll();
    },
    scrollRight() {
      this.sliderCenterElements ? this.currentCard = this.currentCard === this.content.length - 1 ? 0 : this.currentCard + 1 : this.currentCard = this.lastVisibleCard() < 0 || this.currentCard === this.content.length - this.visibleCardNum ? 0 : this.currentCard + 1, this.calculateScroll();
    },
    goToSection(e) {
      this.currentCard = (e - 1) * this.visibleCardNum, this.calculateScroll();
    },
    getHTMLElement(e) {
      if (!this.sliderReady)
        return;
      const t = Array.isArray(e) ? e[0] : e;
      return t instanceof Element ? t : t.$el;
    }
  }
}, vf = {
  name: "Pager",
  props: {
    pagerColor: {
      type: String,
      default: "#0F0F0F"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      required: !0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagerStyles() {
      return {
        "--total-sections": this.pagerSectionCount,
        "--pager-color": this.pagerColor
      };
    },
    cardsPerSection() {
      return Math.ceil(this.totalCards / this.pagerSectionCount);
    }
  },
  methods: {
    activeCard(e) {
      const t = (e - 1) * this.cardsPerSection, n = e * this.cardsPerSection - 1;
      return this.currentCard >= t && this.currentCard <= n;
    },
    ariaLabel(e) {
      return this.activeCard(e) ? T(this.themeStyles, "translations.active", "Active") : T(this.themeStyles, "translations.inactive", "Inactive");
    },
    ariaText(e) {
      return `Display slide ${this.cardsPerSection * e - this.cardsPerSection + 1} through ${this.cardsPerSection * e}`;
    }
  }
}, bf = ["aria-current", "aria-label", "onClick"];
function yf(e, t, n, o, i, r) {
  return l(), h("div", {
    class: "pager",
    style: H(r.pagerStyles)
  }, [
    (l(!0), h(G, null, q(n.pagerSectionCount, (a, s) => (l(), h("button", {
      key: s,
      class: p([{ active: r.activeCard(a) }, "section"]),
      "aria-current": r.ariaLabel(a),
      "aria-label": r.ariaText(a),
      onClick: (u) => e.$emit("go-to-section", a)
    }, null, 10, bf))), 128))
  ], 4);
}
const na = /* @__PURE__ */ I(vf, [["render", yf], ["__scopeId", "data-v-627c6375"]]), Cf = {
  name: "SliderLeftButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, _f = ["aria-label"], wf = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tf = ["stroke"];
function kf(e, t, n, o, i, r) {
  return l(), h("button", {
    class: "scroll-left",
    "aria-label": n.translatedAria,
    style: H({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left"))
  }, [
    (l(), h("svg", wf, [
      d("path", {
        d: "M1 6L14 6M1 6L5.78947 11M1 6L5.78947 0.999999",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Tf)
    ]))
  ], 12, _f);
}
const Ef = /* @__PURE__ */ I(Cf, [["render", kf], ["__scopeId", "data-v-766a4ad9"]]), Sf = {
  name: "SliderRightButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, Mf = ["aria-label"], $f = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, If = ["stroke"];
function Af(e, t, n, o, i, r) {
  return l(), h("button", {
    class: "scroll-right",
    "aria-label": n.translatedAria,
    style: H({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-right"))
  }, [
    (l(), h("svg", $f, [
      d("path", {
        d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, If)
    ]))
  ], 12, Mf);
}
const Lf = /* @__PURE__ */ I(Sf, [["render", Af], ["__scopeId", "data-v-e7f3ab3f"]]), Of = {
  name: "NavSection",
  components: {
    Pager: na,
    LeftSliderButton: Ef,
    RightSliderButton: Lf
  },
  props: {
    hasPager: {
      type: Boolean
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      default: ""
    }
  },
  computed: {
    navStyles() {
      return {
        "--nav-margin-bottom": this.navOrientation === "top" ? "32px" : "0",
        "--nav-margin-top": this.navOrientation === "bottom" || this.navOrientation === "wide" ? "32px" : "0",
        "--button-section-margin": this.navOrientation === "top" || this.navOrientation === "wide" ? "0" : "40px"
      };
    },
    eventArrowColor() {
      return T(this.themeStyles, "event_arrow_color.hex", "#fff");
    },
    arrowIconColor() {
      return T(this.themeStyles, "arrow_icon_color.hex", this.eventArrowColor);
    },
    arrowBackgroundColor() {
      return T(this.themeStyles, "arrow_background_color.hex", "#000");
    },
    pagerColor() {
      return T(this.themeStyles, "pager_color.hex", "#000");
    },
    nextSlideText() {
      return T(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return T(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, Nf = {
  class: "button-section",
  "data-testid": "slider-buttons"
}, Hf = {
  key: 0,
  class: "pager-section"
};
function Pf(e, t, n, o, i, r) {
  const a = S("LeftSliderButton"), s = S("RightSliderButton"), u = S("Pager");
  return l(), h("div", {
    class: p(["nav", `pager-${n.pagerOrientation}`]),
    style: H([n.themeStyles, r.navStyles]),
    role: "group",
    "aria-label": "slide controls"
  }, [
    d("div", Nf, [
      $(a, {
        class: "button",
        "arrow-background-color": r.arrowBackgroundColor,
        "arrow-icon-color": r.arrowIconColor,
        "translated-aria": r.previousSlideText,
        onScrollLeft: t[0] || (t[0] = (c) => e.$emit("scroll-left"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"]),
      $(s, {
        class: "button",
        "arrow-background-color": r.arrowBackgroundColor,
        "arrow-icon-color": r.arrowIconColor,
        "translated-aria": r.nextSlideText,
        onScrollRight: t[1] || (t[1] = (c) => e.$emit("scroll-right"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"])
    ]),
    n.hasPager ? (l(), h("div", Hf, [
      $(u, {
        "total-cards": n.totalCards,
        "pager-color": r.pagerColor,
        "theme-styles": n.themeStyles,
        "current-card": n.currentCard,
        "pager-section-count": n.pagerSectionCount,
        onGoToSection: t[2] || (t[2] = (c) => e.$emit("go-to-section", c))
      }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count"])
    ])) : g("", !0)
  ], 6);
}
const Df = /* @__PURE__ */ I(Of, [["render", Pf], ["__scopeId", "data-v-a6b106b3"]]), Rf = {
  name: "CardSlider",
  components: { NavSection: Df },
  props: {
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    hasPager: {
      type: Boolean,
      default: !0
    },
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: {
      type: Boolean
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      required: !0
    }
  }
}, Vf = ["aria-label"];
function Bf(e, t, n, o, i, r) {
  const a = S("NavSection");
  return l(), h("div", {
    class: p([n.navOrientation, "card-slider"]),
    "aria-label": n.sectionHeader,
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    n.allCardsVisible ? g("", !0) : (l(), _(a, {
      key: 0,
      "nav-orientation": n.navOrientation,
      "pager-orientation": n.pagerOrientation,
      "pager-section-count": n.pagerSectionCount,
      "current-card": n.currentCard,
      "total-cards": n.totalCards,
      "theme-styles": n.themeStyles,
      "has-pager": n.hasPager,
      "section-header": n.sectionHeader,
      onGoToSection: t[0] || (t[0] = (s) => e.$emit("go-to-section", s)),
      onScrollLeft: t[1] || (t[1] = (s) => e.$emit("scroll-left")),
      onScrollRight: t[2] || (t[2] = (s) => e.$emit("scroll-right"))
    }, null, 8, ["nav-orientation", "pager-orientation", "pager-section-count", "current-card", "total-cards", "theme-styles", "has-pager", "section-header"])),
    C(e.$slots, "default")
  ], 10, Vf);
}
const It = /* @__PURE__ */ I(Rf, [["render", Bf], ["__scopeId", "data-v-d95008db"]]), Ff = {
  name: "N5",
  components: { NewsStory: Mn, ArrowIcon: gf, CardSlider: It },
  mixins: [rn, We],
  data: () => ({
    activeNewsContainer: 0,
    newsArticles: []
  }),
  computed: {
    scrollbarArrowColor() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.scrollbar_arrow_color) || { hex: "#FFF" };
    },
    cardSliderStyles() {
      var e, t;
      return de(oe({}, this.theme), {
        arrow_background_color: ((e = this.theme) == null ? void 0 : e.scrollbar_bg_color) || this.cssVars["--scrollbar-bg_color"],
        arrow_icon_color: ((t = this.theme) == null ? void 0 : t.scrollbar_arrow_color) || this.cssVars["--scrollbar-arrow-color"]
      });
    },
    totalArticles() {
      return { "--total-articles": this.articles.slice(0, 6).length };
    },
    content() {
      return this.newsArticles;
    },
    sliderCenterSize() {
      return 959;
    },
    responsiveSliderImage() {
      return {
        "--responsive-width": this.newsArticles.length > 1 && this.screenSize >= 960 ? `${this.screenSize - 80}px` : "100%"
      };
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    overviewImage() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.cover_image) || this.fallbackImage.url;
    },
    overviewTitle() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.title) || "";
    },
    articleTitle() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.title) || "";
    },
    overviewPublishedTime() {
      var t;
      const e = (t = this.newsArticles[0]) != null && t.published_at ? new Date(this.newsArticles[0].published_at) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(e);
    },
    overviewLink() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.id) || "";
    },
    overviewStyles() {
      return {
        "--overview-width": this.newsArticles.length === 1 ? "100%" : "70%",
        "--overview-width-md": this.newsArticles.length === 1 ? "100%" : "55%",
        "--overview-body-width": this.newsArticles.length === 1 ? "auto" : "90%",
        "--overview-body-margin": this.newsArticles.length === 1 ? "48px" : "0",
        "--overview-margin-md": this.newsArticles.length === 1 ? "0" : "35px"
      };
    },
    scrollStyles() {
      return {
        "--wrapper-margin-bottom": this.newsArticles.length < 5 ? "0" : "-32px"
      };
    },
    articleLink() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.id) || "";
    },
    nextSlideText() {
      return T(this.translations, "next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return T(this.translations, "previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    },
    displaySeeAllBottom() {
      return this.isPurpleStyle || this.screenSize < 960 && !this.isBoldStyle || this.screenSize < 600;
    },
    displaySeeAllTop() {
      return !this.isPurpleStyle && this.screenSize >= 960 || this.isBoldStyle && this.screenSize < 959 && this.screenSize >= 600;
    },
    n5PagerStyle() {
      return {
        "--pager-width": `${this.screenSize / this.newsArticles.length * 0.8}px`
      };
    }
  },
  created() {
    this.newsArticles = this.articles.slice(0, 6);
  },
  methods: {
    /**
     * @name scrollUp
     * First it triggers the moveUp function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the last element in the list and pushing it at the beginning.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollUp() {
      const e = this.newsArticles, t = e.pop();
      e.unshift(t), this.newsArticles = e, this.activeNewsContainer === 0 ? this.activeNewsContainer = this.newsArticles.length - 1 : this.activeNewsContainer -= 1;
    },
    /**
     * @name scrollDown
     * First it triggers the moveDown function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the first element in the list and pushing it at the end.
     * After that, it calls the function setOverviewNews to change the overview news on the left.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollDown() {
      const e = this.newsArticles, t = e.shift();
      e.push(t), this.newsArticles = e, this.activeNewsContainer === this.newsArticles.length - 1 ? this.activeNewsContainer = 0 : this.activeNewsContainer += 1;
    }
  }
}, jf = { class: "news-v5-title" }, Uf = ["data-testid"], Kf = ["data-testid"], Gf = { class: "news-overview" }, zf = { class: "news-overview-body" }, Zf = ["href"], Wf = ["src"], qf = { class: "news-overview-published-time" }, Yf = { class: "news-overview-title" }, xf = { class: "news-overview-link" }, Xf = ["aria-label"], Qf = {
  key: 0,
  class: "news-scroll",
  role: "group",
  "aria-label": "slide controls"
}, Jf = ["aria-label"], eg = ["aria-label"], tg = ["aria-current"], ng = { class: "article-title" }, og = ["href"], rg = ["href"];
function ig(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("arrow-icon"), u = S("NewsStory"), c = S("CardSlider");
  return l(), h("div", {
    id: "news-n5",
    style: H(e.cssVars),
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n5"
  }, [
    d("div", jf, [
      $(a, {
        class: p([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (l(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, Kf)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ], 8, Uf)
        ]),
        default: b(() => [
          r.displaySeeAllTop ? (l(), _(R(e.isEditing ? "button" : "a"), {
            key: 0,
            class: p(["see-all-button hide-on-xs", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (y) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ]),
    e.screenSize >= 960 ? (l(), h("div", {
      key: 0,
      class: p(["news-content", { "is-editing": e.isEditing }]),
      style: H(r.overviewStyles)
    }, [
      d("div", Gf, [
        d("div", zf, [
          d("a", {
            href: e.link(`article/${r.overviewLink}`)
          }, [
            d("div", {
              class: p([{ "accent-styling": r.hasAccentStyling }, "news-overview-image-container"])
            }, [
              (l(), h("img", {
                key: e.activeNewsContainer,
                src: r.overviewImage,
                style: H({ objectPosition: e.calculateFocalPoints(this.newsArticles[0]) }),
                alt: "",
                class: "news-overview-image"
              }, null, 12, Wf)),
              t[4] || (t[4] = d("div", { class: "news-backdrop" }, null, -1))
            ], 2),
            d("p", qf, f(r.overviewPublishedTime), 1),
            d("h3", Yf, f(r.overviewTitle), 1),
            d("div", xf, [
              d("p", null, f(e.translations.read_article), 1)
            ])
          ], 8, Zf)
        ])
      ]),
      d("div", {
        "aria-label": e.sectionHeader,
        class: "news-scroll-wrapper",
        role: "region",
        "aria-roledescription": "carousel"
      }, [
        e.newsArticles.length > 4 ? (l(), h("div", Qf, [
          d("button", {
            class: "news-scroll-up",
            "aria-label": r.previousSlideText,
            onClick: t[1] || (t[1] = (...y) => r.scrollUp && r.scrollUp(...y))
          }, [
            $(s, {
              "fill-color": r.scrollbarArrowColor.hex,
              class: "arrow"
            }, null, 8, ["fill-color"])
          ], 8, Jf),
          d("button", {
            class: "news-scroll-down",
            "aria-label": r.nextSlideText,
            onClick: t[2] || (t[2] = (...y) => r.scrollDown && r.scrollDown(...y))
          }, [
            $(s, {
              "fill-color": r.scrollbarArrowColor.hex,
              class: "arrow",
              "dropdown-class": "open"
            }, null, 8, ["fill-color"])
          ], 8, eg),
          d("div", {
            class: "progress-bar",
            style: H(r.totalArticles)
          }, [
            (l(!0), h(G, null, q(e.newsArticles, (y, w) => (l(), h("div", {
              key: y.id,
              class: p(["progress-section", { active: e.activeNewsContainer === w }]),
              "aria-current": e.activeNewsContainer === w ? e.translations.active : e.translations.inactive
            }, null, 10, tg))), 128))
          ], 4)
        ])) : g("", !0),
        d("div", {
          class: "news-list",
          "data-testid": "list",
          style: H({ "margin-right": e.newsArticles.length < 5 ? "15px" : 0 })
        }, [
          $(nn, {
            name: "scroll-wrapper",
            tag: "div",
            class: "scroll-wrapper",
            style: H(r.scrollStyles)
          }, {
            default: b(() => [
              (l(!0), h(G, null, q(e.newsArticles, (y, w) => (l(), _(u, {
                key: y.id,
                item: y,
                theme: e.theme,
                class: p([{ "is-editing": e.isEditing, "has-scroll": e.newsArticles.length > 4 }, "article-container"]),
                "show-snippet": !1,
                "is-preview": e.isPreview,
                "fallback-image": e.fallbackImage,
                "path-prefix": e.pathPrefix,
                "total-cards": e.newsArticles.length,
                "card-number": w + 1,
                variant: "N5-story",
                "data-testid": "news-story"
              }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ], 4)
      ], 8, Xf)
    ], 6)) : (l(), _(c, {
      key: 1,
      "current-card": e.currentCard,
      "pager-section-count": e.newsArticles.length,
      "all-cards-visible": e.newsArticles.length === 1,
      "total-cards": e.newsArticles.length,
      "theme-styles": r.cardSliderStyles,
      "section-header": e.sectionHeader,
      "pager-orientation": "right",
      class: p({ "all-cards-visible": e.allCardsVisible }),
      style: H(r.n5PagerStyle),
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        d("div", {
          ref: "scrollWrapper",
          class: p(["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]),
          "data-testid": "blocks-array"
        }, [
          (l(), _(u, {
            ref: "`sliderCard-0",
            key: e.newsArticles[e.currentCard].id,
            item: e.newsArticles[e.currentCard],
            theme: e.theme,
            "show-snippet": !1,
            "show-title": !1,
            "show-published-time": !0,
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": e.newsArticles.length,
            "card-number": e.currentCard,
            "aria-label": `${e.currentCard} of ${e.newsArticles.length}`,
            class: p([{ "is-editing": e.isEditing }, "article"]),
            "aria-roledescription": "slide",
            role: "group",
            variant: "N5-story",
            "data-testid": "news-story",
            style: H(r.responsiveSliderImage)
          }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number", "aria-label", "class", "style"])),
          d("h3", ng, [
            d("a", {
              href: e.link(`article/${e.newsArticles[e.currentCard].id}`)
            }, f(r.articleTitle), 9, og)
          ]),
          d("a", {
            href: e.link(`article/${e.newsArticles[e.currentCard].id}`),
            class: "article-link"
          }, [
            d("p", null, f(e.translations.read_article), 1)
          ], 8, rg)
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "style", "onScrollRight", "onScrollLeft", "onGoToSection"])),
    r.displaySeeAllBottom ? (l(), _(a, {
      key: 2,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[3] || (t[3] = (y) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const sg = /* @__PURE__ */ I(Ff, [["render", ig], ["__scopeId", "data-v-807a5fa1"]]), ag = {
  name: "N6",
  components: { NewsStory: Mn, CardSlider: It },
  mixins: [rn, We],
  data() {
    const e = this.articles.slice(0, 6);
    return {
      newsArticles: e,
      newsArticlesLength: e.length
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return de(oe({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, lg = ["data-testid"], dg = ["data-testid"], ug = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function cg(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory"), u = S("CardSlider");
  return l(), h("div", {
    id: "news-n6",
    "data-testid": "news-v6",
    style: H(e.cssVars),
    class: p([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, dg)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, lg)
      ]),
      default: b(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (c) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(u, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.newsArticles.length,
      class: p({ "is-editing": e.isEditing }),
      "theme-styles": r.themeStyles,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        d("div", ug, [
          (l(!0), h(G, null, q(i.newsArticles, (c, y) => (l(), _(s, {
            ref_for: !0,
            ref: `sliderCard-${y}`,
            key: c.id,
            item: c,
            theme: e.theme,
            class: p({ "is-editing": e.isEditing }),
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": i.newsArticles.length,
            "card-number": y + 1,
            "show-published-time": "",
            variant: "N6-story",
            "data-testid": "news-story"
          }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
        ], 512)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "total-cards", "class", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (c) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const hg = /* @__PURE__ */ I(ag, [["render", cg], ["__scopeId", "data-v-0747c7a9"]]), mg = {
  name: "N7",
  components: { NewsStory: Mn, CardSlider: It },
  mixins: [rn, We],
  data() {
    return {
      newsArticles: this.articles.slice(0, 6)
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return de(oe({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, pg = ["data-testid"], fg = ["data-testid"], gg = { class: "color-overlay" }, vg = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function bg(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("NewsStory"), u = S("CardSlider");
  return l(), h("div", {
    "data-testid": "news-v7",
    style: H(e.cssVars),
    class: p([e.theme.style, "news-n7"])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, fg)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, pg)
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize > 480 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (c) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", gg, [
      $(u, {
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "has-pager": !1,
        "current-card": e.currentCard,
        "total-cards": i.newsArticles.length,
        "section-header": e.sectionHeader,
        "theme-styles": r.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: b(() => [
          d("div", vg, [
            (l(!0), h(G, null, q(i.newsArticles, (c, y) => (l(), _(s, {
              ref_for: !0,
              ref: `sliderCard-${y}`,
              key: c.id,
              item: c,
              theme: e.theme,
              "is-preview": e.isPreview,
              "fallback-image": e.fallbackImage,
              "path-prefix": e.pathPrefix,
              "total-cards": e.articles.length,
              "card-number": y + 1,
              "show-published-time": "",
              variant: "N7-story",
              "data-testid": "news-story"
            }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style !== "bold" || e.screenSize < 960 ? (l(), _(a, {
        key: 0,
        class: p([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: b(() => [
          (l(), _(R(e.isEditing ? "button" : "a"), {
            class: p(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-bottom`,
            onClick: t[1] || (t[1] = (c) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options"])) : g("", !0)
    ])
  ], 6);
}
const yg = /* @__PURE__ */ I(mg, [["render", bg], ["__scopeId", "data-v-c2ace552"]]);
var Cg = Object.prototype;
function _g(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Cg;
  return e === n;
}
var hi = _g;
function wg(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Gu = wg, Tg = Gu, kg = Tg(Object.keys, Object), Eg = kg, Sg = hi, Mg = Eg, $g = Object.prototype, Ig = $g.hasOwnProperty;
function Ag(e) {
  if (!Sg(e))
    return Mg(e);
  var t = [];
  for (var n in Object(e))
    Ig.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var zu = Ag, Lg = Sn, Og = Ct, Ng = Lg(Og, "DataView"), Hg = Ng, Pg = Sn, Dg = Ct, Rg = Pg(Dg, "Promise"), Vg = Rg, Bg = Sn, Fg = Ct, jg = Bg(Fg, "Set"), Ug = jg, Kg = Sn, Gg = Ct, zg = Kg(Gg, "WeakMap"), Zg = zg, Ms = Hg, $s = ea, Is = Vg, As = Ug, Ls = Zg, Zu = Xo, oo = Du, wl = "[object Map]", Wg = "[object Object]", Tl = "[object Promise]", kl = "[object Set]", El = "[object WeakMap]", Sl = "[object DataView]", qg = oo(Ms), Yg = oo($s), xg = oo(Is), Xg = oo(As), Qg = oo(Ls), fn = Zu;
(Ms && fn(new Ms(new ArrayBuffer(1))) != Sl || $s && fn(new $s()) != wl || Is && fn(Is.resolve()) != Tl || As && fn(new As()) != kl || Ls && fn(new Ls()) != El) && (fn = function(e) {
  var t = Zu(e), n = t == Wg ? e.constructor : void 0, o = n ? oo(n) : "";
  if (o)
    switch (o) {
      case qg:
        return Sl;
      case Yg:
        return wl;
      case xg:
        return Tl;
      case Xg:
        return kl;
      case Qg:
        return El;
    }
  return t;
});
var mi = fn, Jg = Xo, e4 = Jn, t4 = "[object Arguments]";
function n4(e) {
  return e4(e) && Jg(e) == t4;
}
var o4 = n4, Ml = o4, r4 = Jn, Wu = Object.prototype, i4 = Wu.hasOwnProperty, s4 = Wu.propertyIsEnumerable, a4 = Ml(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ml : function(e) {
  return r4(e) && i4.call(e, "callee") && !s4.call(e, "callee");
}, qu = a4, l4 = 9007199254740991;
function d4(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= l4;
}
var Yu = d4, u4 = Pu, c4 = Yu;
function h4(e) {
  return e != null && c4(e.length) && !u4(e);
}
var pi = h4, Fr = { exports: {} };
function m4() {
  return !1;
}
var p4 = m4;
Fr.exports;
(function(e, t) {
  var n = Ct, o = p4, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, a = r && r.exports === i, s = a ? n.Buffer : void 0, u = s ? s.isBuffer : void 0, c = u || o;
  e.exports = c;
})(Fr, Fr.exports);
var oa = Fr.exports, f4 = Xo, g4 = Yu, v4 = Jn, b4 = "[object Arguments]", y4 = "[object Array]", C4 = "[object Boolean]", _4 = "[object Date]", w4 = "[object Error]", T4 = "[object Function]", k4 = "[object Map]", E4 = "[object Number]", S4 = "[object Object]", M4 = "[object RegExp]", $4 = "[object Set]", I4 = "[object String]", A4 = "[object WeakMap]", L4 = "[object ArrayBuffer]", O4 = "[object DataView]", N4 = "[object Float32Array]", H4 = "[object Float64Array]", P4 = "[object Int8Array]", D4 = "[object Int16Array]", R4 = "[object Int32Array]", V4 = "[object Uint8Array]", B4 = "[object Uint8ClampedArray]", F4 = "[object Uint16Array]", j4 = "[object Uint32Array]", Ae = {};
Ae[N4] = Ae[H4] = Ae[P4] = Ae[D4] = Ae[R4] = Ae[V4] = Ae[B4] = Ae[F4] = Ae[j4] = !0;
Ae[b4] = Ae[y4] = Ae[L4] = Ae[C4] = Ae[O4] = Ae[_4] = Ae[w4] = Ae[T4] = Ae[k4] = Ae[E4] = Ae[S4] = Ae[M4] = Ae[$4] = Ae[I4] = Ae[A4] = !1;
function U4(e) {
  return v4(e) && g4(e.length) && !!Ae[f4(e)];
}
var K4 = U4;
function G4(e) {
  return function(t) {
    return e(t);
  };
}
var ra = G4, jr = { exports: {} };
jr.exports;
(function(e, t) {
  var n = Nu, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r && n.process, s = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || a && a.binding && a.binding("util");
    } catch (c) {
    }
  }();
  e.exports = s;
})(jr, jr.exports);
var ia = jr.exports, z4 = K4, Z4 = ra, $l = ia, Il = $l && $l.isTypedArray, W4 = Il ? Z4(Il) : z4, xu = W4, q4 = zu, Y4 = mi, x4 = qu, X4 = En, Q4 = pi, J4 = oa, e8 = hi, t8 = xu, n8 = "[object Map]", o8 = "[object Set]", r8 = Object.prototype, i8 = r8.hasOwnProperty;
function s8(e) {
  if (e == null)
    return !0;
  if (Q4(e) && (X4(e) || typeof e == "string" || typeof e.splice == "function" || J4(e) || t8(e) || x4(e)))
    return !e.length;
  var t = Y4(e);
  if (t == n8 || t == o8)
    return !e.size;
  if (e8(e))
    return !q4(e).length;
  for (var n in e)
    if (i8.call(e, n))
      return !1;
  return !0;
}
var a8 = s8;
const Ut = /* @__PURE__ */ Qn(a8), l8 = {
  name: "News",
  components: {
    N1: q9,
    N2: ef,
    N3: sf,
    N4: cf,
    N5: sg,
    N6: hg,
    N7: yg
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    sidebarOffset: {
      type: Number,
      default: 0
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fallbackImageDefault: {
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png",
        alt: "news default image"
      }
    };
  },
  computed: {
    cssVars() {
      return {
        "--sidebar-offset": `${this.sidebarOffset}px`
      };
    },
    fallbackImg() {
      return Ut(this.fallbackImage) ? this.fallbackImageDefault : this.fallbackImage;
    }
  }
}, d8 = { id: "view-news" };
function u8(e, t, n, o, i, r) {
  return l(), h("div", d8, [
    (l(), _(R(n.theme.version), {
      style: H(r.cssVars),
      theme: n.theme,
      articles: n.content,
      "news-config": n.newsConfig,
      "component-id": n.componentId,
      "is-preview": n.isPreview,
      "is-editing": n.isEditing,
      "is-i-frame": n.isIFrame,
      "fallback-image": r.fallbackImg,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["style", "theme", "articles", "news-config", "component-id", "is-preview", "is-editing", "is-i-frame", "fallback-image", "path-prefix"]))
  ]);
}
const c8 = /* @__PURE__ */ I(l8, [["render", u8], ["__scopeId", "data-v-b303fa92"]]), h8 = (e, t) => {
  const o = (() => {
    if (typeof t != "number")
      return "";
    switch (!0) {
      case t < 600:
        return "px600";
      case (t >= 600 && t < 960):
        return "px960";
      case (t >= 960 && t < 1280):
        return "px1280";
      case (t >= 1280 && t < 1600):
        return "px1600";
      case (t >= 1600 && t < 1920):
        return "px1920";
      case (t >= 1920 && t < 2560):
        return "px2560";
      default:
        return "";
    }
  })();
  e.forEach((i) => {
    var a;
    const r = new Image();
    r.src = o && ((a = i.sizes) == null ? void 0 : a[o]) || i.url;
  });
}, sn = {
  mixins: [Qe],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    hidePager: Boolean
  },
  data() {
    return {
      playSlideshow: !0,
      playVideo: !0,
      index: 0,
      activeImageIdx: 0,
      timer: null,
      transition: "right"
    };
  },
  computed: {
    imageHeight() {
      if (this.theme.version === "G1")
        return "";
      const e = this.theme.version === "G4";
      let t = "42.9vw";
      switch (this.theme.image_size) {
        case "small":
          t = e ? "47vw" : "31vw";
          break;
        case "medium":
          t = e ? "52vw" : "37vw";
          break;
        case "large":
          t = e ? "59vw" : "42.9vw";
          break;
        default:
          t = e ? "59vw" : "42.9vw";
      }
      return {
        "--image-height": t
      };
    },
    accentColor() {
      var e;
      return {
        "--gallery-accent-color": T(
          this.theme,
          "gallery_image_border_color.hex",
          (e = this.theme.globalThemeSettings) == null ? void 0 : e.secondaryColor
        )
      };
    },
    linkStyle() {
      return {
        "--link-color": this.theme.link_color.hex
      };
    },
    bgColor() {
      var e, t;
      return {
        "--bg-color": (t = (e = this.theme) == null ? void 0 : e.bg_color) == null ? void 0 : t.hex
      };
    },
    slides() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.slides) || [];
    },
    widget() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.widget) || {};
    },
    currentTransition() {
      return this.theme.fade_transition ? `${this.transition}-fade` : this.transition;
    }
  },
  mounted() {
    this.preloadImages(), this.$refs.title && this.$refs.title.children[0] && (this.$refs.title.children[0].id = "galleryheading"), !(this.theme.version === "G2" && this.theme.use_video) && this.restartSlideTimer();
  },
  methods: {
    async preloadImages() {
      await this.$nextTick(), h8(this.slides, this.screenSize);
    },
    togglePlay() {
      this.playSlideshow = !this.playSlideshow, this.restartSlideTimer();
    },
    toggleVideoPlay() {
      if (this.playVideo = !this.playVideo, this.$refs.videoPlayer)
        return this.playVideo ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
    },
    jump(e) {
      this.activeImageIdx = e, this.restartSlideTimer();
    },
    moveForward() {
      this.transition = "right", this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.restartSlideTimer();
    },
    moveBack() {
      this.transition = "left", this.activeImageIdx === 0 ? (this.activeImageIdx = this.slides.length - 1, this.restartSlideTimer()) : (this.activeImageIdx = (this.activeImageIdx - 1) % this.slides.length, this.restartSlideTimer());
    },
    restartSlideTimer() {
      var e;
      this.isEditing || (clearTimeout(this.timer), this.playSlideshow && (this.timer = setTimeout(() => {
        this.moveForward(), this.restartSlideTimer();
      }, ((e = this.theme) == null ? void 0 : e.gallery_speed) || 5e3)));
    },
    handleJump(e) {
      this.isEditing ? (this.$emit("jumpTo", e), this.activeImageIdx = e) : this.jump(e);
    },
    handleScrollLeft() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx - 1 + this.slides.length) % this.slides.length, this.$emit("scrollLeft")) : this.moveBack();
    },
    handleScrollRight() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$emit("scrollRight")) : this.moveForward();
    }
  }
}, m8 = {
  props: {
    image: {
      type: Object,
      required: !0
    },
    altText: {
      type: String,
      required: !0
    },
    idx: {
      type: Number,
      required: !0
    }
  },
  computed: {
    sizes() {
      return this.image.sizes || {};
    }
  }
}, p8 = ["srcset"], f8 = ["srcset"], g8 = ["srcset"], v8 = ["srcset"], b8 = ["srcset"], y8 = ["srcset"], C8 = ["src", "alt"];
function _8(e, t, n, o, i, r) {
  return l(), h("div", { key: n.idx }, [
    d("picture", null, [
      d("source", {
        srcset: r.sizes.px600,
        media: "(max-width: 600px)"
      }, null, 8, p8),
      d("source", {
        srcset: r.sizes.px960,
        media: "(max-width: 960px)"
      }, null, 8, f8),
      d("source", {
        srcset: r.sizes.px1280,
        media: "(max-width: 1280px)"
      }, null, 8, g8),
      d("source", {
        srcset: r.sizes.px1600,
        media: "(max-width: 1600px)"
      }, null, 8, v8),
      d("source", {
        srcset: r.sizes.px1920,
        media: "(max-width: 1920px)"
      }, null, 8, b8),
      d("source", {
        srcset: r.sizes.px2560,
        media: "(max-width: 2560px)"
      }, null, 8, y8),
      d("img", {
        src: n.image.url,
        alt: n.altText
      }, null, 8, C8)
    ])
  ]);
}
const ro = /* @__PURE__ */ I(m8, [["render", _8]]), w8 = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, T8 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, k8 = ["fill"], E8 = ["fill"];
function S8(e, t, n, o, i, r) {
  return l(), h("svg", T8, [
    d("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, k8),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 10H12V22H15V10ZM20 10H17V22H20V10Z",
      fill: n.buttonIconColor.hex
    }, null, 8, E8)
  ]);
}
const M8 = /* @__PURE__ */ I(w8, [["render", S8]]), $8 = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, I8 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A8 = ["fill"], L8 = ["fill"];
function O8(e, t, n, o, i, r) {
  return l(), h("svg", I8, [
    d("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, A8),
    d("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, L8)
  ]);
}
const N8 = /* @__PURE__ */ I($8, [["render", O8]]), H8 = {
  name: "SvgReverse",
  mixins: [sn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, P8 = ["fill"], D8 = ["fill"];
function R8(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "8",
    height: "13",
    viewBox: "0 0 8 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.82843 6.50008L7.62132 1.70718L6.20711 0.292969L0 6.50008L6.20711 12.7072L7.62132 11.293L2.82843 6.50008Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, D8)
  ], 8, P8);
}
const V8 = /* @__PURE__ */ I(H8, [["render", R8]]), B8 = {
  name: "SvgAdvance",
  mixins: [sn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, F8 = ["fill"], j8 = ["fill"];
function U8(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.4997 6.49992L0.706805 11.2928L2.12102 12.707L8.32813 6.49992L2.12102 0.292818L0.706806 1.70703L5.4997 6.49992Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, j8)
  ], 8, F8);
}
const K8 = /* @__PURE__ */ I(B8, [["render", U8]]), G8 = {
  name: "G1",
  components: {
    ResponsiveImage: ro,
    PauseSvg: M8,
    PlaySvg: N8,
    ReverseSvg: V8,
    AdvanceSvg: K8
  },
  mixins: [sn]
}, z8 = { class: "text" }, Z8 = ["innerHTML"], W8 = ["innerHTML"], q8 = { class: "image-wrapper" }, Y8 = {
  key: 0,
  class: "navigation"
}, x8 = { class: "button-action-content" }, X8 = { class: "button-action-content" }, Q8 = { class: "arrow-position" }, J8 = { class: "button-action-content" }, e6 = { class: "position" }, t6 = ["aria-label", "aria-current", "onClick", "onKeydown"], n6 = { class: "button-action-content" }, o6 = { class: "button-action-content" };
function r6(e, t, n, o, i, r) {
  const a = S("responsive-image"), s = S("PlaySvg"), u = S("PauseSvg"), c = S("ReverseSvg"), y = S("AdvanceSvg"), w = Ne("touch");
  return l(), h("div", {
    id: "g1",
    "data-testid": "G1",
    style: H([e.linkStyle, e.accentColor])
  }, [
    d("div", {
      style: H(`background-color: ${e.theme.bg_color.hex}`),
      class: "slide"
    }, [
      d("div", z8, [
        d("div", {
          ref: "title",
          class: p(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          d("div", {
            style: H(`color: ${e.theme.heading_color.hex}`),
            innerHTML: e.slides[0].title
          }, null, 12, Z8)
        ], 2),
        d("div", {
          class: p(["description", e.theme.style])
        }, [
          d("div", {
            style: H(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, W8)
        ], 2)
      ]),
      d("div", q8, [
        me((l(), _(nn, {
          tag: "div",
          class: "img-slider",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: b(() => [
            (l(), _(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            w,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            w,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (l(), h("div", Y8, [
          e.playSlideshow ? (l(), h("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...v) => e.togglePlay && e.togglePlay(...v)),
            onKeydown: t[3] || (t[3] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", X8, [
              $(u, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (l(), h("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...v) => e.togglePlay && e.togglePlay(...v)),
            onKeydown: t[1] || (t[1] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", x8, [
              $(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)),
          d("div", Q8, [
            d("button", {
              class: "left-arrow button-action",
              "aria-label": "Previous Image",
              onClick: t[4] || (t[4] = (...v) => e.moveBack && e.moveBack(...v)),
              onKeydown: t[5] || (t[5] = N(D((...v) => e.moveBack && e.moveBack(...v), ["exact", "prevent"]), ["enter"])),
              "data-testid": "gallery-left-button"
            }, [
              d("div", J8, [
                $(c, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32),
            d("p", {
              style: H(`color: ${e.theme.text_color.hex}`)
            }, "1", 4),
            d("div", e6, [
              (l(!0), h(G, null, q(e.slides, (v, E) => (l(), h("button", {
                key: v.url,
                class: "button-action",
                "aria-label": `Image ${E + 1}`,
                "aria-current": e.activeImageIdx === E ? "active" : null,
                onClick: (F) => e.jump(E),
                onKeydown: N(D((F) => e.jump(E), ["exact", "prevent"]), ["enter"]),
                "data-testid": "gallery-pager-button"
              }, [
                d("div", n6, [
                  d("div", {
                    class: p(["rectangle button-action-content", { active: e.activeImageIdx === E }]),
                    style: H({
                      "background-color": e.theme.pager_color.hex,
                      height: e.activeImageIdx === E ? "4px" : "1px"
                    })
                  }, null, 6)
                ])
              ], 40, t6))), 128))
            ]),
            d("p", {
              style: H(`color: ${e.theme.text_color.hex}`)
            }, f(e.slides.length), 5),
            d("button", {
              "aria-label": "Next Image",
              class: "right-arrow button-action",
              onClick: t[6] || (t[6] = (...v) => e.moveForward && e.moveForward(...v)),
              onKeydown: t[7] || (t[7] = N(D((...v) => e.moveForward && e.moveForward(...v), ["exact", "prevent"]), ["enter"])),
              "data-testid": "gallery-right-button"
            }, [
              d("div", o6, [
                $(y, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32)
          ])
        ])) : g("", !0)
      ])
    ], 4)
  ], 4);
}
const i6 = /* @__PURE__ */ I(G8, [["render", r6], ["__scopeId", "data-v-159d1861"]]), s6 = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, a6 = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l6 = ["fill"], d6 = ["fill"];
function u6(e, t, n, o, i, r) {
  return l(), h("svg", a6, [
    d("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, l6),
    d("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, d6)
  ]);
}
const c6 = /* @__PURE__ */ I(s6, [["render", u6]]), h6 = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, m6 = {
  class: "play_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p6 = ["fill"], f6 = ["fill"];
function g6(e, t, n, o, i, r) {
  return l(), h("svg", m6, [
    d("rect", {
      class: "icon-background",
      width: "32",
      height: "32",
      fill: n.buttonBgColor.hex
    }, null, 8, p6),
    d("path", {
      class: "icon-button",
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, f6)
  ]);
}
const v6 = /* @__PURE__ */ I(h6, [["render", g6]]), b6 = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, y6 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C6 = ["fill"], _6 = ["fill"];
function w6(e, t, n, o, i, r) {
  return l(), h("svg", y6, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-6.10352e-05 0L64 0L64 64L-6.10352e-05 64L-6.10352e-05 0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, C6),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 32L37 19.5L35.5 18L21.9999 32.0428L35.5 46L37 44.5L25 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, _6)
  ]);
}
const T6 = /* @__PURE__ */ I(b6, [["render", w6]]), k6 = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, E6 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S6 = ["fill"], M6 = ["fill"];
function $6(e, t, n, o, i, r) {
  return l(), h("svg", E6, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64 64L-7.62939e-06 64L-2.03434e-06 -1.78036e-06L64 3.8147e-06L64 64Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, S6),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M39 32L27 44.5L28.5 46L42 31.9572L28.5 18L27 19.5L39 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, M6)
  ]);
}
const I6 = /* @__PURE__ */ I(k6, [["render", $6]]), A6 = {
  name: "G2",
  components: {
    PauseSvg: c6,
    PlaySvg: v6,
    ReverseSvg: T6,
    AdvanceSvg: I6,
    ResponsiveImage: ro
  },
  mixins: [sn],
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    colors() {
      var e, t, n, o;
      return {
        "--button-bg-color": ((t = (e = this.theme) == null ? void 0 : e.button_bg_color) == null ? void 0 : t.hex) || "",
        "--button-color": ((o = (n = this.theme) == null ? void 0 : n.button_icon_color) == null ? void 0 : o.hex) || ""
      };
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.use_video && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.url) || "";
    },
    showPauseButton() {
      return this.theme.use_video && this.playVideo || !this.theme.use_video && this.playSlideshow && this.slides.length > 1;
    },
    showPlayButton() {
      return this.theme.use_video && !this.playVideo || !this.theme.use_video && !this.playSlideshow && this.slides.length > 1;
    }
  },
  watch: {
    "theme.use_video": {
      handler() {
        this.theme.use_video ? (this.playSlideshow = !1, this.toggleVideoPlay()) : (this.playVideo = !1, this.togglePlay());
      }
    }
  }
}, L6 = { class: "image-wrapper" }, O6 = {
  key: 1,
  class: "video-wrapper"
}, N6 = ["aria-label", "src"], H6 = { "data-testid": "video-play-pause-wrapper" }, P6 = ["data-testid"], D6 = { class: "button-action-content" }, R6 = ["data-testid"], V6 = { class: "button-action-content" }, B6 = { class: "button-action-content" }, F6 = { class: "button-action-content" }, j6 = {
  key: 4,
  class: "position"
}, U6 = ["aria-current", "aria-label", "onClick", "onKeydown"], K6 = ["innerHTML"], G6 = ["innerHTML"];
function z6(e, t, n, o, i, r) {
  const a = S("responsive-image"), s = S("PauseSvg"), u = S("PlaySvg"), c = S("ReverseSvg"), y = S("AdvanceSvg"), w = Ne("touch");
  return l(), h("div", {
    id: "g2",
    style: H([e.linkStyle, r.colors, e.imageHeight])
  }, [
    d("div", {
      class: "slide",
      style: H(`background: ${e.theme.bg_color.hex}`)
    }, [
      d("div", L6, [
        e.theme.use_video ? g("", !0) : me((l(), _(nn, {
          key: 0,
          class: "img-slider",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: b(() => [
            (l(), _(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            w,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            w,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (l(), h("div", O6, [
          d("video", {
            ref: "videoPlayer",
            "aria-label": r.videoAltText,
            src: r.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, N6)
        ])) : g("", !0),
        d("div", H6, [
          r.showPauseButton ? (l(), h("button", {
            key: 0,
            "aria-label": "Pause Gallery",
            "data-testid": e.theme.use_video ? "video-pause-button" : "pause-button",
            class: "pause button-action",
            onClick: t[0] || (t[0] = (v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[1] || (t[1] = N(D((v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", D6, [
              $(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, P6)) : r.showPlayButton ? (l(), h("button", {
            key: 1,
            "aria-label": "Play Gallery",
            "data-testid": e.theme.use_video ? "video-play-button" : "play-button",
            class: "play button-action",
            onClick: t[2] || (t[2] = (v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[3] || (t[3] = N(D((v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", V6, [
              $(u, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, R6)) : g("", !0)
        ]),
        r.arrowsVisible ? (l(), h("button", {
          key: 2,
          class: "left-arrow button-action",
          onClick: t[4] || (t[4] = (...v) => e.moveBack && e.moveBack(...v)),
          onKeydown: t[5] || (t[5] = N(D((...v) => e.moveBack && e.moveBack(...v), ["exact", "prevent"]), ["enter"])),
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image"
        }, [
          d("div", B6, [
            $(c, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : g("", !0),
        r.arrowsVisible ? (l(), h("button", {
          key: 3,
          class: "right-arrow button-action",
          onClick: t[6] || (t[6] = (...v) => e.moveForward && e.moveForward(...v)),
          onKeydown: t[7] || (t[7] = N(D((...v) => e.moveForward && e.moveForward(...v), ["exact", "prevent"]), ["enter"])),
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image"
        }, [
          d("div", F6, [
            $(y, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : g("", !0),
        e.slides.length > 1 && !e.theme.use_video ? (l(), h("div", j6, [
          (l(!0), h(G, null, q(e.slides, (v, E) => (l(), h("div", {
            key: v.url
          }, [
            d("button", {
              class: p(["square button-action", { active: e.activeImageIdx === E }]),
              "aria-current": e.activeImageIdx === E ? "active" : null,
              "aria-label": `Image ${E + 1}`,
              style: H({
                "background-color": e.activeImageIdx === E ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              onClick: (F) => e.jump(E),
              onKeydown: N(D((F) => e.jump(E), ["exact", "prevent"]), ["enter"]),
              "data-testid": "gallery-pager-button"
            }, t[8] || (t[8] = [
              d("div", { class: "button-action-content" }, null, -1)
            ]), 46, U6)
          ]))), 128))
        ])) : g("", !0)
      ]),
      r.titleText || r.descriptionText ? (l(), h("div", {
        key: 0,
        class: "text",
        style: H(`background: ${e.theme.overlay_color.hex}CC`)
      }, [
        r.titleText ? (l(), h("div", {
          key: 0,
          class: p(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          d("div", {
            ref: "title",
            style: H(`color: ${e.theme.heading_color.hex}`),
            innerHTML: r.titleText
          }, null, 12, K6)
        ], 2)) : g("", !0),
        r.descriptionText ? (l(), h("div", {
          key: 1,
          class: p(["description", e.theme.style])
        }, [
          d("div", {
            style: H(`color: ${e.theme.text_color.hex}`),
            innerHTML: r.descriptionText
          }, null, 12, G6)
        ], 2)) : g("", !0)
      ], 4)) : g("", !0)
    ], 4)
  ], 4);
}
const Z6 = /* @__PURE__ */ I(A6, [["render", z6], ["__scopeId", "data-v-b55edbbb"]]), W6 = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, q6 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y6 = ["fill", "stroke"], x6 = ["fill"];
function X6(e, t, n, o, i, r) {
  return l(), h("svg", q6, [
    d("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, Y6),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex
    }, null, 8, x6)
  ]);
}
const Q6 = /* @__PURE__ */ I(W6, [["render", X6]]), J6 = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, e3 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t3 = ["fill", "stroke"], n3 = ["fill"];
function o3(e, t, n, o, i, r) {
  return l(), h("svg", e3, [
    d("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, t3),
    d("path", {
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, n3)
  ]);
}
const r3 = /* @__PURE__ */ I(J6, [["render", o3]]), i3 = {
  name: "SvgReverse",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, s3 = ["stroke"], a3 = ["fill"];
function l3(e, t, n, o, i, r) {
  return l(), h("svg", {
    style: H({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    d("path", {
      d: "M45.5 45.4999L0.5 45.4999L0.500004 0.500007L45.5 0.500011L45.5 45.4999Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, s3),
    d("path", {
      d: "M19.5 33.9999L8 22.9999L19.5 10.9999L21 12.4999L12 21.9999L38 21.9999L38 23.9999L12 23.9999L21 32.4999L19.5 33.9999Z",
      fill: n.buttonIconColor.hex
    }, null, 8, a3)
  ], 4);
}
const d3 = /* @__PURE__ */ I(i3, [["render", l3]]), u3 = {
  name: "SvgAdvance",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, c3 = ["stroke"], h3 = ["fill"];
function m3(e, t, n, o, i, r) {
  return l(), h("svg", {
    style: H({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    d("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, c3),
    d("path", {
      d: "M26.5 12L38 23L26.5 35L25 33.5L34 24H8V22H34L25 13.5L26.5 12Z",
      fill: n.buttonIconColor.hex
    }, null, 8, h3)
  ], 4);
}
const p3 = /* @__PURE__ */ I(u3, [["render", m3]]), f3 = {
  name: "G3",
  components: {
    ResponsiveImage: ro,
    PauseSvg: Q6,
    ReverseSvg: d3,
    PlaySvg: r3,
    AdvanceSvg: p3
  },
  mixins: [sn],
  computed: {
    cssVars() {
      return {
        "--gradient-color": `linear-gradient(180deg, rgba(1, 73, 145, 0) 0%, ${this.theme.overlay_color.hex} 80.73%)`
      };
    }
  }
}, g3 = { class: "image-wrapper" }, v3 = { class: "button-action-content" }, b3 = { class: "button-action-content" }, y3 = { class: "position-tablet" }, C3 = ["aria-current", "aria-label", "onKeydown", "onClick"], _3 = { class: "button-action-content" }, w3 = { class: "button-action-content" }, T3 = ["innerHTML"], k3 = {
  key: 0,
  class: "navigation"
}, E3 = { class: "button-action-content" }, S3 = { class: "button-action-content" }, M3 = { class: "info" }, $3 = {
  key: 0,
  class: "position"
}, I3 = ["aria-label", "aria-current", "onClick", "onKeydown"], A3 = ["innerHTML"], L3 = ["innerHTML"], O3 = {
  key: 1,
  class: "arrows"
}, N3 = { class: "button-action-content" }, H3 = { class: "button-action-content" };
function P3(e, t, n, o, i, r) {
  const a = S("responsive-image"), s = S("PlaySvg"), u = S("PauseSvg"), c = S("ReverseSvg"), y = S("AdvanceSvg"), w = Ne("touch");
  return l(), h("div", {
    id: "g3",
    style: H([e.linkStyle, e.imageHeight, r.cssVars])
  }, [
    d("div", {
      class: "slide",
      style: H({ "background-color": e.theme.overlay_color.hex })
    }, [
      d("div", g3, [
        me((l(), _(nn, {
          tag: "div",
          class: "image",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: b(() => [
            (l(), _(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            w,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            w,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (l(), h("div", {
          key: 0,
          class: p(["navigation-small", { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          e.playSlideshow ? (l(), h("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...v) => e.togglePlay && e.togglePlay(...v)),
            onKeydown: t[3] || (t[3] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", b3, [
              $(u, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (l(), h("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...v) => e.togglePlay && e.togglePlay(...v)),
            onKeydown: t[1] || (t[1] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", v3, [
              $(s, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)),
          d("div", y3, [
            (l(!0), h(G, null, q(e.slides, (v, E) => (l(), h("div", {
              key: v.url
            }, [
              d("button", {
                class: "square button-action",
                style: H({
                  "background-color": e.activeImageIdx === E ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                }),
                "aria-current": e.activeImageIdx === E ? "active" : "inactive",
                "aria-label": `Image ${E + 1}`,
                "data-testid": "gallery-pager-button",
                onKeydown: N(D((F) => e.jump(E), ["exact", "prevent"]), ["enter"]),
                onClick: (F) => e.jump(E)
              }, null, 44, C3)
            ]))), 128))
          ]),
          d("button", {
            class: "left-arrow button-action",
            "data-testid": "gallery-left-button",
            "aria-label": "Previous Image",
            onClick: t[4] || (t[4] = (...v) => e.moveBack && e.moveBack(...v)),
            onKeydown: t[5] || (t[5] = N(D((...v) => e.moveBack && e.moveBack(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", _3, [
              $(c, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32),
          d("button", {
            class: "right-arrow button-action",
            "data-testid": "gallery-right-button",
            "aria-label": "Next Image",
            onClick: t[6] || (t[6] = (...v) => e.moveForward && e.moveForward(...v)),
            onKeydown: t[7] || (t[7] = N(D((...v) => e.moveForward && e.moveForward(...v), ["exact", "prevent"]), ["enter"]))
          }, [
            d("div", w3, [
              $(y, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)
        ], 2)) : g("", !0),
        d("div", {
          class: p(["title-on-image", [
            e.theme.style,
            { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }
          ]])
        }, [
          d("div", {
            ref: "title",
            style: H(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[e.activeImageIdx].title
          }, null, 12, T3)
        ], 2)
      ]),
      e.slides.length > 1 ? (l(), h("div", k3, [
        e.playSlideshow ? (l(), h("button", {
          key: 1,
          "aria-label": "Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button-action",
          onClick: t[10] || (t[10] = (...v) => e.togglePlay && e.togglePlay(...v)),
          onKeydown: t[11] || (t[11] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
        }, [
          d("div", S3, [
            $(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : (l(), h("button", {
          key: 0,
          "aria-label": "Play Gallery",
          "data-testid": "play-button",
          class: "play button-action",
          onClick: t[8] || (t[8] = (...v) => e.togglePlay && e.togglePlay(...v)),
          onKeydown: t[9] || (t[9] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
        }, [
          d("div", E3, [
            $(s, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32))
      ])) : g("", !0),
      d("div", M3, [
        e.slides.length > 1 ? (l(), h("div", $3, [
          (l(!0), h(G, null, q(e.slides, (v, E) => (l(), h("div", {
            key: v.url
          }, [
            d("button", {
              class: "square",
              style: H({
                "background-color": e.activeImageIdx === E ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "aria-label": `Image ${E + 1}`,
              "aria-current": e.activeImageIdx === E ? "active" : null,
              onClick: (F) => e.jump(E),
              onKeydown: N(D((F) => e.jump(E), ["exact", "prevent"]), ["enter"])
            }, null, 44, I3)
          ]))), 128))
        ])) : g("", !0),
        d("div", {
          class: p(["gradient", { "show-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          d("div", {
            class: p(["title", e.theme.style])
          }, [
            d("div", {
              style: H(`color: ${e.theme.heading_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 12, A3)
          ], 2),
          d("div", {
            class: p(["description", e.theme.style])
          }, [
            d("div", {
              style: H(`color: ${e.theme.text_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].content
            }, null, 12, L3)
          ], 2)
        ], 2)
      ]),
      e.slides.length > 1 ? (l(), h("div", O3, [
        d("button", {
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[12] || (t[12] = (...v) => e.moveBack && e.moveBack(...v)),
          onKeydown: t[13] || (t[13] = N(D((...v) => e.moveBack && e.moveBack(...v), ["exact", "prevent"]), ["enter"]))
        }, [
          d("div", N3, [
            $(c, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32),
        d("button", {
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[14] || (t[14] = (...v) => e.moveForward && e.moveForward(...v)),
          onKeydown: t[15] || (t[15] = N(D((...v) => e.moveForward && e.moveForward(...v), ["exact", "prevent"]), ["enter"]))
        }, [
          d("div", H3, [
            $(y, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)
      ])) : g("", !0)
    ], 4)
  ], 4);
}
const D3 = /* @__PURE__ */ I(f3, [["render", P3], ["__scopeId", "data-v-695d2bed"]]), R3 = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, V3 = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B3 = ["fill"], F3 = ["fill"];
function j3(e, t, n, o, i, r) {
  return l(), h("svg", V3, [
    d("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, B3),
    d("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, F3)
  ]);
}
const U3 = /* @__PURE__ */ I(R3, [["render", j3]]), K3 = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, G3 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z3 = ["fill"], Z3 = ["fill"];
function W3(e, t, n, o, i, r) {
  return l(), h("svg", G3, [
    d("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, z3),
    d("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Z3)
  ]);
}
const q3 = /* @__PURE__ */ I(K3, [["render", W3]]), Y3 = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, x3 = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X3 = ["fill"], Q3 = ["fill"];
function J3(e, t, n, o, i, r) {
  return l(), h("svg", x3, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, X3),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Q3)
  ]);
}
const e7 = /* @__PURE__ */ I(Y3, [["render", J3]]), t7 = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, n7 = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o7 = ["fill"], r7 = ["fill"];
function i7(e, t, n, o, i, r) {
  return l(), h("svg", n7, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 0H63.9999V62.9999H0V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, o7),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, r7)
  ]);
}
const s7 = /* @__PURE__ */ I(t7, [["render", i7]]), a7 = {
  name: "G4",
  components: {
    ResponsiveImage: ro,
    PauseSvg: U3,
    PlaySvg: q3,
    ReverseSvg: e7,
    AdvanceSvg: s7
  },
  mixins: [sn]
}, l7 = { class: "image-and-nav" }, d7 = { class: "image-wrapper" }, u7 = {
  key: 0,
  class: "position-and-play"
}, c7 = { class: "button-action-content" }, h7 = { class: "button-action-content" }, m7 = { class: "position" }, p7 = ["aria-current", "aria-label", "onClick", "onKeydown"], f7 = {
  key: 0,
  class: "navigation"
}, g7 = { class: "arrows" }, v7 = { class: "button-action-content" }, b7 = { class: "button-action-content" }, y7 = { class: "text" }, C7 = ["innerHTML"], _7 = ["innerHTML"];
function w7(e, t, n, o, i, r) {
  const a = S("PlaySvg"), s = S("PauseSvg"), u = S("responsive-image"), c = S("ReverseSvg"), y = S("AdvanceSvg"), w = Ne("touch");
  return l(), h("div", {
    id: "g4",
    style: H([e.linkStyle, e.imageHeight])
  }, [
    d("div", {
      class: "slide",
      style: H(`background: ${e.theme.bg_color.hex}`)
    }, [
      d("div", l7, [
        d("div", d7, [
          e.slides.length > 1 ? (l(), h("div", u7, [
            e.playSlideshow ? (l(), h("button", {
              key: 1,
              "aria-label": "Pause Gallery",
              "data-testid": "pause-button",
              class: "pause button-action",
              onClick: t[2] || (t[2] = (...v) => e.togglePlay && e.togglePlay(...v)),
              onKeydown: t[3] || (t[3] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
            }, [
              d("div", h7, [
                $(s, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)) : (l(), h("button", {
              key: 0,
              "aria-label": "Play Gallery",
              "data-testid": "play-button",
              class: "play button-action",
              onClick: t[0] || (t[0] = (...v) => e.togglePlay && e.togglePlay(...v)),
              onKeydown: t[1] || (t[1] = N(D((...v) => e.togglePlay && e.togglePlay(...v), ["exact", "prevent"]), ["enter"]))
            }, [
              d("div", c7, [
                $(a, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)),
            d("div", m7, [
              (l(!0), h(G, null, q(e.slides, (v, E) => (l(), h("div", {
                key: v.url
              }, [
                d("button", {
                  class: p(["square", { active: e.activeImageIdx === E }]),
                  style: H({
                    "background-color": e.activeImageIdx === E ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                  }),
                  "aria-current": e.activeImageIdx === E ? "active" : null,
                  "aria-label": `Image ${E + 1}`,
                  onClick: (F) => e.jump(E),
                  "data-testid": "gallery-pager-button",
                  onKeydown: N(D((F) => e.jump(E), ["exact", "prevent"]), ["enter"])
                }, null, 46, p7)
              ]))), 128))
            ])
          ])) : g("", !0),
          me((l(), _(nn, {
            tag: "div",
            class: "img-slider",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: b(() => [
              (l(), _(u, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              w,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              w,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ]),
        e.slides.length > 1 ? (l(), h("div", f7, [
          d("div", g7, [
            d("button", {
              class: "left-arrow button-action",
              onClick: t[4] || (t[4] = (...v) => e.moveBack && e.moveBack(...v)),
              onKeydown: t[5] || (t[5] = N(D((...v) => e.moveBack && e.moveBack(...v), ["exact", "prevent"]), ["enter"])),
              "data-testid": "gallery-left-button",
              "aria-label": "Previous Image"
            }, [
              d("div", v7, [
                $(c, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32),
            d("button", {
              class: "right-arrow button-action",
              onClick: t[6] || (t[6] = (...v) => e.moveForward && e.moveForward(...v)),
              onKeydown: t[7] || (t[7] = N(D((...v) => e.moveForward && e.moveForward(...v), ["exact", "prevent"]), ["enter"])),
              "data-testid": "gallery-right-button",
              "aria-label": "Next Image"
            }, [
              d("div", b7, [
                $(y, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)
          ])
        ])) : g("", !0)
      ]),
      d("div", y7, [
        d("div", {
          class: p(["title", e.theme.style])
        }, [
          d("div", {
            ref: "title",
            style: H(`color: ${e.theme.heading_color.hex}`),
            innerHTML: e.slides[0].title,
            "data-testid": "gallery-title"
          }, null, 12, C7)
        ], 2),
        d("div", {
          class: p(["description", e.theme.style])
        }, [
          d("div", {
            style: H(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, _7)
        ], 2)
      ])
    ], 4)
  ], 4);
}
const T7 = /* @__PURE__ */ I(a7, [["render", w7], ["__scopeId", "data-v-0bf89312"]]), k7 = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, E7 = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S7 = ["fill"], M7 = ["fill"];
function $7(e, t, n, o, i, r) {
  return l(), h("svg", E7, [
    d("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0700684 0.910156L66.2576 0.910156L66.2576 65.0005L0.0700684 65.0005L0.0700684 0.910156Z"
    }, null, 8, S7),
    d("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.9246 32.9568L38.3347 20.4391L36.7834 18.937L22.822 32.9997L36.7834 46.9766L38.3347 45.4744L25.9246 32.9568Z"
    }, null, 8, M7)
  ]);
}
const I7 = /* @__PURE__ */ I(k7, [["render", $7]]), A7 = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, L7 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O7 = ["fill"], N7 = ["stroke"];
function H7(e, t, n, o, i, r) {
  return l(), h("svg", L7, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, O7),
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, N7)
  ]);
}
const P7 = /* @__PURE__ */ I(A7, [["render", H7]]), D7 = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, R7 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V7 = ["fill"], B7 = ["stroke"];
function F7(e, t, n, o, i, r) {
  return l(), h("svg", R7, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, V7),
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, B7)
  ]);
}
const j7 = /* @__PURE__ */ I(D7, [["render", F7]]), U7 = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, K7 = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G7 = ["fill"], z7 = ["fill"];
function Z7(e, t, n, o, i, r) {
  return l(), h("svg", K7, [
    d("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M66.6326 65L0.445007 65L0.445013 0.909601L66.6326 0.909607L66.6326 65Z"
    }, null, 8, G7),
    d("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40.7781 32.9534L28.3679 45.471L29.9192 46.9731L43.8806 32.9105L29.9192 18.9336L28.3679 20.4357L40.7781 32.9534Z"
    }, null, 8, z7)
  ]);
}
const W7 = /* @__PURE__ */ I(U7, [["render", Z7]]), q7 = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, Y7 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x7 = ["stroke"], X7 = ["fill"], Q7 = ["fill"];
function J7(e, t, n, o, i, r) {
  return l(), h("svg", Y7, [
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, x7),
    n.paused ? (l(), h("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, X7)) : (l(), h("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, Q7))
  ]);
}
const ev = /* @__PURE__ */ I(q7, [["render", J7]]), tv = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, nv = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ov = ["fill"], rv = ["fill"], iv = ["fill"];
function sv(e, t, n, o, i, r) {
  return l(), h("svg", nv, [
    d("rect", {
      fill: n.buttonBgColor.hex,
      x: "0.257568",
      y: "0.910156",
      width: "66.1876",
      height: "64.0904"
    }, null, 8, ov),
    n.paused ? (l(), h("path", {
      key: 0,
      fill: n.buttonIconColor.hex,
      d: "M29.2146 44.9734L41.6248 32.9564L29.2146 20.9395V44.9734Z"
    }, null, 8, rv)) : (l(), h("path", {
      key: 1,
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 20H25V44H31V20ZM41 20H35V44H41V20Z"
    }, null, 8, iv))
  ]);
}
const av = /* @__PURE__ */ I(tv, [["render", sv]]), lv = {
  name: "G5Buttons",
  props: {
    theme: {
      type: Object,
      required: !0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    onlyPlayButton: Boolean,
    smallPager: Boolean,
    isEditing: Boolean
  },
  components: { ReverseASvg: P7, ReverseBSvg: I7, AdvanceASvg: j7, AdvanceBSvg: W7, PlayPauseASvg: ev, PlayPauseBSvg: av },
  computed: {
    cssVars() {
      var e, t, n, o;
      return {
        "--gallery-button-color": ((e = this.theme.button_icon_color) == null ? void 0 : e.hex) || "#FFFFFF",
        "--gallery-button-bg-color": ((t = this.theme.button_bg_color) == null ? void 0 : t.hex) || "#333333",
        "--gallery-pager-color": ((n = this.theme.pager_color) == null ? void 0 : n.hex) || "#333333",
        "--gallery-pager-active-color": ((o = this.theme.pager_active_color) == null ? void 0 : o.hex) || "#0000FF"
      };
    }
  }
}, dv = { class: "gallery-buttons" }, uv = ["aria-label", "data-testid", "disabled"], cv = {
  key: 0,
  class: "gallery-pager"
}, hv = ["aria-label", "aria-current", "onClick"], mv = {
  key: 0,
  class: "pager-bottom"
}, pv = {
  key: 1,
  class: "gallery-small-pager"
}, fv = ["aria-label", "aria-current", "onClick"];
function gv(e, t, n, o, i, r) {
  const a = S("PlayPauseASvg"), s = S("PlayPauseBSvg"), u = S("ReverseASvg"), c = S("ReverseBSvg"), y = S("AdvanceASvg"), w = S("AdvanceBSvg");
  return l(), h("div", {
    style: H(r.cssVars),
    class: p(["gallery-button-wrapper", `type-${n.theme.type}`])
  }, [
    d("div", dv, [
      d("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: p(["pause-play-button", { hasWidget: n.theme.cta_widget }]),
        onClick: t[0] || (t[0] = (v) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = N(D((v) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"])),
        disabled: n.isEditing
      }, [
        n.theme.type === "A" ? (l(), _(a, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])) : (l(), _(s, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"]))
      ], 42, uv),
      n.onlyPlayButton ? g("", !0) : (l(), h("button", {
        key: 0,
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (v) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = N(D((v) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (l(), _(u, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (l(), _(c, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32)),
      n.onlyPlayButton ? g("", !0) : (l(), h("button", {
        key: 1,
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (v) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = N(D((v) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (l(), _(y, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (l(), _(w, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32))
    ]),
    n.hidePager ? g("", !0) : (l(), h(G, { key: 0 }, [
      n.pagerNumber && !n.smallPager ? (l(), h("div", cv, [
        (l(!0), h(G, null, q(n.pagerNumber, (v, E) => (l(), h("button", {
          key: v,
          class: p({ active: n.activeImageIdx === E }),
          "aria-label": `Image ${E + 1}`,
          "aria-current": n.activeImageIdx === E ? "active" : null,
          "data-testid": "gallery-pager-button",
          onClick: (F) => e.$emit("jumpTo", E)
        }, [
          d("span", null, f(v), 1),
          n.theme.type === "A" ? (l(), h("div", mv)) : g("", !0)
        ], 10, hv))), 128))
      ])) : (l(), h("div", pv, [
        (l(!0), h(G, null, q(n.pagerNumber, (v, E) => (l(), h("button", {
          key: v,
          "aria-label": `Image ${E + 1}`,
          "aria-current": n.activeImageIdx === E,
          class: p([{ active: n.activeImageIdx === E }, "circle"]),
          "data-testid": "gallery-pager-button",
          onClick: (F) => e.$emit("jumpTo", E)
        }, null, 10, fv))), 128))
      ]))
    ], 64))
  ], 6);
}
const vv = /* @__PURE__ */ I(lv, [["render", gv], ["__scopeId", "data-v-be9f52d6"]]), bv = {
  name: "G5",
  components: {
    ResponsiveImage: ro,
    G5Buttons: vv
  },
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  mixins: [sn],
  computed: {
    cssVars() {
      return {
        "--gallery-heading-color": T(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": T(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `linear-gradient(0deg, ${this.theme.overlay_color.hex} 0%, rgba(19, 19, 19, 0) 71.87%)`
      };
    }
  }
}, yv = { class: "slide-wrapper" }, Cv = { class: "bottom-content gradient" }, _v = ["innerHTML"], wv = {
  key: 0,
  class: "navigation"
};
function Tv(e, t, n, o, i, r) {
  const a = S("responsive-image"), s = S("G5Buttons"), u = Ne("touch");
  return l(), h("div", {
    id: "g5",
    "data-testid": "G5",
    class: p(`type-${e.theme.type}`),
    style: H([r.cssVars, e.imageHeight])
  }, [
    d("div", {
      class: "slide",
      style: H({ "background-color": e.theme.overlay_color.hex })
    }, [
      d("div", yv, [
        C(e.$slots, "controls"),
        C(e.$slots, "image", {}, () => [
          me((l(), _(nn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: b(() => [
              (l(), _(a, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              u,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              u,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ]),
      d("div", Cv, [
        d("div", {
          class: p(["left-text", e.theme.style])
        }, [
          C(e.$slots, "title", {}, () => [
            d("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, _v)
          ])
        ], 2),
        e.slides.length > 1 ? (l(), h("div", wv, [
          $(s, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            "hide-pager": e.screenSize < 600,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "play-slideshow", "is-editing", "hide-pager", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : g("", !0)
      ])
    ], 4)
  ], 6);
}
const kv = /* @__PURE__ */ I(bv, [["render", Tv], ["__scopeId", "data-v-71bcffb4"]]), Ev = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Sv = ["fill"], Mv = ["stroke"];
function $v(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: H({ backgroundColor: n.buttonBgColor.hex })
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Sv),
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Mv)
  ], 4);
}
const Iv = /* @__PURE__ */ I(Ev, [["render", $v]]), Av = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Lv = ["fill"], Ov = ["stroke"];
function Nv(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: H({ backgroundColor: n.buttonBgColor.hex })
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Lv),
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Ov)
  ], 4);
}
const Hv = /* @__PURE__ */ I(Av, [["render", Nv]]), Pv = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, Dv = ["stroke"], Rv = ["fill"], Vv = ["fill"];
function Bv(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: H({ backgroundColor: n.buttonBgColor.hex })
  }, [
    d("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Dv),
    n.paused ? (l(), h("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Rv)) : (l(), h("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, Vv))
  ], 4);
}
const Fv = /* @__PURE__ */ I(Pv, [["render", Bv]]), jv = {
  name: "G6Buttons",
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    isEditing: Boolean
  },
  components: { ReverseSvg: Iv, AdvanceSvg: Hv, PlayPauseSvg: Fv },
  computed: {
    cssVars() {
      return {
        "--gallery-button-color": T(this.theme, "button_icon_color.hex", "#FFFFFF"),
        "--gallery-button-bg-color": T(this.theme, "button_bg_color.hex", "#333333"),
        "--gallery-pager-color": T(this.theme, "pager_color.hex", "#333333"),
        "--gallery-pager-active-color": T(this.theme, "pager_active_color.hex", "#0000FF")
      };
    }
  }
}, Uv = ["aria-label", "data-testid", "disabled"], Kv = {
  key: 0,
  class: "gallery-pager"
}, Gv = ["aria-label", "aria-current", "onClick"];
function zv(e, t, n, o, i, r) {
  const a = S("PlayPauseSvg"), s = S("ReverseSvg"), u = S("AdvanceSvg");
  return l(), h("div", {
    style: H(r.cssVars),
    class: p(["gallery-button-wrapper"])
  }, [
    d("div", {
      class: p(["gallery-buttons", { hasWidget: n.theme.cta_widget }])
    }, [
      d("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: "pause-play-button",
        onClick: t[0] || (t[0] = (c) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = N(D((c) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"])),
        disabled: n.isEditing
      }, [
        $(a, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])
      ], 40, Uv),
      d("button", {
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (c) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = N(D((c) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        $(s, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32),
      d("button", {
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (c) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = N(D((c) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        $(u, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32)
    ], 2),
    n.hidePager ? g("", !0) : (l(), h("div", Kv, [
      (l(!0), h(G, null, q(n.pagerNumber, (c, y) => (l(), h("button", {
        key: c,
        class: p({ active: n.activeImageIdx === y }),
        "aria-label": `Image ${y + 1}`,
        "aria-current": n.activeImageIdx === y ? "active" : null,
        "data-testid": "gallery-pager-button",
        onClick: (w) => e.$emit("jumpTo", y)
      }, [
        d("span", null, f(c), 1),
        t[6] || (t[6] = d("div", { class: "pager-bottom" }, null, -1))
      ], 10, Gv))), 128))
    ]))
  ], 4);
}
const Zv = /* @__PURE__ */ I(jv, [["render", zv], ["__scopeId", "data-v-bb0ee794"]]), Wv = {
  name: "G6",
  components: {
    ResponsiveImage: ro,
    G6Buttons: Zv
  },
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  mixins: [sn],
  computed: {
    displayWidget() {
      return this.theme.cta_widget && (!Ut(this.widget) || this.isEditing);
    },
    cssVars() {
      var e, t;
      return {
        "--gallery-heading-color": T(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": T(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `radial-gradient( ${(t = (e = this.theme) == null ? void 0 : e.overlay_color) == null ? void 0 : t.hex}, rgba(255, 255, 255, 0) 75%)`,
        "--widget-line-color": T(this.theme, "widget_line_color.hex", "#B9770E"),
        "--widget-background-color": T(this.theme, "widget_background_color.hex", "#fff"),
        "--widget-text-color": T(this.theme, "widget_text_color.hex", "#000000"),
        "--widget-button-icon-color": T(this.theme, "widget_button_icon_color.hex", "#fff"),
        "--widget-button-background-color": T(this.theme, "widget_button_background_color.hex", "#B9770E")
      };
    },
    widgetLinkName() {
      var e, t;
      return (t = (e = this.widget) == null ? void 0 : e.link) != null && t.name ? this.widget.link.name : this.widgetLinkHref;
    },
    widgetBody() {
      var e;
      return ((e = this.widget) == null ? void 0 : e.body) || "";
    },
    widgetLinkHref() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.href) || "";
    },
    widgetLinkTarget() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.target) || "_blank";
    }
  }
}, qv = { class: "slide" }, Yv = ["innerHTML"], xv = {
  key: 0,
  class: "main-content-button"
}, Xv = { class: "slide-wrapper" }, Qv = {
  key: 0,
  class: "widget",
  "data-testid": "cta-widget"
}, Jv = ["innerHTML"];
function eb(e, t, n, o, i, r) {
  const a = S("G6Buttons"), s = S("responsive-image"), u = Ne("touch");
  return l(), h("div", {
    class: "g6",
    "data-testid": "G6",
    style: H([r.cssVars, e.imageHeight, e.bgColor])
  }, [
    d("div", qv, [
      d("div", {
        class: p(["main-content", { "has-widget": e.theme.cta_widget }])
      }, [
        d("div", {
          class: p([
            e.slides[e.activeImageIdx].title ? "main-content-title" : "main-content-title-empty",
            "left-text",
            e.theme.style
          ])
        }, [
          C(e.$slots, "title", {}, () => [
            d("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, Yv)
          ])
        ], 2),
        e.slides.length > 1 ? (l(), h("div", xv, [
          $(a, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "hide-pager": e.screenSize < 600,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "hide-pager", "play-slideshow", "is-editing", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : g("", !0)
      ], 2),
      d("div", Xv, [
        r.displayWidget ? (l(), h("div", Qv, [
          C(e.$slots, "widget", {}, () => [
            d("div", {
              class: p(["widget-body", e.theme.style]),
              innerHTML: r.widgetBody,
              "data-testid": "cta-widget-body"
            }, null, 10, Jv)
          ]),
          (l(), _(R(n.isEditing ? "button" : "a"), {
            class: "widget-button",
            "aria-label": r.widgetLinkName,
            href: r.widgetLinkHref,
            target: r.widgetLinkTarget,
            onClick: t[0] || (t[0] = (c) => e.$emit("openLinkModal")),
            "data-testid": "cta-widget-button"
          }, {
            default: b(() => t[1] || (t[1] = [
              d("svg", {
                width: "15",
                height: "12",
                viewBox: "0 0 15 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                d("path", {
                  d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
                  stroke: "var(--widget-button-icon-color)",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            _: 1
          }, 8, ["aria-label", "href", "target"]))
        ])) : g("", !0),
        t[2] || (t[2] = d("div", { class: "gallery-decoration" }, [
          d("div", { class: "gallery-decoration-left" }),
          d("div", { class: "gallery-decoration-right" })
        ], -1)),
        C(e.$slots, "controls"),
        C(e.$slots, "image", {}, () => [
          me((l(), _(nn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: b(() => [
              (l(), _(s, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              u,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              u,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ])
    ])
  ], 4);
}
const tb = /* @__PURE__ */ I(Wv, [["render", eb], ["__scopeId", "data-v-fc3681f2"]]), nb = {
  name: "CmsGallery",
  components: {
    G1: i6,
    G2: Z6,
    G3: D3,
    G4: T7,
    G5: kv,
    G6: tb
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    skipButtonText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.skipButtonText) || "Skip Gallery";
    },
    galleryEndText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.galleryEndText) || "End of Gallery";
    }
  },
  methods: {
    jumpTo(e) {
      this.$emit("jumpTo", e);
    },
    focusEnd() {
      this.$refs.galleryEnd.focus();
    }
  }
}, ob = { id: "cms-gallery" };
function rb(e, t, n, o, i, r) {
  return l(), h("div", ob, [
    d("button", {
      class: "skip-button",
      type: "button",
      tabindex: "0",
      onKeydown: t[0] || (t[0] = N(D((...a) => r.focusEnd && r.focusEnd(...a), ["exact", "prevent"]), ["enter"]))
    }, f(r.skipButtonText), 33),
    (l(), _(R(n.theme.version), {
      theme: n.theme,
      gallery: n.gallery,
      "is-preview": n.isPreview,
      "is-iframe": n.isIFrame,
      "is-editing": n.isEditing,
      onScrollLeft: t[1] || (t[1] = (a) => e.$emit("scrollLeft")),
      onScrollRight: t[2] || (t[2] = (a) => e.$emit("scrollRight")),
      onJumpTo: r.jumpTo,
      onOpenLinkModal: t[3] || (t[3] = (a) => e.$emit("openLinkModal"))
    }, {
      widget: b(({ widget: a }) => [
        C(e.$slots, "widget", { widget: a }, void 0, !0)
      ]),
      controls: b(({ controls: a }) => [
        C(e.$slots, "controls", { controls: a }, void 0, !0)
      ]),
      image: b(({ image: a }) => [
        C(e.$slots, "image", { image: a }, void 0, !0)
      ]),
      title: b(({ title: a }) => [
        C(e.$slots, "title", { title: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "gallery", "is-preview", "is-iframe", "is-editing", "onJumpTo"])),
    d("div", {
      class: "gallery-end",
      tabindex: "-1",
      ref: "galleryEnd"
    }, f(r.galleryEndText), 513)
  ]);
}
const ib = /* @__PURE__ */ I(nb, [["render", rb], ["__scopeId", "data-v-da0f5d18"]]), Xu = function() {
  return document.ontouchstart !== null ? "click" : "touchstart";
}, Ur = "__vue_click_away__", Qu = function(e, t, n) {
  Ju(e);
  let o = n.context, i = t.value, r = !1;
  setTimeout(function() {
    r = !0;
  }, 0), e[Ur] = function(a) {
    if ((!e || !e.contains(a.target)) && i && r && typeof i == "function")
      return i.call(o, a);
  }, document.addEventListener(Xu(), e[Ur], !1);
}, Ju = function(e) {
  document.removeEventListener(Xu(), e[Ur], !1), delete e[Ur];
}, sb = function(e, t, n) {
  t.value !== t.oldValue && Qu(e, t, n);
}, ab = {
  mounted: Qu,
  updated: sb,
  unmounted: Ju
}, Ze = {
  directives: {
    ClickAway: ab
  }
}, lb = {
  name: "HamburgerIcon",
  props: {
    themeStyle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, db = { "clip-path": "url(#clip0)" }, ub = ["fill", "rx"], cb = ["fill"];
function hb(e, t, n, o, i, r) {
  return l(), h("svg", {
    class: p(n.themeStyle),
    fill: "#fff",
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    d("g", db, [
      d("rect", {
        fill: n.fillColor,
        rx: n.rx,
        width: "23",
        height: "23"
      }, null, 8, ub),
      d("path", {
        fill: n.fillPathColor,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.00195 7H17V8H6.00195V7ZM6.00195 11H17V12H6.00195V11ZM17 15H6.00195V16H17V15Z"
      }, null, 8, cb)
    ]),
    t[0] || (t[0] = d("defs", null, [
      d("clipPath", { id: "clip0" }, [
        d("rect", {
          width: "23",
          height: "23",
          fill: "#fff"
        })
      ])
    ], -1))
  ], 2);
}
const sa = /* @__PURE__ */ I(lb, [["render", hb]]), mb = {
  name: "PlusIcon",
  props: {
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, pb = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, fb = ["fill", "rx"], gb = ["fill"], vb = ["fill"];
function bb(e, t, n, o, i, r) {
  return l(), h("svg", pb, [
    d("rect", {
      fill: n.fillColor,
      rx: n.rx,
      width: "23",
      height: "23"
    }, null, 8, fb),
    d("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 18L11 5L12 5L12 18L11 18Z"
    }, null, 8, gb),
    d("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 11L18 11L18 12L5 12L5 11Z"
    }, null, 8, vb)
  ]);
}
const aa = /* @__PURE__ */ I(mb, [["render", bb]]), yb = {
  name: "MenuSearchIcon",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    }
  }
}, Cb = ["fill"];
function _b(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.iconColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-cy": "search-icon"
  }, t[0] || (t[0] = [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.03661 17.8C13.362 17.8 16.8683 14.3078 16.8683 10C16.8683 5.69218 13.362 2.2 9.03661 2.2C4.71127 2.2 1.20488 5.69218 1.20488 10C1.20488 14.3078 4.71127 17.8 9.03661 17.8ZM9.03661 19C14.0274 19 18.0732 14.9706 18.0732 10C18.0732 5.02944 14.0274 1 9.03661 1C4.04583 1 0 5.02944 0 10C0 14.9706 4.04583 19 9.03661 19Z"
    }, null, -1),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.3011 24L15.1138 16.1179L15.8128 15.3968L24.0001 23.2789L23.3011 24Z"
    }, null, -1)
  ]), 8, Cb);
}
const wb = /* @__PURE__ */ I(yb, [["render", _b]]), Tb = {
  props: {
    fillColor: {
      type: String,
      default: "#000"
    }
  }
}, kb = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Eb = ["fill"], Sb = ["fill"];
function Mb(e, t, n, o, i, r) {
  return l(), h("svg", kb, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.9503 17.7175L11.5 19.1679V15.875H14.3893C13.996 16.5319 13.5163 17.1516 12.9503 17.7175ZM18.5666 15.875C17.1619 18.0508 14.8443 19.5819 12.1556 19.9265L13.6575 18.4247C14.4285 17.6536 15.0546 16.7924 15.5357 15.875H18.5666ZM19.125 14.875H15.9945C16.4244 13.7905 16.6666 12.6489 16.721 11.5H19.9863C19.9204 12.7035 19.6181 13.844 19.125 14.8758V14.875ZM11.5 11.5H15.7198C15.6593 12.6546 15.3892 13.8002 14.9094 14.875H11.5V11.5ZM11.5 10.5H15.7198C15.6593 9.34543 15.3892 8.19979 14.9094 7.125H11.5V10.5ZM19.9863 10.5H16.721C16.6666 9.35113 16.4244 8.20949 15.9945 7.125H19.125V7.12417C19.6181 8.15604 19.9204 9.29654 19.9863 10.5ZM18.5666 6.125H15.5357C15.0546 5.20762 14.4285 4.34646 13.6574 3.57538L12.1555 2.07349C14.8443 2.41811 17.1619 3.9492 18.5666 6.125ZM11.5 6.125H14.3892C13.996 5.46809 13.5163 4.84847 12.9503 4.28249L11.5 2.83217V6.125ZM10.5 19.1679V15.875H7.61071C8.00401 16.5319 8.48364 17.1515 9.04962 17.7175L10.5 19.1679ZM9.84439 19.9265C7.15566 19.5819 4.83807 18.0508 3.43337 15.875H6.46427C6.94536 16.7924 7.57144 17.6535 8.34252 18.4246L9.84439 19.9265ZM7.09055 14.875H10.5V11.5H6.28022C6.3407 12.6546 6.61081 13.8002 7.09055 14.875ZM5.27898 11.5C5.33341 12.6489 5.57557 13.7905 6.00545 14.875H2.875V14.8758C2.38189 13.844 2.07955 12.7035 2.01365 11.5H5.27898ZM6.28022 10.5H10.5V7.125H7.09055C6.61081 8.19979 6.3407 9.34543 6.28022 10.5ZM6.00545 7.125C5.57556 8.20949 5.33341 9.35113 5.27898 10.5H2.01365C2.07955 9.29654 2.38189 8.15604 2.875 7.12417V7.125H6.00545ZM7.61071 6.125H10.5V2.83211L9.04962 4.28248C8.48364 4.84846 8.004 5.46809 7.61071 6.125ZM9.84439 2.0735L8.34251 3.57538C7.57144 4.34646 6.94536 5.20762 6.46427 6.125H3.43337C4.83807 3.94922 7.15566 2.41814 9.84439 2.0735ZM11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
      fill: n.fillColor
    }, null, 8, Eb),
    d("path", {
      fill: n.fillColor,
      d: "M11.5 19.1679H11.35V19.53L11.6061 19.274L11.5 19.1679ZM11.5 15.875V15.725H11.35V15.875H11.5ZM14.3893 15.875L14.518 15.9521L14.6539 15.725H14.3893V15.875ZM12.1556 19.9265L12.0495 19.8204L11.7388 20.1311L12.1747 20.0753L12.1556 19.9265ZM18.5666 15.875L18.6926 15.9564L18.842 15.725H18.5666V15.875ZM15.5357 15.875V15.725H15.445L15.4029 15.8053L15.5357 15.875ZM15.9945 14.875L15.8551 14.8197L15.7737 15.025H15.9945V14.875ZM19.125 14.875H19.275V14.725H19.125V14.875ZM16.721 11.5V11.35H16.5779L16.5712 11.4929L16.721 11.5ZM19.9863 11.5L20.1361 11.5082L20.1448 11.35H19.9863V11.5ZM19.125 14.8758H18.975L19.2603 14.9405L19.125 14.8758ZM15.7198 11.5L15.8695 11.5078L15.8778 11.35H15.7198V11.5ZM11.5 11.5V11.35H11.35V11.5H11.5ZM14.9094 14.875V15.025H15.0067L15.0464 14.9361L14.9094 14.875ZM11.5 14.875H11.35V15.025H11.5V14.875ZM15.7198 10.5V10.65H15.8778L15.8695 10.4922L15.7198 10.5ZM11.5 10.5H11.35V10.65H11.5V10.5ZM14.9094 7.125L15.0464 7.06386L15.0067 6.975H14.9094V7.125ZM11.5 7.125V6.975H11.35V7.125H11.5ZM16.721 10.5L16.5712 10.5071L16.5779 10.65H16.721V10.5ZM19.9863 10.5V10.65H20.1448L20.1361 10.4918L19.9863 10.5ZM15.9945 7.125V6.975H15.7737L15.8551 7.18027L15.9945 7.125ZM19.125 7.125V7.275H19.275V7.125H19.125ZM19.125 7.12417L19.2603 7.0595L18.975 7.12417H19.125ZM15.5357 6.125L15.4028 6.19466L15.445 6.275H15.5357V6.125ZM18.5666 6.125V6.275H18.842L18.6926 6.04364L18.5666 6.125ZM13.6574 3.57538L13.5514 3.68144L13.6574 3.57538ZM12.1555 2.07349L12.1746 1.92471L11.7388 1.86885L12.0495 2.17956L12.1555 2.07349ZM14.3892 6.125V6.275H14.6539L14.5179 6.04795L14.3892 6.125ZM11.5 6.125H11.35V6.275H11.5V6.125ZM12.9503 4.28249L12.8443 4.38855L12.9503 4.28249ZM11.5 2.83217L11.6061 2.7261L11.35 2.47004V2.83217H11.5ZM10.5 15.875H10.65V15.725H10.5V15.875ZM10.5 19.1679L10.3939 19.274L10.65 19.53V19.1679H10.5ZM7.61071 15.875V15.725H7.34608L7.48202 15.9521L7.61071 15.875ZM9.04962 17.7175L9.15569 17.6115L9.04962 17.7175ZM9.84439 19.9265L9.82532 20.0753L10.2612 20.1311L9.95046 19.8204L9.84439 19.9265ZM3.43337 15.875V15.725H3.15798L3.30735 15.9564L3.43337 15.875ZM6.46427 15.875L6.59711 15.8053L6.55499 15.725H6.46427V15.875ZM8.34252 18.4246L8.44858 18.3186L8.34252 18.4246ZM7.09055 14.875L6.95358 14.9361L6.99324 15.025H7.09055V14.875ZM10.5 14.875V15.025H10.65V14.875H10.5ZM10.5 11.5H10.65V11.35H10.5V11.5ZM6.28022 11.5V11.35H6.12216L6.13043 11.5078L6.28022 11.5ZM5.27898 11.5L5.42881 11.4929L5.42204 11.35H5.27898V11.5ZM6.00545 14.875V15.025H6.22626L6.14489 14.8197L6.00545 14.875ZM2.875 14.875V14.725H2.725V14.875H2.875ZM2.875 14.8758L2.73966 14.9405L3.025 14.8758H2.875ZM2.01365 11.5V11.35H1.85522L1.86388 11.5082L2.01365 11.5ZM6.28022 10.5L6.13043 10.4922L6.12216 10.65H6.28022V10.5ZM10.5 10.5V10.65H10.65V10.5H10.5ZM10.5 7.125H10.65V6.975H10.5V7.125ZM7.09055 7.125V6.975H6.99324L6.95358 7.06386L7.09055 7.125ZM6.00545 7.125L6.14489 7.18027L6.22626 6.975H6.00545V7.125ZM5.27898 10.5V10.65H5.42204L5.42881 10.5071L5.27898 10.5ZM2.01365 10.5L1.86388 10.4918L1.85522 10.65H2.01365V10.5ZM2.875 7.12417H3.025L2.73966 7.05949L2.875 7.12417ZM2.875 7.125H2.725V7.275H2.875V7.125ZM7.61071 6.125L7.48201 6.04795L7.34608 6.275H7.61071V6.125ZM10.5 6.125V6.275H10.65V6.125H10.5ZM10.5 2.83211H10.65V2.46997L10.3939 2.72604L10.5 2.83211ZM9.04962 4.28248L8.94356 4.17642H8.94356L9.04962 4.28248ZM9.84439 2.0735L9.95046 2.17957L10.2612 1.86885L9.82532 1.92472L9.84439 2.0735ZM8.34251 3.57538L8.44858 3.68144L8.34251 3.57538ZM6.46427 6.125V6.275H6.55499L6.59711 6.19466L6.46427 6.125ZM3.43337 6.125L3.30735 6.04364L3.15798 6.275H3.43337V6.125ZM11.6061 19.274L13.0564 17.8236L12.8443 17.6115L11.3939 19.0618L11.6061 19.274ZM11.35 15.875V19.1679H11.65V15.875H11.35ZM14.3893 15.725H11.5V16.025H14.3893V15.725ZM13.0564 17.8236C13.6312 17.2488 14.1184 16.6194 14.518 15.9521L14.2606 15.7979C13.8736 16.4444 13.4015 17.0543 12.8443 17.6115L13.0564 17.8236ZM12.1747 20.0753C14.9087 19.7248 17.2648 18.1681 18.6926 15.9564L18.4406 15.7936C17.0591 17.9335 14.78 19.4389 12.1365 19.7777L12.1747 20.0753ZM13.5514 18.3186L12.0495 19.8204L12.2617 20.0326L13.7635 18.5307L13.5514 18.3186ZM15.4029 15.8053C14.9287 16.7095 14.3116 17.5583 13.5514 18.3186L13.7635 18.5307C14.5454 17.7488 15.1805 16.8753 15.6686 15.9447L15.4029 15.8053ZM18.5666 15.725H15.5357V16.025H18.5666V15.725ZM15.9945 15.025H19.125V14.725H15.9945V15.025ZM16.5712 11.4929C16.5175 12.6255 16.2788 13.7508 15.8551 14.8197L16.134 14.9303C16.57 13.8302 16.8156 12.6723 16.8708 11.5071L16.5712 11.4929ZM19.9863 11.35H16.721V11.65H19.9863V11.35ZM19.2603 14.9405C19.7617 13.8913 20.0691 12.7316 20.1361 11.5082L19.8366 11.4918C19.7718 12.6753 19.4745 13.7966 18.9897 14.8112L19.2603 14.9405ZM18.975 14.875V14.8758H19.275V14.875H18.975ZM15.7198 11.35H11.5V11.65H15.7198V11.35ZM15.0464 14.9361C15.5338 13.8443 15.8081 12.6805 15.8695 11.5078L15.57 11.4922C15.5104 12.6286 15.2446 13.7562 14.7725 14.8139L15.0464 14.9361ZM11.5 15.025H14.9094V14.725H11.5V15.025ZM11.35 11.5V14.875H11.65V11.5H11.35ZM15.7198 10.35H11.5V10.65H15.7198V10.35ZM14.7724 7.18614C15.2446 8.24383 15.5104 9.37137 15.57 10.5078L15.8695 10.4922C15.8081 9.31948 15.5338 8.15574 15.0464 7.06386L14.7724 7.18614ZM11.5 7.275H14.9094V6.975H11.5V7.275ZM11.65 10.5V7.125H11.35V10.5H11.65ZM16.721 10.65H19.9863V10.35H16.721V10.65ZM15.8551 7.18027C16.2788 8.24918 16.5175 9.37452 16.5712 10.5071L16.8708 10.4929C16.8156 9.32773 16.57 8.1698 16.134 7.06973L15.8551 7.18027ZM19.125 6.975H15.9945V7.275H19.125V6.975ZM18.975 7.12417V7.125H19.275V7.12417H18.975ZM20.1361 10.4918C20.0691 9.26836 19.7617 8.10871 19.2603 7.0595L18.9897 7.18885C19.4745 8.20338 19.7718 9.32472 19.8366 10.5082L20.1361 10.4918ZM15.5357 6.275H18.5666V5.975H15.5357V6.275ZM13.5514 3.68144C14.3116 4.44169 14.9287 5.29055 15.4028 6.19466L15.6685 6.05534C15.1805 5.1247 14.5454 4.25122 13.7635 3.46931L13.5514 3.68144ZM12.0495 2.17956L13.5514 3.68144L13.7635 3.46931L12.2616 1.96742L12.0495 2.17956ZM18.6926 6.04364C17.2647 3.83192 14.9086 2.27513 12.1746 1.92471L12.1365 2.22227C14.78 2.56109 17.0591 4.06648 18.4406 6.20636L18.6926 6.04364ZM14.3892 5.975H11.5V6.275H14.3892V5.975ZM12.8443 4.38855C13.4015 4.94576 13.8735 5.55562 14.2606 6.20205L14.5179 6.04795C14.1184 5.38056 13.6312 4.75118 13.0564 4.17642L12.8443 4.38855ZM11.3939 2.93823L12.8443 4.38855L13.0564 4.17642L11.6061 2.7261L11.3939 2.93823ZM11.65 6.125V2.83217H11.35V6.125H11.65ZM10.35 15.875V19.1679H10.65V15.875H10.35ZM7.61071 16.025H10.5V15.725H7.61071V16.025ZM9.15569 17.6115C8.59848 17.0542 8.12643 16.4444 7.73941 15.7979L7.48202 15.9521C7.88158 16.6194 8.3688 17.2488 8.94356 17.8236L9.15569 17.6115ZM10.6061 19.0618L9.15569 17.6115L8.94356 17.8236L10.3939 19.274L10.6061 19.0618ZM9.86346 19.7777C7.21998 19.4389 4.9409 17.9335 3.55939 15.7936L3.30735 15.9564C4.73524 18.1681 7.09133 19.7248 9.82532 20.0753L9.86346 19.7777ZM3.43337 16.025H6.46427V15.725H3.43337V16.025ZM6.33143 15.9447C6.81947 16.8753 7.45454 17.7488 8.23645 18.5307L8.44858 18.3186C7.68834 17.5583 7.07124 16.7094 6.59711 15.8053L6.33143 15.9447ZM8.23645 18.5307L9.73833 20.0326L9.95046 19.8204L8.44858 18.3186L8.23645 18.5307ZM7.09055 15.025H10.5V14.725H7.09055V15.025ZM10.65 14.875V11.5H10.35V14.875H10.65ZM10.5 11.35H6.28022V11.65H10.5V11.35ZM7.22753 14.8139C6.75542 13.7562 6.48955 12.6286 6.43002 11.4922L6.13043 11.5078C6.19185 12.6805 6.46621 13.8443 6.95358 14.9361L7.22753 14.8139ZM5.12914 11.5071C5.18435 12.6723 5.42994 13.8302 5.866 14.9303L6.14489 14.8197C5.72119 13.7508 5.48247 12.6255 5.42881 11.4929L5.12914 11.5071ZM2.875 15.025H6.00545V14.725H2.875V15.025ZM3.025 14.8758V14.875H2.725V14.8758H3.025ZM1.86388 11.5082C1.93087 12.7316 2.23826 13.8913 2.73966 14.9405L3.01034 14.8112C2.52552 13.7966 2.22823 12.6753 2.16343 11.4918L1.86388 11.5082ZM5.27898 11.35H2.01365V11.65H5.27898V11.35ZM6.28022 10.65H10.5V10.35H6.28022V10.65ZM10.65 10.5V7.125H10.35V10.5H10.65ZM10.5 6.975H7.09055V7.275H10.5V6.975ZM6.43002 10.5078C6.48955 9.37137 6.75542 8.24383 7.22753 7.18614L6.95358 7.06386C6.4662 8.15575 6.19185 9.31948 6.13043 10.4922L6.43002 10.5078ZM5.866 7.06973C5.42994 8.1698 5.18435 9.32773 5.12914 10.4929L5.42881 10.5071C5.48247 9.37452 5.72119 8.24918 6.14489 7.18027L5.866 7.06973ZM2.01365 10.65H5.27898V10.35H2.01365V10.65ZM2.73966 7.05949C2.23826 8.10871 1.93087 9.26836 1.86388 10.4918L2.16343 10.5082C2.22823 9.32472 2.52552 8.20337 3.01034 7.18885L2.73966 7.05949ZM3.025 7.125V7.12417H2.725V7.125H3.025ZM6.00545 6.975H2.875V7.275H6.00545V6.975ZM7.61071 6.275H10.5V5.975H7.61071V6.275ZM10.65 6.125V2.83211H10.35V6.125H10.65ZM9.15569 4.38855L10.6061 2.93817L10.3939 2.72604L8.94356 4.17642L9.15569 4.38855ZM7.73941 6.20205C8.12643 5.55562 8.59848 4.94576 9.15569 4.38855L8.94356 4.17642C8.3688 4.75117 7.88158 5.38056 7.48201 6.04795L7.73941 6.20205ZM9.73833 1.96743L8.23645 3.46931L8.44858 3.68144L9.95046 2.17957L9.73833 1.96743ZM8.23645 3.46931C7.45454 4.25122 6.81947 5.1247 6.33143 6.05534L6.59711 6.19466C7.07124 5.29055 7.68834 4.44169 8.44858 3.68144L8.23645 3.46931ZM3.43337 6.275H6.46427V5.975H3.43337V6.275ZM9.82532 1.92472C7.09133 2.27516 4.73524 3.83194 3.30735 6.04364L3.55939 6.20636C4.9409 4.0665 7.21998 2.56112 9.86346 2.22228L9.82532 1.92472ZM20.85 11C20.85 16.44 16.44 20.85 11 20.85V21.15C16.6057 21.15 21.15 16.6057 21.15 11H20.85ZM11 1.15C16.44 1.15 20.85 5.56 20.85 11H21.15C21.15 5.39431 16.6057 0.85 11 0.85V1.15ZM1.15 11C1.15 5.56 5.56 1.15 11 1.15V0.85C5.39431 0.85 0.85 5.39431 0.85 11H1.15ZM11 20.85C5.56 20.85 1.15 16.44 1.15 11H0.85C0.85 16.6057 5.39431 21.15 11 21.15V20.85Z"
    }, null, 8, Sb)
  ]);
}
const $b = /* @__PURE__ */ I(Tb, [["render", Mb], ["__scopeId", "data-v-ffbe6fac"]]), Ib = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    fillPathColor: {
      type: String,
      default: "#000"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    circleBackground: {
      type: Boolean
    }
  }
}, Ab = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, Lb = ["fill", "rx"], Ob = ["fill"];
function Nb(e, t, n, o, i, r) {
  return l(), h("svg", Ab, [
    d("rect", {
      fill: n.fillColor,
      rx: n.circleBackground ? 50 : 4,
      width: "23",
      height: "23"
    }, null, 8, Lb),
    d("path", {
      class: p([n.dropdownClass, "arrow"]),
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.14645 8.14645C5.34171 7.95118 5.65829 7.95118 5.85355 8.14645L11.5 13.7929L17.1464 8.14645C17.3417 7.95118 17.6583 7.95118 17.8536 8.14645C18.0488 8.34171 18.0488 8.65829 17.8536 8.85355L11.8536 14.8536C11.6583 15.0488 11.3417 15.0488 11.1464 14.8536L5.14645 8.85355C4.95118 8.65829 4.95118 8.34171 5.14645 8.14645Z"
    }, null, 10, Ob)
  ]);
}
const Hb = /* @__PURE__ */ I(Ib, [["render", Nb], ["__scopeId", "data-v-964bccff"]]), Pb = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  }
}, Db = ["fill"];
function Rb(e, t, n, o, i, r) {
  return l(), h("svg", {
    class: p({
      [n.dropdownClass]: !0,
      open: n.isOpen,
      close: !n.isOpen
    }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 14 11",
    fill: "none"
  }, [
    d("path", {
      d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
      fill: n.fillColor
    }, null, 8, Db)
  ], 2);
}
const ec = /* @__PURE__ */ I(Pb, [["render", Rb], ["__scopeId", "data-v-174954e1"]]), Vb = {
  name: "SvgClose",
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, Bb = ["fill"], Fb = ["fill"], jb = ["fill"];
function Ub(e, t, n, o, i, r) {
  return l(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    "aria-label": "Close icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.439341 0.43934C1.02513 -0.146447 1.97488 -0.146447 2.56066 0.43934L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L0.439341 2.56066C-0.146445 1.97487 -0.146445 1.02513 0.439341 0.43934Z",
      fill: n.fillColor
    }, null, 8, Fb),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.5607 0.43934C24.1464 1.02513 24.1464 1.97487 23.5607 2.56066L2.56066 23.5607C1.97487 24.1464 1.02513 24.1464 0.43934 23.5607C-0.146447 22.9749 -0.146447 22.0251 0.43934 21.4393L21.4393 0.43934C22.0251 -0.146447 22.9749 -0.146447 23.5607 0.43934Z",
      fill: n.fillColor
    }, null, 8, jb)
  ], 8, Bb);
}
const Qo = /* @__PURE__ */ I(Vb, [["render", Ub]]), Kb = {
  name: "MenuItem",
  components: {
    FilledDropdownArrow: Hb,
    HamburgerIcon: sa,
    PlusIcon: aa,
    SearchIcon: wb,
    LanguageIcon: $b,
    TriangleIcon: ec,
    Close: Qo
  },
  props: {
    item: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    themeOverrides: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      required: !0
    },
    focusVisibleColor: {
      type: String,
      default: "#0000FF"
    },
    mobileTextColor: {
      type: String,
      default: "#0000FF"
    },
    isMobile: Boolean,
    dropdownOpen: Boolean,
    showText: {
      type: Boolean,
      default: !0
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-dropdown", "toggle-search"],
  computed: {
    showTitleTop() {
      return this.showText && ["schoolsbutton", "explore-button", "languagebutton"].includes(this.menuItem.id) || this.menuItem.id === "searchbutton" && ["H6", "H7", "H8"].includes(this.theme.version) && this.screenSize > 599;
    },
    showTitleBottom() {
      return this.showText && this.menuItem.id === "menubutton" && !this.isMobile || this.menuItem.id === "searchbutton";
    },
    focusColor() {
      return { "--focus-visible-color": this.focusVisibleColor };
    },
    menuItem() {
      const t = [
        this.menuButton,
        this.exploreButton,
        this.schoolsButton,
        this.languagesButton,
        this.searchButton,
        this.closeButton
      ].find((n) => n.id === this.item);
      return de(oe(oe({}, t), this.themeOverrides), {
        colors: oe(oe({}, t.colors), this.themeOverrides.colors)
      });
    },
    menuButton() {
      var e, t, n, o;
      return {
        id: "menubutton",
        class: ["menu", { "m4-menu": this.content.menuOptions.version === "M4" }, "button-action", this.theme.style],
        iconClass: this.theme.menu_icon,
        dataTestId: "menu-button",
        ariaExpanded: this.content.showMenu,
        ariaControls: this.content.showMenu ? "mainmenu" : null,
        translatedTitle: this.theme.translations.menu_dropdown_title || "Menu",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--nav-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
    },
    exploreButton() {
      var e, t, n, o, i, r;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "explore-menu" : null,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((t = this.theme.translations) == null ? void 0 : t.explore_dropdown_title) || "Explore",
        icon: "FilledDropdownArrow",
        colors: {
          "--fill-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex,
          "--fill-path-color": (o = this.theme.navigation_icon_color) == null ? void 0 : o.hex,
          "--bg-color": (i = this.theme.bg_color) == null ? void 0 : i.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    schoolsButton() {
      var e, t, n, o;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.ariaControlsSchoolsMenu,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
    },
    ariaControlsSchoolsMenu() {
      return this.dropdownOpen ? this.content.hasCustomSchoolsMenu ? "schools-menu-sm1" : "schoolsmenu" : null;
    },
    languagesButton() {
      var e, t, n, o, i, r;
      return {
        id: "languagebutton",
        class: ["languages", "button-action", "menu", this.theme.style],
        dataTestId: "language-button",
        menuItemType: "languagebutton",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "languagesmenu" : null,
        icon: this.isMobile && this.content.newMobileHeader || this.isMobile && this.theme.version === "H3" ? "LanguageIcon" : "FilledDropdownArrow",
        ariaLabel: this.theme.translations.translate_site,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.translate_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.translate_dropdown_title) || "Translate",
        colors: {
          "--fill-color": this.languageButtonColor,
          "--fill-path-color": ((o = this.theme.navigation_icon_color) == null ? void 0 : o.hex) || "#FFFFFF",
          "--bg-color": (i = this.theme.bg_color) == null ? void 0 : i.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": ((r = this.theme.navigation_color) == null ? void 0 : r.hex) || "#0000FF"
        }
      };
    },
    languageButtonColor() {
      var e, t;
      return this.isMobile && this.theme.version === "H3" ? this.mobileTextColor : this.theme.version === "H2" ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : (t = this.theme.navigation_color) == null ? void 0 : t.hex;
    },
    searchButton() {
      var e, t;
      return {
        id: "searchbutton",
        class: [
          "search",
          "focus-search-icon",
          "button-action",
          "menu",
          this.theme.style,
          { shrinkCSSClass: !this.isMobile || !this.content.newMobileHeader }
        ],
        dataTestId: this.searchTestIdByHeader,
        icon: "SearchIcon",
        translatedTitle: this.theme.translations.search_title || "Search Site",
        colors: {
          "--icon-color": this.isMobile ? this.mobileTextColor : (e = this.theme.search_icon_color) == null ? void 0 : e.hex,
          "--bg-color": (t = this.theme.bg_color) == null ? void 0 : t.hex
        }
      };
    },
    closeButton() {
      var e;
      return {
        id: "closebutton",
        class: ["menu", this.theme.style, "close-icon"],
        dataTestId: "close-button",
        icon: "Close",
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex
        }
      };
    },
    searchTestIdByHeader() {
      return this.theme.version === "H2" ? this.isMobile ? "small-utilities-search-button" : "large-utilities-search-button" : "search-button";
    }
  },
  methods: {
    itemAction(e) {
      e === "searchbutton" ? this.$emit("toggle-search") : this.$emit("toggle-dropdown", e);
    }
  }
}, Gb = ["id", "data-testid", "aria-expanded", "aria-controls", "aria-label"], zb = { class: "button-action-content" };
function Zb(e, t, n, o, i, r) {
  return l(), h("button", {
    id: r.menuItem.id,
    "data-testid": r.menuItem.dataTestId,
    "aria-haspopup": "true",
    "aria-expanded": r.menuItem.ariaExpanded,
    "aria-controls": r.menuItem.ariaControls,
    "aria-label": r.menuItem.ariaLabel,
    class: p(["menu-item", r.menuItem.class]),
    style: H(r.focusColor),
    onClick: t[0] || (t[0] = (a) => r.itemAction(r.menuItem.id))
  }, [
    d("span", zb, [
      r.showTitleTop ? (l(), h("span", {
        key: 0,
        class: "menu-field",
        style: H({
          color: r.menuItem.colors["--nav-color"]
        })
      }, f(r.menuItem.translatedTitle), 5)) : g("", !0),
      (l(), _(R(r.menuItem.icon), {
        class: p(r.menuItem.iconClass),
        "theme-style": n.theme.style,
        "bg-color": r.menuItem.colors["--bg-color"] || null,
        "icon-color": r.menuItem.colors["--icon-color"] || null,
        rx: n.theme.style === "purple" ? "50" : "4",
        "fill-color": r.menuItem.colors["--fill-color"] || null,
        "fill-path-color": r.menuItem.colors["--fill-path-color"] || null,
        "fill-background": r.menuItem.colors["--fill-background"] || null,
        "circle-background": r.menuItem.colors["--circle-background"] || null,
        "dropdown-class": r.menuItem.colors["--dropdown-class"],
        "nav-color": r.menuItem.colors["--nav-color"]
      }, null, 8, ["class", "theme-style", "bg-color", "icon-color", "rx", "fill-color", "fill-path-color", "fill-background", "circle-background", "dropdown-class", "nav-color"])),
      r.showTitleBottom ? (l(), h("span", {
        key: 1,
        class: p(["menu-field", { "sr-only": r.menuItem.id === "searchbutton" && n.theme.version !== "H4" }])
      }, f(r.menuItem.translatedTitle), 3)) : g("", !0)
    ])
  ], 14, Gb);
}
const it = /* @__PURE__ */ I(Kb, [["render", Zb], ["__scopeId", "data-v-9e3e9d79"]]), Wb = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    }
  }
}, qb = ["fill"];
function Yb(e, t, n, o, i, r) {
  return l(), h("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    class: p(n.dropdownClass),
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7144 9L11.5003 14.3919L5.28389 9L4 10.4956L11.5003 17L18.9997 10.4956L17.7144 9Z"
    }, null, -1)
  ]), 10, qb);
}
const io = /* @__PURE__ */ I(Wb, [["render", Yb], ["__scopeId", "data-v-5678f690"]]), xb = {
  name: "SchoolsMenuHeader",
  components: {
    DropdownArrowIcon: io
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    isMobile: Boolean,
    isMobileActive: Boolean
  }
}, Xb = ["tabindex"];
function Qb(e, t, n, o, i, r) {
  const a = S("DropdownArrowIcon");
  return l(), h("div", {
    class: p({ "mobile-cursor": n.isMobile }),
    style: H(`color: ${n.theme.schools_menu_text_color.hex}`),
    tabindex: n.isMobile ? "0" : "-1",
    onKeydown: [
      t[0] || (t[0] = N(D((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["enter"])),
      t[1] || (t[1] = N(D((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["space"])),
      t[2] || (t[2] = N(D((s) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[3] || (t[3] = N((s) => e.$emit("tab-action", s), ["tab"]))
    ]
  }, [
    d("h2", {
      class: p(["schools-menu-header", n.theme.style])
    }, f(n.item.name), 3),
    n.isMobile && n.item.children ? (l(), _(a, {
      key: 0,
      class: "schools-menu-arrow",
      "fill-color": `${n.theme.schools_menu_text_color.hex}`,
      "dropdown-class": n.isMobileActive ? "open" : "close"
    }, null, 8, ["fill-color", "dropdown-class"])) : g("", !0)
  ], 46, Xb);
}
const Jb = /* @__PURE__ */ I(xb, [["render", Qb], ["__scopeId", "data-v-0ee6ab64"]]), ey = "sites.thrillshare.com", ty = "sites.thrillshare.ca", ny = "develop.thrillshare.com", oy = "qa.thrillshare.com", ry = "localhost:4000", iy = [ey, ty, ny, oy, ry], Zi = "/", sy = (e) => !!iy.find((t) => e && !!e.toLowerCase().includes(t)), $n = (e, { isPreview: t, currentDomain: n }) => e ? sy(n) || t ? e.path_prefix || Zi : e.org_url ? e.org_url === e.path_prefix ? e.path_prefix || Zi : `https://${e.org_url}` : e.path_prefix || Zi : "#", la = (e, t, { isPreview: n }) => {
  const o = H9(e.link), i = t.find(
    (a) => a && a.alias && e.alias && a.alias.toLowerCase() === e.alias.toLowerCase()
  ), r = {
    isPreview: n,
    currentDomain: window.location.href
  };
  return i ? $n(i, r) : o;
}, ay = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean
  },
  computed: {
    link() {
      return la(this.item, this.organizations, {
        isPreview: this.isPreview
      });
    }
  }
}, ly = ["href"];
function dy(e, t, n, o, i, r) {
  return l(), h("a", {
    href: r.link,
    style: H(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = N(D((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = N((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, f(n.item.name), 45, ly);
}
const uy = /* @__PURE__ */ I(ay, [["render", dy], ["__scopeId", "data-v-40d9da4e"]]), cy = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, hy = ["href", "target"];
function my(e, t, n, o, i, r) {
  return l(), h("a", {
    href: n.item.link,
    target: r.linkTarget,
    style: H(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = N(D((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = N((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, f(n.item.name), 45, hy);
}
const py = /* @__PURE__ */ I(cy, [["render", my], ["__scopeId", "data-v-ca9c8a65"]]), fy = {
  name: "SchoolsMenuImage",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    },
    isDecorativeImage() {
      return !!this.item.decorative_image;
    }
  }
}, gy = { key: 0 }, vy = ["src", "alt"], by = { key: 1 }, yy = ["href", "target"], Cy = ["src", "alt"];
function _y(e, t, n, o, i, r) {
  return l(), h("div", {
    class: p([n.item.image_alignment, "image-container"])
  }, [
    n.item.action_on_click === "no_action" ? (l(), h("div", gy, [
      d("img", {
        src: n.item.url,
        alt: r.isDecorativeImage ? "" : n.item.alt_text,
        style: H({ width: r.width, height: r.height })
      }, null, 12, vy)
    ])) : (l(), h("div", by, [
      d("a", {
        href: n.item.link_url,
        target: r.opensInNewTab,
        onKeydown: [
          t[0] || (t[0] = N(D((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
          t[1] || (t[1] = N((a) => e.$emit("tab-action", a), ["tab"]))
        ]
      }, [
        d("img", {
          src: n.item.url,
          alt: r.isDecorativeImage ? "" : n.item.alt_text,
          style: H({ width: r.width, height: r.height })
        }, null, 12, Cy)
      ], 40, yy)
    ]))
  ], 2);
}
const wy = /* @__PURE__ */ I(fy, [["render", _y], ["__scopeId", "data-v-92129cf0"]]), Ty = {
  name: "SM1",
  components: {
    SchoolsMenuHeader: Jb,
    SchoolsMenuOrg: uy,
    SchoolsMenuLink: py,
    SchoolsMenuImage: wy
  },
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean
  },
  data() {
    return {
      debounceSetScreenSize: () => {
      },
      screenSize: "",
      activeHeader: "",
      allFocusableElements: []
    };
  },
  computed: {
    isMobile() {
      return this.screenSize < 540;
    },
    styles() {
      return {
        background: this.headerTheme.version === "H4" ? "transparent" : this.headerTheme.schools_menu_bg_color.hex
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debounceSetScreenSize = zo(this.setScreenSize, 100), window.addEventListener("resize", this.debounceSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = window.innerWidth;
    },
    setActiveHeader(e) {
      this.activeHeader = e === this.activeHeader ? "" : e;
    },
    determineFocusableElements() {
      this.allFocusableElements = this.$refs["menu-wrapper"].querySelectorAll("[href], .mobile-cursor");
    },
    tabAction(e, t) {
      var c, y;
      this.determineFocusableElements();
      const n = t.shiftKey, o = this.allFocusableElements[0], i = this.allFocusableElements[this.allFocusableElements.length - 1];
      let r = "", a = "";
      e.type === "SchoolsMenuImage" && (r = (c = o == null ? void 0 : o.href) == null ? void 0 : c.toString().slice(0, -1), a = (y = i == null ? void 0 : i.href) == null ? void 0 : y.toString().slice(0, -1));
      const s = o.innerText === e.name || r === e.link_url, u = i.innerText === e.name || a === e.link_url;
      s && n && this.$emit("focus-lost"), u && !n && this.$emit("focus-lost");
    }
  }
}, ky = {
  ref: "menu-wrapper",
  class: "wrapper"
}, Ey = ["id", "onClick"], Sy = ["aria-describedby"];
function My(e, t, n, o, i, r) {
  return l(), h("div", {
    id: "schools-menu-sm1",
    class: p([
      n.headerTheme.version,
      {
        sticky: n.stickyHeader,
        shrink: n.shrinkHeader
      }
    ]),
    style: H(r.styles)
  }, [
    d("div", ky, [
      (l(!0), h(G, null, q(n.columns, (a, s) => (l(), h("div", {
        key: `sm1-col-${s}`,
        class: "column"
      }, [
        d("ul", null, [
          (l(!0), h(G, null, q(a, (u, c) => (l(), h("li", {
            id: `parent-item-${s}-${c}`,
            key: `parent-item-${s}-${c}`,
            class: p(["parent-item", u.type]),
            onClick: (y) => r.setActiveHeader(`${s}-${c}`)
          }, [
            (l(), _(R(u.type), {
              item: u,
              organizations: n.organizations,
              theme: n.headerTheme,
              "is-mobile": r.isMobile,
              "is-preview": n.isPreview,
              "is-mobile-active": i.activeHeader === `${s}-${c}`,
              onHideOnEsc: t[0] || (t[0] = (y) => e.$emit("hide-on-esc")),
              onSetActiveHeader: (y) => r.setActiveHeader(`${s}-${c}`),
              onTabAction: (y) => r.tabAction(u, y)
            }, null, 40, ["item", "organizations", "theme", "is-mobile", "is-preview", "is-mobile-active", "onSetActiveHeader", "onTabAction"])),
            $(ye, {
              name: r.isMobile ? "slide" : ""
            }, {
              default: b(() => [
                u.type === "SchoolsMenuHeader" && !r.isMobile || r.isMobile && i.activeHeader === `${s}-${c}` ? (l(), h("ul", {
                  key: 0,
                  class: "child-ul",
                  "aria-describedby": `parent-item-${s}-${c}`
                }, [
                  (l(!0), h(G, null, q(u.children, (y, w) => (l(), h("li", {
                    key: `child-item-${s}-${c}-${w}`,
                    class: "child-item"
                  }, [
                    (l(), _(R(y.type), {
                      organizations: n.organizations,
                      item: y,
                      theme: n.headerTheme,
                      onHideOnEsc: t[1] || (t[1] = (v) => e.$emit("hide-on-esc")),
                      onTabAction: (v) => r.tabAction(y, v)
                    }, null, 40, ["organizations", "item", "theme", "onTabAction"]))
                  ]))), 128))
                ], 8, Sy)) : g("", !0)
              ]),
              _: 2
            }, 1032, ["name"])
          ], 10, Ey))), 128))
        ])
      ]))), 128))
    ], 512)
  ], 6);
}
const $y = /* @__PURE__ */ I(Ty, [["render", My], ["__scopeId", "data-v-fa1c07e4"]]), Iy = {
  name: "SchoolsMenu",
  components: {
    SM1: $y
  },
  mixins: [Ze],
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    orgMenuContent: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    showCustomSchoolsMenu: Boolean,
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean,
    isIFrame: Boolean
  },
  methods: {
    hideOnClickaway() {
      this.$emit("hide-on-clickaway");
    },
    onFocusLost() {
      this.$emit("focus-lost");
    }
  }
};
function Ay(e, t, n, o, i, r) {
  const a = Ne("click-away");
  return l(), h("div", {
    onKeydown: t[0] || (t[0] = N(D((...s) => r.hideOnClickaway && r.hideOnClickaway(...s), ["exact", "prevent"]), ["esc"]))
  }, [
    $(ye, { name: "slide" }, {
      default: b(() => [
        n.showCustomSchoolsMenu ? me((l(), _(R("SM1"), {
          key: 0,
          "header-theme": n.headerTheme,
          columns: n.orgMenuContent,
          organizations: n.organizations,
          "sticky-header": n.stickyHeader,
          "shrink-header": n.shrinkHeader,
          "is-preview": n.isPreview,
          onHideOnEsc: r.hideOnClickaway,
          onFocusLost: r.onFocusLost
        }, null, 40, ["header-theme", "columns", "organizations", "sticky-header", "shrink-header", "is-preview", "onHideOnEsc", "onFocusLost"])), [
          [a, r.hideOnClickaway]
        ]) : g("", !0)
      ]),
      _: 1
    })
  ], 32);
}
const an = /* @__PURE__ */ I(Iy, [["render", Ay], ["__scopeId", "data-v-e9ebd598"]]), Ly = {
  name: "HeaderDropdown",
  props: {
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    labelledby: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    isVisible: Boolean,
    menuV4Enabled: Boolean,
    isPreview: Boolean,
    isLanguageMenuHidden: Boolean,
    pathPrefix: {
      type: String,
      default: ""
    },
    isShrink: Boolean
  },
  data() {
    return {
      focusedIndex: 0,
      headerHeight: 200
    };
  },
  computed: {
    colors() {
      const e = this.isShrink ? 46 : this.headerHeight;
      return {
        "--school-bg-color": this.styles.schools_menu_bg_color.hex,
        "--school-text-color": this.styles.schools_menu_text_color.hex,
        "--explore-bg-color": T(
          this.styles,
          "explore_menu_bg_color.hex",
          this.styles.language_menu_dropdown_color.hex
        ),
        "--explore-text-color": T(
          this.styles,
          "explore_menu_text_color.hex",
          this.styles.language_menu_text_color.hex
        ),
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex,
        "--lang-text-color": this.styles.language_menu_text_color.hex,
        "--header-height": `${e + 12}px`
      };
    },
    isSchoolMenu() {
      return this.id === "schoolsmenu";
    },
    isMenuV4() {
      return this.menuV4Enabled && this.id === "explore-menu";
    }
  },
  mounted() {
    typeof window != "undefined" && window.addEventListener("resize", this.calculateParentHeight);
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.calculateParentHeight);
  },
  beforeUpdate() {
    this.calculateParentHeight();
  },
  updated() {
    this.isVisible && this.$refs.dropdown && (this.focusedIndex = 0);
  },
  methods: {
    calculateParentHeight() {
      this.$parent.$parent.$refs.cmsHeader && (this.headerHeight = this.$parent.$parent.$refs.cmsHeader.clientHeight);
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.pathPrefix}${e}` : e;
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    changeFocus(e, t) {
      const n = this.focusedIndex + e;
      if (n < 0 || n > this.data.length - 1) {
        this.closeDropdown();
        return;
      }
      this.focusedIndex = n, t ? this.focusItem() : this.focusArrowNavigation();
    },
    focusPrevious(e, t) {
      this.changeFocus(-1, t);
    },
    focusNext(e, t) {
      this.changeFocus(1, t);
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].focus();
    },
    focusArrowNavigation() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    updateLanguageCode(e) {
      this.$emit("setLanguage", e);
    },
    closeDropdown(e) {
      this.$emit("close-dropdown", e);
    },
    orgLink(e) {
      return $n(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    }
  }
}, Oy = ["id", "role", "aria-labelledby"], Ny = { ref: "dropdown" }, Hy = ["href", "target"], Py = ["href"], Dy = ["onKeydown"], Ry = ["onClick"], Vy = {
  class: "button-action-content",
  tabindex: "-1"
};
function By(e, t, n, o, i, r) {
  return l(), _(ye, { name: "fade" }, {
    default: b(() => [
      n.isVisible ? (l(), h("div", {
        key: 0,
        class: "header--dropdown-wrapper",
        style: H(r.colors)
      }, [
        d("div", {
          id: n.id,
          role: n.role,
          "aria-labelledby": n.labelledby,
          class: p(["dropdown", {
            "dropdown--school": r.isSchoolMenu,
            "dropdown--explore": r.isMenuV4,
            "dropdown--lang": !r.isSchoolMenu && !r.isMenuV4,
            "no-language-menu": n.isLanguageMenuHidden
          }]),
          onClick: D(() => {
          }, ["stop"]),
          onKeydown: t[14] || (t[14] = N(D((a) => r.closeDropdown(!0), ["exact", "prevent"]), ["esc"]))
        }, [
          d("ul", Ny, [
            r.isMenuV4 ? (l(!0), h(G, { key: 0 }, q(n.data, (a) => (l(), h("li", {
              key: a.id,
              role: "menuitem",
              onKeydown: [
                t[0] || (t[0] = N(D((...s) => r.focusPrevious && r.focusPrevious(...s), ["exact", "prevent"]), ["up"])),
                t[1] || (t[1] = N(D((...s) => r.focusNext && r.focusNext(...s), ["exact", "prevent"]), ["down"])),
                t[2] || (t[2] = N(D((s) => r.focusPrevious(s, !0), ["shift", "exact"]), ["tab"])),
                t[3] || (t[3] = N(D((s) => r.focusNext(s, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[4] || (t[4] = (...s) => r.closeDropdown && r.closeDropdown(...s))
            }, [
              d("a", {
                href: r.getLink(a.url),
                class: "link-explore",
                target: r.targetWindow(a)
              }, f(a.name), 9, Hy)
            ], 32))), 128)) : r.isSchoolMenu ? (l(!0), h(G, { key: 1 }, q(n.data, (a, s) => (l(), h("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                t[5] || (t[5] = N(D((...u) => r.focusPrevious && r.focusPrevious(...u), ["exact", "prevent"]), ["up"])),
                t[6] || (t[6] = N(D((...u) => r.focusNext && r.focusNext(...u), ["exact", "prevent"]), ["down"])),
                t[7] || (t[7] = N(D((u) => r.focusPrevious(u, !0), ["shift", "exact"]), ["tab"])),
                t[8] || (t[8] = N(D((u) => r.focusNext(u, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[9] || (t[9] = (...u) => r.closeDropdown && r.closeDropdown(...u))
            }, [
              d("a", {
                href: r.orgLink(a),
                class: "link-school"
              }, f(a.name), 9, Py)
            ], 32))), 128)) : (l(!0), h(G, { key: 2 }, q(n.data, (a, s) => (l(), h("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                N(D((u) => r.updateLanguageCode(a), ["exact", "prevent"]), ["enter"]),
                t[10] || (t[10] = N(D((...u) => r.focusPrevious && r.focusPrevious(...u), ["exact", "prevent"]), ["up"])),
                t[11] || (t[11] = N(D((...u) => r.focusNext && r.focusNext(...u), ["exact", "prevent"]), ["down"])),
                t[12] || (t[12] = N(D((u) => r.focusPrevious(u, !0), ["shift", "exact"]), ["tab"])),
                t[13] || (t[13] = N(D((u) => r.focusNext(u, !0), ["exact"]), ["tab"]))
              ]
            }, [
              d("button", {
                class: "button-action link-lang",
                onClick: (u) => r.updateLanguageCode(a)
              }, [
                d("div", Vy, f(a.language), 1)
              ], 8, Ry)
            ], 40, Dy))), 128))
          ], 512)
        ], 42, Oy)
      ], 4)) : g("", !0)
    ]),
    _: 1
  });
}
const Fy = /* @__PURE__ */ I(Ly, [["render", By], ["__scopeId", "data-v-49b8bc7d"]]), jy = {
  props: {
    color: {
      type: String,
      default: ""
    }
  }
}, Uy = {
  width: "176",
  height: "16",
  viewBox: "0 0 176 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-labelledby": "googleTranslateLogoID"
}, Ky = ["fill"], Gy = ["fill"], zy = ["fill"], Zy = ["fill"], Wy = ["fill"], qy = ["fill"], Yy = ["fill"], xy = ["fill"], Xy = ["fill"], Qy = ["fill"], Jy = ["fill"], eC = ["fill"], tC = ["fill"], nC = ["fill"], oC = ["fill"], rC = ["fill"], iC = ["fill"], sC = ["fill"], aC = ["fill"], lC = ["fill"], dC = ["fill"], uC = ["fill"], cC = ["fill"], hC = ["fill"];
function mC(e, t, n, o, i, r) {
  return l(), h("svg", Uy, [
    t[0] || (t[0] = d("title", { id: "googleTranslateLogoID" }, "powered by Google Translate", -1)),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M128.97 4.67C128.23 4.67 127.2 5.19 126.91 6H126.85V4.78H125.58V11.88H126.91V8.06C126.91 6.76 127.84 5.99 128.75 5.99C129.04 5.99 129.27 6.02 129.46 6.09L129.97 4.84C129.69 4.72 129.4 4.67 128.97 4.67",
      fill: n.color || "#757575"
    }, null, 8, Ky),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M152.98 1.33H154.31V11.87H152.98V1.33Z",
      fill: n.color || "#757575"
    }, null, 8, Gy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M148.84 4.67C147.41 4.67 146.07 5.47 146.07 6.72C146.07 7.97 147.28 8.48 147.91 8.63L149.34 8.97C150.07 9.15 150.32 9.53 150.32 9.88C150.32 10.46 149.7 10.83 148.9 10.83C148.1 10.83 147.36 10.43 146.99 9.54L145.84 10.02C146.25 11.02 147.23 12 148.89 12C150.55 12 151.64 11.06 151.64 9.84C151.64 9 151.07 8.15 149.7 7.83L148.3 7.51C147.75 7.38 147.39 7.15 147.39 6.71C147.39 6.15 148.06 5.84 148.79 5.84C149.46 5.84 150.14 6.11 150.4 6.75L151.52 6.29C151.1 5.24 150.02 4.67 148.82 4.67",
      fill: n.color || "#757575"
    }, null, 8, zy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M158.76 10.8C158.09 10.8 157.25 10.45 157.25 9.72C157.25 9.09 157.86 8.4 159.22 8.4C160.32 8.4 160.84 8.81 160.84 8.81C160.84 9.93 159.78 10.8 158.75 10.8M159.03 4.67C157.3 4.67 156.33 5.68 156.09 6.31L157.27 6.82C157.51 6.17 158.34 5.87 159.06 5.87C160.03 5.87 160.84 6.47 160.84 7.56V7.76C160.57 7.61 159.92 7.34 158.99 7.34C157.37 7.34 155.87 8.14 155.87 9.7C155.87 11.13 157.13 12 158.54 12C159.72 12 160.4 11.36 160.78 10.79H160.84V11.87H162.1V7.61C162.1 5.67 160.72 4.66 159.04 4.66",
      fill: n.color || "#757575"
    }, null, 8, Zy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M133.5 10.8C132.83 10.8 131.99 10.45 131.99 9.72C131.99 9.09 132.6 8.4 133.96 8.4C135.06 8.4 135.58 8.81 135.58 8.81C135.58 9.93 134.52 10.8 133.49 10.8M133.77 4.67C132.04 4.67 131.07 5.68 130.83 6.31L132.01 6.82C132.25 6.17 133.08 5.87 133.8 5.87C134.77 5.87 135.58 6.47 135.58 7.56V7.76C135.31 7.61 134.66 7.34 133.73 7.34C132.11 7.34 130.61 8.14 130.61 9.7C130.61 11.13 131.87 12 133.28 12C134.46 12 135.14 11.36 135.52 10.79H135.58V11.87H136.84V7.61C136.84 5.67 135.46 4.66 133.78 4.66",
      fill: n.color || "#757575"
    }, null, 8, Wy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.58 7.5C169.84 6.5 170.61 5.87 171.58 5.87C173.08 5.87 173.59 6.91 173.63 7.5H169.58ZM171.61 4.67C169.56 4.67 168.19 6.38 168.19 8.34C168.19 10.42 169.62 12.01 171.76 12.01C173.37 12.01 174.4 11.11 174.81 10.13L173.64 9.65C173.27 10.52 172.5 10.81 171.73 10.81C170.65 10.81 169.58 10.04 169.5 8.59H175.02C175.02 8.59 175.03 8.44 175.03 8.34C175.03 6.12 173.69 4.67 171.61 4.67",
      fill: n.color || "#757575"
    }, null, 8, qy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M141.96 4.67C140.99 4.67 140.09 5.23 139.71 5.89H139.65V4.78H138.38V11.88H139.71V8.08C139.71 6.99 140.42 5.89 141.58 5.89C142.59 5.89 143.33 6.38 143.33 7.86V11.88H144.66V7.66C144.66 5.91 143.76 4.68 141.95 4.68",
      fill: n.color || "#757575"
    }, null, 8, Yy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M165.58 2.67H164.25V4.78H163V6.01H164.25V9.73C164.25 11.18 165.05 12 166.54 12C166.99 12 167.31 11.94 167.61 11.81L167.15 10.67C166.96 10.76 166.79 10.79 166.54 10.79C165.92 10.79 165.58 10.43 165.58 9.63V6.01H167.32V4.78H165.58V2.67",
      fill: n.color || "#757575"
    }, null, 8, xy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M125.13 1.33H117.91V2.7H120.84V11.87H122.19V2.7H125.12V1.33",
      fill: n.color || "#757575"
    }, null, 8, Xy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M72.34 5.46V7.1H76.26C76.14 8.02 75.84 8.7 75.37 9.16C74.8 9.73 73.91 10.36 72.34 10.36C69.92 10.36 68.04 8.41 68.04 6C68.04 3.59 69.93 1.64 72.34 1.64C73.64 1.64 74.59 2.15 75.3 2.81L76.46 1.65C75.48 0.71 74.18 0 72.35 0C69.04 0 66.26 2.69 66.26 6C66.26 9.31 69.04 12 72.35 12C74.13 12 75.48 11.41 76.54 10.32C77.62 9.24 77.96 7.71 77.96 6.49C77.96 6.11 77.93 5.76 77.87 5.47H72.35",
      fill: n.color || "#4285F4"
    }, null, 8, Qy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M82.85 4.13C80.71 4.13 78.96 5.76 78.96 8C78.96 10.24 80.71 11.87 82.85 11.87C84.99 11.87 86.74 10.23 86.74 8C86.74 5.77 84.99 4.13 82.85 4.13ZM82.85 10.35C81.68 10.35 80.66 9.38 80.66 8C80.66 6.62 81.67 5.65 82.85 5.65C84.03 5.65 85.04 6.6 85.04 8C85.04 9.4 84.03 10.35 82.85 10.35Z",
      fill: n.color || "#EB4335"
    }, null, 8, Jy),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M101.9 4.99H101.84C101.46 4.53 100.72 4.12 99.8001 4.12C97.8601 4.12 96.1801 5.81 96.1801 7.99C96.1801 10.17 97.8701 11.86 99.8001 11.86C100.72 11.86 101.46 11.45 101.84 10.98H101.9V11.52C101.9 13 101.11 13.79 99.8301 13.79C98.7901 13.79 98.1401 13.04 97.8801 12.41L96.4001 13.03C96.8301 14.06 97.9501 15.32 99.8301 15.32C101.83 15.32 103.51 14.15 103.51 11.29V4.32H101.9V4.99V4.99ZM99.9501 10.34C98.7801 10.34 97.8801 9.34 97.8801 7.99C97.8801 6.64 98.7701 5.64 99.9501 5.64C101.13 5.64 102.02 6.64 102.02 8C102.02 9.36 101.11 10.33 99.9501 10.33V10.34Z",
      fill: n.color || "#4285F4"
    }, null, 8, eC),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M91.51 4.13C89.37 4.13 87.62 5.76 87.62 8C87.62 10.24 89.37 11.87 91.51 11.87C93.65 11.87 95.4 10.23 95.4 8C95.4 5.77 93.65 4.13 91.51 4.13ZM91.51 10.35C90.34 10.35 89.32 9.38 89.32 8C89.32 6.62 90.33 5.65 91.51 5.65C92.69 5.65 93.7 6.6 93.7 8C93.7 9.4 92.69 10.35 91.51 10.35Z",
      fill: n.color || "#FBBC05"
    }, null, 8, tC),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.85 0.160004H106.52V11.87H104.85V0.160004Z",
      fill: n.color || "#34A853"
    }, null, 8, nC),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.69 10.35C110.82 10.35 110.21 9.95 109.81 9.18L114.99 7.04L114.81 6.6C114.49 5.73 113.5 4.14 111.5 4.14C109.5 4.14 107.85 5.71 107.85 8.01C107.85 10.18 109.49 11.88 111.69 11.88C113.46 11.88 114.49 10.79 114.92 10.16L113.6 9.28C113.16 9.93 112.56 10.35 111.69 10.35V10.35ZM111.56 5.58C112.25 5.58 112.83 5.93 113.03 6.43L109.53 7.88C109.53 6.25 110.68 5.58 111.56 5.58Z",
      fill: n.color || "#EB4335"
    }, null, 8, oC),
    d("path", {
      d: "M5.36 8.77C5.36 9.73 5.14 10.51 4.7 11.1C4.26 11.69 3.66 11.98 2.91 11.98C2.16 11.98 1.53 11.74 1.09 11.25V14.3H0V5.53H0.99L1.04 6.23C1.48 5.68 2.09 5.41 2.88 5.41C3.67 5.41 4.24 5.7 4.69 6.27C5.14 6.84 5.36 7.64 5.36 8.67V8.77V8.77ZM4.28 8.65C4.28 7.94 4.13 7.37 3.82 6.96C3.51 6.55 3.1 6.34 2.57 6.34C1.91 6.34 1.42 6.63 1.09 7.21V10.24C1.41 10.82 1.91 11.11 2.58 11.11C3.1 11.11 3.51 10.9 3.82 10.49C4.13 10.08 4.28 9.47 4.28 8.65Z",
      fill: n.color || "black"
    }, null, 8, rC),
    d("path", {
      d: "M6.44995 8.64C6.44995 8.02 6.56995 7.46 6.81995 6.96C7.06995 6.46 7.39995 6.08 7.83995 5.81C8.27995 5.54 8.76995 5.41 9.32995 5.41C10.19 5.41 10.89 5.71 11.42 6.31C11.95 6.91 12.22 7.7 12.22 8.69V8.77C12.22 9.39 12.1 9.94 11.87 10.43C11.64 10.92 11.3 11.3 10.86 11.58C10.42 11.86 9.91995 11.99 9.34995 11.99C8.48995 11.99 7.78995 11.69 7.25995 11.09C6.72995 10.49 6.45995 9.7 6.45995 8.72V8.64H6.44995ZM7.53995 8.77C7.53995 9.47 7.69995 10.04 8.02995 10.46C8.35995 10.88 8.78995 11.1 9.33995 11.1C9.88995 11.1 10.33 10.88 10.65 10.45C10.97 10.02 11.14 9.41 11.14 8.64C11.14 7.94 10.97 7.38 10.64 6.95C10.31 6.52 9.86995 6.3 9.31995 6.3C8.76995 6.3 8.34995 6.51 8.02995 6.94C7.70995 7.37 7.53995 7.98 7.53995 8.77V8.77Z",
      fill: n.color || "black"
    }, null, 8, iC),
    d("path", {
      d: "M19.19 10.38L20.41 5.53H21.49L19.64 11.87H18.76L17.22 7.07L15.72 11.87H14.84L13 5.53H14.08L15.33 10.28L16.81 5.53H17.68L19.19 10.38V10.38Z",
      fill: n.color || "black"
    }, null, 8, sC),
    d("path", {
      d: "M25.2201 11.99C24.3601 11.99 23.6601 11.71 23.1201 11.14C22.5801 10.57 22.3101 9.82 22.3101 8.88V8.68C22.3101 8.05 22.4301 7.49 22.6701 7C22.9101 6.51 23.2501 6.12 23.6801 5.84C24.1101 5.56 24.5801 5.42 25.0801 5.42C25.9001 5.42 26.5401 5.69 27.0001 6.23C27.4601 6.77 27.6901 7.55 27.6901 8.56V9.01H23.4001C23.4201 9.63 23.6001 10.14 23.9501 10.52C24.3001 10.9 24.7401 11.1 25.2801 11.1C25.6601 11.1 25.9901 11.02 26.2501 10.87C26.5101 10.72 26.7501 10.51 26.9501 10.25L27.6101 10.77C27.0801 11.59 26.2801 11.99 25.2201 11.99V11.99ZM25.0901 6.31C24.6501 6.31 24.2901 6.47 23.9901 6.79C23.6901 7.11 23.5101 7.55 23.4401 8.13H26.6201V8.05C26.5901 7.5 26.4401 7.07 26.1701 6.77C25.9001 6.47 25.5501 6.32 25.0901 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, aC),
    d("path", {
      d: "M32.02 6.51C31.86 6.48 31.68 6.47 31.49 6.47C30.78 6.47 30.3 6.77 30.04 7.38V11.88H28.96V5.54H30.01L30.03 6.27C30.39 5.7 30.89 5.42 31.54 5.42C31.75 5.42 31.91 5.45 32.02 5.5V6.51Z",
      fill: n.color || "black"
    }, null, 8, lC),
    d("path", {
      d: "M35.64 11.99C34.78 11.99 34.08 11.71 33.54 11.14C33 10.57 32.73 9.82 32.73 8.88V8.68C32.73 8.05 32.85 7.49 33.09 7C33.33 6.51 33.67 6.12 34.1 5.84C34.53 5.56 35 5.42 35.5 5.42C36.32 5.42 36.96 5.69 37.42 6.23C37.88 6.77 38.11 7.55 38.11 8.56V9.01H33.82C33.84 9.63 34.02 10.14 34.37 10.52C34.72 10.9 35.16 11.1 35.7 11.1C36.08 11.1 36.41 11.02 36.67 10.87C36.93 10.72 37.17 10.51 37.37 10.25L38.03 10.77C37.5 11.59 36.7 11.99 35.64 11.99V11.99ZM35.51 6.31C35.07 6.31 34.71 6.47 34.41 6.79C34.11 7.11 33.93 7.55 33.86 8.13H37.04V8.05C37.01 7.5 36.86 7.07 36.59 6.77C36.32 6.47 35.97 6.32 35.51 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, dC),
    d("path", {
      d: "M39.11 8.64999C39.11 7.67999 39.34 6.9 39.8 6.3C40.26 5.7 40.86 5.41 41.61 5.41C42.36 5.41 42.94 5.66 43.37 6.17V2.87H44.45V11.87H43.45L43.4 11.19C42.97 11.72 42.36 11.99 41.59 11.99C40.82 11.99 40.26 11.69 39.79 11.09C39.32 10.49 39.1 9.69999 39.1 8.72999V8.64999H39.11ZM40.19 8.77C40.19 9.49 40.34 10.05 40.64 10.46C40.94 10.87 41.35 11.07 41.87 11.07C42.56 11.07 43.06 10.76 43.38 10.14V7.23C43.06 6.63 42.56 6.33 41.89 6.33C41.36 6.33 40.94 6.54 40.65 6.95C40.36 7.36 40.2 7.97 40.2 8.77H40.19Z",
      fill: n.color || "black"
    }, null, 8, uC),
    d("path", {
      d: "M54.47 8.77C54.47 9.74 54.25 10.52 53.8 11.1C53.35 11.68 52.76 11.98 52.01 11.98C51.21 11.98 50.59 11.7 50.15 11.13L50.1 11.86H49.1V2.87H50.18V6.23C50.62 5.69 51.22 5.42 51.99 5.42C52.76 5.42 53.36 5.71 53.8 6.29C54.24 6.87 54.46 7.67 54.46 8.68V8.77H54.47ZM53.39 8.64999C53.39 7.90999 53.25 7.34 52.96 6.94C52.67 6.54 52.26 6.34 51.73 6.34C51.02 6.34 50.5 6.67 50.19 7.34V10.08C50.52 10.74 51.04 11.08 51.74 11.08C52.26 11.08 52.66 10.88 52.95 10.48C53.24 10.08 53.38 9.47 53.38 8.66L53.39 8.64999Z",
      fill: n.color || "black"
    }, null, 8, cC),
    d("path", {
      d: "M57.91 10.29L59.39 5.53999H60.55L58 12.86C57.61 13.91 56.98 14.44 56.12 14.44L55.91 14.42L55.51 14.34V13.46L55.8 13.48C56.17 13.48 56.45 13.41 56.66 13.26C56.87 13.11 57.03 12.84 57.17 12.45L57.41 11.81L55.15 5.53999H56.33L57.91 10.29V10.29Z",
      fill: n.color || "black"
    }, null, 8, hC)
  ]);
}
const pC = /* @__PURE__ */ I(jy, [["render", mC]]), fC = {
  props: {
    color: {
      type: String,
      default: "#662E80"
    }
  }
}, gC = {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vC = ["stroke"];
function bC(e, t, n, o, i, r) {
  return l(), h("svg", gC, [
    d("path", {
      d: "M1 5.53089L4.75 8.95946L11 0.959457",
      stroke: n.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, vC)
  ]);
}
const yC = /* @__PURE__ */ I(fC, [["render", bC]]), CC = {
  name: "LanguageDropdown",
  components: {
    SelectedIcon: yC,
    PoweredByGoogle: pC
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "All Languages"
    },
    data: {
      type: Array,
      default: () => []
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    currentLanguage: {
      type: String,
      default: "en"
    },
    role: {
      type: String,
      default: ""
    },
    isVisible: Boolean
  },
  data() {
    return {
      bottomListReached: !1,
      focusedIndex: 0,
      inputValue: "",
      selectedLanguage: ""
    };
  },
  computed: {
    colors() {
      return {
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex || "#fff",
        "--lang-text-color": this.langTextColor || "#000",
        "--column-count": this.data.length < 5 ? 2 : 3,
        "--inner-shadow-height": this.data.length > 18 && !this.bottomListReached ? "35px" : "0px"
      };
    },
    googleLogoColor() {
      return this.colors["--lang-bg-color"] === "#fff" ? "" : ie(this.colors["--lang-bg-color"]).isLight() ? "#000" : "#fff";
    },
    langTextColor() {
      return this.styles.language_menu_text_color.hex || "#000";
    },
    filteredLanguages() {
      const e = this.inputValue.trim().toLowerCase();
      return e.length === 0 ? this.data : this.data.filter(
        ({ language: t, code: n }) => t.toLowerCase().includes(e) || n.toLowerCase().includes(e)
      );
    }
  },
  mounted() {
    this.selectedLanguage = this.currentLanguage;
  },
  methods: {
    listScroll(e) {
      const { scrollTop: t, offsetHeight: n, scrollHeight: o } = e.target, i = 10;
      this.bottomListReached = t + n + i >= o;
    },
    inputSearch() {
      var e;
      !this.inputValue.trim().length || !this.filteredLanguages.length || (this.selectedLanguage = (e = this.filteredLanguages[0]) == null ? void 0 : e.code, this.confirmLanguageSelection(this.selectedLanguage));
    },
    selectLanguage(e) {
      this.selectedLanguage = e, this.confirmLanguageSelection(this.selectedLanguage);
    },
    confirmLanguageSelection(e) {
      this.$emit("set-language", { code: e });
    },
    changeFocus(e, t = !1) {
      const n = this.focusedIndex + e;
      if (n < 0) {
        this.focusedIndex = 0, this.$refs["language-input"].focus();
        return;
      }
      if (n > this.filteredLanguages.length - 1) {
        this.focusedIndex = 0, this.$emit("close-dropdown");
        return;
      }
      this.focusedIndex = n, t || this.$refs["languages-list"].children[this.focusedIndex].focus();
    }
  }
}, _C = ["id", "role"], wC = { class: "header" }, TC = { class: "title" }, kC = { class: "body" }, EC = {
  ref: "languages-list",
  class: "languages-list"
}, SC = ["onClick", "onKeydown"], MC = { class: "language-text" }, $C = { class: "footer" };
function IC(e, t, n, o, i, r) {
  const a = S("selected-icon"), s = S("powered-by-google");
  return l(), _(ye, { name: "fade" }, {
    default: b(() => [
      n.isVisible ? (l(), h("div", {
        key: 0,
        id: n.id,
        style: H(r.colors),
        role: n.role,
        class: "dropdown-wrapper"
      }, [
        d("div", wC, [
          d("h1", TC, f(n.title), 1),
          me(d("input", {
            ref: "language-input",
            "onUpdate:modelValue": t[0] || (t[0] = (u) => i.inputValue = u),
            class: "search-input",
            type: "text",
            placeholder: "search languages...",
            onKeydown: [
              t[1] || (t[1] = N(D((...u) => r.inputSearch && r.inputSearch(...u), ["exact", "prevent"]), ["enter"])),
              t[2] || (t[2] = N(D((u) => e.$emit("close-dropdown"), ["shift", "exact"]), ["tab"]))
            ],
            onFocus: t[3] || (t[3] = (u) => i.focusedIndex = 0)
          }, null, 544), [
            [z0, i.inputValue]
          ])
        ]),
        d("div", kC, [
          d("div", {
            class: "languages-container",
            onScroll: t[8] || (t[8] = (...u) => r.listScroll && r.listScroll(...u))
          }, [
            d("ul", EC, [
              (l(!0), h(G, null, q(r.filteredLanguages, ({ language: u, code: c }) => (l(), h("li", {
                key: c,
                role: "menuitem",
                tabindex: "0",
                class: "language",
                onClick: (y) => r.selectLanguage(c),
                onKeydown: [
                  N(D((y) => r.selectLanguage(c), ["exact", "prevent"]), ["enter"]),
                  t[4] || (t[4] = N(D((y) => r.changeFocus(-1), ["exact", "prevent"]), ["up"])),
                  t[5] || (t[5] = N(D((y) => r.changeFocus(1), ["exact", "prevent"]), ["down"])),
                  t[6] || (t[6] = N(D((y) => r.changeFocus(-1), ["shift", "exact", "prevent"]), ["tab"])),
                  t[7] || (t[7] = N(D((y) => r.changeFocus(1, !0), ["exact"]), ["tab"]))
                ]
              }, [
                i.selectedLanguage === c ? (l(), _(a, {
                  key: 0,
                  color: r.langTextColor,
                  class: "selected-icon"
                }, null, 8, ["color"])) : g("", !0),
                d("div", MC, f(u), 1)
              ], 40, SC))), 128))
            ], 512)
          ], 32)
        ]),
        d("div", $C, [
          $(s, { color: r.googleLogoColor }, null, 8, ["color"])
        ])
      ], 12, _C)) : g("", !0)
    ]),
    _: 1
  });
}
const fi = /* @__PURE__ */ I(CC, [["render", IC], ["__scopeId", "data-v-e846b835"]]), AC = [
  [
    {
      type: "SchoolsMenuOrg",
      name: "School District",
      link: "#"
    },
    {
      type: "SchoolsMenuHeader",
      name: "High Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "No-Link High School"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Middle Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Intermediate",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Bohr Science Magnet",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Elementary Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Elementary School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Eastside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Southside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Burnside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Gibbs Magnet School",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      type: "SchoolsMenuImage",
      caption: "Girl walking up steps to school",
      display: "actual-size",
      alt_text: "Girl walking up steps to school",
      asset_id: 206,
      link_url: "",
      set_ratio: 1,
      cropped_width: {},
      cropped_height: {},
      action_on_click: "no_action",
      image_alignment: "center",
      preferred_width: null,
      preferred_height: null,
      caption_alignment: "center",
      open_link_in_new_tab: !1
    }
  ]
], tc = {
  menu: AC
}, Fe = {
  components: {
    HeaderDropdown: Fy,
    LanguageDropdown: fi
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    shouldShrink: Boolean,
    shouldBeSticky: Boolean,
    isMobile: Boolean,
    isHomepage: Boolean,
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["language-change", "toggle-search", "toggle-menu", "toggle-mobile-menu"],
  data() {
    return {
      customSchoolsMenuVisible: !1,
      schoolDropdownVisible: !1,
      exploreMenuVisible: !1,
      languageDropdownVisible: !1,
      containerHeight: "auto"
    };
  },
  computed: {
    isCustomSchoolsMenuVisible() {
      return this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible;
    },
    isSchoolDropdownVisible() {
      return !this.content.hasCustomSchoolsMenu && this.schoolDropdownVisible;
    },
    logoLink() {
      const e = this.content.pathPrefix ? this.content.pathPrefix : "/";
      return this.content.isIFrame ? "" : e;
    },
    shrinkCSSClass() {
      return this.shouldShrink && !this.content.isIFrame ? "shrink" : "";
    },
    logoCircleCSSClass() {
      return this.theme.logo_circle ? "logo-circle" : "";
    },
    menuV4Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4";
    },
    menuV5Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5";
    },
    menuV6Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M6";
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayLanguagesDropdown() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 1;
    },
    customSchoolsMenu() {
      var e, t;
      return this.content.isPreview || this.content.isIFrame ? tc : (t = (e = this.content.globals) == null ? void 0 : e.homepage) == null ? void 0 : t.schools_menu;
    },
    menuIdByType() {
      let e = null;
      return this.isSchoolDropdownVisible ? e = "schoolsmenu" : this.isCustomSchoolsMenuVisible && (e = "schools-menu-sm1"), e;
    },
    mobileHeaderBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : o.hex) || "#000";
    },
    hasLanguages() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 0;
    },
    signInColors() {
      var e, t, n, o;
      return {
        "--sign-in-border": (e = this.theme.sign_in_button_border) == null ? void 0 : e.hex,
        "--sign-in-color": (t = this.theme.sign_in_button_color) == null ? void 0 : t.hex,
        "--sign-in-bg": (n = this.theme.sign_in_button_bg) == null ? void 0 : n.hex,
        "--sign-in-bg-hover": `${(o = this.theme.sign_in_button_bg) == null ? void 0 : o.hex}CC`
      };
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    },
    hasExploreMenuContent() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.customMenuItems) == null ? void 0 : t.length) >= 1;
    },
    colors() {
      var e, t, n, o, i;
      return oe({
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": (t = (e = this.content.globals) == null ? void 0 : e.info) != null && t.customHeader ? "auto" : "100%",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#000000",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--menu-heading-line-color": (o = (n = this.theme) == null ? void 0 : n.menu_heading_line_color) == null ? void 0 : o.hex,
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF",
        searchIcon: (i = this.theme.search_icon_color) == null ? void 0 : i.hex,
        "--mobile-header-bg-color": this.mobileHeaderBgColor,
        "--mobile-menu-bg-color": this.mobileMenuBgColor,
        "--mobile-menu-text-color": this.mobileMenuTextColor,
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": this.content.globals.info.customHeader ? "auto" : "100%"
      }, this.signInColors);
    }
  },
  mounted() {
    typeof window != "undefined" && (this.resizeLogoContainer(), window.addEventListener("resize", this.resizeLogoContainer));
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.resizeLogoContainer);
  },
  methods: {
    resizeLogoContainer() {
      var e, t, n;
      (n = (t = (e = this.content) == null ? void 0 : e.globals) == null ? void 0 : t.info) != null && n.customHeader ? this.containerHeight = `${window.document.getElementsByClassName("logo")[0].offsetHeight + 15}px` : this.containerHeight = "auto";
    },
    setLanguage(e) {
      this.languageDropdownVisible = !1, this.$emit("language-change", e);
    },
    toggleSearch() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-search");
    },
    clickedMenu(e) {
      this.setDropdownVisibility(e);
    },
    setDropdownVisibility(e) {
      switch (e) {
        case "menubutton":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-menu", !this.content.showMenu);
          break;
        case "explore-button":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !this.exploreMenuVisible;
          break;
        case "schoolsbutton":
          this.exploreMenuVisible = !1, this.languageDropdownVisible = !1, this.content.hasCustomSchoolsMenu ? this.customSchoolsMenuVisible = !this.customSchoolsMenuVisible : this.schoolDropdownVisible = !this.schoolDropdownVisible;
          break;
        case "languagebutton":
          this.exploreMenuVisible = !1, this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !this.languageDropdownVisible;
          break;
        case "closebutton":
          this.$emit("toggle-menu", !1);
      }
    },
    closeAllMenus() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !1;
    }
  }
};
function LC(e) {
  return $u() ? (Iu(e), !0) : !1;
}
function Os(e) {
  return typeof e == "function" ? e() : Z0(e);
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const OC = (e) => e != null;
function NC(e) {
  var t;
  const n = Os(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var nc = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Kr = /* @__PURE__ */ nc.join(","), oc = typeof Element == "undefined", wn = oc ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Gr = !oc && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, zr = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), r = i === "" || i === "true", a = r || n && t && e(t.parentNode);
  return a;
}, HC = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, rc = function(t, n, o) {
  if (zr(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Kr));
  return n && wn.call(t, Kr) && i.unshift(t), i = i.filter(o), i;
}, ic = function e(t, n, o) {
  for (var i = [], r = Array.from(t); r.length; ) {
    var a = r.shift();
    if (!zr(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), u = s.length ? s : a.children, c = e(u, !0, o);
        o.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var y = wn.call(a, Kr);
        y && o.filter(a) && (n || !t.includes(a)) && i.push(a);
        var w = a.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(a), v = !zr(w, !1) && (!o.shadowRootFilter || o.shadowRootFilter(a));
        if (w && v) {
          var E = e(w === !0 ? a.children : w.children, !0, o);
          o.flatten ? i.push.apply(i, E) : i.push({
            scopeParent: a,
            candidates: E
          });
        } else
          r.unshift.apply(r, a.children);
      }
  }
  return i;
}, sc = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Cn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || HC(t)) && !sc(t) ? 0 : t.tabIndex;
}, PC = function(t, n) {
  var o = Cn(t);
  return o < 0 && n && !sc(t) ? 0 : o;
}, DC = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, ac = function(t) {
  return t.tagName === "INPUT";
}, RC = function(t) {
  return ac(t) && t.type === "hidden";
}, VC = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, BC = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, FC = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Gr(t), o = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var r = BC(i, t.form);
  return !r || r === t;
}, jC = function(t) {
  return ac(t) && t.type === "radio";
}, UC = function(t) {
  return jC(t) && !FC(t);
}, KC = function(t) {
  var n, o = t && Gr(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, r = !1;
  if (o && o !== t) {
    var a, s, u;
    for (r = !!((a = i) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (u = t.ownerDocument) !== null && u !== void 0 && u.contains(t)); !r && i; ) {
      var c, y, w;
      o = Gr(i), i = (c = o) === null || c === void 0 ? void 0 : c.host, r = !!((y = i) !== null && y !== void 0 && (w = y.ownerDocument) !== null && w !== void 0 && w.contains(i));
    }
  }
  return r;
}, Al = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, GC = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var r = wn.call(t, "details>summary:first-of-type"), a = r ? t.parentElement : t;
  if (wn.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var u = t.parentElement, c = Gr(t);
        if (u && !u.shadowRoot && i(u) === !0)
          return Al(t);
        t.assignedSlot ? t = t.assignedSlot : !u && c !== t.ownerDocument ? t = c.host : t = u;
      }
      t = s;
    }
    if (KC(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return Al(t);
  return !1;
}, zC = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return wn.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Zr = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  zr(n) || RC(n) || GC(n, t) || // For a details element with a summary, the summary element gets the focus
  VC(n) || zC(n));
}, Ns = function(t, n) {
  return !(UC(n) || Cn(n) < 0 || !Zr(t, n));
}, ZC = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, WC = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, r) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, u = PC(s, a), c = a ? e(i.candidates) : s;
    u === 0 ? a ? n.push.apply(n, c) : n.push(s) : o.push({
      documentOrder: r,
      tabIndex: u,
      item: i,
      isScope: a,
      content: c
    });
  }), o.sort(DC).reduce(function(i, r) {
    return r.isScope ? i.push.apply(i, r.content) : i.push(r.content), i;
  }, []).concat(n);
}, qC = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ic([t], n.includeContainer, {
    filter: Ns.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: ZC
  }) : o = rc(t, n.includeContainer, Ns.bind(null, n)), WC(o);
}, YC = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ic([t], n.includeContainer, {
    filter: Zr.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = rc(t, n.includeContainer, Zr.bind(null, n)), o;
}, Dn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return wn.call(t, Kr) === !1 ? !1 : Ns(n, t);
}, xC = /* @__PURE__ */ nc.concat("iframe").join(","), Wi = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return wn.call(t, xC) === !1 ? !1 : Zr(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Hs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function XC(e) {
  if (Array.isArray(e)) return Hs(e);
}
function QC(e, t, n) {
  return (t = o_(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function JC(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function e_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ll(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ol(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ll(Object(n), !0).forEach(function(o) {
      QC(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ll(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function t_(e) {
  return XC(e) || JC(e) || r_(e) || e_();
}
function n_(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function o_(e) {
  var t = n_(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function r_(e, t) {
  if (e) {
    if (typeof e == "string") return Hs(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Hs(e, t) : void 0;
  }
}
var Nl = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, i_ = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, s_ = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Vo = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, a_ = function(t) {
  return Vo(t) && !t.shiftKey;
}, l_ = function(t) {
  return Vo(t) && t.shiftKey;
}, Hl = function(t) {
  return setTimeout(t, 0);
}, Co = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, lr = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, d_ = [], lc = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || d_, r = Ol({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: a_,
    isKeyBackward: l_
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, u = function(P, V, Q) {
    return P && P[V] !== void 0 ? P[V] : r[Q || V];
  }, c = function(P, V) {
    var Q = typeof (V == null ? void 0 : V.composedPath) == "function" ? V.composedPath() : void 0;
    return a.containerGroups.findIndex(function(ee) {
      var se = ee.container, ce = ee.tabbableNodes;
      return se.contains(P) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (Q == null ? void 0 : Q.includes(se)) || ce.find(function(ue) {
        return ue === P;
      });
    });
  }, y = function(P) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Q = V.hasFallback, ee = Q === void 0 ? !1 : Q, se = V.params, ce = se === void 0 ? [] : se, ue = r[P];
    if (typeof ue == "function" && (ue = ue.apply(void 0, t_(ce))), ue === !0 && (ue = void 0), !ue) {
      if (ue === void 0 || ue === !1)
        return ue;
      throw new Error("`".concat(P, "` was specified but was not a node, or did not return a node"));
    }
    var ve = ue;
    if (typeof ue == "string") {
      try {
        ve = o.querySelector(ue);
      } catch ($e) {
        throw new Error("`".concat(P, '` appears to be an invalid selector; error="').concat($e.message, '"'));
      }
      if (!ve && !ee)
        throw new Error("`".concat(P, "` as selector refers to no known node"));
    }
    return ve;
  }, w = function() {
    var P = y("initialFocus", {
      hasFallback: !0
    });
    if (P === !1)
      return !1;
    if (P === void 0 || P && !Wi(P, r.tabbableOptions))
      if (c(o.activeElement) >= 0)
        P = o.activeElement;
      else {
        var V = a.tabbableGroups[0], Q = V && V.firstTabbableNode;
        P = Q || y("fallbackFocus");
      }
    else P === null && (P = y("fallbackFocus"));
    if (!P)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return P;
  }, v = function() {
    if (a.containerGroups = a.containers.map(function(P) {
      var V = qC(P, r.tabbableOptions), Q = YC(P, r.tabbableOptions), ee = V.length > 0 ? V[0] : void 0, se = V.length > 0 ? V[V.length - 1] : void 0, ce = Q.find(function($e) {
        return Dn($e);
      }), ue = Q.slice().reverse().find(function($e) {
        return Dn($e);
      }), ve = !!V.find(function($e) {
        return Cn($e) > 0;
      });
      return {
        container: P,
        tabbableNodes: V,
        focusableNodes: Q,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ve,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: ee,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: se,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: ce,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ue,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(et) {
          var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, zt = V.indexOf(et);
          return zt < 0 ? tt ? Q.slice(Q.indexOf(et) + 1).find(function(vo) {
            return Dn(vo);
          }) : Q.slice(0, Q.indexOf(et)).reverse().find(function(vo) {
            return Dn(vo);
          }) : V[zt + (tt ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(P) {
      return P.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !y("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(P) {
      return P.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, E = function(P) {
    var V = P.activeElement;
    if (V)
      return V.shadowRoot && V.shadowRoot.activeElement !== null ? E(V.shadowRoot) : V;
  }, F = function(P) {
    if (P !== !1 && P !== E(document)) {
      if (!P || !P.focus) {
        F(w());
        return;
      }
      P.focus({
        preventScroll: !!r.preventScroll
      }), a.mostRecentlyFocusedNode = P, i_(P) && P.select();
    }
  }, O = function(P) {
    var V = y("setReturnFocus", {
      params: [P]
    });
    return V || (V === !1 ? !1 : P);
  }, L = function(P) {
    var V = P.target, Q = P.event, ee = P.isBackward, se = ee === void 0 ? !1 : ee;
    V = V || lr(Q), v();
    var ce = null;
    if (a.tabbableGroups.length > 0) {
      var ue = c(V, Q), ve = ue >= 0 ? a.containerGroups[ue] : void 0;
      if (ue < 0)
        se ? ce = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : ce = a.tabbableGroups[0].firstTabbableNode;
      else if (se) {
        var $e = a.tabbableGroups.findIndex(function(ji) {
          var Ui = ji.firstTabbableNode;
          return V === Ui;
        });
        if ($e < 0 && (ve.container === V || Wi(V, r.tabbableOptions) && !Dn(V, r.tabbableOptions) && !ve.nextTabbableNode(V, !1)) && ($e = ue), $e >= 0) {
          var et = $e === 0 ? a.tabbableGroups.length - 1 : $e - 1, tt = a.tabbableGroups[et];
          ce = Cn(V) >= 0 ? tt.lastTabbableNode : tt.lastDomTabbableNode;
        } else Vo(Q) || (ce = ve.nextTabbableNode(V, !1));
      } else {
        var zt = a.tabbableGroups.findIndex(function(ji) {
          var Ui = ji.lastTabbableNode;
          return V === Ui;
        });
        if (zt < 0 && (ve.container === V || Wi(V, r.tabbableOptions) && !Dn(V, r.tabbableOptions) && !ve.nextTabbableNode(V)) && (zt = ue), zt >= 0) {
          var vo = zt === a.tabbableGroups.length - 1 ? 0 : zt + 1, Xa = a.tabbableGroups[vo];
          ce = Cn(V) >= 0 ? Xa.firstTabbableNode : Xa.firstDomTabbableNode;
        } else Vo(Q) || (ce = ve.nextTabbableNode(V));
      }
    } else
      ce = y("fallbackFocus");
    return ce;
  }, U = function(P) {
    var V = lr(P);
    if (!(c(V, P) >= 0)) {
      if (Co(r.clickOutsideDeactivates, P)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: r.returnFocusOnDeactivate
        });
        return;
      }
      Co(r.allowOutsideClick, P) || P.preventDefault();
    }
  }, z = function(P) {
    var V = lr(P), Q = c(V, P) >= 0;
    if (Q || V instanceof Document)
      Q && (a.mostRecentlyFocusedNode = V);
    else {
      P.stopImmediatePropagation();
      var ee, se = !0;
      if (a.mostRecentlyFocusedNode)
        if (Cn(a.mostRecentlyFocusedNode) > 0) {
          var ce = c(a.mostRecentlyFocusedNode), ue = a.containerGroups[ce].tabbableNodes;
          if (ue.length > 0) {
            var ve = ue.findIndex(function($e) {
              return $e === a.mostRecentlyFocusedNode;
            });
            ve >= 0 && (r.isKeyForward(a.recentNavEvent) ? ve + 1 < ue.length && (ee = ue[ve + 1], se = !1) : ve - 1 >= 0 && (ee = ue[ve - 1], se = !1));
          }
        } else
          a.containerGroups.some(function($e) {
            return $e.tabbableNodes.some(function(et) {
              return Cn(et) > 0;
            });
          }) || (se = !1);
      else
        se = !1;
      se && (ee = L({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: r.isKeyBackward(a.recentNavEvent)
      })), F(ee || a.mostRecentlyFocusedNode || w());
    }
    a.recentNavEvent = void 0;
  }, B = function(P) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = P;
    var Q = L({
      event: P,
      isBackward: V
    });
    Q && (Vo(P) && P.preventDefault(), F(Q));
  }, j = function(P) {
    (r.isKeyForward(P) || r.isKeyBackward(P)) && B(P, r.isKeyBackward(P));
  }, Y = function(P) {
    s_(P) && Co(r.escapeDeactivates, P) !== !1 && (P.preventDefault(), s.deactivate());
  }, K = function(P) {
    var V = lr(P);
    c(V, P) >= 0 || Co(r.clickOutsideDeactivates, P) || Co(r.allowOutsideClick, P) || (P.preventDefault(), P.stopImmediatePropagation());
  }, ne = function() {
    if (a.active)
      return Nl.activateTrap(i, s), a.delayInitialFocusTimer = r.delayInitialFocus ? Hl(function() {
        F(w());
      }) : F(w()), o.addEventListener("focusin", z, !0), o.addEventListener("mousedown", U, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", U, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", K, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", j, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", Y), s;
  }, te = function() {
    if (a.active)
      return o.removeEventListener("focusin", z, !0), o.removeEventListener("mousedown", U, !0), o.removeEventListener("touchstart", U, !0), o.removeEventListener("click", K, !0), o.removeEventListener("keydown", j, !0), o.removeEventListener("keydown", Y), s;
  }, le = function(P) {
    var V = P.some(function(Q) {
      var ee = Array.from(Q.removedNodes);
      return ee.some(function(se) {
        return se === a.mostRecentlyFocusedNode;
      });
    });
    V && F(w());
  }, Re = typeof window != "undefined" && "MutationObserver" in window ? new MutationObserver(le) : void 0, mt = function() {
    Re && (Re.disconnect(), a.active && !a.paused && a.containers.map(function(P) {
      Re.observe(P, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(P) {
      if (a.active)
        return this;
      var V = u(P, "onActivate"), Q = u(P, "onPostActivate"), ee = u(P, "checkCanFocusTrap");
      ee || v(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = o.activeElement, V == null || V();
      var se = function() {
        ee && v(), ne(), mt(), Q == null || Q();
      };
      return ee ? (ee(a.containers.concat()).then(se, se), this) : (se(), this);
    },
    deactivate: function(P) {
      if (!a.active)
        return this;
      var V = Ol({
        onDeactivate: r.onDeactivate,
        onPostDeactivate: r.onPostDeactivate,
        checkCanReturnFocus: r.checkCanReturnFocus
      }, P);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, te(), a.active = !1, a.paused = !1, mt(), Nl.deactivateTrap(i, s);
      var Q = u(V, "onDeactivate"), ee = u(V, "onPostDeactivate"), se = u(V, "checkCanReturnFocus"), ce = u(V, "returnFocus", "returnFocusOnDeactivate");
      Q == null || Q();
      var ue = function() {
        Hl(function() {
          ce && F(O(a.nodeFocusedBeforeActivation)), ee == null || ee();
        });
      };
      return ce && se ? (se(O(a.nodeFocusedBeforeActivation)).then(ue, ue), this) : (ue(), this);
    },
    pause: function(P) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, P)) : this;
    },
    unpause: function(P) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, P)) : this;
    },
    updateContainerElements: function(P) {
      var V = [].concat(P).filter(Boolean);
      return a.containers = V.map(function(Q) {
        return typeof Q == "string" ? o.querySelector(Q) : Q;
      }), a.active && v(), mt(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(P, V) {
        if (a.paused === P)
          return this;
        if (a.paused = P, P) {
          var Q = u(V, "onPause"), ee = u(V, "onPostPause");
          Q == null || Q(), te(), mt(), ee == null || ee();
        } else {
          var se = u(V, "onUnpause"), ce = u(V, "onPostUnpause");
          se == null || se(), v(), ne(), mt(), ce == null || ce();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function da(e, t = {}) {
  let n;
  const v = t, { immediate: o } = v, i = Ki(v, ["immediate"]), r = tn(!1), a = tn(!1), s = (E) => n && n.activate(E), u = (E) => n && n.deactivate(E), c = () => {
    n && (n.pause(), a.value = !0);
  }, y = () => {
    n && (n.unpause(), a.value = !1);
  }, w = xo(() => {
    const E = Os(e);
    return (Array.isArray(E) ? E : [E]).map((F) => {
      const O = Os(F);
      return typeof O == "string" ? O : NC(O);
    }).filter(OC);
  });
  return ri(
    w,
    (E) => {
      E.length && (n = lc(E, de(oe({}, i), {
        onActivate() {
          r.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          r.value = !1, t.onDeactivate && t.onDeactivate();
        }
      })), o && s());
    },
    { flush: "post" }
  ), LC(() => u()), {
    hasFocus: r,
    isPaused: a,
    activate: s,
    deactivate: u,
    pause: c,
    unpause: y
  };
}
const u_ = {
  name: "MenuElement",
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    toggleFn: {
      type: Function,
      default: () => {
      }
    },
    isParent: {
      type: Boolean,
      default: !1
    },
    isSubParent: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: null
    },
    cursorPointer: {
      type: Boolean,
      default: !1
    }
  }
}, c_ = ["href"], h_ = {
  class: "link-content",
  tabindex: "-1"
}, m_ = ["href"], p_ = {
  class: "link-content",
  tabindex: "-1"
}, f_ = ["href", "target"], g_ = {
  class: "link-content",
  tabindex: "-1"
}, v_ = ["href", "target"], b_ = {
  class: "link-content",
  tabindex: "-1"
};
function y_(e, t, n, o, i, r) {
  return l(), h("span", {
    class: "menu-element",
    style: H(n.theme),
    onClick: t[5] || (t[5] = (a) => n.toggleFn(n.element.id, n.isParent))
  }, [
    n.element.type === "page" ? (l(), h("a", {
      key: 0,
      href: `${n.pathPrefix}/page/${n.element.slug}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[0] || (t[0] = D(() => {
      }, ["stop"])),
      onKeydown: t[1] || (t[1] = N(D(() => {
      }, ["stop"]), ["enter"]))
    }, [
      d("span", h_, f(n.element.name), 1)
    ], 40, c_)) : n.element.mailto ? (l(), h("a", {
      key: 1,
      href: `mailto:${n.element.email_address}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" }
    }, [
      d("span", p_, f(n.element.name), 1)
    ], 8, m_)) : n.element.type === "link" && n.element.ipAddress ? (l(), h("a", {
      key: 2,
      href: `http://${n.element.url}`,
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[2] || (t[2] = D(() => {
      }, ["stop"]))
    }, [
      d("span", g_, f(n.element.name), 1)
    ], 8, f_)) : n.element.type === "link" && !n.element.ipAddress ? (l(), h("a", {
      key: 3,
      href: n.element.url,
      class: "link",
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[3] || (t[3] = D(() => {
      }, ["stop"])),
      onKeydown: t[4] || (t[4] = N(D(() => {
      }, ["stop"]), ["enter"]))
    }, [
      d("span", b_, f(n.element.name), 1)
    ], 40, v_)) : (l(), h("span", {
      key: 4,
      style: H({
        color: "inherit",
        "text-decoration": "none",
        cursor: n.isSubParent || n.cursorPointer ? "pointer" : "initial"
      })
    }, f(n.element.name), 5))
  ], 4);
}
const C_ = /* @__PURE__ */ I(u_, [["render", y_], ["__scopeId", "data-v-90cb0a6b"]]), gi = {
  components: {
    MenuElement: C_
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean
  },
  data() {
    return {
      activeIds: []
    };
  },
  computed: {
    menuIconStyle() {
      return {
        "--icon-color": this.theme.icon_color.hex
      };
    },
    translations() {
      return this.theme.translations;
    }
  },
  methods: {
    getLink(e) {
      return e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    toggleOpen(e, t) {
      const n = this.activeIds.indexOf(e);
      n > -1 ? this.activeIds.splice(n, 1) : (t && (this.activeIds = []), this.activeIds.length > 1 && this.activeIds.splice(1, 1), this.activeIds.push(e));
    },
    clickStaticLink(e) {
      this.$route.fullPath !== e && this.$router.push({ path: `${e}` });
    },
    clickGeneratedLink(e, t) {
      e.type === "page" && this.$route.fullPath !== `/page/${e.slug}` ? this.$router.push({ path: `/page/${e.slug}` }) : e.type === "link" ? document.getElementById(`${e.slug || e.id}-${e.type}`).getElementsByTagName("a")[0].click() : e.children.length && this.toggleOpen(e.id, t);
    },
    getUrl(e) {
      return !e || e.type === "header" ? "" : e.type === "page" ? `${this.content.pathPrefix}/page/${e.slug}` : e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url;
    },
    closeMenu() {
      this.$emit("close-menu");
    }
  }
}, dc = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    currentDomain: {
      type: String,
      default: null
    },
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    Close: Qo
  },
  mixins: [Ze],
  emits: ["close-menu", "toggle-search"],
  data() {
    return {
      displayMoreButton: !0,
      isMoreDropdownVisible: !1,
      isTemporarilyHideMenu: !1,
      visibleItems: [],
      underLappedItems: [],
      activeItem: null,
      parentWidth: 0,
      totalElementsWidth: 0,
      timer: null,
      moreMenuTimeout: null,
      hideMenuTimeOut: null,
      menuTimeout: null,
      debounceParentWidth: () => {
      },
      openMoreMenuDropDown: null,
      loadingMenu: !0,
      preventMouseLeaveClose: !1
    };
  },
  computed: {
    colors() {
      var e;
      return {
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#333",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--nav-icon-bg-color": this.theme.navigation_icon_bg_color ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : "#014990",
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF"
      };
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    barNavOptions() {
      return de(oe(oe({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations
      });
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    }
  },
  watch: {
    parentWidth() {
      this.displayMoreButton = !0, this.debounceParentWidth.flush(), this.$nextTick(this.calculateUnderlappedItems.bind(this));
    },
    isMoreDropdownVisible() {
      this.isMoreDropdownVisible && this.handleDrawerToggle();
    }
  },
  mounted() {
    this.loadingMenu = !1;
    let e = 0;
    if (this.isMobile) return;
    const t = this.$refs["bar-nav-item-wrapper"];
    Object.entries(t.childNodes).forEach((n) => {
      var o;
      if (this.theme.version === "M5") {
        const r = Array.from(n[1].childNodes).find((a) => a.className === "bar-menu-item");
        r && (e += r.clientWidth);
      } else ((o = n[1]) == null ? void 0 : o.className) === "m4--menu-item" && (e += n[1].clientWidth);
    }), this.totalElementsWidth = e, this.updateParentWidth(), this.debounceParentWidth = zo(this.updateParentWidth.bind(this), 30), window.addEventListener("resize", this.debounceParentWidth), window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceParentWidth), window.removeEventListener("keydown", this.onKeydown);
  },
  created() {
    this.visibleItems = this.content.sitemapMenuItems;
  },
  methods: {
    canTriggerCloseFirstItem(e, t, n) {
      const o = (r) => n === "exploreButton" || n === "schoolsButton" || r.type !== "header" && r.children.length === 0 || r.type !== "header" && r.children.length > 0 && !t || r.type === "header" && t && r.children.length > 0, i = this.activeItem.children.findIndex(o);
      if (i !== -1) {
        const r = this.activeItem.children[i];
        return e === r.id;
      }
      return !1;
    },
    canTriggerCloseLastItem(e, t, n) {
      const o = (c) => n === "exploreButton" || n === "schoolsButton" || c.type !== "header" && c.children.length === 0 || !!c.children.length, i = this.activeItem.children.findLastIndex(o), r = this.activeItem.children[i];
      if (n === "exploreButton" || n === "schoolsButton")
        return e === r.id;
      const a = e === r.id && !r.children.length, s = e === r.id && t && !r.childrenVisible, u = e === r.id && t && (r.children.length === 0 || r.children.findLastIndex(o) === -1);
      if (a || s || u)
        return e === r.id;
      if (r.childrenVisible && r.children.findLastIndex(o) !== -1) {
        const c = r.children.findLastIndex(o), y = r.children[c].id;
        return e == y;
      }
    },
    toggleParentCollapsible({ itemId: e }) {
      const t = this.activeItem.children.findIndex((o) => o.id === e);
      this.activeItem.children.filter((o) => o.id !== e).forEach(
        (o) => this.activeItem.children[this.activeItem.children.indexOf(o)].childrenVisible = !1
      ), this.activeItem.children[t].childrenVisible = !this.activeItem.children[t].childrenVisible;
    },
    nextTabAction({ itemId: e, isIconButton: t, isBackwardsTab: n }, o) {
      const i = this.canTriggerCloseFirstItem(e, t, o), r = this.canTriggerCloseLastItem(e, t, o);
      if (i && n) {
        this.handleClose();
        return;
      }
      if (r && !n) {
        this.handleClose();
        return;
      }
    },
    onKeydown(e) {
      e.key === "Escape" && !Ut(this.activeItem) && this.handleClose();
    },
    temporalHide() {
      this.isMoreDropdownVisible = !1, this.isTemporarilyHideMenu = !0;
    },
    handleDropdownMenuOpen(e) {
      clearTimeout(this.openMoreMenuDropDown), this.openMoreMenuDropDown = setTimeout(() => {
        this.onMenuItemClick(e);
      }, 300);
    },
    preventClose(e) {
      this.preventMouseLeaveClose = !1, clearTimeout(this.moreMenuTimeout), clearTimeout(this.menuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.openMoreMenuDropDown), this.onMenuItemClick(e, !0);
    },
    preventCloseDrawer() {
      this.preventMouseLeaveClose = !0;
    },
    onMenuItemClick(e, t) {
      if (t && this.hideMoreMenu(), !e) {
        this.hideDrawer();
        return;
      }
      this.$emit("close-menu"), this.activeItem = e;
    },
    focusSubMenu(e) {
      this.activeItem = e;
      const n = this.$refs[`drawer-${e.id}`][0].$refs["drawer-wrapper"];
      n.tabIndex = 0, n.focus(), this.hideMoreMenu();
    },
    handleDrawerToggle(e) {
      if (e) {
        if (e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible === !1 ? this.showItem(e) : this.customSchoolsMenuVisible = !1, !this.activeItem) {
          this.hideDrawer(), this.activeItem = e;
          return;
        }
        if (!e || !e.children || !e.children.length) {
          this.hideDrawer();
          return;
        }
        e.id === this.activeItem.id ? this.hideDrawer() : this.activeItem = e;
      }
    },
    handleMoreMenuToggle(e) {
      clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.menuTimeout), this.moreMenuTimeout = setTimeout(() => {
        this.$emit("close-menu"), e ? this.isMoreDropdownVisible = e : this.isMoreDropdownVisible = !this.isMoreDropdownVisible;
      }, 220);
    },
    handleClose(e) {
      this.hideDrawer(e), this.hideMoreMenu();
    },
    hideMoreMenu() {
      this.isMoreDropdownVisible = !1;
    },
    showDrawer(e) {
      var t, n, o;
      return ((t = this.activeItem) == null ? void 0 : t.id) === e.id && ((o = (n = this.activeItem) == null ? void 0 : n.children) == null ? void 0 : o.length) > 0;
    },
    hideDrawer(e) {
      (!this.preventMouseLeaveClose || e !== "mouseleave") && (this.activeItem = null);
    },
    updateParentWidth() {
      this.parentWidth = this.getWrapperWidth();
    },
    getWrapperWidth() {
      const e = this.theme.version === "M5" ? this.$refs["bar-nav-menu-bar"] : this.$refs["m4-menu--bar"], t = window.getComputedStyle(e, null).getPropertyValue("padding-left"), n = window.getComputedStyle(e, null).getPropertyValue("padding-right");
      return e.clientWidth - parseInt(t, 10) - parseInt(n, 10);
    },
    calculateUnderlappedItems() {
      var i;
      let e = 0;
      const t = {}, n = this.$refs["bar-nav-item-wrapper"];
      let o = this.getWrapperWidth();
      if (this.theme.version === "M5") {
        this.$refs["bar-end-options"];
        const r = ((i = this.$refs["bar-end-options"]) == null ? void 0 : i.clientWidth) || 0;
        o -= r;
      }
      this.visibleItems = this.content.sitemapMenuItems, clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.totalElementsWidth > o ? (this.displayMoreButton = !0, o -= this.moreBtnWidth) : this.displayMoreButton = !1, Object.entries(n.childNodes).forEach((s) => {
          if (this.theme.version === "M5") {
            const c = Array.from(s[1].childNodes).find((y) => y.className === "bar-menu-item");
            c && (e += c.clientWidth, e > o && (t[c.id] = c));
          } else s[1].className === "m4--menu-item" && (e += s[1].clientWidth, e > o && (t[s[1].id] = s[1]));
        });
        const r = Object.entries(t).map(([s, u]) => this.content.sitemapMenuItems.find((c) => +c.id == +s)).sort((s, u) => s.position - u.position), a = this.content.sitemapMenuItems.filter((s) => !r.find((u) => s && u && s.id === u.id)).sort((s, u) => s.position - u.position);
        this.underLappedItems = r, this.visibleItems = a;
      }, 50);
    },
    navigate(e) {
      let t;
      if (!e)
        return null;
      switch (e.type) {
        case "page":
          t = `${this.content.pathPrefix}/page/${e.slug}`;
          break;
        case "link":
          e.mailto && e.email_address ? t = `mailto:${e.email_address}` : t = e.url;
          break;
        case "explore":
          t = this.content.pathPrefix + e.slug;
          break;
        default:
          return null;
      }
      return e.opens_in_new_tab ? window.open(t) : window.location.href = t, null;
    },
    showItem(e) {
      this.customSchoolsMenuVisible = !1, e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !0), clearTimeout(this.menuTimeout), this.menuTimeout = setTimeout(() => {
        this.onMenuItemClick(e, !0);
      }, 220);
    },
    mouseLeaveMenu() {
      clearTimeout(this.menuTimeout), clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), this.hideMenuTimeOut = setTimeout(() => {
        this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !1), this.handleClose("mouseleave");
      }, 600);
    },
    mouseEnterMenu() {
      this.hideMenuTimeOut && clearTimeout(this.hideMenuTimeOut);
    }
  }
}, __ = {
  name: "MenuItemType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, w_ = { class: "m4--menu-item-focusable" }, T_ = ["innerHTML"], k_ = ["href", "target"], E_ = { key: 0 };
function S_(e, t, n, o, i, r) {
  return l(), h("span", w_, [
    r.iconVisible ? (l(), h("div", {
      key: 0,
      class: p(["item-icon", { "global-icon": n.item.cms_icon_id }]),
      style: H(r.colors),
      innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
    }, null, 14, T_)) : r.href ? (l(), h("a", {
      key: 1,
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link"
    }, f(n.item.name), 9, k_)) : (l(), h(G, { key: 2 }, [
      n.moreMenuTitle ? (l(), h("span", E_, f(n.moreMenuTitle), 1)) : (l(), h("span", {
        key: 1,
        class: p(["item-type-header", { "no-children": r.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, f(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const uc = /* @__PURE__ */ I(__, [["render", S_], ["__scopeId", "data-v-09de12df"]]), M_ = {
  name: "M4MainItem",
  components: { MenuItemType: uc, DropdownArrowIcon: io },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    forceShow: Boolean,
    moreMenuItem: {
      type: String,
      default: null
    },
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    themeStyle: {
      type: String,
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-more-menu", "close", "toggle-drawer", "navigate", "mouseover", "focus-sub-menu"],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      if (this.colors)
        return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    hasFocusableChildren() {
      var t, n, o;
      const e = (i) => {
        var r;
        return [i, ...((r = i.children) == null ? void 0 : r.map((a) => e(a))) || []].flat();
      };
      return (o = (n = (t = this.item.children) == null ? void 0 : t.map((i) => e(i))) == null ? void 0 : n.flat()) == null ? void 0 : o.filter((i) => i.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    },
    ariaLabel() {
      if (!this.isHeader && this.hasChildren)
        return `Toggle ${this.item.name} Submenu`;
    },
    showTransition() {
      var e, t;
      return ((t = (e = this.item) == null ? void 0 : e.children) == null ? void 0 : t.length) > 0 && !this.isMoreMenuItem && !this.moreMenuItem && this.isActive;
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem) {
        this.$emit("toggle-more-menu", !this.moreMenuVisible);
        return;
      }
      if (!this.item) {
        this.$emit("close");
        return;
      }
      if (this.isHeader || e === !0) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    /**  handling this behavior here because M4MainItem is shared.
     M4MainItem is found in the top level of the Menu Items in the bar
     and within the More Dropdown**/
    handleNextTab(e, t) {
      var s, u;
      const n = e.shiftKey, o = this.isActive, i = this.activeId && o, r = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((u = this.item) == null ? void 0 : u.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && r && !t) {
          this.$emit("close");
          return;
        }
        if (!this.isMoreMenuItem && o) {
          this.$emit("close");
          return;
        }
        if (a && t && this.hasChildren && i) {
          this.$emit("close");
          return;
        }
      } else {
        if (i && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        if (this.moreMenuItem === "More") return;
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && o && this.$emit("close"), a && (!this.hasChildren || t && this.hasChildren && !i) && this.$emit("close");
      }
    }
  }
}, $_ = ["id"], I_ = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-label"], A_ = ["id"], L_ = ["aria-expanded", "aria-label", "aria-haspopup", "aria-controls"], O_ = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, N_ = { class: "sr-only" }, H_ = { class: "sr-only" }, P_ = {
  key: 0,
  class: "m4--menu-item-active-line"
};
function D_(e, t, n, o, i, r) {
  const a = S("MenuItemType"), s = S("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.item ? (l(), h("div", {
    key: 0,
    id: r.itemId,
    ref: r.itemId,
    class: p(["m4--menu-item", {
      "m4--menu-dropdown-item": n.isMoreMenuItem,
      "m4--menu-item-active": !n.isMoreMenuItem && r.isActive
    }]),
    onMouseover: t[13] || (t[13] = D((u) => e.$emit("mouseover", n.item), ["stop", "prevent"])),
    onClick: t[14] || (t[14] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"])),
    onTouchstart: t[15] || (t[15] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"]))
  }, [
    n.item && n.item.type === "header" && r.hasChildren || n.moreMenuItem === "More" ? (l(), h("button", {
      key: 0,
      id: r.ariaId,
      "aria-controls": r.ariaControls,
      "aria-expanded": r.ariaExpanded,
      "aria-haspopup": r.ariaHasPopup,
      class: p(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": r.isActive,
        [n.themeStyle]: !!n.themeStyle
      }]),
      "aria-label": n.moreMenuItem === "More" ? "Show submenu for More" : `Show submenu for ${n.item && n.item.name}`,
      onKeydown: [
        t[0] || (t[0] = N(D((u) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
        t[1] || (t[1] = N((u) => r.handleNextTab(u, !0), ["tab"]))
      ],
      onTouchstart: t[2] || (t[2] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"]))
    }, [
      $(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 42, I_)) : (l(), h("div", {
      key: 1,
      id: r.ariaId,
      class: p(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": r.isActive,
        [n.themeStyle]: !!n.themeStyle
      }])
    }, [
      $(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item,
        onKeydown: t[3] || (t[3] = N((u) => r.handleNextTab(u), ["tab"]))
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 10, A_)),
    r.isHeader ? g("", !0) : (l(), h(G, { key: 2 }, [
      r.hasChildren ? (l(), h("button", {
        key: 0,
        class: "m4--menu-item-icon",
        "aria-expanded": r.ariaExpanded,
        "aria-label": r.ariaLabel,
        "aria-haspopup": r.ariaHasPopup,
        "aria-controls": r.ariaControls,
        onKeydown: [
          t[4] || (t[4] = N(D((u) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
          t[5] || (t[5] = N((u) => r.handleNextTab(u, !0), ["tab"]))
        ],
        onTouchstart: t[6] || (t[6] = D((u) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
        onClick: t[7] || (t[7] = D((u) => r.handleEnterEvent(!0), ["stop", "prevent"]))
      }, [
        d("span", O_, [
          $(s, {
            "dropdown-class": r.iconClass,
            "fill-color": r.iconColor
          }, null, 8, ["dropdown-class", "fill-color"]),
          d("span", N_, " Show submenu for " + f(n.item && n.item.name), 1)
        ])
      ], 40, L_)) : g("", !0)
    ], 64)),
    r.isHeader || n.moreMenuItem ? (l(), h(G, { key: 3 }, [
      n.moreMenuItem || r.hasChildren ? (l(), h("span", {
        key: 0,
        class: "m4--menu-item-icon",
        onMouseover: t[8] || (t[8] = D(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[9] || (t[9] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"])),
        onKeydown: [
          t[10] || (t[10] = N((u) => r.handleNextTab(u, !0), ["tab"])),
          t[12] || (t[12] = N(D((u) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"]))
        ],
        onClick: t[11] || (t[11] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"]))
      }, [
        $(s, {
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        d("span", H_, " Show submenu for " + f(n.item && n.item.name), 1)
      ], 32)) : g("", !0)
    ], 64)) : g("", !0),
    $(ye, { name: "slide-fade-up" }, {
      default: b(() => [
        r.showTransition ? (l(), h("hr", P_)) : g("", !0)
      ]),
      _: 1
    })
  ], 42, $_)) : g("", !0);
}
const cc = /* @__PURE__ */ I(M_, [["render", D_], ["__scopeId", "data-v-9e969614"]]), R_ = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, V_ = ["fill"];
function B_(e, t, n, o, i, r) {
  return l(), h("svg", {
    class: "plus",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.85721 0H7.14293V7.14283H0V7.85714H7.14293V15H7.85721V7.85714H15V7.14283H7.85721V0Z"
    }, null, -1)
  ]), 8, V_);
}
const hc = /* @__PURE__ */ I(R_, [["render", B_]]), F_ = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, j_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, U_ = ["fill"];
function K_(e, t, n, o, i, r) {
  return l(), h("svg", j_, [
    d("path", {
      fill: n.fillColor,
      d: "M2 7.5V8.5H14V7.5H2Z"
    }, null, 8, U_)
  ]);
}
const mc = /* @__PURE__ */ I(F_, [["render", K_]]), G_ = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, z_ = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, Z_ = ["src", "alt"];
function W_(e, t, n, o, i, r) {
  return l(), h("span", z_, [
    (l(), _(R(r.href ? "a" : "div"), {
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link",
      tabindex: "-1"
    }, {
      default: b(() => [
        d("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, Z_)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const q_ = /* @__PURE__ */ I(G_, [["render", W_], ["__scopeId", "data-v-a0cf2cf9"]]), Y_ = {
  name: "M4DrawerElement",
  components: { MenuItemType: uc, ImageElement: q_, MenuPlusIcon: hc, MenuMinusIcon: mc, DropdownArrowIcon: io },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["navigate", "toggle-child", "toggle-parent", "next-tab"],
  computed: {
    iconColor() {
      if (this.colors)
        return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, x_ = ["id"], X_ = ["id"], Q_ = ["aria-expanded", "aria-controls", "aria-haspopup"], J_ = {
  class: "m4--drawer-element-focusable",
  tabindex: "-1"
}, ew = {
  key: 3,
  class: "sr-only"
}, tw = ["id", "aria-labelledby"];
function nw(e, t, n, o, i, r) {
  const a = S("ImageElement"), s = S("MenuItemType"), u = S("MenuPlusIcon"), c = S("MenuMinusIcon"), y = S("DropdownArrowIcon"), w = S("M4DrawerElement", !0);
  return l(), h("div", {
    role: "menuitem",
    class: p(["m4--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": r.isChild,
      "has-children": r.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": r.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: H(n.colors)
  }, [
    d("div", {
      id: n.elemData.id,
      class: "m4--drawer-element-title",
      onClick: t[4] || (t[4] = (...v) => r.toggleParentCollapsible && r.toggleParentCollapsible(...v))
    }, [
      d("div", {
        id: r.ariaParentId,
        class: p(["m4--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = D(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (l(), _(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (l(), _(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": r.iconColor,
          onHandleHeaderClick: r.toggleParentCollapsible,
          onKeydown: [
            t[0] || (t[0] = N((v) => r.handleNextTab(n.elemData.id, !1, v.shiftKey), ["tab"])),
            N(r.handleEnterEvent, ["enter"])
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "onHandleHeaderClick", "onKeydown"]))
      ], 10, X_),
      n.elemData.children.length ? (l(), h(G, { key: 0 }, [
        n.elemData.children.length ? (l(), h("button", {
          key: 0,
          "aria-expanded": r.ariaExpanded,
          "aria-controls": r.ariaControls,
          "aria-haspopup": r.ariaHasPopup,
          class: "m4--drawer-element-title-icon",
          onClick: t[2] || (t[2] = D((...v) => r.toggleParentCollapsible && r.toggleParentCollapsible(...v), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = N((v) => r.handleNextTab(n.elemData.id, !0, v.shiftKey), ["tab"]))
        }, [
          d("span", J_, [
            n.isMobile && !r.showChildren ? (l(), _(u, {
              key: 0,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && r.showChildren ? (l(), _(c, {
              key: 1,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : g("", !0),
            n.isMobile ? g("", !0) : (l(), _(y, {
              key: 2,
              "fill-color": r.iconColor,
              "dropdown-class": r.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData && n.elemData.name ? (l(), h("span", ew, " Show submenu for " + f(n.elemData.name), 1)) : g("", !0)
          ])
        ], 40, Q_)) : g("", !0)
      ], 64)) : g("", !0)
    ], 8, x_),
    $(ye, { name: "collapse-in" }, {
      default: b(() => [
        r.hasChildren ? me((l(), h("div", {
          key: 0,
          id: r.ariaChildId,
          "aria-labelledby": r.ariaParentId,
          class: p(["m4--drawer-children", { "show-children": r.showChildren }])
        }, [
          (l(!0), h(G, null, q(n.elemData.children, (v) => (l(), _(w, {
            key: v.id,
            "elem-data": v,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[5] || (t[5] = (E) => e.$emit("toggle-child", E)),
            onNextTab: (E) => r.handleNextTab(v.id, !1, E.isBackwardsTab),
            onNavigate: t[6] || (t[6] = (E) => e.$emit("navigate", E))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level", "onNextTab"]))), 128))
        ], 10, tw)), [
          [Ft, r.showChildren]
        ]) : g("", !0)
      ]),
      _: 1
    })
  ], 6);
}
const pc = /* @__PURE__ */ I(Y_, [["render", nw], ["__scopeId", "data-v-b75a0925"]]), ow = {
  name: "M4MobileMenu",
  components: { M4DrawerElement: pc },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: void 0
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["navigate", "close-menu"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      localItems: []
    };
  },
  computed: {
    styles() {
      return oe({}, this.colors);
    }
  },
  beforeUpdate() {
    this.isVisible || (this.activeParent = null, this.activeChild = null);
  },
  mounted() {
    this.localItems = this.menuItems.filter((e) => e.name === "Explore" ? e.children && e.children.length >= 1 : !0), this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.addEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.addEventListener("focus", this.$emit("close-menu"));
  },
  beforeUnmount() {
    this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.removeEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.removeEventListener("focus", this.$emit("close-menu"));
  },
  methods: {
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    },
    handleNavigate(e) {
      this.$emit("navigate", e);
    }
  }
};
function rw(e, t, n, o, i, r) {
  const a = S("M4DrawerElement");
  return l(), _(ye, { name: "slide-fade-up" }, {
    default: b(() => [
      me(d("div", {
        style: H(r.styles),
        class: "m4-menu--mobile-wrapper"
      }, [
        (l(!0), h(G, null, q(i.localItems, (s) => (l(), _(a, {
          ref_for: !0,
          ref: "drawerElement",
          key: `${s.name}-${s.id}`,
          "elem-data": s,
          "is-mobile": !0,
          colors: n.colors,
          "active-parent": i.activeParent,
          "active-child": i.activeChild,
          "path-prefix": n.pathPrefix,
          onToggleParent: r.handleToggleParent,
          onToggleChild: r.handleToggleChild,
          onNavigate: r.handleNavigate
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild", "onNavigate"]))), 128))
      ], 4), [
        [Ft, n.isVisible]
      ])
    ]),
    _: 1
  });
}
const iw = /* @__PURE__ */ I(ow, [["render", rw], ["__scopeId", "data-v-5d2991ec"]]), sw = {
  name: "M4MoreMenuDropdown",
  components: { M4MainItem: cc },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    dropdownId: {
      type: String,
      default: "h4-menu--dropdown"
    },
    moreItems: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["mouseleave", "toggle-drawer", "navigate", "open", "close", "toggle-more-menu", "focus-sub-menu"],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      var n;
      const e = (o) => {
        var i;
        return o.type !== "header" || ((i = o.children) == null ? void 0 : i.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return (n = this.moreItems[t]) == null ? void 0 : n.id;
    }
  }
}, aw = ["id", "aria-labelledby", "aria-expanded"];
function lw(e, t, n, o, i, r) {
  const a = S("M4MainItem");
  return l(), h("div", {
    id: r.ariaId,
    "aria-labelledby": r.ariaLabelledBy,
    "aria-expanded": r.ariaExpanded,
    class: "m4-menu--dropdown-item-wrapper",
    onMouseleave: t[4] || (t[4] = (s) => e.$emit("mouseleave"))
  }, [
    (l(!0), h(G, null, q(n.moreItems, (s) => (l(), h(G, null, [
      s ? (l(), _(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": r.firstItemId,
        "last-item-id": r.lastItemId,
        "active-id": n.activeId,
        "is-active": s.id === n.activeId,
        colors: n.colors,
        "path-prefix": n.pathPrefix,
        onNavigate: (u) => e.$emit("navigate", s),
        onMouseover: (u) => e.$emit("open", s),
        onToggleMoreMenu: t[0] || (t[0] = (u) => e.$emit("toggle-more-menu", u)),
        onToggleDrawer: t[1] || (t[1] = (u) => e.$emit("toggle-drawer", u)),
        onClose: t[2] || (t[2] = (u) => e.$emit("close")),
        onFocusSubMenu: t[3] || (t[3] = (u) => e.$emit("focus-sub-menu", u))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "is-active", "colors", "path-prefix", "onNavigate", "onMouseover"])) : g("", !0)
    ], 64))), 256))
  ], 40, aw);
}
const dw = /* @__PURE__ */ I(sw, [["render", lw], ["__scopeId", "data-v-f1834e78"]]), uw = {
  name: "M4Drawer",
  components: { M4DrawerElement: pc },
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    colors: {
      type: Object,
      default: void 0
    },
    isMoreMenuActive: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    isTemporarilyHideMenu: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["mouseenter", "mouseleave", "hide-drawer", "close", "prevent-close", "toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    itemId() {
      return `drawer-${this.activeItem.id}`;
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("toggle-parent", { itemId: e.id });
        return;
      }
      this.$emit("prevent-close"), this.activeParent = e.id, this.$emit("toggle-parent", { itemId: e.id });
    }
  }
}, cw = ["id", "aria-labelledby"], hw = { class: "m4-menu--drawer-title" };
function mw(e, t, n, o, i, r) {
  const a = S("M4DrawerElement");
  return l(), h("div", {
    id: r.itemId,
    ref: r.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: "m4-menu--drawer",
    style: H({ flexDirection: i.scrollWidth ? "column" : "row" }),
    onMouseleave: t[2] || (t[2] = D((s) => e.$emit("mouseleave"), ["exact", "stop", "prevent"])),
    onMouseenter: t[3] || (t[3] = (s) => e.$emit("mouseenter"))
  }, [
    d("div", hw, [
      d("h2", {
        class: p(n.themeStyle)
      }, f(n.activeItem.name), 3)
    ]),
    d("div", {
      ref: "drawer-wrapper",
      class: p(["m4-menu--drawer-content-wrapper", { scrollWidth: i.scrollWidth }])
    }, [
      (l(!0), h(G, null, q(n.activeItem.children, (s) => (l(), _(a, {
        key: s.id,
        "elem-data": s,
        colors: n.colors,
        "theme-style": n.themeStyle,
        "active-parent": i.activeParent,
        "path-prefix": n.pathPrefix,
        onToggleParent: r.handleToggleParent,
        onNextTab: t[0] || (t[0] = (u) => e.$emit("next-tab", u)),
        onNavigate: t[1] || (t[1] = (u) => e.$emit("navigate", u))
      }, null, 8, ["elem-data", "colors", "theme-style", "active-parent", "path-prefix", "onToggleParent"]))), 128))
    ], 2)
  ], 44, cw);
}
const pw = /* @__PURE__ */ I(uw, [["render", mw], ["__scopeId", "data-v-6a36474b"]]), fw = {
  name: "M4",
  components: {
    M4Drawer: pw,
    M4MobileMenu: iw,
    M4MoreMenuDropdown: dw,
    M4MainItem: cc
  },
  mixins: [gi, dc],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean,
    isMobile: Boolean
  },
  emits: ["close-menus", "toggle-mobile-menu"],
  setup() {
    const e = tn(), { hasFocus: t, activate: n, deactivate: o } = da(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      m4MobileMenu: e
    };
  },
  computed: {
    showMobileMenu() {
      return this.content.showMenu;
    },
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["m4-menu--more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    }
  },
  watch: {
    async showMobileMenu() {
      this.isMobile && (this.showMobileMenu ? (await Bt(), this.activate()) : (await Bt(), this.deactivate()));
    }
  }
}, gw = { class: "m4-menu--align-right" }, vw = {
  ref: "bar-nav-item-wrapper",
  class: "m4-menu--bar-item-wrapper"
}, bw = {
  ref: "m4-menu--more-wrapper",
  class: "m4-menu--bar-dropdown-wrapper"
}, yw = { ref: "m4MobileMenu" };
function Cw(e, t, n, o, i, r) {
  const a = S("M4MainItem"), s = S("M4Drawer"), u = S("M4MoreMenuDropdown"), c = S("Close"), y = S("M4MobileMenu"), w = Ne("click-away");
  return l(), h("div", {
    id: "m4",
    style: H(e.colors),
    class: p(["m4-menu", { loadingMenu: e.loadingMenu }])
  }, [
    d("div", {
      ref: "m4-menu--bar",
      class: "m4-menu--bar",
      onMouseleave: t[13] || (t[13] = (v) => e.mouseLeaveMenu()),
      onMouseenter: t[14] || (t[14] = (v) => e.mouseEnterMenu())
    }, [
      d("div", gw, [
        me((l(), h("div", vw, [
          (l(!0), h(G, null, q(n.content.sitemapMenuItems, (v) => (l(), h(G, {
            key: v.id
          }, [
            me($(a, {
              item: v,
              "active-id": e.activeItem ? e.activeItem.id : null,
              "theme-style": n.theme.style,
              colors: e.colors,
              "path-prefix": n.content.pathPrefix,
              onNavigate: e.navigate,
              onMouseover: (E) => e.showItem(v),
              onToggleDrawer: (E) => e.handleDrawerToggle(v),
              onClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme-style", "colors", "path-prefix", "onNavigate", "onMouseover", "onToggleDrawer", "onClose"]), [
              [Ft, e.visibleItems.find(({ id: E }) => E === v.id)]
            ]),
            $(ye, { name: "slide-fade-up" }, {
              default: b(() => [
                d("div", {
                  onMousemove: t[5] || (t[5] = (E) => e.preventMouseLeaveClose = !1)
                }, [
                  me($(s, {
                    id: `drawer-${v.id}`,
                    ref_for: !0,
                    ref: `drawer-${v.id}`,
                    "active-item": v,
                    "theme-style": n.theme.style,
                    colors: e.colors,
                    "is-more-menu-active": e.isMoreDropdownVisible,
                    "is-open": e.activeItem && e.activeItem.id === v.id,
                    "path-prefix": n.content.pathPrefix,
                    "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                    onToggleParent: e.toggleParentCollapsible,
                    onPreventClose: t[0] || (t[0] = (E) => e.preventCloseDrawer(E)),
                    onNavigate: t[1] || (t[1] = (E) => e.navigate(E)),
                    onMouseleave: t[2] || (t[2] = (E) => e.hideDrawer("mouseleave")),
                    onClose: e.handleClose,
                    onHideDrawer: e.hideDrawer,
                    onMouseenter: t[3] || (t[3] = (E) => e.preventClose(e.activeItem)),
                    onNextTab: t[4] || (t[4] = (E) => e.nextTabAction(E))
                  }, null, 8, ["id", "active-item", "theme-style", "colors", "is-more-menu-active", "is-open", "path-prefix", "is-temporarily-hide-menu", "onToggleParent", "onClose", "onHideDrawer"]), [
                    [Ft, e.showDrawer(v)]
                  ])
                ], 32)
              ]),
              _: 2
            }, 1024)
          ], 64))), 128))
        ])), [
          [w, e.hideDrawer]
        ]),
        me(d("div", bw, [
          $(a, {
            id: "m4-menu--bar-dropdown-button",
            "more-menu-item": e.translations.more_dropdown_title,
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": !0,
            "theme-style": n.theme.style,
            colors: e.colors,
            "path-prefix": n.content.pathPrefix,
            onNavigate: e.navigate,
            onToggleMoreMenu: t[6] || (t[6] = (v) => e.handleMoreMenuToggle(v)),
            onMouseover: t[7] || (t[7] = (v) => e.handleMoreMenuToggle(!0)),
            onClose: e.handleClose
          }, null, 8, ["more-menu-item", "more-menu-visible", "theme-style", "colors", "path-prefix", "onNavigate", "onClose"]),
          $(ye, { name: "slide-fade-up" }, {
            default: b(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? me((l(), _(u, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                "theme-style": n.theme.style,
                colors: e.colors,
                "path-prefix": n.content.pathPrefix,
                onNavigate: e.navigate,
                onOpen: t[8] || (t[8] = (v) => e.handleDropdownMenuOpen(v)),
                onToggleMoreMenu: t[9] || (t[9] = (v) => e.handleMoreMenuToggle(v)),
                onToggleDrawer: t[10] || (t[10] = (v) => e.handleDrawerToggle(v)),
                onMouseleave: t[11] || (t[11] = (v) => e.preventClose(e.activeItem)),
                onFocusSubMenu: t[12] || (t[12] = (v) => e.focusSubMenu(v)),
                onClose: e.handleClose,
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme-style", "colors", "path-prefix", "onNavigate", "onClose", "onTemporarilyHideMenu"])), [
                [w, e.hideMoreMenu]
              ]) : g("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Ft, e.displayMoreButton]
        ])
      ])
    ], 544),
    n.isMobile ? (l(), h("div", {
      key: 0,
      id: "mainmenu",
      ref: "mainmenu",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      class: p(["m4-menu--mobile", n.content.showMenu && "is-visible"])
    }, [
      d("div", yw, [
        d("button", {
          ref: "closeButton",
          class: "close-icon",
          "aria-label": "close",
          onClick: t[15] || (t[15] = (v) => e.$emit("toggle-mobile-menu", !1))
        }, [
          $(c, {
            tabindex: "-1",
            "fill-color": e.colors["--dropdown-text-color"]
          }, null, 8, ["fill-color"])
        ], 512),
        $(y, {
          "menu-items": r.mobileMenuItems,
          "is-visible": n.content.showMenu,
          colors: e.colors,
          "path-prefix": n.content.pathPrefix,
          onNavigate: e.navigate,
          onCloseMenu: t[16] || (t[16] = (v) => e.$emit("close-menus"))
        }, null, 8, ["menu-items", "is-visible", "colors", "path-prefix", "onNavigate"])
      ], 512)
    ], 2)) : g("", !0)
  ], 6);
}
const ua = /* @__PURE__ */ I(fw, [["render", Cw], ["__scopeId", "data-v-d6ea7a9e"]]), _w = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    globals: {
      type: Object,
      required: !0
    },
    logoLink: {
      type: String,
      required: !0
    },
    shouldShrink: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      return {
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--school-name-color": this.theme.school_name_color.hex,
        "--school-tagline-color": this.theme.school_tagline_color.hex
      };
    },
    aClass() {
      return {
        "logo-circle": this.theme.logo_circle && ["H1", "H2"].includes(this.theme.version),
        shrink: this.shouldShrink,
        mobile: this.isMobile
      };
    },
    slogan() {
      const e = T(this.theme, "translations.school_tag_line"), t = T(this.globals, "info.school_tag_line");
      return e || t;
    }
  }
}, ww = ["href"], Tw = {
  key: 0,
  class: "clipping-rect"
}, kw = { class: "logo" }, Ew = ["src"], Sw = {
  key: 0,
  class: "circle"
}, Mw = { class: "school-info" }, $w = {
  key: 1,
  class: "name"
};
function Iw(e, t, n, o, i, r) {
  return l(), h("a", {
    href: n.logoLink,
    class: p(r.aClass),
    style: H(r.colors)
  }, [
    n.theme.logo_circle ? (l(), h("div", Tw)) : g("", !0),
    d("div", kw, [
      d("img", {
        src: n.globals.logo.url,
        alt: "Return to Home"
      }, null, 8, Ew),
      n.theme.logo_circle ? (l(), h("div", Sw)) : g("", !0)
    ]),
    d("div", Mw, [
      n.globals.info.customHeader ? (l(), h("h1", {
        key: 0,
        class: p({ "sr-only": n.globals.info.customHeader })
      }, f(n.globals.info.school_name) + " - " + f(r.slogan), 3)) : g("", !0),
      n.globals.info.customHeader ? g("", !0) : (l(), h("div", $w, [
        d("h1", {
          class: p([n.theme.style, "org-name"])
        }, f(n.globals.info.school_name), 3),
        d("div", {
          class: p(["slogan", { [n.theme.style]: n.theme.style }])
        }, f(r.slogan), 3)
      ]))
    ])
  ], 14, ww);
}
const ln = /* @__PURE__ */ I(_w, [["render", Iw], ["__scopeId", "data-v-a845ad16"]]), Aw = {
  name: "MenuElementType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    moreMenuVisible: Boolean,
    ariaExpanded: {
      type: String,
      default: "false"
    },
    ariaHasPopup: {
      type: String,
      default: "false"
    },
    ariaControls: {
      type: String,
      default: ""
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, Lw = { class: "bar-nav-element" }, Ow = ["innerHTML"], Nw = ["href", "target"], Hw = { key: 0 };
function Pw(e, t, n, o, i, r) {
  return l(), h("div", Lw, [
    r.href ? (l(), h(G, { key: 0 }, [
      r.iconVisible ? (l(), h("div", {
        key: 0,
        class: p(["item-icon", { "global-icon": n.item.cms_icon_id }]),
        style: H(r.colors),
        innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
      }, null, 14, Ow)) : g("", !0),
      d("a", {
        href: r.href,
        target: n.item.opens_in_new_tab ? "_blank" : void 0,
        class: "link"
      }, f(n.item.translatedTitle || n.item.name), 9, Nw)
    ], 64)) : (l(), h(G, { key: 1 }, [
      n.moreMenuTitle && n.item.name === "more" ? (l(), h("span", Hw, f(n.moreMenuTitle), 1)) : (l(), h("span", {
        key: 1,
        class: p(["item-type-header", { "no-children": r.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, f(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const fc = /* @__PURE__ */ I(Aw, [["render", Pw], ["__scopeId", "data-v-5589e202"]]), Dw = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, Rw = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, Vw = ["src", "alt"];
function Bw(e, t, n, o, i, r) {
  return l(), h("span", Rw, [
    (l(), _(R(r.href ? "a" : "div"), {
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "menu-item-link",
      tabindex: "-1"
    }, {
      default: b(() => [
        d("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, Vw)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const Fw = /* @__PURE__ */ I(Dw, [["render", Bw], ["__scopeId", "data-v-e7e5596a"]]), jw = {
  name: "BarNavDrawerItem",
  components: { MenuElementType: fc, ImageElement: Fw, MenuPlusIcon: hc, MenuMinusIcon: mc, DropdownArrowIcon: io },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["toggle-child", "toggle-parent", "next-tab", "navigate"],
  computed: {
    iconColor() {
      return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    itemBgColor() {
      return {
        "--item-bg-color": this.isMobile ? this.colors["--mobile-menu-bg-color"] : this.colors["--dropdown-bg-color"]
      };
    },
    itemTextColor() {
      return {
        "--item-text-color": this.isMobile ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"]
      };
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, Uw = ["id"], Kw = ["id"], Gw = ["aria-expanded", "aria-controls", "aria-haspopup"], zw = {
  class: "bar-nav--drawer-element-focusable",
  tabindex: "-1"
}, Zw = {
  key: 3,
  class: "sr-only"
}, Ww = ["id", "aria-labelledby"];
function qw(e, t, n, o, i, r) {
  const a = S("ImageElement"), s = S("MenuElementType"), u = S("MenuPlusIcon"), c = S("MenuMinusIcon"), y = S("DropdownArrowIcon"), w = S("BarNavDrawerItem", !0);
  return l(), h("div", {
    role: "menuitem",
    class: p(["bar-nav--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": r.isChild,
      "has-children": r.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": r.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: H([r.itemBgColor, r.itemTextColor]),
    onClick: t[7] || (t[7] = (...v) => r.toggleParentCollapsible && r.toggleParentCollapsible(...v))
  }, [
    d("div", {
      id: n.elemData.id,
      class: "bar-nav--drawer-element-title"
    }, [
      d("div", {
        id: r.ariaParentId,
        class: p(["bar-nav--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = D(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (l(), _(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (l(), _(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": r.iconColor,
          "aria-expanded": r.ariaExpanded,
          "aria-has-popup": r.ariaHasPopup,
          "aria-controls": r.ariaControls,
          onHandleHeaderClick: r.toggleParentCollapsible,
          onKeydown: [
            N(r.handleEnterEvent, ["enter"]),
            t[0] || (t[0] = N((v) => r.handleNextTab(n.elemData.id, !1, v.shiftKey), ["tab"]))
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "aria-expanded", "aria-has-popup", "aria-controls", "onHandleHeaderClick", "onKeydown"]))
      ], 10, Kw),
      n.elemData.children.length ? (l(), h(G, { key: 0 }, [
        n.elemData.children.length ? (l(), h("button", {
          key: 0,
          "aria-expanded": r.ariaExpanded,
          "aria-controls": r.ariaControls,
          "aria-haspopup": r.ariaHasPopup,
          class: "bar-nav--drawer-element-title-icon",
          onClick: t[2] || (t[2] = D((...v) => r.toggleParentCollapsible && r.toggleParentCollapsible(...v), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = N((v) => r.handleNextTab(n.elemData.id, !0, v.shiftKey), ["tab"]))
        }, [
          d("span", zw, [
            n.isMobile && !r.showChildren ? (l(), _(u, {
              key: 0,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && r.showChildren ? (l(), _(c, {
              key: 1,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : g("", !0),
            n.isMobile ? g("", !0) : (l(), _(y, {
              key: 2,
              "fill-color": r.iconColor,
              "dropdown-class": r.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData ? (l(), h("span", Zw, " Show submenu for " + f(n.elemData.name || n.elemData.translatedTitle), 1)) : g("", !0)
          ])
        ], 40, Gw)) : g("", !0)
      ], 64)) : g("", !0)
    ], 8, Uw),
    $(ye, { name: "collapse-in" }, {
      default: b(() => [
        me(d("div", {
          id: r.ariaChildId,
          "aria-labelledby": r.ariaParentId,
          class: p(["bar-nav--drawer-children", { "show-children": r.showChildren }])
        }, [
          (l(!0), h(G, null, q(n.elemData.children, (v) => (l(), _(w, {
            key: v.id,
            "elem-data": v,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[4] || (t[4] = (E) => e.$emit("toggle-child", E)),
            onNextTab: t[5] || (t[5] = (E) => e.$emit("next-tab", E)),
            onNavigate: t[6] || (t[6] = (E) => e.$emit("navigate", E))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level"]))), 128))
        ], 10, Ww), [
          [Ft, r.hasChildren & r.showChildren]
        ])
      ]),
      _: 1
    })
  ], 6);
}
const gc = /* @__PURE__ */ I(jw, [["render", qw], ["__scopeId", "data-v-d0a0d9f1"]]), Yw = {
  name: "MobileMenu",
  components: {
    BarNavDrawerItem: gc,
    MenuItem: it,
    LanguageDropdown: fi
  },
  mixins: [Ze],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    showUtilities: Boolean,
    signInColors: {
      type: Object,
      default: () => ({})
    },
    signInUrl: {
      type: String,
      default: ""
    },
    signInText: {
      type: String,
      default: ""
    },
    showSignInButton: Boolean,
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close-menu", "set-language", "toggle-search"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      languageDropdownVisible: !1
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keydownHandler);
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydownHandler);
  },
  methods: {
    keydownHandler(e) {
      e.key === "Escape" && this.$emit("close-menu");
    },
    setLanguage(e) {
      this.toggleLanguageDropdown(), this.$emit("set-language", e);
    },
    toggleLanguageDropdown() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    }
  }
}, xw = {
  key: 0,
  class: "mobile-menu-wrapper"
}, Xw = {
  key: 0,
  class: "search-translate-buttons"
}, Qw = ["href"], Jw = {
  key: 1,
  class: "utilities-wrapper"
}, eT = ["href", ":href", "target"], tT = {
  key: 2,
  class: "icon-links-container"
}, nT = ["href", ":href", "target", "aria-label"], oT = ["innerHTML"];
function rT(e, t, n, o, i, r) {
  const a = S("MenuItem"), s = S("LanguageDropdown"), u = S("BarNavDrawerItem"), c = Ne("click-away");
  return l(), _(ye, { name: "slide-fade-up" }, {
    default: b(() => [
      n.content.showMenu ? (l(), h("nav", xw, [
        n.showMenuButtons ? (l(), h("div", Xw, [
          $(a, {
            item: "searchbutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--icon-color": n.colors["--mobile-menu-text-color"],
                "--bg-color": "transparent"
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleSearch: t[0] || (t[0] = (y) => e.$emit("toggle-search"))
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color"]),
          n.content.languages.length > 1 ? (l(), _(a, {
            key: 0,
            item: "languagebutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--fill-color": n.colors["--mobile-menu-text-color"],
                "--fill-path-color": n.colors["--mobile-menu-text-color"],
                "--nav-color": n.colors["--mobile-menu-text-color"]
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleDropdown: r.toggleLanguageDropdown
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color", "onToggleDropdown"])) : g("", !0),
          me($(s, {
            id: "languagesmenu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": i.languageDropdownVisible,
            "current-language": n.content.langCode,
            class: "language-dropdown",
            onSetLanguage: r.setLanguage,
            onCloseDropdown: r.toggleLanguageDropdown
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage", "onCloseDropdown"]), [
            [
              c,
              () => {
                i.languageDropdownVisible = !1;
              }
            ]
          ]),
          n.showSignInButton ? (l(), h("a", {
            key: 1,
            href: n.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(n.signInText), 9, Qw)) : g("", !0)
        ])) : g("", !0),
        C(e.$slots, "menu-top", {}, void 0, !0),
        n.showUtilities ? (l(), h("div", Jw, [
          (l(!0), h(G, null, q(n.content.utilities, (y, w) => (l(), h("a", {
            key: w,
            href: y.link,
            ":href": y.link,
            target: y.opens_in_new_tab ? "_blank" : "",
            class: "utility",
            style: H({ color: n.colors["--mobile-menu-text-color"] })
          }, f(y.name), 13, eT))), 128))
        ])) : g("", !0),
        n.theme.version === "H8" && n.theme.style === "texas" ? (l(), h("div", tT, [
          (l(!0), h(G, null, q(n.content.iconLinks, (y) => (l(), h("a", {
            key: y.icon_id,
            href: y.link,
            ":href": y.link,
            target: y.opens_in_new_tab ? "_blank" : "",
            class: "icon-link",
            "aria-label": y.name,
            style: H({ color: n.colors["--mobile-menu-text-color"] })
          }, [
            d("span", {
              "data-testid": "svg",
              innerHTML: y.icon
            }, null, 8, oT)
          ], 12, nT))), 128))
        ])) : g("", !0),
        (l(!0), h(G, null, q(n.content.menuItems, (y) => (l(), _(u, {
          key: `${y.name}-${y.id}`,
          "elem-data": y,
          "is-mobile": "",
          colors: n.colors,
          "active-parent": i.activeParent,
          "active-child": i.activeChild,
          "path-prefix": n.content.pathPrefix,
          "new-mobile-header-element": "",
          onToggleParent: r.handleToggleParent,
          onToggleChild: r.handleToggleChild
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild"]))), 128))
      ])) : g("", !0)
    ]),
    _: 3
  });
}
const iT = /* @__PURE__ */ I(Yw, [["render", rT], ["__scopeId", "data-v-5814f1b4"]]), sT = {
  name: "MobileHeader",
  components: {
    MenuItem: it,
    OrgBanner: ln,
    MobileMenu: iT
  },
  mixins: [Fe],
  props: {
    isShrink: Boolean,
    showUtilities: Boolean,
    showSignInButton: Boolean,
    hideMenuButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    },
    menuButtonBgColor: {
      type: String,
      default: ""
    },
    menuButtonIconColor: {
      type: String,
      default: ""
    },
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggle-mobile-menu", "toggle-search", "set-language"],
  setup() {
    const e = tn(), { hasFocus: t, activate: n, deactivate: o } = da(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      mobileHeader: e
    };
  },
  computed: {
    mobileContent() {
      return de(oe({}, this.content), { menuItems: this.mobileMenuItems });
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    mobileHeaderBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.content.newMobileHeader && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : o.hex) || "#000";
    },
    colors() {
      var e, t, n, o, i, r, a, s, u, c;
      return {
        "--nav-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#fff",
        searchIcon: (t = this.theme.search_icon_color) == null ? void 0 : t.hex,
        "--mobile-menu-bg-color": (this.menuV4Enabled ? (o = (n = this.content.menuOptions) == null ? void 0 : n.dropdown_bg_color) == null ? void 0 : o.hex : (r = (i = this.content.menuOptions) == null ? void 0 : i.bg_color) == null ? void 0 : r.hex) || "#fff",
        "--mobile-menu-text-color": (this.menuV4Enabled ? (s = (a = this.content.menuOptions) == null ? void 0 : a.dropdown_text_color) == null ? void 0 : s.hex : (c = (u = this.content.menuOptions) == null ? void 0 : u.text_color) == null ? void 0 : c.hex) || "#000"
      };
    },
    focusHighlightColor() {
      return ie.mostReadable(this.mobileHeaderBgColor, ["#0000FF", "#FFFFFF"]).toHexString();
    },
    isSearchOpen() {
      return this.$route.query.openSearch === "true";
    }
  },
  watch: {
    "content.isSearchOpen": {
      async handler(e) {
        e ? (await Bt(), this.deactivate()) : (await Bt(), this.activate());
      }
    },
    "content.showMenu": {
      async handler(e) {
        e ? (await Bt(), this.activate()) : (await Bt(), this.deactivate());
      }
    }
  },
  methods: {
    async toggleSearch() {
      this.$emit("toggle-search");
    },
    buildSchoolsMenu(e) {
      if (Ut(e))
        return [];
      const t = (o) => {
        let i = "";
        switch (o) {
          case "SchoolsMenuOrg":
            i = "link";
            break;
          case "SchoolsMenuLink":
            i = "link";
            break;
          case "SchoolsMenuImage":
            i = "image";
            break;
          case "SchoolsMenuHeader":
            i = "header";
            break;
          default:
            i = "link";
            break;
        }
        return i;
      }, n = (o) => o.type === "SchoolsMenuLink" ? o.link : o.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? la(o, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : $n(o, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((o, i) => ({
        id: `schools-${i}`,
        name: o.name,
        slug: o.link || o.path_prefix,
        url: n(o),
        imgSrc: o.url,
        altText: o.alt_text,
        imgHasLink: o.action_on_click === "no_action",
        opens_in_new_tab: o.opens_in_new_tab,
        type: t(o.type),
        children: this.buildSchoolsMenu(o.children)
      }));
    }
  }
}, aT = {
  key: 0,
  class: "left-icon"
}, lT = { class: "main-content" }, dT = {
  key: 0,
  class: "right-icon"
}, uT = {
  key: 0,
  id: "mainmenu",
  "aria-labelledby": "menubutton",
  "aria-modal": "true",
  class: "menu-mobile"
};
function cT(e, t, n, o, i, r) {
  const a = S("MenuItem"), s = S("OrgBanner"), u = S("MobileMenu");
  return l(), h("div", {
    ref: "mobileHeader",
    "data-testid": "mobile-header",
    class: p(["mobile-header", e.theme.version, { "menu-open": e.content.showMenu, shrink: n.isShrink }]),
    style: H(r.colors)
  }, [
    C(e.$slots, "default", {}, () => [
      n.hideMenuButton ? g("", !0) : (l(), h("div", aT, [
        e.content.showMenu ? (l(), _(a, {
          key: 1,
          item: "closebutton",
          "show-text": !1,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": r.focusHighlightColor,
          onToggleDropdown: t[1] || (t[1] = (c) => e.$emit("toggle-mobile-menu", !1))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"])) : (l(), _(a, {
          key: 0,
          item: "menubutton",
          theme: e.theme,
          content: e.content,
          "show-text": !1,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonBgColor,
              "--fill-path-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": r.focusHighlightColor,
          onToggleDropdown: t[0] || (t[0] = (c) => e.$emit("toggle-mobile-menu", !0))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"]))
      ])),
      d("div", lT, [
        $(s, {
          "logo-link": e.logoLink,
          "should-shrink": n.isShrink,
          theme: e.theme,
          globals: e.content.globals,
          "is-mobile": e.theme.version !== "H3",
          class: p(e.theme.version)
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals", "is-mobile", "class"]),
        e.theme.version === "H3" ? (l(), h("div", dT, [
          e.content.showMenu ? (l(), _(a, {
            key: 1,
            item: "closebutton",
            theme: e.theme,
            content: e.content,
            "focus-visible-color": r.focusHighlightColor,
            onToggleDropdown: t[3] || (t[3] = (c) => e.$emit("toggle-mobile-menu", !1))
          }, null, 8, ["theme", "content", "focus-visible-color"])) : (l(), _(a, {
            key: 0,
            item: "menubutton",
            theme: e.theme,
            content: e.content,
            "is-mobile": "",
            "focus-visible-color": r.focusHighlightColor,
            onToggleDropdown: t[2] || (t[2] = (c) => e.$emit("toggle-mobile-menu", !0))
          }, null, 8, ["theme", "content", "focus-visible-color"]))
        ])) : g("", !0)
      ])
    ], !0),
    C(e.$slots, "bottom", {}, void 0, !0),
    e.content.showMenu ? (l(), h("div", uT, [
      $(u, {
        theme: e.theme,
        "show-utilities": n.showUtilities,
        utilities: e.content.utilities,
        "lang-code": e.content.langCode,
        "show-menu-buttons": n.showMenuButtons,
        content: r.mobileContent,
        colors: r.colors,
        "sign-in-colors": e.signInColors,
        "sigin-in-url": n.signInUrl,
        "show-sign-in-button": n.showSignInButton,
        "sign-in-text": e.signInText,
        "sign-in-url": n.signInUrl,
        onCloseMenu: t[4] || (t[4] = (c) => e.$emit("toggle-mobile-menu", !1)),
        onToggleSearch: t[5] || (t[5] = (c) => e.$emit("toggle-search")),
        onSetLanguage: t[6] || (t[6] = (c) => e.$emit("set-language", c))
      }, {
        "menu-top": b(() => [
          C(e.$slots, "menu-top", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["theme", "show-utilities", "utilities", "lang-code", "show-menu-buttons", "content", "colors", "sign-in-colors", "sigin-in-url", "show-sign-in-button", "sign-in-text", "sign-in-url"])
    ])) : g("", !0)
  ], 6);
}
const In = /* @__PURE__ */ I(sT, [["render", cT], ["__scopeId", "data-v-24f89412"]]), hT = {
  name: "Header1",
  components: {
    CmsSchoolsMenu: an,
    M4: ua,
    OrgBanner: ln,
    MobileHeader: In,
    MenuItem: it
  },
  mixins: [Fe, Ze],
  emits: ["language-change", "toggle-search"]
}, mT = { class: "left" }, pT = { class: "right" }, fT = { class: "right-left-menu" }, gT = { class: "explore-menu-container" }, vT = {
  key: 0,
  class: "schools-menu-container"
}, bT = { key: 0 }, yT = ["href"];
function CT(e, t, n, o, i, r) {
  var F, O, L, U, z;
  const a = S("OrgBanner"), s = S("MenuItem"), u = S("HeaderDropdown"), c = S("M4"), y = S("cms-schools-menu"), w = S("LanguageDropdown"), v = S("MobileHeader"), E = Ne("click-away");
  return me((l(), h("div", {
    id: "h1",
    style: H(e.colors)
  }, [
    !e.isMobile || !e.content.newMobileHeader ? (l(), h("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: p(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      d("div", mT, [
        $(a, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      d("div", pT, [
        d("div", fT, [
          d("div", gT, [
            $(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (F = e.theme.navigation_color) == null ? void 0 : F.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (l(), _(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (O = e.theme.navigation_color) == null ? void 0 : O.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility,
              onKeydown: t[0] || (t[0] = N(D((B) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"]))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : g("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? me((l(), _(u, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              role: "menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (B) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])), [
              [
                E,
                () => {
                  e.exploreMenuVisible = !1;
                }
              ]
            ]) : g("", !0),
            e.menuV4Enabled && e.isMobile ? (l(), _(c, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (B) => e.$emit("toggle-mobile-menu", B))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : g("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (l(), h("div", vT, [
            $(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (L = e.theme.navigation_color) == null ? void 0 : L.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = N(D((B) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (B) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            $(ye, { name: "slide" }, {
              default: b(() => [
                e.content.hasCustomSchoolsMenu ? (l(), _(y, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.customSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onHideOnClickaway: t[5] || (t[5] = (B) => e.customSchoolsMenuVisible = !1),
                  onFocusLost: t[6] || (t[6] = (B) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
              ]),
              _: 1
            })
          ])) : g("", !0)
        ]),
        d("div", {
          class: p(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (l(), h("div", bT, [
            $(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (U = e.theme.navigation_color) == null ? void 0 : U.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[7] || (t[7] = N(D((B) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            me($(w, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[8] || (t[8] = (B) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                E,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : g("", !0),
          $(s, {
            item: "searchbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent"
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "onToggleSearch"]),
          e.showSignInButton ? (l(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(e.signInText), 9, yT)) : g("", !0)
        ], 2)
      ])
    ], 2)) : (l(), _(v, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (z = e.theme.navigation_color) == null ? void 0 : z.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[9] || (t[9] = (B) => e.$emit("toggle-mobile-menu", B)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [E, e.closeAllMenus]
  ]);
}
const _T = /* @__PURE__ */ I(hT, [["render", CT], ["__scopeId", "data-v-3f364e00"]]), wT = {
  name: "DraggableWrapper",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    itemKey: {
      type: String,
      required: !0
    }
  }
};
function TT(e, t, n, o, i, r) {
  return l(), h("div", W0(q0(e.$attrs)), [
    (l(!0), h(G, null, q(n.modelValue, (a, s) => C(e.$slots, "item", {
      key: s,
      element: a,
      index: s
    })), 128))
  ], 16);
}
const Ke = /* @__PURE__ */ I(wT, [["render", TT]]), kT = {
  name: "UtilityBar",
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    textColor: {
      type: String,
      required: !0
    },
    bgColor: {
      type: String,
      required: !0
    },
    themeVersion: {
      type: String,
      default: ""
    },
    translatedTitle: {
      type: String,
      default: ""
    },
    languageDropdownOpen: Boolean,
    hasLanguages: Boolean,
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  components: {
    DropdownArrowIcon: io,
    DraggableWrapper: Ke
  },
  computed: {
    iconClass() {
      return this.languageDropdownOpen ? "open" : void 0;
    }
  }
};
function ET(e, t, n, o, i, r) {
  const a = S("DropdownArrowIcon");
  return l(), h(G, null, [
    (l(), _(R(n.wrapperComponent), Ce({ "item-key": "idx" }, n.wrapperProps, {
      "model-value": n.utilities,
      style: [{ color: n.textColor }, { background: n.bgColor }],
      class: ["utility-bar", [n.themeVersion, e.$attrs.class, { "is-editing": n.isEditing }]],
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.$emit("update:utilities", s))
    }), {
      item: b(({ element: s, index: u }) => [
        (l(), _(R(n.isEditing ? "div" : "a"), {
          class: "utilities",
          href: n.isEditing ? "" : s.link,
          target: s.opens_in_new_tab ? "_blank" : ""
        }, {
          default: b(() => [
            C(e.$slots, "utility", { idx: u }, () => [
              k(f(s.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value", "style", "class"])),
    n.themeVersion === "H3" && n.hasLanguages ? (l(), h("button", {
      key: 0,
      class: "translate-button",
      "data-testid": "language-dropdown-button",
      onClick: t[1] || (t[1] = (s) => e.$emit("toggle-language-dropdown"))
    }, [
      d("span", {
        class: "translate-text",
        style: H({ color: n.textColor })
      }, f(n.translatedTitle), 5),
      $(a, {
        "dropdown-class": r.iconClass,
        "fill-color": n.textColor
      }, null, 8, ["dropdown-class", "fill-color"])
    ])) : g("", !0)
  ], 64);
}
const vc = /* @__PURE__ */ I(kT, [["render", ET], ["__scopeId", "data-v-6e681a3d"]]), ST = {
  name: "Header2",
  components: {
    CmsSchoolsMenu: an,
    MenuItem: it,
    M4: ua,
    OrgBanner: ln,
    UtilityBar: vc,
    MobileHeader: In
  },
  mixins: [Fe, Ze],
  emits: ["toggle-menu", "toggle-mobile-menu", "close-menu", "language-change", "toggle-search", "update:utilities"]
}, MT = { class: "left" }, $T = { class: "right" }, IT = ["fill"], AT = { class: "right-menu-items" }, LT = { key: 0 }, OT = { key: 1 }, NT = ["href"], HT = { class: "right-mobile" }, PT = { class: "right-left-menu" }, DT = { class: "explore-menu-container" }, RT = {
  key: 0,
  class: "schools-menu-container"
}, VT = {
  key: 0,
  class: "language-icon"
}, BT = ["href"];
function FT(e, t, n, o, i, r) {
  var O, L, U, z, B, j, Y, K, ne, te;
  const a = S("UtilityBar"), s = S("MenuItem"), u = S("OrgBanner"), c = S("HeaderDropdown"), y = S("M4"), w = S("cms-schools-menu"), v = S("LanguageDropdown"), E = S("MobileHeader"), F = Ne("click-away");
  return me((l(), h("div", {
    id: "h2",
    style: H(e.colors)
  }, [
    d("div", {
      "data-testid": "small-utilities-bar",
      class: p([e.shrinkCSSClass, "utilities utilities-top"])
    }, [
      $(a, {
        class: p([[{ "is-mobile": e.isMobile }, e.shrinkCSSClass], "utility-bar-items"]),
        utilities: e.content.utilities,
        "theme-version": e.theme.version,
        "text-color": e.colors["--utility-link-color"],
        "bg-color": e.colors["--utility-bg-color"]
      }, null, 8, ["class", "utilities", "theme-version", "text-color", "bg-color"]),
      !e.isMobile || !e.content.newMobileHeader ? (l(), _(s, {
        key: 0,
        item: "searchbutton",
        class: p(e.shrinkCSSClass),
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (O = e.theme.search_icon_color) == null ? void 0 : O.hex
          }
        },
        "is-mobile": "",
        onToggleSearch: e.toggleSearch
      }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])) : g("", !0)
    ], 2),
    !e.isMobile || !e.content.newMobileHeader ? (l(), h("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: p(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      d("div", MT, [
        $(u, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      d("div", $T, [
        d("div", {
          "data-testid": "large-utilities-bar",
          class: p([e.shrinkCSSClass, "utilities utilities-right"])
        }, [
          (l(), h("svg", {
            class: p([e.shrinkCSSClass, "sloped-edge"]),
            width: "97",
            height: "56",
            viewBox: "0 0 97 56",
            preserveAspectRatio: "none",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
          }, [
            d("path", {
              d: "M94.5015 56H97V0H1.00114C0.188275 0 -0.284554 0.919373 0.187909 1.58124L6.79574 10.8378C27.0277 39.1796 59.6932 56 94.5015 56Z",
              fill: e.colors["--utility-bg-color"]
            }, null, 8, IT)
          ], 2)),
          $(a, {
            utilities: e.content.utilities,
            class: p([e.shrinkCSSClass, "utility-bar-items"]),
            "theme-version": e.theme.version,
            "text-color": e.colors["--utility-link-color"],
            "bg-color": e.colors["--utility-bg-color"]
          }, null, 8, ["utilities", "class", "theme-version", "text-color", "bg-color"]),
          $(s, {
            item: "searchbutton",
            class: p(e.shrinkCSSClass),
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--icon-color": (L = e.theme.search_icon_color) == null ? void 0 : L.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])
        ], 2),
        d("div", AT, [
          d("div", null, [
            $(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (U = e.theme.navigation_icon_bg_color) == null ? void 0 : U.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (l(), _(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (z = e.theme.navigation_icon_bg_color) == null ? void 0 : z.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[0] || (t[0] = N(D((le) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : g("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? (l(), _(c, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (le) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : g("", !0),
            e.menuV4Enabled && e.isMobile ? (l(), _(y, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (le) => e.$emit("toggle-mobile-menu", le))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : g("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (l(), h("div", LT, [
            $(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (B = e.theme.navigation_icon_bg_color) == null ? void 0 : B.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = N(D((le) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(c, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (le) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-language-menu-hidden", "is-shrink"])),
            $(ye, { name: "slide" }, {
              default: b(() => [
                e.content.hasCustomSchoolsMenu ? (l(), _(w, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[5] || (t[5] = (le) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
              ]),
              _: 1
            })
          ])) : g("", !0),
          e.shouldDisplayLanguagesDropdown ? (l(), h("div", OT, [
            $(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (j = e.theme.navigation_icon_bg_color) == null ? void 0 : j.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[6] || (t[6] = N(D((le) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            $(v, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[7] || (t[7] = (le) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : g("", !0),
          e.showSignInButton ? (l(), h("a", {
            key: 2,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(e.signInText), 9, NT)) : g("", !0)
        ])
      ]),
      d("div", HT, [
        d("div", PT, [
          d("div", DT, [
            $(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (Y = e.theme.navigation_icon_bg_color) == null ? void 0 : Y.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[8] || (t[8] = N(D((le) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.exploreMenuVisible ? (l(), _(c, {
              key: 0,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.sitemapMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[9] || (t[9] = (le) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : g("", !0),
            e.menuV4Enabled && e.isMobile ? (l(), _(y, {
              key: 1,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[10] || (t[10] = (le) => e.$emit("toggle-mobile-menu", le))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : g("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (l(), h("div", RT, [
            $(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (K = e.theme.navigation_icon_bg_color) == null ? void 0 : K.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[11] || (t[11] = N(D((le) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(c, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[12] || (t[12] = (le) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            $(ye, { name: "slide" }, {
              default: b(() => [
                e.content.hasCustomSchoolsMenu ? (l(), _(w, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "schools-menu",
                  "header-theme": e.theme,
                  content: e.content.globals.homepage,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[13] || (t[13] = (le) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
              ]),
              _: 1
            })
          ])) : g("", !0)
        ]),
        d("div", {
          class: p(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (l(), h("div", VT, [
            $(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (ne = e.theme.navigation_icon_bg_color) == null ? void 0 : ne.hex
                }
              },
              "is-mobile": "",
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[14] || (t[14] = N(D((le) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            $(v, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[15] || (t[15] = (le) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : g("", !0),
          e.showSignInButton ? (l(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(e.signInText), 9, BT)) : g("", !0)
        ], 2)
      ])
    ], 2)) : (l(), _(E, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (te = e.theme.navigation_color) == null ? void 0 : te.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[16] || (t[16] = (le) => e.$emit("toggle-mobile-menu", le)),
      onToggleSearch: t[17] || (t[17] = (le) => e.$emit("toggle-search")),
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [F, e.closeAllMenus]
  ]);
}
const jT = /* @__PURE__ */ I(ST, [["render", FT], ["__scopeId", "data-v-d757c21e"]]), UT = {
  mixins: [Fe, Ze],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-language-dropdown"],
  components: {
    OrgBanner: ln,
    UtilityBar: vc,
    LanguageDropdown: fi,
    MobileHeader: In
  },
  mixins: [Fe, Ze]
};
function KT(e, t, n, o, i, r) {
  var w, v;
  const a = S("MobileHeader"), s = S("OrgBanner"), u = S("UtilityBar"), c = S("LanguageDropdown"), y = Ne("click-away");
  return me((l(), h("div", {
    id: "h3",
    style: H(e.colors)
  }, [
    e.isMobile ? (l(), _(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": (w = e.theme.navigation_icon_bg_color) == null ? void 0 : w.hex,
      "menu-button-icon-color": (v = e.theme.navigation_icon_color) == null ? void 0 : v.hex,
      "show-utilities": !0,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "hide-menu-button": "",
      onToggleMenu: t[0] || (t[0] = (E) => e.$emit("toggle-menu")),
      onToggleMobileMenu: t[1] || (t[1] = (E) => e.$emit("toggle-mobile-menu", E)),
      onToggleSearch: t[2] || (t[2] = (E) => e.$emit("toggle-search")),
      onLanguageChange: t[3] || (t[3] = (E) => e.$emit("language-change")),
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-bg-color", "menu-button-icon-color", "show-sign-in-button", "sign-in-url", "is-shrink", "onCloseMenu"])) : (l(), h("div", {
      key: 1,
      class: p(["utility-menu", [e.theme.shadow_type, { isIframe: e.content.isIFrame }]])
    }, [
      $(s, {
        "logo-link": e.logoLink,
        "should-shrink": e.shouldShrink,
        theme: e.theme,
        globals: e.content.globals
      }, null, 8, ["logo-link", "should-shrink", "theme", "globals"]),
      d("div", {
        "data-testid": "utilities-bar",
        class: p([e.shrinkCSSClass, "utilities-bar"])
      }, [
        $(u, {
          class: p([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "theme-version": e.theme.version,
          "translated-title": e.theme.translations.translate_dropdown_title,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.colors["--utility-link-color"],
          "bg-color": "transparent",
          "language-dropdown-open": e.languageDropdownVisible,
          "has-languages": e.hasLanguages,
          onToggleLanguageDropdown: t[4] || (t[4] = (E) => e.setDropdownVisibility("languagebutton")),
          "onUpdate:utilities": t[5] || (t[5] = (E) => e.$emit("update:utilities", E))
        }, {
          utility: b(({ idx: E }) => [
            C(e.$slots, "utility", { idx: E }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "theme-version", "translated-title", "wrapper-component", "wrapper-props", "text-color", "language-dropdown-open", "has-languages"]),
        $(c, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (E) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
      ], 2)
    ], 2))
  ], 4)), [
    [y, e.closeAllMenus]
  ]);
}
const GT = /* @__PURE__ */ I(UT, [["render", KT], ["__scopeId", "data-v-04771afc"]]), zT = {
  name: "UtilityBar",
  components: {
    DraggableWrapper: Ke
  },
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    textColor: {
      type: String,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"]
};
function ZT(e, t, n, o, i, r) {
  return l(), _(R(n.wrapperComponent), Ce(n.wrapperProps, {
    "model-value": n.utilities,
    "item-key": "idx",
    class: "utility-bar",
    "onUpdate:modelValue": t[0] || (t[0] = (a) => e.$emit("update:utilities", a))
  }), {
    item: b(({ element: a, index: s }) => [
      (l(), _(R(n.isEditing ? "div" : "a"), {
        class: "utilities",
        href: a.link,
        style: H({ color: n.textColor }),
        target: a.opens_in_new_tab ? "_blank" : ""
      }, {
        default: b(() => [
          C(e.$slots, "utility", { idx: s }, () => [
            k(f(a.name), 1)
          ], !0)
        ]),
        _: 2
      }, 1032, ["href", "style", "target"]))
    ]),
    _: 3
  }, 16, ["model-value"]);
}
const WT = /* @__PURE__ */ I(zT, [["render", ZT], ["__scopeId", "data-v-f4ecbd63"]]), qT = {
  name: "MenuIcon",
  props: {
    type: {
      type: String,
      default: "arrow-1"
    }
  }
}, YT = {
  key: 0,
  class: "menu-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, xT = {
  key: 1,
  class: "menu-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function XT(e, t, n, o, i, r) {
  return l(), h(G, null, [
    n.type === "arrow-2" ? (l(), h("svg", YT, t[0] || (t[0] = [
      d("path", {
        d: "M6 13L11 8L6 3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]))) : g("", !0),
    n.type === "arrow-1" ? (l(), h("svg", xT, t[1] || (t[1] = [
      d("g", null, [
        d("path", {
          d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))) : g("", !0)
  ], 64);
}
const QT = /* @__PURE__ */ I(qT, [["render", XT]]), JT = {
  name: "M6",
  components: {
    MenuIcon: QT
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isMobile: Boolean
  },
  data() {
    return {
      currentPath: []
    };
  },
  computed: {
    breadcrumbTrail() {
      return this.currentPath;
    },
    currentLevelItems() {
      return this.currentPath.length === 0 ? this.isMobile ? this.mobileMenuItems : this.content.sitemapMenuItems : this.currentPath[this.currentPath.length - 1].children || [];
    },
    mobileContent() {
      return de(oe({}, this.content), { menuItems: this.mobileMenuItems });
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayUtilities() {
      return this.isMobile ? this.currentPath.length === 0 : !0;
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    colors() {
      return {
        "--heading-color": this.theme.menu_heading_color.hex,
        "--heading-line-color": this.theme.menu_heading_line_color.hex,
        "--icon-color": this.content.menuOptions.icon_color.hex,
        "--icon-bg-color": this.content.menuOptions.icon_bg_color.hex,
        "--icon-text-color": this.content.menuOptions.icon_text_color.hex,
        "--icon-text-hover-color": this.content.menuOptions.icon_text_hover_color.hex,
        "--text-color": this.content.menuOptions.text_color.hex,
        "--text-hover-color": this.content.menuOptions.text_hover_color.hex,
        "--utilities-color": this.theme.utility_link_color.hex
      };
    }
  },
  methods: {
    getPageUrl(e) {
      return e ? `${this.content.pathPrefix}/page/${e.slug}` : "";
    },
    getLinkUrl(e) {
      return e ? e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url : "";
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    selectItem(e) {
      e.children && e.children.length > 0 && this.currentPath.push(e);
    },
    navigateTo(e) {
      this.currentPath = this.currentPath.slice(0, e + 1);
    },
    resetToMenu() {
      this.currentPath = [];
    },
    buildSchoolsMenu(e) {
      if (Ut(e))
        return [];
      const t = (o) => {
        let i = "";
        switch (o) {
          case "SchoolsMenuOrg":
            i = "link";
            break;
          case "SchoolsMenuLink":
            i = "link";
            break;
          case "SchoolsMenuImage":
            i = "image";
            break;
          case "SchoolsMenuHeader":
            i = "header";
            break;
          default:
            i = "link";
            break;
        }
        return i;
      }, n = (o) => o.type === "SchoolsMenuLink" ? o.link : o.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? la(o, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : $n(o, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((o, i) => ({
        id: `schools-${i}`,
        name: o.name,
        slug: o.link || o.path_prefix,
        url: n(o),
        imgSrc: o.url,
        altText: o.alt_text,
        imgHasLink: o.action_on_click === "no_action",
        opens_in_new_tab: o.opens_in_new_tab,
        type: t(o.type),
        children: this.buildSchoolsMenu(o.children)
      }));
    }
  }
}, ek = {
  key: 0,
  class: "heading"
}, tk = ["onClick", "onKeydown"], nk = { key: 1 }, ok = { class: "custom-menu-items" }, rk = ["innerHTML"], ik = ["href", "target"], sk = {
  key: 1,
  class: "utilities"
}, ak = ["href", "target"], lk = {
  key: 2,
  class: "heading-mobile"
}, dk = ["onClick", "onKeydown"], uk = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, ck = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, hk = ["onClick", "onKeydown"], mk = { class: "name" }, pk = ["src", "alt"], fk = ["innerHTML"], gk = ["href", "target"], vk = ["onClick", "onKeydown"];
function bk(e, t, n, o, i, r) {
  const a = S("MenuIcon");
  return l(), h("div", {
    id: "m6",
    class: "menu",
    style: H(r.colors)
  }, [
    n.content.menuOptions.menu_titles ? (l(), h("div", ek, [
      d("div", {
        class: p(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        d("div", {
          class: p(["breadcrumb-item", { active: i.currentPath.length === 0 }])
        }, [
          d("div", {
            tabindex: "0",
            role: "button",
            class: "home",
            onClick: t[0] || (t[0] = (...s) => r.resetToMenu && r.resetToMenu(...s)),
            onKeydown: [
              t[1] || (t[1] = N((...s) => r.resetToMenu && r.resetToMenu(...s), ["enter"])),
              t[2] || (t[2] = N((...s) => r.resetToMenu && r.resetToMenu(...s), ["space"]))
            ]
          }, [
            i.currentPath.length > 0 ? (l(), _(a, {
              key: 0,
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])) : g("", !0),
            k(" " + f(n.theme.translations.menu_dropdown_title), 1)
          ], 32)
        ], 2),
        (l(!0), h(G, null, q(r.breadcrumbTrail, (s, u) => (l(), h("div", {
          key: s.id,
          class: p(["breadcrumb-item", { active: u === r.breadcrumbTrail.length - 1 }])
        }, [
          u !== r.breadcrumbTrail.length - 1 ? (l(), h("div", {
            key: 0,
            tabindex: "0",
            role: "button",
            onClick: (c) => r.navigateTo(u),
            onKeydown: [
              N((c) => r.navigateTo(u), ["enter"]),
              N((c) => r.navigateTo(u), ["space"])
            ]
          }, f(s.name), 41, tk)) : (l(), h("span", nk, f(s.name), 1))
        ], 2))), 128))
      ], 2),
      t[3] || (t[3] = d("div", { class: "line" }, null, -1))
    ])) : g("", !0),
    d("div", ok, [
      (l(!0), h(G, null, q(n.content.customMenuItems, (s) => (l(), h("div", {
        key: s.id,
        class: "item"
      }, [
        s.icon || s.icon_cms ? (l(), h("span", {
          key: 0,
          class: p(["icon", s.icon_cms && "global-icon"]),
          innerHTML: s.icon || s.icon_cms
        }, null, 10, rk)) : g("", !0),
        d("a", {
          class: "name",
          href: r.getLink(s.url),
          target: r.targetWindow(s)
        }, f(s.name), 9, ik)
      ]))), 128))
    ]),
    r.shouldDisplayUtilities ? (l(), h("div", sk, [
      (l(!0), h(G, null, q(n.content.utilities, (s) => (l(), h("a", {
        key: s.id,
        href: s.link,
        target: s.opens_in_new_tab ? "_blank" : "",
        class: "utility"
      }, f(s.name), 9, ak))), 128))
    ])) : g("", !0),
    i.currentPath.length > 0 && n.isMobile ? (l(), h("div", lk, [
      (l(!0), h(G, null, q(r.breadcrumbTrail, (s, u) => (l(), h("div", {
        class: p(["breadcrumb", { [n.theme.style]: n.theme.style }]),
        key: s.id
      }, [
        d("div", {
          tabindex: "0",
          role: "button",
          onClick: (c) => r.navigateTo(u - 1),
          onKeydown: [
            N((c) => r.navigateTo(u - 1), ["enter"]),
            N((c) => r.navigateTo(u - 1), ["space"])
          ],
          class: p(["breadcrumb-item", { active: u === r.breadcrumbTrail.length - 1 }])
        }, [
          n.content.menuOptions.link_icon === "arrow-2" ? (l(), h("svg", uk, t[4] || (t[4] = [
            d("path", {
              d: "M6 13L11 8L6 3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))) : (l(), h("svg", ck, t[5] || (t[5] = [
            d("g", null, [
              d("path", {
                d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))),
          d("span", null, f(s.name), 1)
        ], 42, dk)
      ], 2))), 128)),
      t[6] || (t[6] = d("div", { class: "line" }, null, -1))
    ])) : g("", !0),
    d("div", {
      class: p(["sitemap-menu-items", { "first-level": this.currentPath.length === 0 && n.isMobile }])
    }, [
      (l(!0), h(G, null, q(r.currentLevelItems, (s) => (l(), h("div", {
        key: s.id,
        class: p(["item", s.type])
      }, [
        s.type === "header" ? (l(), h("div", {
          key: 0,
          class: "wrapper",
          role: "button",
          tabindex: "0",
          onClick: (u) => r.selectItem(s),
          onKeydown: [
            N((u) => r.selectItem(s), ["enter"]),
            N((u) => r.selectItem(s), ["space"])
          ]
        }, [
          d("span", mk, f(s.name), 1),
          $(a, {
            type: n.content.menuOptions.link_icon
          }, null, 8, ["type"])
        ], 40, hk)) : s.type === "image" ? (l(), h("img", {
          key: 1,
          src: s.imgSrc,
          alt: s.altText
        }, null, 8, pk)) : (l(), h(G, { key: 2 }, [
          s.icon || s.icon_cms ? (l(), h("span", {
            key: 0,
            class: p(["icon", s.icon_cms && "global-icon"]),
            innerHTML: s.icon || s.icon_cms
          }, null, 10, fk)) : g("", !0),
          d("a", {
            class: "name",
            href: s.type === "page" ? r.getPageUrl(s) : r.getLinkUrl(s),
            target: r.targetWindow(s)
          }, f(s.name), 9, gk),
          s.children && s.children.length > 0 ? (l(), h("div", {
            key: 1,
            class: "icon-wrapper",
            role: "button",
            tabindex: "0",
            onClick: (u) => r.selectItem(s),
            onKeydown: [
              N((u) => r.selectItem(s), ["enter"]),
              N((u) => r.selectItem(s), ["space"])
            ]
          }, [
            $(a, {
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])
          ], 40, vk)) : g("", !0)
        ], 64))
      ], 2))), 128))
    ], 2)
  ], 4);
}
const yk = /* @__PURE__ */ I(JT, [["render", bk], ["__scopeId", "data-v-c2302a5d"]]), Ck = {
  components: {
    UtilityBar: WT,
    LanguageDropdown: fi,
    MenuItem: it,
    CmsSchoolsMenu: an,
    M6: yk
  },
  mixins: [Fe, Ze],
  mixins: [Fe, Ze],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    slogan() {
      var n, o, i, r, a;
      const e = (o = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : o.school_tag_line, t = (a = (r = (i = this.content) == null ? void 0 : i.globals) == null ? void 0 : r.info) == null ? void 0 : a.school_tag_line;
      return e || t;
    },
    menuButtonIcon() {
      return {
        arrow: "TriangleIcon",
        plus: "PlusIcon",
        hamburger: "HamburgerIcon"
      }[this.theme.menu_icon];
    },
    menuButtonColors() {
      var n, o, i;
      const e = {
        "--dropdown-class": this.content.showMenu ? "open" : "close"
      }, t = {
        plus: {
          "--fill-color": "transparent",
          "--fill-path-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex
        },
        hamburger: {
          "--fill-color": "transparent",
          "--fill-path-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        },
        arrow: {
          "--fill-color": (i = this.theme.navigation_color) == null ? void 0 : i.hex
        }
      };
      return oe(oe({}, e), t[this.theme.menu_icon]);
    },
    colors() {
      var e, t, n, o, i, r, a, s, u, c, y, w, v, E, F, O, L, U, z, B, j, Y;
      return oe({
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex,
        "--menu-heading-color": (o = (n = this.theme) == null ? void 0 : n.menu_heading_color) == null ? void 0 : o.hex,
        "--menu-heading-line-color": (r = (i = this.theme) == null ? void 0 : i.menu_heading_line_color) == null ? void 0 : r.hex,
        "--school-name-color": (s = (a = this.theme) == null ? void 0 : a.school_name_color) == null ? void 0 : s.hex,
        "--school-menu-text-color": (c = (u = this.theme) == null ? void 0 : u.schools_menu_text_color) == null ? void 0 : c.hex,
        "--school-tagline-color": (w = (y = this.theme) == null ? void 0 : y.school_tagline_color) == null ? void 0 : w.hex,
        "--school-tagline-bg-color": (E = (v = this.theme) == null ? void 0 : v.utility_bg_color) == null ? void 0 : E.hex,
        "--navigation-links": (O = (F = this.theme) == null ? void 0 : F.utility_link_color) == null ? void 0 : O.hex,
        "--language-color": (U = (L = this.theme) == null ? void 0 : L.language_color) == null ? void 0 : U.hex,
        "--search-color": (B = (z = this.theme) == null ? void 0 : z.search_color) == null ? void 0 : B.hex,
        "--background-opacity": `${(Y = (j = this.theme) == null ? void 0 : j.background_opacity) != null ? Y : "80"}%`
      }, this.signInColors);
    }
  },
  methods: {
    orgLink(e) {
      return $n(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    },
    schoolButtonClick() {
      this.setDropdownVisibility("schoolsbutton"), this.content.showMenu && this.$emit("toggle-menu", !1);
    }
  }
}, _k = { class: "top-header" }, wk = { class: "slogan" }, Tk = { class: "menu" }, kk = { class: "wrapper" }, Ek = { class: "org-banner" }, Sk = ["href"], Mk = ["src"], $k = { class: "school-info" }, Ik = ["href"], Ak = { class: "menu-buttons" }, Lk = {
  key: 0,
  id: "sign-in-button-wrapper"
}, Ok = ["href"], Nk = { class: "menus" }, Hk = {
  key: 1,
  class: "schools-menu",
  "data-testid": "schools-menu"
}, Pk = { class: "school-links" }, Dk = ["href"], Rk = {
  key: 2,
  class: "schools-menu",
  "data-testid": "schools-menu"
};
function Vk(e, t, n, o, i, r) {
  var v, E, F, O;
  const a = S("MenuItem"), s = S("LanguageDropdown"), u = S("UtilityBar"), c = S("M6"), y = S("CmsSchoolsMenu"), w = Ne("click-away");
  return me((l(), h("div", {
    class: "h4",
    style: H(r.colors)
  }, [
    d("div", _k, [
      d("span", wk, f(r.slogan), 1),
      d("div", Tk, [
        $(a, {
          item: "languagebutton",
          theme: e.theme,
          content: e.content,
          "is-uppercase": !0,
          "dropdown-open": e.languageDropdownVisible,
          "theme-overrides": {
            icon: "TriangleIcon",
            colors: {
              "--fill-color": (v = e.theme.language_color) == null ? void 0 : v.hex,
              "--nav-color": (E = e.theme.language_color) == null ? void 0 : E.hex
            }
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides", "onToggleDropdown"]),
        $(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[0] || (t[0] = (L) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]),
        $(a, {
          item: "searchbutton",
          class: "search-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--icon-color": (F = e.theme.search_color) == null ? void 0 : F.hex,
              "--nav-color": (O = e.theme.search_color) == null ? void 0 : O.hex
            }
          },
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"])
      ])
    ]),
    d("div", {
      class: p(["bottom-header", [
        e.theme.shadow_type,
        e.theme.bg_type,
        { expanded: e.isCustomSchoolsMenuVisible || e.schoolDropdownVisible || e.content.showMenu }
      ]])
    }, [
      d("div", kk, [
        d("div", Ek, [
          d("a", {
            href: e.logoLink,
            class: "logo"
          }, [
            d("img", {
              src: e.content.globals.logo.url,
              alt: "Return to Home"
            }, null, 8, Mk)
          ], 8, Sk),
          d("div", $k, [
            e.content.globals.info.customHeader ? (l(), h("h1", {
              key: 0,
              class: p({ "sr-only": e.content.globals.info.customHeader })
            }, f(e.content.globals.info.school_name) + " - " + f(r.slogan), 3)) : g("", !0),
            e.content.globals.info.customHeader ? g("", !0) : (l(), h("a", {
              key: 1,
              href: e.logoLink,
              class: "name"
            }, [
              d("h1", {
                class: p([e.theme.style, "org-name"])
              }, f(e.content.globals.info.school_name), 3),
              d("div", {
                class: p(["slogan", { [e.theme.style]: e.theme.style }])
              }, f(r.slogan), 3)
            ], 8, Ik)),
            d("div", Ak, [
              $(a, {
                item: "schoolsbutton",
                class: "schools-button",
                theme: e.theme,
                content: e.content,
                "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
                "theme-overrides": {
                  icon: "TriangleIcon"
                },
                onToggleDropdown: r.schoolButtonClick
              }, null, 8, ["theme", "content", "dropdown-open", "onToggleDropdown"]),
              $(a, {
                item: "menubutton",
                class: "desktop-menu-button",
                theme: e.theme,
                content: e.content,
                "theme-overrides": {
                  icon: r.menuButtonIcon,
                  colors: r.menuButtonColors
                },
                onToggleDropdown: e.setDropdownVisibility
              }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"])
            ])
          ])
        ]),
        $(a, {
          item: "menubutton",
          class: "mobile-menu-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            icon: r.menuButtonIcon,
            colors: r.menuButtonColors
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"]),
        $(u, {
          class: p([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          "data-testid": "utility-bar",
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.theme.utility_link_color.hex,
          "onUpdate:utilities": t[1] || (t[1] = (L) => e.$emit("update:utilities", L))
        }, {
          utility: b(({ idx: L }) => [
            C(e.$slots, "utility", { idx: L }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "wrapper-component", "wrapper-props", "text-color"]),
        e.showSignInButton ? (l(), h("div", Lk, [
          d("a", {
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(e.signInText), 9, Ok)
        ])) : g("", !0)
      ]),
      d("div", Nk, [
        e.menuV6Enabled && e.content.showMenu ? (l(), _(c, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "is-mobile": e.isMobile
        }, null, 8, ["theme", "content", "is-mobile"])) : g("", !0),
        !e.content.hasCustomSchoolsMenu && e.schoolDropdownVisible ? (l(), h("div", Hk, [
          d("div", {
            class: p(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            d("div", null, f(e.theme.translations.schools_dropdown_title), 1),
            t[3] || (t[3] = d("div", { class: "line" }, null, -1))
          ], 2),
          d("div", Pk, [
            (l(!0), h(G, null, q(e.content.organizations, (L, U) => (l(), h("a", {
              key: U,
              href: r.orgLink(L),
              class: "link"
            }, f(L.name), 9, Dk))), 128))
          ])
        ])) : g("", !0),
        e.content.hasCustomSchoolsMenu && e.isCustomSchoolsMenuVisible ? (l(), h("div", Rk, [
          d("div", {
            class: p(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            d("div", null, f(e.theme.translations.schools_dropdown_title), 1),
            t[4] || (t[4] = d("div", { class: "line" }, null, -1))
          ], 2),
          $(y, {
            id: "schoolsmenu",
            ref: "schoolsmenu",
            "data-testid": "custom-schools-menu",
            role: "menu",
            "header-theme": e.theme,
            "org-menu-content": e.content.orgMenuContent,
            organizations: e.content.organizations,
            "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
            "shrink-header": e.shouldShrink,
            "is-preview": e.content.isPreview,
            onFocusLost: t[2] || (t[2] = (L) => e.customSchoolsMenuVisible = !1)
          }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "shrink-header", "is-preview"])
        ])) : g("", !0)
      ])
    ], 2)
  ], 4)), [
    [w, e.closeAllMenus]
  ]);
}
const Bk = /* @__PURE__ */ I(Ck, [["render", Vk], ["__scopeId", "data-v-e27b35ba"]]), Fk = ["fill"], jk = {
  __name: "FilledTriangleArrow",
  props: {
    iconColor: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (l(), h("svg", {
      class: p(e.isOpen ? "open" : "close"),
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 14 11",
      fill: "none"
    }, [
      d("path", {
        d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
        fill: e.iconColor
      }, null, 8, Fk)
    ], 2));
  }
}, Uk = /* @__PURE__ */ I(jk, [["__scopeId", "data-v-23478d63"]]), Kk = {
  components: {
    DraggableWrapper: Ke,
    HamburgerIcon: sa,
    TriangleIcon: ec,
    FilledTriangleArrow: Uk,
    PlusIcon: aa,
    MenuItem: it,
    CmsSchoolsMenu: an
  },
  mixins: [Fe, Ze],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      return oe({
        "--utility-bg-color": this.theme.main_nav_bg === "solid" || !this.isHomepage ? this.theme.utility_bg_color.hex : ie(this.theme.utility_bg_color.hex).setAlpha(0.75).toRgbString(),
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--utility-nav-position": this.theme.main_nav_bg === "solid" || !this.isHomepage ? "block" : "absolute",
        "--box-shadow": this.theme.nav_inner_drop_shadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset" : "unset",
        "--utility-nav-overflow": this.exploreMenuVisible || this.schoolDropdownVisible || this.customSchoolsMenuVisible || this.isMobile ? "unset" : "auto"
      }, this.signInColors);
    },
    menuDropdownIcon() {
      switch (this.theme.menu_icon) {
        case "arrow":
          return "FilledTriangleArrow";
        case "hamburger":
          return "HamburgerIcon";
        case "plus":
          return "PlusIcon";
        default:
          return "FilledTriangleArrow";
      }
    },
    showTemplateWithSignInButton() {
      return this.showSignInButton && this.isMobile && !this.content.isEditing;
    },
    schoolDropdownAriaControlsValue() {
      return (this.isSchoolDropdownVisible || this.isCustomSchoolsMenuVisible) && this.content.hasCustomSchoolsMenu ? "schoolsmenu" : void 0;
    },
    getExploreDropdownText() {
      var e, t, n, o, i;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.menu_dropdown_title) || ((i = (o = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : o.header) == null ? void 0 : i.explore_dropdown_title) || "Explore";
    }
  }
}, Gk = ["aria-expanded", "aria-controls"], zk = ["href"], Zk = { class: "bottom-bar-item schools-dropdown-wrapper" }, Wk = ["aria-expanded", "aria-controls"], qk = { class: "bottom-bar-item mobile-right" }, Yk = ["aria-expanded", "aria-controls"], xk = { class: "bottom-bar-item mobile-right" }, Xk = ["aria-expanded", "aria-controls"], Qk = { class: "bottom-bar-item schools-dropdown-wrapper" }, Jk = ["aria-expanded", "aria-controls"];
function eE(e, t, n, o, i, r) {
  const a = S("TriangleIcon"), s = S("HeaderDropdown"), u = S("cms-schools-menu"), c = S("MenuItem"), y = S("LanguageDropdown"), w = Ne("click-away");
  return l(), h("div", {
    style: H(r.colors),
    class: p(["bottom-bar", { "show-sign-in-button": e.showSignInButton }]),
    "data-testid": "utility-bar"
  }, [
    r.showTemplateWithSignInButton ? (l(), h(G, { key: 0 }, [
      e.isMobile ? (l(), h("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[0] || (t[0] = (v) => e.clickedMenu("menubutton"))
      }, [
        k(f(r.getExploreDropdownText) + " ", 1),
        $(a, {
          "fill-color": r.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, Gk)) : g("", !0),
      e.showSignInButton ? (l(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        target: "_blank"
      }, f(e.signInText), 9, zk)) : g("", !0),
      d("div", Zk, [
        d("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": r.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[1] || (t[1] = (v) => e.clickedMenu("schoolsbutton"))
        }, [
          k(f(e.content.orgDropdownTitle) + " ", 1),
          $(a, {
            "fill-color": r.colors["--utility-text-color"],
            "is-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible
          }, null, 8, ["fill-color", "is-open"])
        ], 8, Wk),
        e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[2] || (t[2] = (v) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        $(ye, { name: "slide" }, {
          default: b(() => [
            e.content.hasCustomSchoolsMenu ? (l(), _(u, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[3] || (t[3] = (v) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[4] || (t[4] = (v) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : g("", !0)
          ]),
          _: 1
        })
      ]),
      d("div", qk, [
        e.shouldDisplayLanguagesDropdown ? (l(), _(c, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[5] || (t[5] = (v) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : g("", !0),
        me($(y, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (v) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            w,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        $(c, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : e.isMobile && !e.content.isEditing ? (l(), h(G, { key: 1 }, [
      e.isMobile ? (l(), h("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[7] || (t[7] = (v) => e.clickedMenu("menubutton"))
      }, [
        k(f(r.getExploreDropdownText) + " ", 1),
        $(a, {
          "fill-color": r.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, Yk)) : g("", !0),
      d("div", xk, [
        e.shouldDisplayLanguagesDropdown ? (l(), _(c, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[8] || (t[8] = (v) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : g("", !0),
        me($(y, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[9] || (t[9] = (v) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            w,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        $(c, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : (l(), h(G, { key: 2 }, [
      d("button", {
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        "aria-haspopup": "true",
        onClick: t[10] || (t[10] = (v) => e.clickedMenu("menubutton"))
      }, [
        k(f(e.theme.translations.menu_dropdown_title || "Menu") + " ", 1),
        (l(), _(R(r.menuDropdownIcon), {
          "theme-style": e.theme.style,
          "bg-color": r.colors["--utility-bg-color"],
          "icon-color": r.colors["--utility-text-color"],
          "fill-color": "transparent",
          "fill-path-color": r.colors["--utility-text-color"],
          rx: e.theme.style === "purple" ? "50" : "4",
          "is-open": e.content.showMenu || e.exploreMenuVisible
        }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
      ], 8, Xk),
      d("div", Qk, [
        d("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": r.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[11] || (t[11] = (v) => e.clickedMenu("schoolsbutton"))
        }, [
          k(f(e.content.orgDropdownTitle) + " ", 1),
          (l(), _(R(r.menuDropdownIcon), {
            "theme-style": e.theme.style,
            "bg-color": r.colors["--utility-bg-color"],
            "icon-color": r.colors["--utility-text-color"],
            "fill-color": "transparent",
            "fill-path-color": r.colors["--utility-text-color"],
            rx: e.theme.style === "purple" ? "50" : "4",
            "is-open": e.isSchoolDropdownVisible || e.customSchoolsMenuVisible
          }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
        ], 8, Jk),
        e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[12] || (t[12] = (v) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        $(ye, { name: "slide" }, {
          default: b(() => [
            e.content.hasCustomSchoolsMenu ? (l(), _(u, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[13] || (t[13] = (v) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[14] || (t[14] = (v) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : g("", !0)
          ]),
          _: 1
        })
      ]),
      (l(), _(R(n.wrapperComponent), Ce(n.wrapperProps, {
        "model-value": e.content.utilities,
        "item-key": "idx",
        class: "bottom-bar-utilities-wrapper",
        "onUpdate:modelValue": t[15] || (t[15] = (v) => e.$emit("update:utilities", v))
      }), {
        item: b(({ element: v, index: E }) => [
          (l(), _(R(e.content.isEditing ? "div" : "a"), {
            class: "bottom-bar-item utilities",
            href: v.link,
            target: v.opens_in_new_tab ? "_blank" : ""
          }, {
            default: b(() => [
              C(e.$slots, "utility", { idx: E }, () => [
                k(f(v.name), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ]),
        _: 3
      }, 16, ["model-value"]))
    ], 64))
  ], 6);
}
const tE = /* @__PURE__ */ I(Kk, [["render", eE], ["__scopeId", "data-v-9725d1c9"]]), nE = {
  name: "Header5",
  components: {
    UtilityBar: tE,
    OrgBanner: ln,
    MobileHeader: In,
    MenuItem: it
  },
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  mixins: [Fe, Ze],
  computed: {
    colors() {
      var e, t;
      return oe({
        "--top-bar": this.theme.show_top_bar ? `8px solid ${this.theme.top_bar_color.hex}` : "none",
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex
      }, this.signInColors);
    }
  }
}, oE = {
  key: 0,
  "data-testid": "large-screen-header",
  class: "header-container"
}, rE = { class: "left" }, iE = { class: "right" }, sE = { class: "right-right-menu" }, aE = { key: 0 }, lE = ["href"];
function dE(e, t, n, o, i, r) {
  var v, E, F;
  const a = S("OrgBanner"), s = S("MenuItem"), u = S("LanguageDropdown"), c = S("UtilityBar"), y = S("MobileHeader"), w = Ne("click-away");
  return l(), h("div", {
    style: H(r.colors),
    class: "h5"
  }, [
    !e.isMobile || e.isEditing ? (l(), h("div", oE, [
      d("div", rE, [
        $(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      d("div", iE, [
        d("div", sE, [
          e.shouldDisplayLanguagesDropdown ? (l(), h("div", aE, [
            $(s, {
              theme: e.theme,
              content: e.content,
              item: "languagebutton",
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--icon-color": (v = e.theme.navigation_color) == null ? void 0 : v.hex,
                  "--fill-color": "transparent",
                  "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onToggleDropdown: t[0] || (t[0] = (O) => e.clickedMenu("languagebutton"))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
            me($(u, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[1] || (t[1] = (O) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                w,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : g("", !0),
          $(s, {
            theme: e.theme,
            content: e.content,
            item: "searchbutton",
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent",
                "--fill-path-color": (F = e.theme.navigation_color) == null ? void 0 : F.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"]),
          e.showSignInButton ? (l(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, f(e.signInText), 9, lE)) : g("", !0)
        ])
      ])
    ])) : (l(), _(y, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "hide-menu-button": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onCloseMenu: e.closeAllMenus
    }, {
      bottom: b(() => [
        $(c, {
          content: e.content,
          "is-homepage": e.isHomepage,
          "is-mobile": e.isMobile,
          theme: e.theme,
          "show-sign-in-button": e.showSignInButton,
          onToggleMenu: t[2] || (t[2] = (O) => e.$emit("toggle-mobile-menu", O)),
          onToggleSearch: e.toggleSearch,
          onLanguageChange: t[3] || (t[3] = (O) => e.$emit("language-change", O))
        }, null, 8, ["content", "is-homepage", "is-mobile", "theme", "show-sign-in-button", "onToggleSearch"])
      ]),
      _: 1
    }, 8, ["theme", "content", "onCloseMenu"])),
    !e.isMobile || e.isEditing ? (l(), _(c, {
      key: 2,
      content: e.content,
      "is-homepage": e.isHomepage,
      "is-mobile": e.isMobile,
      theme: e.theme,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      onToggleMenu: t[4] || (t[4] = (O) => e.$emit("toggle-menu", O)),
      "onUpdate:utilities": t[5] || (t[5] = (O) => e.$emit("update:utilities", O))
    }, {
      utility: b(({ idx: O }) => [
        C(e.$slots, "utility", { idx: O }, void 0, !0)
      ]),
      _: 3
    }, 8, ["content", "is-homepage", "is-mobile", "theme", "wrapper-component", "wrapper-props"])) : g("", !0)
  ], 4);
}
const uE = /* @__PURE__ */ I(nE, [["render", dE], ["__scopeId", "data-v-951a398f"]]), cE = {
  components: {
    CmsSchoolsMenu: an,
    MenuItem: it
  },
  mixins: [Fe, Ze, rt],
  props: {
    textColor: {
      type: String,
      required: !0
    },
    largeSize: {
      type: Boolean,
      default: !1
    }
  }
}, hE = { class: "header-nav-wrapper" }, mE = { class: "left button-group" }, pE = {
  key: 1,
  class: "language-button-wrapper"
}, fE = { class: "center" }, gE = {
  key: 0,
  class: "schools-menu-container"
}, vE = ["href"];
function bE(e, t, n, o, i, r) {
  var w, v, E, F, O, L, U, z, B, j, Y, K, ne;
  const a = S("MenuItem"), s = S("LanguageDropdown"), u = S("HeaderDropdown"), c = S("CmsSchoolsMenu"), y = Ne("click-away");
  return l(), h("div", hE, [
    d("div", mE, [
      n.largeSize ? g("", !0) : (l(), _(a, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (w = e.theme.utility_link_color) == null ? void 0 : w.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])),
      e.shouldDisplayLanguagesDropdown ? (l(), h("div", pE, [
        $(a, {
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (v = e.theme.navigation_color) == null ? void 0 : v.hex : (E = e.theme.utility_link_color) == null ? void 0 : E.hex,
              "--nav-color": n.largeSize ? (F = e.theme.navigation_color) == null ? void 0 : F.hex : (O = e.theme.utility_link_color) == null ? void 0 : O.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[0] || (t[0] = (te) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        me($(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[1] || (t[1] = (te) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            y,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : g("", !0),
      n.largeSize ? (l(), _(a, {
        key: 2,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (L = e.theme.navigation_color) == null ? void 0 : L.hex,
            "--nav-color": (U = e.theme.navigation_color) == null ? void 0 : U.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])) : g("", !0)
    ]),
    d("div", fE, [
      C(e.$slots, "default", {}, void 0, !0)
    ]),
    d("div", {
      class: p([[n.largeSize ? "" : "small-bar"], "right button-group"])
    }, [
      e.shouldDisplaySchoolsDropdown && !e.isMobile ? (l(), h("div", gE, [
        $(a, {
          item: "schoolsbutton",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (z = e.theme.navigation_color) == null ? void 0 : z.hex : (B = e.theme.utility_link_color) == null ? void 0 : B.hex,
              "--nav-color": n.largeSize ? (j = e.theme.navigation_color) == null ? void 0 : j.hex : (Y = e.theme.utility_link_color) == null ? void 0 : Y.hex
            }
          },
          "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
        e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(u, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[2] || (t[2] = (te) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
        $(ye, { name: "slide" }, {
          default: b(() => [
            e.content.hasCustomSchoolsMenu ? (l(), _(c, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "schools-menu",
              "header-theme": e.theme,
              content: e.content.globals.homepage,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
              "sticky-header": e.shouldBeSticky,
              "shrink-header": e.shouldShrink,
              "is-preview": e.content.isPreview,
              onFocusLost: t[3] || (t[3] = (te) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
          ]),
          _: 1
        })
      ])) : g("", !0),
      d("div", null, [
        $(a, {
          theme: e.theme,
          content: e.content,
          "dropdown-open": e.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--nav-color": n.textColor,
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (K = e.theme.navigation_color) == null ? void 0 : K.hex : (ne = e.theme.utility_link_color) == null ? void 0 : ne.hex
            }
          },
          item: "explore-button",
          onToggleDropdown: t[4] || (t[4] = (te) => e.clickedMenu("menubutton"))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
        e.menuV4Enabled && e.content.showMenu ? (l(), _(u, {
          key: 0,
          id: "explore-menu",
          "data-testid": "explore-menu",
          "aria-labelledby": "explore-button",
          styles: e.theme,
          data: e.content.sitemapMenuItems,
          "menu-v4-enabled": e.menuV4Enabled,
          "is-visible": e.exploreMenuVisible,
          "path-prefix": e.content.pathPrefix,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[5] || (t[5] = (te) => e.exploreMenuVisible = !1)
        }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : g("", !0)
      ]),
      e.showSignInButton ? (l(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, f(e.signInText), 9, vE)) : g("", !0)
    ], 2)
  ]);
}
const yE = /* @__PURE__ */ I(cE, [["render", bE], ["__scopeId", "data-v-12d14a57"]]);
function CE(e) {
  return $u() ? (Iu(e), !0) : !1;
}
const _E = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
function wE(e) {
  return Au();
}
function TE(e) {
  return Array.isArray(e) ? e : [e];
}
function kE(e, t = !0, n) {
  wE() ? Qs(e, n) : t ? e() : Bt(e);
}
const bc = _E ? window : void 0;
function zn(e) {
  var t;
  const n = Lu(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function EE() {
  const e = Y0(!1), t = Au();
  return t && Qs(() => {
    e.value = !0;
  }, t), e;
}
function SE(e) {
  const t = EE();
  return xo(() => (t.value, !!e()));
}
function ME(e, t, n = {}) {
  const w = n, { window: o = bc } = w, i = Ki(w, ["window"]);
  let r;
  const a = SE(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, u = xo(() => {
    const v = Lu(e);
    return Array.isArray(v) ? v.map((E) => zn(E)) : [zn(v)];
  }), c = ri(
    u,
    (v) => {
      if (s(), a.value && o) {
        r = new ResizeObserver(t);
        for (const E of v)
          E && r.observe(E, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    s(), c();
  };
  return CE(y), {
    isSupported: a,
    stop: y
  };
}
function $E(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: o = bc, box: i = "content-box" } = n, r = xo(() => {
    var w, v;
    return (v = (w = zn(e)) == null ? void 0 : w.namespaceURI) == null ? void 0 : v.includes("svg");
  }), a = tn(t.width), s = tn(t.height), { stop: u } = ME(
    e,
    ([w]) => {
      const v = i === "border-box" ? w.borderBoxSize : i === "content-box" ? w.contentBoxSize : w.devicePixelContentBoxSize;
      if (o && r.value) {
        const E = zn(e);
        if (E) {
          const F = E.getBoundingClientRect();
          a.value = F.width, s.value = F.height;
        }
      } else if (v) {
        const E = TE(v);
        a.value = E.reduce((F, { inlineSize: O }) => F + O, 0), s.value = E.reduce((F, { blockSize: O }) => F + O, 0);
      } else
        a.value = w.contentRect.width, s.value = w.contentRect.height;
    },
    n
  );
  kE(() => {
    const w = zn(e);
    w && (a.value = "offsetWidth" in w ? w.offsetWidth : t.width, s.value = "offsetHeight" in w ? w.offsetHeight : t.height);
  });
  const c = ri(
    () => zn(e),
    (w) => {
      a.value = w ? t.width : 0, s.value = w ? t.height : 0;
    }
  );
  function y() {
    u(), c();
  }
  return {
    width: a,
    height: s,
    stop: y
  };
}
const IE = {
  name: "Header6",
  components: {
    OrgBanner: ln,
    MobileHeader: In,
    HeaderNav: yE
  },
  mixins: [Fe],
  setup() {
    const e = x0("headerElement"), { width: t } = $E(e);
    return {
      headerWidth: t
    };
  },
  computed: {
    colors() {
      return oe({
        "--utility-bg-color": this.theme.utility_bg_color.hex,
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, AE = {
  key: 0,
  class: "header-container"
}, LE = { class: "org-banner-wrapper" }, OE = {
  key: 1,
  class: "org-banner-wrapper smaller-screen"
}, NE = {
  key: 2,
  class: "bottom-nav"
}, HE = { class: "mobile-header-top" }, PE = { class: "org-banner-wrapper" }, DE = { class: "bottom-nav" }, RE = ["href"];
function VE(e, t, n, o, i, r) {
  const a = S("OrgBanner"), s = S("HeaderNav"), u = S("MobileHeader");
  return l(), h("div", {
    style: H(r.colors),
    class: "h6",
    ref: "headerElement"
  }, [
    e.isMobile ? (l(), _(u, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (c) => e.$emit("toggle-mobile-menu")),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: b(() => [
        d("div", HE, [
          d("div", PE, [
            $(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          d("div", DE, [
            $(s, {
              theme: e.theme,
              content: e.content,
              "show-sign-in-button": e.showSignInButton,
              "sign-in-url": e.signInUrl,
              "text-color": e.theme.utility_link_color.hex,
              "bg-color": e.theme.utility_bg_color.hex,
              "is-mobile": "",
              onLanguageChange: t[6] || (t[6] = (c) => e.$emit("language-change", c)),
              onToggleSearch: t[7] || (t[7] = (c) => e.$emit("toggle-search")),
              onToggleMenu: t[8] || (t[8] = (c) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
            }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color", "bg-color"])
          ])
        ])
      ]),
      "menu-top": b(() => [
        e.showSignInButton && o.headerWidth <= 320 ? (l(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, f(e.signInText), 9, RE)) : g("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"])) : (l(), h("div", AE, [
      o.headerWidth > 1280 ? (l(), _(s, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "show-sign-in-button": e.showSignInButton,
        "sign-in-url": e.signInUrl,
        "large-size": "",
        "text-color": e.theme.navigation_color.hex,
        onLanguageChange: t[0] || (t[0] = (c) => e.$emit("language-change", c)),
        onToggleSearch: t[1] || (t[1] = (c) => e.$emit("toggle-search")),
        onToggleMenu: t[2] || (t[2] = (c) => e.$emit("toggle-menu", c))
      }, {
        default: b(() => [
          d("div", LE, [
            $(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ])
        ]),
        _: 1
      }, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])) : (l(), h("div", OE, [
        $(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals,
          class: "org-banner"
        }, null, 8, ["logo-link", "theme", "globals"])
      ])),
      o.headerWidth <= 1280 ? (l(), h("div", NE, [
        $(s, {
          theme: e.theme,
          content: e.content,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "text-color": e.theme.utility_link_color.hex,
          onLanguageChange: t[3] || (t[3] = (c) => e.$emit("language-change", c)),
          onToggleSearch: t[4] || (t[4] = (c) => e.$emit("toggle-search")),
          onToggleMenu: t[5] || (t[5] = (c) => e.$emit("toggle-menu", c))
        }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])
      ])) : g("", !0)
    ]))
  ], 4);
}
const BE = /* @__PURE__ */ I(IE, [["render", VE], ["__scopeId", "data-v-c53a837d"]]), FE = {
  name: "H7TopBar",
  components: { DraggableWrapper: Ke, MenuItem: it },
  mixins: [Fe, Ze, rt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"]
}, jE = { class: "right-icons" }, UE = { key: 0 }, KE = ["href"];
function GE(e, t, n, o, i, r) {
  const a = S("MenuItem"), s = S("LanguageDropdown"), u = Ne("click-away");
  return l(), h("div", {
    class: "top-bar",
    style: H({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (l(), _(R(n.wrapperComponent), Ce({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (c) => e.$emit("update:utilities", c))
    }), {
      item: b(({ element: c, index: y }) => [
        (l(), _(R(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: c.link,
          target: c.opens_in_new_tab ? "_blank" : ""
        }, {
          default: b(() => [
            C(e.$slots, "utility", { idx: y }, () => [
              k(f(c.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : g("", !0),
    d("div", jE, [
      e.shouldDisplayLanguagesDropdown ? (l(), h("div", UE, [
        $(a, {
          theme: n.theme,
          content: n.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent",
              "--nav-color": n.theme.utility_link_color.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[1] || (t[1] = (c) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        me($(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: n.content.languages,
          styles: n.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": n.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[2] || (t[2] = (c) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            u,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : g("", !0),
      $(a, {
        theme: n.theme,
        content: n.content,
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
      e.showSignInButton && e.screenSize > 320 ? (l(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, f(e.signInText), 9, KE)) : g("", !0),
      e.screenSize <= 320 ? (l(), _(a, {
        key: 2,
        theme: n.theme,
        content: n.content,
        "dropdown-open": n.content.showMenu,
        "theme-overrides": {
          icon: "HamburgerIcon",
          colors: {
            "--fill-color": "transparent",
            "--fill-path-color": n.theme.utility_link_color.hex,
            "--bg-color": "transparent"
          }
        },
        item: "explore-button",
        onToggleDropdown: t[3] || (t[3] = (c) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
      }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : g("", !0)
    ])
  ], 4);
}
const zE = /* @__PURE__ */ I(FE, [["render", GE], ["__scopeId", "data-v-cc378e48"]]), ZE = {
  name: "Header7",
  components: {
    CmsSchoolsMenu: an,
    OrgBanner: ln,
    MobileHeader: In,
    MenuItem: it,
    TopBar: zE
  },
  mixins: [Fe, rt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"],
  computed: {
    colors() {
      return oe({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--text-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, WE = {
  key: 1,
  class: "header-container"
}, qE = { class: "header-container-left" }, YE = { class: "header-container-right" }, xE = {
  key: 0,
  class: "schools-menu-container"
}, XE = { class: "mobile-header-top" }, QE = { class: "org-banner-wrapper" }, JE = ["href"];
function eS(e, t, n, o, i, r) {
  const a = S("TopBar"), s = S("OrgBanner"), u = S("MenuItem"), c = S("HeaderDropdown"), y = S("CmsSchoolsMenu"), w = S("MobileHeader");
  return l(), h("div", {
    style: H(r.colors),
    class: "h7"
  }, [
    !e.isMobile || e.content.isEditing ? (l(), _(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[0] || (t[0] = (v) => e.$emit("update:utilities", v))
    }, {
      utility: b(({ idx: v }) => [
        C(e.$slots, "utility", { idx: v }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"])) : g("", !0),
    !e.isMobile || e.content.isEditing ? (l(), h("div", WE, [
      d("div", qE, [
        $(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      d("div", YE, [
        e.shouldDisplaySchoolsDropdown ? (l(), h("div", xE, [
          $(u, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(c, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[1] || (t[1] = (v) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          $(ye, { name: "slide" }, {
            default: b(() => [
              e.content.hasCustomSchoolsMenu ? (l(), _(y, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[2] || (t[2] = (v) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
            ]),
            _: 1
          })
        ])) : g("", !0),
        d("div", null, [
          $(u, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[3] || (t[3] = (v) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (l(), _(c, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[4] || (t[4] = (v) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : g("", !0)
        ])
      ])
    ])) : (l(), _(w, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[7] || (t[7] = (v) => e.$emit("toggle-mobile-menu", v)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: b(() => [
        $(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[5] || (t[5] = (v) => e.$emit("toggle-mobile-menu", v)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        d("div", XE, [
          d("div", QE, [
            $(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (l(), _(u, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[6] || (t[6] = (v) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : g("", !0)
        ])
      ]),
      "menu-top": b(() => [
        e.showSignInButton && e.screenSize <= 320 ? (l(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, f(e.signInText), 9, JE)) : g("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const tS = /* @__PURE__ */ I(ZE, [["render", eS], ["__scopeId", "data-v-24ce3076"]]), nS = {
  name: "H8TopBar",
  components: { DraggableWrapper: Ke, MenuItem: it },
  mixins: [Fe, Ze, rt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "toggle-mobile-menu", "open-icon-modal"]
}, oS = { class: "right-utilities-wrapper" }, rS = ["innerHTML"], iS = { class: "other-utility-options" }, sS = { key: 0 }, aS = ["href"];
function lS(e, t, n, o, i, r) {
  const a = S("MenuItem"), s = S("LanguageDropdown"), u = Ne("click-away");
  return l(), h("div", {
    class: "top-bar",
    style: H({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (l(), _(R(n.wrapperComponent), Ce({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (c) => e.$emit("update:utilities", c))
    }), {
      item: b(({ element: c, index: y }) => [
        (l(), _(R(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: c.link,
          target: c.opens_in_new_tab ? "_blank" : ""
        }, {
          default: b(() => [
            C(e.$slots, "utility", { idx: y }, () => [
              k(f(c.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : g("", !0),
    d("div", oS, [
      n.content.isEditing || !e.isMobile ? (l(), _(R(n.wrapperComponent), Ce({ key: 0 }, n.wrapperProps, {
        "model-value": n.content.iconLinks,
        "item-key": "idx",
        class: "icon-links-container",
        "data-testid": "icon-links-section",
        "onUpdate:modelValue": t[2] || (t[2] = (c) => e.$emit("update:icon-links", c))
      }), {
        item: b(({ element: c, index: y }) => [
          n.theme.version === "H8" && n.theme.style === "texas" ? (l(), _(R(n.content.isEditing ? "div" : "a"), {
            key: 0,
            class: "icon-link",
            href: c.link,
            target: c.opens_in_new_tab ? "_blank" : "",
            "aria-label": c.name
          }, {
            default: b(() => [
              C(e.$slots, "iconLink", { idx: y }, () => [
                d("span", {
                  "data-testid": "svg",
                  onClick: t[1] || (t[1] = (w) => e.$emit("open-icon-modal")),
                  innerHTML: c.icon
                }, null, 8, rS)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target", "aria-label"])) : g("", !0)
        ]),
        _: 3
      }, 16, ["model-value"])) : g("", !0),
      d("div", iS, [
        e.shouldDisplayLanguagesDropdown ? (l(), h("div", sS, [
          $(a, {
            theme: n.theme,
            content: n.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": n.theme.utility_link_color.hex,
                "--bg-color": "transparent",
                "--nav-color": n.theme.utility_link_color.hex
              }
            },
            item: "languagebutton",
            "dropdown-open": e.languageDropdownVisible,
            onToggleDropdown: t[3] || (t[3] = (c) => e.clickedMenu("languagebutton"))
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
          me($(s, {
            id: "languagesmenu",
            "data-testid": "languages-menu",
            role: "menu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": e.languageDropdownVisible,
            "current-language": n.content.langCode,
            onSetLanguage: e.setLanguage,
            onCloseDropdown: t[4] || (t[4] = (c) => e.languageDropdownVisible = !1)
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
            [
              u,
              () => {
                e.languageDropdownVisible = !1;
              }
            ]
          ])
        ])) : g("", !0),
        $(a, {
          theme: n.theme,
          content: n.content,
          item: "searchbutton",
          "screen-size": e.screenSize,
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
        e.showSignInButton && e.screenSize > 320 ? (l(), h("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          "data-testid": "desktop-signin-button",
          target: "_blank"
        }, f(e.signInText), 9, aS)) : g("", !0),
        e.screenSize <= 320 ? (l(), _(a, {
          key: 2,
          theme: n.theme,
          content: n.content,
          "dropdown-open": n.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent"
            }
          },
          item: "explore-button",
          onToggleDropdown: t[5] || (t[5] = (c) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : g("", !0)
      ])
    ])
  ], 4);
}
const dS = /* @__PURE__ */ I(nS, [["render", lS], ["__scopeId", "data-v-15d54e26"]]), uS = {
  name: "Header8",
  components: {
    CmsSchoolsMenu: an,
    OrgBanner: ln,
    MobileHeader: In,
    MenuItem: it,
    H8TopBar: dS
  },
  mixins: [Fe, rt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "open-icon-modal", "toggle-mobile-menu"],
  computed: {
    colors() {
      return oe({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--icon-link-color": this.theme.icon_link_color.hex
      }, this.signInColors);
    }
  }
}, cS = {
  key: 1,
  class: "header-container"
}, hS = { class: "header-container-left" }, mS = { class: "header-container-right" }, pS = {
  key: 0,
  class: "schools-menu-container"
}, fS = { class: "mobile-header-top" }, gS = { class: "org-banner-wrapper" }, vS = ["href"];
function bS(e, t, n, o, i, r) {
  const a = S("H8TopBar"), s = S("OrgBanner"), u = S("MenuItem"), c = S("HeaderDropdown"), y = S("CmsSchoolsMenu"), w = S("MobileHeader");
  return l(), h("div", {
    style: H(r.colors),
    class: "h8"
  }, [
    !e.isMobile || e.content.isEditing ? (l(), _(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onOpenIconModal: t[0] || (t[0] = (v) => e.$emit("open-icon-modal", v)),
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[1] || (t[1] = (v) => e.$emit("update:utilities", v)),
      "onUpdate:iconLinks": t[2] || (t[2] = (v) => e.$emit("update:icon-links", v))
    }, {
      utility: b(({ idx: v }) => [
        C(e.$slots, "utility", { idx: v }, void 0, !0)
      ]),
      iconLink: b(({ idx: v }) => [
        C(e.$slots, "iconLink", { idx: v }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"])) : g("", !0),
    !e.isMobile || e.content.isEditing ? (l(), h("div", cS, [
      d("div", hS, [
        $(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      d("div", mS, [
        e.shouldDisplaySchoolsDropdown ? (l(), h("div", pS, [
          $(u, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), _(c, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[3] || (t[3] = (v) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          $(ye, { name: "slide" }, {
            default: b(() => [
              e.content.hasCustomSchoolsMenu ? (l(), _(y, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[4] || (t[4] = (v) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : g("", !0)
            ]),
            _: 1
          })
        ])) : g("", !0),
        d("div", null, [
          $(u, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[5] || (t[5] = (v) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (l(), _(c, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[6] || (t[6] = (v) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : g("", !0)
        ])
      ])
    ])) : (l(), _(w, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (v) => e.$emit("toggle-mobile-menu", v)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: b(() => [
        $(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[7] || (t[7] = (v) => e.$emit("toggle-mobile-menu", v)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        d("div", fS, [
          d("div", gS, [
            $(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (l(), _(u, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[8] || (t[8] = (v) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : g("", !0)
        ])
      ]),
      "menu-top": b(() => [
        e.showSignInButton && e.screenSize <= 320 ? (l(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, f(e.signInText), 9, vS)) : g("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const yS = /* @__PURE__ */ I(uS, [["render", bS], ["__scopeId", "data-v-32b1c780"]]);
var CS = Object.defineProperty, _S = Object.defineProperties, wS = Object.getOwnPropertyDescriptors, Pl = Object.getOwnPropertySymbols, TS = Object.prototype.hasOwnProperty, kS = Object.prototype.propertyIsEnumerable, Dl = (e, t, n) => t in e ? CS(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Vt = (e, t) => {
  for (var n in t || (t = {}))
    TS.call(t, n) && Dl(e, n, t[n]);
  if (Pl)
    for (var n of Pl(t))
      kS.call(t, n) && Dl(e, n, t[n]);
  return e;
}, ca = (e, t) => _S(e, wS(t));
function Rl(e) {
  if (e)
    throw e;
}
var dr = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function so(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var ES = function(e) {
  return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
};
const yc = /* @__PURE__ */ so(ES);
var $r = Object.prototype.hasOwnProperty, Cc = Object.prototype.toString, Vl = Object.defineProperty, Bl = Object.getOwnPropertyDescriptor, Fl = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : Cc.call(e) === "[object Array]";
}, jl = function(e) {
  if (!e || Cc.call(e) !== "[object Object]")
    return !1;
  var t = $r.call(e, "constructor"), n = e.constructor && e.constructor.prototype && $r.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !t && !n)
    return !1;
  var o;
  for (o in e)
    ;
  return typeof o == "undefined" || $r.call(e, o);
}, Ul = function(e, t) {
  Vl && t.name === "__proto__" ? Vl(e, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : e[t.name] = t.newValue;
}, Kl = function(e, t) {
  if (t === "__proto__")
    if ($r.call(e, t)) {
      if (Bl)
        return Bl(e, t).value;
    } else return;
  return e[t];
}, SS = function e() {
  var t, n, o, i, r, a, s = arguments[0], u = 1, c = arguments.length, y = !1;
  for (typeof s == "boolean" && (y = s, s = arguments[1] || {}, u = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); u < c; ++u)
    if (t = arguments[u], t != null)
      for (n in t)
        o = Kl(s, n), i = Kl(t, n), s !== i && (y && i && (jl(i) || (r = Fl(i))) ? (r ? (r = !1, a = o && Fl(o) ? o : []) : a = o && jl(o) ? o : {}, Ul(s, { name: n, newValue: e(y, a, i) })) : typeof i != "undefined" && Ul(s, { name: n, newValue: i }));
  return s;
};
const Gl = /* @__PURE__ */ so(SS);
function Ps(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function MS() {
  const e = [], t = { run: n, use: o };
  return t;
  function n(...i) {
    let r = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(u, ...c) {
      const y = e[++r];
      let w = -1;
      if (u) {
        a(u);
        return;
      }
      for (; ++w < i.length; )
        (c[w] === null || c[w] === void 0) && (c[w] = i[w]);
      i = c, y ? $S(y, s)(...c) : a(null, ...c);
    }
  }
  function o(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function $S(e, t) {
  let n;
  return o;
  function o(...a) {
    const s = e.length > a.length;
    let u;
    s && a.push(i);
    try {
      u = e.apply(this, a);
    } catch (c) {
      const y = (
        /** @type {Error} */
        c
      );
      if (s && n)
        throw y;
      return i(y);
    }
    s || (u && u.then && typeof u.then == "function" ? u.then(r, i) : u instanceof Error ? i(u) : r(u));
  }
  function i(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function r(a) {
    i(null, a);
  }
}
function IS(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? zl(e.position) : "start" in e || "end" in e ? zl(e) : "line" in e || "column" in e ? Ds(e) : "";
}
function Ds(e) {
  return Zl(e && e.line) + ":" + Zl(e && e.column);
}
function zl(e) {
  return Ds(e && e.start) + "-" + Ds(e && e.end);
}
function Zl(e) {
  return e && typeof e == "number" ? e : 1;
}
class ut extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, o) {
    const i = [null, null];
    let r = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (o = n, n = void 0), typeof o == "string") {
      const a = o.indexOf(":");
      a === -1 ? i[1] = o : (i[0] = o.slice(0, a), i[1] = o.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (r = n.position) : "start" in n || "end" in n ? r = n : ("line" in n || "column" in n) && (r.start = n)), this.name = IS(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = r.start.line, this.column = r.start.column, this.position = r, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
ut.prototype.file = "";
ut.prototype.name = "";
ut.prototype.reason = "";
ut.prototype.message = "";
ut.prototype.stack = "";
ut.prototype.fatal = null;
ut.prototype.column = null;
ut.prototype.line = null;
ut.prototype.source = null;
ut.prototype.ruleId = null;
ut.prototype.position = null;
const Et = { basename: AS, dirname: LS, extname: OS, join: NS, sep: "/" };
function AS(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Jo(e);
  let n = 0, o = -1, i = e.length, r;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (r) {
          n = i + 1;
          break;
        }
      } else o < 0 && (r = !0, o = i + 1);
    return o < 0 ? "" : e.slice(n, o);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (r) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (r = !0, a = i + 1), s > -1 && (e.charCodeAt(i) === t.charCodeAt(s--) ? s < 0 && (o = i) : (s = -1, o = a));
  return n === o ? o = a : o < 0 && (o = e.length), e.slice(n, o);
}
function LS(e) {
  if (Jo(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, o;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (o) {
        t = n;
        break;
      }
    } else o || (o = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function OS(e) {
  Jo(e);
  let t = e.length, n = -1, o = 0, i = -1, r = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        o = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : r !== 1 && (r = 1) : i > -1 && (r = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  r === 0 || // The (right-most) trimmed path component is exactly `..`.
  r === 1 && i === n - 1 && i === o + 1 ? "" : e.slice(i, n);
}
function NS(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Jo(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : HS(n);
}
function HS(e) {
  Jo(e);
  const t = e.charCodeAt(0) === 47;
  let n = PS(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function PS(e, t) {
  let n = "", o = 0, i = -1, r = 0, a = -1, s, u;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || r === 1)) if (i !== a - 1 && r === 2) {
        if (n.length < 2 || o !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", o = 0) : (n = n.slice(0, u), o = n.length - 1 - n.lastIndexOf("/")), i = a, r = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", o = 0, i = a, r = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", o = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), o = a - i - 1;
      i = a, r = 0;
    } else s === 46 && r > -1 ? r++ : r = -1;
  }
  return n;
}
function Jo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const DS = { cwd: RS };
function RS() {
  return "/";
}
function Rs(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function VS(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Rs(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return BS(e);
}
function BS(e) {
  if (e.hostname !== "") {
    const o = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw o.code = "ERR_INVALID_FILE_URL_HOST", o;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const o = t.charCodeAt(n + 2);
      if (o === 70 || o === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const qi = ["history", "path", "basename", "stem", "extname", "dirname"];
class FS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || jS(t) ? n = { value: t } : Rs(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = DS.cwd(), this.value, this.stored, this.result, this.map;
    let o = -1;
    for (; ++o < qi.length; ) {
      const r = qi[o];
      r in n && n[r] !== void 0 && n[r] !== null && (this[r] = r === "history" ? [...n[r]] : n[r]);
    }
    let i;
    for (i in n)
      qi.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    Rs(t) && (t = VS(t)), xi(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Et.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Wl(this.basename, "dirname"), this.path = Et.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Et.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    xi(t, "basename"), Yi(t, "basename"), this.path = Et.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Et.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Yi(t, "extname"), Wl(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Et.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Et.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    xi(t, "stem"), Yi(t, "stem"), this.path = Et.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, o) {
    const i = new ut(t, n, o);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, o) {
    const i = this.message(t, n, o);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, o) {
    const i = this.message(t, n, o);
    throw i.fatal = !0, i;
  }
}
function Yi(e, t) {
  if (e && e.includes(Et.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Et.sep + "`"
    );
}
function xi(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Wl(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function jS(e) {
  return yc(e);
}
const Vs = wc().freeze(), _c = {}.hasOwnProperty;
function wc() {
  const e = MS(), t = [];
  let n = {}, o, i = -1;
  return r.data = a, r.Parser = void 0, r.Compiler = void 0, r.freeze = s, r.attachers = t, r.use = u, r.parse = c, r.stringify = y, r.run = w, r.runSync = v, r.process = E, r.processSync = F, r;
  function r() {
    const O = wc();
    let L = -1;
    for (; ++L < t.length; )
      O.use(...t[L]);
    return O.data(Gl(!0, {}, n)), O;
  }
  function a(O, L) {
    return typeof O == "string" ? arguments.length === 2 ? (Ji("data", o), n[O] = L, r) : _c.call(n, O) && n[O] || null : O ? (Ji("data", o), n = O, r) : n;
  }
  function s() {
    if (o)
      return r;
    for (; ++i < t.length; ) {
      const [O, ...L] = t[i];
      if (L[0] === !1)
        continue;
      L[0] === !0 && (L[0] = void 0);
      const U = O.call(r, ...L);
      typeof U == "function" && e.use(U);
    }
    return o = !0, i = Number.POSITIVE_INFINITY, r;
  }
  function u(O, ...L) {
    let U;
    if (Ji("use", o), O != null) if (typeof O == "function")
      Y(O, ...L);
    else if (typeof O == "object")
      Array.isArray(O) ? j(O) : B(O);
    else
      throw new TypeError("Expected usable value, not `" + O + "`");
    return U && (n.settings = Object.assign(n.settings || {}, U)), r;
    function z(K) {
      if (typeof K == "function")
        Y(K);
      else if (typeof K == "object")
        if (Array.isArray(K)) {
          const [ne, ...te] = K;
          Y(ne, ...te);
        } else
          B(K);
      else
        throw new TypeError("Expected usable value, not `" + K + "`");
    }
    function B(K) {
      j(K.plugins), K.settings && (U = Object.assign(U || {}, K.settings));
    }
    function j(K) {
      let ne = -1;
      if (K != null) if (Array.isArray(K))
        for (; ++ne < K.length; ) {
          const te = K[ne];
          z(te);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + K + "`");
    }
    function Y(K, ne) {
      let te = -1, le;
      for (; ++te < t.length; )
        if (t[te][0] === K) {
          le = t[te];
          break;
        }
      le ? (Ps(le[1]) && Ps(ne) && (ne = Gl(!0, le[1], ne)), le[1] = ne) : t.push([...arguments]);
    }
  }
  function c(O) {
    r.freeze();
    const L = _o(O), U = r.Parser;
    return Xi("parse", U), ql(U, "parse") ? new U(String(L), L).parse() : U(String(L), L);
  }
  function y(O, L) {
    r.freeze();
    const U = _o(L), z = r.Compiler;
    return Qi("stringify", z), Yl(O), ql(z, "compile") ? new z(O, U).compile() : z(O, U);
  }
  function w(O, L, U) {
    if (Yl(O), r.freeze(), !U && typeof L == "function" && (U = L, L = void 0), !U)
      return new Promise(z);
    z(null, U);
    function z(B, j) {
      e.run(O, _o(L), Y);
      function Y(K, ne, te) {
        ne = ne || O, K ? j(K) : B ? B(ne) : U(null, ne, te);
      }
    }
  }
  function v(O, L) {
    let U, z;
    return r.run(O, L, B), xl("runSync", "run", z), U;
    function B(j, Y) {
      Rl(j), U = Y, z = !0;
    }
  }
  function E(O, L) {
    if (r.freeze(), Xi("process", r.Parser), Qi("process", r.Compiler), !L)
      return new Promise(U);
    U(null, L);
    function U(z, B) {
      const j = _o(O);
      r.run(r.parse(j), j, (K, ne, te) => {
        if (K || !ne || !te)
          Y(K);
        else {
          const le = r.stringify(ne, te);
          le == null || (GS(le) ? te.value = le : te.result = le), Y(K, te);
        }
      });
      function Y(K, ne) {
        K || !ne ? B(K) : z ? z(ne) : L(null, ne);
      }
    }
  }
  function F(O) {
    let L;
    r.freeze(), Xi("processSync", r.Parser), Qi("processSync", r.Compiler);
    const U = _o(O);
    return r.process(U, z), xl("processSync", "process", L), U;
    function z(B) {
      L = !0, Rl(B);
    }
  }
}
function ql(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (US(e.prototype) || t in e.prototype);
}
function US(e) {
  let t;
  for (t in e)
    if (_c.call(e, t))
      return !0;
  return !1;
}
function Xi(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Qi(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Ji(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Yl(e) {
  if (!Ps(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function xl(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function _o(e) {
  return KS(e) ? e : new FS(e);
}
function KS(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function GS(e) {
  return typeof e == "string" || yc(e);
}
var _t = {};
const zS = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
_t.REPLACEMENT_CHARACTER = "�";
_t.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
_t.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
_t.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
_t.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
_t.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
_t.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
_t.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || zS.indexOf(e) > -1;
};
var ha = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const Un = _t, es = ha, cn = Un.CODE_POINTS, ZS = 65536;
let WS = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = ZS;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.lastCharPos) {
      const t = this.html.charCodeAt(this.pos + 1);
      if (Un.isSurrogatePair(t))
        return this.pos++, this._addGap(), Un.getSurrogatePairCodePoint(e, t);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, cn.EOF;
    return this._err(es.surrogateInInputStream), e;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(e, t) {
    this.html ? this.html += e : this.html = e, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = t;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, cn.EOF;
    let e = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && e === cn.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : e === cn.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, cn.LINE_FEED) : (this.skipNextNewLine = !1, Un.isSurrogate(e) && (e = this._processSurrogate(e)), e > 31 && e < 127 || e === cn.LINE_FEED || e === cn.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    Un.isControlCodePoint(e) ? this._err(es.controlCharacterInInputStream) : Un.isUndefinedCodePoint(e) && this._err(es.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var qS = WS, YS = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const xS = qS, _e = _t, _n = YS, W = ha, M = _e.CODE_POINTS, hn = _e.CODE_POINT_SEQUENCES, XS = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, Tc = 1, kc = 2, Ec = 4, QS = Tc | kc | Ec, pe = "DATA_STATE", Kn = "RCDATA_STATE", Ro = "RAWTEXT_STATE", Rt = "SCRIPT_DATA_STATE", Sc = "PLAINTEXT_STATE", Xl = "TAG_OPEN_STATE", Ql = "END_TAG_OPEN_STATE", ts = "TAG_NAME_STATE", Jl = "RCDATA_LESS_THAN_SIGN_STATE", e1 = "RCDATA_END_TAG_OPEN_STATE", t1 = "RCDATA_END_TAG_NAME_STATE", n1 = "RAWTEXT_LESS_THAN_SIGN_STATE", o1 = "RAWTEXT_END_TAG_OPEN_STATE", r1 = "RAWTEXT_END_TAG_NAME_STATE", i1 = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", s1 = "SCRIPT_DATA_END_TAG_OPEN_STATE", a1 = "SCRIPT_DATA_END_TAG_NAME_STATE", l1 = "SCRIPT_DATA_ESCAPE_START_STATE", d1 = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", pt = "SCRIPT_DATA_ESCAPED_STATE", u1 = "SCRIPT_DATA_ESCAPED_DASH_STATE", ns = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", ur = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", c1 = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", h1 = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", m1 = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", Ot = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", p1 = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", f1 = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", cr = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", g1 = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", kt = "BEFORE_ATTRIBUTE_NAME_STATE", hr = "ATTRIBUTE_NAME_STATE", os = "AFTER_ATTRIBUTE_NAME_STATE", rs = "BEFORE_ATTRIBUTE_VALUE_STATE", mr = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", pr = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", fr = "ATTRIBUTE_VALUE_UNQUOTED_STATE", is = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", Zt = "SELF_CLOSING_START_TAG_STATE", wo = "BOGUS_COMMENT_STATE", v1 = "MARKUP_DECLARATION_OPEN_STATE", b1 = "COMMENT_START_STATE", y1 = "COMMENT_START_DASH_STATE", Wt = "COMMENT_STATE", C1 = "COMMENT_LESS_THAN_SIGN_STATE", _1 = "COMMENT_LESS_THAN_SIGN_BANG_STATE", w1 = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", T1 = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", gr = "COMMENT_END_DASH_STATE", vr = "COMMENT_END_STATE", k1 = "COMMENT_END_BANG_STATE", E1 = "DOCTYPE_STATE", br = "BEFORE_DOCTYPE_NAME_STATE", yr = "DOCTYPE_NAME_STATE", S1 = "AFTER_DOCTYPE_NAME_STATE", M1 = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", $1 = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", ss = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", as = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", ls = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", I1 = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", A1 = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", L1 = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", To = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", ko = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", ds = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Nt = "BOGUS_DOCTYPE_STATE", Cr = "CDATA_SECTION_STATE", O1 = "CDATA_SECTION_BRACKET_STATE", N1 = "CDATA_SECTION_END_STATE", Rn = "CHARACTER_REFERENCE_STATE", H1 = "NAMED_CHARACTER_REFERENCE_STATE", P1 = "AMBIGUOS_AMPERSAND_STATE", D1 = "NUMERIC_CHARACTER_REFERENCE_STATE", R1 = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", V1 = "DECIMAL_CHARACTER_REFERENCE_START_STATE", B1 = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", F1 = "DECIMAL_CHARACTER_REFERENCE_STATE", Eo = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function Ie(e) {
  return e === M.SPACE || e === M.LINE_FEED || e === M.TABULATION || e === M.FORM_FEED;
}
function Bo(e) {
  return e >= M.DIGIT_0 && e <= M.DIGIT_9;
}
function gt(e) {
  return e >= M.LATIN_CAPITAL_A && e <= M.LATIN_CAPITAL_Z;
}
function gn(e) {
  return e >= M.LATIN_SMALL_A && e <= M.LATIN_SMALL_Z;
}
function Xt(e) {
  return gn(e) || gt(e);
}
function us(e) {
  return Xt(e) || Bo(e);
}
function Mc(e) {
  return e >= M.LATIN_CAPITAL_A && e <= M.LATIN_CAPITAL_F;
}
function $c(e) {
  return e >= M.LATIN_SMALL_A && e <= M.LATIN_SMALL_F;
}
function JS(e) {
  return Bo(e) || Mc(e) || $c(e);
}
function Ir(e) {
  return e + 32;
}
function He(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function qt(e) {
  return String.fromCharCode(Ir(e));
}
function j1(e, t) {
  const n = _n[++e];
  let o = ++e, i = o + n - 1;
  for (; o <= i; ) {
    const r = o + i >>> 1, a = _n[r];
    if (a < t)
      o = r + 1;
    else if (a > t)
      i = r - 1;
    else
      return _n[r + n];
  }
  return -1;
}
let ct = class qe {
  constructor() {
    this.preprocessor = new xS(), this.tokenQueue = [], this.allowCDATA = !1, this.state = pe, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, n) {
    this.active = !0, this.preprocessor.write(t, n);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: qe.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, n, o) {
    let i = 0, r = !0;
    const a = t.length;
    let s = 0, u = n, c;
    for (; s < a; s++) {
      if (s > 0 && (u = this._consume(), i++), u === M.EOF) {
        r = !1;
        break;
      }
      if (c = t[s], u !== c && (o || u !== Ir(c))) {
        r = !1;
        break;
      }
    }
    if (!r)
      for (; i--; )
        this._unconsume();
    return r;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== hn.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== hn.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: qe.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: qe.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: qe.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: qe.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: qe.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    qe.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(W.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === qe.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === qe.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(W.endTagWithAttributes), t.selfClosing && this._err(W.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    let n = qe.CHARACTER_TOKEN;
    Ie(t) ? n = qe.WHITESPACE_CHARACTER_TOKEN : t === M.NULL && (n = qe.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, He(t));
  }
  _emitSeveralCodePoints(t) {
    for (let n = 0; n < t.length; n++)
      this._emitCodePoint(t[n]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(qe.CHARACTER_TOKEN, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let n = null, o = 1, i = j1(0, t);
    for (this.tempBuff.push(t); i > -1; ) {
      const r = _n[i], a = r < QS;
      a && r & Tc && (n = r & kc ? [_n[++i], _n[++i]] : [_n[++i]], o = 0);
      const s = this._consume();
      if (this.tempBuff.push(s), o++, s === M.EOF)
        break;
      a ? i = r & Ec ? j1(i, s) : -1 : i = s === r ? ++i : -1;
    }
    for (; o--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === mr || this.returnState === pr || this.returnState === fr;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === M.EQUALS_SIGN || us(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += He(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [pe](t) {
    this.preprocessor.dropParsedChunk(), t === M.LESS_THAN_SIGN ? this.state = Xl : t === M.AMPERSAND ? (this.returnState = pe, this.state = Rn) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitCodePoint(t)) : t === M.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [Kn](t) {
    this.preprocessor.dropParsedChunk(), t === M.AMPERSAND ? (this.returnState = Kn, this.state = Rn) : t === M.LESS_THAN_SIGN ? this.state = Jl : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [Ro](t) {
    this.preprocessor.dropParsedChunk(), t === M.LESS_THAN_SIGN ? this.state = n1 : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Script data state
  //------------------------------------------------------------------
  [Rt](t) {
    this.preprocessor.dropParsedChunk(), t === M.LESS_THAN_SIGN ? this.state = i1 : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [Sc](t) {
    this.preprocessor.dropParsedChunk(), t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Tag open state
  //------------------------------------------------------------------
  [Xl](t) {
    t === M.EXCLAMATION_MARK ? this.state = v1 : t === M.SOLIDUS ? this.state = Ql : Xt(t) ? (this._createStartTagToken(), this._reconsumeInState(ts)) : t === M.QUESTION_MARK ? (this._err(W.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(wo)) : t === M.EOF ? (this._err(W.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(W.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(pe));
  }
  // End tag open state
  //------------------------------------------------------------------
  [Ql](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(ts)) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingEndTagName), this.state = pe) : t === M.EOF ? (this._err(W.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(W.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(wo));
  }
  // Tag name state
  //------------------------------------------------------------------
  [ts](t) {
    Ie(t) ? this.state = kt : t === M.SOLIDUS ? this.state = Zt : t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : gt(t) ? this.currentToken.tagName += qt(t) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.tagName += _e.REPLACEMENT_CHARACTER) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += He(t);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [Jl](t) {
    t === M.SOLIDUS ? (this.tempBuff = [], this.state = e1) : (this._emitChars("<"), this._reconsumeInState(Kn));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [e1](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(t1)) : (this._emitChars("</"), this._reconsumeInState(Kn));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [t1](t) {
    if (gt(t))
      this.currentToken.tagName += qt(t), this.tempBuff.push(t);
    else if (gn(t))
      this.currentToken.tagName += He(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ie(t)) {
          this.state = kt;
          return;
        }
        if (t === M.SOLIDUS) {
          this.state = Zt;
          return;
        }
        if (t === M.GREATER_THAN_SIGN) {
          this.state = pe, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Kn);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [n1](t) {
    t === M.SOLIDUS ? (this.tempBuff = [], this.state = o1) : (this._emitChars("<"), this._reconsumeInState(Ro));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [o1](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(r1)) : (this._emitChars("</"), this._reconsumeInState(Ro));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [r1](t) {
    if (gt(t))
      this.currentToken.tagName += qt(t), this.tempBuff.push(t);
    else if (gn(t))
      this.currentToken.tagName += He(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ie(t)) {
          this.state = kt;
          return;
        }
        if (t === M.SOLIDUS) {
          this.state = Zt;
          return;
        }
        if (t === M.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = pe;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Ro);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [i1](t) {
    t === M.SOLIDUS ? (this.tempBuff = [], this.state = s1) : t === M.EXCLAMATION_MARK ? (this.state = l1, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(Rt));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [s1](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(a1)) : (this._emitChars("</"), this._reconsumeInState(Rt));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [a1](t) {
    if (gt(t))
      this.currentToken.tagName += qt(t), this.tempBuff.push(t);
    else if (gn(t))
      this.currentToken.tagName += He(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ie(t)) {
          this.state = kt;
          return;
        } else if (t === M.SOLIDUS) {
          this.state = Zt;
          return;
        } else if (t === M.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = pe;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Rt);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [l1](t) {
    t === M.HYPHEN_MINUS ? (this.state = d1, this._emitChars("-")) : this._reconsumeInState(Rt);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [d1](t) {
    t === M.HYPHEN_MINUS ? (this.state = ns, this._emitChars("-")) : this._reconsumeInState(Rt);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [pt](t) {
    t === M.HYPHEN_MINUS ? (this.state = u1, this._emitChars("-")) : t === M.LESS_THAN_SIGN ? this.state = ur : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [u1](t) {
    t === M.HYPHEN_MINUS ? (this.state = ns, this._emitChars("-")) : t === M.LESS_THAN_SIGN ? this.state = ur : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.state = pt, this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = pt, this._emitCodePoint(t));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [ns](t) {
    t === M.HYPHEN_MINUS ? this._emitChars("-") : t === M.LESS_THAN_SIGN ? this.state = ur : t === M.GREATER_THAN_SIGN ? (this.state = Rt, this._emitChars(">")) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.state = pt, this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = pt, this._emitCodePoint(t));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [ur](t) {
    t === M.SOLIDUS ? (this.tempBuff = [], this.state = c1) : Xt(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(m1)) : (this._emitChars("<"), this._reconsumeInState(pt));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [c1](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(h1)) : (this._emitChars("</"), this._reconsumeInState(pt));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [h1](t) {
    if (gt(t))
      this.currentToken.tagName += qt(t), this.tempBuff.push(t);
    else if (gn(t))
      this.currentToken.tagName += He(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ie(t)) {
          this.state = kt;
          return;
        }
        if (t === M.SOLIDUS) {
          this.state = Zt;
          return;
        }
        if (t === M.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = pe;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(pt);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [m1](t) {
    Ie(t) || t === M.SOLIDUS || t === M.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? Ot : pt, this._emitCodePoint(t)) : gt(t) ? (this.tempBuff.push(Ir(t)), this._emitCodePoint(t)) : gn(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(pt);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [Ot](t) {
    t === M.HYPHEN_MINUS ? (this.state = p1, this._emitChars("-")) : t === M.LESS_THAN_SIGN ? (this.state = cr, this._emitChars("<")) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [p1](t) {
    t === M.HYPHEN_MINUS ? (this.state = f1, this._emitChars("-")) : t === M.LESS_THAN_SIGN ? (this.state = cr, this._emitChars("<")) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.state = Ot, this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Ot, this._emitCodePoint(t));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [f1](t) {
    t === M.HYPHEN_MINUS ? this._emitChars("-") : t === M.LESS_THAN_SIGN ? (this.state = cr, this._emitChars("<")) : t === M.GREATER_THAN_SIGN ? (this.state = Rt, this._emitChars(">")) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.state = Ot, this._emitChars(_e.REPLACEMENT_CHARACTER)) : t === M.EOF ? (this._err(W.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Ot, this._emitCodePoint(t));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [cr](t) {
    t === M.SOLIDUS ? (this.tempBuff = [], this.state = g1, this._emitChars("/")) : this._reconsumeInState(Ot);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [g1](t) {
    Ie(t) || t === M.SOLIDUS || t === M.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? pt : Ot, this._emitCodePoint(t)) : gt(t) ? (this.tempBuff.push(Ir(t)), this._emitCodePoint(t)) : gn(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(Ot);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [kt](t) {
    Ie(t) || (t === M.SOLIDUS || t === M.GREATER_THAN_SIGN || t === M.EOF ? this._reconsumeInState(os) : t === M.EQUALS_SIGN ? (this._err(W.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = hr) : (this._createAttr(""), this._reconsumeInState(hr)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [hr](t) {
    Ie(t) || t === M.SOLIDUS || t === M.GREATER_THAN_SIGN || t === M.EOF ? (this._leaveAttrName(os), this._unconsume()) : t === M.EQUALS_SIGN ? this._leaveAttrName(rs) : gt(t) ? this.currentAttr.name += qt(t) : t === M.QUOTATION_MARK || t === M.APOSTROPHE || t === M.LESS_THAN_SIGN ? (this._err(W.unexpectedCharacterInAttributeName), this.currentAttr.name += He(t)) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentAttr.name += _e.REPLACEMENT_CHARACTER) : this.currentAttr.name += He(t);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [os](t) {
    Ie(t) || (t === M.SOLIDUS ? this.state = Zt : t === M.EQUALS_SIGN ? this.state = rs : t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(hr)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [rs](t) {
    Ie(t) || (t === M.QUOTATION_MARK ? this.state = mr : t === M.APOSTROPHE ? this.state = pr : t === M.GREATER_THAN_SIGN ? (this._err(W.missingAttributeValue), this.state = pe, this._emitCurrentToken()) : this._reconsumeInState(fr));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [mr](t) {
    t === M.QUOTATION_MARK ? this.state = is : t === M.AMPERSAND ? (this.returnState = mr, this.state = Rn) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentAttr.value += _e.REPLACEMENT_CHARACTER) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : this.currentAttr.value += He(t);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [pr](t) {
    t === M.APOSTROPHE ? this.state = is : t === M.AMPERSAND ? (this.returnState = pr, this.state = Rn) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentAttr.value += _e.REPLACEMENT_CHARACTER) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : this.currentAttr.value += He(t);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [fr](t) {
    Ie(t) ? this._leaveAttrValue(kt) : t === M.AMPERSAND ? (this.returnState = fr, this.state = Rn) : t === M.GREATER_THAN_SIGN ? (this._leaveAttrValue(pe), this._emitCurrentToken()) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentAttr.value += _e.REPLACEMENT_CHARACTER) : t === M.QUOTATION_MARK || t === M.APOSTROPHE || t === M.LESS_THAN_SIGN || t === M.EQUALS_SIGN || t === M.GRAVE_ACCENT ? (this._err(W.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += He(t)) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : this.currentAttr.value += He(t);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [is](t) {
    Ie(t) ? this._leaveAttrValue(kt) : t === M.SOLIDUS ? this._leaveAttrValue(Zt) : t === M.GREATER_THAN_SIGN ? (this._leaveAttrValue(pe), this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : (this._err(W.missingWhitespaceBetweenAttributes), this._reconsumeInState(kt));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [Zt](t) {
    t === M.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInTag), this._emitEOFToken()) : (this._err(W.unexpectedSolidusInTag), this._reconsumeInState(kt));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [wo](t) {
    t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.data += _e.REPLACEMENT_CHARACTER) : this.currentToken.data += He(t);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [v1](t) {
    this._consumeSequenceIfMatch(hn.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = b1) : this._consumeSequenceIfMatch(hn.DOCTYPE_STRING, t, !1) ? this.state = E1 : this._consumeSequenceIfMatch(hn.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = Cr : (this._err(W.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = wo) : this._ensureHibernation() || (this._err(W.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(wo));
  }
  // Comment start state
  //------------------------------------------------------------------
  [b1](t) {
    t === M.HYPHEN_MINUS ? this.state = y1 : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptClosingOfEmptyComment), this.state = pe, this._emitCurrentToken()) : this._reconsumeInState(Wt);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [y1](t) {
    t === M.HYPHEN_MINUS ? this.state = vr : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptClosingOfEmptyComment), this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Wt));
  }
  // Comment state
  //------------------------------------------------------------------
  [Wt](t) {
    t === M.HYPHEN_MINUS ? this.state = gr : t === M.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = C1) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.data += _e.REPLACEMENT_CHARACTER) : t === M.EOF ? (this._err(W.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += He(t);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [C1](t) {
    t === M.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = _1) : t === M.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Wt);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [_1](t) {
    t === M.HYPHEN_MINUS ? this.state = w1 : this._reconsumeInState(Wt);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [w1](t) {
    t === M.HYPHEN_MINUS ? this.state = T1 : this._reconsumeInState(gr);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [T1](t) {
    t !== M.GREATER_THAN_SIGN && t !== M.EOF && this._err(W.nestedComment), this._reconsumeInState(vr);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [gr](t) {
    t === M.HYPHEN_MINUS ? this.state = vr : t === M.EOF ? (this._err(W.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Wt));
  }
  // Comment end state
  //------------------------------------------------------------------
  [vr](t) {
    t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : t === M.EXCLAMATION_MARK ? this.state = k1 : t === M.HYPHEN_MINUS ? this.currentToken.data += "-" : t === M.EOF ? (this._err(W.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Wt));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [k1](t) {
    t === M.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = gr) : t === M.GREATER_THAN_SIGN ? (this._err(W.incorrectlyClosedComment), this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Wt));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [E1](t) {
    Ie(t) ? this.state = br : t === M.GREATER_THAN_SIGN ? this._reconsumeInState(br) : t === M.EOF ? (this._err(W.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(br));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [br](t) {
    Ie(t) || (gt(t) ? (this._createDoctypeToken(qt(t)), this.state = yr) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this._createDoctypeToken(_e.REPLACEMENT_CHARACTER), this.state = yr) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(He(t)), this.state = yr));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [yr](t) {
    Ie(t) ? this.state = S1 : t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : gt(t) ? this.currentToken.name += qt(t) : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.name += _e.REPLACEMENT_CHARACTER) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += He(t);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [S1](t) {
    Ie(t) || (t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(hn.PUBLIC_STRING, t, !1) ? this.state = M1 : this._consumeSequenceIfMatch(hn.SYSTEM_STRING, t, !1) ? this.state = A1 : this._ensureHibernation() || (this._err(W.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [M1](t) {
    Ie(t) ? this.state = $1 : t === M.QUOTATION_MARK ? (this._err(W.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = ss) : t === M.APOSTROPHE ? (this._err(W.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = as) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [$1](t) {
    Ie(t) || (t === M.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = ss) : t === M.APOSTROPHE ? (this.currentToken.publicId = "", this.state = as) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [ss](t) {
    t === M.QUOTATION_MARK ? this.state = ls : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.publicId += _e.REPLACEMENT_CHARACTER) : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += He(t);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [as](t) {
    t === M.APOSTROPHE ? this.state = ls : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.publicId += _e.REPLACEMENT_CHARACTER) : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += He(t);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [ls](t) {
    Ie(t) ? this.state = I1 : t === M.GREATER_THAN_SIGN ? (this.state = pe, this._emitCurrentToken()) : t === M.QUOTATION_MARK ? (this._err(W.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = To) : t === M.APOSTROPHE ? (this._err(W.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = ko) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [I1](t) {
    Ie(t) || (t === M.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = pe) : t === M.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = To) : t === M.APOSTROPHE ? (this.currentToken.systemId = "", this.state = ko) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [A1](t) {
    Ie(t) ? this.state = L1 : t === M.QUOTATION_MARK ? (this._err(W.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = To) : t === M.APOSTROPHE ? (this._err(W.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = ko) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [L1](t) {
    Ie(t) || (t === M.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = To) : t === M.APOSTROPHE ? (this.currentToken.systemId = "", this.state = ko) : t === M.GREATER_THAN_SIGN ? (this._err(W.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = pe, this._emitCurrentToken()) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Nt)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [To](t) {
    t === M.QUOTATION_MARK ? this.state = ds : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.systemId += _e.REPLACEMENT_CHARACTER) : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += He(t);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [ko](t) {
    t === M.APOSTROPHE ? this.state = ds : t === M.NULL ? (this._err(W.unexpectedNullCharacter), this.currentToken.systemId += _e.REPLACEMENT_CHARACTER) : t === M.GREATER_THAN_SIGN ? (this._err(W.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += He(t);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [ds](t) {
    Ie(t) || (t === M.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = pe) : t === M.EOF ? (this._err(W.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(W.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(Nt)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [Nt](t) {
    t === M.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = pe) : t === M.NULL ? this._err(W.unexpectedNullCharacter) : t === M.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [Cr](t) {
    t === M.RIGHT_SQUARE_BRACKET ? this.state = O1 : t === M.EOF ? (this._err(W.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [O1](t) {
    t === M.RIGHT_SQUARE_BRACKET ? this.state = N1 : (this._emitChars("]"), this._reconsumeInState(Cr));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [N1](t) {
    t === M.GREATER_THAN_SIGN ? this.state = pe : t === M.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(Cr));
  }
  // Character reference state
  //------------------------------------------------------------------
  [Rn](t) {
    this.tempBuff = [M.AMPERSAND], t === M.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = D1) : us(t) ? this._reconsumeInState(H1) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [H1](t) {
    const n = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [M.AMPERSAND];
    else if (n) {
      const o = this.tempBuff[this.tempBuff.length - 1] === M.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(o) || (o || this._errOnNextCodePoint(W.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = P1;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [P1](t) {
    us(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += He(t) : this._emitCodePoint(t) : (t === M.SEMICOLON && this._err(W.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [D1](t) {
    this.charRefCode = 0, t === M.LATIN_SMALL_X || t === M.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = R1) : this._reconsumeInState(V1);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [R1](t) {
    JS(t) ? this._reconsumeInState(B1) : (this._err(W.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [V1](t) {
    Bo(t) ? this._reconsumeInState(F1) : (this._err(W.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [B1](t) {
    Mc(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : $c(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : Bo(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === M.SEMICOLON ? this.state = Eo : (this._err(W.missingSemicolonAfterCharacterReference), this._reconsumeInState(Eo));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [F1](t) {
    Bo(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === M.SEMICOLON ? this.state = Eo : (this._err(W.missingSemicolonAfterCharacterReference), this._reconsumeInState(Eo));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [Eo]() {
    if (this.charRefCode === M.NULL)
      this._err(W.nullCharacterReference), this.charRefCode = M.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(W.characterReferenceOutsideUnicodeRange), this.charRefCode = M.REPLACEMENT_CHARACTER;
    else if (_e.isSurrogate(this.charRefCode))
      this._err(W.surrogateCharacterReference), this.charRefCode = M.REPLACEMENT_CHARACTER;
    else if (_e.isUndefinedCodePoint(this.charRefCode))
      this._err(W.noncharacterCharacterReference);
    else if (_e.isControlCodePoint(this.charRefCode) || this.charRefCode === M.CARRIAGE_RETURN) {
      this._err(W.controlCharacterReference);
      const t = XS[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
ct.CHARACTER_TOKEN = "CHARACTER_TOKEN";
ct.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
ct.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
ct.START_TAG_TOKEN = "START_TAG_TOKEN";
ct.END_TAG_TOKEN = "END_TAG_TOKEN";
ct.COMMENT_TOKEN = "COMMENT_TOKEN";
ct.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
ct.EOF_TOKEN = "EOF_TOKEN";
ct.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
ct.MODE = {
  DATA: pe,
  RCDATA: Kn,
  RAWTEXT: Ro,
  SCRIPT_DATA: Rt,
  PLAINTEXT: Sc
};
ct.getTokenAttr = function(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
};
var vi = ct, wt = {};
const cs = wt.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
wt.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
wt.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const X = wt.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
wt.SPECIAL_ELEMENTS = {
  [cs.HTML]: {
    [X.ADDRESS]: !0,
    [X.APPLET]: !0,
    [X.AREA]: !0,
    [X.ARTICLE]: !0,
    [X.ASIDE]: !0,
    [X.BASE]: !0,
    [X.BASEFONT]: !0,
    [X.BGSOUND]: !0,
    [X.BLOCKQUOTE]: !0,
    [X.BODY]: !0,
    [X.BR]: !0,
    [X.BUTTON]: !0,
    [X.CAPTION]: !0,
    [X.CENTER]: !0,
    [X.COL]: !0,
    [X.COLGROUP]: !0,
    [X.DD]: !0,
    [X.DETAILS]: !0,
    [X.DIR]: !0,
    [X.DIV]: !0,
    [X.DL]: !0,
    [X.DT]: !0,
    [X.EMBED]: !0,
    [X.FIELDSET]: !0,
    [X.FIGCAPTION]: !0,
    [X.FIGURE]: !0,
    [X.FOOTER]: !0,
    [X.FORM]: !0,
    [X.FRAME]: !0,
    [X.FRAMESET]: !0,
    [X.H1]: !0,
    [X.H2]: !0,
    [X.H3]: !0,
    [X.H4]: !0,
    [X.H5]: !0,
    [X.H6]: !0,
    [X.HEAD]: !0,
    [X.HEADER]: !0,
    [X.HGROUP]: !0,
    [X.HR]: !0,
    [X.HTML]: !0,
    [X.IFRAME]: !0,
    [X.IMG]: !0,
    [X.INPUT]: !0,
    [X.LI]: !0,
    [X.LINK]: !0,
    [X.LISTING]: !0,
    [X.MAIN]: !0,
    [X.MARQUEE]: !0,
    [X.MENU]: !0,
    [X.META]: !0,
    [X.NAV]: !0,
    [X.NOEMBED]: !0,
    [X.NOFRAMES]: !0,
    [X.NOSCRIPT]: !0,
    [X.OBJECT]: !0,
    [X.OL]: !0,
    [X.P]: !0,
    [X.PARAM]: !0,
    [X.PLAINTEXT]: !0,
    [X.PRE]: !0,
    [X.SCRIPT]: !0,
    [X.SECTION]: !0,
    [X.SELECT]: !0,
    [X.SOURCE]: !0,
    [X.STYLE]: !0,
    [X.SUMMARY]: !0,
    [X.TABLE]: !0,
    [X.TBODY]: !0,
    [X.TD]: !0,
    [X.TEMPLATE]: !0,
    [X.TEXTAREA]: !0,
    [X.TFOOT]: !0,
    [X.TH]: !0,
    [X.THEAD]: !0,
    [X.TITLE]: !0,
    [X.TR]: !0,
    [X.TRACK]: !0,
    [X.UL]: !0,
    [X.WBR]: !0,
    [X.XMP]: !0
  },
  [cs.MATHML]: {
    [X.MI]: !0,
    [X.MO]: !0,
    [X.MN]: !0,
    [X.MS]: !0,
    [X.MTEXT]: !0,
    [X.ANNOTATION_XML]: !0
  },
  [cs.SVG]: {
    [X.TITLE]: !0,
    [X.FOREIGN_OBJECT]: !0,
    [X.DESC]: !0
  }
};
const Ic = wt, J = Ic.TAG_NAMES, we = Ic.NAMESPACES;
function U1(e) {
  switch (e.length) {
    case 1:
      return e === J.P;
    case 2:
      return e === J.RB || e === J.RP || e === J.RT || e === J.DD || e === J.DT || e === J.LI;
    case 3:
      return e === J.RTC;
    case 6:
      return e === J.OPTION;
    case 8:
      return e === J.OPTGROUP;
  }
  return !1;
}
function eM(e) {
  switch (e.length) {
    case 1:
      return e === J.P;
    case 2:
      return e === J.RB || e === J.RP || e === J.RT || e === J.DD || e === J.DT || e === J.LI || e === J.TD || e === J.TH || e === J.TR;
    case 3:
      return e === J.RTC;
    case 5:
      return e === J.TBODY || e === J.TFOOT || e === J.THEAD;
    case 6:
      return e === J.OPTION;
    case 7:
      return e === J.CAPTION;
    case 8:
      return e === J.OPTGROUP || e === J.COLGROUP;
  }
  return !1;
}
function _r(e, t) {
  switch (e.length) {
    case 2:
      if (e === J.TD || e === J.TH)
        return t === we.HTML;
      if (e === J.MI || e === J.MO || e === J.MN || e === J.MS)
        return t === we.MATHML;
      break;
    case 4:
      if (e === J.HTML)
        return t === we.HTML;
      if (e === J.DESC)
        return t === we.SVG;
      break;
    case 5:
      if (e === J.TABLE)
        return t === we.HTML;
      if (e === J.MTEXT)
        return t === we.MATHML;
      if (e === J.TITLE)
        return t === we.SVG;
      break;
    case 6:
      return (e === J.APPLET || e === J.OBJECT) && t === we.HTML;
    case 7:
      return (e === J.CAPTION || e === J.MARQUEE) && t === we.HTML;
    case 8:
      return e === J.TEMPLATE && t === we.HTML;
    case 13:
      return e === J.FOREIGN_OBJECT && t === we.SVG;
    case 14:
      return e === J.ANNOTATION_XML && t === we.MATHML;
  }
  return !1;
}
let tM = class {
  constructor(e, t) {
    this.stackTop = -1, this.items = [], this.current = e, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = t;
  }
  //Index of element
  _indexOf(e) {
    let t = -1;
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === e) {
        t = n;
        break;
      }
    return t;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === J.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === we.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(e) {
    this.items[++this.stackTop] = e, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(e, t) {
    const n = this._indexOf(e);
    this.items[n] = t, n === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(e, t) {
    const n = this._indexOf(e) + 1;
    this.items.splice(n, 0, t), n === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(e) {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === e && n === we.HTML)
        break;
    }
  }
  popUntilElementPopped(e) {
    for (; this.stackTop > -1; ) {
      const t = this.current;
      if (this.pop(), t === e)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, t = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === J.H1 || e === J.H2 || e === J.H3 || e === J.H4 || e === J.H5 || e === J.H6 && t === we.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, t = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === J.TD || e === J.TH && t === we.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== J.TABLE && this.currentTagName !== J.TEMPLATE && this.currentTagName !== J.HTML || this.treeAdapter.getNamespaceURI(this.current) !== we.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== J.TBODY && this.currentTagName !== J.TFOOT && this.currentTagName !== J.THEAD && this.currentTagName !== J.TEMPLATE && this.currentTagName !== J.HTML || this.treeAdapter.getNamespaceURI(this.current) !== we.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== J.TR && this.currentTagName !== J.TEMPLATE && this.currentTagName !== J.HTML || this.treeAdapter.getNamespaceURI(this.current) !== we.HTML; )
      this.pop();
  }
  remove(e) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.items[t] === e) {
        this.items.splice(t, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const e = this.items[1];
    return e && this.treeAdapter.getTagName(e) === J.BODY ? e : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    let t = this._indexOf(e);
    return --t >= 0 ? this.items[t] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === J.HTML;
  }
  //Element in scope
  hasInScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === we.HTML)
        return !0;
      if (_r(n, o))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const t = this.treeAdapter.getTagName(this.items[e]), n = this.treeAdapter.getNamespaceURI(this.items[e]);
      if ((t === J.H1 || t === J.H2 || t === J.H3 || t === J.H4 || t === J.H5 || t === J.H6) && n === we.HTML)
        return !0;
      if (_r(t, n))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === we.HTML)
        return !0;
      if ((n === J.UL || n === J.OL) && o === we.HTML || _r(n, o))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === we.HTML)
        return !0;
      if (n === J.BUTTON && o === we.HTML || _r(n, o))
        return !1;
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === we.HTML) {
        if (n === e)
          return !0;
        if (n === J.TABLE || n === J.TEMPLATE || n === J.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const t = this.treeAdapter.getTagName(this.items[e]);
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === we.HTML) {
        if (t === J.TBODY || t === J.THEAD || t === J.TFOOT)
          return !0;
        if (t === J.TABLE || t === J.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === we.HTML) {
        if (n === e)
          return !0;
        if (n !== J.OPTION && n !== J.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; U1(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; eM(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; U1(this.currentTagName) && this.currentTagName !== e; )
      this.pop();
  }
};
var nM = tM;
const wr = 3;
let ma = class Qt {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t) {
    const n = [];
    if (this.length >= wr) {
      const o = this.treeAdapter.getAttrList(t).length, i = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
      for (let a = this.length - 1; a >= 0; a--) {
        const s = this.entries[a];
        if (s.type === Qt.MARKER_ENTRY)
          break;
        const u = s.element, c = this.treeAdapter.getAttrList(u);
        this.treeAdapter.getTagName(u) === i && this.treeAdapter.getNamespaceURI(u) === r && c.length === o && n.push({ idx: a, attrs: c });
      }
    }
    return n.length < wr ? [] : n;
  }
  _ensureNoahArkCondition(t) {
    const n = this._getNoahArkConditionCandidates(t);
    let o = n.length;
    if (o) {
      const i = this.treeAdapter.getAttrList(t), r = i.length, a = /* @__PURE__ */ Object.create(null);
      for (let s = 0; s < r; s++) {
        const u = i[s];
        a[u.name] = u.value;
      }
      for (let s = 0; s < r; s++)
        for (let u = 0; u < o; u++) {
          const c = n[u].attrs[s];
          if (a[c.name] !== c.value && (n.splice(u, 1), o--), n.length < wr)
            return;
        }
      for (let s = o - 1; s >= wr - 1; s--)
        this.entries.splice(n[s].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: Qt.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: Qt.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(t, n) {
    let o = this.length - 1;
    for (; o >= 0 && this.entries[o] !== this.bookmark; o--)
      ;
    this.entries.splice(o + 1, 0, {
      type: Qt.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  removeEntry(t) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === t) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === Qt.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const o = this.entries[n];
      if (o.type === Qt.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(o.element) === t)
        return o;
    }
    return null;
  }
  getElementEntry(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const o = this.entries[n];
      if (o.type === Qt.ELEMENT_ENTRY && o.element === t)
        return o;
    }
    return null;
  }
};
ma.MARKER_ENTRY = "MARKER_ENTRY";
ma.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var oM = ma;
let Ac = class {
  constructor(e) {
    const t = {}, n = this._getOverriddenMethods(this, t);
    for (const o of Object.keys(n))
      typeof n[o] == "function" && (t[o] = e[o], e[o] = n[o]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
Ac.install = function(e, t, n) {
  e.__mixins || (e.__mixins = []);
  for (let i = 0; i < e.__mixins.length; i++)
    if (e.__mixins[i].constructor === t)
      return e.__mixins[i];
  const o = new t(e, n);
  return e.__mixins.push(o), o;
};
var Gt = Ac;
const rM = Gt;
let iM = class extends rM {
  constructor(e) {
    super(e), this.preprocessor = e, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(e, t) {
    return {
      advance() {
        const n = this.pos + 1, o = this.html[n];
        return e.isEol && (e.isEol = !1, e.line++, e.lineStartPos = n), (o === `
` || o === "\r" && this.html[n + 1] !== `
`) && (e.isEol = !0), e.col = n - e.lineStartPos + 1, e.offset = e.droppedBufferSize + n, t.advance.call(this);
      },
      retreat() {
        t.retreat.call(this), e.isEol = !1, e.col = this.pos - e.lineStartPos + 1;
      },
      dropParsedChunk() {
        const n = this.pos;
        t.dropParsedChunk.call(this);
        const o = n - this.pos;
        e.lineStartPos -= o, e.droppedBufferSize += o, e.offset = e.droppedBufferSize + this.pos;
      }
    };
  }
};
var Lc = iM;
const K1 = Gt, hs = vi, sM = Lc;
let aM = class extends K1 {
  constructor(e) {
    super(e), this.tokenizer = e, this.posTracker = K1.install(e.preprocessor, sM), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const e = this.tokenizer.currentToken, t = this.tokenizer.currentAttr;
    e.location.attrs || (e.location.attrs = /* @__PURE__ */ Object.create(null)), e.location.attrs[t.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(e, t) {
    const n = {
      _createStartTagToken() {
        t._createStartTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createEndTagToken() {
        t._createEndTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createCommentToken() {
        t._createCommentToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createDoctypeToken(o) {
        t._createDoctypeToken.call(this, o), this.currentToken.location = e.ctLoc;
      },
      _createCharacterToken(o, i) {
        t._createCharacterToken.call(this, o, i), this.currentCharacterToken.location = e.ctLoc;
      },
      _createEOFToken() {
        t._createEOFToken.call(this), this.currentToken.location = e._getCurrentLocation();
      },
      _createAttr(o) {
        t._createAttr.call(this, o), e.currentAttrLocation = e._getCurrentLocation();
      },
      _leaveAttrName(o) {
        t._leaveAttrName.call(this, o), e._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(o) {
        t._leaveAttrValue.call(this, o), e._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const o = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = o.startLine, this.currentCharacterToken.location.endCol = o.startCol, this.currentCharacterToken.location.endOffset = o.startOffset), this.currentToken.type === hs.EOF_TOKEN ? (o.endLine = o.startLine, o.endCol = o.startCol, o.endOffset = o.startOffset) : (o.endLine = e.posTracker.line, o.endCol = e.posTracker.col + 1, o.endOffset = e.posTracker.offset + 1), t._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const o = this.currentCharacterToken && this.currentCharacterToken.location;
        o && o.endOffset === -1 && (o.endLine = e.posTracker.line, o.endCol = e.posTracker.col, o.endOffset = e.posTracker.offset), t._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(hs.MODE).forEach((o) => {
      const i = hs.MODE[o];
      n[i] = function(r) {
        e.ctLoc = e._getCurrentLocation(), t[i].call(this, r);
      };
    }), n;
  }
};
var Oc = aM;
const lM = Gt;
let dM = class extends lM {
  constructor(e, t) {
    super(e), this.onItemPop = t.onItemPop;
  }
  _getOverriddenMethods(e, t) {
    return {
      pop() {
        e.onItemPop(this.current), t.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let n = this.stackTop; n > 0; n--)
          e.onItemPop(this.items[n]);
        t.popAllUpToHtmlElement.call(this);
      },
      remove(n) {
        e.onItemPop(this.current), t.remove.call(this, n);
      }
    };
  }
};
var uM = dM;
const ms = Gt, G1 = vi, cM = Oc, hM = uM, mM = wt, ps = mM.TAG_NAMES;
let pM = class extends ms {
  constructor(e) {
    super(e), this.parser = e, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(e) {
    let t = null;
    this.lastStartTagToken && (t = Object.assign({}, this.lastStartTagToken.location), t.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(e, t);
  }
  _setEndLocation(e, t) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && t.location) {
      const n = t.location, o = this.treeAdapter.getTagName(e), i = t.type === G1.END_TAG_TOKEN && o === t.tagName, r = {};
      i ? (r.endTag = Object.assign({}, n), r.endLine = n.endLine, r.endCol = n.endCol, r.endOffset = n.endOffset) : (r.endLine = n.startLine, r.endCol = n.startCol, r.endOffset = n.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(e, r);
    }
  }
  _getOverriddenMethods(e, t) {
    return {
      _bootstrap(n, o) {
        t._bootstrap.call(this, n, o), e.lastStartTagToken = null, e.lastFosterParentingLocation = null, e.currentToken = null;
        const i = ms.install(this.tokenizer, cM);
        e.posTracker = i.posTracker, ms.install(this.openElements, hM, {
          onItemPop: function(r) {
            e._setEndLocation(r, e.currentToken);
          }
        });
      },
      _runParsingLoop(n) {
        t._runParsingLoop.call(this, n);
        for (let o = this.openElements.stackTop; o >= 0; o--)
          e._setEndLocation(this.openElements.items[o], e.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(n) {
        e.currentToken = n, t._processTokenInForeignContent.call(this, n);
      },
      _processToken(n) {
        if (e.currentToken = n, t._processToken.call(this, n), n.type === G1.END_TAG_TOKEN && (n.tagName === ps.HTML || n.tagName === ps.BODY && this.openElements.hasInScope(ps.BODY)))
          for (let o = this.openElements.stackTop; o >= 0; o--) {
            const i = this.openElements.items[o];
            if (this.treeAdapter.getTagName(i) === n.tagName) {
              e._setEndLocation(i, n);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(n) {
        t._setDocumentType.call(this, n);
        const o = this.treeAdapter.getChildNodes(this.document), i = o.length;
        for (let r = 0; r < i; r++) {
          const a = o[r];
          if (this.treeAdapter.isDocumentTypeNode(a)) {
            this.treeAdapter.setNodeSourceCodeLocation(a, n.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(n) {
        e._setStartLocation(n), e.lastStartTagToken = null, t._attachElementToTree.call(this, n);
      },
      _appendElement(n, o) {
        e.lastStartTagToken = n, t._appendElement.call(this, n, o);
      },
      _insertElement(n, o) {
        e.lastStartTagToken = n, t._insertElement.call(this, n, o);
      },
      _insertTemplate(n) {
        e.lastStartTagToken = n, t._insertTemplate.call(this, n);
        const o = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(o, null);
      },
      _insertFakeRootElement() {
        t._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(n, o) {
        t._appendCommentNode.call(this, n, o);
        const i = this.treeAdapter.getChildNodes(o), r = i[i.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(r, n.location);
      },
      //Text
      _findFosterParentingLocation() {
        return e.lastFosterParentingLocation = t._findFosterParentingLocation.call(this), e.lastFosterParentingLocation;
      },
      _insertCharacters(n) {
        t._insertCharacters.call(this, n);
        const o = this._shouldFosterParentOnInsertion(), i = o && e.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, r = this.treeAdapter.getChildNodes(i), a = o && e.lastFosterParentingLocation.beforeElement ? r.indexOf(e.lastFosterParentingLocation.beforeElement) - 1 : r.length - 1, s = r[a];
        if (this.treeAdapter.getNodeSourceCodeLocation(s)) {
          const { endLine: u, endCol: c, endOffset: y } = n.location;
          this.treeAdapter.updateNodeSourceCodeLocation(s, { endLine: u, endCol: c, endOffset: y });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(s, n.location);
      }
    };
  }
};
var fM = pM;
const gM = Gt;
let vM = class extends gM {
  constructor(e, t) {
    super(e), this.posTracker = null, this.onParseError = t.onParseError;
  }
  _setErrorLocation(e) {
    e.startLine = e.endLine = this.posTracker.line, e.startCol = e.endCol = this.posTracker.col, e.startOffset = e.endOffset = this.posTracker.offset;
  }
  _reportError(e) {
    const t = {
      code: e,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(t), this.onParseError(t);
  }
  _getOverriddenMethods(e) {
    return {
      _err(t) {
        e._reportError(t);
      }
    };
  }
};
var pa = vM;
const bM = pa, yM = Lc, CM = Gt;
let _M = class extends bM {
  constructor(e, t) {
    super(e, t), this.posTracker = CM.install(e, yM), this.lastErrOffset = -1;
  }
  _reportError(e) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(e));
  }
};
var wM = _M;
const TM = pa, kM = wM, EM = Gt;
let SM = class extends TM {
  constructor(e, t) {
    super(e, t);
    const n = EM.install(e.preprocessor, kM, t);
    this.posTracker = n.posTracker;
  }
};
var MM = SM;
const $M = pa, IM = MM, AM = Oc, z1 = Gt;
let LM = class extends $M {
  constructor(e, t) {
    super(e, t), this.opts = t, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(e) {
    this.ctLoc && (e.startLine = this.ctLoc.startLine, e.startCol = this.ctLoc.startCol, e.startOffset = this.ctLoc.startOffset, e.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, e.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, e.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(e, t) {
    return {
      _bootstrap(n, o) {
        t._bootstrap.call(this, n, o), z1.install(this.tokenizer, IM, e.opts), z1.install(this.tokenizer, AM);
      },
      _processInputToken(n) {
        e.ctLoc = n.location, t._processInputToken.call(this, n);
      },
      _err(n, o) {
        e.locBeforeToken = o && o.beforeToken, e._reportError(n);
      }
    };
  }
};
var OM = LM, ge = {};
const { DOCUMENT_MODE: NM } = wt;
ge.createDocument = function() {
  return {
    nodeName: "#document",
    mode: NM.NO_QUIRKS,
    childNodes: []
  };
};
ge.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
ge.createElement = function(e, t, n) {
  return {
    nodeName: e,
    tagName: e,
    attrs: n,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
ge.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const Nc = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, Hc = ge.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, HM = ge.insertBefore = function(e, t, n) {
  const o = e.childNodes.indexOf(n);
  e.childNodes.splice(o, 0, t), t.parentNode = e;
};
ge.setTemplateContent = function(e, t) {
  e.content = t;
};
ge.getTemplateContent = function(e) {
  return e.content;
};
ge.setDocumentType = function(e, t, n, o) {
  let i = null;
  for (let r = 0; r < e.childNodes.length; r++)
    if (e.childNodes[r].nodeName === "#documentType") {
      i = e.childNodes[r];
      break;
    }
  i ? (i.name = t, i.publicId = n, i.systemId = o) : Hc(e, {
    nodeName: "#documentType",
    name: t,
    publicId: n,
    systemId: o
  });
};
ge.setDocumentMode = function(e, t) {
  e.mode = t;
};
ge.getDocumentMode = function(e) {
  return e.mode;
};
ge.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
ge.insertText = function(e, t) {
  if (e.childNodes.length) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += t;
      return;
    }
  }
  Hc(e, Nc(t));
};
ge.insertTextBefore = function(e, t, n) {
  const o = e.childNodes[e.childNodes.indexOf(n) - 1];
  o && o.nodeName === "#text" ? o.value += t : HM(e, Nc(t), n);
};
ge.adoptAttributes = function(e, t) {
  const n = [];
  for (let o = 0; o < e.attrs.length; o++)
    n.push(e.attrs[o].name);
  for (let o = 0; o < t.length; o++)
    n.indexOf(t[o].name) === -1 && e.attrs.push(t[o]);
};
ge.getFirstChild = function(e) {
  return e.childNodes[0];
};
ge.getChildNodes = function(e) {
  return e.childNodes;
};
ge.getParentNode = function(e) {
  return e.parentNode;
};
ge.getAttrList = function(e) {
  return e.attrs;
};
ge.getTagName = function(e) {
  return e.tagName;
};
ge.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
ge.getTextNodeContent = function(e) {
  return e.value;
};
ge.getCommentNodeContent = function(e) {
  return e.data;
};
ge.getDocumentTypeNodeName = function(e) {
  return e.name;
};
ge.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
ge.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
ge.isTextNode = function(e) {
  return e.nodeName === "#text";
};
ge.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
ge.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
ge.isElementNode = function(e) {
  return !!e.tagName;
};
ge.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
ge.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
ge.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var PM = function(e, t) {
  return t = t || /* @__PURE__ */ Object.create(null), [e, t].reduce((n, o) => (Object.keys(o).forEach((i) => {
    n[i] = o[i];
  }), n), /* @__PURE__ */ Object.create(null));
}, bi = {};
const { DOCUMENT_MODE: Vn } = wt, Pc = "html", DM = "about:legacy-compat", RM = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Dc = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], VM = Dc.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), BM = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], Rc = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], FM = Rc.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function Z1(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function W1(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.indexOf(t[n]) === 0)
      return !0;
  return !1;
}
bi.isConforming = function(e) {
  return e.name === Pc && e.publicId === null && (e.systemId === null || e.systemId === DM);
};
bi.getDocumentMode = function(e) {
  if (e.name !== Pc)
    return Vn.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === RM)
    return Vn.QUIRKS;
  let n = e.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), BM.indexOf(n) > -1)
      return Vn.QUIRKS;
    let o = t === null ? VM : Dc;
    if (W1(n, o))
      return Vn.QUIRKS;
    if (o = t === null ? Rc : FM, W1(n, o))
      return Vn.LIMITED_QUIRKS;
  }
  return Vn.NO_QUIRKS;
};
bi.serializeContent = function(e, t, n) {
  let o = "!DOCTYPE ";
  return e && (o += e), t ? o += " PUBLIC " + Z1(t) : n && (o += " SYSTEM"), n !== null && (o += " " + Z1(n)), o;
};
var dn = {};
const fs = vi, fa = wt, ae = fa.TAG_NAMES, je = fa.NAMESPACES, Ar = fa.ATTRS, q1 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, jM = "definitionurl", UM = "definitionURL", KM = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, GM = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: je.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: je.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: je.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: je.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: je.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: je.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: je.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: je.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: je.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: je.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: je.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: je.XMLNS }
}, zM = dn.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, ZM = {
  [ae.B]: !0,
  [ae.BIG]: !0,
  [ae.BLOCKQUOTE]: !0,
  [ae.BODY]: !0,
  [ae.BR]: !0,
  [ae.CENTER]: !0,
  [ae.CODE]: !0,
  [ae.DD]: !0,
  [ae.DIV]: !0,
  [ae.DL]: !0,
  [ae.DT]: !0,
  [ae.EM]: !0,
  [ae.EMBED]: !0,
  [ae.H1]: !0,
  [ae.H2]: !0,
  [ae.H3]: !0,
  [ae.H4]: !0,
  [ae.H5]: !0,
  [ae.H6]: !0,
  [ae.HEAD]: !0,
  [ae.HR]: !0,
  [ae.I]: !0,
  [ae.IMG]: !0,
  [ae.LI]: !0,
  [ae.LISTING]: !0,
  [ae.MENU]: !0,
  [ae.META]: !0,
  [ae.NOBR]: !0,
  [ae.OL]: !0,
  [ae.P]: !0,
  [ae.PRE]: !0,
  [ae.RUBY]: !0,
  [ae.S]: !0,
  [ae.SMALL]: !0,
  [ae.SPAN]: !0,
  [ae.STRONG]: !0,
  [ae.STRIKE]: !0,
  [ae.SUB]: !0,
  [ae.SUP]: !0,
  [ae.TABLE]: !0,
  [ae.TT]: !0,
  [ae.U]: !0,
  [ae.UL]: !0,
  [ae.VAR]: !0
};
dn.causesExit = function(e) {
  const t = e.tagName;
  return t === ae.FONT && (fs.getTokenAttr(e, Ar.COLOR) !== null || fs.getTokenAttr(e, Ar.SIZE) !== null || fs.getTokenAttr(e, Ar.FACE) !== null) ? !0 : ZM[t];
};
dn.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === jM) {
      e.attrs[t].name = UM;
      break;
    }
};
dn.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = KM[e.attrs[t].name];
    n && (e.attrs[t].name = n);
  }
};
dn.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = GM[e.attrs[t].name];
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
};
dn.adjustTokenSVGTagName = function(e) {
  const t = zM[e.tagName];
  t && (e.tagName = t);
};
function WM(e, t) {
  return t === je.MATHML && (e === ae.MI || e === ae.MO || e === ae.MN || e === ae.MS || e === ae.MTEXT);
}
function qM(e, t, n) {
  if (t === je.MATHML && e === ae.ANNOTATION_XML) {
    for (let o = 0; o < n.length; o++)
      if (n[o].name === Ar.ENCODING) {
        const i = n[o].value.toLowerCase();
        return i === q1.TEXT_HTML || i === q1.APPLICATION_XML;
      }
  }
  return t === je.SVG && (e === ae.FOREIGN_OBJECT || e === ae.DESC || e === ae.TITLE);
}
dn.isIntegrationPoint = function(e, t, n, o) {
  return !!((!o || o === je.HTML) && qM(e, t, n) || (!o || o === je.MATHML) && WM(e, t));
};
const A = vi, YM = nM, Y1 = oM, xM = fM, XM = OM, x1 = Gt, QM = ge, JM = PM, X1 = bi, Mt = dn, Ge = ha, e$ = _t, An = wt, m = An.TAG_NAMES, re = An.NAMESPACES, Vc = An.ATTRS, t$ = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: QM
}, Bc = "hidden", n$ = 8, o$ = 3, Fc = "INITIAL_MODE", ga = "BEFORE_HTML_MODE", yi = "BEFORE_HEAD_MODE", ao = "IN_HEAD_MODE", jc = "IN_HEAD_NO_SCRIPT_MODE", Ci = "AFTER_HEAD_MODE", $t = "IN_BODY_MODE", Wr = "TEXT_MODE", Ue = "IN_TABLE_MODE", Uc = "IN_TABLE_TEXT_MODE", _i = "IN_CAPTION_MODE", er = "IN_COLUMN_GROUP_MODE", dt = "IN_TABLE_BODY_MODE", Kt = "IN_ROW_MODE", wi = "IN_CELL_MODE", va = "IN_SELECT_MODE", ba = "IN_SELECT_IN_TABLE_MODE", qr = "IN_TEMPLATE_MODE", ya = "AFTER_BODY_MODE", Ti = "IN_FRAMESET_MODE", Kc = "AFTER_FRAMESET_MODE", Gc = "AFTER_AFTER_BODY_MODE", zc = "AFTER_AFTER_FRAMESET_MODE", r$ = {
  [m.TR]: Kt,
  [m.TBODY]: dt,
  [m.THEAD]: dt,
  [m.TFOOT]: dt,
  [m.CAPTION]: _i,
  [m.COLGROUP]: er,
  [m.TABLE]: Ue,
  [m.BODY]: $t,
  [m.FRAMESET]: Ti
}, i$ = {
  [m.CAPTION]: Ue,
  [m.COLGROUP]: Ue,
  [m.TBODY]: Ue,
  [m.TFOOT]: Ue,
  [m.THEAD]: Ue,
  [m.COL]: er,
  [m.TR]: dt,
  [m.TD]: Kt,
  [m.TH]: Kt
}, Q1 = {
  [Fc]: {
    [A.CHARACTER_TOKEN]: Mo,
    [A.NULL_CHARACTER_TOKEN]: Mo,
    [A.WHITESPACE_CHARACTER_TOKEN]: fe,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: f$,
    [A.START_TAG_TOKEN]: Mo,
    [A.END_TAG_TOKEN]: Mo,
    [A.EOF_TOKEN]: Mo
  },
  [ga]: {
    [A.CHARACTER_TOKEN]: Fo,
    [A.NULL_CHARACTER_TOKEN]: Fo,
    [A.WHITESPACE_CHARACTER_TOKEN]: fe,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: g$,
    [A.END_TAG_TOKEN]: v$,
    [A.EOF_TOKEN]: Fo
  },
  [yi]: {
    [A.CHARACTER_TOKEN]: jo,
    [A.NULL_CHARACTER_TOKEN]: jo,
    [A.WHITESPACE_CHARACTER_TOKEN]: fe,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: Tr,
    [A.START_TAG_TOKEN]: b$,
    [A.END_TAG_TOKEN]: y$,
    [A.EOF_TOKEN]: jo
  },
  [ao]: {
    [A.CHARACTER_TOKEN]: Uo,
    [A.NULL_CHARACTER_TOKEN]: Uo,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: Tr,
    [A.START_TAG_TOKEN]: Be,
    [A.END_TAG_TOKEN]: Ln,
    [A.EOF_TOKEN]: Uo
  },
  [jc]: {
    [A.CHARACTER_TOKEN]: Ko,
    [A.NULL_CHARACTER_TOKEN]: Ko,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: Tr,
    [A.START_TAG_TOKEN]: C$,
    [A.END_TAG_TOKEN]: _$,
    [A.EOF_TOKEN]: Ko
  },
  [Ci]: {
    [A.CHARACTER_TOKEN]: Go,
    [A.NULL_CHARACTER_TOKEN]: Go,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: Tr,
    [A.START_TAG_TOKEN]: w$,
    [A.END_TAG_TOKEN]: T$,
    [A.EOF_TOKEN]: Go
  },
  [$t]: {
    [A.CHARACTER_TOKEN]: kr,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: Je,
    [A.END_TAG_TOKEN]: Ca,
    [A.EOF_TOKEN]: Pt
  },
  [Wr]: {
    [A.CHARACTER_TOKEN]: Ye,
    [A.NULL_CHARACTER_TOKEN]: Ye,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: fe,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: fe,
    [A.END_TAG_TOKEN]: eI,
    [A.EOF_TOKEN]: tI
  },
  [Ue]: {
    [A.CHARACTER_TOKEN]: Dt,
    [A.NULL_CHARACTER_TOKEN]: Dt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Dt,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: _a,
    [A.END_TAG_TOKEN]: wa,
    [A.EOF_TOKEN]: Pt
  },
  [Uc]: {
    [A.CHARACTER_TOKEN]: cI,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: uI,
    [A.COMMENT_TOKEN]: $o,
    [A.DOCTYPE_TOKEN]: $o,
    [A.START_TAG_TOKEN]: $o,
    [A.END_TAG_TOKEN]: $o,
    [A.EOF_TOKEN]: $o
  },
  [_i]: {
    [A.CHARACTER_TOKEN]: kr,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: hI,
    [A.END_TAG_TOKEN]: mI,
    [A.EOF_TOKEN]: Pt
  },
  [er]: {
    [A.CHARACTER_TOKEN]: Yr,
    [A.NULL_CHARACTER_TOKEN]: Yr,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: pI,
    [A.END_TAG_TOKEN]: fI,
    [A.EOF_TOKEN]: Pt
  },
  [dt]: {
    [A.CHARACTER_TOKEN]: Dt,
    [A.NULL_CHARACTER_TOKEN]: Dt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Dt,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: gI,
    [A.END_TAG_TOKEN]: vI,
    [A.EOF_TOKEN]: Pt
  },
  [Kt]: {
    [A.CHARACTER_TOKEN]: Dt,
    [A.NULL_CHARACTER_TOKEN]: Dt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Dt,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: bI,
    [A.END_TAG_TOKEN]: yI,
    [A.EOF_TOKEN]: Pt
  },
  [wi]: {
    [A.CHARACTER_TOKEN]: kr,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: CI,
    [A.END_TAG_TOKEN]: _I,
    [A.EOF_TOKEN]: Pt
  },
  [va]: {
    [A.CHARACTER_TOKEN]: Ye,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: Zc,
    [A.END_TAG_TOKEN]: Wc,
    [A.EOF_TOKEN]: Pt
  },
  [ba]: {
    [A.CHARACTER_TOKEN]: Ye,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: wI,
    [A.END_TAG_TOKEN]: TI,
    [A.EOF_TOKEN]: Pt
  },
  [qr]: {
    [A.CHARACTER_TOKEN]: kr,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: kI,
    [A.END_TAG_TOKEN]: EI,
    [A.EOF_TOKEN]: qc
  },
  [ya]: {
    [A.CHARACTER_TOKEN]: xr,
    [A.NULL_CHARACTER_TOKEN]: xr,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: p$,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: SI,
    [A.END_TAG_TOKEN]: MI,
    [A.EOF_TOKEN]: So
  },
  [Ti]: {
    [A.CHARACTER_TOKEN]: fe,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: $I,
    [A.END_TAG_TOKEN]: II,
    [A.EOF_TOKEN]: So
  },
  [Kc]: {
    [A.CHARACTER_TOKEN]: fe,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ye,
    [A.COMMENT_TOKEN]: Ve,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: AI,
    [A.END_TAG_TOKEN]: LI,
    [A.EOF_TOKEN]: So
  },
  [Gc]: {
    [A.CHARACTER_TOKEN]: Lr,
    [A.NULL_CHARACTER_TOKEN]: Lr,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: J1,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: OI,
    [A.END_TAG_TOKEN]: Lr,
    [A.EOF_TOKEN]: So
  },
  [zc]: {
    [A.CHARACTER_TOKEN]: fe,
    [A.NULL_CHARACTER_TOKEN]: fe,
    [A.WHITESPACE_CHARACTER_TOKEN]: mn,
    [A.COMMENT_TOKEN]: J1,
    [A.DOCTYPE_TOKEN]: fe,
    [A.START_TAG_TOKEN]: NI,
    [A.END_TAG_TOKEN]: fe,
    [A.EOF_TOKEN]: So
  }
};
class s$ {
  constructor(t) {
    this.options = JM(t$, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && x1.install(this, xM), this.options.onParseError && x1.install(this, XM, { onParseError: this.options.onParseError });
  }
  // API
  parse(t) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
  }
  parseFragment(t, n) {
    n || (n = this.treeAdapter.createElement(m.TEMPLATE, re.HTML, []));
    const o = this.treeAdapter.createElement("documentmock", re.HTML, []);
    this._bootstrap(o, n), this.treeAdapter.getTagName(n) === m.TEMPLATE && this._pushTmplInsertionMode(qr), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const i = this.treeAdapter.getFirstChild(o), r = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(i, r), r;
  }
  //Bootstrap parser
  _bootstrap(t, n) {
    this.tokenizer = new A(this.options), this.stopped = !1, this.insertionMode = Fc, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new YM(this.document, this.treeAdapter), this.activeFormattingElements = new Y1(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === A.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === A.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const o = this.pendingScript;
      this.pendingScript = null, n(o);
      return;
    }
    t && t();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== re.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, re.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = Wr;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Wr, this.originalInsertionMode = $t, this.tokenizer.state = A.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === m.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === re.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === m.TITLE || t === m.TEXTAREA ? this.tokenizer.state = A.MODE.RCDATA : t === m.STYLE || t === m.XMP || t === m.IFRAME || t === m.NOEMBED || t === m.NOFRAMES || t === m.NOSCRIPT ? this.tokenizer.state = A.MODE.RAWTEXT : t === m.SCRIPT ? this.tokenizer.state = A.MODE.SCRIPT_DATA : t === m.PLAINTEXT && (this.tokenizer.state = A.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(t) {
    const n = t.name || "", o = t.publicId || "", i = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, o, i);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, t);
    }
  }
  _appendElement(t, n) {
    const o = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(o);
  }
  _insertElement(t, n) {
    const o = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(o), this.openElements.push(o);
  }
  _insertFakeElement(t) {
    const n = this.treeAdapter.createElement(t, re.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, re.HTML, t.attrs), o = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, o), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(m.HTML, re.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, n) {
    const o = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, o);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, t.chars);
    }
  }
  _adoptNodes(t, n) {
    for (let o = this.treeAdapter.getFirstChild(t); o; o = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(o), this.treeAdapter.appendChild(n, o);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(t) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const o = this.treeAdapter.getNamespaceURI(n);
    if (o === re.HTML || this.treeAdapter.getTagName(n) === m.ANNOTATION_XML && o === re.MATHML && t.type === A.START_TAG_TOKEN && t.tagName === m.SVG)
      return !1;
    const i = t.type === A.CHARACTER_TOKEN || t.type === A.NULL_CHARACTER_TOKEN || t.type === A.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === A.START_TAG_TOKEN && t.tagName !== m.MGLYPH && t.tagName !== m.MALIGNMARK || i) && this._isIntegrationPoint(n, re.MATHML) || (t.type === A.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, re.HTML) ? !1 : t.type !== A.EOF_TOKEN;
  }
  _processToken(t) {
    Q1[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    Q1[$t][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === A.CHARACTER_TOKEN ? PI(this, t) : t.type === A.NULL_CHARACTER_TOKEN ? HI(this, t) : t.type === A.WHITESPACE_CHARACTER_TOKEN ? Ye(this, t) : t.type === A.COMMENT_TOKEN ? Ve(this, t) : t.type === A.START_TAG_TOKEN ? DI(this, t) : t.type === A.END_TAG_TOKEN && RI(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === A.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(Ge.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(t, n) {
    const o = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t), r = this.treeAdapter.getAttrList(t);
    return Mt.isIntegrationPoint(o, i, r, n);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let n = t, o = null;
      do
        if (n--, o = this.activeFormattingElements.entries[n], o.type === Y1.MARKER_ENTRY || this.openElements.contains(o.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let i = n; i < t; i++)
        o = this.activeFormattingElements.entries[i], this._insertElement(o.token, this.treeAdapter.getNamespaceURI(o.element)), o.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Kt;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(m.P), this.openElements.popUntilTagNamePopped(m.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, n = !1; t >= 0; t--) {
      let o = this.openElements.items[t];
      t === 0 && (n = !0, this.fragmentContext && (o = this.fragmentContext));
      const i = this.treeAdapter.getTagName(o), r = r$[i];
      if (r) {
        this.insertionMode = r;
        break;
      } else if (!n && (i === m.TD || i === m.TH)) {
        this.insertionMode = wi;
        break;
      } else if (!n && i === m.HEAD) {
        this.insertionMode = ao;
        break;
      } else if (i === m.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (i === m.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (i === m.HTML) {
        this.insertionMode = this.headElement ? Ci : yi;
        break;
      } else if (n) {
        this.insertionMode = $t;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const o = this.openElements.items[n], i = this.treeAdapter.getTagName(o);
        if (i === m.TEMPLATE)
          break;
        if (i === m.TABLE) {
          this.insertionMode = ba;
          return;
        }
      }
    this.insertionMode = va;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    const n = this.treeAdapter.getTagName(t);
    return n === m.TABLE || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const o = this.openElements.items[n], i = this.treeAdapter.getTagName(o), r = this.treeAdapter.getNamespaceURI(o);
      if (i === m.TEMPLATE && r === re.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(o);
        break;
      } else if (i === m.TABLE) {
        t.parent = this.treeAdapter.getParentNode(o), t.parent ? t.beforeElement = o : t.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _fosterParentText(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
  }
  //Special elements
  _isSpecialElement(t) {
    const n = this.treeAdapter.getTagName(t), o = this.treeAdapter.getNamespaceURI(t);
    return An.SPECIAL_ELEMENTS[o][n];
  }
}
var a$ = s$;
function l$(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : vt(e, t), n;
}
function d$(e, t) {
  let n = null;
  for (let o = e.openElements.stackTop; o >= 0; o--) {
    const i = e.openElements.items[o];
    if (i === t.element)
      break;
    e._isSpecialElement(i) && (n = i);
  }
  return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function u$(e, t, n) {
  let o = t, i = e.openElements.getCommonAncestor(t);
  for (let r = 0, a = i; a !== n; r++, a = i) {
    i = e.openElements.getCommonAncestor(a);
    const s = e.activeFormattingElements.getElementEntry(a), u = s && r >= o$;
    !s || u ? (u && e.activeFormattingElements.removeEntry(s), e.openElements.remove(a)) : (a = c$(e, s), o === t && (e.activeFormattingElements.bookmark = s), e.treeAdapter.detachNode(o), e.treeAdapter.appendChild(a, o), o = a);
  }
  return o;
}
function c$(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), o = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, o), t.element = o, o;
}
function h$(e, t, n) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(n);
  else {
    const o = e.treeAdapter.getTagName(t), i = e.treeAdapter.getNamespaceURI(t);
    o === m.TEMPLATE && i === re.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function m$(e, t, n) {
  const o = e.treeAdapter.getNamespaceURI(n.element), i = n.token, r = e.treeAdapter.createElement(i.tagName, o, i.attrs);
  e._adoptNodes(t, r), e.treeAdapter.appendChild(t, r), e.activeFormattingElements.insertElementAfterBookmark(r, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, r);
}
function Jt(e, t) {
  let n;
  for (let o = 0; o < n$ && (n = l$(e, t), !!n); o++) {
    const i = d$(e, n);
    if (!i)
      break;
    e.activeFormattingElements.bookmark = n;
    const r = u$(e, i, n.element), a = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(r), h$(e, a, r), m$(e, i, n);
  }
}
function fe() {
}
function Tr(e) {
  e._err(Ge.misplacedDoctype);
}
function Ve(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function p$(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function J1(e, t) {
  e._appendCommentNode(t, e.document);
}
function Ye(e, t) {
  e._insertCharacters(t);
}
function So(e) {
  e.stopped = !0;
}
function f$(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? An.DOCUMENT_MODE.QUIRKS : X1.getDocumentMode(t);
  X1.isConforming(t) || e._err(Ge.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = ga;
}
function Mo(e, t) {
  e._err(Ge.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, An.DOCUMENT_MODE.QUIRKS), e.insertionMode = ga, e._processToken(t);
}
function g$(e, t) {
  t.tagName === m.HTML ? (e._insertElement(t, re.HTML), e.insertionMode = yi) : Fo(e, t);
}
function v$(e, t) {
  const n = t.tagName;
  (n === m.HTML || n === m.HEAD || n === m.BODY || n === m.BR) && Fo(e, t);
}
function Fo(e, t) {
  e._insertFakeRootElement(), e.insertionMode = yi, e._processToken(t);
}
function b$(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.HEAD ? (e._insertElement(t, re.HTML), e.headElement = e.openElements.current, e.insertionMode = ao) : jo(e, t);
}
function y$(e, t) {
  const n = t.tagName;
  n === m.HEAD || n === m.BODY || n === m.HTML || n === m.BR ? jo(e, t) : e._err(Ge.endTagWithoutMatchingOpenElement);
}
function jo(e, t) {
  e._insertFakeElement(m.HEAD), e.headElement = e.openElements.current, e.insertionMode = ao, e._processToken(t);
}
function Be(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.BASE || n === m.BASEFONT || n === m.BGSOUND || n === m.LINK || n === m.META ? (e._appendElement(t, re.HTML), t.ackSelfClosing = !0) : n === m.TITLE ? e._switchToTextParsing(t, A.MODE.RCDATA) : n === m.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, A.MODE.RAWTEXT) : (e._insertElement(t, re.HTML), e.insertionMode = jc) : n === m.NOFRAMES || n === m.STYLE ? e._switchToTextParsing(t, A.MODE.RAWTEXT) : n === m.SCRIPT ? e._switchToTextParsing(t, A.MODE.SCRIPT_DATA) : n === m.TEMPLATE ? (e._insertTemplate(t, re.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = qr, e._pushTmplInsertionMode(qr)) : n === m.HEAD ? e._err(Ge.misplacedStartTagForHeadElement) : Uo(e, t);
}
function Ln(e, t) {
  const n = t.tagName;
  n === m.HEAD ? (e.openElements.pop(), e.insertionMode = Ci) : n === m.BODY || n === m.BR || n === m.HTML ? Uo(e, t) : n === m.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== m.TEMPLATE && e._err(Ge.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(m.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(Ge.endTagWithoutMatchingOpenElement);
}
function Uo(e, t) {
  e.openElements.pop(), e.insertionMode = Ci, e._processToken(t);
}
function C$(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.BASEFONT || n === m.BGSOUND || n === m.HEAD || n === m.LINK || n === m.META || n === m.NOFRAMES || n === m.STYLE ? Be(e, t) : n === m.NOSCRIPT ? e._err(Ge.nestedNoscriptInHead) : Ko(e, t);
}
function _$(e, t) {
  const n = t.tagName;
  n === m.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = ao) : n === m.BR ? Ko(e, t) : e._err(Ge.endTagWithoutMatchingOpenElement);
}
function Ko(e, t) {
  const n = t.type === A.EOF_TOKEN ? Ge.openElementsLeftAfterEof : Ge.disallowedContentInNoscriptInHead;
  e._err(n), e.openElements.pop(), e.insertionMode = ao, e._processToken(t);
}
function w$(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.BODY ? (e._insertElement(t, re.HTML), e.framesetOk = !1, e.insertionMode = $t) : n === m.FRAMESET ? (e._insertElement(t, re.HTML), e.insertionMode = Ti) : n === m.BASE || n === m.BASEFONT || n === m.BGSOUND || n === m.LINK || n === m.META || n === m.NOFRAMES || n === m.SCRIPT || n === m.STYLE || n === m.TEMPLATE || n === m.TITLE ? (e._err(Ge.abandonedHeadElementChild), e.openElements.push(e.headElement), Be(e, t), e.openElements.remove(e.headElement)) : n === m.HEAD ? e._err(Ge.misplacedStartTagForHeadElement) : Go(e, t);
}
function T$(e, t) {
  const n = t.tagName;
  n === m.BODY || n === m.HTML || n === m.BR ? Go(e, t) : n === m.TEMPLATE ? Ln(e, t) : e._err(Ge.endTagWithoutMatchingOpenElement);
}
function Go(e, t) {
  e._insertFakeElement(m.BODY), e.insertionMode = $t, e._processToken(t);
}
function mn(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function kr(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function k$(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function E$(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function S$(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, re.HTML), e.insertionMode = Ti);
}
function Ht(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML);
}
function M$(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement();
  const n = e.openElements.currentTagName;
  (n === m.H1 || n === m.H2 || n === m.H3 || n === m.H4 || n === m.H5 || n === m.H6) && e.openElements.pop(), e._insertElement(t, re.HTML);
}
function ed(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function $$(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML), n || (e.formElement = e.openElements.current));
}
function I$(e, t) {
  e.framesetOk = !1;
  const n = t.tagName;
  for (let o = e.openElements.stackTop; o >= 0; o--) {
    const i = e.openElements.items[o], r = e.treeAdapter.getTagName(i);
    let a = null;
    if (n === m.LI && r === m.LI ? a = m.LI : (n === m.DD || n === m.DT) && (r === m.DD || r === m.DT) && (a = r), a) {
      e.openElements.generateImpliedEndTagsWithExclusion(a), e.openElements.popUntilTagNamePopped(a);
      break;
    }
    if (r !== m.ADDRESS && r !== m.DIV && r !== m.P && e._isSpecialElement(i))
      break;
  }
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML);
}
function A$(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML), e.tokenizer.state = A.MODE.PLAINTEXT;
}
function L$(e, t) {
  e.openElements.hasInScope(m.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(m.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML), e.framesetOk = !1;
}
function O$(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(m.A);
  n && (Jt(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Bn(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function N$(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(m.NOBR) && (Jt(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function td(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function H$(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== An.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML), e.framesetOk = !1, e.insertionMode = Ue;
}
function Gn(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, re.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function P$(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, re.HTML);
  const n = A.getTokenAttr(t, Vc.TYPE);
  (!n || n.toLowerCase() !== Bc) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function nd(e, t) {
  e._appendElement(t, re.HTML), t.ackSelfClosing = !0;
}
function D$(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._appendElement(t, re.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function R$(e, t) {
  t.tagName = m.IMG, Gn(e, t);
}
function V$(e, t) {
  e._insertElement(t, re.HTML), e.skipNextNewLine = !0, e.tokenizer.state = A.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = Wr;
}
function B$(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function F$(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function od(e, t) {
  e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function j$(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML), e.framesetOk = !1, e.insertionMode === Ue || e.insertionMode === _i || e.insertionMode === dt || e.insertionMode === Kt || e.insertionMode === wi ? e.insertionMode = ba : e.insertionMode = va;
}
function rd(e, t) {
  e.openElements.currentTagName === m.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML);
}
function id(e, t) {
  e.openElements.hasInScope(m.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, re.HTML);
}
function U$(e, t) {
  e.openElements.hasInScope(m.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(m.RTC), e._insertElement(t, re.HTML);
}
function K$(e, t) {
  e.openElements.hasInButtonScope(m.P) && e._closePElement(), e._insertElement(t, re.HTML);
}
function G$(e, t) {
  e._reconstructActiveFormattingElements(), Mt.adjustTokenMathMLAttrs(t), Mt.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, re.MATHML) : e._insertElement(t, re.MATHML), t.ackSelfClosing = !0;
}
function z$(e, t) {
  e._reconstructActiveFormattingElements(), Mt.adjustTokenSVGAttrs(t), Mt.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, re.SVG) : e._insertElement(t, re.SVG), t.ackSelfClosing = !0;
}
function st(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, re.HTML);
}
function Je(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === m.I || n === m.S || n === m.B || n === m.U ? Bn(e, t) : n === m.P ? Ht(e, t) : n === m.A ? O$(e, t) : st(e, t);
      break;
    case 2:
      n === m.DL || n === m.OL || n === m.UL ? Ht(e, t) : n === m.H1 || n === m.H2 || n === m.H3 || n === m.H4 || n === m.H5 || n === m.H6 ? M$(e, t) : n === m.LI || n === m.DD || n === m.DT ? I$(e, t) : n === m.EM || n === m.TT ? Bn(e, t) : n === m.BR ? Gn(e, t) : n === m.HR ? D$(e, t) : n === m.RB ? id(e, t) : n === m.RT || n === m.RP ? U$(e, t) : n !== m.TH && n !== m.TD && n !== m.TR && st(e, t);
      break;
    case 3:
      n === m.DIV || n === m.DIR || n === m.NAV ? Ht(e, t) : n === m.PRE ? ed(e, t) : n === m.BIG ? Bn(e, t) : n === m.IMG || n === m.WBR ? Gn(e, t) : n === m.XMP ? B$(e, t) : n === m.SVG ? z$(e, t) : n === m.RTC ? id(e, t) : n !== m.COL && st(e, t);
      break;
    case 4:
      n === m.HTML ? k$(e, t) : n === m.BASE || n === m.LINK || n === m.META ? Be(e, t) : n === m.BODY ? E$(e, t) : n === m.MAIN || n === m.MENU ? Ht(e, t) : n === m.FORM ? $$(e, t) : n === m.CODE || n === m.FONT ? Bn(e, t) : n === m.NOBR ? N$(e, t) : n === m.AREA ? Gn(e, t) : n === m.MATH ? G$(e, t) : n === m.MENU ? K$(e, t) : n !== m.HEAD && st(e, t);
      break;
    case 5:
      n === m.STYLE || n === m.TITLE ? Be(e, t) : n === m.ASIDE ? Ht(e, t) : n === m.SMALL ? Bn(e, t) : n === m.TABLE ? H$(e, t) : n === m.EMBED ? Gn(e, t) : n === m.INPUT ? P$(e, t) : n === m.PARAM || n === m.TRACK ? nd(e, t) : n === m.IMAGE ? R$(e, t) : n !== m.FRAME && n !== m.TBODY && n !== m.TFOOT && n !== m.THEAD && st(e, t);
      break;
    case 6:
      n === m.SCRIPT ? Be(e, t) : n === m.CENTER || n === m.FIGURE || n === m.FOOTER || n === m.HEADER || n === m.HGROUP || n === m.DIALOG ? Ht(e, t) : n === m.BUTTON ? L$(e, t) : n === m.STRIKE || n === m.STRONG ? Bn(e, t) : n === m.APPLET || n === m.OBJECT ? td(e, t) : n === m.KEYGEN ? Gn(e, t) : n === m.SOURCE ? nd(e, t) : n === m.IFRAME ? F$(e, t) : n === m.SELECT ? j$(e, t) : n === m.OPTION ? rd(e, t) : st(e, t);
      break;
    case 7:
      n === m.BGSOUND ? Be(e, t) : n === m.DETAILS || n === m.ADDRESS || n === m.ARTICLE || n === m.SECTION || n === m.SUMMARY ? Ht(e, t) : n === m.LISTING ? ed(e, t) : n === m.MARQUEE ? td(e, t) : n === m.NOEMBED ? od(e, t) : n !== m.CAPTION && st(e, t);
      break;
    case 8:
      n === m.BASEFONT ? Be(e, t) : n === m.FRAMESET ? S$(e, t) : n === m.FIELDSET ? Ht(e, t) : n === m.TEXTAREA ? V$(e, t) : n === m.TEMPLATE ? Be(e, t) : n === m.NOSCRIPT ? e.options.scriptingEnabled ? od(e, t) : st(e, t) : n === m.OPTGROUP ? rd(e, t) : n !== m.COLGROUP && st(e, t);
      break;
    case 9:
      n === m.PLAINTEXT ? A$(e, t) : st(e, t);
      break;
    case 10:
      n === m.BLOCKQUOTE || n === m.FIGCAPTION ? Ht(e, t) : st(e, t);
      break;
    default:
      st(e, t);
  }
}
function Z$(e) {
  e.openElements.hasInScope(m.BODY) && (e.insertionMode = ya);
}
function W$(e, t) {
  e.openElements.hasInScope(m.BODY) && (e.insertionMode = ya, e._processToken(t));
}
function Yt(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function q$(e) {
  const t = e.openElements.tmplCount > 0, n = e.formElement;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(m.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(m.FORM) : e.openElements.remove(n));
}
function Y$(e) {
  e.openElements.hasInButtonScope(m.P) || e._insertFakeElement(m.P), e._closePElement();
}
function x$(e) {
  e.openElements.hasInListItemScope(m.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(m.LI), e.openElements.popUntilTagNamePopped(m.LI));
}
function X$(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function Q$(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function sd(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function J$(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(m.BR), e.openElements.pop(), e.framesetOk = !1;
}
function vt(e, t) {
  const n = t.tagName;
  for (let o = e.openElements.stackTop; o > 0; o--) {
    const i = e.openElements.items[o];
    if (e.treeAdapter.getTagName(i) === n) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(i);
      break;
    }
    if (e._isSpecialElement(i))
      break;
  }
}
function Ca(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === m.A || n === m.B || n === m.I || n === m.S || n === m.U ? Jt(e, t) : n === m.P ? Y$(e) : vt(e, t);
      break;
    case 2:
      n === m.DL || n === m.UL || n === m.OL ? Yt(e, t) : n === m.LI ? x$(e) : n === m.DD || n === m.DT ? X$(e, t) : n === m.H1 || n === m.H2 || n === m.H3 || n === m.H4 || n === m.H5 || n === m.H6 ? Q$(e) : n === m.BR ? J$(e) : n === m.EM || n === m.TT ? Jt(e, t) : vt(e, t);
      break;
    case 3:
      n === m.BIG ? Jt(e, t) : n === m.DIR || n === m.DIV || n === m.NAV || n === m.PRE ? Yt(e, t) : vt(e, t);
      break;
    case 4:
      n === m.BODY ? Z$(e) : n === m.HTML ? W$(e, t) : n === m.FORM ? q$(e) : n === m.CODE || n === m.FONT || n === m.NOBR ? Jt(e, t) : n === m.MAIN || n === m.MENU ? Yt(e, t) : vt(e, t);
      break;
    case 5:
      n === m.ASIDE ? Yt(e, t) : n === m.SMALL ? Jt(e, t) : vt(e, t);
      break;
    case 6:
      n === m.CENTER || n === m.FIGURE || n === m.FOOTER || n === m.HEADER || n === m.HGROUP || n === m.DIALOG ? Yt(e, t) : n === m.APPLET || n === m.OBJECT ? sd(e, t) : n === m.STRIKE || n === m.STRONG ? Jt(e, t) : vt(e, t);
      break;
    case 7:
      n === m.ADDRESS || n === m.ARTICLE || n === m.DETAILS || n === m.SECTION || n === m.SUMMARY || n === m.LISTING ? Yt(e, t) : n === m.MARQUEE ? sd(e, t) : vt(e, t);
      break;
    case 8:
      n === m.FIELDSET ? Yt(e, t) : n === m.TEMPLATE ? Ln(e, t) : vt(e, t);
      break;
    case 10:
      n === m.BLOCKQUOTE || n === m.FIGCAPTION ? Yt(e, t) : vt(e, t);
      break;
    default:
      vt(e, t);
  }
}
function Pt(e, t) {
  e.tmplInsertionModeStackTop > -1 ? qc(e, t) : e.stopped = !0;
}
function eI(e, t) {
  t.tagName === m.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function tI(e, t) {
  e._err(Ge.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Dt(e, t) {
  const n = e.openElements.currentTagName;
  n === m.TABLE || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = Uc, e._processToken(t)) : lt(e, t);
}
function nI(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, re.HTML), e.insertionMode = _i;
}
function oI(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, re.HTML), e.insertionMode = er;
}
function rI(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(m.COLGROUP), e.insertionMode = er, e._processToken(t);
}
function iI(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, re.HTML), e.insertionMode = dt;
}
function sI(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(m.TBODY), e.insertionMode = dt, e._processToken(t);
}
function aI(e, t) {
  e.openElements.hasInTableScope(m.TABLE) && (e.openElements.popUntilTagNamePopped(m.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function lI(e, t) {
  const n = A.getTokenAttr(t, Vc.TYPE);
  n && n.toLowerCase() === Bc ? e._appendElement(t, re.HTML) : lt(e, t), t.ackSelfClosing = !0;
}
function dI(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, re.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function _a(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 2:
      n === m.TD || n === m.TH || n === m.TR ? sI(e, t) : lt(e, t);
      break;
    case 3:
      n === m.COL ? rI(e, t) : lt(e, t);
      break;
    case 4:
      n === m.FORM ? dI(e, t) : lt(e, t);
      break;
    case 5:
      n === m.TABLE ? aI(e, t) : n === m.STYLE ? Be(e, t) : n === m.TBODY || n === m.TFOOT || n === m.THEAD ? iI(e, t) : n === m.INPUT ? lI(e, t) : lt(e, t);
      break;
    case 6:
      n === m.SCRIPT ? Be(e, t) : lt(e, t);
      break;
    case 7:
      n === m.CAPTION ? nI(e, t) : lt(e, t);
      break;
    case 8:
      n === m.COLGROUP ? oI(e, t) : n === m.TEMPLATE ? Be(e, t) : lt(e, t);
      break;
    default:
      lt(e, t);
  }
}
function wa(e, t) {
  const n = t.tagName;
  n === m.TABLE ? e.openElements.hasInTableScope(m.TABLE) && (e.openElements.popUntilTagNamePopped(m.TABLE), e._resetInsertionMode()) : n === m.TEMPLATE ? Ln(e, t) : n !== m.BODY && n !== m.CAPTION && n !== m.COL && n !== m.COLGROUP && n !== m.HTML && n !== m.TBODY && n !== m.TD && n !== m.TFOOT && n !== m.TH && n !== m.THEAD && n !== m.TR && lt(e, t);
}
function lt(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function uI(e, t) {
  e.pendingCharacterTokens.push(t);
}
function cI(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function $o(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      lt(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function hI(e, t) {
  const n = t.tagName;
  n === m.CAPTION || n === m.COL || n === m.COLGROUP || n === m.TBODY || n === m.TD || n === m.TFOOT || n === m.TH || n === m.THEAD || n === m.TR ? e.openElements.hasInTableScope(m.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(m.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Ue, e._processToken(t)) : Je(e, t);
}
function mI(e, t) {
  const n = t.tagName;
  n === m.CAPTION || n === m.TABLE ? e.openElements.hasInTableScope(m.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(m.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Ue, n === m.TABLE && e._processToken(t)) : n !== m.BODY && n !== m.COL && n !== m.COLGROUP && n !== m.HTML && n !== m.TBODY && n !== m.TD && n !== m.TFOOT && n !== m.TH && n !== m.THEAD && n !== m.TR && Ca(e, t);
}
function pI(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.COL ? (e._appendElement(t, re.HTML), t.ackSelfClosing = !0) : n === m.TEMPLATE ? Be(e, t) : Yr(e, t);
}
function fI(e, t) {
  const n = t.tagName;
  n === m.COLGROUP ? e.openElements.currentTagName === m.COLGROUP && (e.openElements.pop(), e.insertionMode = Ue) : n === m.TEMPLATE ? Ln(e, t) : n !== m.COL && Yr(e, t);
}
function Yr(e, t) {
  e.openElements.currentTagName === m.COLGROUP && (e.openElements.pop(), e.insertionMode = Ue, e._processToken(t));
}
function gI(e, t) {
  const n = t.tagName;
  n === m.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, re.HTML), e.insertionMode = Kt) : n === m.TH || n === m.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(m.TR), e.insertionMode = Kt, e._processToken(t)) : n === m.CAPTION || n === m.COL || n === m.COLGROUP || n === m.TBODY || n === m.TFOOT || n === m.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Ue, e._processToken(t)) : _a(e, t);
}
function vI(e, t) {
  const n = t.tagName;
  n === m.TBODY || n === m.TFOOT || n === m.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Ue) : n === m.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Ue, e._processToken(t)) : (n !== m.BODY && n !== m.CAPTION && n !== m.COL && n !== m.COLGROUP || n !== m.HTML && n !== m.TD && n !== m.TH && n !== m.TR) && wa(e, t);
}
function bI(e, t) {
  const n = t.tagName;
  n === m.TH || n === m.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, re.HTML), e.insertionMode = wi, e.activeFormattingElements.insertMarker()) : n === m.CAPTION || n === m.COL || n === m.COLGROUP || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR ? e.openElements.hasInTableScope(m.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = dt, e._processToken(t)) : _a(e, t);
}
function yI(e, t) {
  const n = t.tagName;
  n === m.TR ? e.openElements.hasInTableScope(m.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = dt) : n === m.TABLE ? e.openElements.hasInTableScope(m.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = dt, e._processToken(t)) : n === m.TBODY || n === m.TFOOT || n === m.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope(m.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = dt, e._processToken(t)) : (n !== m.BODY && n !== m.CAPTION && n !== m.COL && n !== m.COLGROUP || n !== m.HTML && n !== m.TD && n !== m.TH) && wa(e, t);
}
function CI(e, t) {
  const n = t.tagName;
  n === m.CAPTION || n === m.COL || n === m.COLGROUP || n === m.TBODY || n === m.TD || n === m.TFOOT || n === m.TH || n === m.THEAD || n === m.TR ? (e.openElements.hasInTableScope(m.TD) || e.openElements.hasInTableScope(m.TH)) && (e._closeTableCell(), e._processToken(t)) : Je(e, t);
}
function _I(e, t) {
  const n = t.tagName;
  n === m.TD || n === m.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Kt) : n === m.TABLE || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== m.BODY && n !== m.CAPTION && n !== m.COL && n !== m.COLGROUP && n !== m.HTML && Ca(e, t);
}
function Zc(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.OPTION ? (e.openElements.currentTagName === m.OPTION && e.openElements.pop(), e._insertElement(t, re.HTML)) : n === m.OPTGROUP ? (e.openElements.currentTagName === m.OPTION && e.openElements.pop(), e.openElements.currentTagName === m.OPTGROUP && e.openElements.pop(), e._insertElement(t, re.HTML)) : n === m.INPUT || n === m.KEYGEN || n === m.TEXTAREA || n === m.SELECT ? e.openElements.hasInSelectScope(m.SELECT) && (e.openElements.popUntilTagNamePopped(m.SELECT), e._resetInsertionMode(), n !== m.SELECT && e._processToken(t)) : (n === m.SCRIPT || n === m.TEMPLATE) && Be(e, t);
}
function Wc(e, t) {
  const n = t.tagName;
  if (n === m.OPTGROUP) {
    const o = e.openElements.items[e.openElements.stackTop - 1], i = o && e.treeAdapter.getTagName(o);
    e.openElements.currentTagName === m.OPTION && i === m.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === m.OPTGROUP && e.openElements.pop();
  } else n === m.OPTION ? e.openElements.currentTagName === m.OPTION && e.openElements.pop() : n === m.SELECT && e.openElements.hasInSelectScope(m.SELECT) ? (e.openElements.popUntilTagNamePopped(m.SELECT), e._resetInsertionMode()) : n === m.TEMPLATE && Ln(e, t);
}
function wI(e, t) {
  const n = t.tagName;
  n === m.CAPTION || n === m.TABLE || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR || n === m.TD || n === m.TH ? (e.openElements.popUntilTagNamePopped(m.SELECT), e._resetInsertionMode(), e._processToken(t)) : Zc(e, t);
}
function TI(e, t) {
  const n = t.tagName;
  n === m.CAPTION || n === m.TABLE || n === m.TBODY || n === m.TFOOT || n === m.THEAD || n === m.TR || n === m.TD || n === m.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(m.SELECT), e._resetInsertionMode(), e._processToken(t)) : Wc(e, t);
}
function kI(e, t) {
  const n = t.tagName;
  if (n === m.BASE || n === m.BASEFONT || n === m.BGSOUND || n === m.LINK || n === m.META || n === m.NOFRAMES || n === m.SCRIPT || n === m.STYLE || n === m.TEMPLATE || n === m.TITLE)
    Be(e, t);
  else {
    const o = i$[n] || $t;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(o), e.insertionMode = o, e._processToken(t);
  }
}
function EI(e, t) {
  t.tagName === m.TEMPLATE && Ln(e, t);
}
function qc(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(m.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function SI(e, t) {
  t.tagName === m.HTML ? Je(e, t) : xr(e, t);
}
function MI(e, t) {
  t.tagName === m.HTML ? e.fragmentContext || (e.insertionMode = Gc) : xr(e, t);
}
function xr(e, t) {
  e.insertionMode = $t, e._processToken(t);
}
function $I(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.FRAMESET ? e._insertElement(t, re.HTML) : n === m.FRAME ? (e._appendElement(t, re.HTML), t.ackSelfClosing = !0) : n === m.NOFRAMES && Be(e, t);
}
function II(e, t) {
  t.tagName === m.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== m.FRAMESET && (e.insertionMode = Kc));
}
function AI(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.NOFRAMES && Be(e, t);
}
function LI(e, t) {
  t.tagName === m.HTML && (e.insertionMode = zc);
}
function OI(e, t) {
  t.tagName === m.HTML ? Je(e, t) : Lr(e, t);
}
function Lr(e, t) {
  e.insertionMode = $t, e._processToken(t);
}
function NI(e, t) {
  const n = t.tagName;
  n === m.HTML ? Je(e, t) : n === m.NOFRAMES && Be(e, t);
}
function HI(e, t) {
  t.chars = e$.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function PI(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function DI(e, t) {
  if (Mt.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== re.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const n = e._getAdjustedCurrentElement(), o = e.treeAdapter.getNamespaceURI(n);
    o === re.MATHML ? Mt.adjustTokenMathMLAttrs(t) : o === re.SVG && (Mt.adjustTokenSVGTagName(t), Mt.adjustTokenSVGAttrs(t)), Mt.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, o) : e._insertElement(t, o), t.ackSelfClosing = !0;
  }
}
function RI(e, t) {
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const o = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(o) === re.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(o).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(o);
      break;
    }
  }
}
const VI = /* @__PURE__ */ so(a$);
class tr {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, o) {
    this.property = t, this.normal = n, o && (this.space = o);
  }
}
tr.prototype.property = {};
tr.prototype.normal = {};
tr.prototype.space = null;
function Yc(e, t) {
  const n = {}, o = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(o, e[i].normal);
  return new tr(n, o, t);
}
function Zo(e) {
  return e.toLowerCase();
}
class ht {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
ht.prototype.space = null;
ht.prototype.boolean = !1;
ht.prototype.booleanish = !1;
ht.prototype.overloadedBoolean = !1;
ht.prototype.number = !1;
ht.prototype.commaSeparated = !1;
ht.prototype.spaceSeparated = !1;
ht.prototype.commaOrSpaceSeparated = !1;
ht.prototype.mustUseProperty = !1;
ht.prototype.defined = !1;
let BI = 0;
const he = On(), Pe = On(), xc = On(), x = On(), Se = On(), Wn = On(), ot = On();
function On() {
  return 2 ** ++BI;
}
const Bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: he,
  booleanish: Pe,
  commaOrSpaceSeparated: ot,
  commaSeparated: Wn,
  number: x,
  overloadedBoolean: xc,
  spaceSeparated: Se
}, Symbol.toStringTag, { value: "Module" })), gs = Object.keys(Bs);
class Ta extends ht {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, o, i) {
    let r = -1;
    if (super(t, n), ad(this, "space", i), typeof o == "number")
      for (; ++r < gs.length; ) {
        const a = gs[r];
        ad(this, gs[r], (o & Bs[a]) === Bs[a]);
      }
  }
}
Ta.prototype.defined = !0;
function ad(e, t, n) {
  n && (e[t] = n);
}
const FI = {}.hasOwnProperty;
function lo(e) {
  const t = {}, n = {};
  let o;
  for (o in e.properties)
    if (FI.call(e.properties, o)) {
      const i = e.properties[o], r = new Ta(
        o,
        e.transform(e.attributes || {}, o),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(o) && (r.mustUseProperty = !0), t[o] = r, n[Zo(o)] = o, n[Zo(r.attribute)] = o;
    }
  return new tr(t, n, e.space);
}
const Xc = lo({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Qc = lo({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Jc(e, t) {
  return t in e ? e[t] : t;
}
function eh(e, t) {
  return Jc(e, t.toLowerCase());
}
const th = lo({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: eh,
  properties: { xmlns: null, xmlnsXLink: null }
}), nh = lo({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Pe,
    ariaAutoComplete: null,
    ariaBusy: Pe,
    ariaChecked: Pe,
    ariaColCount: x,
    ariaColIndex: x,
    ariaColSpan: x,
    ariaControls: Se,
    ariaCurrent: null,
    ariaDescribedBy: Se,
    ariaDetails: null,
    ariaDisabled: Pe,
    ariaDropEffect: Se,
    ariaErrorMessage: null,
    ariaExpanded: Pe,
    ariaFlowTo: Se,
    ariaGrabbed: Pe,
    ariaHasPopup: null,
    ariaHidden: Pe,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Se,
    ariaLevel: x,
    ariaLive: null,
    ariaModal: Pe,
    ariaMultiLine: Pe,
    ariaMultiSelectable: Pe,
    ariaOrientation: null,
    ariaOwns: Se,
    ariaPlaceholder: null,
    ariaPosInSet: x,
    ariaPressed: Pe,
    ariaReadOnly: Pe,
    ariaRelevant: null,
    ariaRequired: Pe,
    ariaRoleDescription: Se,
    ariaRowCount: x,
    ariaRowIndex: x,
    ariaRowSpan: x,
    ariaSelected: Pe,
    ariaSetSize: x,
    ariaSort: null,
    ariaValueMax: x,
    ariaValueMin: x,
    ariaValueNow: x,
    ariaValueText: null,
    role: null
  }
}), jI = lo({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: eh,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Wn,
    acceptCharset: Se,
    accessKey: Se,
    action: null,
    allow: null,
    allowFullScreen: he,
    allowPaymentRequest: he,
    allowUserMedia: he,
    alt: null,
    as: null,
    async: he,
    autoCapitalize: null,
    autoComplete: Se,
    autoFocus: he,
    autoPlay: he,
    blocking: Se,
    capture: null,
    charSet: null,
    checked: he,
    cite: null,
    className: Se,
    cols: x,
    colSpan: null,
    content: null,
    contentEditable: Pe,
    controls: he,
    controlsList: Se,
    coords: x | Wn,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: he,
    defer: he,
    dir: null,
    dirName: null,
    disabled: he,
    download: xc,
    draggable: Pe,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: he,
    formTarget: null,
    headers: Se,
    height: x,
    hidden: he,
    high: x,
    href: null,
    hrefLang: null,
    htmlFor: Se,
    httpEquiv: Se,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: he,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: he,
    itemId: null,
    itemProp: Se,
    itemRef: Se,
    itemScope: he,
    itemType: Se,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: he,
    low: x,
    manifest: null,
    max: null,
    maxLength: x,
    media: null,
    method: null,
    min: null,
    minLength: x,
    multiple: he,
    muted: he,
    name: null,
    nonce: null,
    noModule: he,
    noValidate: he,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: he,
    optimum: x,
    pattern: null,
    ping: Se,
    placeholder: null,
    playsInline: he,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: he,
    referrerPolicy: null,
    rel: Se,
    required: he,
    reversed: he,
    rows: x,
    rowSpan: x,
    sandbox: Se,
    scope: null,
    scoped: he,
    seamless: he,
    selected: he,
    shadowRootClonable: he,
    shadowRootDelegatesFocus: he,
    shadowRootMode: null,
    shape: null,
    size: x,
    sizes: null,
    slot: null,
    span: x,
    spellCheck: Pe,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: x,
    step: null,
    style: null,
    tabIndex: x,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: he,
    useMap: null,
    value: Pe,
    width: x,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Se,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: x,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: x,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: he,
    // Lists. Use CSS to reduce space between items instead
    declare: he,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: x,
    // `<img>` and `<object>`
    leftMargin: x,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: x,
    // `<body>`
    marginWidth: x,
    // `<body>`
    noResize: he,
    // `<frame>`
    noHref: he,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: he,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: he,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: x,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Pe,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: x,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: x,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: he,
    disableRemotePlayback: he,
    prefix: null,
    property: null,
    results: x,
    security: null,
    unselectable: null
  }
}), UI = lo({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Jc,
  properties: {
    about: ot,
    accentHeight: x,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: x,
    amplitude: x,
    arabicForm: null,
    ascent: x,
    attributeName: null,
    attributeType: null,
    azimuth: x,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: x,
    by: null,
    calcMode: null,
    capHeight: x,
    className: Se,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: x,
    diffuseConstant: x,
    direction: null,
    display: null,
    dur: null,
    divisor: x,
    dominantBaseline: null,
    download: he,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: x,
    enableBackground: null,
    end: null,
    event: null,
    exponent: x,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: x,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Wn,
    g2: Wn,
    glyphName: Wn,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: x,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: x,
    horizOriginX: x,
    horizOriginY: x,
    id: null,
    ideographic: x,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: x,
    k: x,
    k1: x,
    k2: x,
    k3: x,
    k4: x,
    kernelMatrix: ot,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: x,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: x,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: x,
    overlineThickness: x,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: x,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Se,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: x,
    pointsAtY: x,
    pointsAtZ: x,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ot,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ot,
    rev: ot,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ot,
    requiredFeatures: ot,
    requiredFonts: ot,
    requiredFormats: ot,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: x,
    specularExponent: x,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: x,
    strikethroughThickness: x,
    string: null,
    stroke: null,
    strokeDashArray: ot,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: x,
    strokeOpacity: x,
    strokeWidth: null,
    style: null,
    surfaceScale: x,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ot,
    tabIndex: x,
    tableValues: null,
    target: null,
    targetX: x,
    targetY: x,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ot,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: x,
    underlineThickness: x,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: x,
    values: null,
    vAlphabetic: x,
    vMathematical: x,
    vectorEffect: null,
    vHanging: x,
    vIdeographic: x,
    version: null,
    vertAdvY: x,
    vertOriginX: x,
    vertOriginY: x,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: x,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), KI = /^data[-\w.:]+$/i, ld = /-[a-z]/g, GI = /[A-Z]/g;
function ka(e, t) {
  const n = Zo(t);
  let o = t, i = ht;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && KI.test(t)) {
    if (t.charAt(4) === "-") {
      const r = t.slice(5).replace(ld, ZI);
      o = "data" + r.charAt(0).toUpperCase() + r.slice(1);
    } else {
      const r = t.slice(4);
      if (!ld.test(r)) {
        let a = r.replace(GI, zI);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = Ta;
  }
  return new i(o, t);
}
function zI(e) {
  return "-" + e.toLowerCase();
}
function ZI(e) {
  return e.charAt(1).toUpperCase();
}
const ki = Yc([Qc, Xc, th, nh, jI], "html"), nr = Yc([Qc, Xc, th, nh, UI], "svg"), dd = /[#.]/g;
function WI(e, t) {
  const n = e || "", o = {};
  let i = 0, r, a;
  for (; i < n.length; ) {
    dd.lastIndex = i;
    const s = dd.exec(n), u = n.slice(i, s ? s.index : n.length);
    u && (r ? r === "#" ? o.id = u : Array.isArray(o.className) ? o.className.push(u) : o.className = [u] : a = u, i += u.length), s && (r = s[0], i++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: a || t || "div",
    properties: o,
    children: []
  };
}
function ud(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function qI(e) {
  return e.join(" ").trim();
}
function cd(e) {
  const t = [], n = String(e || "");
  let o = n.indexOf(","), i = 0, r = !1;
  for (; !r; ) {
    o === -1 && (o = n.length, r = !0);
    const a = n.slice(i, o).trim();
    (a || !r) && t.push(a), i = o + 1, o = n.indexOf(",", i);
  }
  return t;
}
function YI(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const xI = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), Fs = {}.hasOwnProperty;
function oh(e, t, n) {
  const o = n && eA(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(i, r, ...a) {
      let s = -1, u;
      if (i == null)
        u = { type: "root", children: [] }, a.unshift(r);
      else if (u = WI(i, t), u.tagName = u.tagName.toLowerCase(), o && Fs.call(o, u.tagName) && (u.tagName = o[u.tagName]), XI(r, u.tagName)) {
        let c;
        for (c in r)
          Fs.call(r, c) && QI(e, u.properties, c, r[c]);
      } else
        a.unshift(r);
      for (; ++s < a.length; )
        js(u.children, a[s]);
      return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
    }
  );
}
function XI(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? xI.has(e.type.toLowerCase()) : !("value" in e);
}
function QI(e, t, n, o) {
  const i = ka(e, n);
  let r = -1, a;
  if (o != null) {
    if (typeof o == "number") {
      if (Number.isNaN(o)) return;
      a = o;
    } else typeof o == "boolean" ? a = o : typeof o == "string" ? i.spaceSeparated ? a = ud(o) : i.commaSeparated ? a = cd(o) : i.commaOrSpaceSeparated ? a = ud(cd(o).join(" ")) : a = hd(i, i.property, o) : Array.isArray(o) ? a = o.concat() : a = i.property === "style" ? JI(o) : String(o);
    if (Array.isArray(a)) {
      const s = [];
      for (; ++r < a.length; )
        s[r] = hd(i, i.property, a[r]);
      a = s;
    }
    i.property === "className" && Array.isArray(t.className) && (a = t.className.concat(a)), t[i.property] = a;
  }
}
function js(e, t) {
  let n = -1;
  if (t != null) if (typeof t == "string" || typeof t == "number")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (; ++n < t.length; )
      js(e, t[n]);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? js(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function hd(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || Zo(n) === Zo(t)))
      return !0;
  }
  return n;
}
function JI(e) {
  const t = [];
  let n;
  for (n in e)
    Fs.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function eA(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const Me = oh(ki, "div"), tA = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], nA = oh(nr, "g", tA);
function oA(e) {
  const t = String(e), n = [], o = /\r?\n|\r/g;
  for (; o.test(t); )
    n.push(o.lastIndex);
  return n.push(t.length + 1), { toPoint: i, toOffset: r };
  function i(a) {
    let s = -1;
    if (typeof a == "number" && a > -1 && a < n[n.length - 1]) {
      for (; ++s < n.length; )
        if (n[s] > a)
          return {
            line: s + 1,
            column: a - (s > 0 ? n[s - 1] : 0) + 1,
            offset: a
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function r(a) {
    const s = a && a.line, u = a && a.column;
    if (typeof s == "number" && typeof u == "number" && !Number.isNaN(s) && !Number.isNaN(u) && s - 1 in n) {
      const c = (n[s - 2] || 0) + u - 1 || 0;
      if (c > -1 && c < n[n.length - 1])
        return c;
    }
    return -1;
  }
}
const rA = {
  svg: "http://www.w3.org/2000/svg"
}, rh = {}.hasOwnProperty, iA = Object.prototype;
function sA(e, t) {
  const n = t || {};
  let o, i;
  return dA(n) ? (i = n, o = {}) : (i = n.file || void 0, o = n), Ea(
    {
      schema: o.space === "svg" ? nr : ki,
      file: i,
      verbose: o.verbose,
      location: !1
    },
    e
  );
}
function Ea(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const o = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: o.data }, Or(e, o, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const o = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), i = "mode" in o ? o.mode === "quirks" || o.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: ih(e, t.childNodes),
        data: { quirksMode: i }
      }, e.file && e.location) {
        const r = String(e.file), a = oA(r), s = a.toPoint(0), u = a.toPoint(r.length);
        n.position = { start: s, end: u };
      }
      return n;
    }
    case "#documentType": {
      const o = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, Or(e, o, n), n;
    }
    case "#text": {
      const o = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: o.value }, Or(e, o, n), n;
    }
    default:
      return n = aA(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function ih(e, t) {
  let n = -1;
  const o = [];
  for (; ++n < t.length; )
    o[n] = Ea(e, t[n]);
  return o;
}
function aA(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === rA.svg ? nr : ki;
  let o = -1;
  const i = {};
  for (; ++o < t.attrs.length; ) {
    const a = t.attrs[o], s = (a.prefix ? a.prefix + ":" : "") + a.name;
    rh.call(iA, s) || (i[s] = a.value);
  }
  const r = (e.schema.space === "svg" ? nA : Me)(t.tagName, i, ih(e, t.childNodes));
  if (Or(e, t, r), r.tagName === "template") {
    const a = (
      /** @type {P5Template} */
      t
    ), s = a.sourceCodeLocation, u = s && s.startTag && Zn(s.startTag), c = s && s.endTag && Zn(s.endTag), y = Ea(e, a.content);
    u && c && e.file && (y.position = { start: u.end, end: c.start }), r.content = y;
  }
  return e.schema = n, r;
}
function Or(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const o = lA(e, n, t.sourceCodeLocation);
    o && (e.location = !0, n.position = o);
  }
}
function lA(e, t, n) {
  const o = Zn(n);
  if (t.type === "element") {
    const i = t.children[t.children.length - 1];
    if (o && !n.endTag && i && i.position && i.position.end && (o.end = Object.assign({}, i.position.end)), e.verbose) {
      const r = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          rh.call(n.attrs, a) && (r[ka(e.schema, a).property] = Zn(
            n.attrs[a]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: Zn(n.startTag),
          closing: n.endTag ? Zn(n.endTag) : null,
          properties: r
        }
      };
    }
  }
  return o;
}
function Zn(e) {
  const t = md({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = md({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function md(e) {
  return e.line && e.column ? e : void 0;
}
function dA(e) {
  return "messages" in e;
}
const uA = {
  abandonedHeadElementChild: {
    reason: "Unexpected metadata element after head",
    description: "Unexpected element after head. Expected the element before `</head>`",
    url: !1
  },
  abruptClosingOfEmptyComment: {
    reason: "Unexpected abruptly closed empty comment",
    description: "Unexpected `>` or `->`. Expected `-->` to close comments"
  },
  abruptDoctypePublicIdentifier: {
    reason: "Unexpected abruptly closed public identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
  },
  abruptDoctypeSystemIdentifier: {
    reason: "Unexpected abruptly closed system identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
  },
  absenceOfDigitsInNumericCharacterReference: {
    reason: "Unexpected non-digit at start of numeric character reference",
    description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
  },
  cdataInHtmlContent: {
    reason: "Unexpected CDATA section in HTML",
    description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
  },
  characterReferenceOutsideUnicodeRange: {
    reason: "Unexpected too big numeric character reference",
    description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
  },
  closingOfElementWithOpenChildElements: {
    reason: "Unexpected closing tag with open child elements",
    description: "Unexpectedly closing tag. Expected other tags to be closed first",
    url: !1
  },
  controlCharacterInInputStream: {
    reason: "Unexpected control character",
    description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  controlCharacterReference: {
    reason: "Unexpected control character reference",
    description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  disallowedContentInNoscriptInHead: {
    reason: "Disallowed content inside `<noscript>` in `<head>`",
    description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
    url: !1
  },
  duplicateAttribute: {
    reason: "Unexpected duplicate attribute",
    description: "Unexpectedly double attribute. Expected attributes to occur only once"
  },
  endTagWithAttributes: {
    reason: "Unexpected attribute on closing tag",
    description: "Unexpected attribute. Expected `>` instead"
  },
  endTagWithTrailingSolidus: {
    reason: "Unexpected slash at end of closing tag",
    description: "Unexpected `%c-1`. Expected `>` instead"
  },
  endTagWithoutMatchingOpenElement: {
    reason: "Unexpected unopened end tag",
    description: "Unexpected end tag. Expected no end tag or another end tag",
    url: !1
  },
  eofBeforeTagName: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected tag name instead"
  },
  eofInCdata: {
    reason: "Unexpected end of file in CDATA",
    description: "Unexpected end of file. Expected `]]>` to close the CDATA"
  },
  eofInComment: {
    reason: "Unexpected end of file in comment",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInDoctype: {
    reason: "Unexpected end of file in doctype",
    description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
  },
  eofInElementThatCanContainOnlyText: {
    reason: "Unexpected end of file in element that can only contain text",
    description: "Unexpected end of file. Expected text or a closing tag",
    url: !1
  },
  eofInScriptHtmlCommentLikeText: {
    reason: "Unexpected end of file in comment inside script",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInTag: {
    reason: "Unexpected end of file in tag",
    description: "Unexpected end of file. Expected `>` to close the tag"
  },
  incorrectlyClosedComment: {
    reason: "Incorrectly closed comment",
    description: "Unexpected `%c-1`. Expected `-->` to close the comment"
  },
  incorrectlyOpenedComment: {
    reason: "Incorrectly opened comment",
    description: "Unexpected `%c`. Expected `<!--` to open the comment"
  },
  invalidCharacterSequenceAfterDoctypeName: {
    reason: "Invalid sequence after doctype name",
    description: "Unexpected sequence at `%c`. Expected `public` or `system`"
  },
  invalidFirstCharacterOfTagName: {
    reason: "Invalid first character in tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  misplacedDoctype: {
    reason: "Misplaced doctype",
    description: "Unexpected doctype. Expected doctype before head",
    url: !1
  },
  misplacedStartTagForHeadElement: {
    reason: "Misplaced `<head>` start tag",
    description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
    url: !1
  },
  missingAttributeValue: {
    reason: "Missing attribute value",
    description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
  },
  missingDoctype: {
    reason: "Missing doctype before other content",
    description: "Expected a `<!doctype html>` before anything else",
    url: !1
  },
  missingDoctypeName: {
    reason: "Missing doctype name",
    description: "Unexpected doctype end at `%c`. Expected `html` instead"
  },
  missingDoctypePublicIdentifier: {
    reason: "Missing public identifier in doctype",
    description: "Unexpected `%c`. Expected identifier for `public` instead"
  },
  missingDoctypeSystemIdentifier: {
    reason: "Missing system identifier in doctype",
    description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
  },
  missingEndTagName: {
    reason: "Missing name in end tag",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  missingQuoteBeforeDoctypePublicIdentifier: {
    reason: "Missing quote before public identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingQuoteBeforeDoctypeSystemIdentifier: {
    reason: "Missing quote before system identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingSemicolonAfterCharacterReference: {
    reason: "Missing semicolon after character reference",
    description: "Unexpected `%c`. Expected `;` instead"
  },
  missingWhitespaceAfterDoctypePublicKeyword: {
    reason: "Missing whitespace after public identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceAfterDoctypeSystemKeyword: {
    reason: "Missing whitespace after system identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBeforeDoctypeName: {
    reason: "Missing whitespace before doctype name",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenAttributes: {
    reason: "Missing whitespace between attributes",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
    reason: "Missing whitespace between public and system identifiers in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  nestedComment: {
    reason: "Unexpected nested comment",
    description: "Unexpected `<!--`. Expected `-->`"
  },
  nestedNoscriptInHead: {
    reason: "Unexpected nested `<noscript>` in `<head>`",
    description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
    url: !1
  },
  nonConformingDoctype: {
    reason: "Unexpected non-conforming doctype declaration",
    description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
    url: !1
  },
  nonVoidHtmlElementStartTagWithTrailingSolidus: {
    reason: "Unexpected trailing slash on start tag of non-void element",
    description: "Unexpected `/`. Expected `>` instead"
  },
  noncharacterCharacterReference: {
    reason: "Unexpected noncharacter code point referenced by character reference",
    description: "Unexpected code point. Do not use noncharacters in HTML"
  },
  noncharacterInInputStream: {
    reason: "Unexpected noncharacter character",
    description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
  },
  nullCharacterReference: {
    reason: "Unexpected NULL character referenced by character reference",
    description: "Unexpected code point. Do not use NULL characters in HTML"
  },
  openElementsLeftAfterEof: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected closing tag instead",
    url: !1
  },
  surrogateCharacterReference: {
    reason: "Unexpected surrogate character referenced by character reference",
    description: "Unexpected code point. Do not use lone surrogate characters in HTML"
  },
  surrogateInInputStream: {
    reason: "Unexpected surrogate character",
    description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
  },
  unexpectedCharacterAfterDoctypeSystemIdentifier: {
    reason: "Invalid character after system identifier in doctype",
    description: "Unexpected character at `%c`. Expected `>`"
  },
  unexpectedCharacterInAttributeName: {
    reason: "Unexpected character in attribute name",
    description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
  },
  unexpectedCharacterInUnquotedAttributeValue: {
    reason: "Unexpected character in unquoted attribute value",
    description: "Unexpected `%c`. Quote the attribute value to include it"
  },
  unexpectedEqualsSignBeforeAttributeName: {
    reason: "Unexpected equals sign before attribute name",
    description: "Unexpected `%c`. Add an attribute name before it"
  },
  unexpectedNullCharacter: {
    reason: "Unexpected NULL character",
    description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
  },
  unexpectedQuestionMarkInsteadOfTagName: {
    reason: "Unexpected question mark instead of tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  unexpectedSolidusInTag: {
    reason: "Unexpected slash in tag",
    description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
  },
  unknownNamedCharacterReference: {
    reason: "Unexpected unknown named character reference",
    description: "Unexpected character reference. Expected known named character references"
  }
}, cA = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", hA = { 2: !0, 1: !1, 0: null };
function sh(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Parser: o });
  function o(i, r) {
    const a = n.fragment ? "parseFragment" : "parse", s = n.emitParseErrors ? c : null, u = new VI({
      sourceCodeLocationInfo: !0,
      onParseError: s,
      scriptingEnabled: !1
    });
    return sA(u[a](i), {
      space: n.space,
      file: r,
      verbose: n.verbose
    });
    function c(y) {
      const w = y.code, v = mA(w), E = n[v], F = E == null ? !0 : E, O = typeof F == "number" ? F : F ? 1 : 0, L = {
        line: y.startLine,
        column: y.startCol,
        offset: y.startOffset
      }, U = {
        line: y.endLine,
        column: y.endCol,
        offset: y.endOffset
      };
      if (O) {
        const B = uA[v] || { reason: "", description: "", url: "" }, j = r.message(z(B.reason), { start: L, end: U });
        j.source = "parse-error", j.ruleId = w, j.fatal = hA[O], j.note = z(B.description), j.url = "url" in B && B.url === !1 ? null : cA + w;
      }
      function z(B) {
        return B.replace(/%c(?:-(\d+))?/g, (j, Y) => {
          const K = Y ? -Number.parseInt(Y, 10) : 0, ne = i.charAt(y.startOffset + K);
          return ne === "`" ? "` ` `" : ne;
        }).replace(
          /%x/g,
          () => "0x" + i.charCodeAt(y.startOffset).toString(16).toUpperCase()
        );
      }
    }
  }
}
function mA(e) {
  return e.replace(/-[a-z]/g, (t) => t.charAt(1).toUpperCase());
}
const ah = {
  strip: ["script"],
  clobberPrefix: "user-content-",
  clobber: ["name", "id"],
  ancestors: {
    tbody: ["table"],
    tfoot: ["table"],
    thead: ["table"],
    td: ["table"],
    th: ["table"],
    tr: ["table"]
  },
  protocols: {
    href: ["http", "https", "mailto", "xmpp", "irc", "ircs"],
    cite: ["http", "https"],
    src: ["http", "https"],
    longDesc: ["http", "https"]
  },
  tagNames: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "br",
    "b",
    "i",
    "strong",
    "em",
    "a",
    "pre",
    "code",
    "img",
    "tt",
    "div",
    "ins",
    "del",
    "sup",
    "sub",
    "p",
    "ol",
    "ul",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "blockquote",
    "dl",
    "dt",
    "dd",
    "kbd",
    "q",
    "samp",
    "var",
    "hr",
    "ruby",
    "rt",
    "rp",
    "li",
    "tr",
    "td",
    "th",
    "s",
    "strike",
    "summary",
    "details",
    "caption",
    "figure",
    "figcaption",
    "abbr",
    "bdo",
    "cite",
    "dfn",
    "mark",
    "small",
    "span",
    "time",
    "wbr",
    "input"
  ],
  attributes: {
    a: ["href"],
    img: ["src", "longDesc"],
    input: [
      ["type", "checkbox"],
      ["disabled", !0]
    ],
    li: [["className", "task-list-item"]],
    div: ["itemScope", "itemType"],
    blockquote: ["cite"],
    del: ["cite"],
    ins: ["cite"],
    q: ["cite"],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "ariaDescribedBy",
      "ariaHidden",
      "ariaLabel",
      "ariaLabelledBy",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "cols",
      "colSpan",
      "color",
      "compact",
      "coords",
      "dateTime",
      "dir",
      "disabled",
      "encType",
      "htmlFor",
      "frame",
      "headers",
      "height",
      "hrefLang",
      "hSpace",
      "isMap",
      "id",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rel",
      "rev",
      "rows",
      "rowSpan",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "target",
      "title",
      "type",
      "useMap",
      "vAlign",
      "value",
      "vSpace",
      "width",
      "itemProp"
    ]
  },
  required: {
    input: {
      type: "checkbox",
      disabled: !0
    }
  }
}, St = {}.hasOwnProperty, vs = {
  root: { children: pd },
  doctype: fA,
  comment: gA,
  element: {
    tagName: dh,
    properties: vA,
    children: pd
  },
  text: { value: CA },
  "*": { data: fd, position: fd }
};
function pA(e, t) {
  let n = { type: "root", children: [] };
  if (e && typeof e == "object" && e.type) {
    const o = lh(
      Object.assign({}, ah, t || {}),
      e,
      []
    );
    o && (Array.isArray(o) ? o.length === 1 ? n = o[0] : n.children = o : n = o);
  }
  return n;
}
function lh(e, t, n) {
  const o = t && t.type, i = { type: t.type };
  let r;
  if (St.call(vs, o)) {
    let a = vs[o];
    if (typeof a == "function" && (a = a(e, t)), a) {
      const s = Object.assign({}, a, vs["*"]);
      let u;
      r = !0;
      for (u in s)
        if (St.call(s, u)) {
          const c = s[u](e, t[u], t, n);
          c === !1 ? (r = void 0, i[u] = t[u]) : c != null && (i[u] = c);
        }
    }
  }
  return r ? i : i.type === "element" && e.strip && !e.strip.includes(i.tagName) ? i.children : void 0;
}
function pd(e, t, n, o) {
  const i = [];
  if (Array.isArray(t)) {
    let r = -1;
    for (n.type === "element" && o.push(n.tagName); ++r < t.length; ) {
      const a = lh(e, t[r], o);
      a && (Array.isArray(a) ? i.push(...a) : i.push(a));
    }
    n.type === "element" && o.pop();
  }
  return i;
}
function fA(e) {
  return e.allowDoctypes ? { name: bA } : void 0;
}
function gA(e) {
  return e.allowComments ? { value: yA } : void 0;
}
function vA(e, t, n, o) {
  const i = dh(e, n.tagName, n, o), r = e.attributes || {}, a = e.required || {}, s = t || {}, u = Object.assign(
    {},
    gd(r["*"]),
    gd(i && St.call(r, i) ? r[i] : [])
  ), c = {};
  let y;
  for (y in s)
    if (St.call(s, y)) {
      let w = s[y], v;
      if (St.call(u, y))
        v = u[y];
      else if (TA(y) && St.call(u, "data*"))
        v = u["data*"];
      else
        continue;
      w = Array.isArray(w) ? _A(e, w, y, v) : uh(e, w, y, v), w != null && (c[y] = w);
    }
  if (i && St.call(a, i))
    for (y in a[i])
      St.call(c, y) || (c[y] = a[i][y]);
  return c;
}
function bA() {
  return "html";
}
function dh(e, t, n, o) {
  const i = typeof t == "string" ? t : "";
  let r = -1;
  if (!i || i === "*" || e.tagNames && !e.tagNames.includes(i))
    return !1;
  if (e.ancestors && St.call(e.ancestors, i)) {
    for (; ++r < e.ancestors[i].length; )
      if (o.includes(e.ancestors[i][r]))
        return i;
    return !1;
  }
  return i;
}
function yA(e, t) {
  const n = typeof t == "string" ? t : "", o = n.indexOf("-->");
  return o < 0 ? n : n.slice(0, o);
}
function CA(e, t) {
  return typeof t == "string" ? t : "";
}
function fd(e, t) {
  return t;
}
function _A(e, t, n, o) {
  let i = -1;
  const r = [];
  for (; ++i < t.length; ) {
    const a = uh(e, t[i], n, o);
    a != null && r.push(a);
  }
  return r;
}
function uh(e, t, n, o) {
  if ((typeof t == "boolean" || typeof t == "number" || typeof t == "string") && wA(e, t, n) && (o.length === 0 || o.some(
    (i) => i && typeof i == "object" && "flags" in i ? i.test(String(t)) : i === t
  )))
    return e.clobberPrefix && e.clobber && e.clobber.includes(n) ? e.clobberPrefix + t : t;
}
function wA(e, t, n) {
  const o = String(t), i = o.indexOf(":"), r = o.indexOf("?"), a = o.indexOf("#"), s = o.indexOf("/"), u = e.protocols && St.call(e.protocols, n) ? e.protocols[n].concat() : [];
  let c = -1;
  if (u.length === 0 || i < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  s > -1 && i > s || r > -1 && i > r || a > -1 && i > a)
    return !0;
  for (; ++c < u.length; )
    if (i === u[c].length && o.slice(0, u[c].length) === u[c])
      return !0;
  return !1;
}
function gd(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; ) {
    const o = e[n];
    Array.isArray(o) ? t[o[0]] = o.slice(1) : t[o] = [];
  }
  return t;
}
function TA(e) {
  return e.length > 4 && e.slice(0, 4).toLowerCase() === "data";
}
function ch(e = ah) {
  return (t) => pA(t, e);
}
const kA = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], vd = {}.hasOwnProperty;
function EA(e, t) {
  const n = t || {};
  function o(i, ...r) {
    let a = o.invalid;
    const s = o.handlers;
    if (i && vd.call(i, e)) {
      const u = String(i[e]);
      a = vd.call(s, u) ? s[u] : o.unknown;
    }
    if (a)
      return a.call(this, i, ...r);
  }
  return o.handlers = n.handlers || {}, o.invalid = n.invalid, o.unknown = n.unknown, o;
}
const SA = /["&'<>`]/g, MA = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, $A = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), IA = /[|\\{}()[\]^$+*?.]/g, bd = /* @__PURE__ */ new WeakMap();
function AA(e, t) {
  if (e = e.replace(
    t.subset ? LA(t.subset) : SA,
    o
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(MA, n).replace($A, o);
  function n(i, r, a) {
    return t.format(
      (i.charCodeAt(0) - 55296) * 1024 + i.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(r + 2),
      t
    );
  }
  function o(i, r, a) {
    return t.format(
      i.charCodeAt(0),
      a.charCodeAt(r + 1),
      t
    );
  }
}
function LA(e) {
  let t = bd.get(e);
  return t || (t = OA(e), bd.set(e, t)), t;
}
function OA(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(IA, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const NA = /[\dA-Fa-f]/;
function HA(e, t, n) {
  const o = "&#x" + e.toString(16).toUpperCase();
  return n && t && !NA.test(String.fromCharCode(t)) ? o : o + ";";
}
const PA = /\d/;
function DA(e, t, n) {
  const o = "&#" + String(e);
  return n && t && !PA.test(String.fromCharCode(t)) ? o : o + ";";
}
const RA = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], bs = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, VA = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], hh = {}.hasOwnProperty, Us = {};
let Er;
for (Er in bs)
  hh.call(bs, Er) && (Us[bs[Er]] = Er);
const BA = /[^\dA-Za-z]/;
function FA(e, t, n, o) {
  const i = String.fromCharCode(e);
  if (hh.call(Us, i)) {
    const r = Us[i], a = "&" + r;
    return n && RA.includes(r) && !VA.includes(r) && (!o || t && t !== 61 && BA.test(String.fromCharCode(t))) ? a : a + ";";
  }
  return "";
}
function jA(e, t, n) {
  let o = HA(e, t, n.omitOptionalSemicolons), i;
  if ((n.useNamedReferences || n.useShortestReferences) && (i = FA(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !i) && n.useShortestReferences) {
    const r = DA(e, t, n.omitOptionalSemicolons);
    r.length < o.length && (o = r);
  }
  return i && (!n.useShortestReferences || i.length < o.length) ? i : o;
}
function qn(e, t) {
  return AA(e, Object.assign({ format: jA }, t));
}
function UA(e, t, n, o) {
  return o.settings.bogusComments ? "<?" + qn(
    e.value,
    Object.assign({}, o.settings.characterReferences, { subset: [">"] })
  ) + ">" : "<!--" + e.value.replace(/^>|^->|<!--|-->|--!>|<!-$/g, i) + "-->";
  function i(r) {
    return qn(
      r,
      Object.assign({}, o.settings.characterReferences, {
        subset: ["<", ">"]
      })
    );
  }
}
function KA(e, t, n, o) {
  return "<!" + (o.settings.upperDoctype ? "DOCTYPE" : "doctype") + (o.settings.tightDoctype ? "" : " ") + "html>";
}
function yd(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let o = 0, i = n.indexOf(t);
  for (; i !== -1; )
    o++, i = n.indexOf(t, i + t.length);
  return o;
}
function Sa(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
const De = ph(1), mh = ph(-1);
function ph(e) {
  return t;
  function t(n, o, i) {
    const r = n ? n.children : [];
    let a = (o || 0) + e, s = r && r[a];
    if (!i)
      for (; s && Sa(s); )
        a += e, s = r[a];
    return s;
  }
}
const GA = {}.hasOwnProperty;
function fh(e) {
  return t;
  function t(n, o, i) {
    return GA.call(e, n.tagName) && e[n.tagName](n, o, i);
  }
}
const Ma = fh({
  html: zA,
  head: ys,
  body: ZA,
  p: WA,
  li: qA,
  dt: YA,
  dd: xA,
  rt: Cd,
  rp: Cd,
  optgroup: XA,
  option: QA,
  menuitem: JA,
  colgroup: ys,
  caption: ys,
  thead: eL,
  tbody: tL,
  tfoot: nL,
  tr: oL,
  td: _d,
  th: _d
});
function ys(e, t, n) {
  const o = De(n, t, !0);
  return !o || o.type !== "comment" && !(o.type === "text" && Sa(o.value.charAt(0)));
}
function zA(e, t, n) {
  const o = De(n, t);
  return !o || o.type !== "comment";
}
function ZA(e, t, n) {
  const o = De(n, t);
  return !o || o.type !== "comment";
}
function WA(e, t, n) {
  const o = De(n, t);
  return o ? o.type === "element" && (o.tagName === "address" || o.tagName === "article" || o.tagName === "aside" || o.tagName === "blockquote" || o.tagName === "details" || o.tagName === "div" || o.tagName === "dl" || o.tagName === "fieldset" || o.tagName === "figcaption" || o.tagName === "figure" || o.tagName === "footer" || o.tagName === "form" || o.tagName === "h1" || o.tagName === "h2" || o.tagName === "h3" || o.tagName === "h4" || o.tagName === "h5" || o.tagName === "h6" || o.tagName === "header" || o.tagName === "hgroup" || o.tagName === "hr" || o.tagName === "main" || o.tagName === "menu" || o.tagName === "nav" || o.tagName === "ol" || o.tagName === "p" || o.tagName === "pre" || o.tagName === "section" || o.tagName === "table" || o.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function qA(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && o.tagName === "li";
}
function YA(e, t, n) {
  const o = De(n, t);
  return o && o.type === "element" && (o.tagName === "dt" || o.tagName === "dd");
}
function xA(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "dt" || o.tagName === "dd");
}
function Cd(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "rp" || o.tagName === "rt");
}
function XA(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && o.tagName === "optgroup";
}
function QA(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "option" || o.tagName === "optgroup");
}
function JA(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "menuitem" || o.tagName === "hr" || o.tagName === "menu");
}
function eL(e, t, n) {
  const o = De(n, t);
  return o && o.type === "element" && (o.tagName === "tbody" || o.tagName === "tfoot");
}
function tL(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "tbody" || o.tagName === "tfoot");
}
function nL(e, t, n) {
  return !De(n, t);
}
function oL(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && o.tagName === "tr";
}
function _d(e, t, n) {
  const o = De(n, t);
  return !o || o.type === "element" && (o.tagName === "td" || o.tagName === "th");
}
const rL = fh({
  html: iL,
  head: sL,
  body: aL,
  colgroup: lL,
  tbody: dL
});
function iL(e) {
  const t = De(e, -1);
  return !t || t.type !== "comment";
}
function sL(e) {
  const t = e.children, n = [];
  let o = -1;
  for (; ++o < t.length; ) {
    const i = t[o];
    if (i.type === "element" && (i.tagName === "title" || i.tagName === "base")) {
      if (n.includes(i.tagName)) return !1;
      n.push(i.tagName);
    }
  }
  return t.length > 0;
}
function aL(e) {
  const t = De(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && Sa(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function lL(e, t, n) {
  const o = mh(n, t), i = De(e, -1, !0);
  return n && o && o.type === "element" && o.tagName === "colgroup" && Ma(o, n.children.indexOf(o), n) ? !1 : i && i.type === "element" && i.tagName === "col";
}
function dL(e, t, n) {
  const o = mh(n, t), i = De(e, -1);
  return n && o && o.type === "element" && (o.tagName === "thead" || o.tagName === "tbody") && Ma(o, n.children.indexOf(o), n) ? !1 : i && i.type === "element" && i.tagName === "tr";
}
const Sr = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function uL(e, t, n, o) {
  const i = o.schema, r = i.space === "svg" ? !1 : o.settings.omitOptionalTags;
  let a = i.space === "svg" ? o.settings.closeEmptyElements : o.settings.voids.includes(e.tagName.toLowerCase());
  const s = [];
  let u;
  i.space === "html" && e.tagName === "svg" && (o.schema = nr);
  const c = cL(o, e.properties), y = o.all(
    i.space === "html" && e.tagName === "template" ? e.content : e
  );
  return o.schema = i, y && (a = !1), (c || !r || !rL(e, t, n)) && (s.push("<", e.tagName, c ? " " + c : ""), a && (i.space === "svg" || o.settings.closeSelfClosing) && (u = c.charAt(c.length - 1), (!o.settings.tightSelfClosing || u === "/" || u && u !== '"' && u !== "'") && s.push(" "), s.push("/")), s.push(">")), s.push(y), !a && (!r || !Ma(e, t, n)) && s.push("</" + e.tagName + ">"), s.join("");
}
function cL(e, t) {
  const n = [];
  let o = -1, i;
  if (t) {
    for (i in t)
      if (t[i] !== void 0 && t[i] !== null) {
        const r = hL(e, i, t[i]);
        r && n.push(r);
      }
  }
  for (; ++o < n.length; ) {
    const r = e.settings.tightAttributes ? n[o].charAt(n[o].length - 1) : null;
    o !== n.length - 1 && r !== '"' && r !== "'" && (n[o] += " ");
  }
  return n.join("");
}
function hL(e, t, n) {
  const o = ka(e.schema, t), i = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, r = e.settings.allowDangerousCharacters ? 0 : 1;
  let a = e.quote, s;
  if (o.overloadedBoolean && (n === o.attribute || n === "") ? n = !0 : (o.boolean || o.overloadedBoolean && typeof n != "string") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const u = qn(
    o.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: Sr.name[i][r]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (o.commaSeparated ? YI : qI)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? u : (e.settings.preferUnquoted && (s = qn(
    n,
    Object.assign({}, e.settings.characterReferences, {
      subset: Sr.unquoted[i][r],
      attribute: !0
    })
  )), s !== n && (e.settings.quoteSmart && yd(n, a) > yd(n, e.alternative) && (a = e.alternative), s = a + qn(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (a === "'" ? Sr.single : Sr.double)[i][r],
      attribute: !0
    })
  ) + a), u + (s && "=" + s));
}
function gh(e, t, n, o) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : qn(
    e.value,
    Object.assign({}, o.settings.characterReferences, {
      subset: ["<", "&"]
    })
  );
}
function mL(e, t, n, o) {
  return o.settings.allowDangerousHtml ? e.value : gh(e, t, n, o);
}
function pL(e, t, n, o) {
  return o.all(e);
}
const fL = EA("type", {
  invalid: gL,
  unknown: vL,
  handlers: { comment: UA, doctype: KA, element: uL, raw: mL, root: pL, text: gh }
});
function gL(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function vL(e) {
  throw new Error("Cannot compile unknown node `" + e.type + "`");
}
function bL(e, t) {
  const n = t || {}, o = n.quote || '"', i = o === '"' ? "'" : '"';
  if (o !== '"' && o !== "'")
    throw new Error("Invalid quote `" + o + "`, expected `'` or `\"`");
  return {
    one: yL,
    all: CL,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || kA,
      characterReferences: n.characterReferences || n.entities || {},
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? nr : ki,
    quote: o,
    alternative: i
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function yL(e, t, n) {
  return fL(e, t, n, this);
}
function CL(e) {
  const t = [], n = e && e.children || [];
  let o = -1;
  for (; ++o < n.length; )
    t[o] = this.one(n[o], o, e);
  return t.join("");
}
function _L(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Compiler: o });
  function o(i) {
    return bL(i, n);
  }
}
var wL = Object.prototype;
function TL(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || wL;
  return e === n;
}
var Ei = TL;
function kL(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var vh = kL, EL = vh, SL = EL(Object.keys, Object), ML = SL, $L = Ei, IL = ML, AL = Object.prototype, LL = AL.hasOwnProperty;
function OL(e) {
  if (!$L(e))
    return IL(e);
  var t = [];
  for (var n in Object(e))
    LL.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var bh = OL, NL = typeof dr == "object" && dr && dr.Object === Object && dr, yh = NL, HL = yh, PL = typeof self == "object" && self && self.Object === Object && self, DL = HL || PL || Function("return this")(), At = DL, RL = At, VL = RL.Symbol, Si = VL, wd = Si, Ch = Object.prototype, BL = Ch.hasOwnProperty, FL = Ch.toString, Io = wd ? wd.toStringTag : void 0;
function jL(e) {
  var t = BL.call(e, Io), n = e[Io];
  try {
    e[Io] = void 0;
    var o = !0;
  } catch (r) {
  }
  var i = FL.call(e);
  return o && (t ? e[Io] = n : delete e[Io]), i;
}
var UL = jL, KL = Object.prototype, GL = KL.toString;
function zL(e) {
  return GL.call(e);
}
var ZL = zL, Td = Si, WL = UL, qL = ZL, YL = "[object Null]", xL = "[object Undefined]", kd = Td ? Td.toStringTag : void 0;
function XL(e) {
  return e == null ? e === void 0 ? xL : YL : kd && kd in Object(e) ? WL(e) : qL(e);
}
var or = XL;
function QL(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var rr = QL, JL = or, eO = rr, tO = "[object AsyncFunction]", nO = "[object Function]", oO = "[object GeneratorFunction]", rO = "[object Proxy]";
function iO(e) {
  if (!eO(e))
    return !1;
  var t = JL(e);
  return t == nO || t == oO || t == tO || t == rO;
}
var _h = iO, sO = At, aO = sO["__core-js_shared__"], lO = aO, Cs = lO, Ed = function() {
  var e = /[^.]+$/.exec(Cs && Cs.keys && Cs.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function dO(e) {
  return !!Ed && Ed in e;
}
var uO = dO, cO = Function.prototype, hO = cO.toString;
function mO(e) {
  if (e != null) {
    try {
      return hO.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var wh = mO, pO = _h, fO = uO, gO = rr, vO = wh, bO = /[\\^$.*+?()[\]{}|]/g, yO = /^\[object .+?Constructor\]$/, CO = Function.prototype, _O = Object.prototype, wO = CO.toString, TO = _O.hasOwnProperty, kO = RegExp(
  "^" + wO.call(TO).replace(bO, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function EO(e) {
  if (!gO(e) || fO(e))
    return !1;
  var t = pO(e) ? kO : yO;
  return t.test(vO(e));
}
var SO = EO;
function MO(e, t) {
  return e == null ? void 0 : e[t];
}
var $O = MO, IO = SO, AO = $O;
function LO(e, t) {
  var n = AO(e, t);
  return IO(n) ? n : void 0;
}
var Nn = LO, OO = Nn, NO = At, HO = OO(NO, "DataView"), PO = HO, DO = Nn, RO = At, VO = DO(RO, "Map"), $a = VO, BO = Nn, FO = At, jO = BO(FO, "Promise"), UO = jO, KO = Nn, GO = At, zO = KO(GO, "Set"), ZO = zO, WO = Nn, qO = At, YO = WO(qO, "WeakMap"), xO = YO, Ks = PO, Gs = $a, zs = UO, Zs = ZO, Ws = xO, Th = or, uo = wh, Sd = "[object Map]", XO = "[object Object]", Md = "[object Promise]", $d = "[object Set]", Id = "[object WeakMap]", Ad = "[object DataView]", QO = uo(Ks), JO = uo(Gs), eN = uo(zs), tN = uo(Zs), nN = uo(Ws), vn = Th;
(Ks && vn(new Ks(new ArrayBuffer(1))) != Ad || Gs && vn(new Gs()) != Sd || zs && vn(zs.resolve()) != Md || Zs && vn(new Zs()) != $d || Ws && vn(new Ws()) != Id) && (vn = function(e) {
  var t = Th(e), n = t == XO ? e.constructor : void 0, o = n ? uo(n) : "";
  if (o)
    switch (o) {
      case QO:
        return Ad;
      case JO:
        return Sd;
      case eN:
        return Md;
      case tN:
        return $d;
      case nN:
        return Id;
    }
  return t;
});
var Mi = vn;
function oN(e) {
  return e != null && typeof e == "object";
}
var co = oN, rN = or, iN = co, sN = "[object Arguments]";
function aN(e) {
  return iN(e) && rN(e) == sN;
}
var lN = aN, Ld = lN, dN = co, kh = Object.prototype, uN = kh.hasOwnProperty, cN = kh.propertyIsEnumerable, hN = Ld(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ld : function(e) {
  return dN(e) && uN.call(e, "callee") && !cN.call(e, "callee");
}, Eh = hN, mN = Array.isArray, Hn = mN, pN = 9007199254740991;
function fN(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= pN;
}
var Sh = fN, gN = _h, vN = Sh;
function bN(e) {
  return e != null && vN(e.length) && !gN(e);
}
var Ia = bN, Xr = { exports: {} };
function yN() {
  return !1;
}
var CN = yN;
Xr.exports;
(function(e, t) {
  var n = At, o = CN, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, a = r && r.exports === i, s = a ? n.Buffer : void 0, u = s ? s.isBuffer : void 0, c = u || o;
  e.exports = c;
})(Xr, Xr.exports);
var Aa = Xr.exports, _N = or, wN = Sh, TN = co, kN = "[object Arguments]", EN = "[object Array]", SN = "[object Boolean]", MN = "[object Date]", $N = "[object Error]", IN = "[object Function]", AN = "[object Map]", LN = "[object Number]", ON = "[object Object]", NN = "[object RegExp]", HN = "[object Set]", PN = "[object String]", DN = "[object WeakMap]", RN = "[object ArrayBuffer]", VN = "[object DataView]", BN = "[object Float32Array]", FN = "[object Float64Array]", jN = "[object Int8Array]", UN = "[object Int16Array]", KN = "[object Int32Array]", GN = "[object Uint8Array]", zN = "[object Uint8ClampedArray]", ZN = "[object Uint16Array]", WN = "[object Uint32Array]", Le = {};
Le[BN] = Le[FN] = Le[jN] = Le[UN] = Le[KN] = Le[GN] = Le[zN] = Le[ZN] = Le[WN] = !0;
Le[kN] = Le[EN] = Le[RN] = Le[SN] = Le[VN] = Le[MN] = Le[$N] = Le[IN] = Le[AN] = Le[LN] = Le[ON] = Le[NN] = Le[HN] = Le[PN] = Le[DN] = !1;
function qN(e) {
  return TN(e) && wN(e.length) && !!Le[_N(e)];
}
var YN = qN;
function xN(e) {
  return function(t) {
    return e(t);
  };
}
var La = xN, Qr = { exports: {} };
Qr.exports;
(function(e, t) {
  var n = yh, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r && n.process, s = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || a && a.binding && a.binding("util");
    } catch (c) {
    }
  }();
  e.exports = s;
})(Qr, Qr.exports);
var Oa = Qr.exports, XN = YN, QN = La, Od = Oa, Nd = Od && Od.isTypedArray, JN = Nd ? QN(Nd) : XN, Mh = JN, eH = bh, tH = Mi, nH = Eh, oH = Hn, rH = Ia, iH = Aa, sH = Ei, aH = Mh, lH = "[object Map]", dH = "[object Set]", uH = Object.prototype, cH = uH.hasOwnProperty;
function hH(e) {
  if (e == null)
    return !0;
  if (rH(e) && (oH(e) || typeof e == "string" || typeof e.splice == "function" || iH(e) || aH(e) || nH(e)))
    return !e.length;
  var t = tH(e);
  if (t == lH || t == dH)
    return !e.size;
  if (sH(e))
    return !eH(e).length;
  for (var n in e)
    if (cH.call(e, n))
      return !1;
  return !0;
}
var mH = hH;
const pH = /* @__PURE__ */ so(mH);
function fH() {
  this.__data__ = [], this.size = 0;
}
var gH = fH;
function vH(e, t) {
  return e === t || e !== e && t !== t;
}
var $h = vH, bH = $h;
function yH(e, t) {
  for (var n = e.length; n--; )
    if (bH(e[n][0], t))
      return n;
  return -1;
}
var $i = yH, CH = $i, _H = Array.prototype, wH = _H.splice;
function TH(e) {
  var t = this.__data__, n = CH(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : wH.call(t, n, 1), --this.size, !0;
}
var kH = TH, EH = $i;
function SH(e) {
  var t = this.__data__, n = EH(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var MH = SH, $H = $i;
function IH(e) {
  return $H(this.__data__, e) > -1;
}
var AH = IH, LH = $i;
function OH(e, t) {
  var n = this.__data__, o = LH(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var NH = OH, HH = gH, PH = kH, DH = MH, RH = AH, VH = NH;
function ho(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
ho.prototype.clear = HH;
ho.prototype.delete = PH;
ho.prototype.get = DH;
ho.prototype.has = RH;
ho.prototype.set = VH;
var Ii = ho, BH = Ii;
function FH() {
  this.__data__ = new BH(), this.size = 0;
}
var jH = FH;
function UH(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var KH = UH;
function GH(e) {
  return this.__data__.get(e);
}
var zH = GH;
function ZH(e) {
  return this.__data__.has(e);
}
var WH = ZH, qH = Nn, YH = qH(Object, "create"), Ai = YH, Hd = Ai;
function xH() {
  this.__data__ = Hd ? Hd(null) : {}, this.size = 0;
}
var XH = xH;
function QH(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var JH = QH, eP = Ai, tP = "__lodash_hash_undefined__", nP = Object.prototype, oP = nP.hasOwnProperty;
function rP(e) {
  var t = this.__data__;
  if (eP) {
    var n = t[e];
    return n === tP ? void 0 : n;
  }
  return oP.call(t, e) ? t[e] : void 0;
}
var iP = rP, sP = Ai, aP = Object.prototype, lP = aP.hasOwnProperty;
function dP(e) {
  var t = this.__data__;
  return sP ? t[e] !== void 0 : lP.call(t, e);
}
var uP = dP, cP = Ai, hP = "__lodash_hash_undefined__";
function mP(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = cP && t === void 0 ? hP : t, this;
}
var pP = mP, fP = XH, gP = JH, vP = iP, bP = uP, yP = pP;
function mo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
mo.prototype.clear = fP;
mo.prototype.delete = gP;
mo.prototype.get = vP;
mo.prototype.has = bP;
mo.prototype.set = yP;
var CP = mo, Pd = CP, _P = Ii, wP = $a;
function TP() {
  this.size = 0, this.__data__ = {
    hash: new Pd(),
    map: new (wP || _P)(),
    string: new Pd()
  };
}
var kP = TP;
function EP(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var SP = EP, MP = SP;
function $P(e, t) {
  var n = e.__data__;
  return MP(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Li = $P, IP = Li;
function AP(e) {
  var t = IP(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var LP = AP, OP = Li;
function NP(e) {
  return OP(this, e).get(e);
}
var HP = NP, PP = Li;
function DP(e) {
  return PP(this, e).has(e);
}
var RP = DP, VP = Li;
function BP(e, t) {
  var n = VP(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var FP = BP, jP = kP, UP = LP, KP = HP, GP = RP, zP = FP;
function po(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
po.prototype.clear = jP;
po.prototype.delete = UP;
po.prototype.get = KP;
po.prototype.has = GP;
po.prototype.set = zP;
var Ih = po, ZP = Ii, WP = $a, qP = Ih, YP = 200;
function xP(e, t) {
  var n = this.__data__;
  if (n instanceof ZP) {
    var o = n.__data__;
    if (!WP || o.length < YP - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new qP(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var XP = xP, QP = Ii, JP = jH, eD = KH, tD = zH, nD = WH, oD = XP;
function fo(e) {
  var t = this.__data__ = new QP(e);
  this.size = t.size;
}
fo.prototype.clear = JP;
fo.prototype.delete = eD;
fo.prototype.get = tD;
fo.prototype.has = nD;
fo.prototype.set = oD;
var rD = fo;
function iD(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var sD = iD, aD = Nn, lD = function() {
  try {
    var e = aD(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), dD = lD, Dd = dD;
function uD(e, t, n) {
  t == "__proto__" && Dd ? Dd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Ah = uD, cD = Ah, hD = $h, mD = Object.prototype, pD = mD.hasOwnProperty;
function fD(e, t, n) {
  var o = e[t];
  (!(pD.call(e, t) && hD(o, n)) || n === void 0 && !(t in e)) && cD(e, t, n);
}
var Lh = fD, gD = Lh, vD = Ah;
function bD(e, t, n, o) {
  var i = !n;
  n || (n = {});
  for (var r = -1, a = t.length; ++r < a; ) {
    var s = t[r], u = o ? o(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), i ? vD(n, s, u) : gD(n, s, u);
  }
  return n;
}
var Oi = bD;
function yD(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var CD = yD, _D = 9007199254740991, wD = /^(?:0|[1-9]\d*)$/;
function TD(e, t) {
  var n = typeof e;
  return t = t == null ? _D : t, !!t && (n == "number" || n != "symbol" && wD.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var kD = TD, ED = CD, SD = Eh, MD = Hn, $D = Aa, ID = kD, AD = Mh, LD = Object.prototype, OD = LD.hasOwnProperty;
function ND(e, t) {
  var n = MD(e), o = !n && SD(e), i = !n && !o && $D(e), r = !n && !o && !i && AD(e), a = n || o || i || r, s = a ? ED(e.length, String) : [], u = s.length;
  for (var c in e)
    (t || OD.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    ID(c, u))) && s.push(c);
  return s;
}
var Oh = ND, HD = Oh, PD = bh, DD = Ia;
function RD(e) {
  return DD(e) ? HD(e) : PD(e);
}
var Na = RD, VD = Oi, BD = Na;
function FD(e, t) {
  return e && VD(t, BD(t), e);
}
var jD = FD;
function UD(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var KD = UD, GD = rr, zD = Ei, ZD = KD, WD = Object.prototype, qD = WD.hasOwnProperty;
function YD(e) {
  if (!GD(e))
    return ZD(e);
  var t = zD(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !qD.call(e, o)) || n.push(o);
  return n;
}
var xD = YD, XD = Oh, QD = xD, JD = Ia;
function eR(e) {
  return JD(e) ? XD(e, !0) : QD(e);
}
var Ha = eR, tR = Oi, nR = Ha;
function oR(e, t) {
  return e && tR(t, nR(t), e);
}
var rR = oR, Jr = { exports: {} };
Jr.exports;
(function(e, t) {
  var n = At, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function u(c, y) {
    if (y)
      return c.slice();
    var w = c.length, v = s ? s(w) : new c.constructor(w);
    return c.copy(v), v;
  }
  e.exports = u;
})(Jr, Jr.exports);
var iR = Jr.exports;
function sR(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var aR = sR;
function lR(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = 0, r = []; ++n < o; ) {
    var a = e[n];
    t(a, n, e) && (r[i++] = a);
  }
  return r;
}
var dR = lR;
function uR() {
  return [];
}
var Nh = uR, cR = dR, hR = Nh, mR = Object.prototype, pR = mR.propertyIsEnumerable, Rd = Object.getOwnPropertySymbols, fR = Rd ? function(e) {
  return e == null ? [] : (e = Object(e), cR(Rd(e), function(t) {
    return pR.call(e, t);
  }));
} : hR, Pa = fR, gR = Oi, vR = Pa;
function bR(e, t) {
  return gR(e, vR(e), t);
}
var yR = bR;
function CR(e, t) {
  for (var n = -1, o = t.length, i = e.length; ++n < o; )
    e[i + n] = t[n];
  return e;
}
var Hh = CR, _R = vh, wR = _R(Object.getPrototypeOf, Object), Ph = wR, TR = Hh, kR = Ph, ER = Pa, SR = Nh, MR = Object.getOwnPropertySymbols, $R = MR ? function(e) {
  for (var t = []; e; )
    TR(t, ER(e)), e = kR(e);
  return t;
} : SR, Dh = $R, IR = Oi, AR = Dh;
function LR(e, t) {
  return IR(e, AR(e), t);
}
var OR = LR, NR = Hh, HR = Hn;
function PR(e, t, n) {
  var o = t(e);
  return HR(e) ? o : NR(o, n(e));
}
var Rh = PR, DR = Rh, RR = Pa, VR = Na;
function BR(e) {
  return DR(e, VR, RR);
}
var FR = BR, jR = Rh, UR = Dh, KR = Ha;
function GR(e) {
  return jR(e, KR, UR);
}
var zR = GR, ZR = Object.prototype, WR = ZR.hasOwnProperty;
function qR(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && WR.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var YR = qR, xR = At, XR = xR.Uint8Array, QR = XR, Vd = QR;
function JR(e) {
  var t = new e.constructor(e.byteLength);
  return new Vd(t).set(new Vd(e)), t;
}
var Da = JR, eV = Da;
function tV(e, t) {
  var n = t ? eV(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var nV = tV, oV = /\w*$/;
function rV(e) {
  var t = new e.constructor(e.source, oV.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var iV = rV, Bd = Si, Fd = Bd ? Bd.prototype : void 0, jd = Fd ? Fd.valueOf : void 0;
function sV(e) {
  return jd ? Object(jd.call(e)) : {};
}
var aV = sV, lV = Da;
function dV(e, t) {
  var n = t ? lV(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var uV = dV, cV = Da, hV = nV, mV = iV, pV = aV, fV = uV, gV = "[object Boolean]", vV = "[object Date]", bV = "[object Map]", yV = "[object Number]", CV = "[object RegExp]", _V = "[object Set]", wV = "[object String]", TV = "[object Symbol]", kV = "[object ArrayBuffer]", EV = "[object DataView]", SV = "[object Float32Array]", MV = "[object Float64Array]", $V = "[object Int8Array]", IV = "[object Int16Array]", AV = "[object Int32Array]", LV = "[object Uint8Array]", OV = "[object Uint8ClampedArray]", NV = "[object Uint16Array]", HV = "[object Uint32Array]";
function PV(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case kV:
      return cV(e);
    case gV:
    case vV:
      return new o(+e);
    case EV:
      return hV(e, n);
    case SV:
    case MV:
    case $V:
    case IV:
    case AV:
    case LV:
    case OV:
    case NV:
    case HV:
      return fV(e, n);
    case bV:
      return new o();
    case yV:
    case wV:
      return new o(e);
    case CV:
      return mV(e);
    case _V:
      return new o();
    case TV:
      return pV(e);
  }
}
var DV = PV, RV = rr, Ud = Object.create, VV = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!RV(t))
      return {};
    if (Ud)
      return Ud(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), BV = VV, FV = BV, jV = Ph, UV = Ei;
function KV(e) {
  return typeof e.constructor == "function" && !UV(e) ? FV(jV(e)) : {};
}
var GV = KV, zV = Mi, ZV = co, WV = "[object Map]";
function qV(e) {
  return ZV(e) && zV(e) == WV;
}
var YV = qV, xV = YV, XV = La, Kd = Oa, Gd = Kd && Kd.isMap, QV = Gd ? XV(Gd) : xV, JV = QV, eB = Mi, tB = co, nB = "[object Set]";
function oB(e) {
  return tB(e) && eB(e) == nB;
}
var rB = oB, iB = rB, sB = La, zd = Oa, Zd = zd && zd.isSet, aB = Zd ? sB(Zd) : iB, lB = aB, dB = rD, uB = sD, cB = Lh, hB = jD, mB = rR, pB = iR, fB = aR, gB = yR, vB = OR, bB = FR, yB = zR, CB = Mi, _B = YR, wB = DV, TB = GV, kB = Hn, EB = Aa, SB = JV, MB = rr, $B = lB, IB = Na, AB = Ha, LB = 1, OB = 2, NB = 4, Vh = "[object Arguments]", HB = "[object Array]", PB = "[object Boolean]", DB = "[object Date]", RB = "[object Error]", Bh = "[object Function]", VB = "[object GeneratorFunction]", BB = "[object Map]", FB = "[object Number]", Fh = "[object Object]", jB = "[object RegExp]", UB = "[object Set]", KB = "[object String]", GB = "[object Symbol]", zB = "[object WeakMap]", ZB = "[object ArrayBuffer]", WB = "[object DataView]", qB = "[object Float32Array]", YB = "[object Float64Array]", xB = "[object Int8Array]", XB = "[object Int16Array]", QB = "[object Int32Array]", JB = "[object Uint8Array]", eF = "[object Uint8ClampedArray]", tF = "[object Uint16Array]", nF = "[object Uint32Array]", ke = {};
ke[Vh] = ke[HB] = ke[ZB] = ke[WB] = ke[PB] = ke[DB] = ke[qB] = ke[YB] = ke[xB] = ke[XB] = ke[QB] = ke[BB] = ke[FB] = ke[Fh] = ke[jB] = ke[UB] = ke[KB] = ke[GB] = ke[JB] = ke[eF] = ke[tF] = ke[nF] = !0;
ke[RB] = ke[Bh] = ke[zB] = !1;
function Nr(e, t, n, o, i, r) {
  var a, s = t & LB, u = t & OB, c = t & NB;
  if (n && (a = i ? n(e, o, i, r) : n(e)), a !== void 0)
    return a;
  if (!MB(e))
    return e;
  var y = kB(e);
  if (y) {
    if (a = _B(e), !s)
      return fB(e, a);
  } else {
    var w = CB(e), v = w == Bh || w == VB;
    if (EB(e))
      return pB(e, s);
    if (w == Fh || w == Vh || v && !i) {
      if (a = u || v ? {} : TB(e), !s)
        return u ? vB(e, mB(a, e)) : gB(e, hB(a, e));
    } else {
      if (!ke[w])
        return i ? e : {};
      a = wB(e, w, s);
    }
  }
  r || (r = new dB());
  var E = r.get(e);
  if (E)
    return E;
  r.set(e, a), $B(e) ? e.forEach(function(L) {
    a.add(Nr(L, t, n, L, e, r));
  }) : SB(e) && e.forEach(function(L, U) {
    a.set(U, Nr(L, t, n, U, e, r));
  });
  var F = c ? u ? yB : bB : u ? AB : IB, O = y ? void 0 : F(e);
  return uB(O || e, function(L, U) {
    O && (U = L, L = e[U]), cB(a, U, Nr(L, t, n, U, e, r));
  }), a;
}
var oF = Nr, rF = oF, iF = 1, sF = 4;
function aF(e) {
  return rF(e, iF | sF);
}
var lF = aF;
const jh = /* @__PURE__ */ so(lF), dF = {
  news: {
    cover_image: [
      {
        url: "cover_image",
        alt_text: "image_description",
        image_focal_point_x: "image_focal_point_x",
        image_focal_point_y: "image_focal_point_y"
      }
    ],
    title: "title",
    snippet: "snippet",
    author: "author",
    time_ago: "time_ago",
    date: ["published_at"],
    time: ["published_at"]
  },
  events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  all_events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  live_feed: {
    status: "status",
    author: "author",
    avatar: "avatar",
    time_ago: "time_ago",
    date: ["time"],
    live_feed_images: "live_feed_images",
    time: ["time"]
  },
  athletics: {
    title: "title",
    home_team: "home_team",
    home_score: "home_score",
    away_team: "away_team",
    away_score: "away_score",
    date: ["formatted_date"],
    time: ["formatted_date"],
    address: "address",
    versus: "versus",
    filter_name: "filter_name"
  },
  dining: {
    breakfast: "breakfast",
    lunch: "lunch"
  }
}, qs = (e, t, n) => {
  const o = Object.entries(t).reduce((i, [r, a]) => (a instanceof Array ? i[r] = Object.values(qs(e, a)) : a instanceof Object ? i[r] = qs(e, a) : a in e && (i[r] = e[a]), i), {});
  return n && ["events", "all_events", "news", "live_feed"].includes(n.DATA_TYPE) ? ca(Vt({}, o), { entry_url: cF(e, n) }) : o;
}, uF = (e, t) => {
  if (!e) throw new Error("No data source found.");
  const n = dF[[t.DATA_TYPE]];
  return e.map((o) => qs(o, n, t));
}, cF = (e, t) => {
  const n = {
    all_events: "events",
    news: "article",
    live_feed: "live-feed"
  }[t.DATA_TYPE] || t.DATA_TYPE, o = `${t.PATH_PREFIX}/${n}`;
  switch (n) {
    case "events":
      return `${o}?id=${e.id}`;
    case "article":
      return `${o}/${e.id}`;
    case "live-feed":
      return `${o}#${e.id}`;
    default:
      return o;
  }
}, hF = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, mF = (e, t, n) => {
  let o;
  const i = hF[e];
  return typeof i == "string" ? o = i : t === 1 ? o = i.one : o = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function _s(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const pF = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, fF = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, gF = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vF = {
  date: _s({
    formats: pF,
    defaultWidth: "full"
  }),
  time: _s({
    formats: fF,
    defaultWidth: "full"
  }),
  dateTime: _s({
    formats: gF,
    defaultWidth: "full"
  })
}, bF = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yF = (e, t, n, o) => bF[e];
function Ao(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (o === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const r = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[r];
  };
}
const CF = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, _F = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, wF = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, TF = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, kF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, EF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, SF = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, MF = {
  ordinalNumber: SF,
  era: Ao({
    values: CF,
    defaultWidth: "wide"
  }),
  quarter: Ao({
    values: _F,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ao({
    values: wF,
    defaultWidth: "wide"
  }),
  day: Ao({
    values: TF,
    defaultWidth: "wide"
  }),
  dayPeriod: Ao({
    values: kF,
    defaultWidth: "wide",
    formattingValues: EF,
    defaultFormattingWidth: "wide"
  })
};
function Lo(e) {
  return (t, n = {}) => {
    const o = n.width, i = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], r = t.match(i);
    if (!r)
      return null;
    const a = r[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? IF(s, (w) => w.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      $F(s, (w) => w.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(u) : u, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const y = t.slice(a.length);
    return { value: c, rest: y };
  };
}
function $F(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function IF(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function AF(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const i = o[0], r = t.match(e.parsePattern);
    if (!r) return null;
    let a = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const LF = /^(\d+)(th|st|nd|rd)?/i, OF = /\d+/i, NF = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, HF = {
  any: [/^b/i, /^(a|c)/i]
}, PF = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, DF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, RF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, VF = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, BF = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, FF = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, jF = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, UF = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, KF = {
  ordinalNumber: AF({
    matchPattern: LF,
    parsePattern: OF,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Lo({
    matchPatterns: NF,
    defaultMatchWidth: "wide",
    parsePatterns: HF,
    defaultParseWidth: "any"
  }),
  quarter: Lo({
    matchPatterns: PF,
    defaultMatchWidth: "wide",
    parsePatterns: DF,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Lo({
    matchPatterns: RF,
    defaultMatchWidth: "wide",
    parsePatterns: VF,
    defaultParseWidth: "any"
  }),
  day: Lo({
    matchPatterns: BF,
    defaultMatchWidth: "wide",
    parsePatterns: FF,
    defaultParseWidth: "any"
  }),
  dayPeriod: Lo({
    matchPatterns: jF,
    defaultMatchWidth: "any",
    parsePatterns: UF,
    defaultParseWidth: "any"
  })
}, GF = {
  code: "en-US",
  formatDistance: mF,
  formatLong: vF,
  formatRelative: yF,
  localize: MF,
  match: KF,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let zF = {};
function Ni() {
  return zF;
}
const Uh = 6048e5, ZF = 864e5, Kh = 6e4, Gh = 36e5;
function Tt(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Wd(e) {
  const t = Tt(e);
  return t.setHours(0, 0, 0, 0), t;
}
function qd(e) {
  const t = Tt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function WF(e, t) {
  const n = Wd(e), o = Wd(t), i = +n - qd(n), r = +o - qd(o);
  return Math.round((i - r) / ZF);
}
function Tn(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function qF(e) {
  const t = Tt(e), n = Tn(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function YF(e) {
  const t = Tt(e);
  return WF(t, qF(t)) + 1;
}
function Wo(e, t) {
  var n, o, i, r, a, s, u, c;
  const y = Ni(), w = (c = (u = (r = (i = t == null ? void 0 : t.weekStartsOn) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.weekStartsOn) != null ? r : y.weekStartsOn) != null ? u : (s = (a = y.locale) == null ? void 0 : a.options) == null ? void 0 : s.weekStartsOn) != null ? c : 0, v = Tt(e), E = v.getDay(), F = (E < w ? 7 : 0) + E - w;
  return v.setDate(v.getDate() - F), v.setHours(0, 0, 0, 0), v;
}
function ei(e) {
  return Wo(e, { weekStartsOn: 1 });
}
function zh(e) {
  const t = Tt(e), n = t.getFullYear(), o = Tn(e, 0);
  o.setFullYear(n + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = ei(o), r = Tn(e, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const a = ei(r);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function xF(e) {
  const t = zh(e), n = Tn(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ei(n);
}
function XF(e) {
  const t = Tt(e), n = +ei(t) - +xF(t);
  return Math.round(n / Uh) + 1;
}
function Zh(e, t) {
  var n, o, i, r, a, s, u, c;
  const y = Tt(e), w = y.getFullYear(), v = Ni(), E = (c = (u = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.firstWeekContainsDate) != null ? r : v.firstWeekContainsDate) != null ? u : (s = (a = v.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? c : 1, F = Tn(e, 0);
  F.setFullYear(w + 1, 0, E), F.setHours(0, 0, 0, 0);
  const O = Wo(F, t), L = Tn(e, 0);
  L.setFullYear(w, 0, E), L.setHours(0, 0, 0, 0);
  const U = Wo(L, t);
  return y.getTime() >= O.getTime() ? w + 1 : y.getTime() >= U.getTime() ? w : w - 1;
}
function QF(e, t) {
  var n, o, i, r, a, s, u, c;
  const y = Ni(), w = (c = (u = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.firstWeekContainsDate) != null ? r : y.firstWeekContainsDate) != null ? u : (s = (a = y.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? c : 1, v = Zh(e, t), E = Tn(e, 0);
  return E.setFullYear(v, 0, w), E.setHours(0, 0, 0, 0), Wo(E, t);
}
function JF(e, t) {
  const n = Tt(e), o = +Wo(n, t) - +QF(n, t);
  return Math.round(o / Uh) + 1;
}
function be(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const xt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return be(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : be(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return be(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return be(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return be(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return be(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return be(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), i = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return be(i, t.length);
  }
}, Fn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Yd = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), i = o > 0 ? o : 1 - o;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return xt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const i = Zh(e, o), r = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = r % 100;
      return be(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : be(r, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = zh(e);
    return be(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return be(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(o);
      case "QQ":
        return be(o, 2);
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(o);
      case "qq":
        return be(o, 2);
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return xt.M(e, t);
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "L":
        return String(o + 1);
      case "LL":
        return be(o + 1, 2);
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const i = JF(e, o);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : be(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = XF(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : be(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : xt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = YF(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : be(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const i = e.getDay(), r = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(r);
      case "ee":
        return be(r, 2);
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const i = e.getDay(), r = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(r);
      case "cc":
        return be(r, t.length);
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), i = o === 0 ? 7 : o;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return be(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let i;
    switch (o === 12 ? i = Fn.noon : o === 0 ? i = Fn.midnight : i = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let i;
    switch (o >= 17 ? i = Fn.evening : o >= 12 ? i = Fn.afternoon : o >= 4 ? i = Fn.morning : i = Fn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return xt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : xt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : be(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : be(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : xt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : xt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return xt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return Xd(o);
      case "XXXX":
      case "XX":
        return bn(o);
      case "XXXXX":
      case "XXX":
      default:
        return bn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Xd(o);
      case "xxxx":
      case "xx":
        return bn(o);
      case "xxxxx":
      case "xxx":
      default:
        return bn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xd(o, ":");
      case "OOOO":
      default:
        return "GMT" + bn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + xd(o, ":");
      case "zzzz":
      default:
        return "GMT" + bn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(e.getTime() / 1e3);
    return be(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const o = e.getTime();
    return be(o, t.length);
  }
};
function xd(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), i = Math.trunc(o / 60), r = o % 60;
  return r === 0 ? n + String(i) : n + String(i) + t + be(r, 2);
}
function Xd(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + be(Math.abs(e) / 60, 2) : bn(e, t);
}
function bn(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), i = be(Math.trunc(o / 60), 2), r = be(o % 60, 2);
  return n + i + t + r;
}
const Qd = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Wh = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ej = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], i = n[2];
  if (!i)
    return Qd(e, t);
  let r;
  switch (o) {
    case "P":
      r = t.dateTime({ width: "short" });
      break;
    case "PP":
      r = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = t.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", Qd(o, t)).replace("{{time}}", Wh(i, t));
}, tj = {
  p: Wh,
  P: ej
}, nj = /^D+$/, oj = /^Y+$/, rj = ["D", "DD", "YY", "YYYY"];
function ij(e) {
  return nj.test(e);
}
function sj(e) {
  return oj.test(e);
}
function aj(e, t, n) {
  const o = lj(e, t, n);
  if (console.warn(o), rj.includes(e)) throw new RangeError(o);
}
function lj(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function dj(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function uj(e) {
  if (!dj(e) && typeof e != "number")
    return !1;
  const t = Tt(e);
  return !isNaN(Number(t));
}
const cj = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hj = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, mj = /^'([^]*?)'?$/, pj = /''/g, fj = /[a-zA-Z]/;
function gj(e, t, n) {
  var o, i, r, a, s, u, c, y, w;
  const v = Ni(), E = (o = v.locale) != null ? o : GF, F = (s = (a = v.firstWeekContainsDate) != null ? a : (r = (i = v.locale) == null ? void 0 : i.options) == null ? void 0 : r.firstWeekContainsDate) != null ? s : 1, O = (w = (y = v.weekStartsOn) != null ? y : (c = (u = v.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) != null ? w : 0, L = Tt(e);
  if (!uj(L))
    throw new RangeError("Invalid time value");
  let U = t.match(hj).map((B) => {
    const j = B[0];
    if (j === "p" || j === "P") {
      const Y = tj[j];
      return Y(B, E.formatLong);
    }
    return B;
  }).join("").match(cj).map((B) => {
    if (B === "''")
      return { isToken: !1, value: "'" };
    const j = B[0];
    if (j === "'")
      return { isToken: !1, value: vj(B) };
    if (Yd[j])
      return { isToken: !0, value: B };
    if (j.match(fj))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + j + "`"
      );
    return { isToken: !1, value: B };
  });
  E.localize.preprocessor && (U = E.localize.preprocessor(L, U));
  const z = {
    firstWeekContainsDate: F,
    weekStartsOn: O,
    locale: E
  };
  return U.map((B) => {
    if (!B.isToken) return B.value;
    const j = B.value;
    (sj(j) || ij(j)) && aj(j, t, String(e));
    const Y = Yd[j[0]];
    return Y(L, j, E.localize, z);
  }).join("");
}
function vj(e) {
  const t = e.match(mj);
  return t ? t[1].replace(pj, "'") : e;
}
function bj(e, t) {
  const n = wj(e);
  let o;
  if (n.date) {
    const s = Tj(n.date, 2);
    o = kj(s.restDateString, s.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = o.getTime();
  let r = 0, a;
  if (n.time && (r = Ej(n.time), isNaN(r)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (a = Sj(n.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const s = new Date(i + r), u = /* @__PURE__ */ new Date(0);
    return u.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), u.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), u;
  }
  return new Date(i + r + a);
}
const Mr = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, yj = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Cj = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, _j = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function wj(e) {
  const t = {}, n = e.split(Mr.dateTimeDelimiter);
  let o;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? o = n[0] : (t.date = n[0], o = n[1], Mr.timeZoneDelimiter.test(t.date) && (t.date = e.split(Mr.timeZoneDelimiter)[0], o = e.substr(
    t.date.length,
    e.length
  ))), o) {
    const i = Mr.timezone.exec(o);
    i ? (t.time = o.replace(i[1], ""), t.timezone = i[1]) : t.time = o;
  }
  return t;
}
function Tj(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), o = e.match(n);
  if (!o) return { year: NaN, restDateString: "" };
  const i = o[1] ? parseInt(o[1]) : null, r = o[2] ? parseInt(o[2]) : null;
  return {
    year: r === null ? i : r * 100,
    restDateString: e.slice((o[1] || o[2]).length)
  };
}
function kj(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(yj);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const o = !!n[4], i = Oo(n[1]), r = Oo(n[2]) - 1, a = Oo(n[3]), s = Oo(n[4]), u = Oo(n[5]) - 1;
  if (o)
    return Lj(t, s, u) ? Mj(t, s, u) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !Ij(t, r, a) || !Aj(t, i) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, r, Math.max(i, a)), c);
  }
}
function Oo(e) {
  return e ? parseInt(e) : 1;
}
function Ej(e) {
  const t = e.match(Cj);
  if (!t) return NaN;
  const n = ws(t[1]), o = ws(t[2]), i = ws(t[3]);
  return Oj(n, o, i) ? n * Gh + o * Kh + i * 1e3 : NaN;
}
function ws(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Sj(e) {
  if (e === "Z") return 0;
  const t = e.match(_j);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, o = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return Nj(o, i) ? n * (o * Gh + i * Kh) : NaN;
}
function Mj(e, t, n) {
  const o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  const i = o.getUTCDay() || 7, r = (t - 1) * 7 + n + 1 - i;
  return o.setUTCDate(o.getUTCDate() + r), o;
}
const $j = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function qh(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Ij(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= ($j[t] || (qh(e) ? 29 : 28));
}
function Aj(e, t) {
  return t >= 1 && t <= (qh(e) ? 366 : 365);
}
function Lj(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function Oj(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function Nj(e, t) {
  return t >= 0 && t <= 59;
}
function bt(e, t) {
  const n = e.includes("T") ? e.substring(0, e.lastIndexOf(".")) : e, o = bj(n);
  return gj(o, t);
}
function Hj(e, t) {
  return t ? bt(e, "MMM/dd/yyyy") === bt(t, "MMM/dd/yyyy") : !0;
}
var Pj = or, Dj = co, Rj = "[object Symbol]";
function Vj(e) {
  return typeof e == "symbol" || Dj(e) && Pj(e) == Rj;
}
var Ra = Vj, Bj = Hn, Fj = Ra, jj = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Uj = /^\w*$/;
function Kj(e, t) {
  if (Bj(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Fj(e) ? !0 : Uj.test(e) || !jj.test(e) || t != null && e in Object(t);
}
var Gj = Kj, Yh = Ih, zj = "Expected a function";
function Va(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(zj);
  var n = function() {
    var o = arguments, i = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var a = e.apply(this, o);
    return n.cache = r.set(i, a) || r, a;
  };
  return n.cache = new (Va.Cache || Yh)(), n;
}
Va.Cache = Yh;
var Zj = Va, Wj = Zj, qj = 500;
function Yj(e) {
  var t = Wj(e, function(o) {
    return n.size === qj && n.clear(), o;
  }), n = t.cache;
  return t;
}
var xj = Yj, Xj = xj, Qj = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Jj = /\\(\\)?/g, eU = Xj(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Qj, function(n, o, i, r) {
    t.push(i ? r.replace(Jj, "$1") : o || n);
  }), t;
}), tU = eU;
function nU(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = Array(o); ++n < o; )
    i[n] = t(e[n], n, e);
  return i;
}
var oU = nU, Jd = Si, rU = oU, iU = Hn, sU = Ra, eu = Jd ? Jd.prototype : void 0, tu = eu ? eu.toString : void 0;
function xh(e) {
  if (typeof e == "string")
    return e;
  if (iU(e))
    return rU(e, xh) + "";
  if (sU(e))
    return tu ? tu.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var aU = xh, lU = aU;
function dU(e) {
  return e == null ? "" : lU(e);
}
var uU = dU, cU = Hn, hU = Gj, mU = tU, pU = uU;
function fU(e, t) {
  return cU(e) ? e : hU(e, t) ? [e] : mU(pU(e));
}
var gU = fU, vU = Ra;
function bU(e) {
  if (typeof e == "string" || vU(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var yU = bU, CU = gU, _U = yU;
function wU(e, t) {
  t = CU(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[_U(t[n++])];
  return n && n == o ? e : void 0;
}
var TU = wU, kU = TU;
function EU(e, t, n) {
  var o = e == null ? void 0 : kU(e, t);
  return o === void 0 ? n : o;
}
var SU = EU;
const Ys = /* @__PURE__ */ so(SU), MU = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value date not found" };
  const [o, i] = e.entries[t][n], r = Hj(o, i) ? "" : bt(i, "MMM/dd/yyyy"), a = bt(o, "MMM"), s = bt(o, "dd"), u = bt(o, "iiii"), c = Me("span.date", [
    Me("span.start-month", a),
    Me("span.start-date", s),
    Me("span.start-weekday", u)
  ]);
  if (r) {
    const y = bt(i, "MMM"), w = bt(i, "dd"), v = bt(i, "iiii");
    c.children = c.children.concat(
      Me("span.date-separator", "-"),
      Me("span.end-month", y),
      Me("span.end-date", w),
      Me("span.end-weekday", v)
    );
  }
  return c;
}, $U = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value time not found" };
  const [o, i, r] = e.entries[t][n];
  let a;
  const s = bt(o, "h:mmaaa");
  if (r)
    return Me("span.time", Me("span.start-time", "All day"));
  const u = Me("span.time", [Me("span.start-time", s)]);
  return i && (a = bt(i, "h:mmaaa"), u.children = u.children.concat(Me("span.time-separator", "-"), Me("span.end-time", a))), u;
}, nu = (e, t, n) => {
  let o = e.entries[t][n];
  return (o.length === 0 || !o[0].url) && (o = [{ url: Ys(e, "fallback_image.url", "") }]), Me(
    `div.${n.replace(/_/g, "-")}`,
    o.map(
      (i, r) => Me(`img.entry-${t}-img-${r}`, {
        src: i.url,
        alt: i.alt_text || "",
        style: i.image_focal_point_x && i.image_focal_point_y ? { "object-position": `${i.image_focal_point_x || 50}% ${i.image_focal_point_y || 50}%` } : void 0
      })
    )
  );
}, IU = (e, t, n) => {
  const o = e.split("|");
  for (let i = 0; i < o.length; i++) {
    const r = o[i], a = Ys(t.entries[n], r, Ys(t, r, void 0));
    if (a !== void 0) return a;
  }
};
function AU(e) {
  const t = {
    type: "element",
    tagName: "a",
    properties: {
      href: e.link_url,
      target: e.opens_in_new_tab,
      class: "automatic-schools-menu-image-a"
    }
  }, n = {
    type: "element",
    tagName: "img",
    properties: {
      src: e.url,
      class: "automatic-schools-menu-image-img",
      alt: e.alt_text,
      width: `${e.width}`,
      height: `${e.height}`
    }
  };
  return e.action_on_click === "no_action" ? n : (t.children = [n], t);
}
const xs = "default", Xh = "children", Ba = (e, t, n, o = {}, i) => e ? e.tagName === Xh ? NU(e, t, n, o, i) : OU(e, t, n, o, i) : null, LU = (e) => {
  const t = {
    [xs]: Me(null, [new Me("div", ["{{name|url}}", new Me(Xh)])])
  }, n = { templates: t, children: [] };
  return (e.children || []).forEach((o) => {
    var i, r;
    if (o.tagName === "template") {
      const a = Me(null, [...((i = o.content) == null ? void 0 : i.children) || []]), s = ((r = o.properties) == null ? void 0 : r.type) || xs;
      t[s] = a;
    } else
      n.children.push(o);
  }), n;
}, OU = (e, t, n, o, i) => (e.tagName && (e.properties.className = [
  ...Array.isArray(e.properties.className) ? e.properties.className : [],
  `${e.tagName}-${t.class || ""}`
]), Array.isArray(e.children) && (e.children = e.children.map((r) => Ba(r, t, n, o, i)).filter(Boolean)), e), NU = (e, t, n, o, i) => {
  if (!n || n.length === 0)
    return null;
  const { startRange: r, endRange: a } = PU(e.properties, n.length), { templates: s, children: u } = LU(e), c = Vt(Vt({}, o), s);
  e.children = u;
  const y = new Me(null, []);
  for (let w = r; w < a; w++) {
    const v = Vt(Vt({}, t), n[w]), E = jh(c[v.type] || c[xs]);
    if (!E) continue;
    HU(v, t.class), Ba(E, ca(Vt({}, t), { class: v.class }), v.children, c, i);
    const F = i(E, Vt(Vt({}, t), v));
    F && y.children.push(F);
  }
  return y;
}, HU = (e, t) => {
  if (Array.isArray(e.children)) {
    const n = `${t}-${(e.name || "").replace(/\W/g, "").toLowerCase()}`;
    e.children.forEach((o) => {
      o.class = n;
    });
  }
}, PU = (e, t) => {
  let n = 0, o = t;
  if (e != null && e.idx)
    n = Number(e.idx), o = n + 1;
  else if (e != null && e.loop) {
    const [i, r] = (e.loop.match(/\d+/g) || []).map(Number);
    n = i || 0, o = r || t;
  }
  return { startRange: n, endRange: o };
}, ou = "loop", Ts = (e) => parseInt(e, 10), Qh = (e) => e.substr(2, e.length - 4).trim(), DU = (e) => Ts(e) ? [0, Ts(e)] : e.replace(/[()]/g, "").split(", ").map(Ts), ru = {
  "cms-header-menu": (e, t) => {
    const n = t.menus[e.properties.entity].entries;
    return t.class = e.properties.entity, Ba(e, t, n, {}, Xn), Xn(e, t);
  },
  "cms-sign-in-button": (e, t) => {
    const { signInButtonText: n, showSignInButton: o, signInUrl: i } = t, r = o ? Me(
      "a",
      {
        href: i,
        className: ["sign-in"],
        target: "_blank",
        "aria-label": `${n} (opens ${i} in a new tab)`
      },
      n
    ) : Me(null);
    return Me(null, [r]);
  }
}, en = {
  DATA_TYPE: "",
  PATH_PREFIX: "",
  reservedTagParser: () => {
  },
  mappingFn: () => {
  }
}, RU = ["cms-media", "cms-header-menu", "cms-sign-in-button"], VU = (e) => {
  const t = {
    "&#x26;lt;": "<",
    "&#x3C;": "<",
    "&#x26;gt;": ">"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (o) => t[o]);
}, Jh = (e, t, n) => {
  const o = "{{", i = "}}", r = /{{([^{][\s\S]+?[^}])}}/g, a = e.toString().match(r);
  if (!a)
    return e;
  const s = a.map((u) => {
    const c = u.indexOf(o), y = u.lastIndexOf(i);
    if (c !== 0 && !c || !y || y < c)
      throw new Error(`Syntax error at ${u}`);
    const w = Qh(u), v = en.mappingFn(w, t, n);
    if (v == null)
      throw new Error(`Value ${w} not found`);
    return v;
  });
  return a.reduce((u, c, y) => u.replace(c, s[y]), e);
}, Xn = (e, t, n = -1) => {
  let o = jh(e);
  const i = (s) => s.type === "text", r = (s) => s.type === "element", a = (s) => s.children && s.children.length > 0;
  if (!a(e) && i(e)) {
    const s = iu(e, t, n);
    s.length === 1 ? r(s[0]) ? o = s[0] : o.value = s[0].value : s.length > 1 && (o = Me("span", s));
  }
  if (a(e)) {
    const s = (u) => u.tagName && RU.includes(u.tagName) && u.children;
    o.children = e.children.reduce((u, c) => {
      if (i(c))
        return [...u, ...iu(c, t, n)];
      if (s(c)) {
        if (typeof ru[c.tagName] == "function") {
          const y = ru[c.tagName](c, t);
          return [...u, ...y.children];
        }
        return en.reservedTagParser(u, c, n, t);
      }
      return [...u, Xn(c, t, n)];
    }, []);
  }
  return ((s) => !pH(s.properties))(e) && (o.properties = Object.fromEntries(
    Object.entries(e.properties).map(([s, u]) => [s, Jh(u, t, n)])
  )), o;
}, BU = (e, t, n, o) => {
  let i = n;
  if (t.properties.idx) {
    i = t.properties.idx;
    const r = t.children.map((a) => Xn(a, o, i));
    return [...e, ...r];
  }
  if (t.properties[ou]) {
    const [r, a] = DU(t.properties[ou]);
    let s = 0;
    a > 0 ? s = a > o.entries.length ? o.entries.length : a + r : s = o.entries.length;
    let u = [];
    for (let c = r; c < s; c++)
      u = u.concat(t.children.map((y) => Xn(y, o, c)));
    return [...e, ...u];
  }
}, e0 = (e, t, n) => {
  if (!t)
    throw new Error("Data type must be specified, eg. news, live_feed, athletics, events, or dining");
  if (!n)
    throw new Error("Data source is missing.");
  en.DATA_TYPE = t, en.PATH_PREFIX = n.path_prefix, en.reservedTagParser = BU, en.mappingFn = IU;
  const o = uF(n.entries, en), i = (u) => u == "all_events" ? "events" : u.replace(/_/g, "-"), r = `${en.PATH_PREFIX}/${i(t)}`, a = Vs().use(sh, { fragment: !0, emitParseErrors: !0, duplicateAttribute: !1 }).use(ch).parse(e), s = Xn(a, ca(Vt({}, n), { section_page_url: r, entries: o }));
  return VU(Vs().use(_L).stringify(s));
};
function iu(e, t, n) {
  const o = /({{[^{][\s\S]+?[^}]}})/g, i = e.value.trim().split(o).filter((a) => a != ""), r = {
    date: MU,
    time: $U,
    cover_image: nu,
    live_feed_images: nu,
    schoolMenuImage: AU,
    default: function(a, s, u) {
      return { type: "text", value: Jh(`{{${u}}}`, a, s) };
    }
  };
  return i.map((a) => {
    if (a.match(o)) {
      const s = Qh(a);
      return r[s] ? r[s](t, n, s) : r.default(t, n, s);
    } else
      return { type: "text", value: a };
  });
}
const FU = (e) => Vs().use(sh, { fragment: !0, emitParseErrors: !0 }).use(ch).parse(e), jU = {
  name: "CustomHtml",
  props: {
    theme: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      componentKey: 0
    };
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlCode() {
      return this.theme.html_code;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      if (!e)
        return;
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        if (!e || !this.$refs.container)
          return;
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    }
  }
}, UU = ["id"], KU = ["innerHTML"];
function GU(e, t, n, o, i, r) {
  return l(), h("div", {
    id: n.theme.container_id,
    ref: "container",
    class: "custom-html"
  }, [
    (l(), h("div", {
      ref: "html_code",
      key: i.componentKey,
      innerHTML: r.htmlCode
    }, null, 8, KU))
  ], 8, UU);
}
const Hi = /* @__PURE__ */ I(jU, [["render", GU], ["__scopeId", "data-v-20687f05"]]), zU = {
  name: "Custom",
  components: {
    CustomHtml: Hi
  },
  mixins: [Fe],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      var t, n, o, i;
      let e = "";
      try {
        const r = [], a = {
          schoolName: this.content.globals.info.school_name,
          schoolLogo: this.content.globals.logo.url || "",
          schoolTagline: this.content.globals.info.school_tag_line || "",
          schoolPath: this.content.pathPrefix || "/",
          langCode: this.content.langCode,
          langText: "",
          signInButtonText: this.signInText,
          showSignInButton: this.showSignInButton,
          signInUrl: this.signInUrl
        };
        this.content.languages.forEach((y) => {
          y.code === this.content.langCode && (a.langText = y.language), r.push(de(oe({}, y), { name: y.language }));
        });
        const s = this.formatItems(this.content.sitemapMenuItems), u = ((i = (o = (n = (t = this.content.globals) == null ? void 0 : t.homepage) == null ? void 0 : n.schools_menu) == null ? void 0 : o.menu) == null ? void 0 : i.flat()) || tc.menu.flat(), c = {
          siteMenu: {
            dataType: "siteMenu",
            entries: s
          },
          schoolsCustomMenu: {
            dataType: "schoolsCustomMenu",
            entries: this.formatItems(u)
          },
          schoolsMenu: {
            dataType: "schoolsMenu",
            entries: this.formatItems(this.content.organizations, "schoolsMenu")
          },
          languages: {
            dataType: "languages",
            entries: r
          }
        };
        e = e0(this.theme.customData.htmlCode, "header", de(oe({}, a), { entries: [], menus: c }));
      } catch (r) {
        e = r;
      }
      return de(oe({}, this.theme), {
        html_code: e,
        css_code: this.theme.customData.cssCode,
        js_code: this.theme.customData.jsCode
      });
    }
  },
  methods: {
    formatItems(e, t) {
      const n = this.formatItems;
      return e.map((o) => {
        let i = oe({}, o);
        const r = {
          SchoolsMenuLink: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.link || "", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s),
          SchoolsMenuImage: (s) => (s.opens_in_new_tab = s.open_in_new_tab ? "_blank" : "_self", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.height = s.preferred_height || "auto", s.width = s.preferred_width || "auto", s.alignment = s.image_alignment, s),
          link: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.mailto ? `mailto:${s.email_address}` : s.url, s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.ipAddress = s.ipAddress || "", s.email_address = s.email_address || "", s),
          SchoolsMenuOrg: (s) => (s.alias = s.alias || "", s.link = s.link || "", s.link = s.link.toLowerCase().replace(/\s/g, "-"), s),
          schoolsMenu: (s) => (s.path_prefix = s.path_prefix ? s.path_prefix : "/", s),
          page: (s) => (s.link_path = `${this.content.pathPrefix}/page/${s.slug}`, s)
        }, a = i.type || t;
        return r[a] && (i = r[a](i)), Array.isArray(i.children) && (i.children = n(i.children, t)), i;
      });
    }
  }
}, ZU = { class: "header-custom-code" };
function WU(e, t, n, o, i, r) {
  const a = S("CustomHtml");
  return l(), h("div", ZU, [
    $(a, { theme: r.processedTheme }, null, 8, ["theme"])
  ]);
}
const qU = /* @__PURE__ */ I(zU, [["render", WU]]), YU = {
  name: "BarNavItemWrapper",
  components: { MenuElementType: fc, DropdownArrowIcon: io, HamburgerIcon: sa, PlusIcon: aa },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => {
      }
    },
    colors: {
      type: Object,
      required: !0
    },
    forceShow: Boolean,
    moreMenuItem: Boolean,
    additionalMenuItem: Boolean,
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    activeId: {
      type: [String, Number],
      default: null
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "handle-item",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "handle-close",
    "next-tab",
    "focus-sub-menu"
  ],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    buttonTitle() {
      var e, t;
      return ((e = this.item) == null ? void 0 : e.name) || ((t = this.item) == null ? void 0 : t.translatedTitle);
    },
    hasFocusableChildren() {
      var t, n, o;
      const e = (i) => {
        var r;
        return [i, ...((r = i.children) == null ? void 0 : r.map((a) => e(a))) || []].flat();
      };
      return (o = (n = (t = this.item.children) == null ? void 0 : t.map((i) => e(i))) == null ? void 0 : n.flat()) == null ? void 0 : o.filter((i) => i.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem || !this.item) {
        this.$emit("handle-enter-event");
        return;
      }
      if (this.isHeader || this.additionalMenuItem || e) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    handleNextTab(e, t) {
      var s, u;
      const n = e.shiftKey, o = this.isActive, i = this.activeId && o, r = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((u = this.item) == null ? void 0 : u.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && r && !t) {
          this.$emit("handle-close");
          return;
        }
        if (!this.isMoreMenuItem && o) {
          this.$emit("handle-close");
          return;
        }
        if (a && t && this.hasChildren && i) {
          this.$emit("handle-close");
          return;
        }
      } else {
        if (this.moreMenuItem) return;
        if (i && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && o && this.$emit("handle-close"), a && (!this.hasChildren || t && this.hasChildren && !i) && this.$emit("handle-close");
      }
    }
  }
}, xU = ["id"], XU = ["aria-expanded", "aria-haspopup", "aria-controls"], QU = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, JU = { class: "sr-only" }, eK = ["aria-expanded", "aria-haspopup", "aria-controls"], tK = { class: "sr-only" };
function nK(e, t, n, o, i, r) {
  const a = S("MenuElementType"), s = S("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.additionalMenuItem || n.item ? (l(), h("div", {
    key: 0,
    id: r.itemId,
    ref: r.itemId,
    class: p(["bar-menu-item", {
      "menu-dropdown-item": n.isMoreMenuItem,
      "menu-item-active": !n.isMoreMenuItem && r.isActive
    }]),
    "data-testid": "menu-item",
    onMouseover: t[8] || (t[8] = D((u) => e.$emit("handle-item", n.item), ["stop", "prevent"])),
    onTouchstart: t[9] || (t[9] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"]))
  }, [
    $(a, {
      id: r.ariaId,
      class: p(["menu-item-text", {
        "menu-dropdown-item-active": r.isActive,
        [n.theme.style]: !!n.theme.style
      }]),
      "path-prefix": n.content.pathPrefix,
      "more-menu-title": n.theme.translations.more_dropdown_title,
      "more-menu-visible": n.moreMenuVisible,
      "fill-color": n.colors["--dropdown-text-color"],
      item: n.item,
      "aria-expanded": r.ariaExpanded,
      "aria-has-popup": r.ariaHasPopup,
      "aria-controls": r.ariaControls,
      onKeydown: [
        N(r.handleEnterEvent, ["enter"]),
        t[0] || (t[0] = N((u) => r.handleNextTab(u, !1), ["tab"]))
      ],
      onTouchstart: D(r.handleEnterEvent, ["exact", "stop", "prevent"])
    }, null, 8, ["id", "class", "path-prefix", "more-menu-title", "more-menu-visible", "fill-color", "item", "aria-expanded", "aria-has-popup", "aria-controls", "onKeydown", "onTouchstart"]),
    !r.isHeader && r.hasChildren && r.itemId !== "explore-button" && r.itemId !== "schoolsbutton" ? (l(), h("button", {
      key: 0,
      class: "menu-item-icon",
      "aria-expanded": r.ariaExpanded,
      "aria-haspopup": r.ariaHasPopup,
      "aria-controls": r.ariaControls,
      onKeydown: t[1] || (t[1] = N((u) => r.handleNextTab(u, !0), ["tab"])),
      onTouchstart: t[2] || (t[2] = D((u) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
      onClick: t[3] || (t[3] = D((u) => r.handleEnterEvent(!0), ["stop", "prevent"]))
    }, [
      d("span", QU, [
        $(s, {
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        d("span", JU, " Show submenu for " + f(r.buttonTitle) + " button", 1)
      ])
    ], 40, XU)) : g("", !0),
    r.isHeader || n.moreMenuItem || n.additionalMenuItem ? (l(), h(G, { key: 1 }, [
      n.moreMenuItem || n.additionalMenuItem || r.hasChildren ? (l(), h("button", {
        key: 0,
        class: p(["menu-item-icon", n.item.id]),
        "aria-expanded": r.ariaExpanded,
        "aria-haspopup": r.ariaHasPopup,
        "aria-controls": r.ariaControls,
        onMouseover: t[4] || (t[4] = D(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[5] || (t[5] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"])),
        onKeydown: t[6] || (t[6] = N((u) => r.handleNextTab(u, !0), ["tab"])),
        onClick: t[7] || (t[7] = D((...u) => r.handleEnterEvent && r.handleEnterEvent(...u), ["exact", "stop", "prevent"]))
      }, [
        n.item.id === "explore-button" ? (l(), _(R(n.item.icon), {
          key: 0,
          "fill-color": n.item.colors["--bg-color"],
          "fill-path-color": r.iconColor
        }, null, 8, ["fill-color", "fill-path-color"])) : (l(), _(s, {
          key: 1,
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"])),
        d("span", tK, " Show submenu for " + f(n.item.name || n.item.translatedTitle), 1)
      ], 42, eK)) : g("", !0)
    ], 64)) : g("", !0)
  ], 42, xU)) : g("", !0);
}
const t0 = /* @__PURE__ */ I(YU, [["render", nK], ["__scopeId", "data-v-bb22e3b0"]]), oK = {
  name: "BarNavDrawer",
  components: { BarNavDrawerItem: gc },
  mixins: [Fe],
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    currentDomain: {
      type: String,
      default: null
    },
    isMoreMenuActive: Boolean,
    isOpen: Boolean,
    isTemporarilyHideMenu: Boolean,
    isUnderlapped: Boolean
  },
  emits: ["hide-drawer", "handle-close", "prevent-close", "handle-toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    orgsWithIds() {
      return this.content.organizations.map((t, n) => de(oe({}, t), { id: n + 1 }));
    },
    itemId() {
      return `drawer-${this.activeItem.id}`;
    },
    drawerWidth() {
      return {
        "--drawer-width": this.isUnderlapped ? "100%" : "auto",
        "--left-alignment": this.isUnderlapped ? "46px" : ""
      };
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    orgLink(e) {
      return $n(e, {
        isPreview: this.content.isPreview,
        currentDomain: this.currentDomain
      });
    },
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleNextTab({ itemId: e, isIconButton: t, isBackwardsTab: n }) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("handle-toggle-parent", { itemId: e.id });
        return;
      }
      this.activeParent = e.id, this.$emit("handle-toggle-parent", { itemId: e.id });
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    }
  }
}, rK = ["id", "aria-labelledby"], iK = {
  key: 0,
  class: "menu-item-active-line"
}, sK = { key: 0 }, aK = { class: "explore-link" }, lK = ["innerHTML"], dK = ["href", "target", "onKeydown"], uK = { key: 1 }, cK = {
  key: 0,
  class: "basic-schools-dropdown"
}, hK = ["href", "target", "onKeydown"], mK = { key: 2 };
function pK(e, t, n, o, i, r) {
  const a = S("BarNavDrawerItem");
  return l(), h("div", {
    id: r.itemId,
    ref: r.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: p(["bar-nav-menu--drawer", [n.activeItem.id]]),
    style: H([r.drawerWidth, { flexDirection: i.scrollWidth ? "column" : "row" }]),
    onMouseleave: t[3] || (t[3] = D((s) => e.$emit("hide-drawer"), ["exact", "stop", "prevent"])),
    onMouseenter: t[4] || (t[4] = (s) => e.$emit("prevent-close"))
  }, [
    d("div", {
      ref: "drawer-wrapper",
      class: p(["bar-nav-menu--drawer-content-wrapper", { scrollWidth: i.scrollWidth }])
    }, [
      $(ye, { name: "slide-fade-up" }, {
        default: b(() => [
          n.isOpen ? (l(), h("div", iK)) : g("", !0)
        ]),
        _: 1
      }),
      n.activeItem.id === "explore-button" ? (l(), h("div", sK, [
        (l(!0), h(G, null, q(e.content.customMenuItems, (s) => (l(), h("div", {
          key: s.id,
          class: "dropdown-with-icons"
        }, [
          d("div", aK, [
            d("span", {
              innerHTML: s.icon || s.icon_cms
            }, null, 8, lK),
            d("a", {
              href: r.getLink(s.url),
              style: H({ color: e.theme.explore_menu_text_color }),
              target: r.targetWindow(s),
              onKeydown: N((u) => r.handleNextTab({ itemId: s.id, isIconButton: !1, isBackwardsTab: u.shiftKey }), ["tab"])
            }, f(s.name), 45, dK)
          ])
        ]))), 128))
      ])) : g("", !0),
      n.activeItem.id === "schoolsbutton" ? (l(), h("div", uK, [
        e.content.hasCustomSchoolsMenu ? g("", !0) : (l(), h("ul", cK, [
          (l(!0), h(G, null, q(r.orgsWithIds, (s) => (l(), h("li", {
            key: s.id
          }, [
            d("a", {
              href: r.orgLink(s),
              class: "school-link",
              target: r.targetWindow(s),
              onKeydown: N((u) => r.handleNextTab({ itemId: s.id, isIconButton: !0, isBackwardsTab: u.shiftKey }), ["tab"])
            }, f(s.name), 41, hK)
          ]))), 128))
        ]))
      ])) : g("", !0),
      n.activeItem.id !== "schoolsbutton" && n.activeItem.id !== "explore-button" ? (l(), h("div", mK, [
        (l(!0), h(G, null, q(n.activeItem.children, (s) => (l(), _(a, {
          key: s.id,
          "elem-data": s,
          "theme-style": e.theme.style,
          colors: e.colors,
          "active-parent": i.activeParent,
          "path-prefix": e.content.pathPrefix,
          onToggleParent: r.handleToggleParent,
          onHandleClose: t[0] || (t[0] = (u) => e.$emit("handle-close")),
          onNextTab: t[1] || (t[1] = (u) => e.$emit("next-tab", u)),
          onNavigate: t[2] || (t[2] = (u) => e.$emit("navigate", u))
        }, null, 8, ["elem-data", "theme-style", "colors", "active-parent", "path-prefix", "onToggleParent"]))), 128))
      ])) : g("", !0)
    ], 2)
  ], 46, rK);
}
const fK = /* @__PURE__ */ I(oK, [["render", pK], ["__scopeId", "data-v-ab83e199"]]), gK = {
  name: "BarNavMenuDropdown",
  components: { BarNavItemWrapper: t0 },
  props: {
    activeId: {
      type: [String, Number],
      default: null
    },
    isVisible: Boolean,
    moreItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: null
    },
    theme: {
      type: Object,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  emits: [
    "prevent-close",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "open-dropdown",
    "handle-close",
    "temporarily-hide-menu",
    "focus-sub-menu"
  ],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return this.moreItems[t].id;
    }
  }
}, vK = ["id", "aria-labelledby", "aria-expanded"];
function bK(e, t, n, o, i, r) {
  const a = S("BarNavItemWrapper");
  return l(), h("div", {
    id: r.ariaId,
    "aria-labelledby": r.ariaLabelledBy,
    "aria-expanded": r.ariaExpanded,
    class: "bar-nav-menu--dropdown-item-wrapper",
    onMouseleave: t[3] || (t[3] = (s) => e.$emit("prevent-close"))
  }, [
    (l(!0), h(G, null, q(n.moreItems, (s) => (l(), h(G, null, [
      s ? (l(), _(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": r.firstItemId,
        "last-item-id": r.lastItemId,
        "active-id": n.activeId,
        theme: n.theme,
        content: n.content,
        colors: n.colors,
        onNavigate: (u) => e.$emit("navigate", s),
        onHandleEnterEvent: (u) => e.$emit("handle-enter-event", s),
        onHandleItem: (u) => e.$emit("open-dropdown", s),
        onToggleDrawer: t[0] || (t[0] = (u) => e.$emit("toggle-drawer", u)),
        onHandleClose: t[1] || (t[1] = (u) => e.$emit("handle-close")),
        onFocusSubMenu: t[2] || (t[2] = (u) => e.$emit("focus-sub-menu", u))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem"])) : g("", !0)
    ], 64))), 256))
  ], 40, vK);
}
const yK = /* @__PURE__ */ I(gK, [["render", bK], ["__scopeId", "data-v-34008b2c"]]), CK = {
  name: "M5",
  components: {
    BarNavItemWrapper: t0,
    BarNavDrawer: fK,
    BarNavMoreDropdown: yK,
    CMSSchoolsMenu: an,
    MenuItem: it
  },
  mixins: [dc, Fe],
  emits: ["toggle-search"],
  computed: {
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    exploreButton() {
      var e, t, n, o;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.exploreMenuVisible,
        ariaControls: this.exploreMenuVisible ? "explore-menu" : null,
        children: this.content.customMenuItems,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.explore_dropdown_title) || "Explore",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": ((o = this.theme.navigation_color) == null ? void 0 : o.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.exploreMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    schoolsButton() {
      var e;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible,
        ariaControls: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "schools-menu-sm1" : null,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle || "Schools",
        children: this.orgsWithIds,
        colors: {
          "--fill-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    orgsWithIds() {
      return this.content.organizations.map((t, n) => de(oe({}, t), { id: n + 1 }));
    }
  },
  methods: {
    isUnderlapped(e) {
      return e === null ? void 0 : !!this.underLappedItems.find((n) => n.id === e);
    },
    closeCustomSchoolsMenu() {
      this.customSchoolsMenuVisible = !1, this.handleClose();
    }
  }
}, _K = { class: "bar-nav-menu--align-right" }, wK = {
  ref: "bar-nav-item-wrapper",
  class: "bar-nav-item-wrapper"
}, TK = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, kK = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, EK = {
  ref: "more-wrapper",
  class: "bar-dropdown-more-wrapper"
}, SK = {
  ref: "bar-end-options",
  class: "bar-end-options"
}, MK = ["href"];
function $K(e, t, n, o, i, r) {
  const a = S("BarNavItemWrapper"), s = S("BarNavDrawer"), u = S("CMSSchoolsMenu"), c = S("BarNavMoreDropdown"), y = S("MenuItem"), w = Ne("click-away");
  return l(), h("div", {
    id: "m5",
    style: H(e.colors),
    class: p(["bar-nav-menu", { "is-i-frame": e.content.isIFrame }])
  }, [
    d("div", {
      ref: "bar-nav-menu-bar",
      class: "bar-nav-menu-bar",
      onMouseleave: t[21] || (t[21] = (v) => e.mouseLeaveMenu()),
      onMouseenter: t[22] || (t[22] = (v) => e.mouseEnterMenu())
    }, [
      d("div", _K, [
        me((l(), h("div", wK, [
          d("div", TK, [
            $(a, {
              item: r.exploreButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[0] || (t[0] = (v) => e.showItem(r.exploreButton)),
              onToggleDrawer: t[1] || (t[1] = (v) => e.handleDrawerToggle(r.exploreButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            $(ye, { name: "slide-fade-up" }, {
              default: b(() => [
                e.activeItem && e.activeItem.id === r.exploreButton.id ? (l(), _(s, {
                  key: 0,
                  ref: `drawer-${r.exploreButton.id}`,
                  "active-item": r.exploreButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === r.exploreButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: t[2] || (t[2] = (v) => e.navigate(v)),
                  onHideDrawer: t[3] || (t[3] = (v) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[4] || (t[4] = (v) => e.preventClose(e.activeItem)),
                  onNextTab: t[5] || (t[5] = (v) => e.nextTabAction(v, "exploreButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onHandleClose"])) : g("", !0)
              ]),
              _: 1
            })
          ]),
          d("div", kK, [
            $(a, {
              item: r.schoolsButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[6] || (t[6] = (v) => e.showItem(r.schoolsButton)),
              onToggleDrawer: t[7] || (t[7] = (v) => e.handleDrawerToggle(r.schoolsButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            $(ye, { name: "slide-fade-up" }, {
              default: b(() => [
                e.activeItem && e.activeItem.id === r.schoolsButton.id & !e.content.hasCustomSchoolsMenu ? (l(), _(s, {
                  key: 0,
                  ref: "drawer-schoolsbutton",
                  "active-item": r.schoolsButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === r.schoolsButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[8] || (t[8] = (v) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[9] || (t[9] = (v) => e.preventClose(e.activeItem)),
                  onNextTab: t[10] || (t[10] = (v) => e.nextTabAction(v, "schoolsButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onNavigate", "onHandleClose"])) : g("", !0)
              ]),
              _: 1
            }),
            $(ye, { name: "slide" }, {
              default: b(() => [
                e.content.hasCustomSchoolsMenu ? (l(), _(u, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  role: "menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: r.closeCustomSchoolsMenu,
                  onMouseleave: r.closeCustomSchoolsMenu
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview", "onFocusLost", "onMouseleave"])) : g("", !0)
              ]),
              _: 1
            })
          ]),
          (l(!0), h(G, null, q(e.content.sitemapMenuItems, (v) => (l(), h("div", {
            key: v.id,
            class: "options-wrapper",
            "data-testid": "options-wrapper"
          }, [
            me($(a, {
              item: v,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              onNavigate: e.navigate,
              onHandleEnterEvent: e.handleClose,
              onHandleItem: (E) => e.showItem(v),
              onToggleDrawer: (E) => e.handleDrawerToggle(v),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem", "onToggleDrawer", "onHandleClose"]), [
              [Ft, e.visibleItems.find(({ id: E }) => E === v.id)]
            ]),
            $(ye, { name: "slide-fade-up" }, {
              default: b(() => [
                me($(s, {
                  ref_for: !0,
                  ref: `drawer-${v.id}`,
                  "active-item": v,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === v.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  "is-underlapped": r.isUnderlapped(e.activeItem && e.activeItem.id),
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[11] || (t[11] = (E) => e.hideDrawer("hide-drawer")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[12] || (t[12] = (E) => e.preventClose(e.activeItem)),
                  onNextTab: t[13] || (t[13] = (E) => e.nextTabAction(E))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "is-underlapped", "onHandleToggleParent", "onNavigate", "onHandleClose"]), [
                  [Ft, e.activeItem && e.activeItem.id === v.id && v.children.length > 0]
                ])
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ])), [
          [w, e.hideDrawer]
        ]),
        me(d("div", EK, [
          $(a, {
            class: "bar-dropdown-button",
            "more-menu-item": "",
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": "",
            theme: e.theme,
            item: { name: "more", children: [], id: "more" },
            content: e.content,
            colors: e.colors,
            onNavigate: e.navigate,
            onHandleEnterEvent: t[14] || (t[14] = (v) => e.isMoreDropdownVisible = !e.isMoreDropdownVisible),
            onHandleClose: e.hideMoreMenu,
            onHandleItem: t[15] || (t[15] = (v) => {
              e.handleMoreMenuToggle(e.isMoreDropdownVisible), e.hideDrawer();
            })
          }, null, 8, ["more-menu-visible", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
          $(ye, { name: "slide-fade-up" }, {
            default: b(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? me((l(), _(c, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                theme: e.theme,
                content: e.content,
                colors: e.colors,
                onNavigate: e.navigate,
                onHandleEnterEvent: e.handleClose,
                onOpenDropdown: t[16] || (t[16] = (v) => e.handleDropdownMenuOpen(v)),
                onToggleDrawer: t[17] || (t[17] = (v) => e.handleDrawerToggle(v)),
                onPreventClose: t[18] || (t[18] = (v) => e.preventClose(e.activeItem)),
                onHandleClose: e.handleClose,
                onFocusSubMenu: t[19] || (t[19] = (v) => e.focusSubMenu(v)),
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleClose", "onTemporarilyHideMenu"])), [
                [w, e.hideMoreMenu]
              ]) : g("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Ft, e.displayMoreButton]
        ])
      ]),
      d("div", SK, [
        !e.isMobile || !e.content.newMobileHeader ? (l(), _(y, {
          key: 0,
          item: "searchbutton",
          theme: e.theme,
          content: e.content,
          onToggleSearch: t[20] || (t[20] = (v) => e.$emit("toggle-search"))
        }, null, 8, ["theme", "content"])) : g("", !0),
        e.showSignInButton ? (l(), h("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank"
        }, f(e.signInText), 9, MK)) : g("", !0)
      ], 512)
    ], 544)
  ], 6);
}
const IK = /* @__PURE__ */ I(CK, [["render", $K], ["__scopeId", "data-v-3d31fa36"]]), AK = {
  name: "CmsHeader",
  components: {
    /* eslint-disable vue/no-reserved-component-names */
    H1: _T,
    H2: jT,
    H3: GT,
    H4: Bk,
    H5: uE,
    H6: BE,
    H7: tS,
    H8: yS,
    /* eslint-enable vue/no-reserved-component-names */
    Custom: qU,
    M4: ua,
    M5: IK
  },
  mixins: [rt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      validator(e) {
        const t = Object.keys(e);
        return [
          "customMenuItems",
          "globals",
          "hasCustomSchoolsMenu",
          "hasGalleryImages",
          "isIFrame",
          "isEditing",
          "isPreview",
          "isSearchOpen",
          "langCode",
          "langText",
          "languages",
          "menuOptions",
          "newMobileHeader",
          "orgDropdownTitle",
          "orgMenuContent",
          "organizations",
          "pathPrefix",
          "showMenu",
          "sitemapMenuItems",
          "iconLinks",
          "translations",
          "utilities"
        ].every((o) => t.includes(o));
      },
      type: Object,
      required: !0
    },
    isHomepage: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    currentDomain: {
      type: String,
      default: null
    },
    mediaSubdomain: {
      type: String,
      default: ""
    }
  },
  emits: [
    "toggle-mobile-menu",
    "toggle-menu",
    "toggle-search",
    "language-change",
    "close-menu",
    "update:utilities",
    "update:icon-links"
  ],
  data() {
    return {
      headerShouldShrink: !1,
      headerOffsetHeight: 0,
      headerClientHeight: 218,
      ticking: !1,
      debouncedToggleStickyHeaderAdj: () => {
      },
      debouncedCalculateHeaderHeight: () => {
      }
    };
  },
  computed: {
    customSchoolsMenu() {
      return this.content.hasCustomSchoolsMenu || this.theme.custom_schools_dropdown;
    },
    cmsHeaderStickyStyles() {
      const e = this.content.isPreview || !this.headerShouldBeSticky ? 0 : this.headerOffsetHeight, t = this.theme.version === "H3" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages, n = this.theme.version === "H4" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages;
      return {
        paddingBottom: `${e}px`,
        "--header-position": t || n ? "absolute" : "relative",
        "--header-width": t || n ? "100%" : "auto"
      };
    },
    headerShouldBeSticky() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.sticky_header) && this.headerShouldShrink && !this.content.isIFrame;
    },
    // Used only to toggle settings in cms-v2-components example
    themeSettingsToWatch() {
      var e;
      return `${this.theme.version}${(e = this.theme) == null ? void 0 : e.sticky_header}`;
    },
    isBarNavEnabled() {
      var e, t;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" || ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M5";
    },
    menuOptions() {
      return de(oe(oe({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations,
        headerHeight: this.headerClientHeight
      });
    },
    showMenuV4() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    showMenuV5() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    isMobile() {
      var t;
      if (!this.screenSize)
        return !1;
      let e = this.isBarNavEnabled ? 1023 : 960;
      return ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M6" ? this.screenSize <= 600 : (["H5", "H6"].includes(this.theme.version) && (e = 600), this.screenSize <= e);
    },
    showSignInButton() {
      return !!(this.theme.show_sign_in_button && (this.mediaSubdomain || this.content.isPreview));
    },
    signInUrl() {
      return `https://${this.mediaSubdomain}.id.thrillshare.com`;
    },
    H3gradient() {
      var e;
      return {
        "--bg-color": this.theme.version === "H3" ? this.theme.bg_color.hex : "",
        "--background-opacity": `${(e = this.theme.background_opacity) != null ? e : "80"}%`
      };
    }
  },
  watch: {
    themeSettingsToWatch() {
      this.calculateHeaderHeight();
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateHeaderHeight()), this.debouncedToggleStickyHeaderAdj = zo(this.toggleStickyHeaderAdjustments, 10), this.debouncedCalculateHeaderHeight = zo(this.calculateHeaderHeight, 100), window.addEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.addEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.removeEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  methods: {
    toggleStickyHeaderAdjustments() {
      !this.theme.sticky_header || this.content.isIFrame || this.ticking || (this.ticking = !0, window.requestAnimationFrame(() => {
        const e = window.scrollY > this.$refs.headerWrapper.offsetHeight;
        e !== this.headerShouldShrink && (this.headerShouldShrink = e), this.ticking = !1;
      }));
    },
    async calculateHeaderHeight() {
      if (await this.$nextTick(), this.$refs.headerWrapper) {
        const e = this.$refs.headerWrapper, t = e.clientHeight, n = e.offsetHeight, o = this.isBarNavEnabled && this.screenSize > 1024 ? 54 : 0;
        this.headerOffsetHeight = n + o, t > 0 && t !== this.headerClientHeight && (this.headerClientHeight = t);
      }
    }
  }
};
function LK(e, t, n, o, i, r) {
  const a = S("M4"), s = S("M5");
  return l(), h("div", {
    id: "cms-header",
    ref: "cmsHeader",
    class: "cms-header",
    style: H(r.cmsHeaderStickyStyles)
  }, [
    d("div", {
      ref: "headerWrapper",
      class: p(["header-bar-wrapper", [r.headerShouldBeSticky ? "sticky" : ""]]),
      style: H(r.H3gradient)
    }, [
      (l(), _(R(n.theme.version), {
        ref: "header",
        theme: n.theme,
        content: n.content,
        "should-shrink": i.headerShouldShrink,
        "should-be-sticky": r.headerShouldBeSticky,
        "is-mobile": r.isMobile,
        "is-homepage": n.isHomepage,
        "wrapper-component": n.wrapperComponent,
        "wrapper-props": n.wrapperProps,
        "show-sign-in-button": r.showSignInButton,
        "sign-in-url": r.signInUrl,
        onToggleMenu: t[0] || (t[0] = (u) => e.$emit("toggle-menu", u)),
        onToggleMobileMenu: t[1] || (t[1] = (u) => e.$emit("toggle-mobile-menu", u)),
        onCloseMenu: t[2] || (t[2] = (u) => e.$emit("close-menu")),
        onLanguageChange: t[3] || (t[3] = (u) => e.$emit("language-change", u)),
        onToggleSearch: t[4] || (t[4] = (u) => e.$emit("toggle-search")),
        "onUpdate:utilities": t[5] || (t[5] = (u) => e.$emit("update:utilities", u)),
        "onUpdate:iconLinks": t[6] || (t[6] = (u) => e.$emit("update:icon-links", u))
      }, {
        utility: b(({ idx: u }) => [
          C(e.$slots, "utility", { idx: u }, void 0, !0)
        ]),
        iconLink: b(({ idx: u }) => [
          C(e.$slots, "iconLink", { idx: u }, void 0, !0)
        ]),
        _: 3
      }, 40, ["theme", "content", "should-shrink", "should-be-sticky", "is-mobile", "is-homepage", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url"])),
      r.showMenuV4 ? (l(), _(a, {
        key: 0,
        theme: r.menuOptions,
        content: n.content,
        "is-mobile": r.isMobile,
        "is-preview": n.content.isPreview,
        onCloseMenu: t[7] || (t[7] = (u) => e.$emit("close-menu"))
      }, null, 8, ["theme", "content", "is-mobile", "is-preview"])) : g("", !0),
      r.showMenuV5 ? (l(), _(s, {
        key: 1,
        theme: r.menuOptions,
        content: n.content,
        "current-domain": n.currentDomain,
        "show-sign-in-button": r.showSignInButton,
        "sign-in-url": r.signInUrl,
        onCloseMenu: t[8] || (t[8] = (u) => e.$emit("toggle-menu", !1)),
        onToggleSearch: t[9] || (t[9] = (u) => e.$emit("toggle-search"))
      }, null, 8, ["theme", "content", "current-domain", "show-sign-in-button", "sign-in-url"])) : g("", !0)
    ], 6)
  ], 4);
}
const OK = /* @__PURE__ */ I(AK, [["render", LK], ["__scopeId", "data-v-34cc8f5d"]]), n0 = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
function o0(e) {
  return e.replace(n0, (t, n, o, i) => "#" + n + n + o + o + i + i).substring(1).match(/.{2}/g).map((t) => parseInt(t, 16));
}
function su(e, t = 1) {
  return [...e.replace(n0, (o, i, r, a) => "#" + i + i + r + r + a + a).substring(1).match(/.{2}/g).map((o) => parseInt(o, 16)), t].join(",");
}
const NK = {
  name: "M1",
  mixins: [gi],
  props: {
    isActive: Boolean
  },
  data() {
    return {
      parentList: null,
      childList: null,
      grandchildList: null
    };
  },
  computed: {
    columns() {
      if (!this.content.sitemapMenuItems || this.content.sitemapMenuItems.length < 1) return [];
      const e = 3, t = new Array(e).fill(null).map(() => []);
      let n = 0;
      return this.content.sitemapMenuItems.forEach((o) => {
        n > e - 1 && (n = 0), t[n].push(o), n += 1;
      }), t;
    },
    mainMenuRGBColor() {
      const [e, t, n] = o0(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  methods: {
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    },
    isSubMenuExpanded(e) {
      return this.activeIds.includes(e.id);
    },
    closeDropdownOnChildReverse(e, t, n) {
      e.id === n[0].id && this.toggleOpen(t.id, !1);
    },
    closeDropdownOnParentReverse(e, t) {
      e && this.toggleOpen(t.id, !1);
    },
    checkForExpandedMenu(e, t, n, o) {
      if (!e) {
        const i = o.length - 1;
        t.id === o[i].id && this.toggleOpen(n.id, !0);
      }
    },
    closeDropdownOnLastGrandchild(e, t, n) {
      const o = n.length - 1, i = t.length - 1, r = n[o].children[i].id;
      e.id === r && this.toggleOpen(e.id, !0);
    },
    closeDropdownOnLastChild(e, t) {
      const n = t.length - 1;
      e.id === t[n].id && e.children.length === 0 && this.toggleOpen(e.id, !0);
    }
  }
}, HK = {
  id: "m1",
  "data-testid": "m1"
}, PK = { "data-testid": "heading" }, DK = { class: "content" }, RK = { class: "static-links" }, VK = ["onKeydown"], BK = ["id", "target", "href"], FK = ["innerHTML"], jK = {
  key: 0,
  class: "generated-links"
}, UK = ["onMouseover"], KK = ["onKeydown"], GK = ["id", "aria-expanded", "aria-controls", "aria-describedby", "onKeydown", "onClick"], zK = ["onKeydown", "onClick"], ZK = ["id", "aria-expanded", "aria-controls", "aria-describedby"], WK = ["id", "aria-labelledby"], qK = ["onMouseover"], YK = ["onKeydown"], xK = ["onKeydown", "onClick"], XK = ["id", "aria-expanded", "aria-controls", "aria-describedby"], QK = ["id", "aria-labelledby"], JK = ["onMouseover", "onKeydown"], eG = ["onKeydown"], tG = {
  class: "button-action-content",
  tabindex: "-1"
}, nG = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, oG = ["fill"], rG = ["fill"];
function iG(e, t, n, o, i, r) {
  const a = S("MenuElement");
  return l(), h("div", HK, [
    d("div", {
      id: "mainmenu",
      ref: "mainmenu",
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      style: H(`background: ${r.mainMenuRGBColor}`),
      onKeydown: [
        t[8] || (t[8] = N(D((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[9] || (t[9] = N(D(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[10] || (t[10] = N(D(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[11] || (t[11] = N(D(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      d("div", {
        style: H(`color: ${e.theme.l1_text_color.hex || "#dddddd"};`),
        class: "heading",
        "data-testid": "heading-color"
      }, [
        d("h2", PK, f(e.translations.title), 1)
      ], 4),
      d("div", DK, [
        d("div", RK, [
          d("ul", null, [
            (l(!0), h(G, null, q(e.content.customMenuItems, (s) => (l(), h("li", {
              key: s.id,
              "data-testid": "static-link",
              onKeydown: N(D((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"])
            }, [
              d("a", {
                id: s.id,
                style: H(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url),
                onClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, [
                d("div", null, [
                  d("div", {
                    class: p(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: H(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    d("div", {
                      class: "menu-item-icon",
                      "data-testid": "m1-icon-color",
                      style: H(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, FK)
                  ], 6),
                  d("span", {
                    "data-testid": "m1-icon-text",
                    style: H(`color: ${e.theme.icon_text_color.hex};`)
                  }, f(s.name), 5)
                ])
              ], 12, BK)
            ], 40, VK))), 128))
          ])
        ]),
        r.columns.length ? (l(), h("div", jK, [
          d("ul", null, [
            (l(!0), h(G, null, q(e.content.sitemapMenuItems, (s, u) => (l(), h("li", {
              key: `parent-${u}`,
              "data-testid": "generated-link",
              class: p({
                "has-child": s.children.length,
                open: e.activeIds.includes(s.id)
              }),
              style: H(
                i.parentList === u ? { color: e.theme.l1_text_hover_color.hex } : { color: e.theme.l1_text_color.hex }
              ),
              onMouseover: (c) => r.setHoverColor("parentList", u),
              onMouseleave: t[6] || (t[6] = (c) => r.removeHoverColor("parentList"))
            }, [
              d("span", {
                class: "parent-menu-element-wrapper",
                onKeydown: [
                  N(D((c) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["enter"]),
                  N(D((c) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["space"])
                ]
              }, [
                $(a, {
                  id: `${s.slug || s.id}-${s.type}`,
                  element: s,
                  "toggle-fn": e.toggleOpen,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  "cursor-pointer": "",
                  onRouterLinkClick: t[1] || (t[1] = (c) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
              ], 40, KK),
              s.children.length ? (l(), h("span", {
                key: 0,
                id: `${s.slug || s.id}-${s.type}-parent-button`,
                role: "button",
                tabindex: "-1",
                "aria-expanded": !!e.activeIds.includes(s.id),
                "aria-haspopup": "true",
                "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                "aria-label": "Toggle Submenu",
                "aria-describedby": `${s.slug || s.id}-${s.type}`,
                onKeydown: [
                  N(D((c) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  N(D((c) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"])
                ],
                onClick: (c) => e.toggleOpen(s.id, !0)
              }, null, 40, GK)) : g("", !0),
              s.children.length ? (l(), h("span", {
                key: 1,
                class: "arrow-box",
                tabindex: "0",
                onKeydown: [
                  N(D((c) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  N(D((c) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"]),
                  N(D((c) => r.closeDropdownOnParentReverse(e.activeIds.includes(s.id), s), ["shift", "exact"]), ["tab"])
                ],
                onClick: (c) => e.toggleOpen(s.id, !0)
              }, [
                d("span", {
                  id: `${s.slug || s.id}-${s.type}-parent-button`,
                  role: "button",
                  class: "parent-arrow",
                  tabindex: "-1",
                  "aria-expanded": !!e.activeIds.includes(s.id),
                  "aria-haspopup": "true",
                  "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                  "aria-label": "Toggle Submenu",
                  "aria-describedby": `${s.slug || s.id}-${s.type}`
                }, null, 8, ZK)
              ], 40, zK)) : g("", !0),
              d("div", {
                class: "dropdown",
                style: H(`background: ${e.theme.l2_bg_color.hex || "#000000"};`)
              }, [
                s.children.length ? (l(), h("ul", {
                  key: 0,
                  id: `${s.slug || s.id}-${u}-child-list`,
                  "aria-labelledby": `${s.slug || s.id}-${s.type}-parent-button`
                }, [
                  (l(!0), h(G, null, q(s.children, (c, y) => (l(), h("li", {
                    key: `child-${y}`,
                    style: H(
                      i.childList === y ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                    ),
                    class: p({
                      "has-child": c.children.length,
                      open: e.activeIds.includes(c.id)
                    }),
                    onMouseover: (w) => r.setHoverColor("childList", y),
                    onMouseleave: t[5] || (t[5] = (w) => r.removeHoverColor("childList"))
                  }, [
                    d("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        N(D((w) => e.clickGeneratedLink(c, !1), ["exact", "prevent"]), ["enter"]),
                        N(D((w) => e.clickGeneratedLink(c, !1), ["exact", "prevent"]), ["space"]),
                        N(D((w) => r.closeDropdownOnChildReverse(c, s, s.children), ["shift", "exact"]), ["tab"]),
                        N(D((w) => r.closeDropdownOnLastChild(c, s.children), ["exact"]), ["tab"])
                      ]
                    }, [
                      $(a, {
                        id: `${c.slug || c.id}-${c.type}`,
                        element: c,
                        "toggle-fn": e.toggleOpen,
                        "path-prefix": e.content.pathPrefix,
                        "is-sub-parent": "",
                        onRouterLinkClick: t[2] || (t[2] = (w) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                    ], 40, YK),
                    c.children.length ? (l(), h("span", {
                      key: 0,
                      class: "arrow-box",
                      tabindex: "0",
                      onKeydown: [
                        N(D((w) => e.toggleOpen(c.id, !1), ["exact", "prevent"]), ["enter"]),
                        N(D((w) => e.toggleOpen(c.id, !1), ["exact", "prevent"]), ["space"]),
                        N(D((w) => r.checkForExpandedMenu(r.isSubMenuExpanded(c), c, s, s.children), ["exact"]), ["tab"])
                      ],
                      onClick: (w) => e.toggleOpen(c.id, !1)
                    }, [
                      d("span", {
                        id: `${c.slug || c.id}-${c.type}-child-button`,
                        class: "child-arrow",
                        role: "button",
                        tabindex: "-1",
                        "aria-expanded": !!e.activeIds.includes(c.id),
                        "aria-haspopup": "true",
                        "aria-controls": `${c.slug || c.id}-${y}-grandchild-list`,
                        "aria-label": "Toggle Submenu",
                        "aria-describedby": `${c.slug || c.id}-${c.type}`
                      }, null, 8, XK)
                    ], 40, xK)) : g("", !0),
                    c.children.length ? (l(), h("ul", {
                      key: 1,
                      id: `${c.slug || c.id}-${y}-grandchild-list`,
                      "aria-labelledby": `${c.slug || c.id}-${c.type}-child-button`,
                      style: H(`border-left: 1px solid ${e.theme.l2_text_color.hex}`)
                    }, [
                      (l(!0), h(G, null, q(c.children, (w, v) => (l(), h("li", {
                        key: `grandchild-${v}`,
                        style: H(
                          i.grandchildList === v ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                        ),
                        onMouseover: (E) => r.setHoverColor("grandchildList", v),
                        onMouseleave: t[4] || (t[4] = (E) => r.removeHoverColor("grandchildList")),
                        onKeydown: N(D((E) => r.closeDropdownOnLastGrandchild(w, c.children, s.children), ["exact"]), ["tab"])
                      }, [
                        d("span", {
                          class: "grandchild-menu-element-wrapper",
                          onKeydown: [
                            N(D((E) => e.clickGeneratedLink(w, !1), ["exact", "prevent"]), ["enter"]),
                            N(D((E) => e.clickGeneratedLink(w, !1), ["exact", "prevent"]), ["space"])
                          ]
                        }, [
                          $(a, {
                            id: `${w.slug || w.id}-${w.type}`,
                            element: w,
                            "path-prefix": e.content.pathPrefix,
                            onRouterLinkClick: t[3] || (t[3] = (E) => e.$emit("close-menu"))
                          }, null, 8, ["id", "element", "path-prefix"])
                        ], 40, eG)
                      ], 44, JK))), 128))
                    ], 12, QK)) : g("", !0)
                  ], 46, qK))), 128))
                ], 8, WK)) : g("", !0)
              ], 4)
            ], 46, UK))), 128))
          ])
        ])) : g("", !0)
      ]),
      d("button", {
        ref: "close-menu-button'",
        "data-testid": "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (s) => e.$emit("close-menu"))
      }, [
        d("div", tG, [
          (l(), h("svg", nG, [
            d("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              d("g", {
                id: "close_modal_icon",
                fill: e.theme.l1_text_color.hex
              }, t[12] || (t[12] = [
                d("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, rG)
            ], 8, oG)
          ]))
        ])
      ], 512)
    ], 36)
  ]);
}
const sG = /* @__PURE__ */ I(NK, [["render", iG], ["__scopeId", "data-v-4b5a0977"]]), aG = {
  name: "M2",
  mixins: [gi],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  computed: {
    mainMenuRGBColor() {
      const [e, t, n] = o0(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  methods: {
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, lG = { id: "m2" }, dG = { class: "content" }, uG = { class: "static-links" }, cG = ["onKeydown"], hG = ["id", "target", "href"], mG = ["innerHTML"], pG = { class: "generated-links" }, fG = ["onKeydown", "onMouseover"], gG = ["id", "aria-labelledby"], vG = ["onMouseover"], bG = ["id", "aria-expanded", "aria-controls", "tabindex", "onKeydown", "onMousedown"], yG = ["fill"], CG = ["fill", "stroke"], _G = ["fill", "stroke"], wG = ["tabindex", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onClick"], TG = ["id", "aria-labelledby"], kG = ["onMouseover"], EG = ["onKeydown"], SG = {
  class: "button-action-content",
  tabindex: "-1"
}, MG = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, $G = ["fill"], IG = ["fill"];
function AG(e, t, n, o, i, r) {
  const a = S("MenuElement");
  return l(), h("div", lG, [
    d("div", {
      id: "mainmenu",
      style: H(`background: ${r.mainMenuRGBColor}`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      onKeydown: [
        t[6] || (t[6] = N(D((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[7] || (t[7] = N(D(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[8] || (t[8] = N(D(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[9] || (t[9] = N(D(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      d("div", dG, [
        d("div", uG, [
          d("ul", null, [
            (l(!0), h(G, null, q(e.content.customMenuItems, (s) => (l(), h("li", {
              key: s.id,
              onKeydown: N(D((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"])
            }, [
              d("a", {
                id: s.id,
                style: H(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url)
              }, [
                d("div", null, [
                  d("div", {
                    class: p(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: H(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    d("div", {
                      class: "menu-item-icon",
                      style: H(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, mG)
                  ], 6),
                  d("span", {
                    style: H(`color: ${e.theme.icon_text_color.hex};`)
                  }, f(s.name), 5)
                ])
              ], 12, hG)
            ], 40, cG))), 128))
          ])
        ]),
        d("div", pG, [
          (l(!0), h(G, null, q(e.content.sitemapMenuItems, (s, u) => (l(), h("div", {
            key: `section-${u}`,
            style: H(`border-right-color: ${e.theme.text_color.hex}`),
            class: "col"
          }, [
            d("h2", {
              style: H(
                i.sectionList === s.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
              ),
              onKeydown: [
                N(D((c) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["enter"]),
                N(D((c) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["space"])
              ],
              onMouseover: (c) => r.setHoverColor("sectionList", s.id),
              onMouseleave: t[1] || (t[1] = (c) => r.removeHoverColor("sectionList"))
            }, [
              $(a, {
                id: `${s.slug || s.id}-${s.type}`,
                element: s,
                class: p({ "has-child": s.children.length }),
                "path-prefix": e.content.pathPrefix,
                "is-parent": "",
                onRouterLinkClick: t[0] || (t[0] = (c) => e.$emit("close-menu"))
              }, null, 8, ["id", "element", "class", "path-prefix"])
            ], 44, fG),
            s.children.length ? (l(), h("ul", {
              key: 0,
              id: `${s.slug || s.id}-${u}-parent-list`,
              "aria-labelledby": `${s.slug || s.id}-${s.type}`
            }, [
              (l(!0), h(G, null, q(s.children, (c, y) => (l(), h("li", {
                key: `parent-${y}`,
                style: H(
                  i.parentList === c.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: p({
                  "has-child": c.children.length,
                  open: e.activeIds.includes(c.id)
                }),
                onMouseover: (w) => r.setHoverColor("parentList", c.id),
                onMouseleave: t[4] || (t[4] = (w) => r.removeHoverColor("parentList"))
              }, [
                c.children.length ? (l(), h("svg", {
                  key: 0,
                  id: `${c.slug || c.id}-${c.type}-parent-button`,
                  role: "button",
                  "aria-expanded": c.type !== "header" ? !!e.activeIds.includes(c.id) : "",
                  "aria-haspopup": "true",
                  "aria-controls": c.type !== "header" ? `${c.slug || c.id}-${y}-child-list` : "",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 16 16",
                  class: "icon-box",
                  tabindex: c.children.length && c.type !== "header" ? "0" : "-1",
                  onKeydown: [
                    N(D((w) => e.toggleOpen(c.id, !0), ["exact", "prevent"]), ["enter"]),
                    N(D((w) => e.toggleOpen(c.id, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onMousedown: D((w) => e.toggleOpen(c.id, !0), ["prevent"])
                }, [
                  d("title", null, f(`Toggle Submenu for ${c.name}`), 1),
                  d("circle", {
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.bg_color.hex,
                    cx: "10",
                    cy: "10",
                    r: "20"
                  }, null, 8, yG),
                  e.activeIds.includes(c.id) ? (l(), h("path", {
                    key: 0,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,659a8,8,0,1,1,8-8A8,8,0,0,1,549,659Zm4-9h-8v2h8v-2Z",
                    transform: "translate(-541 -643)"
                  }, null, 8, CG)) : (l(), h("path", {
                    key: 1,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,638a8,8,0,1,1,8-8A8,8,0,0,1,549,638Zm4-9h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
                    transform: "translate(-541 -622)"
                  }, null, 8, _G))
                ], 40, bG)) : g("", !0),
                d("span", {
                  class: "parent-menu-element-wrapper",
                  tabindex: c.children.length && c.type === "header" ? "0" : "-1",
                  "aria-controls": c.type === "header" ? `${c.slug || c.id}-${y}-child-list` : "",
                  "aria-expanded": c.type === "header" ? !!e.activeIds.includes(c.id) : "",
                  "aria-label": c.type === "header" ? `Toggle Submenu for ${c.name}` : "",
                  onKeydown: [
                    N(D((w) => e.clickGeneratedLink(c, !0), ["exact", "prevent"]), ["enter"]),
                    N(D((w) => e.clickGeneratedLink(c, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: D((w) => e.clickGeneratedLink(c, !0), ["stop"])
                }, [
                  $(a, {
                    id: `${c.slug || c.id}-${c.type}`,
                    element: c,
                    "path-prefix": e.content.pathPrefix,
                    "is-sub-parent": ""
                  }, null, 8, ["id", "element", "path-prefix"])
                ], 40, wG),
                c.children.length ? (l(), h("ul", {
                  key: 1,
                  id: `${c.slug || c.id}-${y}-child-list`,
                  "aria-labelledby": `${c.slug || c.id}-${c.type}-parent-button`
                }, [
                  (l(!0), h(G, null, q(c.children, (w, v) => (l(), h("li", {
                    key: `child-${v}`,
                    style: H(
                      i.childList === w.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                    ),
                    onMouseover: (E) => r.setHoverColor("childList", w.id),
                    onMouseleave: t[3] || (t[3] = (E) => r.removeHoverColor("childList"))
                  }, [
                    d("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        N(D((E) => e.clickGeneratedLink(w, !1), ["exact", "prevent"]), ["enter"]),
                        N(D((E) => e.clickGeneratedLink(w, !1), ["exact", "prevent"]), ["space"])
                      ]
                    }, [
                      $(a, {
                        id: `${w.slug || w.id}-${w.type}`,
                        element: w,
                        "path-prefix": e.content.pathPrefix,
                        onRouterLinkClick: t[2] || (t[2] = (E) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "path-prefix"])
                    ], 40, EG)
                  ], 44, kG))), 128))
                ], 8, TG)) : g("", !0)
              ], 46, vG))), 128))
            ], 8, gG)) : g("", !0)
          ], 4))), 128))
        ])
      ]),
      d("button", {
        ref: "closeButton",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[5] || (t[5] = (s) => e.$emit("close-menu"))
      }, [
        d("div", SG, [
          (l(), h("svg", MG, [
            d("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              d("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[10] || (t[10] = [
                d("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, IG)
            ], 8, $G)
          ]))
        ])
      ], 512)
    ], 36)
  ]);
}
const LG = /* @__PURE__ */ I(aG, [["render", AG], ["__scopeId", "data-v-5e351852"]]), OG = {
  name: "M3",
  mixins: [gi, Ze],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  methods: {
    closeMenuIfOpen() {
      this.content.showMenu && !this.isPreview && this.$emit("close-menu");
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, NG = { id: "m3" }, HG = { class: "content" }, PG = { class: "static-links" }, DG = ["onKeydown"], RG = ["id", "target", "href"], VG = ["innerHTML"], BG = { class: "generated-links" }, FG = ["onKeydown", "onMouseover"], jG = ["id", "aria-labelledby"], UG = ["onMouseover"], KG = ["onKeydown"], GG = ["tabindex", "onKeydown"], zG = ["id", "aria-expanded", "aria-controls", "aria-label", "onClick"], ZG = ["id", "aria-labelledby"], WG = ["onMouseover"], qG = ["onKeydown"], YG = {
  class: "button-action-content",
  tabindex: "-1"
}, xG = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, XG = ["fill"], QG = ["fill"];
function JG(e, t, n, o, i, r) {
  const a = S("MenuElement"), s = Ne("click-away");
  return l(), h("div", NG, [
    me((l(), h("div", {
      style: H(`background: ${e.theme.bg_color.hex}; opacity: 0.96`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      onKeydown: t[8] || (t[8] = N(D((u) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"]))
    }, [
      d("div", {
        style: H(`color: ${e.theme.text_color.hex || "#dddddd"};`),
        class: "heading"
      }, [
        d("h2", null, f(e.translations.title), 1)
      ], 4),
      d("div", HG, [
        d("div", PG, [
          d("ul", null, [
            (l(!0), h(G, null, q(e.content.customMenuItems, (u) => (l(), h("li", {
              key: u.id,
              onKeydown: N(D((c) => e.clickStaticLink(e.getLink(u.url)), ["exact", "prevent"]), ["space"])
            }, [
              d("a", {
                id: u.id,
                style: H(`color: ${e.theme.icon_text_color.hex};`),
                target: u.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(u.url),
                onClick: t[0] || (t[0] = (c) => e.$emit("close-menu"))
              }, [
                d("div", null, [
                  d("div", {
                    class: p(["link-image", { "global-icon": u.cms_icon_id }]),
                    style: H(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    d("div", {
                      class: "menu-item-icon",
                      style: H(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: u.cms_icon_id ? u.icon_cms : u.icon
                    }, null, 12, VG)
                  ], 6),
                  d("span", {
                    style: H(`color: ${e.theme.icon_text_color.hex};`)
                  }, f(u.name), 5)
                ])
              ], 12, RG)
            ], 40, DG))), 128))
          ])
        ]),
        d("div", BG, [
          d("ul", null, [
            (l(!0), h(G, null, q(e.content.sitemapMenuItems, (u, c) => (l(), h("li", {
              key: `section-${c}`
            }, [
              d("h2", {
                style: H(
                  i.sectionList === u.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: p({ "has-child": u.children.length }),
                onKeydown: [
                  N(D((y) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["enter"]),
                  N(D((y) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["space"])
                ],
                onMouseover: (y) => r.setHoverColor("sectionList", u.id),
                onMouseleave: t[2] || (t[2] = (y) => r.removeHoverColor("sectionList"))
              }, [
                $(a, {
                  id: `${u.slug || u.id}-${u.type}`,
                  element: u,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  onRouterLinkClick: t[1] || (t[1] = (y) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "path-prefix"])
              ], 46, FG),
              u.children.length ? (l(), h("ul", {
                key: 0,
                id: `${u.slug || u.id}-${c}-parent-list`,
                "aria-labelledby": `${u.slug || u.id}-${u.type}`
              }, [
                (l(!0), h(G, null, q(u.children, (y, w) => (l(), h("li", {
                  key: `parent-${w}`,
                  style: H(
                    i.parentList === y.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                  ),
                  class: p({
                    "has-child": y.children.length,
                    open: e.activeIds.includes(y.id)
                  }),
                  onMouseover: (v) => r.setHoverColor("parentList", y.id),
                  onMouseleave: t[6] || (t[6] = (v) => r.removeHoverColor("parentList"))
                }, [
                  d("span", {
                    class: "parent-menu-element-wrapper",
                    onKeydown: [
                      N(D((v) => e.clickGeneratedLink(y, !0), ["exact", "prevent"]), ["enter"]),
                      N(D((v) => e.clickGeneratedLink(y, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    $(a, {
                      id: `${y.slug || y.id}-${y.type}`,
                      element: y,
                      "toggle-fn": e.toggleOpen,
                      "path-prefix": e.content.pathPrefix,
                      "is-sub-parent": "",
                      onRouterLinkClick: t[3] || (t[3] = (v) => e.$emit("close-menu"))
                    }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                  ], 40, KG),
                  d("span", {
                    class: "arrow-box",
                    tabindex: y.children.length ? "0" : "-1",
                    onKeydown: [
                      N(D((v) => e.toggleOpen(y.id, !0), ["exact", "prevent"]), ["enter"]),
                      N(D((v) => e.toggleOpen(y.id, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    y.children.length ? (l(), h("span", {
                      key: 0,
                      id: `${y.slug || y.id}-${y.type}-parent-button`,
                      class: "parent-arrow",
                      role: "button",
                      tabindex: "-1",
                      "aria-expanded": !!e.activeIds.includes(y.id),
                      "aria-haspopup": !0,
                      "aria-controls": `${y.slug || y.id}-${w}-child-list`,
                      "aria-label": `Toggle Submenu for ${y.name}`,
                      onClick: (v) => e.toggleOpen(y.id, !0)
                    }, null, 8, zG)) : g("", !0)
                  ], 40, GG),
                  y.children.length ? (l(), h("ul", {
                    key: 0,
                    id: `${y.slug || y.id}-${w}-child-list`,
                    "aria-labelledby": `${y.slug || y.id}-${y.type}-parent-button`
                  }, [
                    (l(!0), h(G, null, q(y.children, (v, E) => (l(), h("li", {
                      key: `child-${E}`,
                      style: H(
                        i.childList === v.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                      ),
                      onMouseover: (F) => r.setHoverColor("childList", v.id),
                      onMouseleave: t[5] || (t[5] = (F) => r.removeHoverColor("childList"))
                    }, [
                      d("span", {
                        class: "child-menu-element-wrapper",
                        onKeydown: [
                          N(D((F) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["enter"]),
                          N(D((F) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["space"])
                        ]
                      }, [
                        $(a, {
                          id: `${v.slug || v.id}-${v.type}`,
                          element: v,
                          "path-prefix": e.content.pathPrefix,
                          onRouterLinkClick: t[4] || (t[4] = (F) => e.$emit("close-menu"))
                        }, null, 8, ["id", "element", "path-prefix"])
                      ], 40, qG)
                    ], 44, WG))), 128))
                  ], 8, ZG)) : g("", !0)
                ], 46, UG))), 128))
              ], 8, jG)) : g("", !0)
            ]))), 128))
          ])
        ])
      ]),
      d("button", {
        ref: "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (u) => e.$emit("close-menu"))
      }, [
        d("div", YG, [
          (l(), h("svg", xG, [
            d("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.text_color.hex,
              "fill-rule": "evenodd"
            }, [
              d("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[9] || (t[9] = [
                d("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, QG)
            ], 8, XG)
          ]))
        ])
      ], 512)
    ], 36)), [
      [s, r.closeMenuIfOpen]
    ])
  ]);
}
const ez = /* @__PURE__ */ I(OG, [["render", JG], ["__scopeId", "data-v-4f6d0b70"]]), tz = {
  name: "CMSMenu",
  components: {
    M1: sG,
    M2: LG,
    M3: ez
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close-menu"],
  setup() {
    const e = tn(), { hasFocus: t, activate: n, deactivate: o } = da(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      cmsmenu: e
    };
  },
  computed: {
    hasMenu() {
      return ["M1", "M2", "M3"].includes(this.theme.version);
    }
  },
  watch: {
    "content.showMenu": {
      async handler() {
        this.content.showMenu && !this.isPreview ? (await Bt(), this.activate()) : (await Bt(), this.deactivate());
      }
    }
  }
}, nz = { id: "view-menu" };
function oz(e, t, n, o, i, r) {
  return r.hasMenu ? (l(), _(R(n.content.showMenu ? "nav" : "div"), { key: 0 }, {
    default: b(() => [
      d("div", nz, [
        $(ye, {
          name: `${n.theme.version}-fade`
        }, {
          default: b(() => [
            n.content.showMenu ? (l(), _(R(n.theme.version), {
              key: 0,
              ref: "cmsmenu",
              theme: n.theme,
              content: n.content,
              "is-preview": n.isPreview,
              onCloseMenu: t[0] || (t[0] = (a) => e.$emit("close-menu"))
            }, null, 40, ["theme", "content", "is-preview"])) : g("", !0)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _: 1
  })) : g("", !0);
}
const rz = /* @__PURE__ */ I(tz, [["render", oz], ["__scopeId", "data-v-794058fb"]]), iz = {
  name: "FooterHeader",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function sz(e, t, n, o, i, r) {
  return l(), h("h2", {
    style: H(`color: ${n.theme.heading_color.hex || "#cccccc"};`),
    class: p(n.theme.style === "light" ? "" : "bold")
  }, f(n.item.content), 7);
}
const az = /* @__PURE__ */ I(iz, [["render", sz]]), lz = {
  name: "FooterLink",
  props: {
    item: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    getReference() {
      return this.item.mailto ? `mailto:${this.item.email_address}` : this.item.url;
    },
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, dz = ["href", "target"];
function uz(e, t, n, o, i, r) {
  return l(), h("a", {
    href: r.getReference,
    target: r.linkTarget,
    style: H({ color: n.theme.text_link_color.hex, textDecoration: "none" })
  }, f(n.item.content), 13, dz);
}
const cz = /* @__PURE__ */ I(lz, [["render", uz]]), hz = {
  name: "FooterTextField",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function mz(e, t, n, o, i, r) {
  return l(), h("p", {
    style: H(`color: ${n.theme.text_link_color.hex || "#cccccc"};`),
    class: "textfield"
  }, f(n.item.content), 5);
}
const pz = /* @__PURE__ */ I(hz, [["render", mz]]), fz = {
  name: "FooterImage",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasLink() {
      return this.item.action_on_click === "link";
    },
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    }
  }
}, gz = ["src", "alt"];
function vz(e, t, n, o, i, r) {
  return l(), h("div", {
    class: p([n.item.image_alignment, "image-container"])
  }, [
    (l(), _(R(r.hasLink ? "a" : "div"), {
      style: H({ width: r.width, height: r.height }),
      href: r.hasLink && n.item.link_url,
      target: r.hasLink && r.opensInNewTab,
      class: "image-wrapper"
    }, {
      default: b(() => [
        d("img", {
          src: n.item.url,
          alt: n.item.alt_text
        }, null, 8, gz)
      ]),
      _: 1
    }, 8, ["style", "href", "target"]))
  ], 2);
}
const bz = /* @__PURE__ */ I(fz, [["render", vz], ["__scopeId", "data-v-37437fa5"]]), yz = /(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, Cz = (e) => {
  if (typeof e != "string")
    throw new Error("Expected a string argument");
  return e.replace(yz, (n) => `<a href="tel:${n}" class="tel-link">${n}</a>`);
}, r0 = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      required: !0
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    addTelLinksToPhoneNumbers: Cz
  },
  computed: {
    logoImage() {
      return this.isPreview ? this.logo : this.content.logo.url;
    },
    logoWidth() {
      return this.content.logo.display === "percentage" ? `${this.content.logo.set_ratio * 100}%` : `${this.content.logo.preferred_width || 150}px`;
    },
    logoHeight() {
      return this.content.logo.display === "percentage" || !this.content.logo.preferred_height ? "100%" : `${this.content.logo.preferred_height}px`;
    },
    logoAlignment() {
      return T(this.content, "logo.image_alignment", "center");
    },
    firstColumnHeader() {
      return this.content.columns[0].hasHeader || this.isPreview ? this.content.columns[0].header : !1;
    },
    info() {
      return this.content.organization_info;
    },
    currentYear() {
      return (/* @__PURE__ */ new Date()).getFullYear();
    },
    primaryOrg() {
      return this.organizations.filter((e) => e.primary);
    },
    copyrightOrg() {
      return this.organizations.length > 0 && !this.isIFrame ? this.primaryOrg[0].name : "School District";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": T(this.theme, "bg_color.hex", "#ffffff"),
        "--heading-color": T(this.theme, "heading_color.hex", "#cccccc"),
        "--link-color": T(this.theme, "text_link_color.hex", "#000000"),
        "--text-link-color": T(this.theme, "text_link_color.hex", "#000000"),
        "--logo-width": this.logoWidth,
        "--logo-height": this.logoHeight,
        "--logo-alignment": this.logoAlignment
      };
    }
  }
}, i0 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M81.5259%2019.2009V21.4919H80.0898V22.9944H81.5259V28.0994C81.5259%2029.8425%2082.3144%2030.5398%2084.2983%2030.5398C84.647%2030.5398%2084.979%2030.4983%2085.2695%2030.4485V28.9626C85.0205%2028.9875%2084.8628%2029.0041%2084.5889%2029.0041C83.7007%2029.0041%2083.3105%2028.5891%2083.3105%2027.6428V22.9944H85.2695V21.4919H83.3105V19.2009H81.5259Z'%20fill='white'/%3e%3cpath%20d='M90.3234%2030.6643C92.963%2030.6643%2094.5817%2028.8962%2094.5817%2025.9661C94.5817%2023.0525%2092.9547%2021.2761%2090.3234%2021.2761C87.6837%2021.2761%2086.0568%2023.0525%2086.0568%2025.9661C86.0568%2028.8962%2087.6754%2030.6643%2090.3234%2030.6643ZM90.3234%2029.0789C88.7711%2029.0789%2087.8995%2027.9416%2087.8995%2025.9661C87.8995%2024.0071%2088.7711%2022.8616%2090.3234%2022.8616C91.8673%2022.8616%2092.7472%2024.0071%2092.7472%2025.9661C92.7472%2027.9333%2091.8673%2029.0789%2090.3234%2029.0789Z'%20fill='white'/%3e%3cpath%20d='M95.9666%2030.49H97.7512V25.1526C97.7512%2023.8826%2098.7058%2023.0276%20100.059%2023.0276C100.374%2023.0276%20100.906%2023.0857%20101.055%2023.1355V21.3757C100.864%2021.3259%20100.524%2021.301%20100.258%2021.301C99.0794%2021.301%2098.075%2021.9485%2097.8176%2022.8367H97.6848V21.4504H95.9666V30.49Z'%20fill='white'/%3e%3cpath%20d='M105.486%2022.7952C106.806%2022.7952%20107.669%2023.7165%20107.711%2025.136H103.145C103.245%2023.7248%20104.166%2022.7952%20105.486%2022.7952ZM107.703%2028.0496C107.371%2028.7551%20106.632%2029.1453%20105.553%2029.1453C104.125%2029.1453%20103.204%2028.1409%20103.145%2026.5554V26.4558H109.529V25.8332C109.529%2022.9944%20108.01%2021.2761%20105.495%2021.2761C102.946%2021.2761%20101.328%2023.1106%20101.328%2025.9993C101.328%2028.8879%20102.913%2030.6643%20105.503%2030.6643C107.57%2030.6643%20109.014%2029.6682%20109.421%2028.0496H107.703Z'%20fill='white'/%3e%3cpath%20d='M69.8223%2027.1518C69.9599%2029.3715%2071.8097%2030.7911%2074.5628%2030.7911C77.5052%2030.7911%2079.3464%2029.3027%2079.3464%2026.9281C79.3464%2025.0612%2078.2967%2024.0287%2075.7501%2023.4351L74.3821%2023.0996C72.7647%2022.721%2072.1108%2022.2134%2072.1108%2021.3272C72.1108%2020.2088%2073.126%2019.4775%2074.6489%2019.4775C76.0942%2019.4775%2077.0923%2020.1916%2077.2729%2021.3358H79.1485C79.0366%2019.2452%2077.1955%2017.774%2074.6747%2017.774C71.9646%2017.774%2070.1578%2019.2452%2070.1578%2021.4563C70.1578%2023.2802%2071.1816%2024.3643%2073.4272%2024.8891L75.0274%2025.2763C76.6707%2025.6634%2077.3934%2026.2312%2077.3934%2027.1776C77.3934%2028.2789%2076.2577%2029.079%2074.7091%2029.079C73.0486%2029.079%2071.8957%2028.3305%2071.7323%2027.1518H69.8223Z'%20fill='white'/%3e%3cpath%20d='M51.3349%2021.301C50.1064%2021.301%2049.0439%2021.9153%2048.4961%2022.9446H48.3633V21.4504H46.645V33.4949H48.4297V29.1204H48.5708C49.0439%2030.0749%2050.0649%2030.6394%2051.3516%2030.6394C53.6343%2030.6394%2055.0869%2028.8381%2055.0869%2025.9661C55.0869%2023.094%2053.6343%2021.301%2051.3349%2021.301ZM50.8286%2029.0373C49.3345%2029.0373%2048.3965%2027.8586%2048.3965%2025.9744C48.3965%2024.0818%2049.3345%2022.9031%2050.8369%2022.9031C52.3476%2022.9031%2053.2524%2024.0569%2053.2524%2025.9661C53.2524%2027.8835%2052.3476%2029.0373%2050.8286%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M61.3317%2021.301C60.1032%2021.301%2059.0407%2021.9153%2058.4929%2022.9446H58.3601V21.4504H56.6418V33.4949H58.4265V29.1204H58.5676C59.0407%2030.0749%2060.0617%2030.6394%2061.3483%2030.6394C63.6311%2030.6394%2065.0837%2028.8381%2065.0837%2025.9661C65.0837%2023.094%2063.6311%2021.301%2061.3317%2021.301ZM60.8254%2029.0373C59.3313%2029.0373%2058.3933%2027.8586%2058.3933%2025.9744C58.3933%2024.0818%2059.3313%2022.9031%2060.8337%2022.9031C62.3444%2022.9031%2063.2492%2024.0569%2063.2492%2025.9661C63.2492%2027.8835%2062.3444%2029.0373%2060.8254%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M43.443%2030.49H45.4906L41.0082%2018.0751H38.9348L34.4523%2030.49H36.4311L37.5754%2027.1948H42.3073L43.443%2030.49ZM39.8725%2020.3292H40.0188L41.8169%2025.5774H38.0658L39.8725%2020.3292Z'%20fill='white'/%3e%3cpath%20d='M35.6511%208.71094V14.7H37.8135C39.5981%2014.7%2040.6316%2013.6001%2040.6316%2011.6868C40.6316%209.80249%2039.5898%208.71094%2037.8135%208.71094H35.6511ZM36.5808%209.55762H37.7097C38.9507%209.55762%2039.6853%2010.3462%2039.6853%2011.6992C39.6853%2013.073%2038.9631%2013.8533%2037.7097%2013.8533H36.5808V9.55762Z'%20fill='white'/%3e%3cpath%20d='M43.7967%2014.7871C45.1165%2014.7871%2045.9258%2013.9031%2045.9258%2012.438C45.9258%2010.9812%2045.1124%2010.093%2043.7967%2010.093C42.4769%2010.093%2041.6634%2010.9812%2041.6634%2012.438C41.6634%2013.9031%2042.4727%2014.7871%2043.7967%2014.7871ZM43.7967%2013.9944C43.0206%2013.9944%2042.5848%2013.4258%2042.5848%2012.438C42.5848%2011.4585%2043.0206%2010.8857%2043.7967%2010.8857C44.5687%2010.8857%2045.0086%2011.4585%2045.0086%2012.438C45.0086%2013.4216%2044.5687%2013.9944%2043.7967%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M52.818%2010.1802H51.9256L51.1205%2013.6292H51.0499L50.1202%2010.1802H49.2652L48.3355%2013.6292H48.2691L47.4598%2010.1802H46.555L47.8001%2014.7H48.7174L49.6471%2011.3713H49.7176L50.6515%2014.7H51.577L52.818%2010.1802Z'%20fill='white'/%3e%3cpath%20d='M53.8456%2014.7H54.7379V12.0562C54.7379%2011.3506%2055.1571%2010.9106%2055.817%2010.9106C56.477%2010.9106%2056.7924%2011.2717%2056.7924%2011.998V14.7H57.6847V11.7739C57.6847%2010.699%2057.1286%2010.093%2056.12%2010.093C55.4394%2010.093%2054.9911%2010.396%2054.7711%2010.8982H54.7047V10.1802H53.8456V14.7Z'%20fill='white'/%3e%3cpath%20d='M59.09%2014.7H59.9824V8.41626H59.09V14.7Z'%20fill='white'/%3e%3cpath%20d='M63.3384%2014.7871C64.6582%2014.7871%2065.4675%2013.9031%2065.4675%2012.438C65.4675%2010.9812%2064.6541%2010.093%2063.3384%2010.093C62.0186%2010.093%2061.2051%2010.9812%2061.2051%2012.438C61.2051%2013.9031%2062.0144%2014.7871%2063.3384%2014.7871ZM63.3384%2013.9944C62.5623%2013.9944%2062.1265%2013.4258%2062.1265%2012.438C62.1265%2011.4585%2062.5623%2010.8857%2063.3384%2010.8857C64.1104%2010.8857%2064.5503%2011.4585%2064.5503%2012.438C64.5503%2013.4216%2064.1104%2013.9944%2063.3384%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M68.1263%2014.0234C67.6407%2014.0234%2067.2879%2013.7869%2067.2879%2013.3801C67.2879%2012.9817%2067.5701%2012.77%2068.1927%2012.7285L69.2967%2012.658V13.0356C69.2967%2013.5959%2068.7986%2014.0234%2068.1263%2014.0234ZM67.898%2014.7747C68.4915%2014.7747%2068.9854%2014.5173%2069.2552%2014.0649H69.3257V14.7H70.1849V11.6121C70.1849%2010.6575%2069.5457%2010.093%2068.4126%2010.093C67.3875%2010.093%2066.657%2010.5911%2066.5657%2011.3672H67.429C67.5286%2011.0476%2067.8731%2010.865%2068.3711%2010.865C68.9812%2010.865%2069.2967%2011.1348%2069.2967%2011.6121V12.0022L68.0723%2012.0728C66.9974%2012.1392%2066.3914%2012.6082%2066.3914%2013.4216C66.3914%2014.2476%2067.0264%2014.7747%2067.898%2014.7747Z'%20fill='white'/%3e%3cpath%20d='M73.213%2014.7747C73.8355%2014.7747%2074.3626%2014.48%2074.6324%2013.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543%2010.4001%2073.8314%2010.1055%2073.213%2010.1055C72.0716%2010.1055%2071.337%2011.0103%2071.337%2012.438C71.337%2013.8699%2072.0633%2014.7747%2073.213%2014.7747ZM73.4662%2010.9065C74.2132%2010.9065%2074.6822%2011.5%2074.6822%2012.4421C74.6822%2013.3884%2074.2174%2013.9736%2073.4662%2013.9736C72.7108%2013.9736%2072.2584%2013.3967%2072.2584%2012.438C72.2584%2011.4875%2072.7149%2010.9065%2073.4662%2010.9065Z'%20fill='white'/%3e%3cpath%20d='M81.3444%2014.7871C82.6643%2014.7871%2083.4736%2013.9031%2083.4736%2012.438C83.4736%2010.9812%2082.6601%2010.093%2081.3444%2010.093C80.0246%2010.093%2079.2111%2010.9812%2079.2111%2012.438C79.2111%2013.9031%2080.0205%2014.7871%2081.3444%2014.7871ZM81.3444%2013.9944C80.5683%2013.9944%2080.1325%2013.4258%2080.1325%2012.438C80.1325%2011.4585%2080.5683%2010.8857%2081.3444%2010.8857C82.1164%2010.8857%2082.5563%2011.4585%2082.5563%2012.438C82.5563%2013.4216%2082.1164%2013.9944%2081.3444%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M84.6548%2014.7H85.5471V12.0562C85.5471%2011.3506%2085.9663%2010.9106%2086.6262%2010.9106C87.2861%2010.9106%2087.6016%2011.2717%2087.6016%2011.998V14.7H88.4939V11.7739C88.4939%2010.699%2087.9377%2010.093%2086.9292%2010.093C86.2485%2010.093%2085.8003%2010.396%2085.5803%2010.8982H85.5139V10.1802H84.6548V14.7Z'%20fill='white'/%3e%3cpath%20d='M92.6036%209.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036%2014.3762%2092.9979%2014.7249%2093.9898%2014.7249C94.1642%2014.7249%2094.3302%2014.7041%2094.4754%2014.6792V13.9363C94.3509%2013.9487%2094.2721%2013.957%2094.1351%2013.957C93.691%2013.957%2093.4959%2013.7495%2093.4959%2013.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z'%20fill='white'/%3e%3cpath%20d='M95.6732%2014.7H96.5656V12.0603C96.5656%2011.3755%2096.9723%2010.9148%2097.7028%2010.9148C98.3336%2010.9148%2098.6698%2011.28%2098.6698%2012.0022V14.7H99.5622V11.7822C99.5622%2010.7073%2098.9687%2010.0972%2098.0058%2010.0972C97.3251%2010.0972%2096.8478%2010.4001%2096.6278%2010.9065H96.5573V8.41626H95.6732V14.7Z'%20fill='white'/%3e%3cpath%20d='M102.781%2010.8525C103.441%2010.8525%20103.873%2011.3132%20103.894%2012.0229H101.611C101.661%2011.3174%20102.121%2010.8525%20102.781%2010.8525ZM103.889%2013.4797C103.723%2013.8325%20103.354%2014.0276%20102.814%2014.0276C102.101%2014.0276%20101.64%2013.5254%20101.611%2012.7327V12.6829H104.802V12.3716C104.802%2010.9521%20104.043%2010.093%20102.785%2010.093C101.511%2010.093%20100.702%2011.0103%20100.702%2012.4546C100.702%2013.8989%20101.495%2014.7871%20102.789%2014.7871C103.823%2014.7871%20104.545%2014.2891%20104.748%2013.4797H103.889Z'%20fill='white'/%3e%3cpath%20d='M24.769%2020.3008C24.7907%2018.6198%2025.6934%2017.0292%2027.1256%2016.1488C26.2221%2014.8584%2024.7088%2014.0403%2023.1344%2013.9911C21.4552%2013.8148%2019.8272%2014.9959%2018.9715%2014.9959C18.0992%2014.9959%2016.7817%2014.0086%2015.363%2014.0378C13.5137%2014.0975%2011.7898%2015.1489%2010.8901%2016.7656C8.95607%2020.1141%2010.3987%2025.0351%2012.2513%2027.7417C13.1782%2029.0671%2014.2615%2030.5475%2015.6789%2030.495C17.066%2030.4375%2017.584%2029.6105%2019.2583%2029.6105C20.9171%2029.6105%2021.4031%2030.495%2022.8493%2030.4616C24.3377%2030.4375%2025.2754%2029.1304%2026.1698%2027.7925C26.8358%2026.8481%2027.3483%2025.8044%2027.6882%2024.7C25.9391%2023.9602%2024.771%2022.2%2024.769%2020.3008Z'%20fill='white'/%3e%3cpath%20d='M22.0373%2012.2111C22.8489%2011.2369%2023.2487%209.98469%2023.1518%208.72046C21.912%208.85068%2020.7668%209.44324%2019.9443%2010.3801C19.14%2011.2954%2018.7214%2012.5255%2018.8006%2013.7415C20.0408%2013.7542%2021.2601%2013.1777%2022.0373%2012.2111Z'%20fill='white'/%3e%3c/svg%3e", s0 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M68.136%2020.8861C65.784%2020.8861%2063.867%2022.6751%2063.867%2025.1391C63.867%2027.5881%2065.784%2029.3921%2068.136%2029.3921C70.489%2029.3921%2072.406%2027.5881%2072.406%2025.1391C72.405%2022.6751%2070.488%2020.8861%2068.136%2020.8861ZM68.136%2027.7181C66.847%2027.7181%2065.736%2026.6551%2065.736%2025.1401C65.736%2023.6091%2066.848%2022.5621%2068.136%2022.5621C69.425%2022.5621%2070.536%2023.6091%2070.536%2025.1401C70.536%2026.6541%2069.425%2027.7181%2068.136%2027.7181ZM58.822%2020.8861C56.47%2020.8861%2054.553%2022.6751%2054.553%2025.1391C54.553%2027.5881%2056.47%2029.3921%2058.822%2029.3921C61.175%2029.3921%2063.092%2027.5881%2063.092%2025.1391C63.092%2022.6751%2061.175%2020.8861%2058.822%2020.8861ZM58.822%2027.7181C57.533%2027.7181%2056.422%2026.6551%2056.422%2025.1401C56.422%2023.6091%2057.534%2022.5621%2058.822%2022.5621C60.111%2022.5621%2061.222%2023.6091%2061.222%2025.1401C61.223%2026.6541%2060.111%2027.7181%2058.822%2027.7181ZM47.744%2022.1921V23.9961H52.062C51.933%2025.0111%2051.595%2025.7521%2051.079%2026.2671C50.451%2026.8951%2049.468%2027.5881%2047.744%2027.5881C45.086%2027.5881%2043.008%2025.4451%2043.008%2022.7871C43.008%2020.1291%2045.086%2017.9861%2047.744%2017.9861C49.178%2017.9861%2050.225%2018.5501%2050.998%2019.2751L52.271%2018.0021C51.191%2016.9711%2049.758%2016.1821%2047.744%2016.1821C44.103%2016.1821%2041.042%2019.1461%2041.042%2022.7871C41.042%2026.4281%2044.103%2029.3921%2047.744%2029.3921C49.709%2029.3921%2051.192%2028.7471%2052.351%2027.5391C53.543%2026.3471%2053.914%2024.6711%2053.914%2023.3181C53.914%2022.9001%2053.882%2022.5131%2053.817%2022.1911H47.744V22.1921ZM93.052%2023.5931C92.698%2022.6431%2091.618%2020.8861%2089.411%2020.8861C87.22%2020.8861%2085.399%2022.6101%2085.399%2025.1391C85.399%2027.5231%2087.204%2029.3921%2089.62%2029.3921C91.569%2029.3921%2092.697%2028.2001%2093.165%2027.5071L91.715%2026.5401C91.232%2027.2491%2090.571%2027.7161%2089.62%2027.7161C88.67%2027.7161%2087.993%2027.2811%2087.558%2026.4271L93.245%2024.0751L93.052%2023.5931ZM87.252%2025.0111C87.204%2023.3671%2088.525%2022.5301%2089.476%2022.5301C90.217%2022.5301%2090.845%2022.9011%2091.055%2023.4321L87.252%2025.0111ZM82.629%2029.1351H84.497V16.6341H82.629V29.1351ZM79.567%2021.8371H79.503C79.084%2021.3371%2078.278%2020.8861%2077.264%2020.8861C75.137%2020.8861%2073.188%2022.7551%2073.188%2025.1561C73.188%2027.5401%2075.137%2029.3931%2077.264%2029.3931C78.279%2029.3931%2079.084%2028.9421%2079.503%2028.4271H79.567V29.0391C79.567%2030.6661%2078.697%2031.5361%2077.296%2031.5361C76.152%2031.5361%2075.443%2030.7151%2075.153%2030.0221L73.526%2030.6991C73.993%2031.8261%2075.233%2033.2121%2077.296%2033.2121C79.487%2033.2121%2081.34%2031.9231%2081.34%2028.7811V21.1451H79.568V21.8371H79.567ZM77.425%2027.7181C76.136%2027.7181%2075.057%2026.6381%2075.057%2025.1561C75.057%2023.6571%2076.136%2022.5621%2077.425%2022.5621C78.697%2022.5621%2079.696%2023.6571%2079.696%2025.1561C79.696%2026.6381%2078.697%2027.7181%2077.425%2027.7181ZM101.806%2016.6341H97.335V29.1351H99.2V24.3991H101.805C103.873%2024.3991%20105.907%2022.9021%20105.907%2020.5171C105.907%2018.1321%20103.874%2016.6341%20101.806%2016.6341ZM101.854%2022.6591H99.2V18.3741H101.854C103.249%2018.3741%20104.041%2019.5291%20104.041%2020.5171C104.041%2021.4851%20103.249%2022.6591%20101.854%2022.6591ZM113.386%2020.8641C112.035%2020.8641%20110.636%2021.4591%20110.057%2022.7781L111.713%2023.4691C112.067%2022.7781%20112.727%2022.5521%20113.418%2022.5521C114.383%2022.5521%20115.364%2023.1311%20115.38%2024.1601V24.2891C115.042%2024.0961%20114.318%2023.8071%20113.434%2023.8071C111.649%2023.8071%20109.831%2024.7881%20109.831%2026.6211C109.831%2028.2941%20111.295%2029.3711%20112.935%2029.3711C114.189%2029.3711%20114.881%2028.8081%20115.315%2028.1481H115.379V29.1131H117.181V24.3201C117.182%2022.1021%20115.524%2020.8641%20113.386%2020.8641ZM113.16%2027.7151C112.55%2027.7151%20111.697%2027.4091%20111.697%2026.6531C111.697%2025.6881%20112.759%2025.3181%20113.676%2025.3181C114.495%2025.3181%20114.882%2025.4951%20115.38%2025.7361C115.235%2026.8951%20114.238%2027.7151%20113.16%2027.7151ZM123.743%2021.1371L121.604%2026.5571H121.54L119.32%2021.1371H117.31L120.639%2028.7121L118.741%2032.9261H120.687L125.818%2021.1371H123.743ZM106.937%2029.1351H108.802V16.6341H106.937V29.1351Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20fill='white'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20fill='white'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20fill='white'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20fill='white'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20fill='white'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20fill='white'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cg%20filter='url(%23filter0_ii)'%3e%3cpath%20d='M10.436%206.67302C10.145%206.98102%209.97302%207.45902%209.97302%208.07802V30.194C9.97302%2030.814%2010.145%2031.291%2010.436%2031.599L10.51%2031.671L22.899%2019.282V19.136V18.99L10.51%206.60002L10.436%206.67302Z'%20fill='url(%23paint0_linear)'/%3e%3cpath%20d='M27.028%2023.413L22.899%2019.282V19.136V18.99L27.029%2014.86L27.122%2014.913L32.015%2017.693C33.412%2018.487%2033.412%2019.786%2032.015%2020.581L27.122%2023.361L27.028%2023.413Z'%20fill='url(%23paint1_linear)'/%3e%3cg%20filter='url(%23filter1_i)'%3e%3cpath%20d='M27.122%2023.36L22.898%2019.136L10.436%2031.599C10.896%2032.087%2011.657%2032.147%2012.514%2031.661L27.122%2023.36Z'%20fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath%20d='M27.122%2014.912L12.514%206.61202C11.657%206.12502%2010.896%206.18602%2010.436%206.67402L22.899%2019.137L27.122%2014.912Z'%20fill='url(%23paint3_linear)'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_ii'%20x='9.97302'%20y='6.27594'%20width='23.0898'%20height='25.7208'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.12%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%201%200%200%200%200%201%200%200%200%200%201%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='effect1_innerShadow'%20result='effect2_innerShadow'/%3e%3c/filter%3e%3cfilter%20id='filter1_i'%20x='10.436'%20y='19.136'%20width='16.686'%20height='12.8607'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.08%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='21.8008'%20y1='7.84402'%20x2='5.01882'%20y2='24.626'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2300A0FF'/%3e%3cstop%20offset='0.0066'%20stop-color='%2300A1FF'/%3e%3cstop%20offset='0.2601'%20stop-color='%2300BEFF'/%3e%3cstop%20offset='0.5122'%20stop-color='%2300D2FF'/%3e%3cstop%20offset='0.7604'%20stop-color='%2300DFFF'/%3e%3cstop%20offset='1'%20stop-color='%2300E3FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='33.8335'%20y1='19.136'%20x2='9.63765'%20y2='19.136'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFE000'/%3e%3cstop%20offset='0.4087'%20stop-color='%23FFBD00'/%3e%3cstop%20offset='0.7754'%20stop-color='%23FFA500'/%3e%3cstop%20offset='1'%20stop-color='%23FF9C00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='24.8281'%20y1='21.4299'%20x2='2.06964'%20y2='44.1884'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF3A44'/%3e%3cstop%20offset='1'%20stop-color='%23C31162'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='7.29743'%20y1='-0.688184'%20x2='17.4597'%20y2='9.47412'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2332A071'/%3e%3cstop%20offset='0.0685'%20stop-color='%232DA771'/%3e%3cstop%20offset='0.4762'%20stop-color='%2315CF74'/%3e%3cstop%20offset='0.8009'%20stop-color='%2306E775'/%3e%3cstop%20offset='1'%20stop-color='%2300F076'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", a0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%233B5998'/%3e%3cpath%20d='M24.625%206.625H7.375C6.96016%206.625%206.625%206.96016%206.625%207.375V24.625C6.625%2025.0398%206.96016%2025.375%207.375%2025.375H24.625C25.0398%2025.375%2025.375%2025.0398%2025.375%2024.625V7.375C25.375%206.96016%2025.0398%206.625%2024.625%206.625ZM22.4594%2012.0977H20.9617C19.7875%2012.0977%2019.5602%2012.6555%2019.5602%2013.4758V15.2828H22.3633L21.9977%2018.1117H19.5602V25.375H16.6375V18.1141H14.193V15.2828H16.6375V13.1969C16.6375%2010.7758%2018.1164%209.45625%2020.2773%209.45625C21.3133%209.45625%2022.2016%209.53359%2022.4617%209.56875V12.0977H22.4594Z'%20fill='white'/%3e%3c/svg%3e", l0 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2028.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2032%2032'%20style='enable-background:new%200%200%2032%2032;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%23231F20;}%20.st1{fill:%23FFFFFF;}%20%3c/style%3e%3cpath%20class='st0'%20d='M2,0h28c1.1,0,2,0.9,2,2v28c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z'/%3e%3cpath%20class='st1'%20d='M17.6,14.7L24,7.2h-1.5L17,13.7l-4.4-6.5H7.4l6.7,9.8l-6.7,7.8h1.5l5.9-6.8l4.7,6.8h5.1L17.6,14.7L17.6,14.7z%20M15.6,17.1l-0.7-1L9.5,8.3h2.3l4.4,6.3l0.7,1l5.7,8.1h-2.3L15.6,17.1L15.6,17.1z'/%3e%3c/svg%3e", d0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23FF0000'/%3e%3cpath%20d='M26.0617%2010.9398C25.9422%2010.4946%2025.7078%2010.0886%2025.382%209.76243C25.0563%209.43625%2024.6505%209.20136%2024.2055%209.08125C22.5672%208.64063%2016%208.64062%2016%208.64062C16%208.64062%209.43281%208.64062%207.79453%209.07891C7.34927%209.19862%206.94334%209.43339%206.61751%209.75962C6.29169%2010.0859%206.05744%2010.4921%205.93828%2010.9375C5.5%2012.5781%205.5%2016%205.5%2016C5.5%2016%205.5%2019.4219%205.93828%2021.0602C6.17969%2021.9648%206.89219%2022.6773%207.79453%2022.9188C9.43281%2023.3594%2016%2023.3594%2016%2023.3594C16%2023.3594%2022.5672%2023.3594%2024.2055%2022.9188C25.1102%2022.6773%2025.8203%2021.9648%2026.0617%2021.0602C26.5%2019.4219%2026.5%2016%2026.5%2016C26.5%2016%2026.5%2012.5781%2026.0617%2010.9398ZM13.9141%2019.1406V12.8594L19.3516%2015.9766L13.9141%2019.1406Z'%20fill='white'/%3e%3c/svg%3e", u0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23E5017B'/%3e%3cpath%20d='M16%2011.193C13.3398%2011.193%2011.193%2013.3398%2011.193%2016C11.193%2018.6602%2013.3398%2020.807%2016%2020.807C18.6601%2020.807%2020.807%2018.6602%2020.807%2016C20.807%2013.3398%2018.6601%2011.193%2016%2011.193ZM16%2019.1242C14.2797%2019.1242%2012.8758%2017.7203%2012.8758%2016C12.8758%2014.2797%2014.2797%2012.8758%2016%2012.8758C17.7203%2012.8758%2019.1242%2014.2797%2019.1242%2016C19.1242%2017.7203%2017.7203%2019.1242%2016%2019.1242ZM21.0039%209.87578C20.3828%209.87578%2019.8812%2010.3773%2019.8812%2010.9984C19.8812%2011.6195%2020.3828%2012.1211%2021.0039%2012.1211C21.625%2012.1211%2022.1266%2011.6219%2022.1266%2010.9984C22.1267%2010.851%2022.0978%2010.7049%2022.0415%2010.5686C21.9851%2010.4323%2021.9024%2010.3085%2021.7981%2010.2042C21.6939%2010.0999%2021.57%2010.0172%2021.4337%209.96086C21.2974%209.90451%2021.1514%209.87559%2021.0039%209.87578ZM25.3703%2016C25.3703%2014.7062%2025.382%2013.4242%2025.3094%2012.1328C25.2367%2010.6328%2024.8945%209.30156%2023.7976%208.20469C22.6984%207.10547%2021.3695%206.76562%2019.8695%206.69297C18.5758%206.62031%2017.2937%206.63203%2016.0023%206.63203C14.7086%206.63203%2013.4266%206.62031%2012.1351%206.69297C10.6351%206.76562%209.3039%207.10781%208.20702%208.20469C7.1078%209.3039%206.76796%2010.6328%206.6953%2012.1328C6.62265%2013.4266%206.63436%2014.7086%206.63436%2016C6.63436%2017.2914%206.62265%2018.5758%206.6953%2019.8672C6.76796%2021.3672%207.11015%2022.6984%208.20702%2023.7953C9.30624%2024.8945%2010.6351%2025.2344%2012.1351%2025.307C13.4289%2025.3797%2014.7109%2025.368%2016.0023%2025.368C17.2961%2025.368%2018.5781%2025.3797%2019.8695%2025.307C21.3695%2025.2344%2022.7008%2024.8922%2023.7976%2023.7953C24.8969%2022.6961%2025.2367%2021.3672%2025.3094%2019.8672C25.3844%2018.5758%2025.3703%2017.2937%2025.3703%2016ZM23.3078%2021.5266C23.1367%2021.9531%2022.9305%2022.2719%2022.6%2022.6C22.2695%2022.9305%2021.9531%2023.1367%2021.5266%2023.3078C20.2937%2023.7977%2017.3664%2023.6875%2016%2023.6875C14.6336%2023.6875%2011.7039%2023.7977%2010.4711%2023.3102C10.0445%2023.1391%209.72577%2022.9328%209.39765%2022.6023C9.06718%2022.2719%208.86093%2021.9555%208.68983%2021.5289C8.20233%2020.2937%208.31249%2017.3664%208.31249%2016C8.31249%2014.6336%208.20233%2011.7039%208.68983%2010.4711C8.86093%2010.0445%209.06718%209.72578%209.39765%209.39765C9.72811%209.06953%2010.0445%208.86094%2010.4711%208.68984C11.7039%208.20234%2014.6336%208.3125%2016%208.3125C17.3664%208.3125%2020.2961%208.20234%2021.5289%208.68984C21.9555%208.86094%2022.2742%209.06719%2022.6023%209.39765C22.9328%209.72812%2023.1391%2010.0445%2023.3101%2010.4711C23.7976%2011.7039%2023.6875%2014.6336%2023.6875%2016C23.6875%2017.3664%2023.7976%2020.2937%2023.3078%2021.5266Z'%20fill='white'/%3e%3c/svg%3e", _z = {
  name: "F1",
  components: {
    FooterHeader: az,
    FooterLink: cz,
    FooterImage: bz,
    FooterTextField: pz
  },
  mixins: [r0],
  methods: {
    orgLink(e) {
      return $n(e, {
        isPreview: this.isPreview,
        currentDomain: this.currentDomain
      });
    }
  }
}, wz = { class: "row" }, Tz = {
  class: "footer-column-main",
  "data-testid": "footer-column"
}, kz = { class: "logo-wrapper" }, Ez = ["src"], Sz = { key: 0 }, Mz = { key: 1 }, $z = { key: 2 }, Iz = ["innerHTML"], Az = ["innerHTML"], Lz = { key: 5 }, Oz = ["innerHTML"], Nz = ["href"], Hz = {
  class: "footer-column-last",
  "data-testid": "footer-column"
}, Pz = ["href"], Dz = ["href"], Rz = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, Vz = ["href"], Bz = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, Fz = ["href"], jz = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, Uz = ["href"], Kz = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, Gz = ["href"], zz = ["innerHTML"];
function Zz(e, t, n, o, i, r) {
  return l(), h("footer", {
    id: "footer-f1",
    style: H(e.cssVars)
  }, [
    d("div", wz, [
      d("div", Tz, [
        d("div", kz, [
          e.content.hasLogo || e.isPreview ? (l(), h("img", {
            key: 0,
            src: e.logoImage,
            alt: "",
            class: "footer-logo"
          }, null, 8, Ez)) : g("", !0)
        ]),
        e.firstColumnHeader ? (l(), h("h2", {
          key: 0,
          class: p(e.theme.style)
        }, f(e.firstColumnHeader), 3)) : g("", !0),
        d("p", null, [
          e.info.name ? (l(), h("span", Sz, f(e.info.name), 1)) : g("", !0),
          e.info.address ? (l(), h("span", Mz, f(e.info.address), 1)) : g("", !0),
          e.info.city ? (l(), h("span", $z, f(e.info.city) + ", " + f(e.info.state) + " " + f(e.info.zip), 1)) : g("", !0),
          e.info.phone_number ? (l(), h("span", {
            key: 3,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
          }, null, 8, Iz)) : g("", !0),
          e.info.fax_number ? (l(), h("span", {
            key: 4,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
          }, null, 8, Az)) : g("", !0),
          e.info.email ? (l(), h("span", Lz, f(e.info.email), 1)) : g("", !0)
        ]),
        d("ul", null, [
          (l(!0), h(G, null, q(e.content.columns[0].items, (a, s) => (l(), h("li", { key: s }, [
            (l(), _(R(a.type), {
              item: a,
              theme: e.theme,
              class: p(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ]),
        e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (l(), h("div", {
          key: 1,
          class: "additional-text",
          innerHTML: e.content.additionalText
        }, null, 8, Oz)) : g("", !0)
      ]),
      (l(!0), h(G, null, q(e.theme.num_columns - 2, (a, s) => (l(), h("div", {
        key: s,
        class: "footer-columns",
        "data-testid": "footer-column"
      }, [
        e.content.columns[s + 1].hasHeader ? (l(), h("h2", {
          key: 0,
          class: p(e.theme.style)
        }, f(e.content.columns[s + 1].header), 3)) : g("", !0),
        s === 0 && e.content.columns[s + 1].showSchools ? (l(), h("ul", {
          key: 1,
          class: p({ "normal-window": !e.isIFrame })
        }, [
          (l(!0), h(G, null, q(e.organizations, (u, c) => (l(), h("li", { key: c }, [
            d("a", {
              href: r.orgLink(u)
            }, f(u.name), 9, Nz)
          ]))), 128))
        ], 2)) : g("", !0),
        d("ul", {
          class: p({ "normal-window": !e.isIFrame })
        }, [
          (l(!0), h(G, null, q(e.content.columns[s + 1].items, (u, c) => (l(), h("li", { key: c }, [
            (l(), _(R(u.type), {
              item: u,
              theme: e.theme,
              class: p(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ], 2)
      ]))), 128)),
      d("div", Hz, [
        d("h2", {
          class: p(e.theme.style)
        }, f(e.translations.stay_connected), 3),
        e.iosLink || e.isPreview ? (l(), h("a", {
          key: 0,
          href: e.iosLink,
          target: "_blank",
          "data-mobile-app": "ios"
        }, t[0] || (t[0] = [
          d("img", {
            class: "app-link",
            src: i0,
            alt: "Download our iOS App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, Pz)) : g("", !0),
        e.androidLink || e.isPreview ? (l(), h("a", {
          key: 1,
          href: e.androidLink,
          target: "_blank",
          "data-mobile-app": "android"
        }, t[1] || (t[1] = [
          d("img", {
            class: "app-link",
            src: s0,
            alt: "Download our Android App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, Dz)) : g("", !0),
        d("ul", {
          class: p(["footer-social-links", { "normal-window": !e.isIFrame }])
        }, [
          e.content.facebook || e.isPreview ? (l(), h("li", Rz, [
            d("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              d("img", {
                src: a0,
                alt: "Visit us on Facebook"
              }, null, -1)
            ]), 8, Vz)
          ])) : g("", !0),
          e.content.twitter || e.isPreview ? (l(), h("li", Bz, [
            d("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              d("img", {
                src: l0,
                alt: "Visit us on X, formerly Twitter"
              }, null, -1)
            ]), 8, Fz)
          ])) : g("", !0),
          e.content.youtube || e.isPreview ? (l(), h("li", jz, [
            d("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              d("img", {
                src: d0,
                alt: "Visit us on Youtube"
              }, null, -1)
            ]), 8, Uz)
          ])) : g("", !0),
          e.content.instagram || e.isPreview ? (l(), h("li", Kz, [
            d("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              d("img", {
                src: u0,
                alt: "Visit us on Instagram"
              }, null, -1)
            ]), 8, Gz)
          ])) : g("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (l(), h("div", {
      key: 0,
      class: "additional-text additional-text-bottom",
      innerHTML: e.content.additionalText
    }, null, 8, zz)) : g("", !0),
    d("div", {
      class: p(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      d("span", null, f(e.translations.copyright) + " © " + f(e.currentYear) + " " + f(e.copyrightOrg) + ". " + f(e.translations.all_rights_reserved), 1),
      d("span", null, [
        k(f(e.translations.powered_by) + " ", 1),
        t[6] || (t[6] = d("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          k("Apptegy "),
          d("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const Wz = /* @__PURE__ */ I(_z, [["render", Zz], ["__scopeId", "data-v-e45d0272"]]), qz = {
  name: "F2",
  mixins: [r0],
  computed: {
    showDownloadApps() {
      return this.content.hasApps || this.content.columns[2].showApps || this.isPreview;
    },
    showSocialMedia() {
      return this.content.hasSocial || this.content.columns[0].hasSocial || this.isPreview;
    },
    thirdColumnHeader() {
      return this.isPreview ? this.translations.stay_connected : this.content.columns[2].hasHeader ? this.content.columns[2].header : !1;
    }
  }
}, Yz = { class: "footer-wrapper" }, xz = { class: "logo" }, Xz = ["src"], Qz = {
  class: "download-links",
  "data-testid": "download-links"
}, Jz = {
  key: 1,
  class: "links-wrapper"
}, eZ = ["href"], tZ = ["href"], nZ = { class: "contact-data" }, oZ = {
  key: 0,
  class: "social-media"
}, rZ = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, iZ = ["href"], sZ = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, aZ = ["href"], lZ = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, dZ = ["href"], uZ = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, cZ = ["href"], hZ = { key: 0 }, mZ = { key: 1 }, pZ = { key: 2 }, fZ = { key: 3 }, gZ = ["innerHTML"], vZ = { key: 4 }, bZ = ["innerHTML"], yZ = { key: 5 }, CZ = ["innerHTML"];
function _Z(e, t, n, o, i, r) {
  return l(), h("footer", {
    id: "footer-f2",
    style: H(e.cssVars)
  }, [
    d("div", Yz, [
      d("div", xz, [
        e.content.hasLogo || e.isPreview ? (l(), h("img", {
          key: 0,
          src: e.logoImage,
          alt: "",
          class: "footer-logo"
        }, null, 8, Xz)) : g("", !0)
      ]),
      d("div", Qz, [
        r.thirdColumnHeader ? (l(), h("h2", {
          key: 0,
          class: p(`header ${e.theme.style}`)
        }, f(r.thirdColumnHeader), 3)) : g("", !0),
        r.showDownloadApps ? (l(), h("div", Jz, [
          e.iosLink || e.isPreview ? (l(), h("a", {
            key: 0,
            href: e.iosLink,
            target: "_blank",
            "data-mobile-app": "ios"
          }, t[0] || (t[0] = [
            d("img", {
              class: "app-icon",
              src: i0,
              alt: "Download our iOS App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, eZ)) : g("", !0),
          e.androidLink || e.isPreview ? (l(), h("a", {
            key: 1,
            href: e.androidLink,
            target: "_blank",
            "data-mobile-app": "android"
          }, t[1] || (t[1] = [
            d("img", {
              class: "app-icon",
              src: s0,
              alt: "Download our Android App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, tZ)) : g("", !0)
        ])) : g("", !0)
      ]),
      d("div", nZ, [
        r.showSocialMedia ? (l(), h("ul", oZ, [
          e.content.facebook || e.isPreview ? (l(), h("li", rZ, [
            d("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              d("img", {
                src: a0,
                alt: "Visit us on Facebook",
                class: "icon-img"
              }, null, -1)
            ]), 8, iZ)
          ])) : g("", !0),
          e.content.twitter || e.isPreview ? (l(), h("li", sZ, [
            d("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              d("img", {
                src: l0,
                alt: "Visit us on X, formerly Twitter",
                class: "icon-img"
              }, null, -1)
            ]), 8, aZ)
          ])) : g("", !0),
          e.content.youtube || e.isPreview ? (l(), h("li", lZ, [
            d("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              d("img", {
                src: d0,
                alt: "Visit us on Youtube",
                class: "icon-img"
              }, null, -1)
            ]), 8, dZ)
          ])) : g("", !0),
          e.content.instagram || e.isPreview ? (l(), h("li", uZ, [
            d("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              d("img", {
                src: u0,
                alt: "Visit us on Instagram",
                class: "icon-img"
              }, null, -1)
            ]), 8, cZ)
          ])) : g("", !0)
        ])) : g("", !0),
        e.firstColumnHeader ? (l(), h("h2", {
          key: 1,
          class: p(`header ${e.theme.style}`)
        }, f(e.firstColumnHeader), 3)) : g("", !0),
        d("div", {
          class: p(`info ${e.theme.style}`)
        }, [
          e.info.name ? (l(), h("span", hZ, f(e.info.name), 1)) : g("", !0),
          t[6] || (t[6] = k("  ")),
          e.info.address ? (l(), h("span", mZ, f(e.info.address), 1)) : g("", !0),
          t[7] || (t[7] = k("  ")),
          e.info.city ? (l(), h("span", pZ, f(e.info.city) + ", " + f(e.info.state) + " " + f(e.info.zip), 1)) : g("", !0),
          t[8] || (t[8] = d("br", null, null, -1)),
          e.info.phone_number ? (l(), h("span", fZ, [
            k(f(e.translations.phone_number) + ": ", 1),
            d("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
            }, null, 8, gZ)
          ])) : g("", !0),
          t[9] || (t[9] = k("  ")),
          e.info.fax_number ? (l(), h("span", vZ, [
            k(f(e.translations.fax_number) + ": ", 1),
            d("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
            }, null, 8, bZ)
          ])) : g("", !0),
          t[10] || (t[10] = k("  ")),
          e.info.email ? (l(), h("span", yZ, f(e.translations.email) + ": " + f(e.info.email), 1)) : g("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && !e.isPreview ? (l(), h("div", {
      key: 0,
      class: "additional-text",
      innerHTML: e.content.additionalText
    }, null, 8, CZ)) : g("", !0),
    d("div", {
      class: p(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      d("span", null, f(e.translations.copyright) + " © " + f(e.currentYear) + " " + f(e.copyrightOrg) + ". " + f(e.translations.all_rights_reserved), 1),
      d("span", null, [
        k(f(e.translations.powered_by) + " ", 1),
        t[11] || (t[11] = d("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          k("Apptegy "),
          d("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const wZ = /* @__PURE__ */ I(qz, [["render", _Z], ["__scopeId", "data-v-e681d8e1"]]), TZ = {
  name: "CmsFooter",
  components: {
    F1: Wz,
    F2: wZ,
    CustomHtml: Hi
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      default: () => []
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    themeVersion() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.version) == null ? void 0 : t.toLowerCase()) || "";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": T(this.theme, "bg_color.hex", "#ffffff"),
        "--separator-color": T(this.theme, "separator_color.hex", "#ffffff"),
        "--text-color": T(this.theme, "text_link_color.hex", "#000000"),
        "--apptegy-link-color": T(this.theme, "apptegy_link_color.hex", "#000000")
      };
    }
  }
};
function kZ(e, t, n, o, i, r) {
  const a = S("custom-html");
  return l(), h("div", null, [
    n.theme.version !== "CustomFooter" ? (l(), h("div", {
      key: 0,
      id: "cms-footer",
      style: H(r.cssVars)
    }, [
      (l(), _(R(n.theme.version), {
        theme: n.theme,
        content: n.content,
        organizations: n.organizations,
        "ios-link": n.iosLink,
        "android-link": n.androidLink,
        "is-preview": n.isPreview,
        "is-i-frame": n.isIFrame,
        "current-domain": n.currentDomain,
        logo: n.logo
      }, null, 8, ["theme", "content", "organizations", "ios-link", "android-link", "is-preview", "is-i-frame", "current-domain", "logo"]))
    ], 4)) : (l(), _(a, {
      key: 1,
      theme: n.theme
    }, null, 8, ["theme"]))
  ]);
}
const EZ = /* @__PURE__ */ I(TZ, [["render", kZ], ["__scopeId", "data-v-97861574"]]);
var SZ = di;
function MZ() {
  this.__data__ = new SZ(), this.size = 0;
}
var $Z = MZ;
function IZ(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var AZ = IZ;
function LZ(e) {
  return this.__data__.get(e);
}
var OZ = LZ;
function NZ(e) {
  return this.__data__.has(e);
}
var HZ = NZ, PZ = di, DZ = ea, RZ = Ru, VZ = 200;
function BZ(e, t) {
  var n = this.__data__;
  if (n instanceof PZ) {
    var o = n.__data__;
    if (!DZ || o.length < VZ - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new RZ(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var FZ = BZ, jZ = di, UZ = $Z, KZ = AZ, GZ = OZ, zZ = HZ, ZZ = FZ;
function go(e) {
  var t = this.__data__ = new jZ(e);
  this.size = t.size;
}
go.prototype.clear = UZ;
go.prototype.delete = KZ;
go.prototype.get = GZ;
go.prototype.has = zZ;
go.prototype.set = ZZ;
var WZ = go;
function qZ(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var YZ = qZ, xZ = Sn, XZ = function() {
  try {
    var e = xZ(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), QZ = XZ, au = QZ;
function JZ(e, t, n) {
  t == "__proto__" && au ? au(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var c0 = JZ, eW = c0, tW = Js, nW = Object.prototype, oW = nW.hasOwnProperty;
function rW(e, t, n) {
  var o = e[t];
  (!(oW.call(e, t) && tW(o, n)) || n === void 0 && !(t in e)) && eW(e, t, n);
}
var h0 = rW, iW = h0, sW = c0;
function aW(e, t, n, o) {
  var i = !n;
  n || (n = {});
  for (var r = -1, a = t.length; ++r < a; ) {
    var s = t[r], u = o ? o(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), i ? sW(n, s, u) : iW(n, s, u);
  }
  return n;
}
var Pi = aW;
function lW(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var dW = lW, uW = 9007199254740991, cW = /^(?:0|[1-9]\d*)$/;
function hW(e, t) {
  var n = typeof e;
  return t = t == null ? uW : t, !!t && (n == "number" || n != "symbol" && cW.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var m0 = hW, mW = dW, pW = qu, fW = En, gW = oa, vW = m0, bW = xu, yW = Object.prototype, CW = yW.hasOwnProperty;
function _W(e, t) {
  var n = fW(e), o = !n && pW(e), i = !n && !o && gW(e), r = !n && !o && !i && bW(e), a = n || o || i || r, s = a ? mW(e.length, String) : [], u = s.length;
  for (var c in e)
    (t || CW.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    vW(c, u))) && s.push(c);
  return s;
}
var p0 = _W, wW = p0, TW = zu, kW = pi;
function EW(e) {
  return kW(e) ? wW(e) : TW(e);
}
var Fa = EW, SW = Pi, MW = Fa;
function $W(e, t) {
  return e && SW(t, MW(t), e);
}
var IW = $W;
function AW(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var LW = AW, OW = on, NW = hi, HW = LW, PW = Object.prototype, DW = PW.hasOwnProperty;
function RW(e) {
  if (!OW(e))
    return HW(e);
  var t = NW(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !DW.call(e, o)) || n.push(o);
  return n;
}
var VW = RW, BW = p0, FW = VW, jW = pi;
function UW(e) {
  return jW(e) ? BW(e, !0) : FW(e);
}
var ja = UW, KW = Pi, GW = ja;
function zW(e, t) {
  return e && KW(t, GW(t), e);
}
var ZW = zW, ti = { exports: {} };
ti.exports;
(function(e, t) {
  var n = Ct, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function u(c, y) {
    if (y)
      return c.slice();
    var w = c.length, v = s ? s(w) : new c.constructor(w);
    return c.copy(v), v;
  }
  e.exports = u;
})(ti, ti.exports);
var WW = ti.exports;
function qW(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var YW = qW;
function xW(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = 0, r = []; ++n < o; ) {
    var a = e[n];
    t(a, n, e) && (r[i++] = a);
  }
  return r;
}
var XW = xW;
function QW() {
  return [];
}
var f0 = QW, JW = XW, eq = f0, tq = Object.prototype, nq = tq.propertyIsEnumerable, lu = Object.getOwnPropertySymbols, oq = lu ? function(e) {
  return e == null ? [] : (e = Object(e), JW(lu(e), function(t) {
    return nq.call(e, t);
  }));
} : eq, Ua = oq, rq = Pi, iq = Ua;
function sq(e, t) {
  return rq(e, iq(e), t);
}
var aq = sq;
function lq(e, t) {
  for (var n = -1, o = t.length, i = e.length; ++n < o; )
    e[i + n] = t[n];
  return e;
}
var g0 = lq, dq = Gu, uq = dq(Object.getPrototypeOf, Object), v0 = uq, cq = g0, hq = v0, mq = Ua, pq = f0, fq = Object.getOwnPropertySymbols, gq = fq ? function(e) {
  for (var t = []; e; )
    cq(t, mq(e)), e = hq(e);
  return t;
} : pq, b0 = gq, vq = Pi, bq = b0;
function yq(e, t) {
  return vq(e, bq(e), t);
}
var Cq = yq, _q = g0, wq = En;
function Tq(e, t, n) {
  var o = t(e);
  return wq(e) ? o : _q(o, n(e));
}
var y0 = Tq, kq = y0, Eq = Ua, Sq = Fa;
function Mq(e) {
  return kq(e, Sq, Eq);
}
var $q = Mq, Iq = y0, Aq = b0, Lq = ja;
function Oq(e) {
  return Iq(e, Lq, Aq);
}
var Nq = Oq, Hq = Object.prototype, Pq = Hq.hasOwnProperty;
function Dq(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Pq.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Rq = Dq, Vq = Ct, Bq = Vq.Uint8Array, Fq = Bq, du = Fq;
function jq(e) {
  var t = new e.constructor(e.byteLength);
  return new du(t).set(new du(e)), t;
}
var Ka = jq, Uq = Ka;
function Kq(e, t) {
  var n = t ? Uq(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Gq = Kq, zq = /\w*$/;
function Zq(e) {
  var t = new e.constructor(e.source, zq.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Wq = Zq, uu = ii, cu = uu ? uu.prototype : void 0, hu = cu ? cu.valueOf : void 0;
function qq(e) {
  return hu ? Object(hu.call(e)) : {};
}
var Yq = qq, xq = Ka;
function Xq(e, t) {
  var n = t ? xq(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Qq = Xq, Jq = Ka, eY = Gq, tY = Wq, nY = Yq, oY = Qq, rY = "[object Boolean]", iY = "[object Date]", sY = "[object Map]", aY = "[object Number]", lY = "[object RegExp]", dY = "[object Set]", uY = "[object String]", cY = "[object Symbol]", hY = "[object ArrayBuffer]", mY = "[object DataView]", pY = "[object Float32Array]", fY = "[object Float64Array]", gY = "[object Int8Array]", vY = "[object Int16Array]", bY = "[object Int32Array]", yY = "[object Uint8Array]", CY = "[object Uint8ClampedArray]", _Y = "[object Uint16Array]", wY = "[object Uint32Array]";
function TY(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case hY:
      return Jq(e);
    case rY:
    case iY:
      return new o(+e);
    case mY:
      return eY(e, n);
    case pY:
    case fY:
    case gY:
    case vY:
    case bY:
    case yY:
    case CY:
    case _Y:
    case wY:
      return oY(e, n);
    case sY:
      return new o();
    case aY:
    case uY:
      return new o(e);
    case lY:
      return tY(e);
    case dY:
      return new o();
    case cY:
      return nY(e);
  }
}
var kY = TY, EY = on, mu = Object.create, SY = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!EY(t))
      return {};
    if (mu)
      return mu(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), MY = SY, $Y = MY, IY = v0, AY = hi;
function LY(e) {
  return typeof e.constructor == "function" && !AY(e) ? $Y(IY(e)) : {};
}
var OY = LY, NY = mi, HY = Jn, PY = "[object Map]";
function DY(e) {
  return HY(e) && NY(e) == PY;
}
var RY = DY, VY = RY, BY = ra, pu = ia, fu = pu && pu.isMap, FY = fu ? BY(fu) : VY, jY = FY, UY = mi, KY = Jn, GY = "[object Set]";
function zY(e) {
  return KY(e) && UY(e) == GY;
}
var ZY = zY, WY = ZY, qY = ra, gu = ia, vu = gu && gu.isSet, YY = vu ? qY(vu) : WY, xY = YY, XY = WZ, QY = YZ, JY = h0, ex = IW, tx = ZW, nx = WW, ox = YW, rx = aq, ix = Cq, sx = $q, ax = Nq, lx = mi, dx = Rq, ux = kY, cx = OY, hx = En, mx = oa, px = jY, fx = on, gx = xY, vx = Fa, bx = ja, yx = 1, Cx = 2, _x = 4, C0 = "[object Arguments]", wx = "[object Array]", Tx = "[object Boolean]", kx = "[object Date]", Ex = "[object Error]", _0 = "[object Function]", Sx = "[object GeneratorFunction]", Mx = "[object Map]", $x = "[object Number]", w0 = "[object Object]", Ix = "[object RegExp]", Ax = "[object Set]", Lx = "[object String]", Ox = "[object Symbol]", Nx = "[object WeakMap]", Hx = "[object ArrayBuffer]", Px = "[object DataView]", Dx = "[object Float32Array]", Rx = "[object Float64Array]", Vx = "[object Int8Array]", Bx = "[object Int16Array]", Fx = "[object Int32Array]", jx = "[object Uint8Array]", Ux = "[object Uint8ClampedArray]", Kx = "[object Uint16Array]", Gx = "[object Uint32Array]", Ee = {};
Ee[C0] = Ee[wx] = Ee[Hx] = Ee[Px] = Ee[Tx] = Ee[kx] = Ee[Dx] = Ee[Rx] = Ee[Vx] = Ee[Bx] = Ee[Fx] = Ee[Mx] = Ee[$x] = Ee[w0] = Ee[Ix] = Ee[Ax] = Ee[Lx] = Ee[Ox] = Ee[jx] = Ee[Ux] = Ee[Kx] = Ee[Gx] = !0;
Ee[Ex] = Ee[_0] = Ee[Nx] = !1;
function Hr(e, t, n, o, i, r) {
  var a, s = t & yx, u = t & Cx, c = t & _x;
  if (n && (a = i ? n(e, o, i, r) : n(e)), a !== void 0)
    return a;
  if (!fx(e))
    return e;
  var y = hx(e);
  if (y) {
    if (a = dx(e), !s)
      return ox(e, a);
  } else {
    var w = lx(e), v = w == _0 || w == Sx;
    if (mx(e))
      return nx(e, s);
    if (w == w0 || w == C0 || v && !i) {
      if (a = u || v ? {} : cx(e), !s)
        return u ? ix(e, tx(a, e)) : rx(e, ex(a, e));
    } else {
      if (!Ee[w])
        return i ? e : {};
      a = ux(e, w, s);
    }
  }
  r || (r = new XY());
  var E = r.get(e);
  if (E)
    return E;
  r.set(e, a), gx(e) ? e.forEach(function(L) {
    a.add(Hr(L, t, n, L, e, r));
  }) : px(e) && e.forEach(function(L, U) {
    a.set(U, Hr(L, t, n, U, e, r));
  });
  var F = c ? u ? ax : sx : u ? bx : vx, O = y ? void 0 : F(e);
  return QY(O || e, function(L, U) {
    O && (U = L, L = e[U]), JY(a, U, Hr(L, t, n, U, e, r));
  }), a;
}
var zx = Hr, Zx = zx, Wx = 1, qx = 4;
function Yx(e) {
  return Zx(e, Wx | qx);
}
var xx = Yx;
const Xx = /* @__PURE__ */ Qn(xx), Di = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    programs: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    colors() {
      const e = this.sharedThemeColors(), t = T(this.theme, "box_bg_color.hex", "none"), n = `${t}cc`;
      return de(oe({}, e), {
        "--text-color": T(this.theme, "text_color.hex", "#fff"),
        "--hover-text-color": T(this.theme, "hover_text_color.hex", "initial"),
        "--box-bg-color": t,
        "--box-bg-color-opacity": n,
        "--hover-bg-color": T(this.theme, "hover_bg_color.hex", "initial"),
        "--hover-line-color": T(this.theme, "hover_line_color.hex", "initial"),
        "--title-color": T(this.theme, "title_color.hex", "--heading-color", "initial"),
        "--arrow-icon-color": T(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "initial"),
        "--program-image-border-color": T(
          this.theme,
          "program_image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--link-color": T(this.theme, "link_color.hex", "#0070E0")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.programs.component_header_top || this.isEditing);
    }
  }
}, Qx = {
  name: "P1",
  mixins: [Di],
  data() {
    return {
      hoverIndex: -1,
      editIdx: -1,
      descriptionTabIndex: -1
    };
  },
  computed: {
    getLinkFormData() {
      const e = Xx(this.programs.content[this.editIdx].link);
      return this.programs.read_more_link || (e.name = this.programs.content[this.editIdx].title), e;
    }
  },
  methods: {
    showLinkButton(e) {
      return this.hoverIndex === e && this.programs.read_more_link;
    },
    setHoverIndex(e) {
      this.hoverIndex = e;
    },
    async toggleVisibility(e, t) {
      this.isEditing || (t.preventDefault(), this.programs.details_on_hover && (this.hoverIndex = this.hoverIndex === e ? -1 : e, this.descriptionTabIndex = -1, await this.$nextTick(), this.$refs.programDescription[0] && this.$refs.programDescription[0].scrollHeight > this.$refs.programDescription[0].clientHeight && (this.descriptionTabIndex = 0, this.$refs.programDescription[0].focus({ showFocus: !0 }))));
    },
    closeOnBlur(e) {
      e.currentTarget.contains(e.relatedTarget) || (this.hoverIndex = -1);
    }
  }
}, Jx = ["data-testid"], eX = ["data-testid"], tX = ["tabindex", "aria-haspopup", "aria-labelledby", "aria-describedby", "role", "onKeydown", "onFocus", "onMouseover"], nX = ["src", "alt"], oX = {
  key: 1,
  class: "program-image"
}, rX = {
  key: 0,
  class: "hover-content"
}, iX = {
  class: "middle",
  role: "document"
}, sX = ["id"], aX = ["tabindex", "id"], lX = {
  key: 0,
  class: "program-link"
}, dX = {
  key: 1,
  maxlength: "26"
};
function uX(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "programs-p1",
    class: p(e.theme.style),
    style: H(e.colors)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.programs.component_header_top), 1)
            ], !0)
          ], 8, eX)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.programs.component_header), 1)
          ], !0)
        ], 8, Jx)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.programs.content,
      "onUpdate:modelValue": t[7] || (t[7] = (s) => e.programs.content = s),
      "item-key": "index",
      class: "programs-wrapper"
    }), {
      item: b(({ element: s, index: u }) => [
        d("div", {
          class: p([e.programs.num_columns === 3 ? "three-column" : "four-column", "program"])
        }, [
          C(e.$slots, "controls", { idx: u }, void 0, !0),
          d("div", {
            class: "image-wrapper image-border-accent",
            tabindex: e.programs.details_on_hover ? 0 : "",
            "aria-haspopup": !!e.programs.details_on_hover,
            "aria-labelledby": e.programs.details_on_hover && `dialog${u}Title`,
            "aria-describedby": e.programs.details_on_hover && `dialog${u}Desc`,
            role: e.programs.details_on_hover && "dialog",
            "data-testid": "program-content",
            onKeydown: [
              N(D((c) => r.toggleVisibility(u, c), ["exact"]), ["enter"]),
              N(D((c) => r.toggleVisibility(u, c), ["exact"]), ["space"])
            ],
            onFocus: (c) => r.toggleVisibility(u, c),
            onBlur: t[5] || (t[5] = (...c) => r.closeOnBlur && r.closeOnBlur(...c)),
            onMouseover: (c) => i.hoverIndex = u,
            onMouseleave: t[6] || (t[6] = (c) => i.hoverIndex = -1)
          }, [
            s.image.url ? (l(), h("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "program-image"
            }, null, 8, nX)) : (l(), h("div", oX)),
            d("div", {
              class: p([[
                e.theme.style,
                e.theme.text_background,
                {
                  "hover-enter": e.programs.details_on_hover && i.hoverIndex === u
                }
              ], "content-box"])
            }, [
              e.programs.details_on_hover && i.hoverIndex === u ? (l(), h("div", rX, [
                t[8] || (t[8] = d("div", { class: "top-bar" }, null, -1)),
                d("div", iX, [
                  d("div", {
                    class: p([e.theme.style, "title"])
                  }, [
                    s.link.url && !e.programs.read_more_link ? (l(), _(R(e.isEditing ? "div" : "a"), {
                      key: 0,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      id: `dialog${u}Title`,
                      onKeydown: [
                        t[0] || (t[0] = N((c) => r.setHoverIndex(-1), ["tab"])),
                        t[1] || (t[1] = N(D(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: b(() => [
                        C(e.$slots, "title", { idx: u }, () => [
                          k(f(s.title), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["href", "target", "id"])) : (l(), h("p", {
                      key: 1,
                      id: `dialog${u}Title`,
                      maxlength: "26"
                    }, [
                      C(e.$slots, "title", { idx: u }, () => [
                        k(f(s.title), 1)
                      ], !0)
                    ], 8, sX))
                  ], 2),
                  d("p", {
                    ref: "programDescription",
                    class: p([[{ editing: e.isEditing }, e.theme.style], "program-description"]),
                    tabindex: i.descriptionTabIndex,
                    id: `dialog${u}Desc`,
                    "aria-label": "program-description"
                  }, [
                    C(e.$slots, "description", { idx: u }, () => [
                      k(f(s.description), 1)
                    ], !0)
                  ], 10, aX),
                  r.showLinkButton(u) ? (l(), h("div", lX, [
                    (l(), _(R(e.isEditing ? "div" : "a"), {
                      "aria-label": s.link.name,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[2] || (t[2] = N((c) => r.setHoverIndex(-1), ["tab"])),
                        t[3] || (t[3] = N(D(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: b(() => [
                        C(e.$slots, "link", { idx: u }, () => [
                          k(f(s.link.name), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["aria-label", "href", "target"]))
                  ])) : g("", !0)
                ])
              ])) : (l(), h("div", {
                key: 1,
                class: p(["normal-content title", e.theme.style])
              }, [
                !e.programs.details_on_hover && s.link.url ? (l(), _(R(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: s.link.url,
                  target: s.link.opens_in_new_tab ? "_blank" : "",
                  onKeydown: t[4] || (t[4] = N(D(() => {
                  }, ["exact", "stop"]), ["enter"]))
                }, {
                  default: b(() => [
                    C(e.$slots, "title", { idx: u }, () => [
                      k(f(s.title), 1)
                    ], !0)
                  ]),
                  _: 2
                }, 1064, ["href", "target"])) : (l(), h("p", dX, [
                  C(e.$slots, "title", { idx: u }, () => [
                    k(f(s.title), 1)
                  ], !0)
                ]))
              ], 2))
            ], 2)
          ], 40, tX)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const cX = /* @__PURE__ */ I(Qx, [["render", uX], ["__scopeId", "data-v-8707d49d"]]), hX = {
  name: "P2",
  mixins: [Di],
  data() {
    return {
      direction: "forward",
      content: []
    };
  },
  computed: {
    seeAllURL() {
      return T(this.programs, "see_all_link.url", !1);
    },
    seeAll() {
      return this.programs.see_all && (!!this.seeAllURL || this.isEditing);
    },
    programRows() {
      let e = [[]];
      return this.programs.content.length > 0 && (e = this.content.slice(1).reduce(
        (t, n, o) => (this.isEditing || o % 4 !== 0 || o === 0 ? t[t.length - 1].push(n) : t.push([n]), t),
        [[]]
      )), this.programs.slider ? [e[0]] : e;
    },
    opensInNewTab() {
      return this.programs.see_all_link.opens_in_new_tab ? "_blank" : "";
    }
  },
  watch: {
    programs: {
      handler(e) {
        this.content = e.content.map((t, n) => de(oe({}, t), {
          idx: n
        }));
      },
      deep: !0,
      immediate: !0
    }
  },
  methods: {
    previous() {
      this.direction = "backward", this.$nextTick(() => {
        this.content.splice(0, 0, this.content.pop());
      });
    },
    next() {
      this.direction = "forward", this.$nextTick(() => {
        this.content.push(this.content.shift());
      });
    }
  }
}, mX = ["data-testid"], pX = ["data-testid"], fX = ["target", "href", "data-testid"], gX = { class: "main-program" }, vX = {
  key: 0,
  "data-testid": "component-header-top"
}, bX = ["data-testid"], yX = ["target", "href", "data-testid"], CX = { class: "main-program-text" }, _X = {
  key: 0,
  class: "purple arrows"
}, wX = {
  class: "left-arrow-button",
  role: "button"
}, TX = {
  class: "right-arrow-button",
  role: "button"
}, kX = {
  key: 0,
  class: "light-bold arrows"
}, EX = {
  class: "left-arrow-button",
  role: "button"
}, SX = {
  class: "right-arrow-button",
  role: "button"
}, MX = ["src", "alt"], $X = { class: "stacked-programs" }, IX = { class: "small-first-program" }, AX = { class: "aspect-ratio-box" }, LX = ["src", "alt"], OX = { class: "aspect-ratio-box" }, NX = ["src", "alt"], HX = { class: "aspect-ratio-box" }, PX = ["src", "alt"], DX = ["target", "href", "data-testid"];
function RX(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return e.programs.content.length > 0 ? (l(), h("div", {
    key: 0,
    id: "programs-v2",
    style: H(e.colors),
    class: p(e.theme.style),
    "data-testid": "p2"
  }, [
    e.screenSize <= 960 || e.theme.style === "purple" ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          class: p({ "no-border": !r.seeAll }),
          "data-testid": `header-${e.theme.style}-above`
        }, [
          e.displayHeaderTop ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.programs.component_header_top), 1)
            ], !0)
          ], 8, pX)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.programs.component_header), 1)
          ], !0)
        ], 10, mX)
      ]),
      default: b(() => [
        r.seeAll && e.screenSize > 600 && e.theme.style !== "purple" ? (l(), h("a", {
          key: 0,
          target: r.opensInNewTab,
          href: `${e.pathPrefix}${r.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-above`,
          onClick: t[0] || (t[0] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          k(f(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          C(e.$slots, "link", {}, void 0, !0)
        ], 8, fX)) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : g("", !0),
    d("div", gX, [
      d("div", {
        class: p(["main-program-left", e.theme.style])
      }, [
        e.screenSize > 960 && e.theme.style !== "purple" ? (l(), _(a, {
          key: 0,
          class: p([e.theme.style, "see-all-top"]),
          "theme-options": e.theme
        }, {
          header: b(() => [
            e.theme.style === "monterrey" && (e.programs.component_header_top || e.isEditing) ? (l(), h("h3", vX, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.programs.component_header_top), 1)
              ], !0)
            ])) : g("", !0),
            d("h2", {
              class: p({ "no-border": !r.seeAll }),
              "data-testid": `header-${e.theme.style}-top`
            }, [
              C(e.$slots, "header", {}, () => [
                k(f(e.programs.component_header), 1)
              ], !0)
            ], 10, bX)
          ]),
          default: b(() => [
            r.seeAll ? (l(), h("a", {
              key: 0,
              class: "hide-on-xs",
              target: r.opensInNewTab,
              href: `${e.pathPrefix}${r.seeAllURL}`,
              "data-testid": `see-all-${e.theme.style}-top`,
              onClick: t[1] || (t[1] = (s) => e.$emit("edit-see-all-link", s))
            }, [
              k(f(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
              C(e.$slots, "link", {}, void 0, !0)
            ], 8, yX)) : g("", !0)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : g("", !0),
        d("div", CX, [
          e.theme.style === "purple" && e.programs.slider ? (l(), h("div", _X, [
            d("div", wX, [
              (l(), h("svg", {
                class: "purple-left-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[2] || (t[2] = (...s) => r.previous && r.previous(...s))
              }, t[7] || (t[7] = [
                d("path", {
                  class: "arrow-stroke",
                  d: "M28 68.2969L3 35.6597L28 3.02245",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[8] || (t[8] = d("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            d("div", TX, [
              (l(), h("svg", {
                class: "purple-right-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[3] || (t[3] = (...s) => r.next && r.next(...s))
              }, t[9] || (t[9] = [
                d("path", {
                  class: "arrow-stroke",
                  d: "M3 3.01953L28 35.6567L3 68.294",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[10] || (t[10] = d("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ])) : g("", !0),
          $(ye, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: b(() => [
              (l(), h("h3", {
                key: i.content[0].idx,
                class: p([[e.theme.style, i.direction], "main program-title"])
              }, [
                i.content[0].link && i.content[0].link.url ? (l(), _(R(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: i.content[0].link.url,
                  target: i.content[0].link.opens_in_new_tab ? "_blank" : ""
                }, {
                  default: b(() => [
                    C(e.$slots, "title", {
                      idx: i.content[0].idx
                    }, () => [
                      k(f(i.content[0].title), 1)
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["href", "target"])) : C(e.$slots, "title", {
                  key: 1,
                  idx: i.content[0].idx
                }, () => [
                  k(f(i.content[0].title), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          }),
          $(ye, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: b(() => [
              (l(), h("p", {
                key: i.content[0].idx,
                class: p([[e.theme.style, i.direction], "main program-description"])
              }, [
                C(e.$slots, "description", {
                  idx: i.content[0].idx
                }, () => [
                  k(f(i.content[0].description), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          })
        ])
      ], 2),
      d("div", {
        class: p(["main-program-image", { editing: e.isEditing }])
      }, [
        C(e.$slots, "controls", {
          idx: i.content[0].idx
        }, void 0, !0),
        ["light", "bold", "monterrey", "sydney"].includes(e.theme.style) && e.programs.slider ? (l(), h("div", kX, [
          C(e.$slots, "main-controls", {}, () => [
            d("div", EX, [
              (l(), h("svg", {
                class: "left-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[4] || (t[4] = (...s) => r.previous && r.previous(...s))
              }, t[11] || (t[11] = [
                d("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M-6.10352e-05 0L63.9999 0L63.9999 64L-6.10352e-05 64L-6.10352e-05 0Z",
                  fill: "#014990"
                }, null, -1),
                d("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M26 32L38 19.5L36.5 18L22.9999 32.0428L36.5 46L38 44.5L26 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[12] || (t[12] = d("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            d("div", SX, [
              (l(), h("svg", {
                class: "right-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[5] || (t[5] = (...s) => r.next && r.next(...s))
              }, t[13] || (t[13] = [
                d("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M64.0001 64L5.34058e-05 64L5.90008e-05 -1.78036e-06L64.0001 3.8147e-06L64.0001 64Z",
                  fill: "#014990"
                }, null, -1),
                d("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M38 32L26 44.5L27.5 46L41.0001 31.9572L27.5 18L26 19.5L38 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[14] || (t[14] = d("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ], !0)
        ])) : g("", !0),
        $(ye, {
          appear: "",
          mode: "out-in",
          name: "fade-vertical"
        }, {
          default: b(() => [
            (l(), h("div", {
              key: i.content[0].idx,
              class: p([i.direction, "aspect-ratio-box main"])
            }, [
              d("img", {
                class: "image-border-accent",
                src: i.content[0].image.url,
                alt: i.content[0].image.alt_text,
                loading: "lazy"
              }, null, 8, MX)
            ], 2))
          ]),
          _: 1
        })
      ], 2)
    ]),
    d("ul", $X, [
      d("li", IX, [
        d("div", AX, [
          d("img", {
            class: "image-border-accent",
            src: i.content[0].image.url,
            alt: i.content[0].image.alt_text,
            loading: "lazy"
          }, null, 8, LX)
        ]),
        d("h3", {
          class: p([e.theme.style, "program-title"])
        }, [
          i.content[0].link && i.content[0].link.url ? (l(), _(R(e.isEditing ? "div" : "a"), {
            key: 0,
            href: i.content[0].link.url,
            target: i.content[0].link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: b(() => [
              C(e.$slots, "title", {
                idx: i.content[0].idx
              }, () => [
                k(f(i.content[0].title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : C(e.$slots, "title", {
            key: 1,
            idx: i.content[0].idx
          }, () => [
            k(f(i.content[0].title), 1)
          ], !0)
        ], 2),
        d("p", {
          class: p([e.theme.style, "program-description"])
        }, [
          C(e.$slots, "description", {
            idx: i.content[0].idx
          }, () => [
            k(f(i.content[0].description), 1)
          ], !0)
        ], 2)
      ]),
      (l(!0), h(G, null, q(i.content.slice(1), (s) => (l(), h("li", {
        key: s.idx,
        "data-testid": "programs-content"
      }, [
        d("div", OX, [
          C(e.$slots, "small-controls", {
            idx: s.idx
          }, void 0, !0),
          d("img", {
            src: s.image.url,
            alt: s.image.alt_text,
            class: "program-image image-border-accent",
            loading: "lazy"
          }, null, 8, NX)
        ]),
        d("h3", {
          class: p([e.theme.style, "program-title"])
        }, [
          s.link && s.link.url ? (l(), _(R(e.isEditing ? "div" : "a"), {
            key: 0,
            href: s.link.url,
            target: s.link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: b(() => [
              C(e.$slots, "title", {
                idx: i.content[0].idx
              }, () => [
                k(f(s.title), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"])) : C(e.$slots, "title", {
            key: 1,
            idx: i.content[0].idx
          }, () => [
            k(f(s.title), 1)
          ], !0)
        ], 2),
        d("p", {
          class: p([e.theme.style, "program-description"])
        }, [
          C(e.$slots, "description", {
            idx: i.content[0].idx
          }, () => [
            k(f(s.description), 1)
          ], !0)
        ], 2)
      ]))), 128))
    ]),
    d("div", null, [
      (l(!0), h(G, null, q(r.programRows, (s, u) => (l(), _(nn, {
        key: u + 1,
        tag: "ul",
        name: "program-row",
        class: p(["program-row", { "less-than-4": s.length < 4 }])
      }, {
        default: b(() => [
          (l(!0), h(G, null, q(s, (c) => (l(), h("li", {
            key: c.idx,
            class: p([i.direction, ["row-of-" + s.length]])
          }, [
            C(e.$slots, "controls", {
              idx: c.idx
            }, void 0, !0),
            d("div", HX, [
              d("img", {
                src: c.image.url,
                alt: c.image.alt_text,
                class: "program-image image-border-accent",
                loading: "lazy"
              }, null, 8, PX)
            ]),
            d("h3", {
              class: p([e.theme.style, "program-title"])
            }, [
              c.link && c.link.url ? (l(), _(R(e.isEditing ? "div" : "a"), {
                key: 0,
                href: c.link.url,
                target: c.link.opens_in_new_tab ? "_blank" : ""
              }, {
                default: b(() => [
                  C(e.$slots, "title", {
                    idx: c.idx
                  }, () => [
                    k(f(c.title), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : C(e.$slots, "title", {
                key: 1,
                idx: c.idx
              }, () => [
                k(f(c.title), 1)
              ], !0)
            ], 2),
            d("p", {
              class: p([e.theme.style, "program-description"])
            }, [
              C(e.$slots, "description", {
                idx: c.idx
              }, () => [
                k(f(c.description), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]),
    e.programs.see_all ? (l(), _(a, {
      key: 1,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        r.seeAll && (e.screenSize < 600 || e.theme.style === "purple") ? (l(), h("a", {
          key: 0,
          target: r.opensInNewTab,
          href: `${e.pathPrefix}${r.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[6] || (t[6] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          k(f(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          C(e.$slots, "link", {}, void 0, !0)
        ], 8, DX)) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6)) : g("", !0);
}
const VX = /* @__PURE__ */ I(hX, [["render", RX], ["__scopeId", "data-v-28b03eb0"]]), BX = {
  name: "P3",
  components: {
    CardSlider: It
  },
  mixins: [Di, We],
  computed: {
    content() {
      return this.programs.content;
    },
    sliderCenterSize() {
      return 600;
    },
    p3Colors() {
      return de(oe({}, this.colors), {
        "--heading-description-color": T(this.theme, "heading_description_color.hex", "#000000"),
        "--top-heading-color": T(this.theme, "top_heading_color.hex", "#000000"),
        "--card-1-bg-color": T(this.theme, "programs_card_1_bg_color.hex", "#4e0188"),
        "--card-1-heading-color": T(this.theme, "programs_card_1_heading_color.hex", "#ffffff"),
        "--card-1-text-color": T(this.theme, "programs_card_1_text_color.hex", "#ffffff"),
        "--card-1-box-color": T(this.theme, "programs_card_1_box_color.hex", "#ffffff"),
        "--card-2-bg-color": T(this.theme, "programs_card_2_bg_color.hex", "#86259C"),
        "--card-2-heading-color": T(this.theme, "programs_card_2_heading_color.hex", "#ffffff"),
        "--card-2-text-color": T(this.theme, "programs_card_2_text_color.hex", "#ffffff"),
        "--card-2-box-color": T(this.theme, "programs_card_2_box_color.hex", "#ffffff"),
        "--card-3-bg-color": T(this.theme, "programs_card_3_bg_color.hex", "#fcD40b"),
        "--card-3-heading-color": T(this.theme, "programs_card_3_heading_color.hex", "#131313"),
        "--card-3-text-color": T(this.theme, "programs_card_3_text_color.hex", "#131313"),
        "--card-3-box-color": T(this.theme, "programs_card_3_box_color.hex", "#ffffff"),
        "--card-4-bg-color": T(this.theme, "programs_card_4_bg_color.hex", "#b22785"),
        "--card-4-heading-color": T(this.theme, "programs_card_4_heading_color.hex", "#ffffff"),
        "--card-4-text-color": T(this.theme, "programs_card_4_text_color.hex", "#ffffff"),
        "--card-4-box-color": T(this.theme, "programs_card_4_box_color.hex", "#ffffff"),
        "--card-5-bg-color": T(this.theme, "programs_card_5_bg_color.hex", "#5e49ec"),
        "--card-5-heading-color": T(this.theme, "programs_card_5_heading_color.hex", "#ffffff"),
        "--card-5-text-color": T(this.theme, "programs_card_5_text_color.hex", "#000000"),
        "--card-5-box-color": T(this.theme, "programs_card_5_box_color.hex", "#ffffff")
      });
    }
  }
}, FX = { class: "header-wrapper" }, jX = {
  key: 0,
  "data-testid": "component-header-top",
  class: "header-top"
}, UX = {
  key: 0,
  class: "header-description",
  "data-testid": "header-description"
}, KX = ["data-testid", "aria-label"], GX = { class: "program-card-wrapper" }, zX = { class: "program-bottom-card" }, ZX = { class: "program-description" }, WX = ["innerHTML"];
function qX(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    id: "programs-v3",
    "data-testid": "P3",
    style: H(r.p3Colors),
    class: p([e.theme.style, { editing: e.isEditing }])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("div", FX, [
          d("div", null, [
            d("h2", null, [
              e.displayHeaderTop ? (l(), h("span", jX, [
                C(e.$slots, "header-top", {}, () => [
                  k(f(e.programs.component_header_top), 1)
                ], !0)
              ])) : g("", !0),
              C(e.$slots, "header", {}, () => [
                k(f(e.programs.component_header), 1)
              ], !0)
            ])
          ]),
          e.programs.component_header_description || e.isEditing ? (l(), h("div", UX, [
            C(e.$slots, "header-description", {}, () => [
              k(f(e.programs.component_header_description), 1)
            ], !0)
          ])) : g("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.programs.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        (l(), _(R(e.wrapperComponent), Ce({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.programs.content,
          "onUpdate:modelValue": t[0] || (t[0] = (u) => e.programs.content = u),
          class: [{ "all-cards-visible": e.allCardsVisible }, "programs-wrapper"],
          "item-key": "index"
        }), {
          item: b(({ element: u, index: c }) => [
            d("div", {
              ref: `sliderCard-${c}`,
              class: p(["program", `card-${c + 1}`, `card-style-${c % 5 + 1}`]),
              "data-testid": `programCard${c + 1}`,
              "aria-label": `${c + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              "data-attr": "program-content"
            }, [
              C(e.$slots, "controls", { idx: c }, void 0, !0),
              C(e.$slots, "image", { idx: c }, () => [
                (l(), _(R(u.image ? "img" : "div"), {
                  src: u.image.url,
                  alt: u.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0),
              d("div", GX, [
                d("div", zX, [
                  (l(), _(R(u.link && u.link.url && !e.isEditing ? "a" : "span"), {
                    href: u.link.url,
                    target: u.link.opens_in_new_tab ? "_blank" : null,
                    class: p(["program-title", { "is-editing": e.isEditing }])
                  }, {
                    default: b(() => [
                      C(e.$slots, "title", {
                        title: u.title,
                        idx: c
                      }, () => [
                        k(f(u.title), 1)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["href", "target", "class"])),
                  d("span", ZX, [
                    C(e.$slots, "description", {
                      title: u.description,
                      idx: c
                    }, () => [
                      d("span", {
                        class: "description-link",
                        innerHTML: u.description
                      }, null, 8, WX)
                    ], !0)
                  ])
                ])
              ])
            ], 10, KX)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const YX = /* @__PURE__ */ I(BX, [["render", qX], ["__scopeId", "data-v-c6e0bd97"]]), xX = {
  name: "P4",
  mixins: [Di],
  data() {
    return {
      activeItem: 0
    };
  },
  computed: {
    programsContent: {
      get() {
        return this.programs.content.slice(0, 5);
      },
      set(e) {
        this.programs.content = e;
      }
    },
    programsLength() {
      return this.programs.content.length;
    },
    cssVars() {
      return de(oe({}, this.colors), {
        "--active-headline-color": T(this.theme, "active_headline_color.hex", "#000000"),
        "--active-line-color": T(this.theme, "active_line_color.hex", "#000000"),
        "--headline-color": T(this.theme, "headline_color.hex", "#000000"),
        "--card-bg-color": T(this.theme, "card_bg_color.hex", "#FFFFFF"),
        "--card-border-color": T(this.theme, "card_border_color.hex", "#000000")
      });
    }
  },
  methods: {
    activateTab(e) {
      this.activeItem = e;
    },
    onKeyDown(e) {
      if (this.isEditing) return;
      const n = {
        ArrowLeft: this.focusPreviousTab,
        ArrowRight: this.focusNextTab,
        Home: this.focusFirstTab,
        End: this.focusLastTab
      }[e.key];
      n && n.call(this);
    },
    focusActiveTab() {
      this.$refs["tab-" + this.activeItem][0].focus();
    },
    focusPreviousTab() {
      this.activeItem > 0 ? this.activeItem -= 1 : this.activeItem = this.programsLength - 1, this.focusActiveTab();
    },
    focusNextTab() {
      this.activeItem < this.programsLength - 1 ? this.activeItem += 1 : this.activeItem = 0, this.focusActiveTab();
    },
    focusFirstTab() {
      this.activeItem = 0, this.focusActiveTab();
    },
    focusLastTab() {
      this.activeItem = this.programsLength - 1, this.focusActiveTab();
    }
  }
}, XX = { class: "columns-wrapper" }, QX = ["data-testid"], JX = { class: "column-1" }, eQ = ["data-testid"], tQ = ["data-testid"], nQ = ["id", "tabindex", "aria-selected", "aria-controls", "onClick"], oQ = { class: "column-2" }, rQ = ["id", "aria-labelledby"], iQ = { class: "program-card" }, sQ = { class: "card-title" }, aQ = {
  key: 0,
  class: "card-description"
}, lQ = ["innerHTML"];
function dQ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    class: p(["programs-v4", e.theme.style]),
    style: H(r.cssVars)
  }, [
    d("div", XX, [
      e.programs.has_header && e.isPurpleStyle ? (l(), _(a, {
        key: 0,
        class: p(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header", {}, () => [
              k(f(e.programs.component_header), 1)
            ])
          ], 8, QX)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : g("", !0),
      d("div", JX, [
        e.programs.has_header && !e.isPurpleStyle ? (l(), _(a, {
          key: 0,
          class: p(["see-all-top", e.theme.style]),
          "theme-options": e.theme
        }, {
          header: b(() => [
            d("h2", {
              "data-testid": `header-${e.theme.style}-top`
            }, [
              e.isMonterreyStyle ? (l(), h("span", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`,
                class: "header-top"
              }, [
                C(e.$slots, "header-top", {}, () => [
                  k(f(e.programs.component_header_top), 1)
                ])
              ], 8, tQ)) : g("", !0),
              C(e.$slots, "header", {}, () => [
                k(f(e.programs.component_header), 1)
              ])
            ], 8, eQ)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : g("", !0),
        (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
          modelValue: r.programsContent,
          "onUpdate:modelValue": t[1] || (t[1] = (s) => r.programsContent = s),
          class: ["programs-tabs", e.theme.style],
          role: "tablist",
          "item-key": "index",
          "aria-label": "programs-tabs"
        }), {
          item: b(({ element: s, index: u }) => [
            d("button", {
              id: `tab-${u}`,
              ref: `tab-${u}`,
              role: "tab",
              tabindex: String(i.activeItem === u ? 0 : -1),
              "aria-selected": String(i.activeItem === u),
              "aria-controls": `tabpanel-${u}`,
              class: p(["tab-button", { active: u === i.activeItem, [e.theme.style]: !0 }]),
              "data-testid": "tab-button",
              onClick: (c) => r.activateTab(u),
              onKeydown: t[0] || (t[0] = (c) => r.onKeyDown(c))
            }, [
              C(e.$slots, "drag"),
              C(e.$slots, "headline", { idx: u }, () => [
                k(f(s.headline), 1)
              ])
            ], 42, nQ)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      d("div", oQ, [
        (l(!0), h(G, null, q(r.programsContent, (s, u) => (l(), h("div", {
          key: u,
          id: ["tabpanel-" + u],
          "aria-labelledby": u,
          role: "tabpanel",
          class: p([{ active: u === i.activeItem }, "program-slide"]),
          "data-testid": "program-slide"
        }, [
          C(e.$slots, "controls", { idx: u }),
          C(e.$slots, "image", { idx: u }, () => [
            (l(), _(R(s.image.url ? "img" : "div"), {
              src: s.image.url,
              alt: s.image.alt_text,
              class: "program-image"
            }, null, 8, ["src", "alt"]))
          ]),
          d("div", iQ, [
            d("h2", sQ, [
              C(e.$slots, "title", { idx: u }, () => [
                k(f(s.title), 1)
              ])
            ]),
            e.programs.has_snippet ? (l(), h("div", aQ, [
              C(e.$slots, "description", {
                description: s.description,
                idx: u
              }, () => [
                d("span", {
                  innerHTML: s.description
                }, null, 8, lQ)
              ])
            ])) : g("", !0),
            e.programs.read_more_link ? (l(), _(R(e.isEditing ? "div" : "a"), {
              key: 1,
              class: "card-link",
              href: s.link.url,
              target: s.link.opens_in_new_tab ? "_blank" : ""
            }, {
              default: b(() => [
                C(e.$slots, "link", { idx: u }, () => [
                  k(f(s.link.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["href", "target"])) : g("", !0)
          ])
        ], 10, rQ))), 128))
      ])
    ])
  ], 6);
}
const uQ = /* @__PURE__ */ I(xX, [["render", dQ], ["__scopeId", "data-v-23dc4233"]]), cQ = {
  name: "Programs",
  components: {
    P1: cX,
    P2: VX,
    P3: YX,
    P4: uQ
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  }
};
function hQ(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    programs: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    onEditSeeAllLink: t[0] || (t[0] = (a) => {
      e.$emit("edit-see-all-link", a);
    })
  }, {
    "header-top": b(() => [
      C(e.$slots, "header-top")
    ]),
    header: b(() => [
      C(e.$slots, "header")
    ]),
    "header-description": b(() => [
      C(e.$slots, "header-description")
    ]),
    controls: b(({ idx: a }) => [
      C(e.$slots, "controls", { idx: a })
    ]),
    "main-controls": b(() => [
      C(e.$slots, "main-controls")
    ]),
    "small-controls": b(({ idx: a }) => [
      C(e.$slots, "small-controls", { idx: a })
    ]),
    image: b(({ idx: a }) => [
      C(e.$slots, "image", { idx: a })
    ]),
    link: b(({ idx: a }) => [
      C(e.$slots, "link", { idx: a })
    ]),
    title: b(({ title: a, idx: s }) => [
      C(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    description: b(({ description: a, idx: s }) => [
      C(e.$slots, "description", {
        description: a,
        idx: s
      })
    ]),
    headline: b(({ idx: a }) => [
      C(e.$slots, "headline", { idx: a })
    ]),
    drag: b(() => [
      C(e.$slots, "drag")
    ]),
    _: 3
  }, 40, ["theme", "programs", "wrapper-component", "wrapper-props", "is-editing"]);
}
const mQ = /* @__PURE__ */ I(cQ, [["render", hQ]]), pQ = ["regular", "pill"], fQ = (e) => (t) => e.includes(t), gQ = {
  name: "EventTag",
  props: {
    displayText: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: "regular",
      validator: fQ(pQ)
    },
    bgColor: {
      type: String,
      default: "#F3F3F3"
    },
    fontColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    text() {
      return this.variant === "pill" ? this.displayText : `| ${this.displayText}`;
    },
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--font-color": `${this.fontColor}CC`
      };
    }
  }
}, vQ = { class: "tag-tooltip tag-tooltip-bottom" }, bQ = { class: "tag-tooltip-text" };
function yQ(e, t, n, o, i, r) {
  return l(), h("div", vQ, [
    n.displayText ? (l(), h("div", {
      key: 0,
      style: H(r.cssVars),
      class: p([n.variant, "event-tag"])
    }, f(r.text), 7)) : g("", !0),
    d("div", bQ, f(n.displayText), 1)
  ]);
}
const CQ = /* @__PURE__ */ I(gQ, [["render", yQ], ["__scopeId", "data-v-c536c1f9"]]), Pn = {
  components: { EventTag: CQ },
  mixins: [Qe],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--date-color": T(this.theme, "date_color.hex", "initial"),
        "--date-bg-color": T(this.theme, "date_bg_color.hex", "initial"),
        "--time-color": T(this.theme, "time_color.hex", "initial"),
        "--location-color": T(this.theme, "location_color.hex", "initial"),
        "--bg-color": T(this.theme, "bg_color.hex", "#fff"),
        "--event-bg-color": T(this.theme, "event_bg_color.hex", "none"),
        "--event-title-color": T(this.theme, "event_title_color.hex", "initial"),
        "--event-separator-color": T(this.theme, "event_separator_color.hex", "#000"),
        "--event-border-color": T(this.theme, "event_border_color.hex", "#000"),
        event_section_tag_color: T(this.theme, "event_section_tag_color.hex", "#F3F3F3"),
        event_section_tag_text_color: T(this.theme, "event_section_tag_text_color.hex", "#fff"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "#fff"),
        "--event-arrow-color": T(this.theme, "event_arrow_color.hex", "#fff"),
        "--pager-color": T(this.theme, "pager_color.hex", "#fff"),
        "--event-bg-color-1": T(this.theme, "event_bg_color_1.hex", "#fff"),
        "--event-date-border-color": T(this.theme, "event_date_border_color.hex", "#fff"),
        "--event-bg-color-3": T(this.theme, "event_bg_color_3.hex", "#fff"),
        "--event-text-color-1": T(this.theme, "event_text_color_1.hex", "#fff"),
        "--event-text-color-3": T(this.theme, "event_text_color_3.hex", "#000"),
        "--percentage-date-opacity": `${(t = this.theme.percentage_date_opacity) != null ? t : 0}%`,
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : 0}%`
      });
    },
    timeColor() {
      return T(this.theme, "time_color.hex", "initial");
    },
    translations() {
      return this.options.translations || {};
    },
    isPurpleStyle() {
      return this.options.style === "purple";
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.href) || this.link("events");
    },
    seeAllLinkName() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    },
    visibleItems() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.num_rows) || 4;
    }
  },
  methods: {
    startDateMonth(e) {
      return e.split("from")[0].trim().split(" to ")[0].split(" ")[0];
    },
    startDateDay(e) {
      return e.split("from")[0].trim().split(" to ")[0].split(" ")[1];
    },
    endDateMonth(e) {
      const n = e.split("from")[0].trim().split(" to ");
      let o = "";
      const i = n[1] || "";
      return Ut(i) || (o = i.split(" ")), o[0];
    },
    endDateDay(e) {
      const n = e.split("from")[0].trim().split(" to ");
      let o = "";
      const i = n[1] || "";
      return Ut(i) || (o = i.split(" ")), o[1];
    },
    formatDateAndTime(e, t) {
      const n = e.split("from");
      return t === "date" ? n[0].replace("to", "—") : n[1].replace("to", "—").toUpperCase() !== "" ? n[1].replace("to", "—").toUpperCase() : this.translations.all_day;
    },
    displayEventTags(e) {
      return this.eventsConfig.display_tags && this.eventSectionName(e);
    },
    eventSectionName(e) {
      return e.sectionDisplayName || e.custom_section_name;
    }
  }
}, _Q = {
  name: "E1",
  mixins: [Pn],
  computed: {
    eventsOnHomepage() {
      return this.events.slice(0, 4);
    },
    lessThanFourEvents() {
      return this.eventsOnHomepage.length <= 3;
    }
  }
}, wQ = ["data-testid"], TQ = { class: "events-title-wrapper" }, kQ = ["href"], EQ = { class: "sr-only" }, SQ = {
  key: 0,
  class: "event-tag-wrapper"
};
function MQ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("event-tag");
  return l(), h("div", {
    id: "events-e1",
    style: H(e.colors),
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e1"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, wQ)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: p(["events-info", { "is-editing": e.isEditing }])
    }, [
      (l(!0), h(G, null, q(r.eventsOnHomepage, (u, c) => (l(), h("div", {
        key: `${c}-${u.title}`,
        class: p(["events-card grow events-accent-border", { "less-than-four-events": r.lessThanFourEvents }]),
        "data-testid": "events-content"
      }, [
        d("p", {
          class: p(["events-date", e.theme.style])
        }, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 3),
        d("p", {
          class: p(["events-time", e.theme.style])
        }, f(e.formatDateAndTime(u.cms_formatted_date, "time")), 3),
        d("div", TQ, [
          d("a", {
            href: e.link(`events?id=${u.id}`),
            "data-testid": "events-title",
            class: "events-title"
          }, [
            k(f(u.title) + " ", 1),
            d("span", EQ, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 1)
          ], 8, kQ)
        ]),
        e.displayEventTags(u) ? (l(), h("div", SQ, [
          $(s, {
            variant: "pill",
            "display-text": e.eventSectionName(u),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : g("", !0)
      ], 2))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const $Q = /* @__PURE__ */ I(_Q, [["render", MQ], ["__scopeId", "data-v-83332e23"]]), IQ = {
  name: "E2",
  mixins: [Pn]
}, AQ = ["data-testid"], LQ = { class: "events-date-and-time" }, OQ = { class: "events-title" }, NQ = ["href"], HQ = { class: "sr-only" }, PQ = {
  key: 0,
  class: "event-tag-wrapper"
};
function DQ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("event-tag");
  return l(), h("div", {
    id: "events-e2",
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    style: H(e.colors),
    "data-testid": "e2"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, AQ)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: p(["events-info", { "is-editing": e.isEditing }])
    }, [
      (l(!0), h(G, null, q(e.events.slice(0, 8), (u, c) => (l(), h("div", {
        key: `${c}-${u.title}`,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        d("p", LQ, [
          d("span", {
            class: p(["events-date", e.theme.style])
          }, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 3),
          d("span", {
            class: p(["events-time", e.theme.style])
          }, f(e.formatDateAndTime(u.cms_formatted_date, "time")), 3)
        ]),
        d("h3", OQ, [
          d("a", {
            href: e.isPreview ? void 0 : `${e.pathPrefix}/events?id=${u.id}`
          }, [
            k(f(u.title) + " ", 1),
            d("span", HQ, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 1)
          ], 8, NQ)
        ]),
        e.displayEventTags(u) ? (l(), h("div", PQ, [
          $(s, {
            variant: "pill",
            "display-text": e.eventSectionName(u),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : g("", !0)
      ]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const RQ = /* @__PURE__ */ I(IQ, [["render", DQ], ["__scopeId", "data-v-137bb0d0"]]), VQ = {
  name: "E3",
  mixins: [Pn],
  computed: {
    backgroundStyle() {
      return this.options.show_background_image ? {
        backgroundImage: `linear-gradient(${this.options.bg_color.hex}e6, ${this.options.bg_color.hex}e6), url(${T(
          this.eventsConfig,
          "background_image.url"
        )})`,
        backgroundSize: "cover"
      } : !1;
    }
  }
}, BQ = ["data-testid"], FQ = { class: "events-v3__events" }, jQ = ["href"], UQ = { class: "sr-only" }, KQ = { class: "events-v3__events__event__time" }, GQ = { class: "events-v3__footer" };
function zQ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("event-tag");
  return l(), h("div", {
    id: "events-v3",
    class: p([e.options.style, { "is-editing": e.isEditing }]),
    style: H([r.backgroundStyle, e.colors]),
    "data-testid": "e3"
  }, [
    d("div", {
      class: p(["events-v3__header__button", e.options.style])
    }, [
      $(a, {
        class: p([e.options.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": "see-all-top"
      }, {
        header: b(() => [
          e.isMonterreyStyle ? (l(), h("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, BQ)) : g("", !0),
          (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: b(() => [
              C(e.$slots, "header", {}, () => [
                k(f(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: b(() => [
          e.options.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
            key: 0,
            class: p(["hide-on-xs see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.options.style}-top`,
            onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ], 2),
    d("div", FQ, [
      (l(!0), h(G, null, q(e.events.slice(0, 4), (u, c) => (l(), h("div", {
        key: c,
        class: p(["events-v3__events__event grow", [e.options.style, { "is-editing": e.isEditing }]]),
        "data-testid": "events-content"
      }, [
        d("div", {
          class: p(["events-v3__events__event__date events-date", e.options.style])
        }, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 3),
        d("a", {
          href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${u.id}`,
          class: "events-v3__events__event__title"
        }, [
          k(f(u.title) + " ", 1),
          d("span", UQ, f(e.formatDateAndTime(u.cms_formatted_date, "date")), 1)
        ], 8, jQ),
        d("div", KQ, [
          k(f(e.formatDateAndTime(u.cms_formatted_date, "time")) + " ", 1),
          e.displayEventTags(u) ? (l(), _(s, {
            key: 0,
            "display-text": e.eventSectionName(u),
            "bg-color": e.timeColor
          }, null, 8, ["display-text", "bg-color"])) : g("", !0)
        ])
      ], 2))), 128))
    ]),
    d("div", GQ, [
      e.options.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
        key: 0,
        class: p([e.options.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.options.style}-bottom`
      }, {
        default: b(() => [
          (l(), _(R(e.isEditing ? "button" : "a"), {
            class: p(["see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
    ])
  ], 6);
}
const ZQ = /* @__PURE__ */ I(VQ, [["render", zQ], ["__scopeId", "data-v-5d19246e"]]), WQ = {
  name: "OriginalSliderButton",
  props: {
    iconColor: {
      type: String,
      default: "#000000"
    },
    translatedAria: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "left"
    }
  }
}, qQ = { class: "btn_content" }, YQ = {
  class: "normal",
  viewBox: "0 0 30 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xQ = ["fill"], XQ = ["fill"], QQ = {
  class: "hover",
  viewBox: "0 0 33 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JQ = ["fill"], eJ = ["fill"], tJ = { class: "sr-only" };
function nJ(e, t, n, o, i, r) {
  return l(), h("button", {
    class: p(["cards-slider-arrow", n.direction]),
    onClick: t[0] || (t[0] = (a) => e.$emit(`go-${n.direction}`))
  }, [
    d("span", qQ, [
      (l(), h("svg", YQ, [
        n.direction === "left" ? (l(), h("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M29.0391 68.4702C27.9511 69.3202 26.38 69.1273 25.5299 68.0392L0.529939 36.0392C-0.176646 35.1348 -0.176646 33.8654 0.529939 32.961L25.5299 0.961001C26.38 -0.127035 27.9511 -0.319974 29.0391 0.530047C30.1271 1.38008 30.3201 2.95119 29.4701 4.03923L5.67249 34.5001L29.4701 64.961C30.3201 66.049 30.1271 67.6201 29.0391 68.4702Z"
        }, null, 8, xQ)) : (l(), h("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.46088 0.53005C2.54891 -0.319977 4.12002 -0.127034 4.97005 0.961001L29.97 32.961C30.6766 33.8654 30.6766 35.1348 29.97 36.0392L4.97005 68.0392C4.12002 69.1273 2.54891 69.3202 1.46088 68.4702C0.372844 67.6201 0.179901 66.049 1.02993 64.961L24.8275 34.5001L1.02993 4.03922C0.179901 2.95119 0.372844 1.38008 1.46088 0.53005Z"
        }, null, 8, XQ))
      ])),
      (l(), h("svg", QQ, [
        n.direction === "left" ? (l(), h("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.4626 71.1523C29.7217 72.5123 27.208 72.2036 25.8479 70.4628L0.847911 38.4628C-0.282628 37.0157 -0.282628 34.9847 0.847911 33.5376L25.8479 1.53761C27.208 -0.20324 29.7217 -0.511948 31.4626 0.848091C33.2034 2.20814 33.5122 4.72191 32.1521 6.46277L9.07599 36.0002L32.1521 65.5376C33.5121 67.2785 33.2034 69.7922 31.4626 71.1523Z"
        }, null, 8, JQ)) : (l(), h("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.5376 0.84808C3.27846 -0.511963 5.79223 -0.203254 7.15228 1.5376L32.1523 33.5376C33.2828 34.9847 33.2828 37.0157 32.1523 38.4628L7.15228 70.4628C5.79223 72.2036 3.27846 72.5123 1.5376 71.1523C-0.203254 69.7922 -0.511963 67.2785 0.84808 65.5376L23.9242 36.0002L0.84808 6.46275C-0.511963 4.7219 -0.203254 2.20812 1.5376 0.84808Z"
        }, null, 8, eJ))
      ])),
      d("span", tJ, f(n.translatedAria), 1)
    ])
  ], 2);
}
const oJ = /* @__PURE__ */ I(WQ, [["render", nJ], ["__scopeId", "data-v-34444ce7"]]), rJ = {
  name: "Slider",
  components: { OriginalSliderButton: oJ },
  props: {
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: {
      type: Boolean
    },
    sectionHeader: {
      type: String,
      required: !0
    },
    hideXSmall: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    buttonStyles() {
      var e, t;
      return {
        "--background-color": ((t = (e = this.themeStyles) == null ? void 0 : e.arrow_background_color) == null ? void 0 : t.hex) || "#fff"
      };
    },
    arrowIconColor() {
      return T(this.themeStyles, "arrow_icon_color.hex", "#000");
    },
    nextSlideText() {
      return T(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return T(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, iJ = ["aria-label"];
function sJ(e, t, n, o, i, r) {
  const a = S("OriginalSliderButton");
  return l(), h("div", {
    "aria-label": n.sectionHeader,
    style: H(r.buttonStyles),
    class: p([{ "hide-x-small": n.hideXSmall }, "cards-slider"]),
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    C(e.$slots, "button-left", {}, () => [
      $(a, {
        direction: "left",
        "icon-color": r.arrowIconColor,
        "translated-aria": r.previousSlideText,
        onGoLeft: t[0] || (t[0] = (s) => e.$emit("scroll-left"))
      }, null, 8, ["icon-color", "translated-aria"])
    ]),
    C(e.$slots, "default"),
    C(e.$slots, "button-right", {}, () => [
      $(a, {
        direction: "right",
        "icon-color": r.arrowIconColor,
        "translated-aria": r.nextSlideText,
        onGoRight: t[1] || (t[1] = (s) => e.$emit("scroll-right"))
      }, null, 8, ["icon-color", "translated-aria"])
    ])
  ], 14, iJ);
}
const Ga = /* @__PURE__ */ I(rJ, [["render", sJ], ["__scopeId", "data-v-69aaa9fb"]]), aJ = {
  name: "E4",
  components: { Slider: Ga },
  mixins: [Pn, We],
  computed: {
    content() {
      return this.events;
    },
    eventsContent() {
      return this.isSliderShown ? this.content : this.content.slice(0, 4);
    },
    isSliderShown() {
      return this.screenSize > 960;
    },
    themeStyles() {
      var e, t;
      return de(oe({}, this.theme), {
        arrow_icon_color: { hex: ((t = (e = this.theme) == null ? void 0 : e.event_arrow_color) == null ? void 0 : t.hex) || "#000" }
      });
    }
  },
  methods: {
    isInRange(e, t) {
      return e >= t - 3 && e <= t + 3;
    },
    isTheLastOneInRange(e, t) {
      return e === t + 3;
    },
    isTheFirstOneInRange(e, t) {
      return e === t;
    },
    cardClassObj(e, t) {
      return {
        "events-card-hidden": !this.isInRange(e, t) && this.isSliderShown,
        "events-card-no-border": this.isTheLastOneInRange(e, t),
        "events-card-first": this.isTheFirstOneInRange(e, t)
      };
    }
  }
}, lJ = ["data-testid"], dJ = ["data-testid"], uJ = { class: "cards-slider-content" }, cJ = ["aria-label"], hJ = ["href"], mJ = { class: "sr-only" };
function pJ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("event-tag"), u = S("Slider"), c = Ne("touch");
  return l(), h("div", {
    id: "events-e4",
    style: H(e.colors),
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e4"
  }, [
    e.screenSize >= 600 && e.theme.style === "purple" ? (l(), _(a, {
      key: 0,
      "theme-options": e.theme,
      class: p(["see-all-above hide-on-xs", e.theme.style]),
      "data-testid": `header-${e.theme.style}-above`
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-above`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, lJ)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-above`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      _: 3
    }, 8, ["theme-options", "class", "data-testid"])) : g("", !0),
    d("div", {
      class: p(["events-info", e.theme.style])
    }, [
      e.theme.style !== "purple" || e.screenSize < 600 ? (l(), _(a, {
        key: 0,
        class: p([e.theme.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": `header-${e.theme.style}-top`
      }, {
        header: b(() => [
          e.isMonterreyStyle ? (l(), h("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, dJ)) : g("", !0),
          (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: b(() => [
              C(e.$slots, "header", {}, () => [
                k(f(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: b(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
            key: 0,
            class: p(["hide-on-xs see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (y) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options", "data-testid"])) : g("", !0),
      $(u, {
        "total-cards": r.content.length,
        "current-card": e.currentCard,
        "all-cards-visible": e.allCardsVisible,
        "section-header": e.sectionHeader,
        "theme-styles": r.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: b(() => [
          d("div", uJ, [
            d("div", {
              ref: "scrollWrapper",
              class: p([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-container"])
            }, [
              (l(!0), h(G, null, q(r.eventsContent, (y, w) => me((l(), h("div", {
                ref_for: !0,
                ref: `sliderCard-${w}`,
                key: w,
                class: p(["events-card", [e.theme.style, r.cardClassObj(w, e.currentCard), { "is-editing": e.isEditing }]]),
                "aria-label": `${w + 1} of ${r.content.length}`,
                role: "group",
                "aria-roledescription": "slide",
                "data-attr": "event-content",
                "data-testid": "events-content"
              }, [
                d("p", {
                  class: p(["events-date", e.theme.style])
                }, f(e.formatDateAndTime(y.cms_formatted_date, "date")), 3),
                d("a", {
                  class: p(["events-title", e.theme.style]),
                  href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${y.id}`
                }, [
                  k(f(y.title) + " ", 1),
                  d("span", mJ, f(e.formatDateAndTime(y.cms_formatted_date, "date")), 1)
                ], 10, hJ),
                d("p", {
                  class: p(["events-time", e.theme.style])
                }, [
                  k(f(e.formatDateAndTime(y.cms_formatted_date, "time")) + " ", 1),
                  e.displayEventTags(y) ? (l(), _(s, {
                    key: 0,
                    "display-text": e.eventSectionName(y),
                    "bg-color": e.timeColor
                  }, null, 8, ["display-text", "bg-color"])) : g("", !0)
                ], 2),
                t[2] || (t[2] = d("div", { class: "events-card-mobile-border-top" }, null, -1)),
                t[3] || (t[3] = d("div", { class: "events-card-mobile-border-right" }, null, -1))
              ], 10, cJ)), [
                [
                  c,
                  e.scrollRight,
                  "swipe",
                  { left: !0 }
                ],
                [
                  c,
                  e.scrollLeft,
                  "swipe",
                  { right: !0 }
                ]
              ])), 128))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
        key: 1,
        class: p([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: b(() => [
          (l(), _(R(e.isEditing ? "button" : "a"), {
            class: p(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (y) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              k(f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
    ], 2)
  ], 6);
}
const fJ = /* @__PURE__ */ I(aJ, [["render", pJ], ["__scopeId", "data-v-69eaae50"]]), gJ = {
  name: "E5",
  mixins: [Pn, We],
  components: { CardSlider: It },
  computed: {
    content() {
      return this.events.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    seeAllStyles() {
      return this.theme.style === "purple" ? "see-all-above" : "see-all-top";
    },
    cssVars() {
      return de(oe({}, this.colors), {
        "--event-bg-color-2": T(this.theme, "event_bg_color_2.hex", "#fff"),
        "--event-text-color-2": T(this.theme, "event_text_color_2.hex", "#000"),
        "--event-bg-color-4": T(this.theme, "event_bg_color_4.hex", "#fff"),
        "--event-text-color-4": T(this.theme, "event_text_color_4.hex", "#000")
      });
    }
  },
  methods: {
    iconAndTagColor(e) {
      return e + 1 > 4 ? this.cssVars[`--event-text-color-${(e + 1) % 4}`] : this.cssVars[`--event-text-color-${e + 1}`];
    }
  }
}, vJ = ["data-testid"], bJ = ["data-testid"], yJ = ["aria-label"], CJ = { class: "start-date" }, _J = {
  class: "date-month",
  "data-testid": "start-month"
}, wJ = {
  class: "date-day",
  "data-testid": "start-day"
}, TJ = { key: 0 }, kJ = {
  key: 1,
  class: "end-date"
}, EJ = {
  class: "date-month",
  "data-testid": "end-month"
}, SJ = {
  class: "date-day",
  "data-testid": "end-day"
}, MJ = ["href"], $J = { class: "time-section details" }, IJ = { class: "icon-wrapper" }, AJ = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LJ = ["stroke"], OJ = {
  key: 0,
  class: "location-section details"
}, NJ = { class: "icon-wrapper" }, HJ = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PJ = ["fill"], DJ = ["stroke"], RJ = {
  key: 1,
  class: "section-tag"
};
function VJ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    id: "events-e5",
    style: H(r.cssVars),
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e5"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, bJ)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, vJ)
      ]),
      default: b(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: p({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        d("div", {
          ref: "scrollWrapper",
          class: p(["events-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (l(!0), h(G, null, q(r.content, (u, c) => (l(), h("div", {
            key: c,
            ref_for: !0,
            ref: `sliderCard-${c}`,
            class: p(["card-content", `card-${c}`]),
            "aria-label": `${c + 1} of ${r.content.length}`,
            "data-testid": "events-content",
            role: "group",
            "aria-roledescription": "slide"
          }, [
            (l(), h("div", {
              key: `${c}-${u.title}`,
              class: p(["card events-card card-color", [e.theme.style, `card-color-${c % 4 + 1}`]]),
              "data-testid": "events-content-item"
            }, [
              d("div", {
                class: p(["events-date", e.theme.style])
              }, [
                d("div", CJ, [
                  d("div", _J, f(e.startDateMonth(u.cms_formatted_date)), 1),
                  d("div", wJ, f(e.startDateDay(u.cms_formatted_date)), 1)
                ]),
                e.endDateMonth(u.cms_formatted_date) ? (l(), h("div", TJ, "-")) : g("", !0),
                e.endDateMonth(u.cms_formatted_date) ? (l(), h("div", kJ, [
                  d("div", EJ, f(e.endDateMonth(u.cms_formatted_date)), 1),
                  d("div", SJ, f(e.endDateDay(u.cms_formatted_date)), 1)
                ])) : g("", !0)
              ], 2),
              d("a", {
                class: p(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${u.id}`
              }, f(u.title), 11, MJ),
              d("div", $J, [
                d("div", IJ, [
                  (l(), h("svg", AJ, [
                    d("path", {
                      d: "M11.5 12.381C11.5 12.5269 11.5638 12.6656 11.6746 12.7606L14.3413 15.0463C14.5509 15.226 14.8666 15.2017 15.0463 14.9921C15.226 14.7824 15.2017 14.4668 14.9921 14.287L12.5 12.151V8.66667C12.5 8.39052 12.2761 8.16667 12 8.16667C11.7239 8.16667 11.5 8.39052 11.5 8.66667V12.381ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z",
                      stroke: r.iconAndTagColor(c),
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, LJ)
                  ]))
                ]),
                d("p", {
                  class: p(["events-time", e.theme.style])
                }, f(e.formatDateAndTime(u.cms_formatted_date, "time")), 3)
              ]),
              u.venue ? (l(), h("div", OJ, [
                d("div", NJ, [
                  (l(), h("svg", HJ, [
                    d("rect", {
                      x: "12",
                      y: "11.125",
                      width: "1",
                      height: "9",
                      fill: r.iconAndTagColor(c)
                    }, null, 8, PJ),
                    d("circle", {
                      cx: "12.5",
                      cy: "6.625",
                      r: "5",
                      stroke: r.iconAndTagColor(c)
                    }, null, 8, DJ)
                  ]))
                ]),
                d("p", {
                  class: p(["events-location", e.theme.style])
                }, f(u.venue), 3)
              ])) : g("", !0),
              e.displayEventTags(u) ? (l(), h("div", RJ, f(e.eventSectionName(u)), 1)) : g("", !0),
              t[2] || (t[2] = d("div", { class: "events-card-mobile-border-top" }, null, -1)),
              t[3] || (t[3] = d("div", { class: "events-card-mobile-border-right" }, null, -1))
            ], 2))
          ], 10, yJ))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button see-all-events", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const BJ = /* @__PURE__ */ I(gJ, [["render", VJ], ["__scopeId", "data-v-7c4ee8fd"]]), FJ = {
  name: "E6",
  mixins: [Pn],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    content() {
      return this.events.slice(0, 6);
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    }
  },
  methods: {
    getFormattedDate(e) {
      const t = this.startDateMonth(e) || "", n = this.endDateMonth(e) || "", o = this.startDateDay(e) || "", i = this.endDateDay(e) || "", r = this.formatDateAndTime(e, "time") || "";
      return t === n && o === i ? r : `${t} ${o} - ${n} ${i} ${r}`;
    }
  }
}, jJ = ["data-testid"], UJ = ["data-testid"], KJ = {
  key: 0,
  class: "logo"
}, GJ = { class: "start-date" }, zJ = { class: "month" }, ZJ = { class: "date-number" }, WJ = { class: "details" }, qJ = { class: "event-title" }, YJ = ["href"], xJ = { class: "event-dates" }, XJ = { class: "event-location" };
function QJ(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    class: p(["events-e6", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: H(e.colors),
    "data-testid": "e6"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          r.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, UJ)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, jJ)
      ]),
      default: b(() => [
        !r.isPurpleStyle && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: "events-container",
      style: H(r.logoStyles)
    }, [
      n.logo ? (l(), h("div", KJ)) : g("", !0),
      d("div", {
        class: p(["events-wrapper", { "is-editing": e.isEditing }])
      }, [
        (l(!0), h(G, null, q(r.content, (s, u) => (l(), h("div", {
          key: `${u}-${s.title}`,
          class: "event-card",
          "data-testid": "events-content"
        }, [
          d("div", GJ, [
            d("div", zJ, f(e.startDateMonth(s.cms_formatted_date)), 1),
            d("div", ZJ, f(e.startDateDay(s.cms_formatted_date)), 1)
          ]),
          d("div", WJ, [
            d("div", qJ, [
              d("a", {
                class: p(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${s.id}`
              }, f(s.title), 11, YJ)
            ]),
            d("div", xJ, [
              t[2] || (t[2] = d("br", null, null, -1)),
              k(" " + f(r.getFormattedDate(s.cms_formatted_date)), 1)
            ]),
            d("div", XJ, f(s.venue), 1)
          ])
        ]))), 128))
      ], 2)
    ], 4),
    r.isPurpleStyle || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const JJ = /* @__PURE__ */ I(FJ, [["render", QJ], ["__scopeId", "data-v-53a7dd15"]]), eee = {
  name: "E7",
  mixins: [Pn],
  emits: ["open-modal"],
  methods: {
    getFormattedDate(e) {
      const t = this.startDateMonth(e) || "", n = this.endDateMonth(e) || "", o = this.startDateDay(e) || "", i = this.endDateDay(e) || "", r = this.formatDateAndTime(e, "time") || "";
      return t === n && o === i ? r : `${t} ${o} - ${n} ${i} | ${r}`;
    }
  }
}, tee = ["data-testid"], nee = ["data-testid"], oee = { class: "button-text" }, ree = { class: "month" }, iee = { class: "date-number" }, see = { class: "event-title" }, aee = ["href"], lee = {
  key: 1,
  class: "event-tag"
}, dee = { class: "button-text" };
function uee(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("EventTag");
  return l(), h("div", {
    class: p(["events-e7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: H(e.colors),
    "data-testid": "e7"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, nee)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, tee)
      ]),
      default: b(() => [
        !e.isMonterreyStyle && !e.isPurpleStyle && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            d("div", oee, f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: p(["events-info", { "is-editing": e.isEditing }])
    }, [
      (l(!0), h(G, null, q(e.events.slice(0, e.visibleItems), (u) => (l(), h("div", {
        key: u.id,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        d("div", {
          class: p(["events-date", e.theme.style])
        }, [
          d("div", ree, f(e.startDateMonth(u.cms_formatted_date)), 1),
          d("div", iee, f(e.startDateDay(u.cms_formatted_date)), 1)
        ], 2),
        d("div", {
          class: p(["events-description", e.theme.style])
        }, [
          d("div", see, [
            d("a", {
              class: p(["events-title", e.theme.style]),
              href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${u.id}`
            }, f(u.title), 11, aee)
          ]),
          d("div", {
            class: p(["events-time", e.theme.style])
          }, f(r.getFormattedDate(u.cms_formatted_date)), 3),
          u.venue ? (l(), h("div", {
            key: 0,
            class: p(["events-location", e.theme.style])
          }, f(u.venue), 3)) : g("", !0),
          e.displayEventTags(u) ? (l(), h("div", lee, [
            $(s, {
              variant: "pill",
              "display-text": e.eventSectionName(u),
              "bg-color": e.colors.event_section_tag_color,
              "font-color": e.colors.event_section_tag_text_color
            }, null, 8, ["display-text", "bg-color", "font-color"])
          ])) : g("", !0)
        ], 2)
      ]))), 128))
    ], 2),
    e.isMonterreyStyle || e.isPurpleStyle || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            d("div", dee, f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const cee = /* @__PURE__ */ I(eee, [["render", uee], ["__scopeId", "data-v-57846294"]]), hee = {
  name: "CmsEvents",
  components: {
    E1: $Q,
    E2: RQ,
    E3: ZQ,
    E4: fJ,
    E5: BJ,
    E6: JJ,
    E7: cee
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    },
    logo: {
      type: String,
      default: ""
    }
  }
}, mee = {
  id: "view-events",
  class: "view-events events-versions"
};
function pee(e, t, n, o, i, r) {
  return l(), h("div", mee, [
    (l(), _(R(n.options.version), {
      options: n.options,
      events: n.content,
      "is-preview": n.isPreview,
      "events-config": n.eventsConfig,
      "component-id": n.componentId,
      "path-prefix": n.pathPrefix,
      logo: n.logo,
      "is-editing": n.isEditing,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "events", "is-preview", "events-config", "component-id", "path-prefix", "logo", "is-editing"]))
  ]);
}
const fee = /* @__PURE__ */ I(hee, [["render", pee], ["__scopeId", "data-v-23ed585b"]]), un = {
  mixins: [Qe],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    posts: {
      type: Array,
      required: !0
    },
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      let t = T(this.theme, "link_card_bg_color.hex", "#fff");
      return t.startsWith("#") || (t = `#${t}`), de(oe({}, e), {
        "--top-heading-color": T(this.theme, "top_heading_color.hex", "#fff"),
        "--bottom-heading-color": T(this.theme, "bottom_heading_color.hex", "#fff"),
        "--header-accent-color": T(this.theme, "header_accent_color.hex", "#333"),
        "--button-border-color": T(this.theme, "button_border_color.hex", "#fff"),
        "--link-color": T(this.theme, "post_link_color.hex", "#0000ee"),
        "--time-and-author-color": T(this.theme, "time_and_author_text_color.hex", e["--heading-color"]),
        "--post-bg-color": T(this.theme, "post_bg_color.hex", "#dfdfdf"),
        "--post-text-color": T(this.theme, "post_text_color.hex", "#333"),
        "--panel-bg-color": T(this.theme, "panel_bg_color.hex", "#fff"),
        "--image-border-color": T(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--link-card-bg-color": t,
        "--arrow-border-color": T(this.theme, "arrow_border_color.hex", "#fff"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "#ffffff"),
        "--arrow-icon-color": T(this.theme, "arrow_icon_color.hex", "#ffffff"),
        "--pager-color": T(this.theme, "pager_color.hex", "#000"),
        "--time-color": T(this.theme, "time_color.hex", "#000"),
        "--author-color": T(this.theme, "author_text_color.hex", "#000")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("live-feed");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    openLightbox(e) {
      this.isIFrame || this.$emit("openLightbox", e);
    },
    saveFocusElement(e) {
      this.isIFrame || this.$emit("saveFocusElement", e.target);
    },
    onClickImage(e, t, n) {
      this.saveFocusElement(e), this.openLightbox({ images: t, idx: n });
    },
    clickSeeAllButton() {
      this.isIFrame || this.$router.push({ path: `${this.pathPrefix}/live-feed` });
    },
    viewImageText(e) {
      return e.live_feed_images.length > 1 ? this.translations.view_images : this.translations.view_image;
    },
    // Preferably we shouldn't render user-provided HTML
    // https://vuejs.org/v2/guide/syntax.html#Raw-HTML
    getPostContent(e, t) {
      const n = Ku(e.status, t), o = `
        <a aria-labelledby="LF-${e.id}" href="${this.pathPrefix}/live-feed#${e.id}">
          Read More
        </a>
      `;
      return n.endsWith("...") ? P9(n).concat(o) : n;
    }
  }
}, gee = {
  name: "LF1",
  mixins: [un],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  methods: {
    thumbnailImages(e) {
      return e.length > 4 ? e.slice(0, 3) : e;
    }
  }
}, vee = ["data-testid"], bee = { class: "live-feed-post-header" }, yee = ["src"], Cee = { class: "live-feed-author" }, _ee = ["aria-labelledby", "aria-posinset", "aria-setsize"], wee = ["id", "innerHTML"], Tee = ["onKeydown", "onClick"], kee = {
  class: "button-action-content",
  tabindex: "-1"
}, Eee = {
  key: 1,
  class: "thumbnails"
}, See = ["src", "alt", "onKeydown", "onClick"], Mee = ["onKeydown", "onClick"];
function $ee(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "LF1",
    class: p(e.theme.style),
    style: H(e.colors),
    "data-testid": "lf1",
    role: "feed"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, vee)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(!0), h(G, null, q(r.filteredPosts, (s, u) => (l(), h("div", {
      key: `${u}-${s.author}-LF`,
      class: p(["live-feed-post", [e.theme.style, { "is-editing": e.isEditing }]]),
      "data-testid": "live-feed-content"
    }, [
      d("div", bee, [
        d("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          loading: "lazy"
        }, null, 8, yee),
        d("span", Cee, f(s.author), 1),
        d("span", {
          class: p(["live-feed-time", e.theme.style])
        }, f(s.time_ago), 3)
      ]),
      d("div", {
        class: p(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": u + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        d("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, wee),
        !e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (l(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (c) => e.onClickImage(c, s.live_feed_images)
        }, [
          d("div", kee, f(e.viewImageText(s)), 1)
        ], 40, Tee)) : g("", !0),
        e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (l(), h("div", Eee, [
          (l(!0), h(G, null, q(r.thumbnailImages(s.live_feed_images), (c, y) => (l(), h("img", {
            key: `${c.id}`,
            tabindex: "0",
            class: "thumbnail",
            loading: "lazy",
            src: c.url,
            alt: c.alt_text,
            onKeydown: [
              N(D((w) => e.onClickImage(w, s.live_feed_images, y), ["exact", "prevent"]), ["enter"]),
              N(D((w) => e.onClickImage(w, s.live_feed_images, y), ["exact", "prevent"]), ["space"])
            ],
            onClick: (w) => e.onClickImage(w, s.live_feed_images, y)
          }, null, 40, See))), 128)),
          s.live_feed_images.length > 4 ? (l(), h("div", {
            key: 0,
            style: H({ "--lf-more-bg-image": `url(${s.live_feed_images[3].url})` }),
            tabindex: "0",
            class: "thumbnail more-images",
            onKeydown: [
              N(D((c) => e.onClickImage(c, s.live_feed_images, 3), ["exact", "prevent"]), ["enter"]),
              N(D((c) => e.onClickImage(c, s.live_feed_images, 3), ["exact", "prevent"]), ["space"])
            ],
            onClick: (c) => e.onClickImage(c, s.live_feed_images, 3)
          }, [
            d("span", null, "+ " + f(s.live_feed_images.length - 3), 1)
          ], 44, Mee)) : g("", !0)
        ])) : g("", !0)
      ], 10, _ee)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const Iee = /* @__PURE__ */ I(gee, [["render", $ee], ["__scopeId", "data-v-7efb4a64"]]), Aee = {
  name: "LF2",
  mixins: [un],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, Lee = ["data-testid"], Oee = { class: "live-feed-post-header" }, Nee = ["src"], Hee = { class: "live-feed-time-and-author" }, Pee = ["aria-labelledby", "aria-posinset", "aria-setsize"], Dee = ["id", "innerHTML"], Ree = ["onKeydown", "onClick"], Vee = {
  class: "button-action-content",
  tabindex: "-1"
};
function Bee(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "LF2",
    style: H(e.colors),
    class: p(e.theme.style),
    role: "feed"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Lee)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(!0), h(G, null, q(r.filteredPosts, (s, u) => (l(), h("div", {
      key: `${u}-${s.author}-LF`,
      class: p(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      d("div", Oee, [
        d("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          loading: "lazy"
        }, null, 8, Nee),
        d("span", Hee, f(s.time_ago) + ", " + f(s.author), 1)
      ]),
      d("div", {
        class: p(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": u + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        d("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, Dee),
        e.isPreview || s.live_feed_images.length > 0 ? (l(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (c) => e.onClickImage(c, s.live_feed_images)
        }, [
          d("div", Vee, f(e.viewImageText(s)), 1)
        ], 40, Ree)) : g("", !0)
      ], 10, Pee)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const Fee = /* @__PURE__ */ I(Aee, [["render", Bee], ["__scopeId", "data-v-21aa1e11"]]), jee = {
  name: "LF3",
  mixins: [un],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, Uee = ["data-testid"], Kee = { class: "live-feed-post-header" }, Gee = ["src"], zee = { class: "live-feed-time-and-author" }, Zee = ["aria-labelledby", "aria-posinset", "aria-setsize"], Wee = ["id", "innerHTML"], qee = ["onKeydown", "onClick"], Yee = {
  class: "button-action-content",
  tabindex: "-1"
};
function xee(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "LF3",
    style: H(e.colors),
    class: p(e.theme.style),
    role: "feed"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Uee)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(!0), h(G, null, q(r.filteredPosts, (s, u) => (l(), h("div", {
      key: `${u}-${s.author}-LF`,
      class: p(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      d("div", Kee, [
        d("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          loading: "lazy"
        }, null, 8, Gee),
        d("span", zee, f(s.time_ago) + ", " + f(s.author), 1)
      ]),
      d("div", {
        class: p(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": u + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        d("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, Wee),
        e.isPreview || s.live_feed_images.length > 0 ? (l(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (c) => e.onClickImage(c, s.live_feed_images)
        }, [
          d("div", Yee, f(e.viewImageText(s)), 1)
        ], 40, qee)) : g("", !0)
      ], 10, Zee)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const Xee = /* @__PURE__ */ I(jee, [["render", xee], ["__scopeId", "data-v-d1ca18d8"]]), Qee = {
  name: "LF4",
  mixins: [un],
  data() {
    return {
      displayImage: "",
      displayImageAlt: ""
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  mounted() {
    this.setDisplayImage();
  },
  methods: {
    setImage(e) {
      if (e.live_feed_images.length >= 1) {
        this.displayImage = e.live_feed_images[0].url, this.displayImageAlt = e.live_feed_images[0].alt_text;
        return;
      }
      this.setDisplayImage();
    },
    setDisplayImage() {
      var e, t, n, o, i, r;
      this.displayImage = ((n = (t = (e = this.filteredPosts[0]) == null ? void 0 : e.live_feed_images) == null ? void 0 : t[0]) == null ? void 0 : n.url) || this.fallbackImage.url, this.displayImageAlt = ((r = (i = (o = this.filteredPosts[0]) == null ? void 0 : o.live_feed_images) == null ? void 0 : i[0]) == null ? void 0 : r.alt_text) || "";
    }
  }
}, Jee = { class: "LF4__container" }, ete = ["data-testid"], tte = { class: "LF4__posts__container-images" }, nte = ["src", "alt"], ote = ["onMouseover"], rte = { class: "LF4__posts__container__post__avatar" }, ite = ["src"], ste = { class: "LF4__posts__container__post__info" }, ate = { class: "live-feed-time" }, lte = ["aria-labelledby", "aria-posinset", "aria-setsize"], dte = ["id", "innerHTML"], ute = ["onKeydown", "onClick"], cte = {
  class: "button-action-content",
  tabindex: "-1"
}, hte = { class: "LF4__posts__image" }, mte = ["src", "alt"];
function pte(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "LF4",
    style: H(e.colors),
    class: p(e.theme.style),
    role: "feed"
  }, [
    d("div", Jee, [
      d("div", {
        class: p([e.theme.style, "LF4__posts"])
      }, [
        d("div", {
          class: p(["LF4__posts__container", e.theme.style])
        }, [
          $(a, {
            class: p([e.theme.style, "see-all-top"]),
            "theme-options": e.theme
          }, {
            header: b(() => [
              e.isMonterreyStyle ? (l(), h("h3", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`
              }, [
                C(e.$slots, "header-top", {}, () => [
                  k(f(e.sectionHeaderTop), 1)
                ], !0)
              ], 8, ete)) : g("", !0),
              (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
                "data-testid": `header-${e.theme.style}-top`
              }, {
                default: b(() => [
                  C(e.$slots, "header", {}, () => [
                    k(f(e.sectionHeader), 1)
                  ], !0)
                ]),
                _: 3
              }, 8, ["data-testid"]))
            ]),
            default: b(() => [
              e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
                key: 0,
                class: p(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-top`,
                onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
              }, {
                default: b(() => [
                  k(f(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
            ]),
            _: 3
          }, 8, ["class", "theme-options"]),
          d("div", tte, [
            d("img", {
              class: "LF4__posts__container-images__image",
              src: i.displayImage,
              alt: i.displayImageAlt,
              loading: "lazy"
            }, null, 8, nte)
          ]),
          (l(!0), h(G, null, q(r.filteredPosts, (s, u) => (l(), h("div", {
            key: `${u}-${s.author}-LF`,
            class: p([[e.theme.style, { "is-editing": e.isEditing }], "LF4__posts__container__post"]),
            "data-testid": "live-feed-content",
            onMouseover: (c) => r.setImage(s)
          }, [
            d("div", rte, [
              d("img", {
                src: s.avatar,
                alt: ""
              }, null, 8, ite)
            ]),
            d("div", ste, [
              d("div", {
                class: p([e.theme.style, "LF4__posts__container__post__info__time-author"])
              }, [
                k(f(s.author) + ", ", 1),
                d("span", ate, f(s.time_ago), 1)
              ], 2),
              d("div", {
                class: p([e.theme.style, "live-feed-details"]),
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${s.id}`,
                "aria-posinset": u + 1,
                "aria-setsize": r.filteredPosts.length
              }, [
                d("div", {
                  id: `LF-${s.id}`,
                  class: p(["LF4__posts__container__post__info__text", e.theme.style]),
                  innerHTML: e.getPostContent(s)
                }, null, 10, dte),
                e.isPreview || s.live_feed_images.length > 0 ? (l(), h("button", {
                  key: 0,
                  class: "view-images button-action",
                  "data-testid": "live-feed-images-button",
                  "aria-haspopup": "true",
                  onKeydown: [
                    N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                    N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: (c) => e.onClickImage(c, s.live_feed_images)
                }, [
                  d("div", cte, f(e.viewImageText(s)), 1)
                ], 40, ute)) : g("", !0)
              ], 10, lte)
            ])
          ], 42, ote))), 128)),
          (e.isEditing || e.posts.length > 4) && (e.theme.style !== "bold" || e.screenSize < 600) ? (l(), _(a, {
            key: 0,
            class: p([e.theme.style, "see-all-bottom"]),
            "theme-options": e.theme,
            "data-testid": "see-all-bottom"
          }, {
            default: b(() => [
              (l(), _(R(e.isEditing ? "button" : "a"), {
                class: p(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-bottom`,
                onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
              }, {
                default: b(() => [
                  k(f(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"]))
            ]),
            _: 1
          }, 8, ["class", "theme-options"])) : g("", !0)
        ], 2),
        d("div", hte, [
          d("img", {
            class: "LF4__posts__image__img",
            src: i.displayImage,
            alt: i.displayImageAlt
          }, null, 8, mte)
        ])
      ], 2)
    ])
  ], 6);
}
const fte = /* @__PURE__ */ I(Qee, [["render", pte], ["__scopeId", "data-v-8101e82c"]]), gte = {
  name: "LF5",
  mixins: [un],
  data() {
    return {
      active: null,
      collapsedSibling: null
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 3);
    }
  },
  methods: {
    setActiveCard(e) {
      this.active = e;
      const t = Math.min(window.innerWidth, document.documentElement.clientWidth);
      if (t > 600 && t < 1281 || this.isPreview && t > 1080 && t < 1441) {
        this.collapsedSibling = e === 0 ? 1 : 0;
        return;
      }
      e < 2 ? this.collapsedSibling = e + 1 : e === 2 && (this.collapsedSibling = 1);
    }
  }
}, vte = ["data-testid"], bte = { class: "live-feed--post-container" }, yte = ["onMouseenter"], Cte = { class: "live-feed--card-description" }, _te = { class: "live-feed--card-description--icon" }, wte = ["src"], Tte = { class: "live-feed-time" }, kte = ["aria-labelledby", "aria-posinset", "aria-setsize"], Ete = ["id", "innerHTML"], Ste = ["onKeydown", "onClick"], Mte = {
  class: "button-action-content",
  tabindex: "-1"
}, $te = { class: "live-feed--card-image" }, Ite = ["src", "alt"];
function Ate(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "live-feed-lf5",
    class: p(e.theme.style),
    style: H(e.colors),
    role: "feed"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, vte)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", bte, [
      (l(!0), h(G, null, q(r.filteredPosts, (s, u) => (l(), h("div", {
        key: `${u}-${s.author}-LF`,
        class: p(["live-feed--card", [{ collapsed: u === i.collapsedSibling }, { "is-editing": e.isEditing }]]),
        "data-testid": "live-feed-content",
        onMouseenter: (c) => r.setActiveCard(u),
        onMouseleave: t[1] || (t[1] = (c) => {
          i.active = null, i.collapsedSibling = null;
        })
      }, [
        d("div", Cte, [
          d("div", _te, [
            d("img", {
              src: s.avatar,
              alt: "",
              loading: "lazy"
            }, null, 8, wte)
          ]),
          d("div", {
            class: p(["live-feed--card-description--header", e.theme.style])
          }, [
            d("span", null, [
              k(f(s.author) + " - ", 1),
              d("span", Tte, f(s.time_ago), 1)
            ])
          ], 2),
          d("div", {
            class: p([e.theme.style, "live-feed-details"]),
            role: "article",
            tabindex: "0",
            "aria-labelledby": `LF-${s.id}`,
            "aria-posinset": u + 1,
            "aria-setsize": r.filteredPosts.length
          }, [
            d("div", {
              id: `LF-${s.id}`,
              class: p(["live-feed--card-description--content", e.theme.style]),
              innerHTML: e.getPostContent(s, 120)
            }, null, 10, Ete),
            e.isPreview || s.live_feed_images.length > 0 ? (l(), h("button", {
              key: 0,
              class: "view-images button-action",
              "aria-haspopup": "true",
              onKeydown: [
                N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                N(D((c) => e.onClickImage(c, s.live_feed_images), ["exact", "prevent"]), ["space"])
              ],
              onClick: (c) => e.onClickImage(c, s.live_feed_images)
            }, [
              d("div", Mte, f(e.viewImageText(s)), 1)
            ], 40, Ste)) : g("", !0)
          ], 10, kte)
        ]),
        d("div", $te, [
          d("img", {
            src: s.live_feed_images.length > 0 ? s.live_feed_images[0].url : e.fallbackImage.url,
            alt: s.live_feed_images.length > 0 ? s.live_feed_images[0].alt_text : "",
            loading: "lazy"
          }, null, 8, Ite)
        ])
      ], 42, yte))), 128))
    ]),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[2] || (t[2] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const Lte = /* @__PURE__ */ I(gte, [["render", Ate], ["__scopeId", "data-v-168586e4"]]), Ote = {
  name: "LF6Buttons",
  props: {
    arrowColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    previousSlideText: {
      type: String,
      default: ""
    },
    nextSlideText: {
      type: String,
      default: ""
    }
  }
}, Nte = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
}, Hte = ["aria-label"], Pte = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dte = ["stroke"], Rte = ["aria-label"], Vte = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bte = ["stroke"];
function Fte(e, t, n, o, i, r) {
  return l(), h("div", Nte, [
    d("button", {
      class: "button",
      style: H({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.previousSlideText,
      onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left")),
      onKeyup: t[1] || (t[1] = N((a) => e.$emit("scroll-left"), ["left"]))
    }, [
      (l(), h("svg", Pte, [
        d("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Dte)
      ]))
    ], 44, Hte),
    d("button", {
      class: "button mirror",
      style: H({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.nextSlideText,
      onClick: t[2] || (t[2] = (a) => e.$emit("scroll-right")),
      onKeyup: t[3] || (t[3] = N((a) => e.$emit("scroll-right"), ["right"]))
    }, [
      (l(), h("svg", Vte, [
        d("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Bte)
      ]))
    ], 44, Rte)
  ]);
}
const jte = /* @__PURE__ */ I(Ote, [["render", Fte], ["__scopeId", "data-v-a0941050"]]);
function Ute(e, t, n) {
  var o = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var r = Array(i); ++o < i; )
    r[o] = e[o + t];
  return r;
}
var Kte = Ute, Gte = Js, zte = pi, Zte = m0, Wte = on;
function qte(e, t, n) {
  if (!Wte(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? zte(n) && Zte(t, n.length) : o == "string" && t in n) ? Gte(n[t], e) : !1;
}
var Yte = qte, xte = Uu, Xte = 1 / 0, Qte = 17976931348623157e292;
function Jte(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = xte(e), e === Xte || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * Qte;
  }
  return e === e ? e : 0;
}
var ene = Jte, tne = ene;
function nne(e) {
  var t = tne(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var one = nne, rne = Kte, ine = Yte, sne = one, ane = Math.ceil, lne = Math.max;
function dne(e, t, n) {
  (n ? ine(e, t, n) : t === void 0) ? t = 1 : t = lne(sne(t), 0);
  var o = e == null ? 0 : e.length;
  if (!o || t < 1)
    return [];
  for (var i = 0, r = 0, a = Array(ane(o / t)); i < o; )
    a[r++] = rne(e, i, i += t);
  return a;
}
var une = dne;
const cne = /* @__PURE__ */ Qn(une), hne = {
  name: "LF6",
  components: {
    Pager: na,
    LFButtons: jte
  },
  mixins: [un, We],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    sliderCenterSize() {
      return this.screenSize;
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    },
    nextSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.next_slide) || "Next slide";
    },
    previousSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.previous_slide) || "Previous slide";
    },
    content() {
      return cne(this.posts, 3);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    getGalleryType(e) {
      const t = e.live_feed_images.length;
      return t > 4 ? "cols-4 overflow" : `cols-${t}`;
    },
    goToCard(e) {
      this.currentCard = e - 1, this.calculateScroll();
    },
    handleFocusChange(e) {
      e !== this.currentCard && (this.currentCard = e, this.calculateScroll());
    },
    setCardHeight() {
      if (this.isEditing)
        return;
      this.$refs.scrollWrapper.style.minHeight = "auto";
      const e = Math.max(
        ...Array.from(this.content.length).map((n, o) => this.$refs[`sliderCard-${o}`].offsetHeight)
      ), t = this.content.length <= 2 ? 48 : 0;
      this.$refs.scrollWrapper.style.minHeight = `${e + t}px`;
    }
  }
}, mne = ["data-testid"], pne = ["data-testid"], fne = { class: "controls" }, gne = ["aria-label"], vne = ["id", "aria-label", "onFocusin"], bne = ["id"], yne = { class: "header" }, Cne = ["src"], _ne = { class: "time-author" }, wne = ["aria-labelledby", "aria-posinset", "aria-setsize"], Tne = ["id", "innerHTML"], kne = ["data-see-more", "aria-label", "onClick"], Ene = ["src"];
function Sne(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("LFButtons"), u = S("Pager");
  return l(), h("div", {
    id: "LF6",
    class: p([e.theme.style, { "is-editing": e.isEditing }]),
    style: H(e.colors),
    "data-testid": "lf6",
    role: "feed"
  }, [
    $(a, {
      class: p(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, pne)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, mne)
      ]),
      default: b(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": "see-all-bold-top",
          onClick: t[0] || (t[0] = (c) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: "slider-container",
      style: H(r.logoStyles)
    }, [
      d("div", fne, [
        $(a, {
          class: p(e.theme.style),
          "theme-options": e.theme,
          "data-testid": "lf-link"
        }, {
          default: b(() => [
            e.theme.style !== "bold" || e.screenSize <= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
              key: 0,
              class: p([e.theme.style, "see-all-button"]),
              href: e.seeAllLinkHref,
              target: e.seeAllLinkTarget,
              "data-testid": `see-all-${e.theme.style}-button`,
              onClick: t[1] || (t[1] = (c) => e.$emit("open-modal"))
            }, {
              default: b(() => [
                k(f(e.seeAllLinkName), 1)
              ]),
              _: 1
            }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
          ]),
          _: 1
        }, 8, ["class", "theme-options"]),
        d("div", {
          "aria-label": e.sectionHeader,
          role: "region",
          "aria-roledescription": "carousel",
          class: "control-actions-wrapper"
        }, [
          $(s, {
            "arrow-color": e.theme.arrow_icon_color.hex,
            "background-color": e.theme.arrow_background_color.hex,
            "border-color": e.theme.arrow_border_color.hex,
            "previous-slide-text": r.previousSlideText,
            "next-slide-text": r.nextSlideText,
            onScrollLeft: e.scrollLeft,
            onScrollRight: e.scrollRight
          }, null, 8, ["arrow-color", "background-color", "border-color", "previous-slide-text", "next-slide-text", "onScrollLeft", "onScrollRight"]),
          $(u, {
            "total-cards": r.content.length,
            "pager-color": e.theme.pager_color.hex,
            "theme-styles": e.theme,
            "current-card": e.currentCard,
            "pager-section-count": r.content.length,
            class: "pager",
            onGoToSection: r.goToCard
          }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count", "onGoToSection"])
        ], 8, gne)
      ]),
      d("div", {
        ref: "scrollWrapper",
        class: p(["slider", { "is-editing": e.isEditing }])
      }, [
        (l(!0), h(G, null, q(r.content, (c, y) => (l(), h("div", {
          id: `slide-${y}`,
          key: y,
          ref_for: !0,
          ref: `sliderCard-${y}`,
          class: p(`slide slide-${y} ${y === e.currentCard && "active"}`),
          "aria-label": `${y + 1} of ${r.content.length}`,
          "data-testid": "live-feed-content",
          role: "group",
          "aria-roledescription": "slide",
          onFocusin: (w) => r.handleFocusChange(y)
        }, [
          (l(!0), h(G, null, q(c, (w, v) => (l(), h("div", {
            id: v,
            key: v,
            class: "post"
          }, [
            d("div", yne, [
              d("img", {
                src: w.avatar,
                class: "avatar",
                alt: "",
                loading: "lazy"
              }, null, 8, Cne),
              d("span", _ne, f(w.author) + " | " + f(w.time_ago), 1)
            ]),
            d("div", {
              class: "details",
              role: "article",
              tabindex: "0",
              "aria-labelledby": `LF-${w.id}`,
              "aria-posinset": v + 1,
              "aria-setsize": c.length
            }, [
              d("div", {
                id: `LF-${w.id}`,
                class: "post-content",
                innerHTML: e.getPostContent(w, 200)
              }, null, 8, Tne),
              w.live_feed_images.length ? (l(), h("div", {
                key: 0,
                class: p(["gallery", r.getGalleryType(w)])
              }, [
                (l(!0), h(G, null, q(w.live_feed_images, (E, F) => (l(), h("button", {
                  key: `gallery-item-${F}`,
                  "data-see-more": w.live_feed_images.length > 4 && `+ ${w.live_feed_images.length - 4}`,
                  "aria-label": e.translations.open_image_in_modal,
                  class: "gallery-item",
                  onClick: (O) => e.onClickImage(O, w.live_feed_images)
                }, [
                  d("img", {
                    class: "gallery-image",
                    src: E.url,
                    alt: "",
                    loading: "lazy"
                  }, null, 8, Ene)
                ], 8, kne))), 128))
              ], 2)) : g("", !0)
            ], 8, wne)
          ], 8, bne))), 128))
        ], 42, vne))), 128))
      ], 2)
    ], 4)
  ], 6);
}
const Mne = /* @__PURE__ */ I(hne, [["render", Sne], ["__scopeId", "data-v-5c832164"]]), $ne = {
  name: "LF7",
  components: { CardSlider: It },
  mixins: [un, We],
  computed: {
    content() {
      return this.posts.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    }
  },
  methods: {
    extraImagesContent(e) {
      return e.live_feed_images.length > 4 ? `+ ${e.live_feed_images.length - 3}` : "";
    },
    backgroundImage(e, t) {
      return {
        backgroundImage: `url("${e.live_feed_images[t].url}")`
      };
    }
  }
}, Ine = ["data-testid"], Ane = ["data-testid"], Lne = ["aria-label"], One = { class: "post live-feed-details" }, Nne = { class: "post-info" }, Hne = ["src"], Pne = { class: "author" }, Dne = { class: "time-ago" }, Rne = ["id", "innerHTML"], Vne = { class: "thumbnails-wrapper" }, Bne = ["aria-label", "data-before", "data-testid", "onClick"];
function Fne(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    class: p(["live-feed-lf7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: H(e.colors),
    "data-testid": "lf7"
  }, [
    $(a, {
      class: p(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          r.isMonterreyStyle ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Ane)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.sectionHeader), 1)
          ], !0)
        ], 8, Ine)
      ]),
      default: b(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: p({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        d("div", {
          ref: "scrollWrapper",
          class: p(["posts-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (l(!0), h(G, null, q(r.content, (u, c) => (l(), h("div", {
            key: `${u}-${c}`,
            ref_for: !0,
            ref: `sliderCard-${c}`,
            class: p(["card-content", `card-${c}`]),
            "data-testid": "live-feed-content",
            "aria-label": `${c + 1} of ${r.content.length}`,
            role: "group",
            "aria-roledescription": "slide"
          }, [
            d("div", One, [
              d("div", Nne, [
                d("img", {
                  src: u.avatar,
                  loading: "lazy"
                }, null, 8, Hne),
                d("div", Pne, f(u.author), 1),
                t[2] || (t[2] = d("span", null, "|", -1)),
                d("div", Dne, f(u.time_ago), 1)
              ]),
              d("div", {
                id: `LF-${u.id}`,
                class: "post-status",
                innerHTML: e.getPostContent(u)
              }, null, 8, Rne),
              d("div", Vne, [
                (l(!0), h(G, null, q(u.live_feed_images.slice(0, 4), (y, w) => (l(), h("button", {
                  key: y.id + w,
                  class: "live-feed-image-thumbnail",
                  "aria-label": e.translations.open_image_in_modal,
                  "data-before": r.extraImagesContent(u),
                  style: H(r.backgroundImage(u, w)),
                  "data-testid": `live-feed-images-button-${w}`,
                  onClick: (v) => e.$emit("openLightbox", { images: u.live_feed_images, idx: w })
                }, null, 12, Bne))), 128))
              ])
            ])
          ], 10, Lne))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
  ], 6);
}
const jne = /* @__PURE__ */ I($ne, [["render", Fne], ["__scopeId", "data-v-d0a250b4"]]), Une = {
  name: "ImageGallery",
  props: {
    images: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      activeItem: 0
    };
  },
  methods: {
    activateItem(e) {
      this.activeItem = e;
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.images.length && (e = 0), this.activeItem = e;
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.images.length - 1), this.activeItem = e;
    },
    handleImageClick(e) {
      this.$emit("image-click", { e });
    }
  }
}, Kne = {
  class: "image-gallery",
  "data-testid": "image-gallery"
}, Gne = {
  key: 0,
  class: "gallery-image"
}, zne = ["src", "alt"], Zne = {
  key: 0,
  class: "gallery-controls"
}, Wne = { class: "indicators" }, qne = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
};
function Yne(e, t, n, o, i, r) {
  return l(), h("div", Kne, [
    d("div", {
      class: "gallery-track",
      onClick: t[0] || (t[0] = (a) => r.handleImageClick(a))
    }, [
      t[3] || (t[3] = d("div", {
        class: "gallery-overlay",
        "data-testid": "gallery-overlay"
      }, null, -1)),
      (l(!0), h(G, null, q(n.images, (a, s) => (l(), h("div", {
        key: a.id + s,
        class: p(["gallery-slide", i.activeItem === s && "is-active"]),
        "data-testid": "gallery-slide"
      }, [
        a.url ? (l(), h("div", Gne, [
          d("img", {
            src: a.url,
            alt: a.alt_text
          }, null, 8, zne)
        ])) : g("", !0)
      ], 2))), 128))
    ]),
    n.images.length > 1 ? (l(), h("div", Zne, [
      d("div", Wne, f(i.activeItem + 1) + " / " + f(n.images.length), 1),
      d("div", qne, [
        d("button", {
          class: "button left",
          "aria-label": "button prev",
          onClick: t[1] || (t[1] = (...a) => r.activatePrev && r.activatePrev(...a))
        }, t[4] || (t[4] = [
          d("svg", null, [
            d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ])),
        d("button", {
          class: "button right",
          "aria-label": "button next",
          onClick: t[2] || (t[2] = (...a) => r.activateNext && r.activateNext(...a))
        }, t[5] || (t[5] = [
          d("svg", null, [
            d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]))
      ])
    ])) : g("", !0)
  ]);
}
const xne = /* @__PURE__ */ I(Une, [["render", Yne], ["__scopeId", "data-v-49126e1d"]]), Xne = {
  name: "LF8",
  components: { Slider: Ga, ImageGallery: xne },
  mixins: [un, We],
  computed: {
    content() {
      return this.posts;
    },
    sliderCenterSize() {
      return 599;
    },
    cssVars() {
      var e, t;
      return de(oe({}, this.colors), {
        "--percentage-button-opacity": `${(e = this.theme.percentage_button_opacity) != null ? e : 0}%`,
        "--image-gradient-color": T(this.theme, "image_gradient_color.hex", "#000000"),
        "--image-gradient-opacity": `${(t = this.theme.image_gradient_opacity) != null ? t : 80}%`,
        "--indicators-color": T(this.theme, "indicators_color.hex", "#FFFFFF"),
        "--arrow-color": T(this.theme, "arrow_color.hex", "#FFFFFF"),
        "--button-border-color": T(this.theme, "button_border_color.hex", "#FFFFFF")
      });
    }
  }
}, Qne = { class: "wrapper" }, Jne = ["data-testid"], eoe = ["data-testid"], toe = { class: "button-text" }, noe = {
  ref: "scrollWrapper",
  class: "cards-wrapper"
}, ooe = ["aria-label"], roe = ["aria-labelledby", "aria-posinset", "aria-setsize"], ioe = { class: "card-header" }, soe = ["src"], aoe = { class: "author" }, loe = { class: "time-ago" }, doe = ["id", "innerHTML"], uoe = {
  key: 0,
  class: "card-gallery"
}, coe = {
  class: "buttons-container",
  role: "group",
  "aria-label": "slide controls"
}, hoe = { class: "button-text" };
function moe(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("ImageGallery"), u = S("Slider");
  return l(), h("div", {
    class: p(["live-feed-lf8", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: H(r.cssVars),
    "data-testid": "lf8",
    role: "feed"
  }, [
    d("div", Qne, [
      $(a, {
        class: p(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (l(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, eoe)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ], 8, Jne)
        ]),
        default: b(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
            key: 0,
            class: p(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (c) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              d("div", toe, f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      $(u, {
        "current-card": e.currentCard,
        class: p(["slider", { "is-editing": e.isEditing }]),
        "total-cards": r.content.length,
        "theme-styles": e.theme,
        "section-header": e.sectionHeader,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        "button-left": b(() => [
          d("button", {
            class: "slider-button left",
            "aria-label": "button prev",
            onKeyup: t[1] || (t[1] = N((...c) => e.scrollLeft && e.scrollLeft(...c), ["left"])),
            onClick: t[2] || (t[2] = (...c) => e.scrollLeft && e.scrollLeft(...c))
          }, t[10] || (t[10] = [
            d("svg", null, [
              d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        "button-right": b(() => [
          d("button", {
            class: "slider-button right",
            "aria-label": "button next",
            onKeyup: t[3] || (t[3] = N((...c) => e.scrollRight && e.scrollRight(...c), ["right"])),
            onClick: t[4] || (t[4] = (...c) => e.scrollRight && e.scrollRight(...c))
          }, t[11] || (t[11] = [
            d("svg", null, [
              d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        default: b(() => [
          d("div", noe, [
            (l(!0), h(G, null, q(r.content, (c, y) => (l(), h("div", {
              key: `${c}-${y}`,
              ref_for: !0,
              ref: `sliderCard-${y}`,
              class: p(["card", `card-${y}`]),
              "data-testid": "live-feed-content",
              "aria-label": `${y + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              d("div", {
                class: "card-content",
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${c.id}`,
                "aria-posinset": y + 1,
                "aria-setsize": r.content.length
              }, [
                d("div", ioe, [
                  d("img", {
                    src: c.avatar,
                    loading: "lazy"
                  }, null, 8, soe),
                  d("div", aoe, f(c.author), 1),
                  d("div", loe, f(c.time_ago), 1)
                ]),
                d("div", {
                  id: `LF-${c.id}`,
                  class: "card-description",
                  innerHTML: e.getPostContent(c)
                }, null, 8, doe)
              ], 8, roe),
              c.live_feed_images.length >= 1 && e.screenSize > 600 ? (l(), h("div", uoe, [
                $(s, {
                  images: c.live_feed_images,
                  onImageClick: (w) => e.onClickImage(w, c.live_feed_images)
                }, null, 8, ["images", "onImageClick"])
              ])) : g("", !0)
            ], 10, ooe))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "class", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft"]),
      d("div", coe, [
        d("button", {
          class: "slider-button left",
          "aria-label": "button prev",
          onKeyup: t[5] || (t[5] = N((...c) => e.scrollLeft && e.scrollLeft(...c), ["left"])),
          onClick: t[6] || (t[6] = (...c) => e.scrollLeft && e.scrollLeft(...c))
        }, t[12] || (t[12] = [
          d("svg", null, [
            d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32),
        d("button", {
          class: "slider-button right",
          "aria-label": "button next",
          onKeyup: t[7] || (t[7] = N((...c) => e.scrollRight && e.scrollRight(...c), ["right"])),
          onClick: t[8] || (t[8] = (...c) => e.scrollRight && e.scrollRight(...c))
        }, t[13] || (t[13] = [
          d("svg", null, [
            d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32)
      ]),
      e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
        key: 0,
        class: p([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: b(() => [
          (l(), _(R(e.isEditing ? "button" : "a"), {
            class: p(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[9] || (t[9] = (c) => e.$emit("open-modal"))
          }, {
            default: b(() => [
              d("div", hoe, f(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : g("", !0)
    ])
  ], 6);
}
const poe = /* @__PURE__ */ I(Xne, [["render", moe], ["__scopeId", "data-v-7cecc041"]]), foe = {
  name: "LiveFeed",
  components: {
    LF1: Iee,
    LF2: Fee,
    LF3: Xee,
    LF4: fte,
    LF5: Lte,
    LF6: Mne,
    LF7: jne,
    LF8: poe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean,
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    openLightbox(e) {
      this.$emit("toggleLightbox", e);
    },
    saveFocusElement(e) {
      this.$emit("savePrevFocusedElem", e);
    }
  }
}, goe = { id: "cms-live-feed" };
function voe(e, t, n, o, i, r) {
  return l(), h("div", goe, [
    (l(), _(R(n.theme.version), {
      theme: n.theme,
      posts: n.content,
      "livefeed-config": n.livefeedConfig,
      "component-id": n.componentId,
      "fallback-image": n.fallbackImage,
      "path-prefix": n.pathPrefix,
      "is-preview": n.isPreview,
      "is-i-frame": n.isIFrame,
      "is-editing": n.isEditing,
      logo: n.logo,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal")),
      onSaveFocusElement: t[1] || (t[1] = (a) => r.saveFocusElement(a)),
      onOpenLightbox: t[2] || (t[2] = (a) => r.openLightbox(a))
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "posts", "livefeed-config", "component-id", "fallback-image", "path-prefix", "is-preview", "is-i-frame", "is-editing", "logo"]))
  ]);
}
const boe = /* @__PURE__ */ I(foe, [["render", voe], ["__scopeId", "data-v-cf483d17"]]), Ri = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return de(oe({}, e), {
        "--card-bg-color": T(this.theme, "card_bg_color.hex", t),
        "--card-2-bg-color": T(this.theme, "card_2_bg_color.hex", "#FCD40B"),
        "--card-3-bg-color": T(this.theme, "card_3_bg_color.hex", "#131313"),
        "--card-border-color": T(this.theme, "card_border_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--icon-bg-color": T(this.theme, "icon_bg_color.hex", t),
        "--card-top-border": T(this.theme, "card_top_border.hex", t),
        "--icon-color": T(this.theme, "icon_color.hex", t),
        "--color": T(this.theme, "color.hex", t),
        "--color-2": T(this.theme, "color_2.hex", t),
        "--color-3": T(this.theme, "color_3.hex", t),
        "--headline-color": T(this.theme, "headline_color.hex", t),
        "--snippet-color": T(this.theme, "snippet_color.hex", "#333"),
        "--stats-header-color": T(this.theme, "stats_header_color.hex", t),
        "--stats-slider-header-width": this.stats.headline && this.stats.slider ? "calc(100%/3 - 16px)" : "calc(25% - 18px)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.stats.component_header_top || this.isEditing);
    }
  }
}, yoe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Coe = {
  width: "22",
  height: "32",
  viewBox: "0 0 22 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _oe = ["fill"];
function woe(e, t, n, o, i, r) {
  return l(), h("svg", Coe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 20.2059V30.9971C17 31.3818 16.779 31.7315 16.434 31.8988C16.296 31.9639 16.148 31.997 16 31.997C15.777 31.997 15.556 31.9219 15.375 31.7776L11 28.278L6.625 31.7776C6.324 32.018 5.915 32.0631 5.566 31.8988C5.221 31.7315 5 31.3818 5 30.9971V20.2059C1.994 18.2402 0 14.8498 0 10.9986C0 4.93325 4.935 0 11 0C17.065 0 22 4.93325 22 10.9986C22 14.8498 20.006 18.2402 17 20.2059ZM7 28.9162L10.375 26.2172C10.74 25.9246 11.26 25.9246 11.625 26.2172L15 28.9162V21.2338C13.758 21.7207 12.412 21.9982 11 21.9982C9.588 21.9982 8.242 21.7207 7 21.2338V28.9162ZM11 1.99875C6.037 1.99875 2 6.03632 2 10.9986C2 15.9599 6.037 19.9975 11 19.9975C15.963 19.9975 20 15.9599 20 10.9986C20 6.03632 15.963 1.99875 11 1.99875ZM13 15.998H9C8.447 15.998 8 15.5502 8 14.9981C8 14.4461 8.447 13.9982 9 13.9982H10V9.41265L8.707 10.7051C8.512 10.9014 8.256 10.9986 8 10.9986C7.744 10.9986 7.488 10.9014 7.293 10.7051C6.902 10.3153 6.902 9.68215 7.293 9.29142L10.292 6.2928C10.385 6.19962 10.495 6.12649 10.618 6.07539C10.733 6.0283 10.855 6.00626 10.977 6.00326C10.985 6.00326 10.992 5.99825 11 5.99825C11.007 5.99825 11.012 6.00225 11.019 6.00225C11.143 6.00526 11.266 6.0283 11.382 6.07539C11.627 6.17758 11.822 6.37195 11.923 6.61741C11.973 6.73863 12 6.86788 12 6.99712C12 6.99812 12 6.99812 12 6.99912V13.9982H13C13.553 13.9982 14 14.4461 14 14.9981C14 15.5502 13.553 15.998 13 15.998Z",
      fill: n.color
    }, null, 8, _oe)
  ]);
}
const Toe = /* @__PURE__ */ I(yoe, [["render", woe]]), koe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Eoe = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Soe = ["fill"];
function Moe(e, t, n, o, i, r) {
  return l(), h("svg", Eoe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 32C7.178 32 0 24.823 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.823 24.822 32 16 32ZM4.948 24.542C6.752 22.358 7.753 19.708 7.951 17H2.048C2.25 19.832 3.307 22.425 4.948 24.542ZM7.95 15C7.753 12.293 6.751 9.643 4.946 7.46C3.306 9.577 2.25 12.169 2.048 15H7.95ZM15 2.051C11.622 2.291 8.579 3.739 6.286 5.957C8.517 8.548 9.737 11.741 9.944 15H15V2.051ZM15 17H9.945C9.738 20.259 8.518 23.453 6.288 26.045C8.581 28.262 11.623 29.709 15 29.949V17ZM29.952 17H24.049C24.247 19.708 25.249 22.358 27.053 24.541C28.693 22.424 29.75 19.832 29.952 17ZM17 29.949C20.378 29.709 23.42 28.261 25.713 26.044C23.483 23.452 22.262 20.259 22.055 17H17V29.949ZM17 2.051V15H22.055C22.262 11.741 23.483 8.548 25.713 5.956C23.42 3.739 20.378 2.291 17 2.051ZM27.053 7.458C25.249 9.643 24.247 12.293 24.049 15H29.952C29.75 12.168 28.693 9.576 27.053 7.458Z",
      fill: n.color
    }, null, 8, Soe)
  ]);
}
const $oe = /* @__PURE__ */ I(koe, [["render", Moe]]), Ioe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Aoe = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Loe = ["fill"];
function Ooe(e, t, n, o, i, r) {
  return l(), h("svg", Aoe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 26H26.85L29.8 30.45C30.1 30.9 30 31.55 29.5 31.85C29.4 31.95 29.2 32 29 32C28.7 32 28.35 31.85 28.15 31.55L24.45 26H17V30C17 30.55 16.55 31 16 31C15.45 31 15 30.55 15 30V26H7.55L3.85 31.55C3.65 31.85 3.3 32 3 32C2.8 32 2.6 31.95 2.45 31.85C2 31.55 1.85 30.9 2.15 30.45L5.1 26H2C0.9 26 0 25.1 0 24V6C0 4.9 0.9 4 2 4H15V1C15 0.45 15.45 0 16 0C16.55 0 17 0.45 17 1V4H30C31.1 4 32 4.9 32 6V24C32 25.1 31.1 26 30 26ZM30 24V10H2V24H30ZM2 6V8H30V6H2Z",
      fill: n.color
    }, null, 8, Loe)
  ]);
}
const Noe = /* @__PURE__ */ I(Ioe, [["render", Ooe]]), Hoe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Poe = {
  width: "28",
  height: "32",
  viewBox: "0 0 28 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Doe = ["fill"];
function Roe(e, t, n, o, i, r) {
  return l(), h("svg", Poe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 29V31C27 31.552 26.553 32 26 32H20C19.447 32 19 31.552 19 31V29H9V31C9 31.552 8.553 32 8 32H2C1.447 32 1 31.552 1 31V29C0.447 29 0 28.552 0 28V3C0 1.346 1.346 0 3 0H25C26.654 0 28 1.346 28 3V28C28 28.552 27.553 29 27 29ZM21 30H25V29H21V30ZM3 30H7V29H3V30ZM26 3C26 2.449 25.552 2 25 2H3C2.448 2 2 2.449 2 3V7H26V3ZM26 9H2V17H26V9ZM26 19H2V27H26V19ZM6 21C7.102 21 8 21.897 8 23C8 24.103 7.102 25 6 25C4.897 25 4 24.103 4 23C4 21.897 4.897 21 6 21ZM22 21C23.102 21 24 21.897 24 23C24 24.103 23.102 25 22 25C20.897 25 20 24.103 20 23C20 21.897 20.897 21 22 21Z",
      fill: n.color
    }, null, 8, Doe)
  ]);
}
const Voe = /* @__PURE__ */ I(Hoe, [["render", Roe]]), Boe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Foe = {
  width: "26",
  height: "32",
  viewBox: "0 0 26 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, joe = ["fill"];
function Uoe(e, t, n, o, i, r) {
  return l(), h("svg", Foe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.4203 27C26.0792 28.25 26.1806 29.5 25.623 30.45C25.0149 31.45 23.8492 32 22.3794 32H3.62695C2.15716 32 0.940789 31.45 0.383285 30.45C-0.17422 29.5 -0.123538 28.25 0.535331 27L7.98562 13.8V2C7.42812 2 6.97198 1.55 6.97198 1C6.97198 0.45 7.42812 0 7.98562 0H17.97C18.5275 0 18.9837 0.45 18.9837 1C18.9837 1.5 18.5782 1.9 18.1221 2V14L25.4203 27ZM13.0032 7H10.0129V9H13.0032C13.5607 9 14.0168 9.45 14.0168 10C14.0168 10.55 13.5607 11 13.0032 11H10.0129V14.05V14.1C10.0129 14.15 10.0129 14.25 9.96223 14.3C9.96223 14.35 9.91155 14.45 9.91155 14.5V14.55L2.30921 27.95C2.00512 28.55 1.90375 29.05 2.10648 29.4C2.30921 29.75 2.86672 30 3.62695 30H22.3794C23.1396 30 23.6971 29.8 23.8999 29.4C24.1026 29.05 24.0519 28.55 23.6971 27.95L16.0948 14.5C15.9427 14.2 15.9427 13.9 16.0441 13.6V2H9.96223V5H12.9525C13.51 5 13.9661 5.45 13.9661 6C13.9661 6.55 13.5607 7 13.0032 7Z",
      fill: n.color
    }, null, 8, joe)
  ]);
}
const Koe = /* @__PURE__ */ I(Boe, [["render", Uoe]]), Goe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, zoe = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zoe = ["fill"];
function Woe(e, t, n, o, i, r) {
  return l(), h("svg", zoe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.7909 3.612L21.9725 16.317L28.6932 23.037C28.6932 23.037 28.6932 23.038 28.6942 23.038L28.6992 23.043C28.7464 23.091 28.7705 23.151 28.8066 23.205C28.8428 23.259 28.89 23.304 28.9151 23.367L28.9181 23.373C28.9181 23.373 28.9181 23.374 28.9191 23.374L31.9235 30.617C32.0791 30.991 31.9927 31.421 31.7066 31.707C31.5148 31.898 31.2597 32 30.9997 32C30.8711 32 30.7396 31.975 30.6171 31.924L23.3753 28.919C23.3743 28.919 23.3733 28.918 23.3712 28.918L23.3672 28.916C23.314 28.894 23.2769 28.853 23.2307 28.824C23.1664 28.784 23.0981 28.755 23.0429 28.699L23.0379 28.695C23.0369 28.694 23.0369 28.694 23.0369 28.693L17.0412 22.698L14.9907 25.352C15.0731 26.699 14.6272 28.048 13.6452 29.203C12.154 30.957 9.70396 32 7.08116 32C7.05706 32 7.03397 32 7.00987 32C4.68529 31.983 2.29847 30.807 0.291199 28.688C0.0100414 28.391 -0.0622564 27.953 0.109451 27.582C0.27915 27.211 0.648671 26.981 1.0674 27.001C3.7394 27.136 4.02256 26.17 4.49652 24.571C4.7114 23.846 4.95541 23.024 5.47354 22.316C6.48972 20.928 8.0622 20.064 9.57041 20L11.8779 17.572L1.29132 6.95C1.26923 6.927 1.26119 6.898 1.24111 6.873C1.21902 6.855 1.19291 6.848 1.17283 6.828C0.416716 6.074 0.00100414 5.069 0 4.001C0 2.933 0.415712 1.928 1.17183 1.171C1.92693 0.416 2.93107 0 3.99947 0C5.06787 0 6.07301 0.416 6.82812 1.171C6.84921 1.193 6.85724 1.222 6.87632 1.245C6.89941 1.264 6.92753 1.272 6.94861 1.293L17.4077 11.751L28.2754 0.311C28.4632 0.112 28.7253 0 28.9994 0C30.5418 0 31.9998 1.458 31.9998 3C31.9998 3.221 31.9265 3.436 31.7909 3.612ZM29.149 29.15L27.6408 25.515L25.5141 27.642L29.149 29.15ZM23.7498 26.578L26.5774 23.75L20.7404 17.912L18.2743 21.103L23.7498 26.578ZM7.08718 23.497C6.7749 23.925 6.59917 24.516 6.41341 25.141C6.02481 26.452 5.52475 28.132 3.42611 28.761C4.60095 29.561 5.83503 29.991 7.02392 30C7.043 30 7.06309 30 7.08216 30C9.12558 30 11.0053 29.22 12.1219 27.908C12.7756 27.139 13.0708 26.265 13.0035 25.418L9.60556 22.02C8.6938 22.064 7.74088 22.604 7.08718 23.497ZM5.53479 2.707C5.5127 2.685 5.50567 2.657 5.48559 2.633C5.4635 2.614 5.43538 2.607 5.41329 2.585C4.65818 1.83 3.34176 1.83 2.58565 2.586C2.20809 2.964 1.99923 3.466 1.99923 4.001C1.99923 4.534 2.20809 5.036 2.58464 5.413C2.60774 5.436 2.61577 5.466 2.63686 5.491C2.65895 5.509 2.68707 5.517 2.70715 5.538L3.99746 6.832L6.82812 4L5.53479 2.707ZM8.24194 5.414L5.40928 8.248L13.2556 16.121L16.03 13.201L8.24194 5.414ZM29.3428 2.092L11.3959 20.982L13.9033 23.489L29.9423 2.733C29.8369 2.474 29.5979 2.222 29.3428 2.092Z",
      fill: n.color
    }, null, 8, Zoe)
  ]);
}
const qoe = /* @__PURE__ */ I(Goe, [["render", Woe]]), Yoe = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, xoe = {
  width: "32",
  height: "26",
  viewBox: "0 0 32 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xoe = ["fill"];
function Qoe(e, t, n, o, i, r) {
  return l(), h("svg", xoe, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 21.9873H29C28.447 21.9873 28 21.5398 28 20.9872C28 20.4366 28.447 19.989 29 19.989H30V2.00429H2V20.0531H15C15.553 20.0531 16 20.4366 16 20.9872C16 21.5398 15.553 21.9873 15 21.9873H1C0.447 21.9873 0 21.5398 0 20.9872V1.00513C0 0.453498 0.447 0.00598145 1 0.00598145H31C31.553 0.00598145 32 0.453498 32 1.00513V20.9872C32 21.5398 31.553 21.9873 31 21.9873ZM22 10.9957C24.757 10.9957 27 13.2372 27 15.9924C27 17.1097 26.618 18.1319 25.995 18.9649C25.995 18.9739 26 18.9809 26 18.9899V24.9848C26 25.3522 25.797 25.6916 25.472 25.8658C25.324 25.9449 25.162 25.984 25 25.984C24.806 25.984 24.612 25.9279 24.445 25.8158L22 24.1869L19.555 25.8158C19.249 26.02 18.853 26.04 18.528 25.8658C18.203 25.6916 18 25.3522 18 24.9848V18.9899C18 18.9809 18.005 18.9739 18.005 18.9649C17.382 18.1319 17 17.1097 17 15.9924C17 13.2372 19.243 10.9957 22 10.9957ZM22 12.995C20.346 12.995 19 14.3395 19 15.9924C19 17.6453 20.346 18.9899 22 18.9899C23.654 18.9899 25 17.6453 25 15.9924C25 14.3395 23.654 12.995 22 12.995ZM21.445 22.1545C21.781 21.9313 22.219 21.9313 22.555 22.1545L24 23.1176V20.5647C23.386 20.833 22.712 20.9872 22 20.9872C21.288 20.9872 20.613 20.833 20 20.5647V23.1176L21.445 22.1545ZM15 10.0416C15.553 10.0416 16 10.445 16 10.9957C16 11.5483 15.553 11.9958 15 11.9958H9C8.447 11.9958 8 11.5483 8 10.9957C8 10.445 8.447 10.0416 9 10.0416H15ZM5 7.9992C4.447 7.9992 4 7.55169 4 7.00005C4 6.44841 4.447 6.03694 5 6.03694H27C27.553 6.03694 28 6.44841 28 7.00005C28 7.55169 27.553 7.9992 27 7.9992H5Z",
      fill: n.color
    }, null, 8, Xoe)
  ]);
}
const Joe = /* @__PURE__ */ I(Yoe, [["render", Qoe]]), ere = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, tre = {
  width: "25",
  height: "33",
  viewBox: "0 0 25 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nre = ["fill"];
function ore(e, t, n, o, i, r) {
  return l(), h("svg", tre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.55567 0C4.69663 0 3.998 0.699099 3.998 1.55839V26.8914C3.998 27.7516 4.69685 28.4492 5.55567 28.4492H22.8797C23.7392 28.4492 24.4373 27.7515 24.4373 26.8914L24.4507 9.09668C24.4507 9.07071 24.4543 9.04756 24.4507 9.02997V9.01535C24.4581 8.98566 24.4507 8.94257 24.4507 8.8917C24.4507 8.59877 24.3093 8.33899 24.0918 8.17674L16.1802 0.260977C15.9739 0.0561669 15.7006 0.00255148 15.4538 0.0325386C15.4031 0.0178254 15.331 0 15.2543 0H5.55567ZM5.7807 26.6664L5.78397 1.74266H14.6593V8.8917C14.6593 9.40065 15.0835 9.75501 15.559 9.75501H22.6547V26.6664H5.7807ZM16.442 8.00033V3.04523L21.3947 8.00033H16.442ZM1.549 4.00017C0.693308 4.00017 0 4.70059 0 5.55789V30.8916C0 31.7509 0.698628 32.45 1.55767 32.45H18.8823C19.2991 32.45 19.6921 32.2858 19.9851 31.9879C20.2784 31.6909 20.4361 31.2951 20.4306 30.8789L20.4206 30.2112C20.4132 29.7031 19.9833 29.3573 19.5315 29.3335L19.5239 29.3331L19.5164 29.3332C19.0237 29.3404 18.6318 29.7454 18.638 30.2374L18.6506 30.6666H1.78259L1.77408 5.78289H2.20567C2.69715 5.78289 3.09667 5.38447 3.09667 4.89153C3.09667 4.3994 2.6973 4.00017 2.20567 4.00017H1.549Z",
      fill: n.color
    }, null, 8, nre)
  ]);
}
const rre = /* @__PURE__ */ I(ere, [["render", ore]]), ire = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, sre = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, are = ["fill"];
function lre(e, t, n, o, i, r) {
  return l(), h("svg", sre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 27.9811V30.091H15C15.55 30.091 16 30.4929 16 31.0455C16 31.5981 15.55 32.0502 15 32.0502H7C6.45 32.0502 6 31.5981 6 31.0455C6 30.4929 6.45 30.091 7 30.091H10V27.9811C7.8 27.8304 5.6 27.1271 3.5 25.9215C3 25.6201 2.85 25.0172 3.15 24.5651C3.45 24.0628 4.05 23.9121 4.5 24.2135C6.65 25.4694 8.8 26.0722 11 26.0722C18.15 26.0722 24 20.2449 24 13.0612C24 8.43953 21.6 4.26999 17.5 1.90892C17 1.60751 16.85 1.00468 17.15 0.552564C17.45 0.0502093 18.05 -0.100497 18.5 0.200916C23.2 2.91363 26 7.73624 26 13.0612C26 20.9482 19.8 27.4285 12 27.9811ZM22 13.011C22 19.0895 17.05 24.0125 11 24.0125C4.95 24.0125 0 19.0895 0 13.011C0 6.93247 4.95 2.00939 11 2.00939C17.05 2.00939 22 6.93247 22 13.011ZM11 4.01881C6.05 4.01881 2 8.03765 2 13.011C2 17.9843 6.05 22.0031 11 22.0031C15.95 22.0031 20 17.9843 20 13.011C20 8.03765 15.95 4.01881 11 4.01881Z",
      fill: n.color
    }, null, 8, are)
  ]);
}
const dre = /* @__PURE__ */ I(ire, [["render", lre]]), ure = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, cre = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hre = ["fill"];
function mre(e, t, n, o, i, r) {
  return l(), h("svg", cre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32 17C32 20.86 28.8599 24 25.0005 24C21.1411 24 18 20.86 18 17C18 16.517 18.0492 16.046 18.1426 15.591C17.8543 15.39 17.1452 15 16 15C14.8639 15 14.1557 15.386 13.8584 15.592C13.9508 16.047 14 16.518 14 17C14 20.86 10.8599 24 7.0005 24C3.14114 24 0 20.86 0 17C0 16.75 0.0150678 16.504 0.0401808 16.26C0.00401809 16.125 -0.0100452 15.983 0.0140633 15.836L2.01406 3.836C2.17579 2.535 3.43446 0 7.0005 0C7.55299 0 8 0.448 8 1C8 1.552 7.55299 2 7.0005 2C4.2893 2 4.00301 4.037 3.99297 4.124L2.77549 11.432C3.95078 10.538 5.41236 10 7.0005 10C9.66047 10 11.9779 11.492 13.1622 13.683C13.78 13.346 14.7172 13 16 13C17.2838 13 18.22 13.346 18.8388 13.682C20.0231 11.492 22.3405 10 25.0005 10C26.5876 10 28.0492 10.537 29.2245 11.432L28.0141 4.164C27.9769 3.916 27.6183 2 25.0005 2C24.447 2 24 1.552 24 1C24 0.448 24.447 0 25.0005 0C28.5655 0 29.8242 2.535 29.992 3.876L31.9859 15.836C32.0111 15.983 31.997 16.125 31.9598 16.261C31.9859 16.504 32 16.75 32 17ZM7.0005 12C4.24309 12 2 14.243 2 17C2 19.757 4.24309 22 7.0005 22C9.75691 22 12 19.757 12 17C12 14.243 9.75691 12 7.0005 12ZM25.0005 12C22.2431 12 20 14.243 20 17C20 19.757 22.2431 22 25.0005 22C27.7569 22 30 19.757 30 17C30 14.243 27.7569 12 25.0005 12Z",
      fill: n.color
    }, null, 8, hre)
  ]);
}
const pre = /* @__PURE__ */ I(ure, [["render", mre]]), fre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, gre = {
  width: "30",
  height: "33",
  viewBox: "0 0 30 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vre = ["fill"];
function bre(e, t, n, o, i, r) {
  return l(), h("svg", gre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.9995 7.00245H24.9995V11.0037C24.9995 11.5559 24.5517 12.0048 23.9995 12.0048C23.4473 12.0048 22.9995 11.5559 22.9995 11.0037V7.00245H18.9995C18.4473 7.00245 17.9995 6.55463 17.9995 6.00239C17.9995 5.45014 18.4091 5.06759 18.9624 5.06759H22.9995V1.00107C22.9995 0.448823 23.4473 0 23.9995 0C24.5517 0 24.9995 0.448823 24.9995 1.00107V5.06759H29.0025C29.5557 5.06759 29.9995 5.45014 29.9995 6.00239C29.9995 6.55463 29.5517 7.00245 28.9995 7.00245ZM23.3439 31.9488C23.2304 31.991 23.114 32.01 22.9995 32.01C22.5919 32.01 22.2093 31.759 22.0608 31.3544L17.9463 20.1288H6.05272L1.93826 31.3544C1.7475 31.8735 1.17722 32.1386 0.655127 31.9488C0.137055 31.758 -0.12901 31.1837 0.0617534 30.6656L11.0608 0.656668C11.2043 0.262065 11.5798 0 11.9995 0C12.4192 0 12.7947 0.262065 12.9383 0.656668L23.9383 30.6656C24.128 31.1837 23.862 31.758 23.3439 31.9488ZM11.9995 3.90587L6.78967 18.1206H17.2104L11.9995 3.90587Z",
      fill: n.color
    }, null, 8, vre)
  ]);
}
const yre = /* @__PURE__ */ I(fre, [["render", bre]]), Cre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, _re = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wre = ["fill"];
function Tre(e, t, n, o, i, r) {
  return l(), h("svg", _re, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.9355 23.8376C28.7979 23.8376 27.871 22.904 27.871 21.759C27.871 20.9929 28.289 20.3299 28.9032 19.9687V12.1175L24.7546 14.5042C24.7577 14.5385 24.7742 14.5687 24.7742 14.6031V24.8764C24.7742 24.916 24.7556 24.9503 24.7515 24.9899C24.7432 25.0606 24.7319 25.1273 24.7102 25.1959C24.6895 25.2594 24.6627 25.3167 24.6307 25.375C24.5987 25.4322 24.5646 25.4843 24.5223 25.5363C24.4759 25.5915 24.4253 25.6362 24.3685 25.681C24.3386 25.7049 24.32 25.7382 24.2859 25.7591C24.1404 25.8507 20.6483 27.9938 15.4839 27.9938C10.3195 27.9938 6.82735 25.8507 6.68181 25.7591C6.64774 25.7382 6.62916 25.7049 6.59923 25.681C6.54245 25.6362 6.49187 25.5915 6.44542 25.5353C6.4031 25.4843 6.36903 25.4322 6.33703 25.375C6.30503 25.3167 6.27819 25.2594 6.25755 25.1959C6.23587 25.1273 6.22452 25.0606 6.21626 24.9899C6.21213 24.9513 6.19355 24.917 6.19355 24.8764V14.6031C6.19355 14.5687 6.21006 14.5385 6.21316 14.5042L0.520258 11.2286C0.198194 11.0444 0 10.6998 0 10.3272C0 9.95355 0.198194 9.60902 0.520258 9.42479L14.9719 1.11037C15.2877 0.928217 15.679 0.928217 15.9959 1.11037L30.4475 9.42479C30.7695 9.60902 30.9677 9.95355 30.9677 10.3272C30.9677 10.3449 30.9554 10.3595 30.9543 10.3782C30.9554 10.4022 30.9677 10.423 30.9677 10.4469V19.9687C31.5819 20.3299 32 20.9929 32 21.759C32 22.904 31.0741 23.8376 29.9355 23.8376ZM22.7097 24.2571V15.6804L15.9959 19.543C15.8379 19.6346 15.6604 19.6804 15.4839 19.6804C15.3074 19.6804 15.1298 19.6346 14.9719 19.543L8.25806 15.6804V24.254C9.29445 24.7765 11.9515 25.9162 15.4839 25.9162C19.0369 25.9162 21.6785 24.7796 22.7097 24.2571ZM15.4839 3.20979L3.11329 10.3272L15.4839 17.4436L27.8545 10.3272L15.4839 3.20979Z",
      fill: n.color
    }, null, 8, wre)
  ]);
}
const kre = /* @__PURE__ */ I(Cre, [["render", Tre]]), Ere = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Sre = {
  width: "33",
  height: "29",
  viewBox: "0 0 33 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mre = ["fill"];
function $re(e, t, n, o, i, r) {
  return l(), h("svg", Sre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0462 2.957H13.8656L8.9928 28.1971C8.89233 28.5986 8.59091 28.8997 8.23926 29C8.18903 29 8.08856 29 8.03832 29C7.73691 29 7.38526 28.8495 7.23455 28.5484L0.201588 18.5627C-0.0998244 18.1111 0.000646586 17.509 0.452766 17.1577C0.904885 16.8566 1.50771 16.957 1.85936 17.4086L7.48573 25.4875L12.0572 1.80288C12.0572 1.7527 12.0572 1.7527 12.0572 1.70252C12.0572 1.65234 12.1074 1.55198 12.1576 1.5018C12.2079 1.45162 12.2079 1.40144 12.2581 1.35126C12.3083 1.30108 12.3586 1.2509 12.4088 1.20073C12.459 1.15055 12.5093 1.15055 12.5595 1.10037C12.6098 1.05019 12.66 1.05019 12.7605 1.00001C12.8107 1.00001 12.8609 0.949829 12.9614 0.949829C13.0116 0.949829 13.0116 0.949829 13.0619 0.949829H31.0964C31.649 0.949829 32.1011 1.40144 32.1011 1.95341C32.1011 2.50538 31.5988 2.957 31.0462 2.957ZM16.4779 7.17205C16.93 6.87098 17.5831 7.02151 17.8342 7.47313L22.0038 14.147L26.1733 7.47313C26.4747 7.02151 27.0776 6.87098 27.5297 7.17205C27.9818 7.47313 28.1325 8.07528 27.8311 8.57707L23.1592 16.0538L27.8311 23.5305C28.1325 23.9821 27.9818 24.6344 27.5297 24.9355C27.379 25.0359 27.178 25.086 26.9771 25.086C26.6254 25.086 26.324 24.9355 26.1231 24.6344L21.9535 18.0108L17.784 24.6344C17.5831 24.9355 17.2816 25.086 16.93 25.086C16.7291 25.086 16.5784 25.0359 16.3774 24.9355C15.9253 24.6344 15.7746 24.0323 16.076 23.5305L20.7479 16.0538L16.1765 8.52689C15.8751 8.07528 16.0258 7.47313 16.4779 7.17205Z",
      fill: n.color
    }, null, 8, Mre)
  ]);
}
const Ire = /* @__PURE__ */ I(Ere, [["render", $re]]), Are = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Lre = {
  width: "32",
  height: "38",
  viewBox: "0 0 32 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ore = ["fill"];
function Nre(e, t, n, o, i, r) {
  return l(), h("svg", Lre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9702 8.89879C31.9829 8.9717 31.9898 9.0423 31.9875 9.11521C31.9863 9.18696 31.9759 9.25525 31.9609 9.327C31.9437 9.4057 31.9217 9.47861 31.8883 9.55268C31.8745 9.58509 31.8745 9.62097 31.8572 9.65337L24.8414 22.3181C25.7754 23.9233 26.2909 25.7218 26.2909 27.5897C26.2909 33.3278 21.6794 37.9977 16.0105 37.9977C10.3416 37.9977 5.73017 33.3278 5.73017 27.5897C5.73017 25.7207 6.24679 23.921 7.17969 22.3181L0.165057 9.65337C0.146607 9.62097 0.146607 9.58509 0.132769 9.55268C0.10048 9.47861 0.0774174 9.4057 0.0612732 9.327C0.0451291 9.25525 0.0347507 9.18696 0.0335976 9.11521C0.0312913 9.0423 0.0393633 8.9717 0.0508949 8.89879C0.0635796 8.82009 0.0831832 8.74718 0.112012 8.67311C0.124697 8.63955 0.12239 8.60367 0.138535 8.57011L3.56571 1.63188C3.57839 1.60526 3.60722 1.59369 3.62221 1.56823C3.69832 1.43977 3.79518 1.33098 3.91396 1.2407C3.95547 1.2083 3.99353 1.17936 4.03965 1.1539C4.17342 1.07868 4.31871 1.03123 4.47785 1.01502C4.50322 1.01271 4.52282 0.994191 4.54819 0.993034C4.55857 0.991877 4.56664 0.995349 4.57702 0.995349C4.58048 0.995349 4.58394 0.993034 4.5874 0.993034H26.8629C26.9793 0.993034 27.0866 1.0266 27.1927 1.06016C27.2872 1.03933 27.3726 0.989562 27.4729 0.993034C27.8915 1.00808 28.2686 1.25343 28.4554 1.63188L31.8825 8.57011C31.8987 8.60367 31.8964 8.63955 31.9102 8.67311C31.939 8.74718 31.9575 8.82009 31.9702 8.89879ZM16.0105 35.6853C20.419 35.6853 24.0065 32.0536 24.0065 27.5897C24.0065 25.9405 23.5164 24.3481 22.587 22.9836C21.4269 21.2834 19.6833 20.1053 17.6757 19.6655C17.1337 19.5532 16.5698 19.4953 16.0105 19.4953C15.4513 19.4953 14.8874 19.5532 14.3315 19.6689C12.34 20.1053 10.5953 21.2834 9.4341 22.9847C8.50581 24.3469 8.01457 25.9405 8.01457 27.5897C8.01457 32.0536 11.602 35.6853 16.0105 35.6853ZM17.309 17.301L21.4073 10.2436H10.6138L14.6971 17.2756C15.5723 17.1645 16.4441 17.1957 17.309 17.301ZM2.45291 9.05619L8.68686 20.3101C9.73392 19.2396 10.9943 18.4109 12.3942 17.8751L4.66927 4.57036L2.45291 9.05619ZM9.27035 7.93126H22.7507L25.4364 3.30539H6.58466L9.27035 7.93126ZM27.3518 4.57036L19.6395 17.8531C21.0394 18.3936 22.2941 19.2315 23.3365 20.3078L29.5682 9.05619L27.3518 4.57036Z",
      fill: n.color
    }, null, 8, Ore)
  ]);
}
const Hre = /* @__PURE__ */ I(Are, [["render", Nre]]), Pre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Dre = {
  width: "32",
  height: "29",
  viewBox: "0 0 32 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rre = ["fill"];
function Vre(e, t, n, o, i, r) {
  return l(), h("svg", Dre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.452 24H20.22L20.82 27H22.047C22.599 27 23.047 27.447 23.047 28C23.047 28.553 22.599 29 22.047 29H10.047C9.495 29 9.047 28.553 9.047 28C9.047 27.447 9.495 27 10.047 27H11.18L11.78 24H2.548C1.143 24 0 22.857 0 21.452V2.548C0 1.143 1.143 0 2.548 0H29.452C30.857 0 32 1.143 32 2.548V21.452C32 22.857 30.857 24 29.452 24ZM18.78 27L18.18 24H13.82L13.22 27H18.78ZM2.548 22H29.452C29.754 22 30 21.754 30 21.452V20H2V21.452C2 21.754 2.246 22 2.548 22ZM29.452 2H2.548C2.246 2 2 2.246 2 2.548V18H30V2.548C30 2.246 29.754 2 29.452 2Z",
      fill: n.color
    }, null, 8, Rre)
  ]);
}
const Bre = /* @__PURE__ */ I(Pre, [["render", Vre]]), Fre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, jre = {
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ure = ["fill"];
function Kre(e, t, n, o, i, r) {
  return l(), h("svg", jre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 30H2C0.898 30 0 29.103 0 28V7C0 5.897 0.898 5 2 5H10V3C10 1.346 11.346 0 13 0H19C20.654 0 22 1.346 22 3V5H30C31.102 5 32 5.897 32 7V28C32 29.103 31.102 30 30 30ZM17 28H29.996L29.998 16H26V17.285C26 18.782 24.654 20 23 20C22.234 20 21.503 19.735 20.94 19.254C20.343 18.742 20 18.024 20 17.285V16H17V28ZM22 17.285C22 17.497 22.151 17.658 22.241 17.735C22.438 17.903 22.715 18 23 18C23.532 18 24 17.666 24 17.285V14H22V17.285ZM2 28H15V16H12V17.285C12 18.782 10.654 20 9 20C8.234 20 7.503 19.735 6.94 19.254C6.343 18.742 6 18.024 6 17.285V16H2V28ZM10 17.285V14H8V17.285C8 17.497 8.151 17.658 8.241 17.735C8.438 17.903 8.715 18 9 18C9.532 18 10 17.666 10 17.285ZM20 3C20 2.448 19.552 2 19 2H13C12.448 2 12 2.448 12 3V5H20V3ZM2 7V14H6V13C6 12.448 6.447 12 7 12H11C11.553 12 12 12.448 12 13V14H20V13C20 12.448 20.447 12 21 12H25C25.553 12 26 12.448 26 13V14H29.999L30 7H2Z",
      fill: n.color
    }, null, 8, Ure)
  ]);
}
const Gre = /* @__PURE__ */ I(Fre, [["render", Kre]]), zre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Zre = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wre = ["fill"];
function qre(e, t, n, o, i, r) {
  return l(), h("svg", Zre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0006 11.9999C30.9956 11.9999 30.9875 11.9999 30.9805 11.9999H26.9838V22.0007H28.9826C29.535 22.0007 29.9811 22.4485 29.9811 23.0006C29.9811 23.5526 29.535 24.0005 28.9826 24.0005H2.99831C2.44596 24.0005 1.99887 23.5526 1.99887 23.0006C1.99887 22.4485 2.44596 22.0007 2.99831 22.0007H4.99718V11.9999H0.999436C0.559363 11.9999 0.171418 11.7113 0.0431051 11.2895C-0.0842053 10.8687 0.079193 10.4129 0.445085 10.1674L15.4356 0.167566C15.7714 -0.0558552 16.2095 -0.0558552 16.5443 0.167566L31.4246 10.0933C31.7644 10.2536 32 10.5992 32 11C32 11.552 31.5529 11.9999 31.0006 11.9999ZM21.9866 22.0007H24.9849V11.9999H21.9866V22.0007ZM16.9894 22.0007H19.9877V11.9999H16.9894V22.0007ZM14.9905 22.0007V11.9999H11.9501V22.0007H14.9905ZM6.93791 22.0007H9.99436V11.9999H6.93791V22.0007ZM15.99 2.2014L4.30048 10.0001H27.6805L15.99 2.2014ZM0.999436 26.0002H30.9805C31.5329 26.0002 31.98 26.4481 31.98 27.0001C31.98 27.5532 31.5329 28 30.9805 28H0.999436C0.44709 28 0 27.5532 0 27.0001C0 26.4481 0.44709 26.0002 0.999436 26.0002Z",
      fill: n.color
    }, null, 8, Wre)
  ]);
}
const Yre = /* @__PURE__ */ I(zre, [["render", qre]]), xre = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Xre = {
  width: "28",
  height: "33",
  viewBox: "0 0 28 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qre = ["fill"];
function Jre(e, t, n, o, i, r) {
  return l(), h("svg", Xre, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.219 17.4369C23.242 18.8659 28 24.1269 28 30.0179V31.0169C28 31.5669 27.552 32.0139 27 32.0139H1C0.448 32.0139 0 31.5669 0 31.0169V30.0179C0 24.1269 4.758 18.8659 10.78 17.4369C7.406 16.1399 5 12.8779 5 9.05893C5 4.10593 9.038 0.0759277 14 0.0759277C18.962 0.0759277 23 4.10593 23 9.05893C23 12.8779 20.594 16.1399 17.219 17.4369ZM2 30.0179H26C26 24.1699 20.393 19.0399 14 19.0399C7.607 19.0399 2 24.1699 2 30.0179ZM14 2.07293C10.14 2.07293 7 5.20693 7 9.05893C7 12.9109 10.14 16.0449 14 16.0449C17.86 16.0449 21 12.9109 21 9.05893C21 5.20693 17.86 2.07293 14 2.07293Z",
      fill: n.color
    }, null, 8, Qre)
  ]);
}
const eie = /* @__PURE__ */ I(xre, [["render", Jre]]), tie = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, nie = {
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oie = ["fill"];
function rie(e, t, n, o, i, r) {
  return l(), h("svg", nie, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 20.794V27C27 28.005 26.269 28.962 25.299 29.227L15.263 31.964C15.175 31.988 15.087 32 14.999 32C14.76 32 14.537 31.908 14.359 31.757C14.331 31.759 14.306 31.77 14.278 31.77C14.111 31.77 13.941 31.747 13.772 31.701L4.702 29.227C3.731 28.962 3 28.005 3 27V20.794C1.567 20.288 0 18.835 0 17C0 15.164 1.567 13.711 3 13.206V11C3 10.423 3.247 9.904 3.677 9.576C4.105 9.247 4.669 9.146 5.229 9.299L14.298 11.772C14.483 11.822 14.648 11.918 14.812 12.015L24.772 9.298C25.327 9.147 25.894 9.247 26.323 9.576C26.753 9.904 27 10.423 27 11V13.206C28.433 13.711 30 15.164 30 17C30 18.835 28.433 20.288 27 20.794ZM2 17C2 18.033 3.375 19 4 19C4.408 19 5 18.22 5 17C5 15.779 4.408 15 4 15C3.375 15 2 15.966 2 17ZM14 14C14 13.901 13.867 13.727 13.772 13.701L5 11.309V13.237C6.173 13.777 7 15.229 7 17C7 18.771 6.173 20.223 5 20.763V27C5 27.099 5.133 27.272 5.229 27.298L14 29.69V14ZM25 11.309L15.96 13.774C15.969 13.851 16 13.923 16 14V29.69L24.772 27.298C24.867 27.272 25 27.099 25 27V20.763C23.827 20.223 23 18.771 23 17C23 15.229 23.827 13.777 25 13.237V11.309ZM26 15C25.592 15 25 15.779 25 17C25 18.22 25.592 19 26 19C26.625 19 28 18.033 28 17C28 15.966 26.625 15 26 15ZM15 10C12.243 10 10 7.757 10 5C10 2.243 12.243 0 15 0C17.757 0 20 2.243 20 5C20 7.757 17.757 10 15 10ZM15 2C13.346 2 12 3.346 12 5C12 6.654 13.346 8 15 8C16.654 8 18 6.654 18 5C18 3.346 16.654 2 15 2Z",
      fill: n.color
    }, null, 8, oie)
  ]);
}
const iie = /* @__PURE__ */ I(tie, [["render", rie]]), sie = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, aie = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lie = ["fill"];
function die(e, t, n, o, i, r) {
  return l(), h("svg", aie, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9511 15.2675C31.8112 15.6861 31.4205 15.9511 31.0026 15.9511C30.8969 15.9511 30.7912 15.934 30.6854 15.8989L26.0083 14.335L25.7032 15.2625C25.6196 15.5155 25.4394 15.7253 25.2017 15.8447C25.0618 15.915 24.9067 15.9511 24.7526 15.9511C24.6459 15.9511 24.5402 15.934 24.4375 15.8999L17.0044 13.4256V15.133C18.7242 15.5807 20.004 17.1335 20.004 18.9935C20.004 20.0274 19.5992 20.9629 18.9528 21.6736L22.9321 31.6269C23.1375 32.1408 22.8878 32.722 22.3753 32.9278C22.2535 32.977 22.1276 33 22.0037 33C21.607 33 21.2314 32.7611 21.0754 32.3707L17.241 22.7797C16.8493 22.9082 16.4385 22.9955 16.0045 22.9955C15.5695 22.9955 15.1597 22.9082 14.768 22.7797L10.9326 32.3707C10.7766 32.7611 10.401 33 10.0042 33C9.88039 33 9.75453 32.977 9.63269 32.9278C9.12016 32.722 8.87045 32.1408 9.07586 31.6269L13.0552 21.6746C12.4088 20.9629 12.004 20.0274 12.004 18.9935C12.004 17.1335 13.2838 15.5807 15.0036 15.133V12.991C15.0036 12.9137 15.0308 12.8465 15.0479 12.7752L9.09902 10.7948L8.9651 11.2645C8.83923 11.7042 8.43848 11.9903 8.00449 11.9903C7.91286 11.9903 7.82023 11.9782 7.7286 11.9511L0.729478 9.9506C0.197823 9.79904 -0.110296 9.24496 0.0417497 8.71397L2.0415 1.7107C2.19354 1.17871 2.75138 0.873565 3.278 1.02413L10.2771 3.02463C10.8088 3.1772 11.1169 3.73028 10.9648 4.26127L10.7484 5.01911L26.3184 10.2005C26.842 10.3742 27.1249 10.9393 26.9528 11.4623L26.6336 12.4339L31.3198 14.0018C31.8434 14.1765 32.1253 14.7436 31.9511 15.2675ZM3.68983 3.22237L2.23986 8.30142L7.31677 9.75286L7.41645 9.40255C7.42451 9.33128 7.41947 9.26102 7.44263 9.19075C7.45773 9.14458 7.49096 9.11146 7.51211 9.0703L8.76673 4.67382L3.68983 3.22237ZM14.0037 18.9935C14.0037 20.0967 14.9019 20.994 16.0045 20.994C17.1061 20.994 18.0042 20.0967 18.0042 18.9935C18.0042 17.8894 17.1061 16.992 16.0045 16.992C14.9019 16.992 14.0037 17.8894 14.0037 18.9935ZM10.1986 6.94433L9.6488 8.87055L24.1163 13.6846L24.7406 11.7845L10.1986 6.94433Z",
      fill: n.color
    }, null, 8, lie)
  ]);
}
const uie = /* @__PURE__ */ I(sie, [["render", die]]), cie = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, hie = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mie = ["fill"];
function pie(e, t, n, o, i, r) {
  return l(), h("svg", hie, [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26 10.9V14C26 19.176 22.046 23.446 17 23.95V30H23C23.553 30 24 30.448 24 31C24 31.552 23.553 32 23 32H9C8.447 32 8 31.552 8 31C8 30.448 8.447 30 9 30H15V23.95C9.954 23.446 6 19.176 6 14V10.9C2.507 10.272 0 6.454 0 3C0 2.448 0.447 2 1 2H6V1C6 0.448 6.447 0 7 0H25C25.553 0 26 0.448 26 1V2H31C31.553 2 32 2.448 32 3C32 6.454 29.493 10.272 26 10.9ZM6 4H2.094C2.481 6.114 4.029 8.274 6 8.845V4ZM24 2H8V14C8 18.411 11.589 22 16 22C20.411 22 24 18.411 24 14V2ZM26 4V8.845C27.971 8.274 29.519 6.114 29.906 4H26ZM18 17H14C13.447 17 13 16.552 13 16C13 15.448 13.447 15 14 15H15V9.414L13.707 10.707C13.316 11.097 12.684 11.097 12.293 10.707C11.902 10.316 11.902 9.683 12.293 9.293L15.293 6.293C15.579 6.006 16.009 5.922 16.383 6.076C16.757 6.231 17 6.596 17 7V15H18C18.553 15 19 15.448 19 16C19 16.552 18.553 17 18 17Z",
      fill: n.color
    }, null, 8, mie)
  ]);
}
const fie = /* @__PURE__ */ I(cie, [["render", pie]]), gie = {
  name: "S1",
  components: {
    CmsBadge: Toe,
    CmsBasketball: $oe,
    CmsBlackboard: Noe,
    CmsBus: Voe,
    CmsChemistry: Koe,
    CmsDesign: qoe,
    CmsDiploma: Joe,
    CmsDocuments: rre,
    CmsGeography: dre,
    CmsGlasses: pre,
    CmsGrade: yre,
    CmsGraduationCap: kre,
    CmsMath: Ire,
    CmsMedal: Hre,
    CmsMonitor: Bre,
    CmsSchoolBag: Gre,
    CmsSchoolBuilding: Yre,
    CmsStaff: eie,
    CmsStudent: iie,
    CmsTelescope: uie,
    CmsTrophy: fie
  },
  mixins: [Ri]
}, vie = {
  key: 0,
  "data-testid": "component-header-top"
}, bie = ["data-testid"], yie = { class: "stats-info" }, Cie = { class: "stats-card-border" }, _ie = {
  class: "stats-card stats-accent-border",
  "data-testid": "stats-accent-border"
}, wie = { class: "svg-wrapper" }, Tie = ["innerHTML"];
function kie(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "stats-s1",
    class: p(e.theme.style),
    style: H(e.colors),
    "data-testid": "S1"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.displayHeaderTop ? (l(), h("h3", vie, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.stats.component_header_top), 1)
          ], !0)
        ])) : g("", !0),
        d("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header", {}, () => [
            k(f(e.stats.component_header), 1)
          ], !0)
        ], 8, bie)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-wrapper"
    }), {
      item: b(({ element: s, index: u }) => [
        d("div", yie, [
          C(e.$slots, "controls", { idx: u }, void 0, !0),
          d("div", Cie, [
            d("div", _ie, [
              d("div", wie, [
                C(e.$slots, "icon", { idx: u }, () => [
                  s.icon ? (l(), h("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "stats-icon",
                    innerHTML: s.icon
                  }, null, 8, Tie)) : s.name ? (l(), _(R(`cms-${s.name.replace(/\s/g, "-")}`), {
                    key: 1,
                    "data-testid": "stats-icon",
                    color: `${e.theme.icon_color.hex}`
                  }, null, 8, ["color"])) : g("", !0)
                ], !0)
              ])
            ])
          ]),
          e.stats.headline ? (l(), h("h3", {
            key: 0,
            class: p(["stats-headline", e.theme.style]),
            "data-testid": "stats-headline"
          }, [
            C(e.$slots, "headline", { idx: u }, () => [
              k(f(s.headline), 1)
            ], !0)
          ], 2)) : g("", !0),
          e.stats.snippet ? (l(), h("p", {
            key: 1,
            class: p(["stats-snippet", e.theme.style]),
            "data-testid": "stats-snippet"
          }, [
            C(e.$slots, "snippet", { idx: u }, () => [
              k(f(s.snippet), 1)
            ], !0)
          ], 2)) : g("", !0)
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Eie = /* @__PURE__ */ I(gie, [["render", kie], ["__scopeId", "data-v-38c8423e"]]), Sie = {
  methods: {
    isShortList(e) {
      var n;
      return (e || ((n = this.items) == null ? void 0 : n.length)) <= this.sliderCapacity;
    },
    goRight(e) {
      this.isShortList(e) || (this.currentCard + this.sliderCapacity === this.cardsLength ? this.currentCard = 0 : this.currentCard += 1, this.move());
    },
    goLeft(e) {
      this.isShortList(e) || (this.currentCard === 0 ? this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 1, this.move());
    },
    move() {
      const t = (this.$refs[`slider-card-${this.currentCard}`] ? this : this.getSlot()).$refs[`slider-card-${this.currentCard}`], { slider: n } = this.$refs, { left: o } = this.getRelativePos(t);
      n.$el.style.transform = `translateX(-${o}px)`;
    },
    getSlot() {
      const e = Object.keys(this.$slots)[this.currentCard], [t] = this.$slots[e]();
      return t.context;
    },
    getRelativePos(e) {
      const t = e.parentNode.getBoundingClientRect(), n = e.getBoundingClientRect(), o = {};
      return o.top = n.top - t.top + e.parentNode.scrollTop, o.right = n.right - t.right, o.bottom = n.bottom - t.bottom, o.left = n.left - t.left + e.parentNode.scrollLeft, o;
    }
  }
}, Mie = {
  name: "S2",
  mixins: [Ri, rt, Sie],
  data() {
    return {
      currentCard: 0,
      cardsLength: 0
    };
  },
  computed: {
    component_header() {
      return this.stats.stats_header;
    },
    stats_header() {
      return this.stats.component_header;
    },
    sliderCapacity() {
      return this.screenSize < 600 ? 1 : this.screenSize >= 1600 && !this.hasHeader ? 4 : this.screenSize >= 960 && this.hasHeader && this.hasSlider ? 3 : 4;
    },
    lowSliderCount() {
      var t;
      const e = ((t = this.stats.content) == null ? void 0 : t.length) || 0;
      return this.hasSlider && e < this.sliderCapacity;
    },
    hasHeader() {
      return this.stats.headline;
    },
    hasSlider() {
      return this.stats.slider && !this.isEditing;
    },
    hasTwoRows() {
      return this.screenSize >= 600 && this.screenSize < 960;
    },
    showArrows() {
      return this.screenSize >= 600 && this.hasSlider && this.stats.content.length > this.sliderCapacity;
    },
    backgroundImage() {
      return this.stats.bg_image && this.stats.bg_image.url ? {
        backgroundImage: `linear-gradient(${this.theme.bg_color.hex}e6, ${this.theme.bg_color.hex}e6), ${`url(${this.stats.bg_image.url})`}`
      } : !1;
    },
    hasDots() {
      return !!(this.hasSlider && this.stats.content.length > this.sliderCapacity);
    },
    dotCount() {
      const e = this.sliderCapacity, t = this.stats.content.length;
      return Math.ceil(t / e);
    },
    activeStatIdx() {
      return Math.ceil(this.currentCard / this.sliderCapacity + 1) === this.dotCount ? this.dotCount : Math.floor(this.currentCard / this.sliderCapacity + 1);
    }
  },
  mounted() {
    this.cardsLength = this.stats.content.length;
  },
  methods: {
    sliderCardOptions(e) {
      return {
        "stats-card-hidden": !this.isInRange(e, this.currentCard) && this.hasSlider,
        "stats-card-no-border": this.isTheLastOneInRange(e, this.currentCard),
        "stats-card-no-header": !this.hasHeader,
        "stats-card-no-slider": !this.hasSlider
      };
    },
    setScreenSize() {
      this.hasSlider && (this.screenSize = document.documentElement.clientWidth, this.lowSliderCount || this.move());
    },
    moveForward() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard + this.sliderCapacity >= this.cardsLength ? this.currentCard = 0 : this.currentCard += 2, this.move()) : this.goRight(this.cardsLength));
    },
    moveBack() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard <= 1 ? this.cardsLength % 2 !== 0 ? this.currentCard = this.cardsLength - this.sliderCapacity + 1 : this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 2, this.move()) : this.goLeft(this.cardsLength));
    },
    isInRange(e, t) {
      return e >= t && e <= t + this.sliderCapacity - 1;
    },
    isTheLastOneInRange(e, t) {
      return e === t + this.sliderCapacity - 1 && this.hasSlider;
    },
    dotMove(e) {
      const t = this.sliderCapacity, n = this.stats.content.length, o = (e - 1) * t;
      if (e === this.dotCount && n < this.dotCount * t) {
        const i = n - t, r = n % 2 === 0;
        this.currentCard = this.hasTwoRows && !r ? i + 1 : i;
      } else
        this.currentCard = o;
      this.move();
    }
  }
}, $ie = { key: 0 }, Iie = ["data-testid"], Aie = { class: "stat-content" }, Lie = { class: "slider-nav" }, Oie = ["onClick"], Nie = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, Hie = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pie = ["fill"], Die = ["fill"], Rie = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, Vie = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bie = ["fill"], Fie = ["fill"];
function jie(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = Ne("touch");
  return l(), h("div", {
    id: "stats-s2",
    class: p([[{ "no-slider": !r.hasSlider }, e.theme.style], "stats-s2"]),
    style: H([r.backgroundImage, e.colors])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.displayHeaderTop ? (l(), h("h3", $ie, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.stats.component_header_top), 1)
          ], !0)
        ])) : g("", !0),
        d("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header", {}, () => [
            k(f(r.component_header), 1)
          ], !0)
        ], 8, Iie)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: p(["stats-info", { "stats-info-w-header": r.hasHeader }])
    }, [
      r.hasHeader && r.hasSlider ? (l(), h("div", {
        key: 0,
        class: p([e.theme.style, "stats-header"])
      }, [
        C(e.$slots, "stats-header", {}, () => [
          k(f(r.stats_header), 1)
        ], !0)
      ], 2)) : g("", !0),
      d("div", {
        class: p(["cards-slider", { "cards-slider-no-slider": !r.hasSlider, "cards-slider-w-header": r.hasHeader }])
      }, [
        me((l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (u) => e.stats.content = u),
          ref: "slider",
          "item-key": "index",
          class: [{ "cards-slider-container-wrap": !r.hasSlider, "cards-slider-container-center": r.lowSliderCount }, "cards-slider-container"]
        }), {
          header: b(() => [
            r.hasHeader && !r.hasSlider ? (l(), h("div", {
              key: 0,
              class: p([e.theme.style, "stats-card stats-card-no-slider stats-header-card"])
            }, [
              C(e.$slots, "stats-header", {}, () => [
                k(f(r.stats_header), 1)
              ], !0)
            ], 2)) : g("", !0)
          ]),
          item: b(({ element: u, index: c }) => [
            d("div", {
              ref: `slider-card-${c}`,
              class: p(["stats-card", r.sliderCardOptions(c)]),
              "data-testid": "stats-content"
            }, [
              C(e.$slots, "controls", { idx: c }, void 0, !0),
              d("div", Aie, [
                d("p", {
                  class: p(["stat-headline", [{ "no-slider": !r.hasSlider }, e.theme.style]])
                }, [
                  C(e.$slots, "headline", { idx: c }, () => [
                    k(f(u.headline), 1)
                  ], !0)
                ], 2),
                d("p", {
                  class: p(["stat-description", e.theme.style])
                }, [
                  C(e.$slots, "snippet", { idx: c }, () => [
                    k(f(u.snippet), 1)
                  ], !0)
                ], 2)
              ])
            ], 2)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])), [
          [
            s,
            r.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            s,
            r.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        r.hasDots ? (l(), h("div", {
          key: 0,
          class: p([{ "slider-dots-w-header": r.hasHeader }, "slider-dots"])
        }, [
          d("ul", Lie, [
            (l(!0), h(G, null, q(r.dotCount, (u) => (l(), h("li", {
              key: u,
              class: p({ activeStatIdx: u === r.activeStatIdx, unactiveStat: u !== r.activeStatIdx }),
              onClick: (c) => r.dotMove(u)
            }, t[5] || (t[5] = [
              d("span", { class: "circle" }, null, -1)
            ]), 10, Oie))), 128))
          ])
        ], 2)) : g("", !0)
      ], 2)
    ], 2),
    r.showArrows ? (l(), h("div", {
      key: 0,
      class: p(["navigation", { "navigation-w-header": r.hasHeader }])
    }, [
      d("div", {
        class: p(["arrows", { "arrows-w-header": r.hasHeader }])
      }, [
        d("button", {
          class: p(["left-arrow button-action", { "left-arrow-w-header": r.hasHeader }]),
          onClick: t[1] || (t[1] = (...u) => r.moveBack && r.moveBack(...u)),
          onKeydown: t[2] || (t[2] = N(D((...u) => r.moveBack && r.moveBack(...u), ["exact", "prevent"]), ["enter"]))
        }, [
          d("div", Nie, [
            (l(), h("svg", Hie, [
              d("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, Pie),
              d("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, Die)
            ])),
            t[6] || (t[6] = d("span", { class: "sr-only" }, "Reverse Slider", -1))
          ])
        ], 34),
        d("button", {
          class: p(["right-arrow button-action", { "right-arrow-w-header": r.hasHeader }]),
          onClick: t[3] || (t[3] = (u) => r.moveForward()),
          onKeydown: t[4] || (t[4] = N((u) => r.moveForward(), ["enter"]))
        }, [
          d("div", Rie, [
            (l(), h("svg", Vie, [
              d("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H63.9999V62.9999H0V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, Bie),
              d("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, Fie)
            ])),
            t[7] || (t[7] = d("span", { class: "sr-only" }, "Advance Slider", -1))
          ])
        ], 34)
      ], 2)
    ], 2)) : g("", !0)
  ], 6);
}
const Uie = /* @__PURE__ */ I(Mie, [["render", jie], ["__scopeId", "data-v-128a686c"]]), Kie = {
  name: "S3",
  mixins: [Ri]
}, Gie = ["data-testid"], zie = {
  key: 0,
  class: "header-top"
}, Zie = {
  key: 0,
  class: "stats-card-img"
}, Wie = ["src", "alt"], qie = {
  key: 1,
  class: "stats-content-body"
}, Yie = ["innerHTML"], xie = { class: "stats-card-body" }, Xie = { class: "stats-card-body-snippet-text" };
function Qie(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    class: p(["stats-s3", e.theme.style]),
    "data-testid": "S3",
    style: H(e.colors)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: "no-border"
        }, [
          e.displayHeaderTop ? (l(), h("span", zie, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.stats.component_header_top), 1)
            ], !0)
          ])) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.stats.component_header), 1)
          ], !0)
        ], 8, Gie)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-container stats-wrapper"
    }), {
      item: b(({ element: s, index: u }) => [
        d("div", {
          class: "stats-card",
          style: H({ backgroundColor: s.bg_color }),
          "data-testid": "stats-content"
        }, [
          C(e.$slots, "controls", { idx: u }, void 0, !0),
          s.bg_image ? (l(), h("div", Zie, [
            C(e.$slots, "image", { idx: u }, () => [
              s.bg_image.url ? (l(), h("img", {
                key: 0,
                class: "stat-card-img",
                src: s.bg_image.url,
                alt: s.bg_image.alt_text
              }, null, 8, Wie)) : g("", !0)
            ], !0)
          ])) : (l(), h("div", qie, [
            e.stats.icon ? (l(), h("div", {
              key: 0,
              class: "svg-wrapper",
              style: H({ fill: s.color })
            }, [
              C(e.$slots, "icon", { idx: u }, () => [
                d("span", {
                  class: "raw-svg",
                  "data-testid": "stats-icon",
                  innerHTML: s.icon
                }, null, 8, Yie)
              ], !0)
            ], 4)) : g("", !0),
            d("div", xie, [
              e.stats.headline ? (l(), h("div", {
                key: 0,
                class: "stats-card-body-headline",
                style: H({ color: s.color })
              }, [
                C(e.$slots, "headline", { idx: u }, () => [
                  d("h3", null, f(s.headline), 1)
                ], !0)
              ], 4)) : g("", !0),
              e.stats.snippet ? (l(), h("div", {
                key: 1,
                class: "stats-card-body-snippet",
                style: H({ color: s.color })
              }, [
                C(e.$slots, "snippet", { idx: u }, () => [
                  d("p", Xie, f(s.snippet), 1)
                ], !0)
              ], 4)) : g("", !0)
            ])
          ]))
        ], 4)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Jie = /* @__PURE__ */ I(Kie, [["render", Qie], ["__scopeId", "data-v-415159a8"]]), ese = {
  name: "S4",
  mixins: [Ri, We],
  components: {
    Pager: na
  },
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStatCardIndex: 0,
      statsImageCards: [],
      scrollInterval: () => {
      },
      sliderOverlayIndex: 0,
      pauseScroll: !1
    };
  },
  computed: {
    statsV4Colors() {
      var e, t, n, o, i, r, a, s;
      return de(oe({}, this.colors), {
        "--control-border-color": ((t = (e = this.theme) == null ? void 0 : e.button_border_color) == null ? void 0 : t.hex) || "#000",
        "--control-bg-color": ((o = (n = this.theme) == null ? void 0 : n.button_bg_color) == null ? void 0 : o.hex) || "#fff",
        "--pager-color": ((r = (i = this.theme) == null ? void 0 : i.pager_color) == null ? void 0 : r.hex) || "#fff",
        "--overlay-color": ((s = (a = this.theme) == null ? void 0 : a.overlay_color) == null ? void 0 : s.hex) || "#fff",
        "--overlay-opacity": `${this.theme.percentage_opacity || "80"}%`
      });
    },
    content() {
      return this.statsImageCards;
    },
    sliderCenterSize() {
      return this.mobileScreenSize ? 600 : 1e6;
    },
    mobileScreenSize() {
      return this.screenSize < 1023;
    },
    activeStat() {
      return this.mappedStats[this.currentStatCardIndex] || {
        top_stats: { headline: "", snippet: "" },
        bottom_stats: { headline: "", snippet: "" }
      };
    },
    mappedStats() {
      const e = this.startIndex ? this.stats.nested_content.slice(this.startIndex).concat(this.stats.nested_content.slice(0, this.startIndex)) : this.stats.nested_content;
      return (e == null ? void 0 : e.map((t, n) => de(oe({}, t), {
        left_image: de(oe({}, t.left_image), {
          internalIdx: n
        }),
        right_image: de(oe({}, t.right_image), {
          internalIdx: n
        })
      }))) || [];
    }
  },
  created() {
    this.statsImageCards = this.getStatsImageCards(), this.currentStatCardIndex = this.startIndex;
  },
  async mounted() {
    this.currentCard = Math.floor(this.statsImageCards.length / 2), await this.$nextTick(), this.mobileScreenSize && (this.currentCard -= 1), this.startScroll(), this.calculateScroll(!0);
  },
  beforeUnmount() {
    this.clearScroll();
  },
  methods: {
    startScroll() {
      this.isEditing || !this.mappedStats.length || (this.scrollInterval = setInterval(this.handleScroll, 4e3));
    },
    clearScroll() {
      clearInterval(this.scrollInterval);
    },
    getStatsImageCards() {
      var n, o, i, r;
      if (!this.mappedStats.length)
        return [];
      const e = [
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.left_image) || {}),
        de(oe({}, ((o = (n = this.mappedStats) == null ? void 0 : n[0]) == null ? void 0 : o.left_image) || {}), {
          position: "left_image"
        })
      ], t = [
        de(oe({}, ((r = (i = this.mappedStats) == null ? void 0 : i[0]) == null ? void 0 : r.right_image) || {}), {
          position: "right_image"
        }),
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.right_image) || {})
      ];
      return [...e, {}, ...t];
    },
    togglePlayPause() {
      if (this.pauseScroll = !this.pauseScroll, this.pauseScroll) {
        this.clearScroll();
        return;
      }
      this.startScroll();
    },
    async handleScroll(e) {
      if (this.isEditing || this.pauseScroll || this.mappedStats.length <= 1)
        return;
      this.currentStatCardIndex = e || (this.currentStatCardIndex + 1) % this.mappedStats.length, this.sliderOverlayIndex = this.currentStatCardIndex, await new Promise((o) => setTimeout(o, 1e3));
      const t = this.mappedStats[this.currentStatCardIndex].left_image;
      this.statsImageCards[this.currentCard] = oe({}, t);
      const n = this.mappedStats.at(this.currentStatCardIndex - 1).right_image;
      this.statsImageCards.push(oe({}, n)), this.statsImageCards.splice(0, 1), this.currentCard -= 1, this.mobileScreenSize && (this.currentCard -= 1), this.$refs.scrollWrapper.style["scroll-behavior"] = "auto", this.calculateScroll(), this.$refs.scrollWrapper.style["scroll-behavior"] = "smooth", await this.$nextTick(), this.scrollRight(), this.mobileScreenSize && (this.currentCard += 1);
    }
  }
}, tse = ["data-testid"], nse = ["data-testid"], ose = {
  class: "card-wrapper",
  ref: "scrollWrapper"
}, rse = { class: "stat-image-wrapper" }, ise = ["src", "alt"], sse = { class: "stats-pager" }, ase = { class: "stat-text-wrapper" }, lse = { class: "stats-action-button-container" }, dse = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, use = {
  key: 0,
  d: "M38 27.9984L23 36.3123L23 19.6846L38 27.9984Z",
  fill: "#333333"
};
function cse(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("Pager");
  return l(), h("div", {
    class: p(["stats-v4", { "is-editing": e.isEditing }, e.theme.style]),
    "data-testid": "S4",
    style: H(r.statsV4Colors)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.stats.component_header_top), 1)
            ], !0)
          ], 8, nse)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.stats.component_header), 1)
          ], !0)
        ], 8, tse)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", ose, [
      (l(!0), h(G, null, q(i.statsImageCards, (u, c) => (l(), h("div", {
        key: c,
        ref_for: !0,
        ref: `sliderCard-${c}`,
        class: p(["stat-card", e.isEditing && "is-editing"])
      }, [
        d("div", rse, [
          C(e.$slots, u.position ? "image" : "image-alt", {
            idx: c,
            position: u.position
          }, () => [
            d("img", {
              src: u.url ? u.url : "",
              alt: u.alt_text ? u.alt_text : "",
              class: "stat-image",
              loading: "lazy"
            }, null, 8, ise)
          ], !0),
          d("div", {
            class: p(["stat-image-overlay", { "overlay-visible": i.sliderOverlayIndex === u.internalIdx }])
          }, null, 2)
        ])
      ], 2))), 128)),
      d("div", {
        class: p(["stats-main-card stat-card", { "is-editing": e.isEditing }])
      }, [
        d("div", sse, [
          $(s, {
            "total-cards": r.mappedStats.length,
            "theme-styles": e.theme,
            "pager-color": e.theme.pager_color ? e.theme.pager_color.hex : "#fff",
            "current-card": i.currentStatCardIndex,
            "pager-section-count": r.mappedStats.length
          }, null, 8, ["total-cards", "theme-styles", "pager-color", "current-card", "pager-section-count"])
        ]),
        d("div", ase, [
          (l(), _(R(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: p(["stats-text-transition stat-top-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: b(() => [
              e.stats.headline ? (l(), h("div", {
                key: `${i.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                C(e.$slots, "headline", {}, () => [
                  k(f(r.activeStat.top_stats.headline), 1)
                ], !0)
              ])) : g("", !0),
              e.stats.snippet ? (l(), h("div", {
                key: `${i.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                C(e.$slots, "snippet", {}, () => [
                  k(f(r.activeStat.top_stats.snippet), 1)
                ], !0)
              ])) : g("", !0)
            ]),
            _: 3
          }, 8, ["class"])),
          t[1] || (t[1] = d("div", { class: "stats-divider" }, null, -1)),
          (l(), _(R(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: p(["stats-text-transition stat-bottom-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: b(() => [
              e.stats.headline ? (l(), h("div", {
                key: `${i.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                C(e.$slots, "bottom-headline", {}, () => [
                  k(f(r.activeStat.bottom_stats.headline), 1)
                ], !0)
              ])) : g("", !0),
              e.stats.snippet ? (l(), h("div", {
                key: `${i.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                C(e.$slots, "bottom-snippet", {}, () => [
                  k(f(r.activeStat.bottom_stats.snippet), 1)
                ], !0)
              ])) : g("", !0)
            ]),
            _: 3
          }, 8, ["class"]))
        ])
      ], 2)
    ], 512),
    d("div", lse, [
      d("button", {
        class: "stats-action-button",
        onClick: t[0] || (t[0] = (...u) => r.togglePlayPause && r.togglePlayPause(...u))
      }, [
        (l(), h("svg", dse, [
          d("g", null, [
            t[4] || (t[4] = d("rect", {
              x: "-0.5",
              y: "0.5",
              width: "55",
              height: "55",
              transform: "matrix(-1 0 0 1 55 0)",
              stroke: "#333333"
            }, null, -1)),
            i.pauseScroll ? (l(), h("path", use)) : (l(), h(G, { key: 1 }, [
              t[2] || (t[2] = d("path", {
                d: "M24 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1)),
              t[3] || (t[3] = d("path", {
                d: "M32 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1))
            ], 64))
          ])
        ]))
      ])
    ])
  ], 6);
}
const hse = /* @__PURE__ */ I(ese, [["render", cse], ["__scopeId", "data-v-d5450d08"]]), mse = {
  name: "Stats",
  components: {
    S1: Eie,
    S2: Uie,
    S3: Jie,
    S4: hse
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    startIndex: {
      type: Number,
      default: 0
    },
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function pse(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    stats: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "start-index": n.startIndex
  }, {
    "header-top": b(() => [
      C(e.$slots, "header-top")
    ]),
    header: b(() => [
      C(e.$slots, "header")
    ]),
    "stats-header": b(() => [
      C(e.$slots, "stats-header")
    ]),
    controls: b(({ idx: a }) => [
      C(e.$slots, "controls", { idx: a })
    ]),
    icon: b(({ idx: a }) => [
      C(e.$slots, "icon", { idx: a })
    ]),
    image: b(({ idx: a, position: s }) => [
      C(e.$slots, "image", {
        idx: a,
        position: s
      })
    ]),
    headline: b(({ idx: a }) => [
      C(e.$slots, "headline", { idx: a })
    ]),
    snippet: b(({ idx: a }) => [
      C(e.$slots, "snippet", { idx: a })
    ]),
    "bottom-headline": b(({ idx: a }) => [
      C(e.$slots, "bottom-headline", { idx: a })
    ]),
    "bottom-snippet": b(({ idx: a }) => [
      C(e.$slots, "bottom-snippet", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "stats", "wrapper-component", "wrapper-props", "is-editing", "start-index"]);
}
const fse = /* @__PURE__ */ I(mse, [["render", pse]]), za = {
  mixins: [rt, Qe],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPlaceholder: Boolean,
    videoSlotsItems: {
      type: Array,
      default: () => []
    },
    currentVideoThrillshare: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeItem: 0,
      isPlaying: !1,
      readMoreOpen: !1
    };
  },
  methods: {
    playPause(e, t, n) {
      const o = document.getElementById(e);
      if (!o) return;
      const i = n || (this.isPlaying ? "pause" : "play");
      if (t === "youtube")
        o.contentWindow.postMessage(`{"event":"command","func":"${i}Video","args":""}`, "*");
      else if (t === "vimeo") {
        const r = o.querySelector("iframe");
        r && r.contentWindow.postMessage(`{"method":"${i}"}`, "*");
      }
    },
    setIsPlaying({ isPlaying: e }) {
      this.isPlaying = e;
    },
    parseVideo(e) {
      let t = null;
      return e.match(
        /(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
      ), RegExp.$3.indexOf("youtu") > -1 ? t = "youtube" : RegExp.$3.indexOf("vimeo") > -1 && (t = "vimeo"), {
        type: t,
        id: RegExp.$6
      };
    },
    getThumbnail(e) {
      return `https://vumbnail.com/${e}_large.jpg`;
    }
  },
  watch: {
    currentVideoThrillshare(e, t) {
      t !== e && (this.activeItem = e);
    },
    content() {
      this.activeItem = this.currentVideoThrillshare;
    }
  },
  computed: {
    videoItems() {
      return this.content.videos.map((e) => {
        const { type: t, id: n } = this.parseVideo(e.url), o = this.getThumbnail(n, t);
        return de(oe({}, e), {
          type: t,
          thumbnail: o,
          videoId: n
        });
      });
    },
    currentItem() {
      return this.videoItems.length === 0 ? {} : this.videoItems[this.activeItem];
    },
    isDesktop() {
      return this.screenSize >= 960;
    },
    colors() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--heading-color": T(this.theme, "heading_color.hex", "#333"),
        "--header-accent-color": T(this.theme, "header_accent_color.hex", "#333"),
        "--video-title-color": T(this.theme, "video_title_color.hex", "#333"),
        "--video-text-color": T(this.theme, "video_text_color.hex", "#333"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "#333"),
        "--arrow-text-color": T(this.theme, "arrow_text_color.hex", "#fff"),
        "--pager-color": T(this.theme, "pager_color.hex", "#333")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayTopHeader() {
      return this.theme.style === "monterrey" && (this.content.component_header_top || this.isEditing);
    }
  }
};
var Za = { exports: {} }, Yn = typeof Reflect == "object" ? Reflect : null, bu = Yn && typeof Yn.apply == "function" ? Yn.apply : function(t, n, o) {
  return Function.prototype.apply.call(t, n, o);
}, Pr;
Yn && typeof Yn.ownKeys == "function" ? Pr = Yn.ownKeys : Object.getOwnPropertySymbols ? Pr = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Pr = function(t) {
  return Object.getOwnPropertyNames(t);
};
function gse(e) {
  console && console.warn && console.warn(e);
}
var T0 = Number.isNaN || function(t) {
  return t !== t;
};
function Te() {
  Te.init.call(this);
}
Za.exports = Te;
Za.exports.once = Cse;
Te.EventEmitter = Te;
Te.prototype._events = void 0;
Te.prototype._eventsCount = 0;
Te.prototype._maxListeners = void 0;
var yu = 10;
function Vi(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(Te, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return yu;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || T0(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    yu = e;
  }
});
Te.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Te.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || T0(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function k0(e) {
  return e._maxListeners === void 0 ? Te.defaultMaxListeners : e._maxListeners;
}
Te.prototype.getMaxListeners = function() {
  return k0(this);
};
Te.prototype.emit = function(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n.push(arguments[o]);
  var i = t === "error", r = this._events;
  if (r !== void 0)
    i = i && r.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (n.length > 0 && (a = n[0]), a instanceof Error)
      throw a;
    var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw s.context = a, s;
  }
  var u = r[t];
  if (u === void 0)
    return !1;
  if (typeof u == "function")
    bu(u, this, n);
  else
    for (var c = u.length, y = I0(u, c), o = 0; o < c; ++o)
      bu(y[o], this, n);
  return !0;
};
function E0(e, t, n, o) {
  var i, r, a;
  if (Vi(n), r = e._events, r === void 0 ? (r = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (r.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    n.listener ? n.listener : n
  ), r = e._events), a = r[t]), a === void 0)
    a = r[t] = n, ++e._eventsCount;
  else if (typeof a == "function" ? a = r[t] = o ? [n, a] : [a, n] : o ? a.unshift(n) : a.push(n), i = k0(e), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, gse(s);
  }
  return e;
}
Te.prototype.addListener = function(t, n) {
  return E0(this, t, n, !1);
};
Te.prototype.on = Te.prototype.addListener;
Te.prototype.prependListener = function(t, n) {
  return E0(this, t, n, !0);
};
function vse() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function S0(e, t, n) {
  var o = { fired: !1, wrapFn: void 0, target: e, type: t, listener: n }, i = vse.bind(o);
  return i.listener = n, o.wrapFn = i, i;
}
Te.prototype.once = function(t, n) {
  return Vi(n), this.on(t, S0(this, t, n)), this;
};
Te.prototype.prependOnceListener = function(t, n) {
  return Vi(n), this.prependListener(t, S0(this, t, n)), this;
};
Te.prototype.removeListener = function(t, n) {
  var o, i, r, a, s;
  if (Vi(n), i = this._events, i === void 0)
    return this;
  if (o = i[t], o === void 0)
    return this;
  if (o === n || o.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, o.listener || n));
  else if (typeof o != "function") {
    for (r = -1, a = o.length - 1; a >= 0; a--)
      if (o[a] === n || o[a].listener === n) {
        s = o[a].listener, r = a;
        break;
      }
    if (r < 0)
      return this;
    r === 0 ? o.shift() : bse(o, r), o.length === 1 && (i[t] = o[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || n);
  }
  return this;
};
Te.prototype.off = Te.prototype.removeListener;
Te.prototype.removeAllListeners = function(t) {
  var n, o, i;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[t]), this;
  if (arguments.length === 0) {
    var r = Object.keys(o), a;
    for (i = 0; i < r.length; ++i)
      a = r[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = o[t], typeof n == "function")
    this.removeListener(t, n);
  else if (n !== void 0)
    for (i = n.length - 1; i >= 0; i--)
      this.removeListener(t, n[i]);
  return this;
};
function M0(e, t, n) {
  var o = e._events;
  if (o === void 0)
    return [];
  var i = o[t];
  return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? yse(i) : I0(i, i.length);
}
Te.prototype.listeners = function(t) {
  return M0(this, t, !0);
};
Te.prototype.rawListeners = function(t) {
  return M0(this, t, !1);
};
Te.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : $0.call(e, t);
};
Te.prototype.listenerCount = $0;
function $0(e) {
  var t = this._events;
  if (t !== void 0) {
    var n = t[e];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
Te.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Pr(this._events) : [];
};
function I0(e, t) {
  for (var n = new Array(t), o = 0; o < t; ++o)
    n[o] = e[o];
  return n;
}
function bse(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function yse(e) {
  for (var t = new Array(e.length), n = 0; n < t.length; ++n)
    t[n] = e[n].listener || e[n];
  return t;
}
function Cse(e, t) {
  return new Promise(function(n, o) {
    function i(a) {
      e.removeListener(t, r), o(a);
    }
    function r() {
      typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
    }
    A0(e, t, r, { once: !0 }), t !== "error" && _se(e, i, { once: !0 });
  });
}
function _se(e, t, n) {
  typeof e.on == "function" && A0(e, "error", t, n);
}
function A0(e, t, n, o) {
  if (typeof e.on == "function")
    o.once ? e.once(t, n) : e.on(t, n);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function i(r) {
      o.once && e.removeEventListener(t, i), n(r);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var wse = Za.exports;
/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Tse = function(t, n, o) {
  return new Promise((i, r) => {
    const a = document.createElement("script");
    a.async = !0, a.src = t;
    for (const [u, c] of Object.entries(n || {}))
      a.setAttribute(u, c);
    a.onload = () => {
      a.onerror = a.onload = null, i(a);
    }, a.onerror = () => {
      a.onerror = a.onload = null, r(new Error(`Failed to load ${t}`));
    }, (o || document.head || document.getElementsByTagName("head")[0]).appendChild(a);
  });
};
/*! yt-player. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
const kse = wse.EventEmitter, Ese = Tse, Cu = "https://www.youtube.com/iframe_api", _u = {
  "-1": "unstarted",
  0: "ended",
  1: "playing",
  2: "paused",
  3: "buffering",
  5: "cued"
}, No = {
  // The request contains an invalid parameter value. For example, this error
  // occurs if you specify a videoId that does not have 11 characters, or if the
  // videoId contains invalid characters, such as exclamation points or asterisks.
  INVALID_PARAM: 2,
  // The requested content cannot be played in an HTML5 player or another error
  // related to the HTML5 player has occurred.
  HTML5_ERROR: 5,
  // The video requested was not found. This error occurs when a video has been
  // removed (for any reason) or has been marked as private.
  NOT_FOUND: 100,
  // The owner of the requested video does not allow it to be played in embedded
  // players.
  UNPLAYABLE_1: 101,
  // This error is the same as 101. It's just a 101 error in disguise!
  UNPLAYABLE_2: 150
}, Ho = [];
class Sse extends kse {
  constructor(t, n) {
    super();
    const o = typeof t == "string" ? document.querySelector(t) : t;
    o.id ? this._id = o.id : this._id = o.id = "ytplayer-" + Math.random().toString(16).slice(2, 8), this._opts = Object.assign({
      width: 640,
      height: 360,
      autoplay: !1,
      captions: void 0,
      controls: !0,
      keyboard: !0,
      fullscreen: !0,
      annotations: !0,
      modestBranding: !1,
      related: !0,
      timeupdateFrequency: 1e3,
      playsInline: !0,
      start: 0
    }, n), this.videoId = null, this.destroyed = !1, this._api = null, this._autoplay = !1, this._player = null, this._ready = !1, this._queue = [], this._interval = null, this._startInterval = this._startInterval.bind(this), this._stopInterval = this._stopInterval.bind(this), this.on("playing", this._startInterval), this.on("unstarted", this._stopInterval), this.on("ended", this._stopInterval), this.on("paused", this._stopInterval), this.on("buffering", this._stopInterval), this._loadIframeAPI((i, r) => {
      if (i) return this._destroy(new Error("YouTube Iframe API failed to load"));
      this._api = r, this.videoId && this.load(this.videoId, this._autoplay, this._start);
    });
  }
  load(t, n = !1, o = 0) {
    if (!this.destroyed && (this.videoId = t, this._autoplay = n, this._start = o, !!this._api)) {
      if (!this._player) {
        this._createPlayer(t);
        return;
      }
      this._ready && (n ? this._player.loadVideoById(t, o) : this._player.cueVideoById(t, o));
    }
  }
  play() {
    this._ready ? this._player.playVideo() : this._queueCommand("play");
  }
  pause() {
    this._ready ? this._player.pauseVideo() : this._queueCommand("pause");
  }
  stop() {
    this._ready ? this._player.stopVideo() : this._queueCommand("stop");
  }
  seek(t) {
    this._ready ? this._player.seekTo(t, !0) : this._queueCommand("seek", t);
  }
  setVolume(t) {
    this._ready ? this._player.setVolume(t) : this._queueCommand("setVolume", t);
  }
  getVolume() {
    return this._ready && this._player.getVolume() || 0;
  }
  mute() {
    this._ready ? this._player.mute() : this._queueCommand("mute");
  }
  unMute() {
    this._ready ? this._player.unMute() : this._queueCommand("unMute");
  }
  isMuted() {
    return this._ready && this._player.isMuted() || !1;
  }
  setSize(t, n) {
    this._ready ? this._player.setSize(t, n) : this._queueCommand("setSize", t, n);
  }
  setPlaybackRate(t) {
    this._ready ? this._player.setPlaybackRate(t) : this._queueCommand("setPlaybackRate", t);
  }
  setPlaybackQuality(t) {
    this._ready ? this._player.setPlaybackQuality(t) : this._queueCommand("setPlaybackQuality", t);
  }
  getPlaybackRate() {
    return this._ready && this._player.getPlaybackRate() || 1;
  }
  getAvailablePlaybackRates() {
    return this._ready && this._player.getAvailablePlaybackRates() || [1];
  }
  getDuration() {
    return this._ready && this._player.getDuration() || 0;
  }
  getProgress() {
    return this._ready && this._player.getVideoLoadedFraction() || 0;
  }
  getState() {
    return this._ready && _u[this._player.getPlayerState()] || "unstarted";
  }
  getCurrentTime() {
    return this._ready && this._player.getCurrentTime() || 0;
  }
  destroy() {
    this._destroy();
  }
  _destroy(t) {
    this.destroyed || (this.destroyed = !0, this._player && (this._player.stopVideo && this._player.stopVideo(), this._player.destroy()), this.videoId = null, this._id = null, this._opts = null, this._api = null, this._player = null, this._ready = !1, this._queue = null, this._stopInterval(), this.removeListener("playing", this._startInterval), this.removeListener("paused", this._stopInterval), this.removeListener("buffering", this._stopInterval), this.removeListener("unstarted", this._stopInterval), this.removeListener("ended", this._stopInterval), t && this.emit("error", t));
  }
  _queueCommand(t, ...n) {
    this.destroyed || this._queue.push([t, n]);
  }
  _flushQueue() {
    for (; this._queue.length; ) {
      const t = this._queue.shift();
      this[t[0]].apply(this, t[1]);
    }
  }
  _loadIframeAPI(t) {
    if (window.YT && typeof window.YT.Player == "function")
      return t(null, window.YT);
    Ho.push(t), Array.from(document.getElementsByTagName("script")).some((r) => r.src === Cu) || Ese(Cu).catch((r) => {
      for (; Ho.length; )
        Ho.shift()(r);
    });
    const i = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      for (typeof i == "function" && i(); Ho.length; )
        Ho.shift()(null, window.YT);
    };
  }
  _createPlayer(t) {
    if (this.destroyed) return;
    const n = this._opts;
    this._player = new this._api.Player(this._id, {
      width: n.width,
      height: n.height,
      videoId: t,
      // (Not part of documented API) This parameter controls the hostname that
      // videos are loaded from. Set to `'https://www.youtube-nocookie.com'`
      // for enhanced privacy.
      host: n.host,
      playerVars: {
        // This parameter specifies whether the initial video will automatically
        // start to play when the player loads. Supported values are 0 or 1. The
        // default value is 0.
        autoplay: n.autoplay ? 1 : 0,
        // Setting the parameter's value to 1 causes closed captions to be shown
        // by default, even if the user has turned captions off. The default
        // behavior is based on user preference.
        cc_load_policy: n.captions != null ? n.captions !== !1 ? 1 : 0 : void 0,
        // default to not setting this option
        // Sets the player's interface language. The parameter value is an ISO
        // 639-1 two-letter language code or a fully specified locale. For
        // example, fr and fr-ca are both valid values. Other language input
        // codes, such as IETF language tags (BCP 47) might also be handled
        // properly.
        hl: n.captions != null && n.captions !== !1 ? n.captions : void 0,
        // default to not setting this option
        // This parameter specifies the default language that the player will
        // use to display captions. Set the parameter's value to an ISO 639-1
        // two-letter language code.
        cc_lang_pref: n.captions != null && n.captions !== !1 ? n.captions : void 0,
        // default to not setting this option
        // This parameter indicates whether the video player controls are
        // displayed. For IFrame embeds that load a Flash player, it also defines
        // when the controls display in the player as well as when the player
        // will load. Supported values are:
        //   - controls=0 – Player controls do not display in the player. For
        //                  IFrame embeds, the Flash player loads immediately.
        //   - controls=1 – (default) Player controls display in the player. For
        //                  IFrame embeds, the controls display immediately and
        //                  the Flash player also loads immediately.
        //   - controls=2 – Player controls display in the player. For IFrame
        //                  embeds, the controls display and the Flash player
        //                  loads after the user initiates the video playback.
        controls: n.controls ? 2 : 0,
        // Setting the parameter's value to 1 causes the player to not respond to
        // keyboard controls. The default value is 0, which means that keyboard
        // controls are enabled.
        disablekb: n.keyboard ? 0 : 1,
        // Setting the parameter's value to 1 enables the player to be
        // controlled via IFrame or JavaScript Player API calls. The default
        // value is 0, which means that the player cannot be controlled using
        // those APIs.
        enablejsapi: 1,
        // Setting this parameter to 0 prevents the fullscreen button from
        // displaying in the player. The default value is 1, which causes the
        // fullscreen button to display.
        fs: n.fullscreen ? 1 : 0,
        // Setting the parameter's value to 1 causes video annotations to be
        // shown by default, whereas setting to 3 causes video annotations to not
        // be shown by default. The default value is 1.
        iv_load_policy: n.annotations ? 1 : 3,
        // This parameter lets you use a YouTube player that does not show a
        // YouTube logo. Set the parameter value to 1 to prevent the YouTube logo
        // from displaying in the control bar. Note that a small YouTube text
        // label will still display in the upper-right corner of a paused video
        // when the user's mouse pointer hovers over the player.
        modestbranding: n.modestBranding ? 1 : 0,
        // This parameter provides an extra security measure for the IFrame API
        // and is only supported for IFrame embeds. If you are using the IFrame
        // API, which means you are setting the enablejsapi parameter value to 1,
        // you should always specify your domain as the origin parameter value.
        origin: window.location.origin,
        // This parameter controls whether videos play inline or fullscreen in an
        // HTML5 player on iOS. Valid values are:
        //   - 0: This value causes fullscreen playback. This is currently the
        //        default value, though the default is subject to change.
        //   - 1: This value causes inline playback for UIWebViews created with
        //        the allowsInlineMediaPlayback property set to TRUE.
        playsinline: n.playsInline ? 1 : 0,
        // This parameter indicates whether the player should show related
        // videos from the same channel (0) or from any channel (1) when
        // playback of the video ends. The default value is 1.
        rel: n.related ? 1 : 0,
        // (Not part of documented API) Allow html elements with higher z-index
        // to be shown on top of the YouTube player.
        wmode: "opaque",
        // This parameter causes the player to begin playing the video at the given number
        // of seconds from the start of the video. The parameter value is a positive integer.
        // Note that similar to the seek function, the player will look for the closest
        // keyframe to the time you specify. This means that sometimes the play head may seek
        // to just before the requested time, usually no more than around two seconds.
        start: n.start
      },
      events: {
        onReady: () => this._onReady(t),
        onStateChange: (o) => this._onStateChange(o),
        onPlaybackQualityChange: (o) => this._onPlaybackQualityChange(o),
        onPlaybackRateChange: (o) => this._onPlaybackRateChange(o),
        onError: (o) => this._onError(o)
      }
    });
  }
  /**
   * This event fires when the player has finished loading and is ready to begin
   * receiving API calls.
   */
  _onReady(t) {
    this.destroyed || (this._ready = !0, this.load(this.videoId, this._autoplay, this._start), this._flushQueue());
  }
  /**
   * Called when the player's state changes. We emit friendly events so the user
   * doesn't need to use YouTube's YT.PlayerState.* event constants.
   */
  _onStateChange(t) {
    if (this.destroyed) return;
    const n = _u[t.data];
    if (n)
      ["paused", "buffering", "ended"].includes(n) && this._onTimeupdate(), this.emit(n), ["unstarted", "playing", "cued"].includes(n) && this._onTimeupdate();
    else
      throw new Error("Unrecognized state change: " + t);
  }
  /**
   * This event fires whenever the video playback quality changes. Possible
   * values are: 'small', 'medium', 'large', 'hd720', 'hd1080', 'highres'.
   */
  _onPlaybackQualityChange(t) {
    this.destroyed || this.emit("playbackQualityChange", t.data);
  }
  /**
   * This event fires whenever the video playback rate changes.
   */
  _onPlaybackRateChange(t) {
    this.destroyed || this.emit("playbackRateChange", t.data);
  }
  /**
   * This event fires if an error occurs in the player.
   */
  _onError(t) {
    if (this.destroyed) return;
    const n = Number(t.data);
    if (n !== No.HTML5_ERROR) {
      if (n === No.UNPLAYABLE_1 || n === No.UNPLAYABLE_2 || n === No.NOT_FOUND || n === No.INVALID_PARAM)
        return this.emit("unplayable", this.videoId);
      this._destroy(new Error("YouTube Player Error. Unknown error code: " + n));
    }
  }
  /**
   * This event fires when the time indicated by the `getCurrentTime()` method
   * has been updated.
   */
  _onTimeupdate() {
    this.emit("timeupdate", this.getCurrentTime());
  }
  _startInterval() {
    this._interval = setInterval(() => this._onTimeupdate(), this._opts.timeupdateFrequency);
  }
  _stopInterval() {
    clearInterval(this._interval), this._interval = null;
  }
}
var Mse = Sse;
const $se = /* @__PURE__ */ Qn(Mse);
/*! @vimeo/player v2.25.1 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function wu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Tu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wu(Object(n), !0).forEach(function(o) {
      Dr(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wu(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function ze() {
  ze = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, o = Object.defineProperty || function(Z, P, V) {
    Z[P] = V.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, r = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function u(Z, P, V) {
    return Object.defineProperty(Z, P, {
      value: V,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), Z[P];
  }
  try {
    u({}, "");
  } catch (Z) {
    u = function(P, V, Q) {
      return P[V] = Q;
    };
  }
  function c(Z, P, V, Q) {
    var ee = P && P.prototype instanceof v ? P : v, se = Object.create(ee.prototype), ce = new le(Q || []);
    return o(se, "_invoke", {
      value: Y(Z, V, ce)
    }), se;
  }
  function y(Z, P, V) {
    try {
      return {
        type: "normal",
        arg: Z.call(P, V)
      };
    } catch (Q) {
      return {
        type: "throw",
        arg: Q
      };
    }
  }
  e.wrap = c;
  var w = {};
  function v() {
  }
  function E() {
  }
  function F() {
  }
  var O = {};
  u(O, r, function() {
    return this;
  });
  var L = Object.getPrototypeOf, U = L && L(L(Re([])));
  U && U !== t && n.call(U, r) && (O = U);
  var z = F.prototype = v.prototype = Object.create(O);
  function B(Z) {
    ["next", "throw", "return"].forEach(function(P) {
      u(Z, P, function(V) {
        return this._invoke(P, V);
      });
    });
  }
  function j(Z, P) {
    function V(ee, se, ce, ue) {
      var ve = y(Z[ee], Z, se);
      if (ve.type !== "throw") {
        var $e = ve.arg, et = $e.value;
        return et && typeof et == "object" && n.call(et, "__await") ? P.resolve(et.__await).then(function(tt) {
          V("next", tt, ce, ue);
        }, function(tt) {
          V("throw", tt, ce, ue);
        }) : P.resolve(et).then(function(tt) {
          $e.value = tt, ce($e);
        }, function(tt) {
          return V("throw", tt, ce, ue);
        });
      }
      ue(ve.arg);
    }
    var Q;
    o(this, "_invoke", {
      value: function(ee, se) {
        function ce() {
          return new P(function(ue, ve) {
            V(ee, se, ue, ve);
          });
        }
        return Q = Q ? Q.then(ce, ce) : ce();
      }
    });
  }
  function Y(Z, P, V) {
    var Q = "suspendedStart";
    return function(ee, se) {
      if (Q === "executing") throw new Error("Generator is already running");
      if (Q === "completed") {
        if (ee === "throw") throw se;
        return mt();
      }
      for (V.method = ee, V.arg = se; ; ) {
        var ce = V.delegate;
        if (ce) {
          var ue = K(ce, V);
          if (ue) {
            if (ue === w) continue;
            return ue;
          }
        }
        if (V.method === "next") V.sent = V._sent = V.arg;
        else if (V.method === "throw") {
          if (Q === "suspendedStart") throw Q = "completed", V.arg;
          V.dispatchException(V.arg);
        } else V.method === "return" && V.abrupt("return", V.arg);
        Q = "executing";
        var ve = y(Z, P, V);
        if (ve.type === "normal") {
          if (Q = V.done ? "completed" : "suspendedYield", ve.arg === w) continue;
          return {
            value: ve.arg,
            done: V.done
          };
        }
        ve.type === "throw" && (Q = "completed", V.method = "throw", V.arg = ve.arg);
      }
    };
  }
  function K(Z, P) {
    var V = P.method, Q = Z.iterator[V];
    if (Q === void 0) return P.delegate = null, V === "throw" && Z.iterator.return && (P.method = "return", P.arg = void 0, K(Z, P), P.method === "throw") || V !== "return" && (P.method = "throw", P.arg = new TypeError("The iterator does not provide a '" + V + "' method")), w;
    var ee = y(Q, Z.iterator, P.arg);
    if (ee.type === "throw") return P.method = "throw", P.arg = ee.arg, P.delegate = null, w;
    var se = ee.arg;
    return se ? se.done ? (P[Z.resultName] = se.value, P.next = Z.nextLoc, P.method !== "return" && (P.method = "next", P.arg = void 0), P.delegate = null, w) : se : (P.method = "throw", P.arg = new TypeError("iterator result is not an object"), P.delegate = null, w);
  }
  function ne(Z) {
    var P = {
      tryLoc: Z[0]
    };
    1 in Z && (P.catchLoc = Z[1]), 2 in Z && (P.finallyLoc = Z[2], P.afterLoc = Z[3]), this.tryEntries.push(P);
  }
  function te(Z) {
    var P = Z.completion || {};
    P.type = "normal", delete P.arg, Z.completion = P;
  }
  function le(Z) {
    this.tryEntries = [{
      tryLoc: "root"
    }], Z.forEach(ne, this), this.reset(!0);
  }
  function Re(Z) {
    if (Z) {
      var P = Z[r];
      if (P) return P.call(Z);
      if (typeof Z.next == "function") return Z;
      if (!isNaN(Z.length)) {
        var V = -1, Q = function ee() {
          for (; ++V < Z.length; ) if (n.call(Z, V)) return ee.value = Z[V], ee.done = !1, ee;
          return ee.value = void 0, ee.done = !0, ee;
        };
        return Q.next = Q;
      }
    }
    return {
      next: mt
    };
  }
  function mt() {
    return {
      value: void 0,
      done: !0
    };
  }
  return E.prototype = F, o(z, "constructor", {
    value: F,
    configurable: !0
  }), o(F, "constructor", {
    value: E,
    configurable: !0
  }), E.displayName = u(F, s, "GeneratorFunction"), e.isGeneratorFunction = function(Z) {
    var P = typeof Z == "function" && Z.constructor;
    return !!P && (P === E || (P.displayName || P.name) === "GeneratorFunction");
  }, e.mark = function(Z) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Z, F) : (Z.__proto__ = F, u(Z, s, "GeneratorFunction")), Z.prototype = Object.create(z), Z;
  }, e.awrap = function(Z) {
    return {
      __await: Z
    };
  }, B(j.prototype), u(j.prototype, a, function() {
    return this;
  }), e.AsyncIterator = j, e.async = function(Z, P, V, Q, ee) {
    ee === void 0 && (ee = Promise);
    var se = new j(c(Z, P, V, Q), ee);
    return e.isGeneratorFunction(P) ? se : se.next().then(function(ce) {
      return ce.done ? ce.value : se.next();
    });
  }, B(z), u(z, s, "Generator"), u(z, r, function() {
    return this;
  }), u(z, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(Z) {
    var P = Object(Z), V = [];
    for (var Q in P) V.push(Q);
    return V.reverse(), function ee() {
      for (; V.length; ) {
        var se = V.pop();
        if (se in P) return ee.value = se, ee.done = !1, ee;
      }
      return ee.done = !0, ee;
    };
  }, e.values = Re, le.prototype = {
    constructor: le,
    reset: function(Z) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(te), !Z) for (var P in this) P.charAt(0) === "t" && n.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = void 0);
    },
    stop: function() {
      this.done = !0;
      var Z = this.tryEntries[0].completion;
      if (Z.type === "throw") throw Z.arg;
      return this.rval;
    },
    dispatchException: function(Z) {
      if (this.done) throw Z;
      var P = this;
      function V(ve, $e) {
        return se.type = "throw", se.arg = Z, P.next = ve, $e && (P.method = "next", P.arg = void 0), !!$e;
      }
      for (var Q = this.tryEntries.length - 1; Q >= 0; --Q) {
        var ee = this.tryEntries[Q], se = ee.completion;
        if (ee.tryLoc === "root") return V("end");
        if (ee.tryLoc <= this.prev) {
          var ce = n.call(ee, "catchLoc"), ue = n.call(ee, "finallyLoc");
          if (ce && ue) {
            if (this.prev < ee.catchLoc) return V(ee.catchLoc, !0);
            if (this.prev < ee.finallyLoc) return V(ee.finallyLoc);
          } else if (ce) {
            if (this.prev < ee.catchLoc) return V(ee.catchLoc, !0);
          } else {
            if (!ue) throw new Error("try statement without catch or finally");
            if (this.prev < ee.finallyLoc) return V(ee.finallyLoc);
          }
        }
      }
    },
    abrupt: function(Z, P) {
      for (var V = this.tryEntries.length - 1; V >= 0; --V) {
        var Q = this.tryEntries[V];
        if (Q.tryLoc <= this.prev && n.call(Q, "finallyLoc") && this.prev < Q.finallyLoc) {
          var ee = Q;
          break;
        }
      }
      ee && (Z === "break" || Z === "continue") && ee.tryLoc <= P && P <= ee.finallyLoc && (ee = null);
      var se = ee ? ee.completion : {};
      return se.type = Z, se.arg = P, ee ? (this.method = "next", this.next = ee.finallyLoc, w) : this.complete(se);
    },
    complete: function(Z, P) {
      if (Z.type === "throw") throw Z.arg;
      return Z.type === "break" || Z.type === "continue" ? this.next = Z.arg : Z.type === "return" ? (this.rval = this.arg = Z.arg, this.method = "return", this.next = "end") : Z.type === "normal" && P && (this.next = P), w;
    },
    finish: function(Z) {
      for (var P = this.tryEntries.length - 1; P >= 0; --P) {
        var V = this.tryEntries[P];
        if (V.finallyLoc === Z) return this.complete(V.completion, V.afterLoc), te(V), w;
      }
    },
    catch: function(Z) {
      for (var P = this.tryEntries.length - 1; P >= 0; --P) {
        var V = this.tryEntries[P];
        if (V.tryLoc === Z) {
          var Q = V.completion;
          if (Q.type === "throw") {
            var ee = Q.arg;
            te(V);
          }
          return ee;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(Z, P, V) {
      return this.delegate = {
        iterator: Re(Z),
        resultName: P,
        nextLoc: V
      }, this.method === "next" && (this.arg = void 0), w;
    }
  }, e;
}
function ku(e, t, n, o, i, r, a) {
  try {
    var s = e[r](a), u = s.value;
  } catch (c) {
    n(c);
    return;
  }
  s.done ? t(u) : Promise.resolve(u).then(o, i);
}
function yn(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(o, i) {
      var r = e.apply(t, n);
      function a(u) {
        ku(r, o, i, a, s, "next", u);
      }
      function s(u) {
        ku(r, o, i, a, s, "throw", u);
      }
      a(void 0);
    });
  };
}
function L0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ise(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, H0(o.key), o);
  }
}
function O0(e, t, n) {
  return t && Ise(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Dr(e, t, n) {
  return t = H0(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ase(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Yo(e, t);
}
function qo(e) {
  return qo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, qo(e);
}
function Yo(e, t) {
  return Yo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
    return o.__proto__ = i, o;
  }, Yo(e, t);
}
function N0() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function Rr(e, t, n) {
  return N0() ? Rr = Reflect.construct.bind() : Rr = function(i, r, a) {
    var s = [null];
    s.push.apply(s, r);
    var u = Function.bind.apply(i, s), c = new u();
    return a && Yo(c, a.prototype), c;
  }, Rr.apply(null, arguments);
}
function Lse(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Xs(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Xs = function(o) {
    if (o === null || !Lse(o)) return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(o)) return t.get(o);
      t.set(o, i);
    }
    function i() {
      return Rr(o, arguments, qo(this).constructor);
    }
    return i.prototype = Object.create(o.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Yo(i, o);
  }, Xs(e);
}
function Vr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ose(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vr(e);
}
function Nse(e) {
  var t = N0();
  return function() {
    var o = qo(e), i;
    if (t) {
      var r = qo(this).constructor;
      i = Reflect.construct(o, arguments, r);
    } else
      i = o.apply(this, arguments);
    return Ose(this, i);
  };
}
function Hse(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function H0(e) {
  var t = Hse(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var P0 = typeof global != "undefined" && {}.toString.call(global) === "[object global]";
function Eu(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function Pse(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function Dse(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function kn(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function D0(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function Rse(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), o = [".videoji.hk", ".vimeo.work", ".videoji.cn"], i = 0, r = o; i < r.length; i++) {
    var a = r[i];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function R0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, o = t || n;
  if (!o)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (Dse(o))
    return "https://vimeo.com/".concat(o);
  if (kn(o))
    return o.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(o, "” is not a vimeo.com url."));
}
var Su = function(t, n, o) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[i](s, o);
  }), {
    cancel: function() {
      return a.forEach(function(u) {
        return t[r](u, o);
      });
    }
  };
}, Vse = typeof Array.prototype.indexOf != "undefined", Bse = typeof window != "undefined" && typeof window.postMessage != "undefined";
if (!P0 && (!Vse || !Bse))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var xn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Fse(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch (r) {
    }
  }(), o = function(r, a, s) {
    n ? Object.defineProperty(r, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : r[a] = s;
  };
  e.WeakMap = function() {
    function r() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (o(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    o(r.prototype, "delete", function(c) {
      if (a(this, "delete"), !i(c))
        return !1;
      var y = c[this._id];
      return y && y[0] === c ? (delete c[this._id], !0) : !1;
    }), o(r.prototype, "get", function(c) {
      if (a(this, "get"), !!i(c)) {
        var y = c[this._id];
        if (y && y[0] === c)
          return y[1];
      }
    }), o(r.prototype, "has", function(c) {
      if (a(this, "has"), !i(c))
        return !1;
      var y = c[this._id];
      return !!(y && y[0] === c);
    }), o(r.prototype, "set", function(c, y) {
      if (a(this, "set"), !i(c))
        throw new TypeError("Invalid value used as weak map key");
      var w = c[this._id];
      return w && w[0] === c ? (w[1] = y, this) : (o(c, this._id, [c, y]), this);
    });
    function a(c, y) {
      if (!i(c) || !t.call(c, "_id"))
        throw new TypeError(y + " method called on incompatible receiver " + typeof c);
    }
    function s(c) {
      return c + "_" + u() + "." + u();
    }
    function u() {
      return Math.random().toString().substring(2);
    }
    return o(r, "_polyfill", !0), r;
  }();
  function i(r) {
    return Object(r) === r;
  }
})(typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : xn);
var at = Fse(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, o, i) {
    o[n] = o[n] || i(), e.exports && (e.exports = o[n]);
  })("Promise", xn, function() {
    var n, o, i, r = Object.prototype.toString, a = typeof setImmediate != "undefined" ? function(B) {
      return setImmediate(B);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(B, j, Y, K) {
        return Object.defineProperty(B, j, {
          value: Y,
          writable: !0,
          configurable: K !== !1
        });
      };
    } catch (z) {
      n = function(j, Y, K) {
        return j[Y] = K, j;
      };
    }
    i = /* @__PURE__ */ function() {
      var B, j, Y;
      function K(ne, te) {
        this.fn = ne, this.self = te, this.next = void 0;
      }
      return {
        add: function(te, le) {
          Y = new K(te, le), j ? j.next = Y : B = Y, j = Y, Y = void 0;
        },
        drain: function() {
          var te = B;
          for (B = j = o = void 0; te; )
            te.fn.call(te.self), te = te.next;
        }
      };
    }();
    function s(z, B) {
      i.add(z, B), o || (o = a(i.drain));
    }
    function u(z) {
      var B, j = typeof z;
      return z != null && (j == "object" || j == "function") && (B = z.then), typeof B == "function" ? B : !1;
    }
    function c() {
      for (var z = 0; z < this.chain.length; z++)
        y(this, this.state === 1 ? this.chain[z].success : this.chain[z].failure, this.chain[z]);
      this.chain.length = 0;
    }
    function y(z, B, j) {
      var Y, K;
      try {
        B === !1 ? j.reject(z.msg) : (B === !0 ? Y = z.msg : Y = B.call(void 0, z.msg), Y === j.promise ? j.reject(TypeError("Promise-chain cycle")) : (K = u(Y)) ? K.call(Y, j.resolve, j.reject) : j.resolve(Y));
      } catch (ne) {
        j.reject(ne);
      }
    }
    function w(z) {
      var B, j = this;
      if (!j.triggered) {
        j.triggered = !0, j.def && (j = j.def);
        try {
          (B = u(z)) ? s(function() {
            var Y = new F(j);
            try {
              B.call(z, function() {
                w.apply(Y, arguments);
              }, function() {
                v.apply(Y, arguments);
              });
            } catch (K) {
              v.call(Y, K);
            }
          }) : (j.msg = z, j.state = 1, j.chain.length > 0 && s(c, j));
        } catch (Y) {
          v.call(new F(j), Y);
        }
      }
    }
    function v(z) {
      var B = this;
      B.triggered || (B.triggered = !0, B.def && (B = B.def), B.msg = z, B.state = 2, B.chain.length > 0 && s(c, B));
    }
    function E(z, B, j, Y) {
      for (var K = 0; K < B.length; K++)
        (function(te) {
          z.resolve(B[te]).then(function(Re) {
            j(te, Re);
          }, Y);
        })(K);
    }
    function F(z) {
      this.def = z, this.triggered = !1;
    }
    function O(z) {
      this.promise = z, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function L(z) {
      if (typeof z != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var B = new O(this);
      this.then = function(Y, K) {
        var ne = {
          success: typeof Y == "function" ? Y : !0,
          failure: typeof K == "function" ? K : !1
        };
        return ne.promise = new this.constructor(function(le, Re) {
          if (typeof le != "function" || typeof Re != "function")
            throw TypeError("Not a function");
          ne.resolve = le, ne.reject = Re;
        }), B.chain.push(ne), B.state !== 0 && s(c, B), ne.promise;
      }, this.catch = function(Y) {
        return this.then(void 0, Y);
      };
      try {
        z.call(void 0, function(Y) {
          w.call(B, Y);
        }, function(Y) {
          v.call(B, Y);
        });
      } catch (j) {
        v.call(B, j);
      }
    }
    var U = n(
      {},
      "constructor",
      L,
      /*configurable=*/
      !1
    );
    return L.prototype = U, n(
      U,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(L, "resolve", function(B) {
      var j = this;
      return B && typeof B == "object" && B.__NPO__ === 1 ? B : new j(function(K, ne) {
        if (typeof K != "function" || typeof ne != "function")
          throw TypeError("Not a function");
        K(B);
      });
    }), n(L, "reject", function(B) {
      return new this(function(Y, K) {
        if (typeof Y != "function" || typeof K != "function")
          throw TypeError("Not a function");
        K(B);
      });
    }), n(L, "all", function(B) {
      var j = this;
      return r.call(B) != "[object Array]" ? j.reject(TypeError("Not an array")) : B.length === 0 ? j.resolve([]) : new j(function(K, ne) {
        if (typeof K != "function" || typeof ne != "function")
          throw TypeError("Not a function");
        var te = B.length, le = Array(te), Re = 0;
        E(j, B, function(Z, P) {
          le[Z] = P, ++Re === te && K(le);
        }, ne);
      });
    }), n(L, "race", function(B) {
      var j = this;
      return r.call(B) != "[object Array]" ? j.reject(TypeError("Not an array")) : new j(function(K, ne) {
        if (typeof K != "function" || typeof ne != "function")
          throw TypeError("Not a function");
        E(j, B, function(le, Re) {
          K(Re);
        }, ne);
      });
    }), L;
  });
}), jt = /* @__PURE__ */ new WeakMap();
function Po(e, t, n) {
  var o = jt.get(e.element) || {};
  t in o || (o[t] = []), o[t].push(n), jt.set(e.element, o);
}
function ni(e, t) {
  var n = jt.get(e.element) || {};
  return n[t] || [];
}
function oi(e, t, n) {
  var o = jt.get(e.element) || {};
  if (!o[t])
    return !0;
  if (!n)
    return o[t] = [], jt.set(e.element, o), !0;
  var i = o[t].indexOf(n);
  return i !== -1 && o[t].splice(i, 1), jt.set(e.element, o), o[t] && o[t].length === 0;
}
function jse(e, t) {
  var n = ni(e, t);
  if (n.length < 1)
    return !1;
  var o = n.shift();
  return oi(e, t, o), o;
}
function Use(e, t) {
  var n = jt.get(e);
  jt.set(t, n), jt.delete(e);
}
function Bi(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function pn(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var o = {
      method: t
    };
    n !== void 0 && (o.value = n);
    var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    i >= 8 && i < 10 && (o = JSON.stringify(o)), e.element.contentWindow.postMessage(o, e.origin);
  }
}
function Kse(e, t) {
  t = Bi(t);
  var n = [], o;
  if (t.event) {
    if (t.event === "error") {
      var i = ni(e, t.data.method);
      i.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), oi(e, t.data.method, a);
      });
    }
    n = ni(e, "event:".concat(t.event)), o = t.data;
  } else if (t.method) {
    var r = jse(e, t.method);
    r && (n.push(r), o = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, o);
        return;
      }
      a.resolve(o);
    } catch (s) {
    }
  });
}
var Gse = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function V0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Gse.reduce(function(n, o) {
    var i = e.getAttribute("data-vimeo-".concat(o));
    return (i || i === "") && (n[o] = i === "" ? 1 : i), n;
  }, t);
}
function Wa(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var o = document.createElement("div");
  return o.innerHTML = n, t.appendChild(o.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function B0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(o, i) {
    if (!kn(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var r = Rse(e), a = "https://".concat(r, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var u = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    u.open("GET", a, !0), u.onload = function() {
      if (u.status === 404) {
        i(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (u.status === 403) {
        i(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var c = JSON.parse(u.responseText);
        if (c.domain_status_code === 403) {
          Wa(c, n), i(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        o(c);
      } catch (y) {
        i(y);
      }
    }, u.onerror = function() {
      var c = u.status ? " (".concat(u.status, ")") : "";
      i(new Error("There was an error fetching the embed code from Vimeo".concat(c, ".")));
    }, u.send();
  });
}
function zse() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(i) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(i));
  };
  t.forEach(function(o) {
    try {
      if (o.getAttribute("data-vimeo-defer") !== null)
        return;
      var i = V0(o), r = R0(i);
      B0(r, i, o).then(function(a) {
        return Wa(a, o);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function Zse() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(o) {
      if (kn(o.origin) && !(!o.data || o.data.event !== "spacechange")) {
        for (var i = e.querySelectorAll("iframe"), r = 0; r < i.length; r++)
          if (i[r].contentWindow === o.source) {
            var a = i[r].parentElement;
            a.style.paddingBottom = "".concat(o.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function Wse() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(o) {
      if (kn(o.origin)) {
        var i = Bi(o.data);
        if (!(!i || i.event !== "ready"))
          for (var r = e.querySelectorAll("iframe"), a = 0; a < r.length; a++) {
            var s = r[a], u = s.contentWindow === o.source;
            if (D0(s.src) && u) {
              var c = new qa(s);
              c.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function qse() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(i) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(i));
    }, n = function(i) {
      if (kn(i.origin)) {
        var r = Bi(i.data);
        if (!(!r || r.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var y = a[u], w = y.contentWindow === i.source;
            if (D0(y.src) && w) {
              var v = new qa(y);
              v.getVideoId().then(function(E) {
                var F = new RegExp("[?&]vimeo_t_".concat(E, "=([^&#]*)")).exec(window.location.href);
                if (F && F[1]) {
                  var O = decodeURI(F[1]);
                  v.setCurrentTime(O);
                }
              }).catch(t);
            }
          }, u = 0; u < a.length; u++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function Yse() {
  var e = function() {
    for (var o, i = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], r = 0, a = i.length, s = {}; r < a; r++)
      if (o = i[r], o && o[1] in document) {
        for (r = 0; r < o.length; r++)
          s[i[0][r]] = o[r];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(i) {
      return new Promise(function(r, a) {
        var s = function c() {
          n.off("fullscreenchange", c), r();
        };
        n.on("fullscreenchange", s), i = i || document.documentElement;
        var u = i[e.requestFullscreen]();
        u instanceof Promise && u.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(i, r) {
        if (!n.isFullscreen) {
          i();
          return;
        }
        var a = function u() {
          n.off("fullscreenchange", u), i();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(r);
      });
    },
    on: function(i, r) {
      var a = t[i];
      a && document.addEventListener(a, r);
    },
    off: function(i, r) {
      var a = t[i];
      a && document.removeEventListener(a, r);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var xse = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, Xse = /* @__PURE__ */ function(e) {
  Ase(n, e);
  var t = Nse(n);
  function n(o, i) {
    var r, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return L0(this, n), r = t.call(this), Dr(Vr(r), "logger", void 0), Dr(Vr(r), "speedAdjustment", 0), Dr(Vr(r), "adjustSpeed", /* @__PURE__ */ function() {
      var u = yn(/* @__PURE__ */ ze().mark(function c(y, w) {
        var v;
        return ze().wrap(function(F) {
          for (; ; ) switch (F.prev = F.next) {
            case 0:
              if (r.speedAdjustment !== w) {
                F.next = 2;
                break;
              }
              return F.abrupt("return");
            case 2:
              return F.next = 4, y.getPlaybackRate();
            case 4:
              return F.t0 = F.sent, F.t1 = r.speedAdjustment, F.t2 = F.t0 - F.t1, F.t3 = w, v = F.t2 + F.t3, r.log("New playbackRate:  ".concat(v)), F.next = 12, y.setPlaybackRate(v);
            case 12:
              r.speedAdjustment = w;
            case 13:
            case "end":
              return F.stop();
          }
        }, c);
      }));
      return function(c, y) {
        return u.apply(this, arguments);
      };
    }()), r.logger = s, r.init(i, o, Tu(Tu({}, xse), a)), r;
  }
  return O0(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var o = yn(/* @__PURE__ */ ze().mark(function r(a, s, u) {
        var c = this, y, w, v;
        return ze().wrap(function(F) {
          for (; ; ) switch (F.prev = F.next) {
            case 0:
              return F.next = 2, this.waitForTOReadyState(a, "open");
            case 2:
              if (u.role !== "viewer") {
                F.next = 10;
                break;
              }
              return F.next = 5, this.updatePlayer(a, s, u);
            case 5:
              y = Su(a, "change", function() {
                return c.updatePlayer(a, s, u);
              }), w = this.maintainPlaybackPosition(a, s, u), this.addEventListener("disconnect", function() {
                w.cancel(), y.cancel();
              }), F.next = 14;
              break;
            case 10:
              return F.next = 12, this.updateTimingObject(a, s);
            case 12:
              v = Su(s, ["seeked", "play", "pause", "ratechange"], function() {
                return c.updateTimingObject(a, s);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return v.cancel();
              });
            case 14:
            case "end":
              return F.stop();
          }
        }, r, this);
      }));
      function i(r, a, s) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var o = yn(/* @__PURE__ */ ze().mark(function r(a, s) {
        return ze().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              return c.t0 = a, c.next = 3, s.getCurrentTime();
            case 3:
              return c.t1 = c.sent, c.next = 6, s.getPaused();
            case 6:
              if (!c.sent) {
                c.next = 10;
                break;
              }
              c.t2 = 0, c.next = 13;
              break;
            case 10:
              return c.next = 12, s.getPlaybackRate();
            case 12:
              c.t2 = c.sent;
            case 13:
              c.t3 = c.t2, c.t4 = {
                position: c.t1,
                velocity: c.t3
              }, c.t0.update.call(c.t0, c.t4);
            case 16:
            case "end":
              return c.stop();
          }
        }, r);
      }));
      function i(r, a) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var o = yn(/* @__PURE__ */ ze().mark(function r(a, s, u) {
        var c, y, w;
        return ze().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              if (c = a.query(), y = c.position, w = c.velocity, typeof y == "number" && s.setCurrentTime(y), typeof w != "number") {
                E.next = 25;
                break;
              }
              if (w !== 0) {
                E.next = 11;
                break;
              }
              return E.next = 6, s.getPaused();
            case 6:
              if (E.t0 = E.sent, E.t0 !== !1) {
                E.next = 9;
                break;
              }
              s.pause();
            case 9:
              E.next = 25;
              break;
            case 11:
              if (!(w > 0)) {
                E.next = 25;
                break;
              }
              return E.next = 14, s.getPaused();
            case 14:
              if (E.t1 = E.sent, E.t1 !== !0) {
                E.next = 19;
                break;
              }
              return E.next = 18, s.play().catch(/* @__PURE__ */ function() {
                var F = yn(/* @__PURE__ */ ze().mark(function O(L) {
                  return ze().wrap(function(z) {
                    for (; ; ) switch (z.prev = z.next) {
                      case 0:
                        if (!(L.name === "NotAllowedError" && u.autoPlayMuted)) {
                          z.next = 5;
                          break;
                        }
                        return z.next = 3, s.setMuted(!0);
                      case 3:
                        return z.next = 5, s.play().catch(function(B) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", B);
                        });
                      case 5:
                      case "end":
                        return z.stop();
                    }
                  }, O);
                }));
                return function(O) {
                  return F.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(a, s, u);
            case 19:
              return E.next = 21, s.getPlaybackRate();
            case 21:
              if (E.t2 = E.sent, E.t3 = w, E.t2 === E.t3) {
                E.next = 25;
                break;
              }
              s.setPlaybackRate(w);
            case 25:
            case "end":
              return E.stop();
          }
        }, r, this);
      }));
      function i(r, a, s) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(i, r, a) {
      var s = this, u = a.allowedDrift, c = a.maxAllowedDrift, y = a.minCheckInterval, w = a.maxRateAdjustment, v = a.maxTimeToCatchUp, E = Math.min(v, Math.max(y, c)) * 1e3, F = /* @__PURE__ */ function() {
        var L = yn(/* @__PURE__ */ ze().mark(function U() {
          var z, B, j, Y, K;
          return ze().wrap(function(te) {
            for (; ; ) switch (te.prev = te.next) {
              case 0:
                if (te.t0 = i.query().velocity === 0, te.t0) {
                  te.next = 6;
                  break;
                }
                return te.next = 4, r.getPaused();
              case 4:
                te.t1 = te.sent, te.t0 = te.t1 === !0;
              case 6:
                if (!te.t0) {
                  te.next = 8;
                  break;
                }
                return te.abrupt("return");
              case 8:
                return te.t2 = i.query().position, te.next = 11, r.getCurrentTime();
              case 11:
                if (te.t3 = te.sent, z = te.t2 - te.t3, B = Math.abs(z), s.log("Drift: ".concat(z)), !(B > c)) {
                  te.next = 22;
                  break;
                }
                return te.next = 18, s.adjustSpeed(r, 0);
              case 18:
                r.setCurrentTime(i.query().position), s.log("Resync by currentTime"), te.next = 29;
                break;
              case 22:
                if (!(B > u)) {
                  te.next = 29;
                  break;
                }
                return j = B / v, Y = w, K = j < Y ? (Y - j) / 2 : Y, te.next = 28, s.adjustSpeed(r, K * Math.sign(z));
              case 28:
                s.log("Resync by playbackRate");
              case 29:
              case "end":
                return te.stop();
            }
          }, U);
        }));
        return function() {
          return L.apply(this, arguments);
        };
      }(), O = setInterval(function() {
        return F();
      }, E);
      return {
        cancel: function() {
          return clearInterval(O);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(i) {
      var r;
      (r = this.logger) === null || r === void 0 || r.call(this, "TimingSrcConnector: ".concat(i));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(i, r) {
        return new Promise(function(a) {
          var s = function u() {
            i.readyState === r ? a() : i.addEventListener("readystatechange", u, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ Xs(EventTarget)), jn = /* @__PURE__ */ new WeakMap(), ks = /* @__PURE__ */ new WeakMap(), xe = {}, qa = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (L0(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document != "undefined" && typeof t == "string" && (t = document.getElementById(t)), !Pse(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var i = t.querySelector("iframe");
      i && (t = i);
    }
    if (t.nodeName === "IFRAME" && !kn(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (jn.has(t))
      return jn.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var r = new at(function(s, u) {
      if (n._onMessage = function(w) {
        if (!(!kn(w.origin) || n.element.contentWindow !== w.source)) {
          n.origin === "*" && (n.origin = w.origin);
          var v = Bi(w.data), E = v && v.event === "error", F = E && v.data && v.data.method === "ready";
          if (F) {
            var O = new Error(v.data.message);
            O.name = v.data.name, u(O);
            return;
          }
          var L = v && v.event === "ready", U = v && v.method === "ping";
          if (L || U) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          Kse(n, v);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var c = V0(t, o), y = R0(c);
        B0(y, c, t).then(function(w) {
          var v = Wa(w, t);
          return n.element = v, n._originalElement = t, Use(t, v), jn.set(n.element, n), w;
        }).catch(u);
      }
    });
    if (ks.set(this, r), jn.set(this.element, this), this.element.nodeName === "IFRAME" && pn(this, "ping"), xe.isEnabled) {
      var a = function() {
        return xe.exit();
      };
      this.fullscreenchangeHandler = function() {
        xe.isFullscreen ? Po(n, "event:exitFullscreen", a) : oi(n, "event:exitFullscreen", a), n.ready().then(function() {
          pn(n, "fullscreenchange", xe.isFullscreen);
        });
      }, xe.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return O0(e, [{
    key: "callMethod",
    value: function(n) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new at(function(r, a) {
        return o.ready().then(function() {
          Po(o, n, {
            resolve: r,
            reject: a
          }), pn(o, n, i);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var o = this;
      return new at(function(i, r) {
        return n = Eu(n, "get"), o.ready().then(function() {
          Po(o, n, {
            resolve: i,
            reject: r
          }), pn(o, n);
        }).catch(r);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, o) {
      var i = this;
      return new at(function(r, a) {
        if (n = Eu(n, "set"), o == null)
          throw new TypeError("There must be a value to set.");
        return i.ready().then(function() {
          Po(i, n, {
            resolve: r,
            reject: a
          }), pn(i, n, o);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!o)
        throw new TypeError("You must pass a callback function.");
      if (typeof o != "function")
        throw new TypeError("The callback must be a function.");
      var i = ni(this, "event:".concat(n));
      i.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), Po(this, "event:".concat(n), o);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (o && typeof o != "function")
        throw new TypeError("The callback must be a function.");
      var i = oi(this, "event:".concat(n), o);
      i && this.callMethod("removeEventListener", n).catch(function(r) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = ks.get(this) || new at(function(o, i) {
        i(new Error("Unknown player. Probably unloaded."));
      });
      return at.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: o
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: o
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return xe.isEnabled ? xe.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return xe.isEnabled ? xe.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return xe.isEnabled ? at.resolve(xe.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new at(function(o) {
        if (ks.delete(n), jn.delete(n.element), n._originalElement && (jn.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var i = n.element.querySelector("iframe");
          i && i.parentNode && (i.parentNode.parentNode && n._originalElement && n._originalElement !== i.parentNode ? i.parentNode.parentNode.removeChild(i.parentNode) : i.parentNode.removeChild(i));
        }
        n._window.removeEventListener("message", n._onMessage), xe.isEnabled && xe.off("fullscreenchange", n.fullscreenchangeHandler), o();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return at.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new at(function(r, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var o = new at(function(r) {
        return r(null);
      }), i = [n[0] ? this.set("colorOne", n[0]) : o, n[1] ? this.set("colorTwo", n[1]) : o, n[2] ? this.set("colorThree", n[2]) : o, n[3] ? this.set("colorFour", n[3]) : o];
      return at.all(i);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = yn(/* @__PURE__ */ ze().mark(function o(i, r) {
        var a = this, s;
        return ze().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (i) {
                c.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return c.next = 4, this.ready();
            case 4:
              return s = new Xse(this, i, r), pn(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                return pn(a, "notifyTimingObjectDisconnect");
              }), c.abrupt("return", s);
            case 8:
            case "end":
              return c.stop();
          }
        }, o, this);
      }));
      function n(o, i) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
P0 || (xe = Yse(), zse(), Zse(), Wse(), qse());
const Qse = {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    typeVideo: {
      type: String,
      default: ""
    },
    elementId: {
      type: String,
      default: "playerVideo"
    },
    autoplay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      player: {
        vimeo: null,
        youtube: null
      }
    };
  },
  watch: {
    async url() {
      if (this.player.vimeo)
        try {
          await this.player.vimeo.destroy(), this.player.vimeo = null;
        } catch (e) {
          console.error("Error destroying ");
        }
      else this.player.youtube && (this.player.youtube.destroy(), this.player.youtube = null);
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    });
  },
  created() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  methods: {
    createVimeoPlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.vimeo = new qa(this.$refs[this.elementId], {
        url: this.url,
        responsive: !0
      }), this.player.vimeo.on("play", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !0 });
      }), this.player.vimeo.on("pause", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !1 });
      }), !0);
    },
    createYoutubePlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.youtube = new $se(this.$refs[this.elementId]), this.player.youtube.on("paused", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("ended", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("playing", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !0,
          elementId: this.elementId
        });
      }), !0);
    },
    loadVimeoPlayer() {
      !this.player.vimeo && !this.createVimeoPlayer() || (this.player.vimeo.loadVideo(this.url), this.player.vimeo.play());
    },
    loadYoutubePlayer() {
      !this.player.youtube && !this.createYoutubePlayer() || (this.player.youtube.load(this.id, this.autoplay), this.setStylesToIFrame());
    },
    setStylesToIFrame() {
      const e = this.$refs[this.elementId];
      e && (e.style.left = "0", e.style.top = "0", e.style.width = "100%", e.style.height = "100%", e.style.position = "absolute");
    }
  }
}, Jse = {
  class: "video-player",
  "data-testid": "video-player"
}, eae = ["id"];
function tae(e, t, n, o, i, r) {
  return l(), h("div", Jse, [
    d("div", {
      id: n.elementId,
      ref: n.elementId
    }, null, 8, eae)
  ]);
}
const F0 = /* @__PURE__ */ I(Qse, [["render", tae], ["__scopeId", "data-v-5fa63831"]]), nae = {
  name: "V1",
  components: {
    VideoPlayer: F0
  },
  mixins: [za],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    prevItem() {
      let e = this.activeItem - 1;
      return e < 0 && (e = this.videoItems.length - 1), this.videoItems[e];
    },
    nextItem() {
      let e = this.activeItem + 1;
      return e >= this.videoItems.length && (e = 0), this.videoItems[e];
    }
  },
  methods: {
    activateItem(e) {
      this.readMoreOpen = !1, this.activeItem = e, this.$emit("setCurrentVideoThrillshare", e);
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.videoItems.length && (e = 0), this.activateItem(e);
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.videoItems.length - 1), this.activateItem(e);
    },
    readMoreToggle() {
      this.readMoreOpen = !this.readMoreOpen;
    },
    isOverflow() {
      this.$nextTick(() => this.$refs.description.offsetHeight < this.$refs.description.scrollHeight || this.$refs.description.offsetWidth < this.$refs.description.scrollWidth);
    }
  }
}, oae = ["data-testid"], rae = ["data-testid"], iae = { class: "video-wrapper" }, sae = {
  key: 0,
  class: "thumbnail"
}, aae = ["src"], lae = { class: "buttons" }, dae = ["aria-label"], uae = ["aria-label"], cae = { class: "mirrors" }, hae = { class: "prev" }, mae = { class: "thumbnail" }, pae = ["src"], fae = { class: "title" }, gae = { class: "next" }, vae = { class: "thumbnail" }, bae = ["src"], yae = { class: "title" }, Cae = { class: "video-info" }, _ae = {
  class: "title",
  "data-testid": "title"
}, wae = {
  key: 1,
  class: "dots"
}, Tae = ["onClick"], kae = {
  key: 2,
  class: "buttons"
}, Eae = ["aria-label"], Sae = ["aria-label"];
function Mae(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("VideoPlayer");
  return l(), h("div", {
    id: "video-component",
    class: p(e.theme.style),
    style: H(e.colors),
    "data-testid": "V1"
  }, [
    e.content.show_headline ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (l(), h("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.content.component_header_top), 1)
            ], !0)
          ], 8, rae)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.content.headline), 1)
          ], !0)
        ], 8, oae)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : g("", !0),
    d("div", iae, [
      d("div", {
        class: "video",
        tabindex: "0",
        onKeyup: [
          t[0] || (t[0] = N((...u) => r.activateNext && r.activateNext(...u), ["right"])),
          t[1] || (t[1] = N((...u) => r.activatePrev && r.activatePrev(...u), ["left"]))
        ]
      }, [
        C(e.$slots, "delete-btn", {
          index: e.currentItem.position
        }, void 0, !0),
        C(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
          e.isPlaceholder ? (l(), h("div", sae, [
            d("img", {
              src: e.currentItem.thumbnail,
              alt: "",
              "data-testid": "current-image"
            }, null, 8, aae)
          ])) : (l(), _(s, {
            key: 1,
            id: e.currentItem.videoId,
            ref: "main-video-player",
            "element-id": `${n.componentId}-main-video-player`,
            "video-id": e.currentItem.videoId,
            "type-video": e.currentItem.type,
            url: e.currentItem.url,
            autoplay: !1,
            responsive: !0,
            class: "player",
            onEventToEmit: e.setIsPlaying
          }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
        ], !0)
      ], 32),
      e.isDesktop && e.videoItems.length > 1 ? (l(), h(G, { key: 0 }, [
        d("div", lae, [
          d("button", {
            class: "prev",
            "aria-label": e.translations.left_arrow || "Previous Video",
            onClick: t[2] || (t[2] = (...u) => r.activatePrev && r.activatePrev(...u)),
            onKeyup: t[3] || (t[3] = N((...u) => r.activatePrev && r.activatePrev(...u), ["left"]))
          }, t[11] || (t[11] = [
            d("div", { class: "icon" }, null, -1)
          ]), 40, dae),
          d("button", {
            class: "next",
            "aria-label": e.translations.right_arrow || "Next Video",
            onClick: t[4] || (t[4] = (...u) => r.activateNext && r.activateNext(...u)),
            onKeyup: t[5] || (t[5] = N((...u) => r.activateNext && r.activateNext(...u), ["right"]))
          }, t[12] || (t[12] = [
            d("div", { class: "icon" }, null, -1)
          ]), 40, uae)
        ]),
        d("div", cae, [
          d("div", hae, [
            C(e.$slots, `video-item-${r.prevItem.position}`, {}, () => [
              d("div", mae, [
                d("img", {
                  src: r.prevItem.thumbnail,
                  alt: "",
                  "data-testid": "previous-image"
                }, null, 8, pae)
              ]),
              d("div", fae, f(r.prevItem.title), 1)
            ], !0)
          ]),
          d("div", gae, [
            C(e.$slots, `video-item-${r.nextItem.position}`, {}, () => [
              d("div", vae, [
                d("img", {
                  src: r.nextItem.thumbnail,
                  alt: "",
                  "data-testid": "next-image"
                }, null, 8, bae)
              ]),
              d("div", yae, f(r.nextItem.title), 1)
            ], !0)
          ])
        ])
      ], 64)) : g("", !0)
    ]),
    d("div", Cae, [
      C(e.$slots, "main-video-alt-text", {
        index: e.currentItem.position
      }, void 0, !0),
      d("div", _ae, [
        C(e.$slots, "main-video-title", {
          index: e.currentItem.position
        }, () => [
          k(f(e.currentItem.title), 1)
        ], !0)
      ]),
      d("div", {
        ref: "description",
        class: p(["description", { more: e.readMoreOpen }]),
        "data-testid": "description"
      }, [
        C(e.$slots, "main-video-description", {
          index: e.currentItem.position
        }, () => [
          k(f(e.currentItem.description), 1)
        ], !0)
      ], 2),
      r.isOverflow ? (l(), h("button", {
        key: 0,
        class: "read-more",
        onClick: t[6] || (t[6] = (...u) => r.readMoreToggle && r.readMoreToggle(...u))
      }, f(e.readMoreOpen ? "Read less" : "Read more"), 1)) : g("", !0)
    ]),
    e.videoItems.length > 1 ? (l(), h("div", wae, [
      (l(!0), h(G, null, q(e.videoItems, (u, c) => (l(), h("div", {
        id: "dot-item",
        key: u.id,
        class: p(["dot", e.activeItem == c ? "active" : ""]),
        onClick: (y) => r.activateItem(c)
      }, null, 10, Tae))), 128))
    ])) : g("", !0),
    !e.isDesktop && e.videoItems.length > 1 ? (l(), h("div", kae, [
      d("button", {
        class: "prev",
        "aria-label": e.translations.left_arrow || "Previous Video",
        onClick: t[7] || (t[7] = (...u) => r.activatePrev && r.activatePrev(...u)),
        onKeyup: t[8] || (t[8] = N((...u) => r.activatePrev && r.activatePrev(...u), ["left"]))
      }, t[13] || (t[13] = [
        d("div", { class: "icon" }, null, -1)
      ]), 40, Eae),
      d("button", {
        class: "next",
        "aria-label": e.translations.right_arrow || "Next Video",
        onClick: t[9] || (t[9] = (...u) => r.activateNext && r.activateNext(...u)),
        onKeyup: t[10] || (t[10] = N((...u) => r.activateNext && r.activateNext(...u), ["right"]))
      }, t[14] || (t[14] = [
        d("div", { class: "icon" }, null, -1)
      ]), 40, Sae)
    ])) : g("", !0)
  ], 6);
}
const $ae = /* @__PURE__ */ I(nae, [["render", Mae], ["__scopeId", "data-v-04867ae6"]]), Iae = {
  name: "V2",
  components: {
    VideoPlayer: F0
  },
  mixins: [za],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    activateItem(e) {
      this.activeItem = e, this.playPause(`${this.componentId}-main-video-player`, this.currentItem.type), this.$emit("setCurrentVideoThrillshare", e);
    }
  }
}, Aae = ["data-testid"], Lae = ["data-testid"], Oae = { class: "wrapper" }, Nae = ["aria-label"], Hae = { class: "video" }, Pae = {
  key: 0,
  class: "thumbnail"
}, Dae = ["src"], Rae = { class: "video-info" }, Vae = {
  class: "title",
  "data-testid": "title"
}, Bae = {
  class: "description",
  "data-testid": "description",
  ref: "description"
}, Fae = {
  key: 1,
  class: "sidebar"
}, jae = ["id", "alert-label", "onClick", "onKeyup"], Uae = { class: "video" }, Kae = {
  class: "secondary-title",
  "data-testid": "title"
}, Gae = { class: "thumbnail" }, zae = ["src"], Zae = {
  key: 0,
  class: "info"
}, Wae = { class: "title" }, qae = { class: "description" };
function Yae(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("VideoPlayer");
  return l(), h("div", {
    id: "video-component",
    class: p(e.theme.style),
    style: H(e.colors),
    "data-testid": "V2"
  }, [
    e.content.show_headline ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (l(), h("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.content.component_header_top), 1)
            ], !0)
          ], 8, Lae)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.content.headline), 1)
          ], !0)
        ], 8, Aae)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : g("", !0),
    d("div", Oae, [
      e.isDesktop || e.videoItems.length === 1 ? (l(), h("div", {
        key: 0,
        class: "main-video",
        tabindex: "0",
        "aria-label": `${e.translations.video_player || "Video player"}: ${e.currentItem.alt_text}`,
        role: "region"
      }, [
        d("div", Hae, [
          C(e.$slots, "delete-btn", {
            index: e.currentItem.position
          }, void 0, !0),
          C(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
            e.isPlaceholder ? (l(), h("div", Pae, [
              d("img", {
                src: e.currentItem.thumbnail,
                alt: "",
                "data-testid": "current-item"
              }, null, 8, Dae)
            ])) : (l(), _(s, {
              key: 1,
              class: "player",
              ref: "main-video-player",
              "element-id": `${n.componentId}-main-video-player`,
              id: e.currentItem.videoId,
              "video-id": e.currentItem.videoId,
              "type-video": e.currentItem.type,
              url: e.currentItem.url,
              autoplay: !1,
              responsive: !0,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["element-id", "id", "video-id", "type-video", "url", "onEventToEmit"]))
          ], !0)
        ]),
        d("div", Rae, [
          C(e.$slots, "main-video-alt-text", {
            altText: e.currentItem.alt_text,
            index: e.currentItem.position
          }, void 0, !0),
          d("div", Vae, [
            C(e.$slots, "main-video-title", {
              index: e.currentItem.position
            }, () => [
              k(f(e.currentItem.title), 1)
            ], !0)
          ]),
          d("div", Bae, [
            C(e.$slots, "main-video-description", {
              index: e.currentItem.position
            }, () => [
              k(f(e.currentItem.description), 1)
            ], !0)
          ], 512)
        ])
      ], 8, Nae)) : g("", !0),
      e.videoItems.length > 1 ? (l(), h("div", Fae, [
        (l(!0), h(G, null, q(e.videoItems, (u, c) => (l(), h("div", {
          tabindex: 0,
          role: "button",
          id: `sidebar-item-${c}`,
          key: u.id,
          class: p(["sidebar-item", e.activeItem === c && "active"]),
          "alert-label": `${e.translations.display_video || "Display video"}: ${u.alt_text}`,
          onClick: (y) => r.activateItem(c),
          onKeyup: N((y) => r.activateItem(c), ["enter"]),
          "on:eventToEmit": t[0] || (t[0] = (...y) => e.setIsPlaying && e.setIsPlaying(...y))
        }, [
          d("div", Uae, [
            C(e.$slots, "delete-btn", {
              index: u.position
            }, void 0, !0),
            C(e.$slots, `video-item-${u.position}`, {}, () => [
              d("div", {
                class: p(["video-mask", e.activeItem === c && !e.isDesktop && "hidden"])
              }, [
                d("div", {
                  class: p(["button", e.isPlaying && e.activeItem === c ? "pause" : "play"])
                }, null, 2),
                d("div", Kae, f(u.title), 1),
                d("div", Gae, [
                  d("img", {
                    src: u.thumbnail,
                    alt: ""
                  }, null, 8, zae)
                ])
              ], 2)
            ], !0),
            e.isDesktop ? g("", !0) : (l(), _(s, {
              key: 0,
              class: "player",
              id: u.videoId,
              "video-id": u.videoId,
              "type-video": u.type,
              url: u.url,
              autoplay: !1,
              responsive: !0,
              "element-id": `${n.componentId}-video-player-${c}`,
              ref_for: !0,
              ref: `video-player-${c}`,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "video-id", "type-video", "url", "element-id", "onEventToEmit"]))
          ]),
          e.isDesktop ? g("", !0) : (l(), h("div", Zae, [
            d("div", Wae, f(u.title), 1),
            d("div", qae, f(u.description), 1)
          ]))
        ], 42, jae))), 128))
      ])) : g("", !0)
    ])
  ], 6);
}
const xae = /* @__PURE__ */ I(Iae, [["render", Yae], ["__scopeId", "data-v-89351548"]]), Xae = {
  name: "CmsVideo",
  components: {
    V1: $ae,
    V2: xae
  },
  mixins: [za],
  data() {
    return {
      componentId: Math.floor(Math.random() * 1e5)
    };
  }
}, Qae = { id: "view-video" };
function Jae(e, t, n, o, i, r) {
  return l(), h("div", Qae, [
    (l(), _(R(e.theme.version), {
      theme: e.theme,
      content: e.content,
      "is-editing": e.isEditing,
      "component-id": i.componentId,
      "is-placeholder": e.isPlaceholder,
      "video-slots-items": e.videoSlotsItems,
      "current-video-thrillshare": e.currentVideoThrillshare,
      onSetCurrentVideoThrillshare: t[0] || (t[0] = (a) => e.$emit("setCurrentVideoThrillshare", a)),
      onDeleteVideo: t[1] || (t[1] = (a) => {
        e.$emit("deleteVideo", a);
      })
    }, Ou({
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      "main-video-description": b(({ index: a }) => [
        C(e.$slots, "main-video-description", { index: a }, void 0, !0)
      ]),
      "main-video-title": b(({ index: a }) => [
        C(e.$slots, "main-video-title", { index: a }, void 0, !0)
      ]),
      "main-video-alt-text": b(({ index: a }) => [
        C(e.$slots, "main-video-alt-text", { index: a }, void 0, !0)
      ]),
      "delete-btn": b(({ index: a }) => [
        C(e.$slots, "delete-btn", { index: a }, void 0, !0)
      ]),
      "main-video-slot": b(({ index: a }) => [
        C(e.$slots, "main-video-slot", { index: a }, void 0, !0)
      ]),
      _: 2
    }, [
      q(e.videoSlotsItems, (a) => ({
        name: a.name,
        fn: b(() => [
          C(e.$slots, a.name, {
            index: a.index
          }, void 0, !0)
        ])
      }))
    ]), 1064, ["theme", "content", "is-editing", "component-id", "is-placeholder", "video-slots-items", "current-video-thrillshare"]))
  ]);
}
const ele = /* @__PURE__ */ I(Xae, [["render", Jae], ["__scopeId", "data-v-e4f3e80d"]]), ir = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    spotlights: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  computed: {
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--bg-color": T(this.theme, "bg_color.hex", "#fff"),
        "--top-heading-color": T(this.theme, "top_heading_color.hex", "#000000"),
        "--quote-color": T(this.theme, "quote_color.hex", "#000"),
        "--name-color": T(this.theme, "name_color.hex", "#000"),
        "--arrow-icon-color": T(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "initial"),
        "--arrow-background-opacity": `${(t = this.theme.arrow_background_opacity) != null ? t : "0"}%`,
        "--arrow-border-color": T(this.theme, "arrow_border_color.hex", "initial"),
        "--image-border-color": T(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--textarea-border-color": T(this.theme, "textarea_border_color.hex", "#00000014"),
        "--textarea-border-accent-color": T(
          this.theme,
          "textarea_border_accent_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : "0"}%`
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.spotlights.component_header_top || this.isEditing);
    },
    isLightStyle() {
      return this.theme.style === "light";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isMobile() {
      return this.screenSize < 600;
    },
    isDesktop() {
      return this.screenSize >= 960;
    }
  }
}, tle = {
  props: {
    spotlight: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    showName: {
      type: Boolean,
      default: !0
    },
    withSlider: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      sliderClass: this.withSlider ? "with-slider" : "no-slider"
    };
  }
}, nle = ["src", "alt"], ole = {
  key: 1,
  class: "no-image"
}, rle = {
  class: "spotlight-text",
  "data-testid": "spotlight-text"
}, ile = { key: 0 };
function sle(e, t, n, o, i, r) {
  return l(), h("div", {
    class: p(i.sliderClass)
  }, [
    C(e.$slots, "controls"),
    d("div", {
      class: p(["spotlight-image rounded-image", i.sliderClass])
    }, [
      C(e.$slots, "image", {}, () => [
        n.spotlight.image.url ? (l(), h("img", {
          key: 0,
          src: n.spotlight.image.url,
          alt: n.spotlight.image.alt_text,
          class: "rounded-image",
          "data-testid": "spotlight-accent-border",
          loading: "lazy"
        }, null, 8, nle)) : (l(), h("div", ole))
      ])
    ], 2),
    d("div", rle, [
      d("div", {
        class: p(["spotlight-quote", [n.theme.style, i.sliderClass]])
      }, [
        d("p", null, [
          C(e.$slots, "quote", {}, () => [
            k(f(n.spotlight.quote), 1)
          ])
        ])
      ], 2),
      n.showName ? (l(), h("div", {
        key: 0,
        class: p(["spotlight-author", i.sliderClass]),
        "data-testid": "spotlight-author-name"
      }, [
        d("p", null, [
          n.spotlight.quote.length > 0 && n.spotlight.author.length > 0 ? (l(), h("span", ile, "- ")) : g("", !0),
          C(e.$slots, "author", {}, () => [
            k(f(n.spotlight.author), 1)
          ])
        ])
      ], 2)) : g("", !0)
    ])
  ], 2);
}
const ale = /* @__PURE__ */ I(tle, [["render", sle], ["__scopeId", "data-v-e5ef89e5"]]), lle = {
  name: "SL1",
  components: { Slider: Ga, SpotlightCard: ale },
  mixins: [ir, We],
  computed: {
    content() {
      return this.spotlights.content;
    },
    showSlider() {
      return this.spotlights.show_slider && !this.isEditing;
    },
    sliderCenterSize() {
      return 599;
    }
  }
}, dle = { key: 0 }, ule = ["data-testid"], cle = { class: "cards-slider-container" }, hle = ["aria-label"];
function mle(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("SpotlightCard"), u = S("Slider"), c = Ne("touch");
  return l(), h("div", {
    id: "SL1",
    class: p(e.theme.style),
    style: H(e.colors)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.displayHeaderTop ? (l(), h("h3", dle, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.spotlights.component_header_top), 1)
          ], !0)
        ])) : g("", !0),
        d("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header", {}, () => [
            k(f(e.spotlights.component_header), 1)
          ], !0)
        ], 8, ule)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(r.showSlider ? "div" : e.wrapperComponent), Ce({
      modelValue: e.spotlights.content,
      "onUpdate:modelValue": t[0] || (t[0] = (y) => e.spotlights.content = y)
    }, e.wrapperProps, {
      class: [{ editing: e.isEditing, "no-slider": !r.showSlider }, "spotlights-content"],
      "item-key": "id"
    }), Ou({
      default: b(() => [
        r.showSlider ? (l(), _(u, {
          key: 0,
          "total-cards": r.content.length,
          "current-card": e.currentCard,
          "all-cards-visible": e.allCardsVisible,
          "section-header": e.spotlights.component_header,
          "hide-x-small": !1,
          "theme-styles": e.theme,
          class: "slider-container",
          "data-testid": "spotlight-slider",
          onScrollRight: e.scrollRight,
          onScrollLeft: e.scrollLeft
        }, {
          default: b(() => [
            d("div", {
              ref: "scrollWrapper",
              class: p([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-content"]),
              "item-key": "index"
            }, [
              d("div", cle, [
                (l(!0), h(G, null, q(e.spotlights.content, (y, w) => me((l(), h("div", {
                  ref_for: !0,
                  ref: `sliderCard-${w}`,
                  key: w,
                  class: p(["spotlight with-slider", { "is-editing": e.isEditing }]),
                  "aria-label": `${w + 1} of ${e.spotlights.content.length}`,
                  role: "group",
                  "aria-roledescription": "slide",
                  "data-testid": "spotlights-content-item"
                }, [
                  $(s, {
                    theme: e.theme,
                    spotlight: y,
                    "show-name": e.spotlights.show_name,
                    "with-slider": !0
                  }, null, 8, ["theme", "spotlight", "show-name"])
                ], 10, hle)), [
                  [
                    c,
                    e.scrollRight,
                    "swipe",
                    { left: !0 }
                  ],
                  [
                    c,
                    e.scrollLeft,
                    "swipe",
                    { right: !0 }
                  ]
                ])), 128))
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"])) : g("", !0)
      ]),
      _: 2
    }, [
      r.showSlider ? void 0 : {
        name: "item",
        fn: b(({ element: y, index: w }) => [
          $(s, {
            class: "spotlight no-slider",
            theme: e.theme,
            spotlight: y,
            "show-name": e.spotlights.show_name
          }, {
            controls: b(() => [
              C(e.$slots, "controls", { idx: w }, void 0, !0)
            ]),
            image: b(() => [
              C(e.$slots, "image", { idx: w }, void 0, !0)
            ]),
            quote: b(() => [
              C(e.$slots, "quote", { idx: w }, void 0, !0)
            ]),
            author: b(() => [
              C(e.$slots, "author", { idx: w }, void 0, !0)
            ]),
            _: 2
          }, 1032, ["theme", "spotlight", "show-name"])
        ]),
        key: "0"
      }
    ]), 1040, ["modelValue", "class"]))
  ], 6);
}
const ple = /* @__PURE__ */ I(lle, [["render", mle], ["__scopeId", "data-v-c8a6ad5d"]]), fle = {
  name: "SL2",
  components: {
    CardSlider: It
  },
  mixins: [ir, We],
  computed: {
    content() {
      return this.spotlights.content;
    },
    sliderCenterSize() {
      return 599;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, gle = ["data-testid"], vle = ["data-testid"], ble = ["aria-label"], yle = ["src", "alt"], Cle = { class: "card-quote-text" }, _le = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
};
function wle(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    id: "SL2",
    "data-testid": "SL2",
    style: H(e.colors),
    class: p([e.theme.style, e.isEditing && "editing"])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, vle)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.spotlights.component_header), 1)
          ], !0)
        ], 8, gle)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      "nav-orientation": e.sliderCenterElements ? "bottom" : "top",
      "current-card": e.currentCard,
      "has-pager": !1,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      class: p([{ "show-accent-left": e.currentCard === 0, "buttons-top": !e.sliderCenterElements }, "spotlight-container"]),
      "pager-orientation": "left",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        (l(), _(R(e.wrapperComponent), Ce({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (u) => e.spotlights.content = u),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: b(({ element: u, index: c }) => [
            d("div", {
              ref: `sliderCard-${c}`,
              "aria-label": `${c + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              C(e.$slots, "controls", { idx: c }, void 0, !0),
              C(e.$slots, "image", { idx: c }, () => [
                d("img", {
                  src: u.image.url,
                  alt: u.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, yle)
              ], !0),
              d("div", {
                ref: `spotlightCard-${c}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                d("div", Cle, [
                  C(e.$slots, "quote", { idx: c }, () => [
                    k(f(u.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (l(), h("div", _le, [
                  C(e.$slots, "author", { idx: c }, () => [
                    k(f(u.author), 1)
                  ], !0)
                ])) : g("", !0)
              ], 512)
            ], 8, ble)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["nav-orientation", "current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Tle = /* @__PURE__ */ I(fle, [["render", wle], ["__scopeId", "data-v-fe8e811c"]]), kle = {
  name: "SL3",
  components: {
    CardSlider: It
  },
  mixins: [ir, We],
  computed: {
    content() {
      return this.spotlights.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, Ele = ["data-testid"], Sle = ["data-testid"], Mle = ["aria-label"], $le = { class: "card-quote-text" }, Ile = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
}, Ale = ["src", "alt"];
function Lle(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    id: "SL3",
    "data-testid": "SL3",
    style: H(e.colors),
    class: p([e.theme.style, { editing: e.isEditing }])
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, Sle)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.spotlights.component_header), 1)
          ], !0)
        ], 8, Ele)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        (l(), _(R(e.wrapperComponent), Ce({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (u) => e.spotlights.content = u),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: b(({ element: u, index: c }) => [
            d("div", {
              ref: `sliderCard-${c}`,
              "aria-label": `${c + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              C(e.$slots, "controls", { idx: c }, void 0, !0),
              d("div", {
                ref: `spotlightCard-${c}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                d("div", $le, [
                  C(e.$slots, "quote", { idx: c }, () => [
                    k(f(u.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (l(), h("div", Ile, [
                  C(e.$slots, "author", { idx: c }, () => [
                    k(f(u.author), 1)
                  ], !0)
                ])) : g("", !0)
              ], 512),
              C(e.$slots, "image", { idx: c }, () => [
                d("img", {
                  src: u.image.url,
                  alt: u.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, Ale)
              ], !0)
            ], 8, Mle)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Ole = /* @__PURE__ */ I(kle, [["render", Lle], ["__scopeId", "data-v-d6a63e6a"]]), Nle = {
  name: "IconButton",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: "#000"
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    opacity: {
      type: String,
      default: "100"
    },
    width: {
      type: String,
      default: "60"
    },
    height: {
      type: String,
      default: "60"
    },
    mirror: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    cssVars() {
      return {
        "--icon-color": this.iconColor,
        "--bg-color": this.backgroundColor,
        "--border-color": this.borderColor,
        "--opacity": `${this.opacity}%`,
        "--width": `${this.width}px`,
        "--height": `${this.height}px`
      };
    }
  }
};
function Hle(e, t, n, o, i, r) {
  return l(), h("button", {
    class: "icon-button",
    style: H(r.cssVars),
    onClick: t[0] || (t[0] = (a) => e.$emit("on-click"))
  }, [
    d("div", {
      class: p(["icon-wrapper", { mirror: n.mirror }])
    }, [
      C(e.$slots, "icon", {}, void 0, !0)
    ], 2)
  ], 4);
}
const Ple = /* @__PURE__ */ I(Nle, [["render", Hle], ["__scopeId", "data-v-c77efb17"]]), Dle = {
  name: "SL4",
  mixins: [ir],
  components: { IconButton: Ple },
  computed: {
    content() {
      var e;
      return (e = this.spotlights.content) != null ? e : [];
    },
    currentItem() {
      return this.content.length > 0 ? this.content[this.activeItem] : {
        id: 0,
        author_id: 0,
        quote: "",
        author: "",
        role: "",
        image: { url: "", alt_text: "" },
        link: { name: "", href: "", target: "" }
      };
    },
    borderColor() {
      return ie(this.colors["--bg-color"]).isLight() ? "#000000" : "#FFFFFF";
    },
    cssVars() {
      return de(oe({}, this.colors), {
        "--image-border-color": this.borderColor
      });
    }
  },
  methods: {
    itemSelect(e) {
      this.activeItem = e, !this.isEditing && this.autoPlay && this.restartAutoplay();
    },
    previousItem() {
      this.itemSelect((this.activeItem - 1 + this.content.length) % this.content.length);
    },
    nextItem() {
      this.itemSelect((this.activeItem + 1) % this.content.length);
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextItem, 8e3);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    restartAutoplay() {
      this.stopAutoplay(), this.startAutoplay();
    },
    toggleAutoplay() {
      this.isEditing || (this.autoPlay = !this.autoPlay, this.autoPlay ? this.startAutoplay() : this.stopAutoplay());
    },
    checkOverflow() {
      this.isOverflow = this.isMobile ? !1 : this.$refs.thumbnails && this.$refs.thumbnails.scrollHeight > this.$refs.thumbnails.clientHeight;
    }
  },
  mounted() {
    this.isEditing || (this.$nextTick(() => {
      this.checkOverflow();
    }), window.addEventListener("resize", this.checkOverflow), this.startAutoplay());
  },
  beforeUnmount() {
    clearInterval(this.autoplayInterval), window.removeEventListener("resize", this.checkOverflow);
  },
  data() {
    return {
      activeItem: 0,
      autoplayInterval: null,
      autoPlay: !0,
      isOverflow: !1
    };
  }
}, Rle = { class: "spotlight-wrapper" }, Vle = ["data-testid"], Ble = ["data-testid"], Fle = { class: "col-1" }, jle = { class: "spotlight-quote-container" }, Ule = { class: "col-2" }, Kle = {
  key: 0,
  class: "author-role-container"
}, Gle = { class: "gallery-container" }, zle = { class: "gallery-track" }, Zle = ["fill"], Wle = {
  key: 1,
  width: "56",
  height: "12",
  viewBox: "0 0 6 12",
  xmlns: "http://www.w3.org/2000/svg"
}, qle = ["fill"], Yle = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xle = ["stroke"], Xle = ["onClick"], Qle = {
  key: 0,
  class: "author-role-container"
}, Jle = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e1e = ["stroke"], t1e = { class: "main-image" };
function n1e(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("IconButton");
  return l(), h("div", {
    class: p(["spotlight-v4", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL4",
    style: H(r.cssVars)
  }, [
    d("div", Rle, [
      $(a, {
        "theme-options": e.theme,
        class: p(["see-all-top", e.theme.style])
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (l(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, Ble)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.spotlights.component_header), 1)
            ], !0)
          ], 8, Vle)
        ]),
        default: b(() => {
          var u, c;
          return [
            e.isBoldStyle && !e.isMobile ? (l(), _(R(e.isEditing ? "button" : "a"), {
              key: 0,
              class: p(["see-all-button", e.theme.style]),
              href: (u = r.currentItem.link) == null ? void 0 : u.href,
              target: (c = r.currentItem.link) == null ? void 0 : c.target
            }, {
              default: b(() => [
                k(f(r.currentItem.link.name) + " ", 1),
                C(e.$slots, "link", { idx: i.activeItem }, void 0, !0)
              ]),
              _: 3
            }, 8, ["class", "href", "target"])) : g("", !0)
          ];
        }),
        _: 3
      }, 8, ["theme-options", "class"]),
      d("div", Fle, [
        d("div", jle, [
          (l(!0), h(G, null, q(r.content, (u, c) => (l(), h("div", {
            key: c,
            class: p(["spotlight-quote-text", e.theme.style, { active: c === i.activeItem }])
          }, [
            C(e.$slots, "quote", { idx: i.activeItem }, () => [
              k(f(u.quote), 1)
            ], !0)
          ], 2))), 128))
        ]),
        e.isBoldStyle || e.isLightStyle && !e.isDesktop ? g("", !0) : (l(), _(a, {
          key: 0,
          class: p(e.theme.style),
          "theme-options": e.theme
        }, {
          default: b(() => {
            var u, c;
            return [
              (l(), _(R(e.isEditing ? "button" : "a"), {
                class: p(["see-all-button", e.theme.style]),
                href: (u = r.currentItem.link) == null ? void 0 : u.href,
                target: (c = r.currentItem.link) == null ? void 0 : c.target
              }, {
                default: b(() => {
                  var y;
                  return [
                    k(f((y = r.currentItem.link) == null ? void 0 : y.name) + " ", 1),
                    C(e.$slots, "link", { idx: i.activeItem }, void 0, !0)
                  ];
                }),
                _: 3
              }, 8, ["class", "href", "target"]))
            ];
          }),
          _: 3
        }, 8, ["class", "theme-options"]))
      ]),
      d("div", Ule, [
        e.isMobile ? (l(), h("div", Kle, [
          (l(!0), h(G, null, q(r.content, (u, c) => (l(), h("div", {
            key: c,
            class: p(["author-role-text", { active: c === i.activeItem }])
          }, [
            d("div", {
              class: p(["spotlight-author-text", e.theme.style])
            }, [
              C(e.$slots, "author", { idx: i.activeItem }, () => [
                k(f(u.author), 1)
              ], !0)
            ], 2),
            d("div", {
              class: p(["spotlight-role-text", e.theme.style])
            }, [
              C(e.$slots, "role", { idx: i.activeItem }, () => [
                k(f(u.role), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ])) : g("", !0),
        d("div", Gle, [
          d("div", zle, [
            e.isEditing ? g("", !0) : (l(), _(s, {
              key: 0,
              class: "play-button",
              onOnClick: r.toggleAutoplay,
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex
            }, {
              icon: b(() => [
                i.autoPlay ? (l(), h("svg", {
                  key: 0,
                  width: "56",
                  height: "56",
                  viewBox: "0 0 56 56",
                  fill: e.theme.arrow_icon_color.hex,
                  xmlns: "http://www.w3.org/2000/svg"
                }, t[0] || (t[0] = [
                  d("rect", {
                    x: "21",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1),
                  d("rect", {
                    x: "30",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1)
                ]), 8, Zle)) : (l(), h("svg", Wle, [
                  d("path", {
                    d: "M0 12L6 6L0 0V12Z",
                    fill: e.theme.arrow_icon_color.hex
                  }, null, 8, qle)
                ]))
              ]),
              _: 1
            }, 8, ["onOnClick", "background-color", "opacity", "border-color"])),
            i.isOverflow ? (l(), _(s, {
              key: 1,
              class: "back-button",
              onOnClick: r.previousItem,
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex
            }, {
              icon: b(() => [
                (l(), h("svg", Yle, [
                  d("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, xle)
                ]))
              ]),
              _: 1
            }, 8, ["onOnClick", "background-color", "opacity", "border-color"])) : g("", !0),
            d("div", {
              ref: "thumbnails",
              class: p(["thumbnails-container", { "is-overflow": i.isOverflow }])
            }, [
              (l(!0), h(G, null, q(r.content, (u, c) => (l(), h("div", {
                key: c,
                onClick: (y) => r.itemSelect(c),
                class: p([{ active: c === i.activeItem }, "thumbnail"])
              }, [
                e.isMobile ? g("", !0) : (l(), h("div", Qle, [
                  d("div", {
                    class: p(["spotlight-author-text", e.theme.style])
                  }, [
                    C(e.$slots, "author", { idx: c }, () => [
                      k(f(u.author), 1)
                    ], !0)
                  ], 2),
                  d("div", {
                    class: p(["spotlight-author-text", e.theme.style])
                  }, [
                    C(e.$slots, "role", { idx: c }, () => [
                      k(f(u.role), 1)
                    ], !0)
                  ], 2)
                ])),
                (l(), _(R(u.image.url ? "img" : "div"), {
                  draggable: "false",
                  src: u.image.url,
                  alt: u.image.alt_text,
                  class: "mini-image"
                }, null, 8, ["src", "alt"]))
              ], 10, Xle))), 128))
            ], 2),
            i.isOverflow ? (l(), _(s, {
              key: 2,
              class: "next-button",
              mirror: "",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: r.nextItem
            }, {
              icon: b(() => [
                (l(), h("svg", Jle, [
                  d("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, e1e)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : g("", !0)
          ]),
          d("div", t1e, [
            (l(!0), h(G, null, q(r.content, (u, c) => (l(), _(R(u.image.url ? "img" : "div"), {
              key: c,
              draggable: "false",
              src: r.currentItem.image.url,
              alt: r.currentItem.image.alt_text,
              class: p(["active-image", { active: c === i.activeItem }])
            }, null, 8, ["src", "alt", "class"]))), 128)),
            C(e.$slots, "image", { idx: i.activeItem }, void 0, !0)
          ])
        ])
      ]),
      e.isBoldStyle && e.isMobile || e.isLightStyle && !e.isDesktop ? (l(), _(a, {
        key: 0,
        class: p([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: b(() => {
          var u, c;
          return [
            (l(), _(R(e.isEditing ? "button" : "a"), {
              class: p(["see-all-button", e.theme.style]),
              href: (u = r.currentItem.link) == null ? void 0 : u.href,
              target: (c = r.currentItem.link) == null ? void 0 : c.target
            }, {
              default: b(() => {
                var y;
                return [
                  k(f((y = r.currentItem.link) == null ? void 0 : y.name) + " ", 1),
                  C(e.$slots, "link", { idx: e.idx }, void 0, !0)
                ];
              }),
              _: 3
            }, 8, ["class", "href", "target"]))
          ];
        }),
        _: 3
      }, 8, ["class", "theme-options"])) : g("", !0)
    ])
  ], 6);
}
const o1e = /* @__PURE__ */ I(Dle, [["render", n1e], ["__scopeId", "data-v-78ba6581"]]), r1e = {
  name: "SL5",
  components: {
    CardSlider: It
  },
  mixins: [ir, We],
  data() {
    return {
      activeTabIdx: 0,
      defaultNestedContent: [
        {
          cards: [],
          icon: "",
          label: "",
          show_image_icons: !0,
          show_headline: !0,
          show_snippet: !0
        }
      ]
    };
  },
  computed: {
    nestedContent() {
      var e, t;
      return (t = (e = this.spotlights) == null ? void 0 : e.nested_content) != null ? t : this.defaultNestedContent;
    },
    activeTabData() {
      return this.nestedContent[this.activeTabIdx];
    },
    content() {
      return this.activeTabData.cards;
    },
    cssVars() {
      return de(oe({}, this.colors), {
        "--button-bg-color": T(this.theme, "button_bg_color.hex", "#5D5FEF"),
        "--button-border-color": T(this.theme, "button_border_color.hex", "#8f91ff"),
        "--button-icon-color": T(this.theme, "button_icon_color.hex", "#8f91ff"),
        "--button-text-color": T(this.theme, "button_text_color.hex", "#8f91ff"),
        "--button-active-bg-color": T(this.theme, "button_active_bg_color.hex", "#5D5FEF"),
        "--button-active-border-color": T(this.theme, "button_active_border_color.hex", "#fff"),
        "--button-active-icon-color": T(this.theme, "button_active_icon_color.hex", "#fff"),
        "--button-active-text-color": T(this.theme, "button_active_text_color.hex", "#fff"),
        "--image-gradient-color": T(this.theme, "image_gradient_color.hex", "#000000"),
        "--quote-icon-color": T(this.theme, "quote_icon_color.hex", "#fff"),
        "--role-color": T(this.theme, "role_color.hex", "#000"),
        "--line-color": T(this.theme, "line_color.hex", "#8f91ff")
      });
    }
  },
  methods: {
    tabActivate(e) {
      this.activeTabIdx = e, this.$emit("update:selectedIdx", this.activeTabIdx);
    }
  }
}, i1e = { class: "spotlight-wrapper" }, s1e = ["data-testid"], a1e = ["data-testid"], l1e = ["onClick"], d1e = {
  key: 0,
  class: "icon-wrapper"
}, u1e = ["innerHTML"], c1e = ["aria-label"], h1e = { class: "top" }, m1e = {
  key: 0,
  class: "mask"
}, p1e = ["src", "alt"], f1e = {
  key: 2,
  class: "no-image"
}, g1e = { class: "content" }, v1e = {
  key: 0,
  class: "icon-wrapper"
}, b1e = ["innerHTML"], y1e = {
  key: 1,
  class: "snippet"
}, C1e = { class: "bottom" }, _1e = {
  key: 0,
  "data-testid": "spotlight-card",
  class: "name-role-wrapper"
}, w1e = { class: "role" }, T1e = ["aria-label"], k1e = ["aria-label"];
function E1e(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    class: p(["spotlight-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL5",
    style: H(r.cssVars)
  }, [
    d("div", i1e, [
      $(a, {
        class: p([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.displayHeaderTop ? (l(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, a1e)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.spotlights.component_header), 1)
            ], !0)
          ], 8, s1e)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
        modelValue: e.spotlights.nested_content,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => e.spotlights.nested_content = u),
        "item-key": "id",
        class: ["spotlight-tabs", { editing: e.isEditing }]
      }), {
        item: b(({ element: u, index: c }) => [
          d("button", {
            class: p(["tab-button", { active: c === i.activeTabIdx }]),
            onClick: (y) => r.tabActivate(c)
          }, [
            C(e.$slots, "controls", { idx: c }, void 0, !0),
            e.spotlights.show_icons ? (l(), h("div", d1e, [
              C(e.$slots, "tab-icon", { idx: c }, () => [
                d("span", {
                  class: "icon",
                  innerHTML: u.icon
                }, null, 8, u1e)
              ], !0)
            ])) : g("", !0),
            e.spotlights.show_tab_labels ? (l(), h("div", {
              key: 1,
              class: p(["label", [e.theme.style]])
            }, [
              C(e.$slots, "label", { idx: c }, () => [
                k(f(u.label), 1)
              ], !0)
            ], 2)) : g("", !0)
          ], 10, l1e)
        ]),
        _: 3
      }, 16, ["modelValue", "class"])),
      r.activeTabData && r.activeTabData.cards && r.activeTabData.cards.length ? (l(), _(s, {
        key: 0,
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "current-card": e.currentCard,
        "pager-section-count": e.pagerSectionCount,
        "total-cards": r.activeTabData.cards.length,
        "section-header": e.spotlights.component_header,
        "has-pager": !1,
        "theme-styles": e.theme,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft,
        onGoToSection: e.goToSection
      }, {
        "button-left": b(() => [
          d("button", {
            class: "slider-button left",
            "aria-label": e.translations.previous_item || "Previous Item",
            onKeyup: t[2] || (t[2] = N((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
            onClick: t[3] || (t[3] = (...u) => e.scrollLeft && e.scrollLeft(...u))
          }, t[6] || (t[6] = [
            d("svg", null, [
              d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, T1e)
        ]),
        "button-right": b(() => [
          d("button", {
            class: "slider-button right",
            "aria-label": e.translations.next_item || "Next Item",
            onKeyup: t[4] || (t[4] = N((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
            onClick: t[5] || (t[5] = (...u) => e.scrollRight && e.scrollRight(...u))
          }, t[7] || (t[7] = [
            d("svg", null, [
              d("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, k1e)
        ]),
        default: b(() => [
          (l(), _(R(e.wrapperComponent), Ce({ ref: "scrollWrapper" }, e.wrapperProps, {
            modelValue: r.activeTabData.cards,
            "onUpdate:modelValue": t[1] || (t[1] = (u) => r.activeTabData.cards = u),
            "item-key": "id",
            class: "cards-wrapper"
          }), {
            item: b(({ element: u, index: c }) => [
              d("div", {
                ref: `sliderCard-${c}`,
                "aria-label": `${c + 1} of ${r.activeTabData.cards.length}`,
                role: "group",
                "aria-roledescription": "slide",
                class: p(["card", { editing: e.isEditing }])
              }, [
                d("div", h1e, [
                  C(e.$slots, "tab-controls", {
                    idx: c,
                    tabIdx: i.activeTabIdx
                  }, void 0, !0),
                  u.image.url ? (l(), h("div", m1e)) : g("", !0),
                  u.image.url ? (l(), h("img", {
                    key: 1,
                    src: u.image.url,
                    alt: u.image.alt_text,
                    class: "image",
                    draggable: "false",
                    loading: "lazy"
                  }, null, 8, p1e)) : g("", !0),
                  !u.image.url && e.isEditing ? (l(), h("div", f1e)) : g("", !0),
                  d("div", g1e, [
                    r.activeTabData.show_image_icons ? (l(), h("div", v1e, [
                      C(e.$slots, "icon", {
                        idx: c,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        d("span", {
                          class: "icon",
                          innerHTML: u.icon
                        }, null, 8, b1e)
                      ], !0)
                    ])) : g("", !0),
                    r.activeTabData.show_snippet ? (l(), h("p", y1e, [
                      C(e.$slots, "snippet", {
                        idx: c,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        k(f(u.snippet), 1)
                      ], !0)
                    ])) : g("", !0)
                  ])
                ]),
                d("div", C1e, [
                  r.activeTabData.show_headline ? (l(), h("div", _1e, [
                    d("div", {
                      class: p(["name", [e.theme.style]]),
                      "data-testid": "spotlight-name"
                    }, [
                      C(e.$slots, "author", {
                        idx: c,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        k(f(u.name), 1)
                      ], !0)
                    ], 2),
                    d("div", w1e, [
                      C(e.$slots, "role", {
                        idx: c,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        k(f(u.role), 1)
                      ], !0)
                    ])
                  ])) : g("", !0)
                ])
              ], 10, c1e)
            ]),
            _: 3
          }, 16, ["modelValue"]))
        ]),
        _: 3
      }, 8, ["current-card", "pager-section-count", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft", "onGoToSection"])) : g("", !0)
    ])
  ], 6);
}
const S1e = /* @__PURE__ */ I(r1e, [["render", E1e], ["__scopeId", "data-v-fd2c2f39"]]), M1e = {
  name: "Spotlight",
  components: {
    SL1: ple,
    SL2: Tle,
    SL3: Ole,
    SL4: o1e,
    SL5: S1e
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  methods: {
    handleSelectedIdx(e) {
      this.$emit("update:selectedIdx", e);
    }
  }
}, $1e = { id: "view-spotlight" };
function I1e(e, t, n, o, i, r) {
  return l(), h("div", $1e, [
    (l(), _(R(n.theme.version), {
      theme: n.theme,
      spotlights: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing,
      "onUpdate:selectedIdx": r.handleSelectedIdx
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      controls: b(({ idx: a }) => [
        C(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      "tab-controls": b(({ idx: a, tabIdx: s }) => [
        C(e.$slots, "tab-controls", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      image: b(({ idx: a }) => [
        C(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      title: b(({ title: a, idx: s }) => [
        C(e.$slots, "title", {
          title: a,
          idx: s
        }, void 0, !0)
      ]),
      quote: b(({ quote: a, idx: s }) => [
        C(e.$slots, "quote", {
          quote: a,
          idx: s
        }, void 0, !0)
      ]),
      author: b(({ author: a, idx: s, tabIdx: u }) => [
        C(e.$slots, "author", {
          author: a,
          idx: s,
          tabIdx: u
        }, void 0, !0)
      ]),
      role: b(({ role: a, idx: s, tabIdx: u }) => [
        C(e.$slots, "role", {
          role: a,
          idx: s,
          tabIdx: u
        }, void 0, !0)
      ]),
      icon: b(({ idx: a, tabIdx: s }) => [
        C(e.$slots, "icon", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      "tab-icon": b(({ idx: a }) => [
        C(e.$slots, "tab-icon", { idx: a }, void 0, !0)
      ]),
      label: b(({ label: a, idx: s }) => [
        C(e.$slots, "label", {
          label: a,
          idx: s
        }, void 0, !0)
      ]),
      snippet: b(({ idx: a, tabIdx: s }) => [
        C(e.$slots, "snippet", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      link: b(({ idx: a }) => [
        C(e.$slots, "link", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "spotlights", "wrapper-component", "wrapper-props", "is-editing", "onUpdate:selectedIdx"]))
  ]);
}
const A1e = /* @__PURE__ */ I(M1e, [["render", I1e], ["__scopeId", "data-v-f0dee26f"]]), L1e = {
  mixins: [Qe],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    athletics: {
      type: Array,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      const e = this.sharedThemeColors(), t = T(this.theme, "athletic_bg_color.hex", "none"), n = T(this.theme, "athletic_title_color.hex", "initial");
      return de(oe({}, e), {
        "--athletic-bg-color": t,
        "--athletic-title-color": n,
        "--date-color": T(this.theme, "date_color.hex", "initial"),
        "--time-color": T(this.theme, "time_color.hex", "initial"),
        "--athletic-separator-color": T(this.theme, "athletic_separator_color.hex", "#000"),
        "--athletic-card-border": T(
          this.theme,
          "athletic_card_border.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--vs-tag-bg-color": T(this.theme, "vs_tag_bg.hex", t),
        "--vs-tag-text-color": T(this.theme, "vs_tag_color.hex", n)
      });
    },
    translations() {
      return this.options.translations;
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("athletics");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  }
}, O1e = {
  name: "A1",
  mixins: [L1e]
}, N1e = ["data-testid"], H1e = { class: "athletics-match" }, P1e = {
  key: 0,
  "data-testid": "versus"
}, D1e = {
  key: 1,
  "data-testid": "non-versus"
};
function R1e(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    id: "athletics-a1",
    style: H(e.colors),
    "data-testid": "a1",
    class: p(e.theme.style)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        e.isMonterreyStyle ? (l(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header-top", {}, () => [
            k(f(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, N1e)) : g("", !0),
        (l(), _(R(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: b(() => [
            C(e.$slots, "header", {}, () => [
              k(f(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: b(() => [
        e.options.style !== "purple" && e.screenSize > 600 ? (l(), _(R(e.isEditing ? "button" : "a"), {
          key: 0,
          class: p(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : g("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", {
      class: p(["athletics-info", { "is-editing": e.isEditing }])
    }, [
      (l(!0), h(G, null, q(e.athletics.slice(0, 6), (s, u) => (l(), h("div", {
        key: `${u}-${s.title}`,
        class: "athletics-card athletic-accent-border",
        "data-testid": "athletic-accent-border"
      }, [
        d("p", {
          class: p(["athletics-date", e.options.style])
        }, f(s.month) + " " + f(s.day), 3),
        d("div", {
          class: p(["athletics-time", e.options.style])
        }, f(s.time), 3),
        d("div", {
          class: p(["athletics-filter", e.options.style])
        }, f(s.filter_name), 3),
        d("h3", H1e, [
          s.versus ? (l(), h("div", P1e, [
            k(f(s.away_team) + " ", 1),
            d("span", null, f(e.translations.at), 1),
            k(" " + f(s.home_team), 1)
          ])) : (l(), h("div", D1e, f(s.title), 1))
        ])
      ]))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (l(), _(a, {
      key: 0,
      class: p([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: b(() => [
        (l(), _(R(e.isEditing ? "button" : "a"), {
          class: p(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: b(() => [
            k(f(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : g("", !0)
  ], 6);
}
const V1e = /* @__PURE__ */ I(O1e, [["render", R1e], ["__scopeId", "data-v-a5ce17c4"]]), B1e = {
  name: "CmsAthletics",
  components: {
    A1: V1e
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  }
}, F1e = { id: "view-athletics" };
function j1e(e, t, n, o, i, r) {
  return l(), h("div", F1e, [
    (l(), _(R(n.options.version), {
      options: n.options,
      "component-id": n.componentId,
      athletics: n.content,
      "athletics-config": n.athleticsConfig,
      "is-editing": n.isEditing,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "component-id", "athletics", "athletics-config", "is-editing", "path-prefix"]))
  ]);
}
const U1e = /* @__PURE__ */ I(B1e, [["render", j1e], ["__scopeId", "data-v-efaab17b"]]), K1e = {
  name: "SvgArrow"
}, G1e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 21",
  fill: "none"
};
function z1e(e, t, n, o, i, r) {
  return l(), h("svg", G1e, t[0] || (t[0] = [
    d("mask", {
      id: "path-1-inside-1_1",
      fill: "white"
    }, [
      d("path", { d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z" })
    ], -1),
    d("path", {
      d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z",
      class: "arrow_svg",
      "stroke-width": "4",
      mask: "url(#path-1-inside-1_1)"
    }, null, -1)
  ]));
}
const Z1e = /* @__PURE__ */ I(K1e, [["render", z1e]]), Fi = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    buttons: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--bg-color": T(this.theme, "bg_color.hex", "#fff"),
        "--text-color": T(this.theme, "text_color.hex", "#000"),
        "--arrow-color": T(this.theme, "arrow_color.hex", "#000"),
        "--arrow-color-hover": T(this.theme, "arrow_color_hover.hex", "#000"),
        "--button-text-color": T(this.theme, "button_text_color.hex", "#fff"),
        "--button-bg-color": T(this.theme, "button_bg_color.hex", "#000"),
        "--border-radius": `${this.theme.border_radius}px`,
        "--percentage-opacity": `${100 - this.theme.percentage_opacity}%`,
        "--icon-and-text-color": T(this.theme, "icon_and_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, W1e = {
  name: "B1",
  components: { SvgArrow: Z1e },
  mixins: [Fi]
}, q1e = { "data-testid": "buttons-content" };
function Y1e(e, t, n, o, i, r) {
  const a = S("SvgArrow");
  return l(), h("div", {
    id: "buttons-b1",
    "data-testid": "B1",
    class: p(e.theme.style),
    style: H(e.colors)
  }, [
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.buttons.content = s),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: b(({ element: s, index: u }) => [
        d("div", q1e, [
          (l(), _(R(e.isEditing ? "div" : "a"), {
            href: s.link,
            target: s.opens_in_new_tab ? "_blank" : "",
            class: "button-link"
          }, {
            default: b(() => [
              C(e.$slots, "controls", { idx: u }, void 0, !0),
              C(e.$slots, "title", { idx: u }, () => [
                k(f(s.title), 1)
              ], !0),
              $(a)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const x1e = /* @__PURE__ */ I(W1e, [["render", Y1e], ["__scopeId", "data-v-5aa49eb4"]]), X1e = {
  name: "B2",
  mixins: [Fi]
};
function Q1e(e, t, n, o, i, r) {
  return l(), h("div", {
    id: "buttons-b2",
    "data-testid": "B2",
    class: p([e.theme.style, { uppercase: e.theme.uppercase }]),
    style: H(e.colors)
  }, [
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: b(({ element: a, index: s }) => [
        d("div", null, [
          (l(), _(R(e.isEditing ? "div" : "a"), {
            href: a.link,
            target: a.opens_in_new_tab ? "_blank" : "",
            class: "button-link",
            "data-testid": "buttons-content"
          }, {
            default: b(() => [
              C(e.$slots, "controls", { idx: s }, void 0, !0),
              d("span", null, [
                C(e.$slots, "title", { idx: s }, () => [
                  k(f(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const J1e = /* @__PURE__ */ I(X1e, [["render", Q1e], ["__scopeId", "data-v-dac6a587"]]), ede = {
  name: "B3",
  mixins: [Fi],
  computed: {
    buttonCount() {
      return this.buttons.content.length;
    },
    iconsActive() {
      return this.buttons.icons_active;
    },
    buttonClasses() {
      return [`buttons-${this.buttonCount}`, { "can-stack": this.buttonCount > 4 }, this.theme.style];
    },
    borderColor() {
      return ie(this.colors["--button-bg-color"]).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    cssVars() {
      return de(oe({}, this.colors), {
        "--button-border": `1px solid ${this.borderColor}`
      });
    }
  }
}, tde = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, nde = { class: "raw-svg" }, ode = ["innerHTML"], rde = { class: "button-title" };
function ide(e, t, n, o, i, r) {
  return l(), h("div", {
    id: "buttons-b3",
    "data-testid": "B3",
    class: p(e.theme.style),
    style: H(r.cssVars)
  }, [
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: b(({ element: a, index: s }) => [
        d("div", {
          class: p(["button", r.buttonClasses])
        }, [
          (l(), _(R(e.isEditing ? "div" : "a"), {
            href: a.link,
            class: p([[e.theme.style, !r.iconsActive && "no-icons"], "button-link"]),
            target: a.opens_in_new_tab ? "_blank" : "",
            "data-testid": "buttons-content"
          }, {
            default: b(() => [
              C(e.$slots, "controls", { idx: s }, void 0, !0),
              r.iconsActive ? (l(), h("div", tde, [
                d("span", nde, [
                  C(e.$slots, "icon", { idx: s }, () => [
                    d("span", {
                      "data-testid": "svg",
                      innerHTML: a.icon
                    }, null, 8, ode)
                  ], !0)
                ])
              ])) : g("", !0),
              d("span", rde, [
                C(e.$slots, "title", { idx: s }, () => [
                  k(f(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "class", "target"]))
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const sde = /* @__PURE__ */ I(ede, [["render", ide], ["__scopeId", "data-v-4f645d00"]]), ade = {
  name: "B4",
  mixins: [Fi],
  props: {
    logo: {
      type: String,
      required: !0
    }
  },
  computed: {
    content: {
      get() {
        return this.buttons.content.slice(0, 3);
      },
      set(e) {
        this.buttons.content = e;
      }
    },
    b4Colors() {
      return {
        // ...this.cssVars,
        "--button-1-bg-color": T(this.theme, "button_1_bg_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-1-border-color": T(this.theme, "button_1_border_color.hex", "#fff"),
        "--button-1-text-color": T(this.theme, "button_1_text_color.hex", "#fff"),
        "--button-2-bg-color": T(this.theme, "button_2_bg_color.hex", this.theme.globalThemeSettings.primaryColor),
        "--button-2-border-color": T(this.theme, "button_2_border_color.hex", "#fff"),
        "--button-2-text-color": T(this.theme, "button_2_text_color.hex", "#fff"),
        "--button-3-bg-color": T(this.theme, "button_3_bg_color.hex", "#000"),
        "--button-3-border-color": T(this.theme, "button_3_border_color.hex", "#fff"),
        "--button-3-text-color": T(this.theme, "button_3_text_color.hex", "#fff")
      };
    }
  }
}, lde = { class: "button-title-wrapper" }, dde = ["src"];
function ude(e, t, n, o, i, r) {
  return l(), h("div", {
    "data-testid": "B4",
    class: p(["B4", e.theme.style]),
    style: H(r.b4Colors)
  }, [
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: r.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => r.content = a),
      "item-key": "index",
      class: "button-wrapper"
    }), {
      item: b(({ element: a, index: s }) => [
        (l(), _(R(e.isEditing ? "div" : "a"), {
          class: p(["button", `button-style-${s + 1}`]),
          href: a.link,
          target: a.opens_in_new_tab ? "_blank" : "",
          "data-testid": "button"
        }, {
          default: b(() => [
            C(e.$slots, "controls", { idx: s }, void 0, !0),
            d("div", lde, [
              d("div", {
                class: p([e.theme.style, "button-title"])
              }, [
                C(e.$slots, "title", {
                  title: a.title,
                  idx: s
                }, () => [
                  k(f(a.title), 1)
                ], !0)
              ], 2),
              d("img", {
                src: n.logo,
                alt: "",
                "data-testid": "button-image"
              }, null, 8, dde)
            ])
          ]),
          _: 2
        }, 1032, ["class", "href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const cde = /* @__PURE__ */ I(ade, [["render", ude], ["__scopeId", "data-v-4be90db0"]]), hde = {
  name: "Buttons",
  components: {
    B1: x1e,
    B2: J1e,
    B3: sde,
    B4: cde
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    logo: {
      type: String,
      default: ""
    }
  }
};
function mde(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    buttons: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    logo: n.logo
  }, {
    controls: b(({ idx: a }) => [
      C(e.$slots, "controls", { idx: a })
    ]),
    icon: b(({ idx: a }) => [
      C(e.$slots, "icon", { idx: a })
    ]),
    title: b(({ title: a, idx: s }) => [
      C(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    _: 3
  }, 8, ["theme", "buttons", "wrapper-component", "wrapper-props", "is-editing", "logo"]);
}
const pde = /* @__PURE__ */ I(hde, [["render", mde]]), fde = {
  name: "IconLinkButtons",
  components: { DraggableWrapper: Ke },
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    buttons: {
      type: Array,
      required: !0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || e.name === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    buttonBgColor: {
      type: String,
      default: "#000"
    },
    buttonIconAndTextColor: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: ""
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--iconlink-button-bg-color": this.buttonBgColor,
        "--iconlink-button-icon-text-color": this.buttonIconAndTextColor,
        "--iconlink-container-width": this.width || `${Math.ceil(this.buttons.length / 2) * 182}px`,
        "--iconlink-border-color": `1px solid ${this.borderColor}`
      };
    },
    borderColor() {
      return ie(this.buttonBgColor).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    buttonModel: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, gde = { class: "button-container" }, vde = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, bde = { class: "raw-svg" }, yde = ["innerHTML"];
function Cde(e, t, n, o, i, r) {
  return l(), _(R(n.wrapperComponent), Ce(n.wrapperProps, {
    modelValue: r.buttonModel,
    "onUpdate:modelValue": t[0] || (t[0] = (a) => r.buttonModel = a),
    style: r.cssVars,
    "item-key": "index",
    class: "icon-link-buttons"
  }), {
    item: b(({ element: a, index: s }) => [
      (l(), _(R(!a.href || n.isEditing ? "div" : "a"), {
        href: a.href,
        target: a.target || "_self",
        class: "button",
        "data-testid": "icon-button"
      }, {
        default: b(() => [
          C(e.$slots, "controls", { idx: s }, void 0, !0),
          d("div", gde, [
            a.icon || n.isEditing ? (l(), h("div", vde, [
              d("span", bde, [
                C(e.$slots, "icon", {
                  icon: a.icon,
                  idx: s
                }, () => [
                  d("span", {
                    innerHTML: a.icon
                  }, null, 8, yde)
                ], !0)
              ])
            ])) : g("", !0),
            d("span", {
              class: p(["button-title", n.themeStyle])
            }, [
              C(e.$slots, "title", {
                title: a.title,
                idx: s
              }, () => [
                k(f(a.title), 1)
              ], !0)
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["href", "target"]))
    ]),
    _: 3
  }, 16, ["modelValue", "style"]);
}
const _de = /* @__PURE__ */ I(fde, [["render", Cde], ["__scopeId", "data-v-7b1e996e"]]), Ya = {
  mixins: [Qe],
  components: {
    IconLinkButtons: _de,
    DraggableWrapper: Ke
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    about: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--top-heading-color": T(this.theme, "top_heading_color.hex", "#000"),
        "--text-color": T(this.theme, "text_color.hex", "#000"),
        "--text-link-color": T(this.theme, "text_link_color.hex", "#000"),
        "--watermark-url": `url(${this.watermark})`,
        "--card-top-header-color": T(this.theme, "card_top_header_color.hex", "#000"),
        "--card-bottom-header-color": T(this.theme, "card_bottom_header_color.hex", "#000")
      });
    },
    buttonBgColor() {
      return T(this.theme, "button_bg_color.hex", "#000");
    },
    buttonIconAndTextColor() {
      return T(this.theme, "icon_and_text_color.hex", "#fff");
    }
  }
}, wde = {
  name: "AboutV1",
  mixins: [Ya],
  computed: {
    aboutImageUrl() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.url;
    },
    aboutImageAltText() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.alt_text;
    }
  }
}, Tde = ["data-testid"], kde = ["data-testid"], Ede = { class: "main-content" }, Sde = { class: "left-content" }, Mde = ["src", "alt"], $de = ["innerHTML"];
function Ide(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("IconLinkButtons");
  return l(), h("div", {
    id: "about-v1",
    class: p([e.theme.style, { editing: e.isEditing }]),
    style: H(e.colors),
    "data-testid": "AboutV1"
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.about.component_header_top), 1)
            ], !0)
          ], 8, kde)) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.about.component_header), 1)
          ], !0)
        ], 8, Tde)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    d("div", Ede, [
      d("div", Sde, [
        C(e.$slots, "image", {}, () => [
          e.about.has_image ? (l(), h("img", {
            key: 0,
            src: r.aboutImageUrl,
            alt: r.aboutImageAltText,
            class: "left-image",
            "data-testid": "about-image",
            loading: "lazy"
          }, null, 8, Mde)) : g("", !0)
        ], !0),
        C(e.$slots, "text", {}, () => [
          d("span", {
            class: "left-text text-block",
            innerHTML: e.about.component_text
          }, null, 8, $de)
        ], !0)
      ]),
      $(s, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => e.about.links = u),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        "is-editing": e.isEditing
      }, {
        controls: b(({ idx: u }) => [
          C(e.$slots, "controls", { idx: u }, void 0, !0)
        ]),
        icon: b(({ idx: u }) => [
          C(e.$slots, "icon", { idx: u }, void 0, !0)
        ]),
        title: b(({ title: u, idx: c }) => [
          C(e.$slots, "title", {
            title: u,
            idx: c
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "is-editing"])
    ])
  ], 6);
}
const Ade = /* @__PURE__ */ I(wde, [["render", Ide], ["__scopeId", "data-v-028957dd"]]), Lde = {
  name: "AboutV2",
  mixins: [Ya, rt],
  computed: {
    isDesktop() {
      return this.screenSize > 1280;
    }
  }
}, Ode = { class: "main-content" }, Nde = {
  key: 0,
  class: "image-wrapper"
}, Hde = ["src"], Pde = ["data-testid"], Dde = { class: "main-text" }, Rde = ["innerHTML"];
function Vde(e, t, n, o, i, r) {
  const a = S("IconLinkButtons");
  return l(), h("div", {
    class: p([{ editing: e.isEditing }, "about-v2"]),
    style: H(e.colors),
    "data-testid": "AboutV2"
  }, [
    d("div", Ode, [
      d("div", {
        class: p([e.theme.style, "top-content"])
      }, [
        e.about.has_accent_logo ? (l(), h("div", Nde, [
          t[1] || (t[1] = d("svg", {
            width: "16",
            height: "55",
            viewBox: "0 0 16 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "accent-icon"
          }, [
            d("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M7.67334 11.7812L7.67334 54.7812H8.67334L8.67334 11.7813L7.67334 11.7812Z",
              fill: "#000"
            }),
            d("rect", {
              width: "10.0781",
              height: "9.82776",
              transform: "matrix(0.704554 0.70965 -0.704554 0.70965 7.91162 0)",
              fill: "#000"
            })
          ], -1)),
          e.watermark ? (l(), h("img", {
            key: 0,
            src: e.watermark,
            alt: "",
            class: "left-image",
            loading: "lazy"
          }, null, 8, Hde)) : g("", !0)
        ])) : g("", !0),
        e.about.has_header ? (l(), h("h2", {
          key: 1,
          class: "header-text",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          C(e.$slots, "header", {}, () => [
            k(f(e.about.component_header), 1)
          ], !0)
        ], 8, Pde)) : g("", !0),
        d("span", Dde, [
          C(e.$slots, "text", {}, () => [
            d("span", {
              innerHTML: e.about.component_text
            }, null, 8, Rde)
          ], !0)
        ])
      ], 2),
      $(a, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.about.links = s),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        width: r.isDesktop ? "100%" : "",
        "is-editing": e.isEditing
      }, {
        controls: b(({ idx: s }) => [
          C(e.$slots, "controls", { idx: s }, void 0, !0)
        ]),
        icon: b(({ idx: s }) => [
          C(e.$slots, "icon", { idx: s }, void 0, !0)
        ]),
        title: b(({ title: s, idx: u }) => [
          C(e.$slots, "title", {
            title: s,
            idx: u
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "width", "is-editing"])
    ])
  ], 6);
}
const Bde = /* @__PURE__ */ I(Lde, [["render", Vde], ["__scopeId", "data-v-de020895"]]), Fde = {
  name: "AboutV3",
  mixins: [Ya],
  data() {
    return {
      wrapperHeight: "unset"
    };
  },
  computed: {
    aboutLinks: {
      get() {
        return this.about.links.slice(0, 5);
      },
      set(e) {
        this.about.links = e;
      }
    }
  },
  async mounted() {
    window.addEventListener("resize", this.setHeight), await this.$nextTick(), this.setHeight();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setHeight);
  },
  methods: {
    setHeight() {
      const e = this.$refs[`card-${this.aboutLinks.length - 1}`];
      if (!e)
        return;
      const t = this.$refs.cardWrapper, o = e.getBoundingClientRect().top - t.$el.getBoundingClientRect().top + e.clientHeight;
      this.wrapperHeight = `${o}px`;
    }
  }
}, jde = { class: "top-container" }, Ude = ["data-testid"], Kde = ["data-testid"], Gde = ["innerHTML"], zde = { class: "card-top-title" }, Zde = { class: "card-title" }, Wde = { class: "card-image" }, qde = ["src", "alt"];
function Yde(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    style: H(e.colors),
    class: p([e.theme.style, "about-v3"])
  }, [
    d("div", jde, [
      $(a, {
        class: p([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}`,
            class: "no-border"
          }, [
            e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (l(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.about.component_header_top), 1)
              ])
            ], 8, Kde)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.about.component_header), 1)
            ])
          ], 8, Ude)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      C(e.$slots, "text", {}, () => [
        d("span", {
          class: "text-block",
          innerHTML: e.about.component_text
        }, null, 8, Gde)
      ])
    ]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: r.aboutLinks,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => r.aboutLinks = s),
      style: { height: i.wrapperHeight },
      ref: "cardWrapper",
      "item-key": "index",
      class: "card-wrapper"
    }), {
      item: b(({ element: s, index: u }) => [
        (l(), _(R(e.isEditing || !s.href ? "div" : "a"), {
          href: s.href,
          target: s.target,
          ref: `card-${u}`,
          class: "card",
          "data-testid": "about-card"
        }, {
          default: b(() => [
            C(e.$slots, "controls", { idx: u }),
            d("div", {
              class: p(["card-left", e.theme.style])
            }, [
              d("div", zde, [
                C(e.$slots, "top-title", { idx: u }, () => [
                  k(f(s.top_title), 1)
                ])
              ]),
              d("div", Zde, [
                C(e.$slots, "title", { idx: u }, () => [
                  k(f(s.title), 1)
                ])
              ])
            ], 2),
            d("div", Wde, [
              C(e.$slots, "image", { idx: u }, () => [
                d("img", {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text
                }, null, 8, qde)
              ])
            ])
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue", "style"]))
  ], 6);
}
const xde = /* @__PURE__ */ I(Fde, [["render", Yde], ["__scopeId", "data-v-533e5527"]]), Xde = {
  name: "About",
  components: {
    AboutV1: Ade,
    AboutV2: Bde,
    AboutV3: xde
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  }
}, Qde = { id: "view-about" };
function Jde(e, t, n, o, i, r) {
  return l(), h("div", Qde, [
    (l(), _(R(n.theme.version), {
      theme: n.theme,
      about: n.content,
      "is-editing": n.isEditing,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      watermark: n.watermark
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      image: b(({ idx: a }) => [
        C(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      text: b(() => [
        C(e.$slots, "text", {}, void 0, !0)
      ]),
      controls: b(({ idx: a }) => [
        C(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      icon: b(({ idx: a }) => [
        C(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      "top-title": b(({ idx: a }) => [
        C(e.$slots, "top-title", { idx: a }, void 0, !0)
      ]),
      title: b(({ idx: a }) => [
        C(e.$slots, "title", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "about", "is-editing", "wrapper-component", "wrapper-props", "watermark"]))
  ]);
}
const eue = /* @__PURE__ */ I(Xde, [["render", Jde], ["__scopeId", "data-v-602a1639"]]);
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const tue = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, j0 = X0({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, tue),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: n }) {
    let o;
    const i = tn(null), r = xo(() => {
      const s = i.value;
      return s && (s instanceof HTMLElement ? s : s.$el);
    });
    function a() {
      return o || (o = lc(r.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          n("update:active", !0), n("activate");
        },
        onDeactivate: () => {
          n("update:active", !1), n("deactivate");
        },
        onPostActivate: () => n("postActivate"),
        onPostDeactivate: () => n("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return Qs(() => {
      ri(() => e.active, (s) => {
        s && r.value ? a().activate() : o && (o.deactivate(), (!r.value || r.value.nodeType === Node.COMMENT_NODE) && (o = null));
      }, { immediate: !0, flush: "post" });
    }), Q0(() => {
      o && o.deactivate(), o = null;
    }), {
      activate() {
        a().activate();
      },
      deactivate() {
        o && o.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const s = t.default().filter((c) => c.type !== J0);
        return !s || !s.length || s.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), s) : e2(s[0], { ref: i });
      }
    };
  }
});
function Xe(e, ...t) {
  const n = t.find((o) => e[o]);
  return n ? e[n] : { hex: "" };
}
const nue = {
  name: "CmsAlertModal",
  components: {
    SvgClose: Qo,
    FocusTrap: j0
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0,
      isActive: !0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--overlay-bg-color": Xe(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": Xe(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": Xe(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": Xe(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "cms-alert-modal__close--no-focus-outline" : "";
    }
  },
  methods: {
    closeModal(e = !1) {
      this.isActive && (this.isActive = !1, this.$emit("close", { closedByKeyboard: e }));
    }
  }
}, oue = { class: "cms-alert-modal__container-wrapper" }, rue = ["aria-label"], iue = ["aria-label"], sue = { class: "cms-alert-modal__body" }, aue = ["innerHTML"];
function lue(e, t, n, o, i, r) {
  const a = S("SvgClose"), s = S("FocusTrap");
  return l(), h("div", {
    id: "cms-alert-modal",
    style: H(r.colors)
  }, [
    d("div", oue, [
      $(s, {
        "initial-focus": () => e.$refs["close-button"],
        "fallback-focus": () => e.$refs["close-button"],
        active: i.isActive,
        "click-outside-deactivates": "",
        "escape-deactivates": "",
        onDeactivate: r.closeModal
      }, {
        default: b(() => [
          d("section", {
            ref: "modal-container",
            class: "cms-alert-modal__container",
            "aria-label": n.translations.legacyContainer,
            role: "alertdialog",
            "aria-modal": "true"
          }, [
            d("button", {
              ref: "close-button",
              "aria-label": n.translations.legacyBody,
              class: p(["cms-alert-modal__close", r.closeBtnFocusOutlineCSSClass]),
              "aria-describedby": "alert-modal-body",
              onClick: t[0] || (t[0] = (u) => r.closeModal()),
              onKeydown: [
                t[1] || (t[1] = N(D((u) => r.closeModal(!0), ["exact", "prevent"]), ["enter"])),
                t[2] || (t[2] = N(D((u) => r.closeModal(!0), ["exact", "prevent"]), ["space"])),
                t[3] || (t[3] = N(D((...u) => e.closeAllModals && e.closeAllModals(...u), ["exact", "prevent"]), ["esc"])),
                t[4] || (t[4] = N(D((u) => i.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
              ]
            }, [
              $(a)
            ], 42, iue),
            d("div", sue, [
              d("div", {
                id: "alert-modal-body",
                class: "cms-alert-modal__body-content",
                innerHTML: n.alertContent
              }, null, 8, aue)
            ])
          ], 8, rue)
        ]),
        _: 1
      }, 8, ["initial-focus", "fallback-focus", "active", "onDeactivate"])
    ])
  ], 4);
}
const due = /* @__PURE__ */ I(nue, [["render", lue], ["__scopeId", "data-v-a8b1fc60"]]), uue = {
  name: "AlertBanner",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": Xe(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": Xe(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": Xe(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    }
  }
}, cue = ["innerHTML"];
function hue(e, t, n, o, i, r) {
  return l(), h("div", {
    id: "alert-banner",
    style: H(r.colors)
  }, [
    d("div", {
      class: "alert-banner__content",
      innerHTML: n.alertContent
    }, null, 8, cue)
  ], 4);
}
const mue = /* @__PURE__ */ I(uue, [["render", hue], ["__scopeId", "data-v-ac60c6f3"]]);
function pue(e, t, n, { maxPadding: o = 25, minPadding: i = 5, smallModalMaxRatioOfViewport: r = 0.3, largeModalMinRatioOfViewport: a = 0.9 } = {}) {
  const s = e / t;
  let u;
  if (s <= r)
    u = o;
  else if (s < a) {
    const y = (s - r) / (a - r);
    u = o - (o - i) * y;
  } else
    u = i;
  const c = Math.min(1, n / t);
  return u = u * c, Math.max(i, Math.min(u, o));
}
const fue = {
  name: "CmsAlertModalSeparate",
  components: {
    SvgClose: Qo,
    FocusTrap: j0
  },
  mixins: [rt],
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    modalArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFocusTrapActive: !1,
      containerHeight: 0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden", this.focusByClassName(".close"), this.updateContainerHeight(), this.$nextTick(() => {
      this.activateFocusTrap();
    });
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    dynamicPadding() {
      return typeof window != "undefined" ? `${pue(this.containerHeight, window.innerHeight, this.screenSize)}vh` : "0vh";
    },
    globalsInfo() {
      var e;
      return (e = this.globals.info) != null ? e : {};
    },
    colors() {
      return {
        "--overlay-bg-color": Xe(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": Xe(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": Xe(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": Xe(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    containsMultipleModals() {
      return this.modalArray.length > 1;
    },
    containsImage() {
      return this.modalArray.some((e) => e.image.url);
    },
    containsLongText() {
      return this.modalArray.some((e) => e.content.length > 100);
    },
    svgFillColor() {
      return ie(this.colors["--overlay-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  watch: {
    screenSize() {
      this.updateContainerHeight();
    }
  },
  methods: {
    activateFocusTrap() {
      this.$refs.modalContainer && (this.isFocusTrapActive = !0, this.focusByClassName(".close"));
    },
    updateContainerHeight() {
      this.$nextTick(() => {
        this.$refs.modalContainer && (this.containerHeight = this.$refs.modalContainer.clientHeight);
      });
    },
    closeModal(e, t = !1) {
      const n = this.modalArray.length <= 1, i = { alertId: e, closedByKeyboard: n && t };
      this.$emit("close", i), n || (this.updateContainerHeight(), this.focusByClassName(".close"));
    },
    closeAllModals() {
      this.modalArray.forEach((e, t) => {
        const n = t === this.modalArray.length - 1;
        this.$emit("close", { alertId: e.id, closedByKeyboard: n });
      });
    },
    generateModalClasses() {
      return [
        this.containsMultipleModals ? "multi-modal" : "single-modal",
        this.containsImage ? "has-image" : "no-image",
        this.containsLongText ? "long-text" : "short-text"
      ];
    },
    focusByClassName(e) {
      this.$nextTick(() => {
        const t = this.$el.querySelector(e);
        t && t.focus();
      });
    }
  }
}, gue = {
  class: "container-wrapper",
  ref: "modalContainer"
}, vue = ["onClick", "onKeydown", "aria-describedby"], bue = {
  class: "container",
  role: "alertdialog",
  "aria-modal": "true"
}, yue = {
  key: 0,
  class: "image"
}, Cue = ["src", "alt"], _ue = ["id"], wue = ["innerHTML"];
function Tue(e, t, n, o, i, r) {
  const a = S("SvgClose"), s = S("FocusTrap");
  return l(), _(s, { active: i.isFocusTrapActive }, {
    default: b(() => [
      d("div", {
        class: "cms-alert-modal",
        style: H([r.colors, { paddingTop: r.dynamicPadding }]),
        onKeydown: t[1] || (t[1] = N(D((...u) => r.closeAllModals && r.closeAllModals(...u), ["exact", "prevent"]), ["esc"]))
      }, [
        d("div", gue, [
          (l(!0), h(G, null, q(n.modalArray, (u, c) => (l(), h("div", {
            key: c,
            class: p(["individual-container-wrapper", ...r.generateModalClasses()])
          }, [
            d("button", {
              class: "close",
              onClick: (y) => r.closeModal(u.id),
              onKeydown: [
                N(D((y) => r.closeModal(u.id, !0), ["exact", "prevent"]), ["enter"]),
                N(D((y) => r.closeModal(u.id, !0), ["exact", "prevent"]), ["space"])
              ],
              "aria-describedby": `alert-modal-body-'${u.id}`
            }, [
              $(a, { "fill-color": r.svgFillColor }, null, 8, ["fill-color"])
            ], 40, vue),
            d("section", bue, [
              u.image.url ? (l(), h("div", yue, [
                d("img", {
                  src: u.image.url,
                  alt: u.image.alt_text,
                  onLoad: t[0] || (t[0] = (...y) => r.updateContainerHeight && r.updateContainerHeight(...y))
                }, null, 40, Cue)
              ])) : g("", !0),
              u.content ? (l(), h("div", {
                key: 1,
                id: "alert-modal-body-" + u.id,
                class: "body"
              }, [
                d("div", {
                  class: "body-content",
                  innerHTML: u.content
                }, null, 8, wue)
              ], 8, _ue)) : g("", !0)
            ])
          ], 2))), 128))
        ], 512)
      ], 36)
    ]),
    _: 1
  }, 8, ["active"]);
}
const kue = /* @__PURE__ */ I(fue, [["render", Tue], ["__scopeId", "data-v-e619a4b5"]]), Eue = {
  name: "CmsAlertBannerSeparate",
  components: {
    SvgClose: Qo
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0
    };
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    bannerArray: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": Xe(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": Xe(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": Xe(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "no-focus-outline" : "";
    },
    svgFillColor() {
      return ie(this.colors["--banner-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  methods: {
    closeBanner(e) {
      this.$emit("close", { alertId: e });
    }
  }
}, Sue = { class: "alert-banners" }, Mue = { class: "banner-wrapper" }, $ue = ["innerHTML"], Iue = ["onClick", "onKeydown"];
function Aue(e, t, n, o, i, r) {
  const a = S("SvgClose");
  return l(), h("div", Sue, [
    (l(!0), h(G, null, q(n.bannerArray, (s) => (l(), h("div", {
      key: s.id,
      class: "banner",
      style: H(r.colors)
    }, [
      d("div", Mue, [
        d("div", {
          class: "content",
          innerHTML: s.content
        }, null, 8, $ue),
        d("button", {
          class: p(["close", r.closeBtnFocusOutlineCSSClass]),
          onClick: (u) => r.closeBanner(s.id),
          onKeydown: [
            N(D((u) => r.closeBanner(s.id), ["exact", "prevent"]), ["enter"]),
            N(D((u) => r.closeBanner(s.id), ["exact", "prevent"]), ["space"]),
            t[0] || (t[0] = N(D((u) => i.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
          ]
        }, [
          $(a, { "fill-color": r.svgFillColor }, null, 8, ["fill-color"])
        ], 42, Iue)
      ])
    ], 4))), 128))
  ]);
}
const Lue = /* @__PURE__ */ I(Eue, [["render", Aue], ["__scopeId", "data-v-7140ef94"]]), Oue = {
  name: "Parallax",
  props: {
    config: {
      type: Object,
      required: !0
    }
  }
}, Nue = { class: "parallax-section" }, Hue = {
  ref: "parallax",
  class: "parallax-container"
}, Pue = { class: "image-container" }, Due = ["src"];
function Rue(e, t, n, o, i, r) {
  return l(), h("div", Nue, [
    d("div", Hue, [
      d("div", {
        class: "parallax",
        style: H({ backgroundImage: `url(${n.config.background_image.url})` })
      }, null, 4)
    ], 512),
    d("div", Pue, [
      d("img", {
        class: "full-image",
        src: n.config.background_image.url
      }, null, 8, Due)
    ])
  ]);
}
const Vue = /* @__PURE__ */ I(Oue, [["render", Rue], ["__scopeId", "data-v-75cfdb1f"]]), Bue = {
  computed: {
    colors() {
      return {
        "--button-one-bg-color": T(this.theme, "button_one.bg_color.hex", "#333"),
        "--button-one-icon-and-text-color": T(this.theme, "button_one.icon_and_text_color.hex", "#fff"),
        "--button-two-bg-color": T(this.theme, "button_two.bg_color.hex", "#fff"),
        "--button-two-icon-and-text-color": T(this.theme, "button_two.icon_and_text_color.hex", "#333"),
        "--button-three-bg-color": T(this.theme, "button_three.bg_color.hex", "#333"),
        "--button-three-icon-and-text-color": T(this.theme, "button_three.icon_and_text_color.hex", "#fff"),
        "--button-four-bg-color": T(this.theme, "button_four.bg_color.hex", "#fff"),
        "--button-four-icon-and-text-color": T(this.theme, "button_four.icon_and_text_color.hex", "#333"),
        "--button-five-bg-color": T(this.theme, "button_five.bg_color.hex", "#333"),
        "--button-five-icon-and-text-color": T(this.theme, "button_five.icon_and_text_color.hex", "#fff"),
        "--button-mobile-bg-color": T(this.theme, "button_mobile.bg_color.hex", "#333"),
        "--button-mobile-icon-and-text-color": T(this.theme, "button_mobile.icon_and_text_color.hex", "#fff")
      };
    },
    translations() {
      return T(this.theme, "translations", {});
    }
  }
}, Fue = {
  name: "MobileSvgArrow",
  props: {
    fillColor: {
      type: String,
      required: !0
    }
  }
}, jue = {
  width: "17",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uue = ["fill"];
function Kue(e, t, n, o, i, r) {
  return l(), h("svg", jue, [
    d("path", {
      d: "M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7L18 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM18 7L1 7L1 9L18 9L18 7Z",
      fill: n.fillColor
    }, null, 8, Uue)
  ]);
}
const Gue = /* @__PURE__ */ I(Fue, [["render", Kue]]), zue = {
  name: "FN1",
  components: {
    mobileNavIcon: Gue
  },
  mixins: [Bue],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      navExpanded: !1,
      pageYOffset: 0
    };
  },
  computed: {
    buttonShape() {
      return this.floatingNav.shape;
    },
    navPosition() {
      return this.floatingNav.is_fixed ? "nav-fixed" : "nav-absolute";
    },
    mobileFill() {
      return T(this.theme, "button_mobile.icon_and_text_color.hex", "#fff");
    },
    isScrolled() {
      return this.pageYOffset > 100;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    togglePanel() {
      this.navExpanded = !this.navExpanded;
    },
    buttonHref(e) {
      return e.mailto ? `mailto:${e.email_address}` : e.url;
    },
    onScroll() {
      this.pageYOffset = window.pageYOffset;
    }
  }
}, Zue = { class: "nav-wrapper" }, Wue = { class: "button-link" }, que = { class: "link-wrapper" }, Yue = ["href", "target"], xue = { class: "link-wrapper" }, Xue = {
  class: "icon-wrapper",
  "data-testid": "svg",
  "aria-hidden": "true"
}, Que = { class: "raw-svg" }, Jue = ["innerHTML"];
function ece(e, t, n, o, i, r) {
  const a = S("mobile-nav-icon");
  return l(), h("div", {
    id: "floating-nav",
    "data-testid": "FN1",
    class: p([r.navPosition, { "is-scrolled": r.isScrolled }]),
    style: H([e.colors])
  }, [
    d("div", Zue, [
      d("div", {
        class: p(["mobile-menu-button button", [r.buttonShape, { expanded: i.navExpanded }]]),
        onClick: t[0] || (t[0] = (...s) => r.togglePanel && r.togglePanel(...s))
      }, [
        d("div", Wue, [
          d("div", que, [
            d("div", {
              class: p(["icon-wrapper", { expanded: i.navExpanded }]),
              "data-testid": "svg",
              "aria-hidden": "true"
            }, [
              $(a, { "fill-color": r.mobileFill }, null, 8, ["fill-color"])
            ], 2),
            d("span", {
              class: p(["button-title", n.theme.style])
            }, f(e.translations.mobile_menu_title || "Collapse Menu"), 3)
          ])
        ])
      ], 2),
      d("div", {
        class: p(["button-wrapper", i.navExpanded ? "expanded" : "hiddenButtons"])
      }, [
        (l(!0), h(G, null, q(n.floatingNav.buttons, (s, u) => (l(), h("div", {
          key: `floating-nav-${u}`,
          class: p(["button", r.buttonShape]),
          "data-testid": "fn1-button"
        }, [
          d("a", {
            class: p(["button-link", n.theme.style]),
            href: r.buttonHref(s),
            target: s.opens_in_new_tab ? "_blank" : "",
            "data-testid": "links"
          }, [
            d("div", xue, [
              d("div", Xue, [
                d("span", Que, [
                  d("span", {
                    "data-testid": "svg",
                    innerHTML: s.icon
                  }, null, 8, Jue)
                ])
              ]),
              d("span", {
                class: p(["button-title", n.theme.style])
              }, f(s.title), 3)
            ])
          ], 10, Yue)
        ], 2))), 128))
      ], 2)
    ])
  ], 6);
}
const tce = /* @__PURE__ */ I(zue, [["render", ece], ["__scopeId", "data-v-4ec6d06b"]]), nce = {
  name: "FloatingNav",
  components: {
    FN1: tce
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      default: () => ({})
    }
  }
};
function oce(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    "floating-nav": n.floatingNav
  }, null, 8, ["theme", "floating-nav"]);
}
const rce = /* @__PURE__ */ I(nce, [["render", oce]]), xa = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    blockHasLink(e) {
      var t;
      return !this.isEditing && ((t = e.link) == null ? void 0 : t.href);
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--description-color": T(this.theme, "description_color.hex", "initial"),
        "--arrow-icon-color": T(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": T(this.theme, "arrow_background_color.hex", "initial"),
        "--pager-color": T(this.theme, "pager_color.hex", "#ffffff"),
        "--box-text-color": T(this.theme, "box_text_color.hex", "#000000"),
        "--box-bg-color": T(this.theme, "box_bg_color.hex", "#ffffff"),
        "--box-gradient-color": T(this.theme, "gradient_overlay.hex", "#ffffff")
      });
    },
    translations() {
      return this.theme.translations;
    },
    content() {
      return this.blocks.content;
    }
  }
}, ice = {
  name: "OS1",
  components: { CardSlider: It },
  mixins: [We, xa],
  computed: {
    sliderCenterSize() {
      return 599;
    },
    showDescription() {
      return this.blocks.has_description && !Ut(this.blocks.component_header_description) || this.blocks.has_description && this.isEditing;
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    }
  },
  methods: {
    fourCardColorPattern(e) {
      return `card-style-${e % 5 + 1}`;
    }
  }
}, sce = { class: "header-wrapper" }, ace = ["data-testid"], lce = ["data-testid"], dce = {
  key: 0,
  class: "header-description",
  "data-testid": "component-header-description"
}, uce = ["data-testid", "aria-label"], cce = { class: "box" };
function hce(e, t, n, o, i, r) {
  const a = S("SeeAllContainer"), s = S("CardSlider");
  return l(), h("div", {
    id: "our-schools-v1",
    "data-testid": "OS1",
    class: p([e.theme.style, e.isEditing && "editing"]),
    style: H(e.colors)
  }, [
    $(a, {
      class: p([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("div", sce, [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (l(), h("span", {
              key: 0,
              class: "header-top",
              "data-testid": `header-${e.theme.style}-top`
            }, [
              C(e.$slots, "header-top", {}, () => [
                k(f(e.blocks.component_header_top), 1)
              ], !0)
            ], 8, lce)) : g("", !0),
            C(e.$slots, "header", {}, () => [
              k(f(e.blocks.component_header), 1)
            ], !0)
          ], 8, ace),
          r.showDescription ? (l(), h("div", dce, [
            C(e.$slots, "header-description", {}, () => [
              k(f(e.blocks.component_header_description), 1)
            ], !0)
          ])) : g("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    $(s, {
      class: p({ "all-cards-visible": e.allCardsVisible }),
      "nav-orientation": "wide",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": e.blocks.content.length,
      "theme-styles": e.theme,
      "section-header": e.blocks.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: b(() => [
        (l(), _(R(e.wrapperComponent), Ce({
          ref: "scrollWrapper",
          modelValue: e.blocks.content,
          "onUpdate:modelValue": t[0] || (t[0] = (u) => e.blocks.content = u),
          class: ["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]
        }, e.wrapperProps, {
          "item-key": "index",
          "data-testid": "blocks-array"
        }), {
          item: b(({ element: u, index: c }) => [
            d("div", {
              ref: `sliderCard-${c}`,
              class: p([[`card-${c + 1}`, r.fourCardColorPattern(c)], "our-schools"]),
              "data-testid": `Card${c + 1}`,
              role: "group",
              "aria-roledescription": "slide",
              "aria-label": `${c + 1} of ${e.blocks.content.length}`
            }, [
              C(e.$slots, "controls", { idx: c }, void 0, !0),
              (l(), _(R(e.blockHasLink(u) ? "a" : "div"), {
                href: e.blockHasLink(u) && u.link.href,
                role: e.blockHasLink(u) && "link",
                target: e.blockHasLink(u) && u.link.target,
                "data-testid": "block-link"
              }, {
                default: b(() => [
                  d("span", cce, [
                    C(e.$slots, "box", { idx: c }, () => [
                      k(f(u.box), 1)
                    ], !0)
                  ]),
                  C(e.$slots, "image", { idx: c }, () => [
                    (l(), _(R(u.image ? "img" : "div"), {
                      src: u.image.url,
                      alt: u.link.href ? "" : u.image.alt_text,
                      class: "our-schools-image",
                      "data-testid": "block-image",
                      loading: "lazy"
                    }, null, 8, ["src", "alt"]))
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "role", "target"]))
            ], 10, uce)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["class", "current-card", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const mce = /* @__PURE__ */ I(ice, [["render", hce], ["__scopeId", "data-v-500cb7cd"]]), pce = {
  name: "OS2",
  mixins: [xa],
  data() {
    return {
      hoverIndex: -1
    };
  },
  computed: {
    colorsWithOpacity() {
      const e = this.colors["--box-gradient-color"], t = `rgba(${su(e, 1)})`, n = `rgba(${su(e, 0)})`;
      return de(oe({}, this.colors), {
        "--box-bg-color-initial-opacity": t,
        "--box-bg-color-final-opacity": n
      });
    },
    columnClass() {
      return this.blocks.content.length <= 3 ? "three-column" : this.blocks.num_columns === 4 ? "four-column" : "three-column";
    }
  }
}, fce = ["data-testid"], gce = ["data-testid"], vce = ["onMouseover"], bce = ["src", "alt"], yce = {
  key: 1,
  class: "our-schools-image"
}, Cce = {
  key: 1,
  class: "title-container",
  "data-testid": "no-link-block",
  maxlength: "26"
};
function _ce(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    class: p(["our-schools-v2", e.theme.style]),
    "data-testid": "OS2",
    style: H(r.colorsWithOpacity)
  }, [
    $(a, {
      class: p(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: p({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (l(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.blocks.component_header_top), 1)
            ], !0)
          ], 8, gce)) : g("", !0),
          C(e.$slots, "header", {
            dataTestid: `header-${e.theme.style}`
          }, () => [
            k(f(e.blocks.component_header), 1)
          ], !0)
        ], 10, fce)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[1] || (t[1] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "data-testid": "blocks-array",
      "item-key": "index"
    }), {
      item: b(({ element: s, index: u }) => [
        d("div", {
          class: p(["block", r.columnClass]),
          "data-testid": "our-schools-block-content"
        }, [
          C(e.$slots, "controls", { idx: u }, void 0, !0),
          d("div", {
            class: "image-wrapper image-border-accent",
            role: "dialog",
            onMouseover: (c) => i.hoverIndex = u,
            onMouseleave: t[0] || (t[0] = (c) => i.hoverIndex = -1)
          }, [
            s.image.url ? (l(), h("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "our-schools-image"
            }, null, 8, bce)) : (l(), h("div", yce)),
            d("div", {
              class: p([[
                e.theme.style,
                {
                  "hover-enter": i.hoverIndex === u
                }
              ], "content-box gradient"])
            }, null, 2),
            d("div", {
              class: p([e.theme.style, "title"])
            }, [
              s.link.href ? (l(), _(R(e.isEditing ? "div" : "a"), {
                key: 0,
                class: "title-container",
                "data-testid": "link-block",
                href: s.link.href,
                target: s.link.target || "_self"
              }, {
                default: b(() => [
                  C(e.$slots, "box", { idx: u }, () => [
                    k(f(s.box), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : (l(), h("p", Cce, [
                C(e.$slots, "box", { idx: u }, () => [
                  k(f(s.box), 1)
                ], !0)
              ]))
            ], 2)
          ], 40, vce)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const wce = /* @__PURE__ */ I(pce, [["render", _ce], ["__scopeId", "data-v-026fb915"]]), Tce = {
  name: "OS3",
  mixins: [xa],
  computed: {
    OS3Colors() {
      var e, t;
      return de(oe({}, this.colors), {
        "--icon-color": ((e = this.theme.icon_color) == null ? void 0 : e.hex) || "#fff",
        "--icon-bg-color": ((t = this.theme.icon_bg_color) == null ? void 0 : t.hex) || "#000"
      });
    }
  },
  methods: {
    isLink({ link: e }) {
      return !this.isEditing && (e == null ? void 0 : e.href) && this.blocks.has_link;
    }
  }
}, kce = {
  key: 0,
  class: "header-top"
}, Ece = {
  key: 0,
  class: "our-schools-icon"
}, Sce = {
  class: "icon-wrapper",
  "aria-hidden": "true"
}, Mce = { class: "raw-svg" }, $ce = ["innerHTML"];
function Ice(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    class: p(["our-schools-v3", e.theme.style]),
    style: H(r.OS3Colors)
  }, [
    $(a, {
      class: p(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: b(() => [
        d("h2", {
          class: p({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (l(), h("span", kce, [
            C(e.$slots, "header-top", {}, () => [
              k(f(e.blocks.component_header_top), 1)
            ], !0)
          ])) : g("", !0),
          C(e.$slots, "header", {}, () => [
            k(f(e.blocks.component_header), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "item-key": "index"
    }), {
      item: b(({ element: s, index: u }) => {
        var c, y;
        return [
          (l(), _(R(r.isLink(s) ? "a" : "div"), {
            href: r.isLink(s) ? (c = s.link) == null ? void 0 : c.href : void 0,
            target: r.isLink(s) ? (y = s.link) == null ? void 0 : y.target : void 0,
            class: "our-schools-block"
          }, {
            default: b(() => [
              C(e.$slots, "controls", { idx: u }, void 0, !0),
              (l(), _(R(s.image ? "img" : "div"), {
                src: s.image.url,
                class: "our-schools-image",
                loading: "lazy",
                alt: ""
              }, null, 8, ["src"])),
              d("div", {
                class: p(["our-schools-block-text", e.theme.style])
              }, [
                C(e.$slots, "box", { idx: u }, () => [
                  k(f(s.box), 1)
                ], !0)
              ], 2),
              s.icon || e.isEditing ? (l(), h("div", Ece, [
                d("div", Sce, [
                  d("span", Mce, [
                    C(e.$slots, "icon", { idx: u }, () => [
                      d("span", {
                        innerHTML: s.icon
                      }, null, 8, $ce)
                    ], !0)
                  ])
                ])
              ])) : g("", !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ];
      }),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Ace = /* @__PURE__ */ I(Tce, [["render", Ice], ["__scopeId", "data-v-cd32b515"]]), Lce = {
  name: "CmsOurSchools",
  components: {
    OS1: mce,
    OS2: wce,
    OS3: Ace
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  }
}, Oce = { class: "our-schools-container" };
function Nce(e, t, n, o, i, r) {
  return l(), h("div", Oce, [
    (l(), _(R(n.theme.version), {
      theme: n.theme,
      blocks: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing
    }, {
      "header-top": b(() => [
        C(e.$slots, "header-top", {}, void 0, !0)
      ]),
      "header-bottom": b(() => [
        C(e.$slots, "header-bottom", {}, void 0, !0)
      ]),
      header: b(() => [
        C(e.$slots, "header", {}, void 0, !0)
      ]),
      "header-description": b(() => [
        C(e.$slots, "header-description", {}, void 0, !0)
      ]),
      controls: b(({ idx: a }) => [
        C(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      image: b(({ idx: a }) => [
        C(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      box: b(({ idx: a }) => [
        C(e.$slots, "box", { idx: a }, void 0, !0)
      ]),
      icon: b(({ idx: a }) => [
        C(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "blocks", "wrapper-component", "wrapper-props", "is-editing"]))
  ]);
}
const Hce = /* @__PURE__ */ I(Lce, [["render", Nce], ["__scopeId", "data-v-89630ecf"]]), Pce = {
  components: {
    CustomHtml: Hi
  },
  props: {
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      if (!this.theme.section || this.theme.section.type === "none" || Ut(this.content))
        return this.theme;
      let e = "";
      try {
        e = e0(this.theme.html_code, this.theme.section.type, this.content);
      } catch (t) {
        e = t;
      }
      return de(oe({}, this.theme), {
        html_code: e
      });
    }
  }
}, Dce = { class: "media-custom-code" };
function Rce(e, t, n, o, i, r) {
  const a = S("CustomHtml");
  return l(), h("div", Dce, [
    $(a, { theme: r.processedTheme }, null, 8, ["theme"])
  ]);
}
const Vce = /* @__PURE__ */ I(Pce, [["render", Rce]]), Bce = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isActive: !1,
      isOverflow: !1
    };
  },
  created() {
    this.isActive = this.isPreview || this.isEditing;
  },
  mounted() {
    this.handleResize(), window.addEventListener("resize", this.handleResize), window.addEventListener("scroll", this.onWindowScroll);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize), window.removeEventListener("scroll", this.onWindowScroll);
  },
  methods: {
    handleResize() {
      this.isOverflow = this.$refs.flexWrapper.offsetWidth >= this.screenSize;
    },
    onScroll(e = "left", t = 120) {
      const i = {
        left: t * (e === "left" ? -1 : 1),
        behavior: "smooth"
      };
      this.$refs.scrollWrapper.scrollBy(oe({}, i));
    },
    stickyFooterActiveToggle() {
      this.isActive = !this.isActive;
    },
    onWindowScroll() {
      window.scrollY > window.innerHeight / 2 && (this.isActive = !0, window.removeEventListener("scroll", this.onWindowScroll));
    }
  },
  computed: {
    toggleButtonText() {
      return this.isActive ? this.content.hide_text_label || "hide" : this.content.show_text_label || "show";
    },
    hasPillButton() {
      return this.content.show_pill_button || this.isPreview;
    },
    hasSocialIcons() {
      return this.content.show_social_icons || this.isPreview;
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--bg-color": T(this.theme, "bg_color.hex", "#333"),
        "--hide-button-and-bar-color": T(this.theme, "hide_button_and_bar_color.hex", "#f8cb43"),
        "--hide-button-text-color": T(this.theme, "hide_button_text_color.hex", "#fff"),
        "--icon-color": T(this.theme, "icon_color.hex", "#fff"),
        "--icon-text-color": T(this.theme, "icon_text_color.hex", "#fff"),
        "--pill-button-color": T(this.theme, "pill_button_color.hex", "#f8cb43"),
        "--pill-button-text-color": T(this.theme, "pill_button_text_color.hex", "#333"),
        "--separator-color": T(this.theme, "separator_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, Fce = {
  name: "StickyFooterV1",
  mixins: [Bce]
}, jce = { class: "text" }, Uce = {
  ref: "scrollWrapper",
  class: "scroll-wrapper"
}, Kce = {
  ref: "flexWrapper",
  class: "flex-wrapper"
}, Gce = { class: "icon-wrapper" }, zce = ["innerHTML"], Zce = { class: "title" }, Wce = { class: "icon-wrapper" }, qce = ["innerHTML"];
function Yce(e, t, n, o, i, r) {
  return l(), h("div", {
    class: p(["sticky-footer-v1", [
      e.theme.style,
      {
        "sf-active": e.isActive,
        "sf-overflow": e.isOverflow,
        "sf-editing": e.isEditing
      }
    ]]),
    style: H(e.cssVars),
    "data-testid": "StickyFooterV1"
  }, [
    C(e.$slots, "toggle", {}, () => [
      d("button", {
        class: p(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
        onClick: t[0] || (t[0] = (...a) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...a))
      }, [
        d("span", jce, f(e.toggleButtonText), 1),
        d("div", {
          class: p(["icon-arrow", { "sf-active": e.isActive }])
        }, null, 2)
      ], 2)
    ], !0),
    d("div", Uce, [
      e.isOverflow ? (l(), h("button", {
        key: 0,
        class: "scroll-button left",
        onClick: t[1] || (t[1] = (a) => e.onScroll("left"))
      }, t[5] || (t[5] = [
        d("div", { class: "icon-arrow" }, null, -1)
      ]))) : g("", !0),
      d("div", Kce, [
        e.hasPillButton ? (l(), _(R(e.isEditing ? "div" : "a"), {
          key: 0,
          class: "pill-button",
          "data-testid": "pill-button",
          href: e.content.pill_button.link,
          target: e.content.pill_button.opens_in_new_tab ? "_blank" : ""
        }, {
          default: b(() => [
            C(e.$slots, "pill-button-controls", {}, void 0, !0),
            C(e.$slots, "pill-button-title", {}, () => [
              k(f(e.content.pill_button.title), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["href", "target"])) : g("", !0),
        (l(), _(R(e.wrapperComponent), Ce(e.wrapperProps, {
          modelValue: e.content.icon_buttons,
          "onUpdate:modelValue": t[2] || (t[2] = (a) => e.content.icon_buttons = a),
          "item-key": "index",
          class: "icon-buttons"
        }), {
          item: b(({ element: a, index: s }) => [
            (l(), _(R(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "button",
              "data-testid": "icon-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: b(() => [
                C(e.$slots, "icon-button-controls", { idx: s }, void 0, !0),
                d("div", Gce, [
                  C(e.$slots, "icon-button-icon", { idx: s }, () => [
                    d("span", {
                      innerHTML: a.icon
                    }, null, 8, zce)
                  ], !0)
                ]),
                d("span", Zce, [
                  C(e.$slots, "icon-button-title", { idx: s }, () => [
                    k(f(a.title), 1)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])),
        e.hasSocialIcons ? (l(), _(R(e.wrapperComponent), Ce({ key: 1 }, e.wrapperProps, {
          modelValue: e.content.social_media_icons,
          "onUpdate:modelValue": t[3] || (t[3] = (a) => e.content.social_media_icons = a),
          "item-key": "index",
          class: "social-media"
        }), {
          item: b(({ element: a, index: s }) => [
            (l(), _(R(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "icons",
              "data-testid": "social-media-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: b(() => [
                C(e.$slots, "social-media-controls", { idx: s }, void 0, !0),
                d("div", Wce, [
                  C(e.$slots, "social-media-icon", { idx: s }, () => [
                    d("span", {
                      innerHTML: a.icon
                    }, null, 8, qce)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])) : g("", !0)
      ], 512),
      e.isOverflow ? (l(), h("button", {
        key: 1,
        class: "scroll-button right",
        onClick: t[4] || (t[4] = (a) => e.onScroll("right"))
      }, t[6] || (t[6] = [
        d("div", { class: "icon-arrow" }, null, -1)
      ]))) : g("", !0)
    ], 512)
  ], 6);
}
const xce = /* @__PURE__ */ I(Fce, [["render", Yce], ["__scopeId", "data-v-1c2cee8d"]]), Xce = {
  name: "StickyFooter",
  components: {
    StickyFooterV1: xce
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Qce(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    content: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-preview": n.isPreview,
    "is-editing": n.isEditing
  }, {
    toggle: b(() => [
      C(e.$slots, "toggle")
    ]),
    "pill-button-controls": b(() => [
      C(e.$slots, "pill-button-controls")
    ]),
    "pill-button-title": b(({ title: a }) => [
      C(e.$slots, "pill-button-title", { title: a })
    ]),
    "icon-button-controls": b(({ idx: a }) => [
      C(e.$slots, "icon-button-controls", { idx: a })
    ]),
    "icon-button-title": b(({ title: a, idx: s }) => [
      C(e.$slots, "icon-button-title", {
        title: a,
        idx: s
      })
    ]),
    "icon-button-icon": b(({ idx: a }) => [
      C(e.$slots, "icon-button-icon", { idx: a })
    ]),
    "social-media-controls": b(({ idx: a }) => [
      C(e.$slots, "social-media-controls", { idx: a })
    ]),
    "social-media-icon": b(({ idx: a }) => [
      C(e.$slots, "social-media-icon", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "is-preview", "is-editing"]);
}
const Jce = /* @__PURE__ */ I(Xce, [["render", Qce]]), ehe = {
  name: "CustomComponent",
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: Object,
      default: Ke,
      validator(e) {
        return (e == null ? void 0 : e.name) === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    }
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlTree() {
      let e = {};
      try {
        e = FU(this.theme.html_code);
      } catch (t) {
        e = "";
      }
      return e;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    customComponent(e) {
      return {
        "cms-input": { slotName: "input", tag: "span" },
        "cms-textarea": {
          slotName: "textarea",
          tag: "span",
          style: "white-space: pre-line;"
        },
        "cms-image": { slotName: "image", tag: "span" },
        "cms-icon": { slotName: "icon", tag: "span" },
        "cms-richtextarea": {
          slotName: "richtextarea",
          tag: "span"
        }
      }[e];
    },
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    },
    dragHandler(e, t) {
      this.$emit("on-drag", {
        oldIndex: e.oldIndex,
        newIndex: e.newIndex,
        loopName: t
      });
    }
  },
  render() {
    var o;
    const e = (i) => {
      if (!i.properties) return {};
      const r = Object.entries(i.properties).filter(([a]) => a.startsWith("data"));
      return r.length ? r.reduce(
        (a, [s, u]) => de(oe({}, a), {
          [s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()]: u
        }),
        {}
      ) : {};
    }, t = (i, r, a) => {
      var u, c, y, w, v, E, F, O, L;
      const s = oe({
        id: (u = i.properties) == null ? void 0 : u.id,
        class: (c = i.properties) == null ? void 0 : c.className,
        style: (y = this.customComponent(i.tagName)) == null ? void 0 : y.style,
        className: (v = (w = i.properties) == null ? void 0 : w.className) == null ? void 0 : v.join(" "),
        name: null,
        link: null,
        limit: null,
        src: (E = i.properties) == null ? void 0 : E.src,
        alt: (F = i.properties) == null ? void 0 : F.alt,
        "aspect-ratio": null
      }, e(i));
      if (i.tagName === "cms-loop") {
        const U = () => {
          var j, Y;
          const z = ((j = this.content.loop) == null ? void 0 : j[i.properties.name]) || [];
          return [
            ...Array(this.isPreview ? Number((Y = i.properties) == null ? void 0 : Y.limit) || 5 : z.length || 1)
          ].map(
            (K, ne) => {
              var te, le, Re;
              return bo("div", {}, [
                (le = (te = this.$slots).dragControls) == null ? void 0 : le.call(te, {
                  loopName: i.properties.name,
                  loopIndex: ne
                })[0],
                ...(Re = i.children) == null ? void 0 : Re.map((mt) => t(mt, i.properties.name, ne))
              ]);
            }
          );
        };
        return bo(
          this.wrapperComponent,
          de(oe({}, s), {
            itemKey: "index",
            modelValue: U(),
            class: [...(s == null ? void 0 : s.class) || "", this.isEditing ? "custom-component-loop-wrapper" : ""],
            handle: ".drag-handle",
            onUpdate: (z) => this.dragHandler(z, i.properties.name)
          }),
          {
            item: ({ element: z }) => z,
            footer: () => {
              var z, B, j, Y, K, ne;
              return [
                [
                  !i.properties.limit || !((B = (z = this.content.loop) == null ? void 0 : z[i.properties.name]) != null && B.length) || Number(i.properties.limit) > ((Y = (j = this.content.loop) == null ? void 0 : j[i.properties.name]) == null ? void 0 : Y.length) ? (ne = (K = this.$slots).addLoopElement) == null ? void 0 : ne.call(K, {
                    loopName: i.properties.name
                  })[0] : []
                ]
              ];
            }
          }
        );
      }
      return this.customComponent(i.tagName) ? bo(this.customComponent(i.tagName).tag, s, [
        this.$slots[this.customComponent(i.tagName).slotName]({
          customName: i.properties.name,
          link: i.properties.hasOwnProperty("link"),
          aspectRatio: (O = i.properties["aspect-ratio"]) != null ? O : "unset",
          inLoop: !!r,
          loopName: r,
          loopIndex: a
        })[0]
      ]) : i.type === "text" ? i.value : bo(
        i.tagName,
        s,
        (L = i.children) == null ? void 0 : L.map((U) => t(U, r, a))
      );
    }, n = (o = this.htmlTree.children) == null ? void 0 : o.map((i) => t(i));
    return bo("div", { id: this.theme.container_id }, n);
  }
}, the = {
  mixins: [Qe],
  components: { DraggableWrapper: Ke },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timelineItems: this.timeline.items || [],
      autoScrollInterval: null,
      isOnAnimation: !1,
      isAutoScroll: this.timeline.auto_scroll,
      onFocus: !1,
      isMirrorArray: !1
    };
  },
  mounted() {
    this.isAutoScroll && !this.isEditing && !this.timeline.hide_component && this.startAutoScroll();
  },
  methods: {
    getAriaLabel(e, t) {
      let n;
      if (this.isMirrorArray) {
        const o = this.content.length === 10 ? [3, 4, 5, 1, 2, 3, 4, 5, 1, 2] : this.content.length === 12 ? [4, 5, 6, 1, 2, 3, 4, 5, 6, 1, 2, 3] : null;
        o && (n = o[e]);
      } else {
        n = e - 2;
        const o = this.content.length;
        n < 1 && (n += o);
      }
      return `item ${n} of ${this.timelineItems.length}, ${t.year}, ${t.title}, ${t.description}, 'Use the left and right arrow keys to navigate'`;
    },
    shiftArray(e, t) {
      const n = e.length - t;
      return [...e.slice(n), ...e.slice(0, n)];
    },
    onAnimation() {
      return new Promise((e) => {
        this.isOnAnimation = !0, setTimeout(() => {
          this.isOnAnimation = !1, e();
        }, 500);
      });
    },
    async moveItem({ direction: e = "next", autofocus: t = !1 } = {}) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel, o = n.children;
      e === "next" ? n.appendChild(o[0]) : e === "prev" && n.prepend(o[o.length - 1]), Array.from(o).forEach((i) => i.setAttribute("tabindex", "-1")), o[3].setAttribute("tabindex", "0"), t && o[3].focus(), this.isAutoScroll && this.resetAutoScroll(), await this.onAnimation();
    },
    handleSwipeStart(e) {
      this.isSwiping = !0, this.startX = e.touches ? e.touches[0].clientX : e.clientX;
    },
    handleSwipeEnd(e) {
      if (!this.isSwiping) return;
      this.isSwiping = !1;
      const n = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - this.startX;
      n > 50 ? this.moveItem({ direction: "prev" }) : n < -50 && this.moveItem({ direction: "next" });
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.moveItem({ direction: "next", autofocus: this.onFocus });
      }, 7e3), this.isAutoScroll = !0;
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval), this.isAutoScroll = !1;
    },
    toggleAutoScroll() {
      this.isAutoScroll ? this.stopAutoScroll() : this.startAutoScroll();
    },
    handleFocus() {
      this.onFocus = !0;
    },
    handleBlur() {
      this.onFocus = !1;
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.moveItem({ direction: "next", autofocus: this.onFocus });
      }, 6e3), this.isAutoScroll = !0;
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval), this.isAutoScroll = !1;
    },
    resetAutoScroll() {
      this.stopAutoScroll(), this.startAutoScroll();
    }
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
  computed: {
    playPauseAriaLabel() {
      return this.isAutoScroll ? "Pause timeline autoscroll" : "Start timeline autoscroll";
    },
    content() {
      let e = [...this.timelineItems];
      return this.isEditing ? e : (e.length < 7 && (this.isMirrorArray = !0, e = [...e, ...e]), this.shiftArray(e, 3));
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return de(oe({}, e), {
        "--bg-color": T(this.theme, "bg_color.hex", "#000"),
        "--button-bg-color": T(this.theme, "button_bg_color.hex", "#fff"),
        "--button-icon-color": T(this.theme, "button_icon_color.hex", "#fff"),
        "--name-color": T(this.theme, "name_color.hex", "#fff"),
        "--wave-line-color": T(this.theme, "wave_line_color.hex", "#fff"),
        "--scroll-text-color": T(this.theme, "scroll_text_color.hex", "#fff"),
        "--card-text-color": T(this.theme, "card_text_color.hex", "#fff"),
        "--year-text-color": T(this.theme, "year_text_color.hex", "#fff"),
        "--year-bg-color": T(this.theme, "year_bg_color.hex", "#000"),
        "--card-text-color": T(this.theme, "card_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, nhe = {
  name: "TimelineV1",
  mixins: [the]
}, ohe = { class: "timeline-wrapper" }, rhe = ["data-testid"], ihe = {
  key: 1,
  class: "timeline-box"
}, she = {
  class: "buttons-container",
  role: "none"
}, ahe = ["aria-label"], lhe = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, dhe = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, uhe = ["id", "tabindex", "aria-label"], che = { class: "item-image" }, hhe = { class: "item-year" }, mhe = { class: "item-body-text" }, phe = { class: "item-description" }, fhe = { class: "item-title" }, ghe = {
  class: "navigation-instructions",
  "aria-live": "assertive",
  "aria-atomic": "true"
}, vhe = { key: 0 }, bhe = { class: "item carrousel-item" }, yhe = { class: "item-image edit" }, Che = { class: "item-year" }, _he = { class: "item-body-text" }, whe = { class: "item-description" }, The = { class: "item-title" };
function khe(e, t, n, o, i, r) {
  const a = S("SeeAllContainer");
  return l(), h("div", {
    style: H(e.cssVars),
    class: p([
      "timeline-v1",
      e.theme.style,
      { "is-editing": e.isEditing },
      { animated: e.theme.wave_animations },
      { hide: e.timeline.hide_component }
    ]),
    "data-testid": "TimelineV1"
  }, [
    d("div", ohe, [
      e.timeline.show_component_header ? (l(), _(a, {
        key: 0,
        class: p(["timeline-header see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: b(() => [
          d("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            C(e.$slots, "header", {}, () => [
              k(f(e.timeline.component_header), 1)
            ], !0)
          ], 8, rhe)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : g("", !0),
      e.isEditing ? (l(), _(R(e.wrapperComponent), Ce({ key: 2 }, e.wrapperProps, {
        modelValue: e.timeline.items,
        "onUpdate:modelValue": t[13] || (t[13] = (s) => e.timeline.items = s),
        "item-key": "id",
        class: "draggable-carrousel editable"
      }), {
        item: b(({ element: s, index: u }) => [
          d("div", bhe, [
            d("div", yhe, [
              C(e.$slots, "image", { idx: u }, void 0, !0),
              (l(), _(R(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              d("span", Che, [
                C(e.$slots, "year", { idx: u }, () => [
                  k(f(s.year), 1)
                ], !0)
              ]),
              d("div", _he, [
                d("span", whe, [
                  C(e.$slots, "description", { idx: u }, () => [
                    k(f(s.description), 1)
                  ], !0)
                ]),
                d("span", The, [
                  C(e.$slots, "title", { idx: u }, () => [
                    k(f(s.title), 1)
                  ], !0)
                ])
              ])
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (l(), h("div", ihe, [
        t[18] || (t[18] = d("svg", {
          class: "wave-line primary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          d("defs", null, [
            d("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          d("use", {
            "xlink:href": "#wave",
            x: "50",
            y: "0"
          })
        ], -1)),
        d("div", she, [
          e.timeline.auto_scroll ? g("", !0) : (l(), h("button", {
            key: 0,
            class: "slider-button left prev",
            "aria-label": "previous item",
            role: "none",
            onKeyup: t[0] || (t[0] = N((s) => e.moveItem({ direction: "prev" }), ["left"])),
            onClick: t[1] || (t[1] = (s) => e.moveItem({ direction: "prev" }))
          }, t[14] || (t[14] = [
            d("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              d("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? g("", !0) : (l(), h("button", {
            key: 1,
            class: "slider-button right next",
            "aria-label": "next item",
            role: "none",
            onKeyup: t[2] || (t[2] = N((s) => e.moveItem({ direction: "next" }), ["right"])),
            onClick: t[3] || (t[3] = (s) => e.moveItem({ direction: "next" }))
          }, t[15] || (t[15] = [
            d("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              d("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? (l(), h("button", {
            key: 2,
            class: "play-pause",
            "aria-label": e.playPauseAriaLabel,
            onClick: t[4] || (t[4] = (...s) => e.toggleAutoScroll && e.toggleAutoScroll(...s))
          }, [
            e.isAutoScroll ? (l(), h("svg", lhe, t[16] || (t[16] = [
              d("g", null, [
                d("path", {
                  d: "M8 6V18",
                  "stroke-linecap": "round"
                }),
                d("path", {
                  d: "M16 6V18",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))) : (l(), h("svg", dhe, t[17] || (t[17] = [
              d("g", null, [
                d("path", { d: "M18.25 11.567C18.5833 11.7594 18.5833 12.2406 18.25 12.433L7.75 18.4952C7.41667 18.6876 7 18.4471 7 18.0622L7 5.93782C7 5.55292 7.41667 5.31236 7.75 5.50481L18.25 11.567Z" })
              ], -1)
            ])))
          ], 8, ahe)) : g("", !0)
        ]),
        d("div", {
          ref: "carrousel",
          role: "none",
          class: "carrousel",
          onTouchstart: t[9] || (t[9] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[10] || (t[10] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[11] || (t[11] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[12] || (t[12] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (l(!0), h(G, null, q(e.content, (s, u) => (l(), h("div", {
            id: `carrousel-item-${u}`,
            key: u,
            tabindex: u === 3 ? 0 : -1,
            class: "item carrousel-item",
            "aria-label": e.getAriaLabel(u, s),
            role: "group",
            onKeyup: [
              t[5] || (t[5] = N((c) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[6] || (t[6] = N((c) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[7] || (t[7] = (...c) => e.handleFocus && e.handleFocus(...c)),
            onBlur: t[8] || (t[8] = (...c) => e.handleBlur && e.handleBlur(...c))
          }, [
            d("div", che, [
              (l(), _(R(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              d("span", hhe, f(s.year), 1),
              d("div", mhe, [
                d("span", phe, f(s.description), 1),
                d("span", fhe, f(s.title), 1)
              ])
            ])
          ], 40, uhe))), 128))
        ], 544),
        t[19] || (t[19] = d("svg", {
          class: "wave-line secondary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          d("defs", null, [
            d("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          d("use", {
            "xlink:href": "#wave",
            x: "48",
            y: "3"
          })
        ], -1)),
        d("div", ghe, [
          e.onFocus ? (l(), h("span", vhe, "Use the left and right arrow keys to navigate")) : g("", !0)
        ])
      ])),
      e.timeline.show_scroll_text ? (l(), h("div", {
        key: 3,
        class: p(["scroll-text", e.theme.style])
      }, [
        C(e.$slots, "scroll", {}, () => [
          k(f(e.timeline.scroll_text), 1)
        ], !0)
      ], 2)) : g("", !0)
    ])
  ], 6);
}
const Ehe = /* @__PURE__ */ I(nhe, [["render", khe], ["__scopeId", "data-v-1c3337f6"]]), She = {
  name: "Timeline",
  components: {
    TimelineV1: Ehe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Mhe(e, t, n, o, i, r) {
  return l(), _(R(n.theme.version), {
    theme: n.theme,
    timeline: n.timeline,
    "is-preview": n.isPreview,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing
  }, {
    header: b(() => [
      C(e.$slots, "header")
    ]),
    year: b(({ idx: a }) => [
      C(e.$slots, "year", { idx: a })
    ]),
    title: b(({ idx: a }) => [
      C(e.$slots, "title", { idx: a })
    ]),
    description: b(({ idx: a }) => [
      C(e.$slots, "description", { idx: a })
    ]),
    scroll: b(() => [
      C(e.$slots, "scroll")
    ]),
    image: b(({ idx: a }) => [
      C(e.$slots, "image", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "timeline", "is-preview", "wrapper-component", "wrapper-props", "is-editing"]);
}
const $he = /* @__PURE__ */ I(She, [["render", Mhe]]), Mu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CmsAbout: eue,
  CmsAlertBanner: mue,
  CmsAlertBannerSeparate: Lue,
  CmsAlertModal: due,
  CmsAlertModalSeparate: kue,
  CmsAthletics: U1e,
  CmsButtons: pde,
  CmsCustomComponent: ehe,
  CmsCustomHtml: Hi,
  CmsEvents: fee,
  CmsFloatingNav: rce,
  CmsFooter: EZ,
  CmsGallery: ib,
  CmsHeader: OK,
  CmsLiveFeed: boe,
  CmsMediaCustomHtml: Vce,
  CmsMenu: rz,
  CmsOurSchools: Hce,
  CmsParallax: Vue,
  CmsPrograms: mQ,
  CmsSpotlight: A1e,
  CmsStats: fse,
  CmsStickyFooter: Jce,
  CmsTimeline: $he,
  CmsVideo: ele,
  News: c8
}, Symbol.toStringTag, { value: "Module" })), Ihe = {
  install(e) {
    e.use(n2), Object.keys(Mu).forEach((t) => {
      e.component(t, Mu[t]);
    });
  }
}, Ohe = Ihe;
export {
  Ohe as plugin
};
//# sourceMappingURL=cms-components.es.js.map
